module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0112":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_GlobalNavItem_vue_vue_type_style_index_0_id_4492b55c_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ea31");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_GlobalNavItem_vue_vue_type_style_index_0_id_4492b55c_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_GlobalNavItem_vue_vue_type_style_index_0_id_4492b55c_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0282":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "030c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "034c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-clip-art.svg";

/***/ }),

/***/ "036a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTitleBlock_vue_vue_type_style_index_0_id_06d80350_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4b68");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTitleBlock_vue_vue_type_style_index_0_id_06d80350_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTitleBlock_vue_vue_type_style_index_0_id_06d80350_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "03d8":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0422":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaVideoCard_vue_vue_type_style_index_0_id_5c2cae84_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("eb18");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaVideoCard_vue_vue_type_style_index_0_id_5c2cae84_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaVideoCard_vue_vue_type_style_index_0_id_5c2cae84_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "04e3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-song.svg";

/***/ }),

/***/ "05de":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaProductBarSearch_vue_vue_type_style_index_0_id_422bd623_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a0a2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaProductBarSearch_vue_vue_type_style_index_0_id_422bd623_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaProductBarSearch_vue_vue_type_style_index_0_id_422bd623_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "05e7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaListItem_vue_vue_type_style_index_0_id_0cc0263f_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98b1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaListItem_vue_vue_type_style_index_0_id_0cc0263f_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaListItem_vue_vue_type_style_index_0_id_0cc0263f_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0663":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaButtonGroup_vue_vue_type_style_index_0_id_36453965_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a879");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaButtonGroup_vue_vue_type_style_index_0_id_36453965_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaButtonGroup_vue_vue_type_style_index_0_id_36453965_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "089c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0a06":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var buildURL = __webpack_require__("30b5");
var InterceptorManager = __webpack_require__("f6b4");
var dispatchRequest = __webpack_require__("5270");
var mergeConfig = __webpack_require__("4a7b");
var validator = __webpack_require__("848b");

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "0a7b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0b58":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0b65":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0b85":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIcon_vue_vue_type_style_index_0_id_5feb93fc_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0d7e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIcon_vue_vue_type_style_index_0_id_5feb93fc_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIcon_vue_vue_type_style_index_0_id_5feb93fc_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0b90":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0c7a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0cf8":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0d44":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MultiLevelNavItem_vue_vue_type_style_index_0_id_0013884d_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dd51");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MultiLevelNavItem_vue_vue_type_style_index_0_id_0013884d_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MultiLevelNavItem_vue_vue_type_style_index_0_id_0013884d_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0d7e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0df6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "0f96":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaListGroup_vue_vue_type_style_index_0_id_0c0581b4_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9cb6");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaListGroup_vue_vue_type_style_index_0_id_0c0581b4_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaListGroup_vue_vue_type_style_index_0_id_0c0581b4_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "104b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "10f9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-encyclopedia-article.svg";

/***/ }),

/***/ "112b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-graphic-organizer.svg";

/***/ }),

/***/ "117e":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-techbook-discipline.svg";

/***/ }),

/***/ "11f7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1236":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1340":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBanner_vue_vue_type_style_index_0_id_619c3c24_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("95ea");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBanner_vue_vue_type_style_index_0_id_619c3c24_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBanner_vue_vue_type_style_index_0_id_619c3c24_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1465":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "148f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "14c2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1614":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaActivityCard_vue_vue_type_style_index_0_id_1f850cec_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8654");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaActivityCard_vue_vue_type_style_index_0_id_1f850cec_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaActivityCard_vue_vue_type_style_index_0_id_1f850cec_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "16fc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-techbook-unit.svg";

/***/ }),

/***/ "172d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-simulation-exploration.svg";

/***/ }),

/***/ "1893":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1962":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-channel.svg";

/***/ }),

/***/ "1981":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_GlobalNavButton_vue_vue_type_style_index_0_id_872df17a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("deb4");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_GlobalNavButton_vue_vue_type_style_index_0_id_872df17a_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_GlobalNavButton_vue_vue_type_style_index_0_id_872df17a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "19c1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1a0c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-pdf-activity.svg";

/***/ }),

/***/ "1a18":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1a51":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-audio-cd.svg";

/***/ }),

/***/ "1a99":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-math-overview.svg";

/***/ }),

/***/ "1ad4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-project.svg";

/***/ }),

/***/ "1d1d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1d2a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaInputWithButtons_vue_vue_type_style_index_0_id_504cae12_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8eda");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaInputWithButtons_vue_vue_type_style_index_0_id_504cae12_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaInputWithButtons_vue_vue_type_style_index_0_id_504cae12_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1d2b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "1d2b7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "1e73":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardRow_vue_vue_type_style_index_0_id_18fef746_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("11f7");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardRow_vue_vue_type_style_index_0_id_18fef746_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardRow_vue_vue_type_style_index_0_id_18fef746_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1f36":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDeselect_vue_vue_type_style_index_0_id_320a8328_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1d2b7");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDeselect_vue_vue_type_style_index_0_id_320a8328_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDeselect_vue_vue_type_style_index_0_id_320a8328_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1ff7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaListboxItem_vue_vue_type_style_index_0_id_07463945_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ab9d");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaListboxItem_vue_vue_type_style_index_0_id_07463945_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaListboxItem_vue_vue_type_style_index_0_id_07463945_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "20cc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaContentRow_vue_vue_type_style_index_0_id_455dbbe5_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5bc7");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaContentRow_vue_vue_type_style_index_0_id_455dbbe5_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaContentRow_vue_vue_type_style_index_0_id_455dbbe5_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "21b3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-techbook-subdiscipline.svg";

/***/ }),

/***/ "2444":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("c532");
var normalizeHeaderName = __webpack_require__("c8af");
var enhanceError = __webpack_require__("387f");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("b50d");
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__("b50d");
  }
  return adapter;
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362")))

/***/ }),

/***/ "2567":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-save-state.svg";

/***/ }),

/***/ "26ee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5ea3");


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),

/***/ "270d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/public-security-recordal.png";

/***/ }),

/***/ "2712":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-video-segment.svg";

/***/ }),

/***/ "277b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-audiobook.svg";

/***/ }),

/***/ "27ec":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2804":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2858":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/keiki_footer.png";

/***/ }),

/***/ "286d":
/***/ (function(module) {

module.exports = JSON.parse("{\"%(count)d Student\":\"%(count)d Students\",\"%(count)d Teacher\":\"%(count)d Teachers\",\"%(count)d Student Not Imported\":\"%(count)d Students Not Imported\"}");

/***/ }),

/***/ "287c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBreadcrumbs_vue_vue_type_style_index_0_id_70094768_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e25b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBreadcrumbs_vue_vue_type_style_index_0_id_70094768_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBreadcrumbs_vue_vue_type_style_index_0_id_70094768_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "28be":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardLabel_vue_vue_type_style_index_0_id_53d91362_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8f93");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardLabel_vue_vue_type_style_index_0_id_53d91362_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardLabel_vue_vue_type_style_index_0_id_53d91362_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "28f8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/eduardo_footer.png";

/***/ }),

/***/ "2d83":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("387f");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "2ddf":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2e67":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "2f72":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaListItemExpandable_vue_vue_type_style_index_0_id_3a864df6_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1236");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaListItemExpandable_vue_vue_type_style_index_0_id_3a864df6_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaListItemExpandable_vue_vue_type_style_index_0_id_3a864df6_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2f74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),

/***/ "2fe5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "30b5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "367c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-interactive.svg";

/***/ }),

/***/ "36b6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "387f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ "3934":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ "3dde":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaHero_vue_vue_type_style_index_0_id_41074696_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f5b6");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaHero_vue_vue_type_style_index_0_id_41074696_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaHero_vue_vue_type_style_index_0_id_41074696_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3e63":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-sound-effect.svg";

/***/ }),

/***/ "3e75":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3ec6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3ed7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-skill-builder.svg";

/***/ }),

/***/ "3f87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPageWrapper_vue_vue_type_style_index_0_id_5474599a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d8b5");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPageWrapper_vue_vue_type_style_index_0_id_5474599a_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPageWrapper_vue_vue_type_style_index_0_id_5474599a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3fcf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaMenuBar_vue_vue_type_style_index_0_id_11f94db0_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a7db");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaMenuBar_vue_vue_type_style_index_0_id_11f94db0_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaMenuBar_vue_vue_type_style_index_0_id_11f94db0_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4102":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4185":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/de-logo-white.png";

/***/ }),

/***/ "4188":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-board-builder.svg";

/***/ }),

/***/ "4330":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-document.svg";

/***/ }),

/***/ "4362":
/***/ (function(module, exports, __webpack_require__) {

exports.nextTick = function nextTick(fn) {
    var args = Array.prototype.slice.call(arguments);
    args.shift();
    setTimeout(function () {
        fn.apply(null, args);
    }, 0);
};

exports.platform = exports.arch = 
exports.execPath = exports.title = 'browser';
exports.pid = 1;
exports.browser = true;
exports.env = {};
exports.argv = [];

exports.binding = function (name) {
	throw new Error('No such module. (Possibly not yet loaded)')
};

(function () {
    var cwd = '/';
    var path;
    exports.cwd = function () { return cwd };
    exports.chdir = function (dir) {
        if (!path) path = __webpack_require__("df7c");
        cwd = path.resolve(dir, cwd);
    };
})();

exports.exit = exports.kill = 
exports.umask = exports.dlopen = 
exports.uptime = exports.memoryUsage = 
exports.uvCounters = function() {};
exports.features = {};


/***/ }),

/***/ "4399":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4502":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaContainerCard_vue_vue_type_style_index_0_id_13884a24_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9987");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaContainerCard_vue_vue_type_style_index_0_id_13884a24_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaContainerCard_vue_vue_type_style_index_0_id_13884a24_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4607":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-audio.svg";

/***/ }),

/***/ "463b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-content-collection.svg";

/***/ }),

/***/ "463f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-program.svg";

/***/ }),

/***/ "467f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("2d83");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "469b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaButtonGroupItem_vue_vue_type_style_index_0_id_c56100fa_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4399");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaButtonGroupItem_vue_vue_type_style_index_0_id_c56100fa_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaButtonGroupItem_vue_vue_type_style_index_0_id_c56100fa_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4703":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-higher-ed-grouping.svg";

/***/ }),

/***/ "4890":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDropdown_vue_vue_type_style_index_0_id_14cec1d8_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4e16");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDropdown_vue_vue_type_style_index_0_id_14cec1d8_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDropdown_vue_vue_type_style_index_0_id_14cec1d8_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4905":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4a0c":
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"axios\",\"version\":\"0.21.2\",\"description\":\"Promise based HTTP client for the browser and node.js\",\"main\":\"index.js\",\"scripts\":{\"test\":\"grunt test\",\"start\":\"node ./sandbox/server.js\",\"build\":\"NODE_ENV=production grunt build\",\"preversion\":\"npm test\",\"version\":\"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json\",\"postversion\":\"git push && git push --tags\",\"examples\":\"node ./examples/server.js\",\"coveralls\":\"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js\",\"fix\":\"eslint --fix lib/**/*.js\"},\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/axios/axios.git\"},\"keywords\":[\"xhr\",\"http\",\"ajax\",\"promise\",\"node\"],\"author\":\"Matt Zabriskie\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/axios/axios/issues\"},\"homepage\":\"https://axios-http.com\",\"devDependencies\":{\"coveralls\":\"^3.0.0\",\"es6-promise\":\"^4.2.4\",\"grunt\":\"^1.3.0\",\"grunt-banner\":\"^0.6.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-clean\":\"^1.1.0\",\"grunt-contrib-watch\":\"^1.0.0\",\"grunt-eslint\":\"^23.0.0\",\"grunt-karma\":\"^4.0.0\",\"grunt-mocha-test\":\"^0.13.3\",\"grunt-ts\":\"^6.0.0-beta.19\",\"grunt-webpack\":\"^4.0.2\",\"istanbul-instrumenter-loader\":\"^1.0.0\",\"jasmine-core\":\"^2.4.1\",\"karma\":\"^6.3.2\",\"karma-chrome-launcher\":\"^3.1.0\",\"karma-firefox-launcher\":\"^2.1.0\",\"karma-jasmine\":\"^1.1.1\",\"karma-jasmine-ajax\":\"^0.1.13\",\"karma-safari-launcher\":\"^1.0.0\",\"karma-sauce-launcher\":\"^4.3.6\",\"karma-sinon\":\"^1.0.5\",\"karma-sourcemap-loader\":\"^0.3.8\",\"karma-webpack\":\"^4.0.2\",\"load-grunt-tasks\":\"^3.5.2\",\"minimist\":\"^1.2.0\",\"mocha\":\"^8.2.1\",\"sinon\":\"^4.5.0\",\"terser-webpack-plugin\":\"^4.2.3\",\"typescript\":\"^4.0.5\",\"url-search-params\":\"^0.10.0\",\"webpack\":\"^4.44.2\",\"webpack-dev-server\":\"^3.11.0\"},\"browser\":{\"./lib/adapters/http.js\":\"./lib/adapters/xhr.js\"},\"jsdelivr\":\"dist/axios.min.js\",\"unpkg\":\"dist/axios.min.js\",\"typings\":\"./index.d.ts\",\"dependencies\":{\"follow-redirects\":\"^1.14.0\"},\"bundlesize\":[{\"path\":\"./dist/axios.min.js\",\"threshold\":\"5kB\"}]}");

/***/ }),

/***/ "4a4d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4a7b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),

/***/ "4aee":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-folder.svg";

/***/ }),

/***/ "4b08":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4b68":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4c84":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4ca2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCombobox_vue_vue_type_style_index_0_id_5b4befd4_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9c7c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCombobox_vue_vue_type_style_index_0_id_5b4befd4_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCombobox_vue_vue_type_style_index_0_id_5b4befd4_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4e16":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4e166":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDropdownItem_vue_vue_type_style_index_0_id_33408c85_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5332");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDropdownItem_vue_vue_type_style_index_0_id_33408c85_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDropdownItem_vue_vue_type_style_index_0_id_33408c85_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4eaf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaProfilePanel_vue_vue_type_style_index_0_id_cb4a839e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4b08");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaProfilePanel_vue_vue_type_style_index_0_id_cb4a839e_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaProfilePanel_vue_vue_type_style_index_0_id_cb4a839e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4f15":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5024":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardGrid_vue_vue_type_style_index_0_id_182af3f6_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4c84");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardGrid_vue_vue_type_style_index_0_id_182af3f6_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardGrid_vue_vue_type_style_index_0_id_182af3f6_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "50f0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaVueSelect_vue_vue_type_style_index_1_id_f8534482_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7090");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaVueSelect_vue_vue_type_style_index_1_id_f8534482_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaVueSelect_vue_vue_type_style_index_1_id_f8534482_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5160":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "51e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaAssetCard_vue_vue_type_style_index_0_id_5bb755db_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0b90");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaAssetCard_vue_vue_type_style_index_0_id_5bb755db_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaAssetCard_vue_vue_type_style_index_0_id_5bb755db_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5270":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var transformData = __webpack_require__("c401");
var isCancel = __webpack_require__("2e67");
var defaults = __webpack_require__("2444");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "5332":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "54c3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaColumn_vue_vue_type_style_index_0_id_00f41d53_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6d58");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaColumn_vue_vue_type_style_index_0_id_00f41d53_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaColumn_vue_vue_type_style_index_0_id_00f41d53_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "564f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTestimonial_vue_vue_type_style_index_0_id_7960d10b_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9845");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTestimonial_vue_vue_type_style_index_0_id_7960d10b_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTestimonial_vue_vue_type_style_index_0_id_7960d10b_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "56fc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaGlobalNav_vue_vue_type_style_index_0_id_5b481dde_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5cd2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaGlobalNav_vue_vue_type_style_index_0_id_5b481dde_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaGlobalNav_vue_vue_type_style_index_0_id_5b481dde_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5750":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-definition-glossary-term.svg";

/***/ }),

/***/ "57f7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/de-logo.png";

/***/ }),

/***/ "5822":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/mei_footer.png";

/***/ }),

/***/ "5830":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBreadcrumbsDropdownButton_vue_vue_type_style_index_0_id_2fd34e2e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f996");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBreadcrumbsDropdownButton_vue_vue_type_style_index_0_id_2fd34e2e_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBreadcrumbsDropdownButton_vue_vue_type_style_index_0_id_2fd34e2e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "58e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("26ee");
/* harmony import */ var _stubFalse_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2f74");



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || _stubFalse_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("dd40")(module)))

/***/ }),

/***/ "5a33":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaAccordionMenu_vue_vue_type_style_index_0_id_568ecda6_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4a4d");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaAccordionMenu_vue_vue_type_style_index_0_id_568ecda6_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaAccordionMenu_vue_vue_type_style_index_0_id_568ecda6_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5a9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaToastMessages_vue_vue_type_style_index_0_id_538d1cd8_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6f0d");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaToastMessages_vue_vue_type_style_index_0_id_538d1cd8_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaToastMessages_vue_vue_type_style_index_0_id_538d1cd8_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5bc7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5c70":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5cd2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5cf7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-techbook-course.svg";

/***/ }),

/***/ "5ea3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "5f02":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ "5f1b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5f87":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "604f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/abuelo_footer.png";

/***/ }),

/***/ "6181":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "633b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6418":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaChannelCard_vue_vue_type_style_index_0_id_3c11b1ee_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4905");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaChannelCard_vue_vue_type_style_index_0_id_3c11b1ee_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaChannelCard_vue_vue_type_style_index_0_id_3c11b1ee_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6456":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardCarousel_vue_vue_type_style_index_0_id_bad1ae54_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fb60");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardCarousel_vue_vue_type_style_index_0_id_bad1ae54_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardCarousel_vue_vue_type_style_index_0_id_bad1ae54_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "653a":
/***/ (function(module) {

module.exports = JSON.parse("{\"CARCON\":{\"class\":\"carcon\",\"icon\":\"options--filled\",\"logo\":\"career-connect-vertical\"},\"CODING\":{\"class\":\"coding\",\"icon\":\"coding\",\"logo\":\"coding-logo\",\"tooltip\":\"Self-guided lessons to code with confidence\"},\"DEMB\":{\"class\":\"math\",\"icon\":\"math\",\"logo\":\"math-techbook-logo\",\"tooltip\":\"Interactive math curriculum designed for long-lasting mastery\"},\"DETB\":{\"class\":\"science\",\"icon\":\"science-flask\",\"logo\":\"science-techbook-logo\",\"tooltip\":\"Immersive, phenomena-driven science curriculum\"},\"DHC\":{\"class\":\"health\",\"icon\":\"health\",\"tooltip\":\"High-quality wellness resources for all ages\"},\"DOENG\":{\"class\":\"doodle-english\",\"icon\":\"doodle-english\",\"logo\":\"doodle-english-logo\",\"tooltip\":\"Adaptive spelling, punctuation and grammar practice for ages 5-11\"},\"DOMS\":{\"class\":\"doodle-math\",\"icon\":\"doodle-math\",\"logo\":\"doodle-maths-logo\",\"tooltip\":\"Personalised maths practice for ages 4-14\"},\"DOOD\":{\"class\":\"doodle-math\",\"icon\":\"doodle-math\",\"logo\":\"doodle-math-logo\",\"tooltip\":\"Personalized K-5 digital math practice solution\"},\"DOSP\":{\"class\":\"doodle-spell\",\"icon\":\"doodle-spell\",\"logo\":\"doodle-spell-logo\",\"tooltip\":\"Engaging, personalised spelling practice for ages 5-11\"},\"DOTA\":{\"class\":\"doodle-tables\",\"icon\":\"doodle-tables\",\"logo\":\"doodle-tables-logo\",\"tooltip\":\"Tailored times tables practice for ages 4-14\"},\"DSC\":{\"class\":\"science\",\"icon\":\"science-flask\",\"logo\":\"science-middle-logo\",\"tooltip\":\"Immersive, phenomena-driven science curriculum\"},\"DSCE\":{\"class\":\"science\",\"icon\":\"science-flask\",\"logo\":\"science-elementary-logo\",\"tooltip\":\"Immersive, phenomena-driven science curriculum\"},\"ESPRESSO\":{\"class\":\"espresso\",\"icon\":\"espresso\",\"logo\":\"espresso-logo\",\"tooltip\":\"Real-world content & instructional supports to inspire learning\"},\"HEALTHRELATIONSHIP\":{\"class\":\"health\",\"icon\":\"health\",\"logo\":\"health-and-relationships-logo\",\"tooltip\":\"High-quality wellness resources for all ages\"},\"MYSTERYSCI\":{\"class\":\"mystery\",\"icon\":\"mysteryscience\",\"logo\":\"mystery-science-horizontal\",\"smallLogo\":\"mystery-science-vertical\",\"tooltip\":\"Open-and-go science lessons students love\"},\"MYSW\":{\"class\":\"mysterywriting\",\"icon\":\"mysteryscience\",\"logo\":\"mystery-writing-horizontal\",\"smallLogo\":\"mystery-writing-vertical\",\"tooltip\":\"Open-and-go writing lessons students love\"},\"PATHWAY\":{\"class\":\"pathway\",\"icon\":\"pathway\",\"logo\":\"pathway-logo\",\"tooltip\":\"Tools & resources to accelerate career growth\"},\"SOCS\":{\"class\":\"social-studies\",\"icon\":\"social-studies\",\"logo\":\"social-studies-techbook-logo\",\"tooltip\":\"Inquiry-based social studies curriculum that explores multiple perspectives\"},\"STEM\":{\"class\":\"stem\",\"icon\":\"stem-connect\",\"logo\":\"stem-connect-logo\",\"tooltip\":\"Dynamic content & lessons to get students future-ready\"},\"SCIFTX\":{\"class\":\"science\",\"icon\":\"science-flask\",\"logo\":\"science-for-texas\",\"tooltip\":\"Immersive, phenomena-driven science curriculum\"},\"UKS\":{\"icon\":\"global-nav-secondary\",\"logo\":\"secondary-logo\"}}");

/***/ }),

/***/ "6573":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-resource-page.svg";

/***/ }),

/***/ "6591":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "69d6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6a6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTitleTooltip_vue_vue_type_style_index_0_id_e0e1f9c8_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4102");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTitleTooltip_vue_vue_type_style_index_0_id_e0e1f9c8_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTitleTooltip_vue_vue_type_style_index_0_id_e0e1f9c8_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6b0d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// runtime helper for setting properties on components
// in a tree-shakable way
exports.default = (sfc, props) => {
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props) {
        target[key] = val;
    }
    return target;
};


/***/ }),

/***/ "6b84":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./asset-5-minute-prep.svg": "ba01",
	"./asset-activity.svg": "d4ab",
	"./asset-animation.svg": "a130",
	"./asset-article.svg": "aea7",
	"./asset-assessment-question.svg": "9f41",
	"./asset-assessment.svg": "710c",
	"./asset-assignment.svg": "ad32",
	"./asset-audio-cd.svg": "1a51",
	"./asset-audio.svg": "4607",
	"./asset-audiobook.svg": "277b",
	"./asset-bcr-constructed-response.svg": "7995",
	"./asset-board-builder.svg": "4188",
	"./asset-board.svg": "98b18",
	"./asset-book.svg": "7655",
	"./asset-brain-game.svg": "ebaa",
	"./asset-channel.svg": "1962",
	"./asset-clip-art.svg": "034c",
	"./asset-coding.svg": "77fe",
	"./asset-constructed-response.svg": "733b",
	"./asset-content-collection.svg": "463b",
	"./asset-core-interactive-text.svg": "7edc",
	"./asset-definition-glossary-term.svg": "5750",
	"./asset-definition.svg": "938a",
	"./asset-document.svg": "4330",
	"./asset-ebook-1.svg": "8848",
	"./asset-ebook.svg": "75cf",
	"./asset-encyclopedia-article.svg": "10f9",
	"./asset-excel.svg": "a439",
	"./asset-exploration.svg": "b526",
	"./asset-five-minute-prep.svg": "6df6",
	"./asset-flash.svg": "ecfc",
	"./asset-folder.svg": "4aee",
	"./asset-full-video.svg": "a82f",
	"./asset-fun-damental.svg": "7225",
	"./asset-game.svg": "81c6",
	"./asset-general-graphic-organizer.svg": "e9ca",
	"./asset-glossary-term.svg": "7b22",
	"./asset-graphic-organizer.svg": "112b",
	"./asset-higher-ed-course.svg": "7603",
	"./asset-higher-ed-discipline.svg": "7575",
	"./asset-higher-ed-grouping.svg": "4703",
	"./asset-higher-ed-objective.svg": "7ac2",
	"./asset-higher-ed-unit.svg": "c54a",
	"./asset-image.svg": "87b0",
	"./asset-integrated-science-simulation.svg": "d00d",
	"./asset-interactive-lesson.svg": "f91b",
	"./asset-interactive-map.svg": "81a4",
	"./asset-interactive-video.svg": "bdd9",
	"./asset-interactive.svg": "367c",
	"./asset-investigation.svg": "aa94",
	"./asset-learning-guide.svg": "aab0",
	"./asset-lesson-plan-video-guide.svg": "6e50",
	"./asset-lesson-plan.svg": "9506",
	"./asset-math-explanation.svg": "9450",
	"./asset-math-exploration.svg": "7ce3",
	"./asset-math-interactive.svg": "a047",
	"./asset-math-overview.svg": "1a99",
	"./asset-multi-layer-map.svg": "d707",
	"./asset-non-searchable-image.svg": "a838",
	"./asset-overview-page.svg": "9bfb",
	"./asset-pdf-activity.svg": "1a0c",
	"./asset-podcast.svg": "f4b8",
	"./asset-program.svg": "463f",
	"./asset-project.svg": "1ad4",
	"./asset-quiz-question.svg": "d9ef",
	"./asset-quiz.svg": "8489",
	"./asset-reading-passage.svg": "8263",
	"./asset-resource-page-content-collection.svg": "d761",
	"./asset-resource-page.svg": "6573",
	"./asset-resource.svg": "d54b",
	"./asset-review-sheet.svg": "d893",
	"./asset-save-state.svg": "2567",
	"./asset-science-sleuth.svg": "b16f",
	"./asset-science-tool.svg": "ef87",
	"./asset-section.svg": "e03b",
	"./asset-simulation-exploration.svg": "172d",
	"./asset-skill-builder.svg": "3ed7",
	"./asset-slideshow.svg": "dd49",
	"./asset-song.svg": "04e3",
	"./asset-sound-effect.svg": "3e63",
	"./asset-state-standards.svg": "bcc7",
	"./asset-subskill.svg": "bbfa",
	"./asset-techbook-concept-page.svg": "f815",
	"./asset-techbook-course.svg": "5cf7",
	"./asset-techbook-discipline.svg": "117e",
	"./asset-techbook-subdiscipline.svg": "21b3",
	"./asset-techbook-unit.svg": "16fc",
	"./asset-technology-enhanced-assessment.svg": "eb52",
	"./asset-tei.svg": "88a9",
	"./asset-theme.svg": "f962",
	"./asset-title-chapter-section-video-segment.svg": "f25c",
	"./asset-title-chapter-video-segment.svg": "fe70",
	"./asset-title-full-video.svg": "ae14",
	"./asset-video-guide.svg": "e55f",
	"./asset-video-segment.svg": "2712",
	"./asset-video.svg": "765b",
	"./asset-virtual-lab.svg": "77b8",
	"./asset-writing-prompt.svg": "95f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b84";

/***/ }),

/***/ "6cae":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6d58":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6dd8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "6df6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-five-minute-prep.svg";

/***/ }),

/***/ "6e50":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-lesson-plan-video-guide.svg";

/***/ }),

/***/ "6e67":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6eaf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFooterCharacter_vue_vue_type_style_index_0_id_511e6fc5_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("69d6");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFooterCharacter_vue_vue_type_style_index_0_id_511e6fc5_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFooterCharacter_vue_vue_type_style_index_0_id_511e6fc5_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6ef7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCarousel_vue_vue_type_style_index_0_id_2e936875_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("76ff");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCarousel_vue_vue_type_style_index_0_id_2e936875_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCarousel_vue_vue_type_style_index_0_id_2e936875_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6f0d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7090":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "710c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-assessment.svg";

/***/ }),

/***/ "7225":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-fun-damental.svg";

/***/ }),

/***/ "733b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-constructed-response.svg";

/***/ }),

/***/ "74bc":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7573":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7575":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-higher-ed-discipline.svg";

/***/ }),

/***/ "75a2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFieldGroup_vue_vue_type_style_index_0_id_16932657_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9ed0");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFieldGroup_vue_vue_type_style_index_0_id_16932657_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFieldGroup_vue_vue_type_style_index_0_id_16932657_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "75cf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-ebook.svg";

/***/ }),

/***/ "7603":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-higher-ed-course.svg";

/***/ }),

/***/ "7655":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-book.svg";

/***/ }),

/***/ "765b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-video.svg";

/***/ }),

/***/ "76f6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDropdownPagination_vue_vue_type_style_index_0_id_619ecd74_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("19c1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDropdownPagination_vue_vue_type_style_index_0_id_619ecd74_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDropdownPagination_vue_vue_type_style_index_0_id_619ecd74_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "76ff":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7702":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaRow_vue_vue_type_style_index_0_id_7ab5d144_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e3a6");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaRow_vue_vue_type_style_index_0_id_7ab5d144_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaRow_vue_vue_type_style_index_0_id_7ab5d144_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "772d":
/***/ (function(module) {

module.exports = JSON.parse("{\"Assets\":[\"asset-lesson\",\"asset-studio-quiz\",\"asset-tea\",\"board-builder\",\"build-step\",\"channel\",\"chat-quiz\",\"choice-board\",\"drama\",\"draw\",\"educator\",\"field-trip\",\"glossary\",\"immersive-reader\",\"journal\",\"life\",\"multi-choice\",\"multi-select\",\"paw\",\"poll\",\"practice-step\",\"quiz\",\"sequential\",\"short-answer\",\"solve-step\",\"student\",\"studio-board\",\"studio-slideshow\",\"studio-slideshow--filled\",\"studio-template\",\"studio-template-create\",\"video-quiz\"],\"Coding\":[\"coding-animation\",\"coding-command\",\"coding-command-round-end\",\"coding-control\",\"coding-event\",\"coding-key\",\"coding-object\",\"coding-object-variable\",\"coding-operator\",\"coding-type-variable\",\"coding-value\"],\"Comet-Assets\":[\"asset-5-minute-prep\",\"asset-activity\",\"asset-animation\",\"asset-article\",\"asset-assessment\",\"asset-assessment-question\",\"asset-assignment\",\"asset-audio\",\"asset-audio-cd\",\"asset-audiobook\",\"asset-bcr-constructed-response\",\"asset-board\",\"asset-board-builder\",\"asset-book\",\"asset-brain-game\",\"asset-channel\",\"asset-clip-art\",\"asset-coding\",\"asset-constructed-response\",\"asset-content-collection\",\"asset-core-interactive-text\",\"asset-definition\",\"asset-definition-glossary-term\",\"asset-document\",\"asset-ebook\",\"asset-ebook-1\",\"asset-encyclopedia-article\",\"asset-excel\",\"asset-exploration\",\"asset-five-minute-prep\",\"asset-flash\",\"asset-folder\",\"asset-full-video\",\"asset-fun-damental\",\"asset-game\",\"asset-general-graphic-organizer\",\"asset-glossary-term\",\"asset-graphic-organizer\",\"asset-higher-ed-course\",\"asset-higher-ed-discipline\",\"asset-higher-ed-grouping\",\"asset-higher-ed-objective\",\"asset-higher-ed-unit\",\"asset-image\",\"asset-integrated-science-simulation\",\"asset-interactive\",\"asset-interactive-lesson\",\"asset-interactive-map\",\"asset-interactive-video\",\"asset-investigation\",\"asset-learning-guide\",\"asset-lesson-plan\",\"asset-lesson-plan-video-guide\",\"asset-math-explanation\",\"asset-math-exploration\",\"asset-math-interactive\",\"asset-math-overview\",\"asset-multi-layer-map\",\"asset-non-searchable-image\",\"asset-overview-page\",\"asset-pdf-activity\",\"asset-podcast\",\"asset-program\",\"asset-project\",\"asset-quiz\",\"asset-quiz-question\",\"asset-reading-passage\",\"asset-resource\",\"asset-resource-page\",\"asset-resource-page-content-collection\",\"asset-review-sheet\",\"asset-save-state\",\"asset-science-sleuth\",\"asset-science-tool\",\"asset-section\",\"asset-simulation-exploration\",\"asset-skill-builder\",\"asset-slideshow\",\"asset-song\",\"asset-sound-effect\",\"asset-state-standards\",\"asset-subskill\",\"asset-techbook-concept-page\",\"asset-techbook-course\",\"asset-techbook-discipline\",\"asset-techbook-subdiscipline\",\"asset-techbook-unit\",\"asset-technology-enhanced-assessment\",\"asset-tei\",\"asset-theme\",\"asset-title-chapter-section-video-segment\",\"asset-title-chapter-video-segment\",\"asset-title-full-video\",\"asset-video\",\"asset-video-guide\",\"asset-video-segment\",\"asset-virtual-lab\",\"asset-writing-prompt\"],\"Comet-Global-Nav\":[\"global-nav-assessment\",\"global-nav-assignments\",\"global-nav-board-builder\",\"global-nav-builder-tools\",\"global-nav-classrooms\",\"global-nav-den\",\"global-nav-english\",\"global-nav-health\",\"global-nav-math-techbook\",\"global-nav-my-admin\",\"global-nav-my-content\",\"global-nav-my-de\",\"global-nav-my-notebook\",\"global-nav-professional-learning\",\"global-nav-science\",\"global-nav-science-elementary\",\"global-nav-science-middle\",\"global-nav-science-techbook\",\"global-nav-search\",\"global-nav-secondary\",\"global-nav-ss-techbook\",\"global-nav-stem-connect\",\"global-nav-streaming\",\"global-nav-studio-beta\",\"global-nav-trending-topics\"],\"Comet-Interface\":[\"add\",\"add-point\",\"add-to-builder\",\"answer\",\"assign\",\"attachment\",\"badge-correct\",\"badge-incorrect\",\"bar-chart\",\"bell\",\"books\",\"channel\",\"check-circle\",\"check-complete\",\"check-incomplete\",\"circle-o\",\"clock-reverse\",\"cloud-upload\",\"collapse-all\",\"comment\",\"contain-image\",\"conversation\",\"conversation-active\",\"copy-alt\",\"create\",\"crop-image\",\"definition\",\"delete\",\"delete-alt\",\"device-rotate\",\"did-you-know\",\"display\",\"display-grid\",\"display-list\",\"document\",\"document-pdf\",\"dots-nine\",\"dots-six\",\"edit-profile\",\"erase\",\"evaluation-criteria\",\"exclamation\",\"expand-all\",\"eye\",\"eye-hidden\",\"feedback-bug\",\"feedback-comment\",\"feedback-suggestion\",\"flame\",\"flip-x\",\"flip-y\",\"grabby\",\"graphing\",\"hand\",\"headline\",\"headphones\",\"help\",\"honeycomb\",\"icon-placeholder\",\"image-alt\",\"immersive-reader\",\"layout-horizontal\",\"layout-thumbnail\",\"layout-vertical\",\"levels\",\"life-ring\",\"live-chat\",\"live-chat-available\",\"live-chat-unavailable\",\"menu\",\"message-error\",\"message-information\",\"message-warning\",\"minus-point\",\"misconception\",\"move-vertical\",\"notification\",\"palette\",\"profile\",\"quicklist-remove\",\"reset\",\"rotate-left\",\"rotate-right\",\"send\",\"share-alt\",\"sortable-asc\",\"sortable-desc\",\"square-grid\",\"stash\",\"stop-impersonating\",\"submit\",\"teacher-note\",\"text\",\"to-bottom\",\"to-top\",\"tool-box\",\"transcript\",\"triangle-up-down\",\"unlocked\",\"up-down-arrows\",\"upper-right-arrow\",\"video-camera\",\"waffle\",\"whiteboard\",\"wizard-active\",\"wizard-passive\"],\"Comet-Misc\":[\"callout-did-you-know\",\"callout-glossary-term\",\"callout-misconception\",\"callout-state-standard\",\"callout-teacher-note\",\"color\",\"consistency\",\"efficiency\",\"facebook\",\"google-plus\",\"instagram\",\"linkedin\",\"pinterest\",\"quality\",\"space\",\"space-alt\",\"token\",\"twitter\",\"youtube\"],\"Comet-Techbook\":[\"analyze\",\"anchor\",\"ask-questions\",\"assessment-item\",\"behind-the-science\",\"can-you-explain\",\"cer\",\"design-solutions\",\"discourse\",\"earth-and-space-science\",\"evaluate\",\"gears\",\"hoa\",\"interpret-data\",\"investigate\",\"life-science\",\"materials\",\"microscope\",\"modeling\",\"observe\",\"physical-science\",\"preperation\",\"record-evidence\",\"solve-problems\",\"storyline\",\"student-background\",\"think-reason\",\"vocabulary\",\"what-did-i-figure-out\"],\"Comet-Tools\":[\"tool-atlas\",\"tool-construction\",\"tool-equation-solver\",\"tool-geometry\",\"tool-global-news\",\"tool-graphing-calculator\",\"tool-matrix-solver\",\"tool-scientific-calculator\",\"tool-standard-calculator\",\"tool-unit-converter\",\"tool-whiteboard\"],\"Creative\":[\"chalk-arrow-down\",\"chalk-arrow-left\",\"chalk-arrow-right\",\"chalk-arrow-up\"],\"Filled\":[\"screen share--filled\",\"stop-screen-share--filled\",\"toolbox--filled\"],\"Global-Nav\":[\"admin\",\"assessment\",\"classroom\",\"doodle-english\",\"doodle-math\",\"doodle-spell\",\"doodle-tables\",\"learning\",\"sos\",\"standard\",\"studio\",\"subject\"],\"Harvey Balls\":[\"harvey-01\",\"harvey-02\",\"harvey-03\",\"harvey-04\",\"harvey-05\",\"harvey-06\",\"harvey-07\",\"harvey-08\"],\"Interface\":[\"activity\",\"add-asset\",\"align-bottom\",\"align-center\",\"align-justify\",\"align-left\",\"align-middle\",\"align-right\",\"align-text\",\"align-top\",\"app\",\"archive\",\"arrow-down\",\"arrow-down-circle\",\"arrow-down-left\",\"arrow-down-right\",\"arrow-left\",\"arrow-left-circle\",\"arrow-right\",\"arrow-right-circle\",\"arrow-up\",\"arrow-up-circle\",\"arrow-up-left\",\"arrow-up-right\",\"assignment\",\"audio\",\"audio-book\",\"avatar\",\"background-image\",\"badge-check\",\"badge-warning\",\"bold\",\"book\",\"bookmark\",\"bring-forwards\",\"bring-to-front\",\"brush size\",\"bucket\",\"buildings\",\"button\",\"calendar\",\"calendar-add\",\"calendar-minus\",\"camera\",\"cancel\",\"caret-down\",\"caret-left\",\"caret-right\",\"caret-up\",\"caution\",\"chat-active\",\"chat-inactive\",\"check\",\"checkbox-empty\",\"circle\",\"circle-check\",\"circle-minus\",\"circle-play\",\"circle-plus\",\"circle-question\",\"circle-x\",\"clear-canvas\",\"clipboard\",\"clock\",\"closed-caption\",\"cloud\",\"computer\",\"copy\",\"copy-to-clipboard\",\"crop\",\"dashboard\",\"debug\",\"doodle-math\",\"dots\",\"download\",\"drag-and-drop\",\"drive\",\"edit\",\"ellipses\",\"ellipses-vertical\",\"ellipsis\",\"ellipsis-vertical\",\"eraser\",\"expand\",\"explore\",\"eyedropper\",\"fast-forward\",\"flag\",\"folder\",\"folder-add\",\"folder-minus\",\"folder-open\",\"fullscreen\",\"fullscreen-exit\",\"gear\",\"globe\",\"grid\",\"grip\",\"hamburger\",\"happy\",\"heart\",\"hide\",\"hierarchy\",\"highlight\",\"history\",\"hit\",\"home\",\"image\",\"inbox\",\"information\",\"interactive\",\"italic\",\"landscape\",\"laptop\",\"layer\",\"lightbulb\",\"line tool\",\"link\",\"list\",\"lock\",\"log-in\",\"log-out\",\"mail\",\"mail-send\",\"map\",\"maximize\",\"messaging\",\"microphone\",\"microphone-off\",\"minus\",\"move-horizontal\",\"move-to-bottom\",\"move-to-top\",\"move-tool\",\"move-vertical\",\"multiple-tries\",\"music\",\"mute\",\"neutral-face\",\"new-window\",\"notes\",\"notifications\",\"notifications-off\",\"numeric-list\",\"options\",\"options-vertical\",\"page\",\"page-add\",\"paint-brush\",\"paperclip\",\"paragraph\",\"pause\",\"pdf\",\"pin\",\"play\",\"plus\",\"pointer\",\"portrait\",\"print\",\"puzzle\",\"qr-code\",\"quicklist\",\"quote\",\"quote-end\",\"redo\",\"refresh\",\"refresh-circle\",\"remix\",\"rename\",\"rewind\",\"rotate\",\"sad\",\"safety\",\"science-flask\",\"search\",\"send-backwards\",\"send-to-back\",\"share\",\"show\",\"sidebar-collapse\",\"sidebar-expand\",\"skip-backward\",\"skip-forward\",\"some-points\",\"sort-asc\",\"sort-desc\",\"sortable\",\"square\",\"star\",\"start\",\"stopwatch\",\"strikethrough\",\"subscript\",\"sun\",\"sun-down\",\"superscript\",\"table\",\"test-tube\",\"text-options\",\"text-tracking\",\"time-afternoon\",\"time-early-morning\",\"time-late-afternoon\",\"time-late-morning\",\"time-morning\",\"time-night\",\"time-sensitive\",\"toolbox\",\"trash\",\"triangle-down\",\"triangle-left\",\"triangle-right\",\"triangle-up\",\"trophy\",\"underline\",\"undo\",\"unlink\",\"unlock\",\"upload\",\"user\",\"user-add\",\"user-check\",\"user-minus\",\"users\",\"vector-tool\",\"video\",\"video-advance\",\"video-loop\",\"video-off\",\"video-speed\",\"volume-0\",\"volume-high\",\"volume-low\",\"warning\",\"world-globe\",\"x\",\"zoom-in\",\"zoom-out\"],\"Interface-Filled\":[\"align-bottom--filled\",\"align-center--filled\",\"align-left--filled\",\"align-middle--filled\",\"align-right--filled\",\"align-top--filled\",\"archive--filled\",\"avatar--filled\",\"background-image--filled\",\"badge-check--filled\",\"badge-warning--filled\",\"book--filled\",\"bookmark--filled\",\"bucket--filled\",\"calendar--filled\",\"camera--filled\",\"cancel--filled\",\"caution--filled\",\"chat-active--filled\",\"chat-inactive--filled\",\"checkbox--filled\",\"circle--filled\",\"circle-check--filled\",\"circle-minus--filled\",\"circle-play--filled\",\"circle-plus--filled\",\"circle-question--filled\",\"circle-x--filled\",\"classroom--filled\",\"clear-canvas--filled\",\"clipboard--filled\",\"clock--filled\",\"cloud--filled\",\"computer--filled\",\"copy--filled\",\"drive--filled\",\"edit--filled\",\"eraser--filled\",\"eyedropper--filled\",\"fast-forward--filled\",\"flag--filled\",\"folder--filled\",\"folder-open--filled\",\"gear--filled\",\"grid--filled\",\"happy--filled\",\"heart--filled\",\"hide--filled\",\"hierarchy--filled\",\"highlight--filled\",\"home--filled\",\"image--filled\",\"information--filled\",\"landscape--filled\",\"layer--filled\",\"lightbulb--filled\",\"lock--filled\",\"map--filled\",\"messaging--filled\",\"microphone--filled\",\"microphone-off--filled\",\"move-horizontal--filled\",\"move-vertical--filled\",\"music--filled\",\"mute--filled\",\"neutral-face--filled\",\"notes--filled\",\"notifications--filled\",\"notifications-off--filled\",\"options--filled\",\"options-vertical--filled\",\"paint-brush--filled\",\"paint-brush-size--filled\",\"paragraph--filled\",\"pin--filled\",\"play--filled\",\"portrait--filled\",\"puzzle--filled\",\"quote--filled\",\"quote-end--filled\",\"rewind--filled\",\"sad--filled\",\"science-flask--filled\",\"share--filled\",\"show--filled\",\"skip-backward--filled\",\"skip-forward--filled\",\"square--filled\",\"star--filled\",\"stopwatch--filled\",\"sun--filled\",\"sun-down--filled\",\"test-tube--filled\",\"toolbox--filled\",\"trash--filled\",\"triangle-down--filled\",\"triangle-left--filled\",\"triangle-right--filled\",\"triangle-up--filled\",\"trophy--filled\",\"unlock--filled\",\"user--filled\",\"users--filled\",\"vector-tool--filled\",\"video--filled\",\"video-off--filled\",\"volume-0--filled\",\"volume-high--filled\",\"volume-low--filled\",\"warning--filled\",\"zoom-in--filled\",\"zoom-out--filled\"],\"Other\":[\"engage-spiral\"],\"Outline\":[\"checkbox-strike\",\"integration\",\"screen-share\",\"screen-share-stop\"],\"Product-Logos\":[\"career-connect-horizontal\",\"career-connect-vertical\",\"coding-logo\",\"community-logo\",\"curriculum-connect-logo\",\"doodle-english-logo\",\"doodle-math-logo\",\"doodle-maths-logo\",\"doodle-spell-logo\",\"doodle-tables-logo\",\"espresso-logo\",\"experience-logo\",\"featured-programs-logo\",\"health-and-relationships-logo\",\"health-logo\",\"math-logo\",\"math-techbook-horizontal\",\"math-techbook-logo\",\"mystery-packs-horizontal\",\"mystery-packs-vertical\",\"mystery-science-horizontal\",\"mystery-science-vertical\",\"mystery-writing-horizontal\",\"mystery-writing-vertical\",\"pathway-logo\",\"professional-development-logo\",\"professional-learning-logo\",\"science-elementary-horizontal\",\"science-elementary-logo\",\"science-for-texas\",\"science-for-texas-horizontal\",\"science-for-texas-logo\",\"science-logo\",\"science-middle-horizontal\",\"science-middle-logo\",\"science-techbook-horizontal\",\"science-techbook-logo\",\"science-techbook-ngss-logo\",\"science-techbook-texas\",\"science-techbook-texas-logo\",\"secondary-logo\",\"social-studies-logo\",\"social-studies-techbook-horizontal\",\"social-studies-techbook-logo\",\"st-math-logo\",\"stem-connect-horizontal\",\"stem-connect-logo\"],\"Techbook\":[\"check-your-understanding\",\"coding\",\"espresso\",\"health\",\"math\",\"mysteryscience\",\"pathway\",\"secondary\",\"sequential\",\"social-studies\",\"split-group\",\"station-rotation\",\"stem-connect\",\"whole-class\"]}");

/***/ }),

/***/ "77b8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-virtual-lab.svg";

/***/ }),

/***/ "77f5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaSwitch_vue_vue_type_style_index_0_id_03f59b55_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("03d8");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaSwitch_vue_vue_type_style_index_0_id_03f59b55_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaSwitch_vue_vue_type_style_index_0_id_03f59b55_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "77f6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIconSidebar_vue_vue_type_style_index_0_id_051a6281_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1893");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIconSidebar_vue_vue_type_style_index_0_id_051a6281_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIconSidebar_vue_vue_type_style_index_0_id_051a6281_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "77fe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-coding.svg";

/***/ }),

/***/ "7995":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-bcr-constructed-response.svg";

/***/ }),

/***/ "7a77":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "7aac":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ "7ac2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-higher-ed-objective.svg";

/***/ }),

/***/ "7b05":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaVideoSegmentCard_vue_vue_type_style_index_0_id_32b7ebcb_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("898f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaVideoSegmentCard_vue_vue_type_style_index_0_id_32b7ebcb_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaVideoSegmentCard_vue_vue_type_style_index_0_id_32b7ebcb_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7b22":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-glossary-term.svg";

/***/ }),

/***/ "7b74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaOpenIndicator_vue_vue_type_style_index_0_id_9b4a5bdc_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2fe5");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaOpenIndicator_vue_vue_type_style_index_0_id_9b4a5bdc_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaOpenIndicator_vue_vue_type_style_index_0_id_9b4a5bdc_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7c1b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7ce3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-math-exploration.svg";

/***/ }),

/***/ "7dfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaImageRow_vue_vue_type_style_index_0_id_331fb13c_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4f15");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaImageRow_vue_vue_type_style_index_0_id_331fb13c_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaImageRow_vue_vue_type_style_index_0_id_331fb13c_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7edc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-core-interactive-text.svg";

/***/ }),

/***/ "810a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPopover_vue_vue_type_style_index_0_id_244aeecb_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2804");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPopover_vue_vue_type_style_index_0_id_244aeecb_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPopover_vue_vue_type_style_index_0_id_244aeecb_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "812b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/quicklist-empty-state.png";

/***/ }),

/***/ "81a4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-interactive-map.svg";

/***/ }),

/***/ "81c6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-game.svg";

/***/ }),

/***/ "824f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaGridRow_vue_vue_type_style_index_0_id_a8b87a8a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e0e1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaGridRow_vue_vue_type_style_index_0_id_a8b87a8a_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaGridRow_vue_vue_type_style_index_0_id_a8b87a8a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8263":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-reading-passage.svg";

/***/ }),

/***/ "8294":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDraggableCards_vue_vue_type_style_index_0_id_216cc2ba_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9ed2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDraggableCards_vue_vue_type_style_index_0_id_216cc2ba_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDraggableCards_vue_vue_type_style_index_0_id_216cc2ba_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "82e1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaImage_vue_vue_type_style_index_0_id_769a0fc8_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9bb7");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaImage_vue_vue_type_style_index_0_id_769a0fc8_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaImage_vue_vue_type_style_index_0_id_769a0fc8_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8303":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/nebula.svg";

/***/ }),

/***/ "83b9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__("d925");
var combineURLs = __webpack_require__("e683");

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ "8461":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8489":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-quiz.svg";

/***/ }),

/***/ "848b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__("4a0c");

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ "851a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFooter_vue_vue_type_style_index_0_id_7b26c40e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a52c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFooter_vue_vue_type_style_index_0_id_7b26c40e_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFooter_vue_vue_type_style_index_0_id_7b26c40e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8532":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaClassroomCard_vue_vue_type_style_index_0_id_2deea084_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e0ac");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaClassroomCard_vue_vue_type_style_index_0_id_2deea084_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaClassroomCard_vue_vue_type_style_index_0_id_2deea084_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8654":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8694":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/default-profile-avatar.png";

/***/ }),

/***/ "87b0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-image.svg";

/***/ }),

/***/ "880f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCard_vue_vue_type_style_index_0_id_74c1e8b8_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e5cc");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCard_vue_vue_type_style_index_0_id_74c1e8b8_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCard_vue_vue_type_style_index_0_id_74c1e8b8_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8848":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-ebook-1.svg";

/***/ }),

/***/ "8866":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "88a9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-tei.svg";

/***/ }),

/***/ "88ad":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8916":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/victor_footer.png";

/***/ }),

/***/ "898f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8b54":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFavoritesButton_vue_vue_type_style_index_0_id_c1d30804_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("db8f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFavoritesButton_vue_vue_type_style_index_0_id_c1d30804_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFavoritesButton_vue_vue_type_style_index_0_id_c1d30804_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "8bde":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaGridBlock_vue_vue_type_style_index_0_id_809fb3cc_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a84a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaGridBlock_vue_vue_type_style_index_0_id_809fb3cc_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaGridBlock_vue_vue_type_style_index_0_id_809fb3cc_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("7a77");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "8eda":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8f8f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaRadio_vue_vue_type_style_index_0_id_7c368bc0_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b23a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaRadio_vue_vue_type_style_index_0_id_7c368bc0_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaRadio_vue_vue_type_style_index_0_id_7c368bc0_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8f93":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9020":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTabs_vue_vue_type_style_index_0_id_011a329e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("148f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTabs_vue_vue_type_style_index_0_id_011a329e_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTabs_vue_vue_type_style_index_0_id_011a329e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "90b2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "921f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "938a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-definition.svg";

/***/ }),

/***/ "9450":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-math-explanation.svg";

/***/ }),

/***/ "945a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9469":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "94e3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/footer-sprite.png";

/***/ }),

/***/ "9506":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-lesson-plan.svg";

/***/ }),

/***/ "95ea":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "95f0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-writing-prompt.svg";

/***/ }),

/***/ "9845":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9874":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDialog_vue_vue_type_style_index_0_id_06e01d37_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("921f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDialog_vue_vue_type_style_index_0_id_06e01d37_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDialog_vue_vue_type_style_index_0_id_06e01d37_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "98b1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "98b18":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-board.svg";

/***/ }),

/***/ "9961":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFormHelper_vue_vue_type_style_index_0_id_9c828ff6_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6e67");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFormHelper_vue_vue_type_style_index_0_id_9c828ff6_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFormHelper_vue_vue_type_style_index_0_id_9c828ff6_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9987":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9a37":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9af3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFloatingActionButton_vue_vue_type_style_index_0_id_43ac5d7a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0c7a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFloatingActionButton_vue_vue_type_style_index_0_id_43ac5d7a_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFloatingActionButton_vue_vue_type_style_index_0_id_43ac5d7a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9b74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaAssignmentCard_vue_vue_type_style_index_0_id_69c1524f_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("14c2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaAssignmentCard_vue_vue_type_style_index_0_id_69c1524f_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaAssignmentCard_vue_vue_type_style_index_0_id_69c1524f_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9bb7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9bfb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-overview-page.svg";

/***/ }),

/***/ "9c7c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9cb6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9e0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBackToTop_vue_vue_type_style_index_0_id_c7bd3592_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fd9e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBackToTop_vue_vue_type_style_index_0_id_c7bd3592_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBackToTop_vue_vue_type_style_index_0_id_c7bd3592_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9ed0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9ed2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9f41":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-assessment-question.svg";

/***/ }),

/***/ "9ffd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCallToAction_vue_vue_type_style_index_0_id_6a5d98c8_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c0aa");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCallToAction_vue_vue_type_style_index_0_id_6a5d98c8_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCallToAction_vue_vue_type_style_index_0_id_6a5d98c8_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a047":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-math-interactive.svg";

/***/ }),

/***/ "a0a2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a0f2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCheckbox_vue_vue_type_style_index_0_id_574fc5f0_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6cae");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCheckbox_vue_vue_type_style_index_0_id_574fc5f0_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCheckbox_vue_vue_type_style_index_0_id_574fc5f0_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a130":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-animation.svg";

/***/ }),

/***/ "a1306":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBlockMessage_vue_vue_type_style_index_0_id_4e5d908e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("030c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBlockMessage_vue_vue_type_style_index_0_id_4e5d908e_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBlockMessage_vue_vue_type_style_index_0_id_4e5d908e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a14a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a1ab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardMetadata_vue_vue_type_style_index_0_id_669c7497_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b135");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardMetadata_vue_vue_type_style_index_0_id_669c7497_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardMetadata_vue_vue_type_style_index_0_id_669c7497_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a266":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/disco_footer.png";

/***/ }),

/***/ "a3cd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a3fe":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a439":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-excel.svg";

/***/ }),

/***/ "a52c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a536":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTabDropdown_vue_vue_type_style_index_0_id_482cb0a6_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d82b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTabDropdown_vue_vue_type_style_index_0_id_482cb0a6_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTabDropdown_vue_vue_type_style_index_0_id_482cb0a6_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a594":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a6d9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaSidebar_vue_vue_type_style_index_0_id_52285868_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6591");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaSidebar_vue_vue_type_style_index_0_id_52285868_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaSidebar_vue_vue_type_style_index_0_id_52285868_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a7c2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a7db":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a82f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-full-video.svg";

/***/ }),

/***/ "a838":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-non-searchable-image.svg";

/***/ }),

/***/ "a846":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTabItem_vue_vue_type_style_index_0_id_6c86c15e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7c1b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTabItem_vue_vue_type_style_index_0_id_6c86c15e_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTabItem_vue_vue_type_style_index_0_id_6c86c15e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a84a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a879":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a8c8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTextarea_vue_vue_type_style_index_0_id_63e72c4e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("104b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTextarea_vue_vue_type_style_index_0_id_63e72c4e_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTextarea_vue_vue_type_style_index_0_id_63e72c4e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "aa47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiDrag", function() { return MultiDragPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sortable", function() { return Sortable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Swap", function() { return SwapPlugin; });
/**!
 * Sortable 1.14.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var version = "1.14.0";

function userAgent(pattern) {
  if (typeof window !== 'undefined' && window.navigator) {
    return !! /*@__PURE__*/navigator.userAgent.match(pattern);
  }
}

var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

var captureMode = {
  capture: false,
  passive: false
};

function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}

function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}

function matches(
/**HTMLElement*/
el,
/**String*/
selector) {
  if (!selector) return;
  selector[0] === '>' && (selector = selector.substring(1));

  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }

  return false;
}

function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}

function closest(
/**HTMLElement*/
el,
/**String*/
selector,
/**HTMLElement*/
ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;

    do {
      if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }

      if (el === ctx) break;
      /* jshint boss:true */
    } while (el = getParentOrHost(el));
  }

  return null;
}

var R_SPACE = /\s+/g;

function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? 'add' : 'remove'](name);
    } else {
      var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
      el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
    }
  }
}

function css(el, prop, val) {
  var style = el && el.style;

  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, '');
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }

      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf('webkit') === -1) {
        prop = '-webkit-' + prop;
      }

      style[prop] = val + (typeof val === 'string' ? '' : 'px');
    }
  }
}

function matrix(el, selfOnly) {
  var appliedTransforms = '';

  if (typeof el === 'string') {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, 'transform');

      if (transform && transform !== 'none') {
        appliedTransforms = transform + ' ' + appliedTransforms;
      }
      /* jshint boss:true */

    } while (!selfOnly && (el = el.parentNode));
  }

  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  /*jshint -W056 */

  return matrixFn && new matrixFn(appliedTransforms);
}

function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName),
        i = 0,
        n = list.length;

    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }

    return list;
  }

  return [];
}

function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;

  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */


function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;

  if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }

  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    // Adjust for translate()
    container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
    // Not needed on <= IE11

    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
          var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

          top -= containerRect.top + parseInt(css(container, 'border-top-width'));
          left -= containerRect.left + parseInt(css(container, 'border-left-width'));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
        /* jshint boss:true */

      } while (container = container.parentNode);
    }
  }

  if (undoScale && el !== window) {
    // Adjust for scale()
    var elMatrix = matrix(container || el),
        scaleX = elMatrix && elMatrix.a,
        scaleY = elMatrix && elMatrix.d;

    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }

  return {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    width: width,
    height: height
  };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */


function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true),
      elSideVal = getRect(el)[elSide];
  /* jshint boss:true */

  while (parent) {
    var parentSideVal = getRect(parent)[parentSide],
        visible = void 0;

    if (parentSide === 'top' || parentSide === 'left') {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }

    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }

  return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */


function getChild(el, childNum, options, includeDragEl) {
  var currentChild = 0,
      i = 0,
      children = el.children;

  while (i < children.length) {
    if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && (includeDragEl || children[i] !== Sortable.dragged) && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }

      currentChild++;
    }

    i++;
  }

  return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */


function lastChild(el, selector) {
  var last = el.lastElementChild;

  while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }

  return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */


function index(el, selector) {
  var index = 0;

  if (!el || !el.parentNode) {
    return -1;
  }
  /* jshint boss:true */


  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index++;
    }
  }

  return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */


function getRelativeScrollOffset(el) {
  var offsetLeft = 0,
      offsetTop = 0,
      winScroller = getWindowScrollingElement();

  if (el) {
    do {
      var elMatrix = matrix(el),
          scaleX = elMatrix.a,
          scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }

  return [offsetLeft, offsetTop];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */


function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }

  return -1;
}

function getParentAutoScrollElement(el, includeSelf) {
  // skip to window
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;

  do {
    // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);

      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
    /* jshint boss:true */

  } while (elem = elem.parentNode);

  return getWindowScrollingElement();
}

function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }

  return dst;
}

function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}

var _throttleTimeout;

function throttle(callback, ms) {
  return function () {
    if (!_throttleTimeout) {
      var args = arguments,
          _this = this;

      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }

      _throttleTimeout = setTimeout(function () {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}

function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}

function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}

function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;

  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}

function setRect(el, rect) {
  css(el, 'position', 'absolute');
  css(el, 'top', rect.top);
  css(el, 'left', rect.left);
  css(el, 'width', rect.width);
  css(el, 'height', rect.height);
}

function unsetRect(el) {
  css(el, 'position', '');
  css(el, 'top', '');
  css(el, 'left', '');
  css(el, 'width', '');
  css(el, 'height', '');
}

var expando = 'Sortable' + new Date().getTime();

function AnimationStateManager() {
  var animationStates = [],
      animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function (child) {
        if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });

        var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);

          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }

        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;

      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === 'function') callback();
        return;
      }

      var animating = false,
          animationTime = 0;
      animationStates.forEach(function (state) {
        var time = 0,
            target = state.target,
            fromRect = target.fromRect,
            toRect = getRect(target),
            prevFromRect = target.prevFromRect,
            prevToRect = target.prevToRect,
            animatingRect = state.rect,
            targetMatrix = matrix(target, true);

        if (targetMatrix) {
          // Compensate for current animation
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }

        target.toRect = toRect;

        if (target.thisAnimationDuration) {
          // Could also check if animatingRect is between fromRect and toRect
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            // If returning to same place as started from animation and on same axis
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        } // if fromRect != toRect: animate


        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;

          if (!time) {
            time = _this.options.animation;
          }

          _this.animate(target, animatingRect, toRect, time);
        }

        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function () {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);

      if (!animating) {
        if (typeof callback === 'function') callback();
      } else {
        animationCallbackId = setTimeout(function () {
          if (typeof callback === 'function') callback();
        }, animationTime);
      }

      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, 'transition', '');
        css(target, 'transform', '');
        var elMatrix = matrix(this.el),
            scaleX = elMatrix && elMatrix.a,
            scaleY = elMatrix && elMatrix.d,
            translateX = (currentRect.left - toRect.left) / (scaleX || 1),
            translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
        this.forRepaintDummy = repaint(target); // repaint

        css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
        css(target, 'transform', 'translate3d(0,0,0)');
        typeof target.animated === 'number' && clearTimeout(target.animated);
        target.animated = setTimeout(function () {
          css(target, 'transition', '');
          css(target, 'transform', '');
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}

function repaint(target) {
  return target.offsetWidth;
}

function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}

var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    // Set default static properties
    for (var option in defaults) {
      if (defaults.hasOwnProperty(option) && !(option in plugin)) {
        plugin[option] = defaults[option];
      }
    }

    plugins.forEach(function (p) {
      if (p.pluginName === plugin.pluginName) {
        throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
      }
    });
    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;

    this.eventCanceled = false;

    evt.cancel = function () {
      _this.eventCanceled = true;
    };

    var eventNameGlobal = eventName + 'Global';
    plugins.forEach(function (plugin) {
      if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
          sortable: sortable
        }, evt));
      } // Only fire plugin event if plugin is enabled in this sortable,
      // and plugin has event defined


      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread2({
          sortable: sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults, options) {
    plugins.forEach(function (plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized; // Add default options from plugin

      _extends(defaults, initialized.defaults);
    });

    for (var option in sortable.options) {
      if (!sortable.options.hasOwnProperty(option)) continue;
      var modified = this.modifyOption(sortable, option, sortable.options[option]);

      if (typeof modified !== 'undefined') {
        sortable.options[option] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function (plugin) {
      if (typeof plugin.eventProperties !== 'function') return;

      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function (plugin) {
      // Plugin must exist on the Sortable
      if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

      if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};

function dispatchEvent(_ref) {
  var sortable = _ref.sortable,
      rootEl = _ref.rootEl,
      name = _ref.name,
      targetEl = _ref.targetEl,
      cloneEl = _ref.cloneEl,
      toEl = _ref.toEl,
      fromEl = _ref.fromEl,
      oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      oldDraggableIndex = _ref.oldDraggableIndex,
      newDraggableIndex = _ref.newDraggableIndex,
      originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl && rootEl[expando];
  if (!sortable) return;
  var evt,
      options = sortable.options,
      onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
  }

  evt.to = toEl || rootEl;
  evt.from = fromEl || rootEl;
  evt.item = targetEl || rootEl;
  evt.clone = cloneEl;
  evt.oldIndex = oldIndex;
  evt.newIndex = newIndex;
  evt.oldDraggableIndex = oldDraggableIndex;
  evt.newDraggableIndex = newDraggableIndex;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

  var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));

  for (var option in allEventProperties) {
    evt[option] = allEventProperties[option];
  }

  if (rootEl) {
    rootEl.dispatchEvent(evt);
  }

  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}

var _excluded = ["evt"];

var pluginEvent = function pluginEvent(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      originalEvent = _ref.evt,
      data = _objectWithoutProperties(_ref, _excluded);

  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
    dragEl: dragEl,
    parentEl: parentEl,
    ghostEl: ghostEl,
    rootEl: rootEl,
    nextEl: nextEl,
    lastDownEl: lastDownEl,
    cloneEl: cloneEl,
    cloneHidden: cloneHidden,
    dragStarted: moved,
    putSortable: putSortable,
    activeSortable: Sortable.active,
    originalEvent: originalEvent,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable: sortable,
        name: name,
        originalEvent: originalEvent
      });
    }
  }, data));
};

function _dispatchEvent(info) {
  dispatchEvent(_objectSpread2({
    putSortable: putSortable,
    cloneEl: cloneEl,
    targetEl: dragEl,
    rootEl: rootEl,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex
  }, info));
}

var dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    oldIndex,
    newIndex,
    oldDraggableIndex,
    newDraggableIndex,
    activeGroup,
    putSortable,
    awaitingDragStarted = false,
    ignoreNextClick = false,
    sortables = [],
    tapEvt,
    touchEvt,
    lastDx,
    lastDy,
    tapDistanceLeft,
    tapDistanceTop,
    moved,
    lastTarget,
    lastDirection,
    pastFirstInvertThresh = false,
    isCircumstantialInvert = false,
    targetMoveDistance,
    // For positioning ghost absolutely
ghostRelativeParent,
    ghostRelativeParentInitialScroll = [],
    // (left, top)
_silent = false,
    savedInputChecked = [];
/** @const */

var documentExists = typeof document !== 'undefined',
    PositionGhostAbsolutely = IOS,
    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
    supportCssPointerEvents = function () {
  if (!documentExists) return; // false when <= IE11

  if (IE11OrLess) {
    return false;
  }

  var el = document.createElement('x');
  el.style.cssText = 'pointer-events:auto';
  return el.style.pointerEvents === 'auto';
}(),
    _detectDirection = function _detectDirection(el, options) {
  var elCSS = css(el),
      elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
      child1 = getChild(el, 0, options),
      child2 = getChild(el, 1, options),
      firstChildCSS = child1 && css(child1),
      secondChildCSS = child2 && css(child2),
      firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
      secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

  if (elCSS.display === 'flex') {
    return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
  }

  if (elCSS.display === 'grid') {
    return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
  }

  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
    var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
    return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
  }

  return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
},
    _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
      dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
      dragElOppLength = vertical ? dragRect.width : dragRect.height,
      targetS1Opp = vertical ? targetRect.left : targetRect.top,
      targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
      targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
},

/**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */
_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
  var ret;
  sortables.some(function (sortable) {
    var threshold = sortable[expando].options.emptyInsertThreshold;
    if (!threshold || lastChild(sortable)) return;
    var rect = getRect(sortable),
        insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
        insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

    if (insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
},
    _prepareGroup = function _prepareGroup(options) {
  function toFn(value, pull) {
    return function (to, from, dragEl, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

      if (value == null && (pull || sameGroup)) {
        // Default pull value
        // Default pull and put value if same group
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === 'clone') {
        return value;
      } else if (typeof value === 'function') {
        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }

  var group = {};
  var originalGroup = options.group;

  if (!originalGroup || _typeof(originalGroup) != 'object') {
    originalGroup = {
      name: originalGroup
    };
  }

  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
},
    _hideGhostForTarget = function _hideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', 'none');
  }
},
    _unhideGhostForTarget = function _unhideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', '');
  }
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


if (documentExists) {
  document.addEventListener('click', function (evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}

var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;

    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

    if (nearest) {
      // Create imitation event
      var event = {};

      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }

      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;

      nearest[expando]._onDragOver(event);
    }
  }
};

var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */


function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }

  this.el = el; // root element

  this.options = options = _extends({}, options); // Export instance

  el[expando] = this;
  var defaults = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ignore: 'a, img',
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl) {
      dataTransfer.setData('Text', dragEl.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: 'data-id',
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window && !Safari,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults); // Set default options

  for (var name in defaults) {
    !(name in options) && (options[name] = defaults[name]);
  }

  _prepareGroup(options); // Bind all private methods


  for (var fn in this) {
    if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
      this[fn] = this[fn].bind(this);
    }
  } // Setup drag mode


  this.nativeDraggable = options.forceFallback ? false : supportDraggable;

  if (this.nativeDraggable) {
    // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
  } // Bind events


  if (options.supportPointer) {
    on(el, 'pointerdown', this._onTapStart);
  } else {
    on(el, 'mousedown', this._onTapStart);
    on(el, 'touchstart', this._onTapStart);
  }

  if (this.nativeDraggable) {
    on(el, 'dragover', this);
    on(el, 'dragenter', this);
  }

  sortables.push(this.el); // Restore sorting

  options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

  _extends(this, AnimationStateManager());
}

Sortable.prototype =
/** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(
  /** Event|TouchEvent */
  evt) {
    if (!evt.cancelable) return;

    var _this = this,
        el = this.el,
        options = this.options,
        preventOnFilter = options.preventOnFilter,
        type = evt.type,
        touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
        target = (touch || evt).target,
        originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
        filter = options.filter;

    _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


    if (dragEl) {
      return;
    }

    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return; // only left button and enabled
    } // cancel dnd if original target is content editable


    if (originalTarget.isContentEditable) {
      return;
    } // Safari ignores further event handling after mousedown


    if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === 'SELECT') {
      return;
    }

    target = closest(target, options.draggable, el, false);

    if (target && target.animated) {
      return;
    }

    if (lastDownEl === target) {
      // Ignoring duplicate `down`
      return;
    } // Get the index of the dragged element within its parent


    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable); // Check filter

    if (typeof filter === 'function') {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: 'filter',
          targetEl: target,
          toEl: el,
          fromEl: el
        });

        pluginEvent('filter', _this, {
          evt: evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    } else if (filter) {
      filter = filter.split(',').some(function (criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);

        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: 'filter',
            targetEl: target,
            fromEl: el,
            toEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          return true;
        }
      });

      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    }

    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    } // Prepare `dragstart`


    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(
  /** Event */
  evt,
  /** Touch */
  touch,
  /** HTMLElement */
  target) {
    var _this = this,
        el = _this.el,
        options = _this.options,
        ownerDocument = el.ownerDocument,
        dragStartFn;

    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style['will-change'] = 'all';

      dragStartFn = function dragStartFn() {
        pluginEvent('delayEnded', _this, {
          evt: evt
        });

        if (Sortable.eventCanceled) {
          _this._onDrop();

          return;
        } // Delayed drag has been triggered
        // we can re-enable the events: touchmove/mousemove


        _this._disableDelayedDragEvents();

        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        } // Bind the events: dragstart/dragend


        _this._triggerDragStart(evt, touch); // Drag start event


        _dispatchEvent({
          sortable: _this,
          name: 'choose',
          originalEvent: evt
        }); // Chosen item


        toggleClass(dragEl, options.chosenClass, true);
      }; // Disable "draggable"


      options.ignore.split(',').forEach(function (criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mouseup', _this._onDrop);
      on(ownerDocument, 'touchend', _this._onDrop);
      on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }

      pluginEvent('delayStart', this, {
        evt: evt
      }); // Delay is impossible for native DnD in Edge or IE

      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();

          return;
        } // If the user moves the pointer or let go the click or touch
        // before the delay has been reached:
        // disable the delayed drag


        on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
        on(ownerDocument, 'touchend', _this._disableDelayedDrag);
        on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
        on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
        on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
  /** TouchEvent|PointerEvent **/
  e) {
    var touch = e.touches ? e.touches[0] : e;

    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);

    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._disableDelayedDrag);
    off(ownerDocument, 'touchend', this._disableDelayedDrag);
    off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
    off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(
  /** Event */
  evt,
  /** Touch */
  touch) {
    touch = touch || evt.pointerType == 'touch' && evt;

    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, 'pointermove', this._onTouchMove);
      } else if (touch) {
        on(document, 'touchmove', this._onTouchMove);
      } else {
        on(document, 'mousemove', this._onTouchMove);
      }
    } else {
      on(dragEl, 'dragend', this);
      on(rootEl, 'dragstart', this._onDragStart);
    }

    try {
      if (document.selection) {
        // Timeout neccessary for IE9
        _nextTick(function () {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {}
  },
  _dragStarted: function _dragStarted(fallback, evt) {

    awaitingDragStarted = false;

    if (rootEl && dragEl) {
      pluginEvent('dragStarted', this, {
        evt: evt
      });

      if (this.nativeDraggable) {
        on(document, 'dragover', _checkOutsideTargetEl);
      }

      var options = this.options; // Apply effect

      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost(); // Drag start event

      _dispatchEvent({
        sortable: this,
        name: 'start',
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;

      _hideGhostForTarget();

      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;

      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }

      dragEl.parentNode[expando]._isOutsideThisEl(target);

      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target,
              rootEl: parent
            });

            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }

          target = parent; // store last element
        }
        /* jshint boss:true */
        while (parent = parent.parentNode);
      }

      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(
  /**TouchEvent*/
  evt) {
    if (tapEvt) {
      var options = this.options,
          fallbackTolerance = options.fallbackTolerance,
          fallbackOffset = options.fallbackOffset,
          touch = evt.touches ? evt.touches[0] : evt,
          ghostMatrix = ghostEl && matrix(ghostEl, true),
          scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
          scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
          relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
          dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
          dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }

        this._onDragStart(evt, true);
      }

      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }

        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, 'webkitTransform', cssMatrix);
        css(ghostEl, 'mozTransform', cssMatrix);
        css(ghostEl, 'msTransform', cssMatrix);
        css(ghostEl, 'transform', cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }

      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    // Bug if using scale(): https://stackoverflow.com/questions/2637058
    // Not being adjusted for
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl,
          rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
          options = this.options; // Position absolutely

      if (PositionGhostAbsolutely) {
        // Get relatively positioned parent
        ghostRelativeParent = container;

        while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }

        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }

        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }

      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, 'transition', '');
      css(ghostEl, 'transform', '');
      css(ghostEl, 'box-sizing', 'border-box');
      css(ghostEl, 'margin', 0);
      css(ghostEl, 'top', rect.top);
      css(ghostEl, 'left', rect.left);
      css(ghostEl, 'width', rect.width);
      css(ghostEl, 'height', rect.height);
      css(ghostEl, 'opacity', '0.8');
      css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
      css(ghostEl, 'zIndex', '100000');
      css(ghostEl, 'pointerEvents', 'none');
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl); // Set transform-origin

      css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
    }
  },
  _onDragStart: function _onDragStart(
  /**Event*/
  evt,
  /**boolean*/
  fallback) {
    var _this = this;

    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent('dragStart', this, {
      evt: evt
    });

    if (Sortable.eventCanceled) {
      this._onDrop();

      return;
    }

    pluginEvent('setupClone', this);

    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style['will-change'] = '';

      this._hideClone();

      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    } // #1143: IFrame support workaround


    _this.cloneId = _nextTick(function () {
      pluginEvent('clone', _this);
      if (Sortable.eventCanceled) return;

      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }

      _this._hideClone();

      _dispatchEvent({
        sortable: _this,
        name: 'clone'
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      // Undo what was set in _prepareDragStart before drag started
      off(document, 'mouseup', _this._onDrop);
      off(document, 'touchend', _this._onDrop);
      off(document, 'touchcancel', _this._onDrop);

      if (dataTransfer) {
        dataTransfer.effectAllowed = 'move';
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }

      on(document, 'drop', _this); // #1276 fix:

      css(dragEl, 'transform', 'translateZ(0)');
    }

    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, 'selectstart', _this);
    moved = true;

    if (Safari) {
      css(document.body, 'user-select', 'none');
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(
  /**Event*/
  evt) {
    var el = this.el,
        target = evt.target,
        dragRect,
        targetRect,
        revert,
        options = this.options,
        group = options.group,
        activeSortable = Sortable.active,
        isOwner = activeGroup === group,
        canSort = options.sort,
        fromSortable = putSortable || activeSortable,
        vertical,
        _this = this,
        completedFired = false;

    if (_silent) return;

    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread2({
        evt: evt,
        isOwner: isOwner,
        axis: vertical ? 'vertical' : 'horizontal',
        revert: revert,
        dragRect: dragRect,
        targetRect: targetRect,
        canSort: canSort,
        fromSortable: fromSortable,
        target: target,
        completed: completed,
        onMove: function onMove(target, after) {
          return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
        },
        changed: changed
      }, extra));
    } // Capture animation state


    function capture() {
      dragOverEvent('dragOverAnimationCapture');

      _this.captureAnimationState();

      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    } // Return invocation when dragEl is inserted (or completed)


    function completed(insertion) {
      dragOverEvent('dragOverCompleted', {
        insertion: insertion
      });

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }

        if (_this !== fromSortable) {
          // Set ghost class to new sortable's ghost class
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }

        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        } // Animation


        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }

        _this.animateAll(function () {
          dragOverEvent('dragOverAnimationComplete');
          _this._ignoreWhileAnimating = null;
        });

        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      } // Null lastTarget if it is not inside a previously swapped element


      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      } // no bubbling and not fallback


      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


        !insertion && nearestEmptyInsertDetectEvent(evt);
      }

      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    } // Call when dragEl has been inserted


    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);

      _dispatchEvent({
        sortable: _this,
        name: 'change',
        toEl: el,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        originalEvent: evt
      });
    }

    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }

    target = closest(target, options.draggable, el, true);
    dragOverEvent('dragOver');
    if (Sortable.eventCanceled) return completedFired;

    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }

    ignoreNextClick = false;

    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) // Reverting item into the original list
    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === 'vertical';
      dragRect = getRect(dragEl);
      dragOverEvent('dragOverValid');
      if (Sortable.eventCanceled) return completedFired;

      if (revert) {
        parentEl = rootEl; // actualization

        capture();

        this._hideClone();

        dragOverEvent('revert');

        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }

        return completed(true);
      }

      var elLastChild = lastChild(el, options.draggable);

      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        // Insert to end of list
        // If already at end of list: Do not insert
        if (elLastChild === dragEl) {
          return completed(false);
        } // if there is a last element, it is the target


        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }

        if (target) {
          targetRect = getRect(target);
        }

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
        // Insert to start of list
        var firstChild = getChild(el, 0, options, true);

        if (firstChild === dragEl) {
          return completed(false);
        }

        target = firstChild;
        targetRect = getRect(target);

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
          capture();
          el.insertBefore(dragEl, firstChild);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0,
            targetBeforeFirstSwap,
            differentLevel = dragEl.parentNode !== el,
            differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
            side1 = vertical ? 'top' : 'left',
            scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
            scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }

        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;

        if (direction !== 0) {
          // Check if target is beside dragEl in respective direction (ignoring hidden elements)
          var dragIndex = index(dragEl);

          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
        } // If dragEl is already beside target: Do not insert


        if (direction === 0 || sibling === target) {
          return completed(false);
        }

        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling,
            after = false;
        after = direction === 1;

        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }

          _silent = true;
          setTimeout(_unsilent, 30);
          capture();

          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          } // Undo chrome's scroll adjustment (has no effect on other browsers)


          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }

          parentEl = dragEl.parentNode; // actualization
          // must be done before animation

          if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }

          changed();
          return completed(true);
        }
      }

      if (el.contains(dragEl)) {
        return completed(false);
      }
    }

    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, 'mousemove', this._onTouchMove);
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'pointermove', this._onTouchMove);
    off(document, 'dragover', nearestEmptyInsertDetectEvent);
    off(document, 'mousemove', nearestEmptyInsertDetectEvent);
    off(document, 'touchmove', nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._onDrop);
    off(ownerDocument, 'touchend', this._onDrop);
    off(ownerDocument, 'pointerup', this._onDrop);
    off(ownerDocument, 'touchcancel', this._onDrop);
    off(document, 'selectstart', this);
  },
  _onDrop: function _onDrop(
  /**Event*/
  evt) {
    var el = this.el,
        options = this.options; // Get the index of the dragged element within its parent

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent('drop', this, {
      evt: evt
    });
    parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);

    if (Sortable.eventCanceled) {
      this._nulling();

      return;
    }

    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);

    _cancelNextTick(this.cloneId);

    _cancelNextTick(this._dragStartId); // Unbind events


    if (this.nativeDraggable) {
      off(document, 'drop', this);
      off(el, 'dragstart', this._onDragStart);
    }

    this._offMoveEvents();

    this._offUpEvents();

    if (Safari) {
      css(document.body, 'user-select', '');
    }

    css(dragEl, 'transform', '');

    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }

      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        // Remove clone(s)
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }

      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, 'dragend', this);
        }

        _disableDraggable(dragEl);

        dragEl.style['will-change'] = ''; // Remove classes
        // ghostClass is added in dragStarted

        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }

        toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

        _dispatchEvent({
          sortable: this,
          name: 'unchoose',
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });

        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            // Add event
            _dispatchEvent({
              rootEl: parentEl,
              name: 'add',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            }); // Remove event


            _dispatchEvent({
              sortable: this,
              name: 'remove',
              toEl: parentEl,
              originalEvent: evt
            }); // drag from one list and drop into another


            _dispatchEvent({
              rootEl: parentEl,
              name: 'sort',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });

            _dispatchEvent({
              sortable: this,
              name: 'sort',
              toEl: parentEl,
              originalEvent: evt
            });
          }

          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              // drag & drop within the same list
              _dispatchEvent({
                sortable: this,
                name: 'update',
                toEl: parentEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }

        if (Sortable.active) {
          /* jshint eqnull:true */
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }

          _dispatchEvent({
            sortable: this,
            name: 'end',
            toEl: parentEl,
            originalEvent: evt
          }); // Save sorting


          this.save();
        }
      }
    }

    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent('nulling', this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function (el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(
  /**Event*/
  evt) {
    switch (evt.type) {
      case 'drop':
      case 'dragend':
        this._onDrop(evt);

        break;

      case 'dragenter':
      case 'dragover':
        if (dragEl) {
          this._onDragOver(evt);

          _globalDragOver(evt);
        }

        break;

      case 'selectstart':
        evt.preventDefault();
        break;
    }
  },

  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [],
        el,
        children = this.el.children,
        i = 0,
        n = children.length,
        options = this.options;

    for (; i < n; i++) {
      el = children[i];

      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }

    return order;
  },

  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order, useAnimation) {
    var items = {},
        rootEl = this.el;
    this.toArray().forEach(function (id, i) {
      var el = rootEl.children[i];

      if (closest(el, this.options.draggable, rootEl, false)) {
        items[id] = el;
      }
    }, this);
    useAnimation && this.captureAnimationState();
    order.forEach(function (id) {
      if (items[id]) {
        rootEl.removeChild(items[id]);
        rootEl.appendChild(items[id]);
      }
    });
    useAnimation && this.animateAll();
  },

  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },

  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },

  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;

    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);

      if (typeof modifiedValue !== 'undefined') {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }

      if (name === 'group') {
        _prepareGroup(options);
      }
    }
  },

  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent('destroy', this);
    var el = this.el;
    el[expando] = null;
    off(el, 'mousedown', this._onTapStart);
    off(el, 'touchstart', this._onTapStart);
    off(el, 'pointerdown', this._onTapStart);

    if (this.nativeDraggable) {
      off(el, 'dragover', this);
      off(el, 'dragenter', this);
    } // Remove draggable attributes


    Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
      el.removeAttribute('draggable');
    });

    this._onDrop();

    this._disableDelayedDragEvents();

    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent('hideClone', this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, 'display', 'none');

      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }

      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable) {
    if (putSortable.lastPutMode !== 'clone') {
      this._hideClone();

      return;
    }

    if (cloneHidden) {
      pluginEvent('showClone', this);
      if (Sortable.eventCanceled) return; // show clone at dragEl or original position

      if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }

      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }

      css(cloneEl, 'display', '');
      cloneHidden = false;
    }
  }
};

function _globalDragOver(
/**Event*/
evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = 'move';
  }

  evt.cancelable && evt.preventDefault();
}

function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt,
      sortable = fromEl[expando],
      onMoveFn = sortable.options.onMove,
      retVal; // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent('move', {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent('move', true, true);
  }

  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);

  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }

  return retVal;
}

function _disableDraggable(el) {
  el.draggable = false;
}

function _unsilent() {
  _silent = false;
}

function _ghostIsFirst(evt, vertical, sortable) {
  var rect = getRect(getChild(sortable.el, 0, sortable.options, true));
  var spacer = 10;
  return vertical ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
}

function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}

function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
      targetLength = vertical ? targetRect.height : targetRect.width,
      targetS1 = vertical ? targetRect.top : targetRect.left,
      targetS2 = vertical ? targetRect.bottom : targetRect.right,
      invert = false;

  if (!invertSwap) {
    // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
      // check if past first invert threshold on side opposite of lastDirection
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        // past first invert threshold, do not restrict inverted threshold to dragEl shadow
        pastFirstInvertThresh = true;
      }

      if (!pastFirstInvertThresh) {
        // dragEl shadow (target move distance shadow)
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
        : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      // Regular
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }

  invert = invert || invertSwap;

  if (invert) {
    // Invert of regular
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }

  return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */


function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */


function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent,
      i = str.length,
      sum = 0;

  while (i--) {
    sum += str.charCodeAt(i);
  }

  return sum.toString(36);
}

function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName('input');
  var idx = inputs.length;

  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}

function _nextTick(fn) {
  return setTimeout(fn, 0);
}

function _cancelNextTick(id) {
  return clearTimeout(id);
} // Fixed #973:


if (documentExists) {
  on(document, 'touchmove', function (evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
} // Export utils


Sortable.utils = {
  on: on,
  off: off,
  css: css,
  find: find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend,
  throttle: throttle,
  closest: closest,
  toggleClass: toggleClass,
  clone: clone,
  index: index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild: getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */

Sortable.get = function (element) {
  return element[expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */


Sortable.mount = function () {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  if (plugins[0].constructor === Array) plugins = plugins[0];
  plugins.forEach(function (plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }

    if (plugin.utils) Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
    PluginManager.mount(plugin);
  });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */


Sortable.create = function (el, options) {
  return new Sortable(el, options);
}; // Export


Sortable.version = version;

var autoScrolls = [],
    scrollEl,
    scrollRootEl,
    scrolling = false,
    lastAutoScrollX,
    lastAutoScrollY,
    touchEvt$1,
    pointerElemChangedInterval;

function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      forceAutoScrollFallback: false,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    }; // Bind all private methods

    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }
  }

  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;

      if (this.sortable.nativeDraggable) {
        on(document, 'dragover', this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, 'touchmove', this._handleFallbackAutoScroll);
        } else {
          on(document, 'mousemove', this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;

      // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop() {
      if (this.sortable.nativeDraggable) {
        off(document, 'dragover', this._handleAutoScroll);
      } else {
        off(document, 'pointermove', this._handleFallbackAutoScroll);
        off(document, 'touchmove', this._handleFallbackAutoScroll);
        off(document, 'mousemove', this._handleFallbackAutoScroll);
      }

      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;

      var x = (evt.touches ? evt.touches[0] : evt).clientX,
          y = (evt.touches ? evt.touches[0] : evt).clientY,
          elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt; // IE does not seem to have native autoscroll,
      // Edge's autoscroll seems too conditional,
      // MACOS Safari does not have autoscroll,
      // Firefox and Chrome are good

      if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

        var ogElemScroller = getParentAutoScrollElement(elem, true);

        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

          pointerElemChangedInterval = setInterval(function () {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }

            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }

        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: 'scroll',
    initializeByDefault: true
  });
}

function clearAutoScrolls() {
  autoScrolls.forEach(function (autoScroll) {
    clearInterval(autoScroll.pid);
  });
  autoScrolls = [];
}

function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}

var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
  // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
  if (!options.scroll) return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX,
      y = (evt.touches ? evt.touches[0] : evt).clientY,
      sens = options.scrollSensitivity,
      speed = options.scrollSpeed,
      winScroller = getWindowScrollingElement();
  var scrollThisInstance = false,
      scrollCustomFn; // New scroll root, set scrollEl

  if (scrollRootEl !== rootEl) {
    scrollRootEl = rootEl;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;

    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl, true);
    }
  }

  var layersOut = 0;
  var currentParent = scrollEl;

  do {
    var el = currentParent,
        rect = getRect(el),
        top = rect.top,
        bottom = rect.bottom,
        left = rect.left,
        right = rect.right,
        width = rect.width,
        height = rect.height,
        canScrollX = void 0,
        canScrollY = void 0,
        scrollWidth = el.scrollWidth,
        scrollHeight = el.scrollHeight,
        elCSS = css(el),
        scrollPosX = el.scrollLeft,
        scrollPosY = el.scrollTop;

    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
    }

    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }

    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);

      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        /* jshint loopfunc:true */

        autoScrolls[layersOut].pid = setInterval(function () {
          // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

          }

          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

          if (typeof scrollCustomFn === 'function') {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
              return;
            }
          }

          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }

    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

  scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);

var drop = function drop(_ref) {
  var originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      dragEl = _ref.dragEl,
      activeSortable = _ref.activeSortable,
      dispatchSortableEvent = _ref.dispatchSortableEvent,
      hideGhostForTarget = _ref.hideGhostForTarget,
      unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();

  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent('spill');
    this.onSpill({
      dragEl: dragEl,
      putSortable: putSortable
    });
  }
};

function Revert() {}

Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl = _ref3.dragEl,
        putSortable = _ref3.putSortable;
    this.sortable.captureAnimationState();

    if (putSortable) {
      putSortable.captureAnimationState();
    }

    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl);
    }

    this.sortable.animateAll();

    if (putSortable) {
      putSortable.animateAll();
    }
  },
  drop: drop
};

_extends(Revert, {
  pluginName: 'revertOnSpill'
});

function Remove() {}

Remove.prototype = {
  onSpill: function onSpill(_ref4) {
    var dragEl = _ref4.dragEl,
        putSortable = _ref4.putSortable;
    var parentSortable = putSortable || this.sortable;
    parentSortable.captureAnimationState();
    dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
    parentSortable.animateAll();
  },
  drop: drop
};

_extends(Remove, {
  pluginName: 'removeOnSpill'
});

var lastSwapEl;

function SwapPlugin() {
  function Swap() {
    this.defaults = {
      swapClass: 'sortable-swap-highlight'
    };
  }

  Swap.prototype = {
    dragStart: function dragStart(_ref) {
      var dragEl = _ref.dragEl;
      lastSwapEl = dragEl;
    },
    dragOverValid: function dragOverValid(_ref2) {
      var completed = _ref2.completed,
          target = _ref2.target,
          onMove = _ref2.onMove,
          activeSortable = _ref2.activeSortable,
          changed = _ref2.changed,
          cancel = _ref2.cancel;
      if (!activeSortable.options.swap) return;
      var el = this.sortable.el,
          options = this.options;

      if (target && target !== el) {
        var prevSwapEl = lastSwapEl;

        if (onMove(target) !== false) {
          toggleClass(target, options.swapClass, true);
          lastSwapEl = target;
        } else {
          lastSwapEl = null;
        }

        if (prevSwapEl && prevSwapEl !== lastSwapEl) {
          toggleClass(prevSwapEl, options.swapClass, false);
        }
      }

      changed();
      completed(true);
      cancel();
    },
    drop: function drop(_ref3) {
      var activeSortable = _ref3.activeSortable,
          putSortable = _ref3.putSortable,
          dragEl = _ref3.dragEl;
      var toSortable = putSortable || this.sortable;
      var options = this.options;
      lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

      if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
        if (dragEl !== lastSwapEl) {
          toSortable.captureAnimationState();
          if (toSortable !== activeSortable) activeSortable.captureAnimationState();
          swapNodes(dragEl, lastSwapEl);
          toSortable.animateAll();
          if (toSortable !== activeSortable) activeSortable.animateAll();
        }
      }
    },
    nulling: function nulling() {
      lastSwapEl = null;
    }
  };
  return _extends(Swap, {
    pluginName: 'swap',
    eventProperties: function eventProperties() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}

function swapNodes(n1, n2) {
  var p1 = n1.parentNode,
      p2 = n2.parentNode,
      i1,
      i2;
  if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
  i1 = index(n1);
  i2 = index(n2);

  if (p1.isEqualNode(p2) && i1 < i2) {
    i2++;
  }

  p1.insertBefore(n2, p1.children[i1]);
  p2.insertBefore(n1, p2.children[i2]);
}

var multiDragElements = [],
    multiDragClones = [],
    lastMultiDragSelect,
    // for selection with modifier key down (SHIFT)
multiDragSortable,
    initialFolding = false,
    // Initial multi-drag fold when drag started
folding = false,
    // Folding any other time
dragStarted = false,
    dragEl$1,
    clonesFromRect,
    clonesHidden;

function MultiDragPlugin() {
  function MultiDrag(sortable) {
    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }

    if (sortable.options.supportPointer) {
      on(document, 'pointerup', this._deselectMultiDrag);
    } else {
      on(document, 'mouseup', this._deselectMultiDrag);
      on(document, 'touchend', this._deselectMultiDrag);
    }

    on(document, 'keydown', this._checkKeyDown);
    on(document, 'keyup', this._checkKeyUp);
    this.defaults = {
      selectedClass: 'sortable-selected',
      multiDragKey: null,
      setData: function setData(dataTransfer, dragEl) {
        var data = '';

        if (multiDragElements.length && multiDragSortable === sortable) {
          multiDragElements.forEach(function (multiDragElement, i) {
            data += (!i ? '' : ', ') + multiDragElement.textContent;
          });
        } else {
          data = dragEl.textContent;
        }

        dataTransfer.setData('Text', data);
      }
    };
  }

  MultiDrag.prototype = {
    multiDragKeyDown: false,
    isMultiDrag: false,
    delayStartGlobal: function delayStartGlobal(_ref) {
      var dragged = _ref.dragEl;
      dragEl$1 = dragged;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function setupClone(_ref2) {
      var sortable = _ref2.sortable,
          cancel = _ref2.cancel;
      if (!this.isMultiDrag) return;

      for (var i = 0; i < multiDragElements.length; i++) {
        multiDragClones.push(clone(multiDragElements[i]));
        multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
        multiDragClones[i].draggable = false;
        multiDragClones[i].style['will-change'] = '';
        toggleClass(multiDragClones[i], this.options.selectedClass, false);
        multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
      }

      sortable._hideClone();

      cancel();
    },
    clone: function clone(_ref3) {
      var sortable = _ref3.sortable,
          rootEl = _ref3.rootEl,
          dispatchSortableEvent = _ref3.dispatchSortableEvent,
          cancel = _ref3.cancel;
      if (!this.isMultiDrag) return;

      if (!this.options.removeCloneOnHide) {
        if (multiDragElements.length && multiDragSortable === sortable) {
          insertMultiDragClones(true, rootEl);
          dispatchSortableEvent('clone');
          cancel();
        }
      }
    },
    showClone: function showClone(_ref4) {
      var cloneNowShown = _ref4.cloneNowShown,
          rootEl = _ref4.rootEl,
          cancel = _ref4.cancel;
      if (!this.isMultiDrag) return;
      insertMultiDragClones(false, rootEl);
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', '');
      });
      cloneNowShown();
      clonesHidden = false;
      cancel();
    },
    hideClone: function hideClone(_ref5) {
      var _this = this;

      var sortable = _ref5.sortable,
          cloneNowHidden = _ref5.cloneNowHidden,
          cancel = _ref5.cancel;
      if (!this.isMultiDrag) return;
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', 'none');

        if (_this.options.removeCloneOnHide && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
      cloneNowHidden();
      clonesHidden = true;
      cancel();
    },
    dragStartGlobal: function dragStartGlobal(_ref6) {
      var sortable = _ref6.sortable;

      if (!this.isMultiDrag && multiDragSortable) {
        multiDragSortable.multiDrag._deselectMultiDrag();
      }

      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.sortableIndex = index(multiDragElement);
      }); // Sort multi-drag elements

      multiDragElements = multiDragElements.sort(function (a, b) {
        return a.sortableIndex - b.sortableIndex;
      });
      dragStarted = true;
    },
    dragStarted: function dragStarted(_ref7) {
      var _this2 = this;

      var sortable = _ref7.sortable;
      if (!this.isMultiDrag) return;

      if (this.options.sort) {
        // Capture rects,
        // hide multi drag elements (by positioning them absolute),
        // set multi drag elements rects to dragRect,
        // show multi drag elements,
        // animate to rects,
        // unset rects & remove from DOM
        sortable.captureAnimationState();

        if (this.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            css(multiDragElement, 'position', 'absolute');
          });
          var dragRect = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRect);
          });
          folding = true;
          initialFolding = true;
        }
      }

      sortable.animateAll(function () {
        folding = false;
        initialFolding = false;

        if (_this2.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
        } // Remove all auxiliary multidrag items from el, if sorting enabled


        if (_this2.options.sort) {
          removeMultiDragElements();
        }
      });
    },
    dragOver: function dragOver(_ref8) {
      var target = _ref8.target,
          completed = _ref8.completed,
          cancel = _ref8.cancel;

      if (folding && ~multiDragElements.indexOf(target)) {
        completed(false);
        cancel();
      }
    },
    revert: function revert(_ref9) {
      var fromSortable = _ref9.fromSortable,
          rootEl = _ref9.rootEl,
          sortable = _ref9.sortable,
          dragRect = _ref9.dragRect;

      if (multiDragElements.length > 1) {
        // Setup unfold animation
        multiDragElements.forEach(function (multiDragElement) {
          sortable.addAnimationState({
            target: multiDragElement,
            rect: folding ? getRect(multiDragElement) : dragRect
          });
          unsetRect(multiDragElement);
          multiDragElement.fromRect = dragRect;
          fromSortable.removeAnimationState(multiDragElement);
        });
        folding = false;
        insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref10) {
      var sortable = _ref10.sortable,
          isOwner = _ref10.isOwner,
          insertion = _ref10.insertion,
          activeSortable = _ref10.activeSortable,
          parentEl = _ref10.parentEl,
          putSortable = _ref10.putSortable;
      var options = this.options;

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        }

        initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

        if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
          // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
          var dragRectAbsolute = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

            parentEl.appendChild(multiDragElement);
          });
          folding = true;
        } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


        if (!isOwner) {
          // Only remove if not folding (folding will remove them anyways)
          if (!folding) {
            removeMultiDragElements();
          }

          if (multiDragElements.length > 1) {
            var clonesHiddenBefore = clonesHidden;

            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
              multiDragClones.forEach(function (clone) {
                activeSortable.addAnimationState({
                  target: clone,
                  rect: clonesFromRect
                });
                clone.fromRect = clonesFromRect;
                clone.thisAnimationDuration = null;
              });
            }
          } else {
            activeSortable._showClone(sortable);
          }
        }
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
      var dragRect = _ref11.dragRect,
          isOwner = _ref11.isOwner,
          activeSortable = _ref11.activeSortable;
      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.thisAnimationDuration = null;
      });

      if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
        clonesFromRect = _extends({}, dragRect);
        var dragMatrix = matrix(dragEl$1, true);
        clonesFromRect.top -= dragMatrix.f;
        clonesFromRect.left -= dragMatrix.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      if (folding) {
        folding = false;
        removeMultiDragElements();
      }
    },
    drop: function drop(_ref12) {
      var evt = _ref12.originalEvent,
          rootEl = _ref12.rootEl,
          parentEl = _ref12.parentEl,
          sortable = _ref12.sortable,
          dispatchSortableEvent = _ref12.dispatchSortableEvent,
          oldIndex = _ref12.oldIndex,
          putSortable = _ref12.putSortable;
      var toSortable = putSortable || this.sortable;
      if (!evt) return;
      var options = this.options,
          children = parentEl.children; // Multi-drag selection

      if (!dragStarted) {
        if (options.multiDragKey && !this.multiDragKeyDown) {
          this._deselectMultiDrag();
        }

        toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

        if (!~multiDragElements.indexOf(dragEl$1)) {
          multiDragElements.push(dragEl$1);
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'select',
            targetEl: dragEl$1,
            originalEvt: evt
          }); // Modifier activated, select from last to dragEl

          if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
            var lastIndex = index(lastMultiDragSelect),
                currentIndex = index(dragEl$1);

            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
              // Must include lastMultiDragSelect (select it), in case modified selection from no selection
              // (but previous selection existed)
              var n, i;

              if (currentIndex > lastIndex) {
                i = lastIndex;
                n = currentIndex;
              } else {
                i = currentIndex;
                n = lastIndex + 1;
              }

              for (; i < n; i++) {
                if (~multiDragElements.indexOf(children[i])) continue;
                toggleClass(children[i], options.selectedClass, true);
                multiDragElements.push(children[i]);
                dispatchEvent({
                  sortable: sortable,
                  rootEl: rootEl,
                  name: 'select',
                  targetEl: children[i],
                  originalEvt: evt
                });
              }
            }
          } else {
            lastMultiDragSelect = dragEl$1;
          }

          multiDragSortable = toSortable;
        } else {
          multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
          lastMultiDragSelect = null;
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'deselect',
            targetEl: dragEl$1,
            originalEvt: evt
          });
        }
      } // Multi-drag drop


      if (dragStarted && this.isMultiDrag) {
        folding = false; // Do not "unfold" after around dragEl if reverted

        if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
          var dragRect = getRect(dragEl$1),
              multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
          if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
          toSortable.captureAnimationState();

          if (!initialFolding) {
            if (options.animation) {
              dragEl$1.fromRect = dragRect;
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.thisAnimationDuration = null;

                if (multiDragElement !== dragEl$1) {
                  var rect = folding ? getRect(multiDragElement) : dragRect;
                  multiDragElement.fromRect = rect; // Prepare unfold animation

                  toSortable.addAnimationState({
                    target: multiDragElement,
                    rect: rect
                  });
                }
              });
            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
            // properly they must all be removed


            removeMultiDragElements();
            multiDragElements.forEach(function (multiDragElement) {
              if (children[multiDragIndex]) {
                parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
              } else {
                parentEl.appendChild(multiDragElement);
              }

              multiDragIndex++;
            }); // If initial folding is done, the elements may have changed position because they are now
            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
            // must be fired here as Sortable will not.

            if (oldIndex === index(dragEl$1)) {
              var update = false;
              multiDragElements.forEach(function (multiDragElement) {
                if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                  update = true;
                  return;
                }
              });

              if (update) {
                dispatchSortableEvent('update');
              }
            }
          } // Must be done after capturing individual rects (scroll bar)


          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
          toSortable.animateAll();
        }

        multiDragSortable = toSortable;
      } // Remove clones if necessary


      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        multiDragClones.forEach(function (clone) {
          clone.parentNode && clone.parentNode.removeChild(clone);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = dragStarted = false;
      multiDragClones.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag();

      off(document, 'pointerup', this._deselectMultiDrag);
      off(document, 'mouseup', this._deselectMultiDrag);
      off(document, 'touchend', this._deselectMultiDrag);
      off(document, 'keydown', this._checkKeyDown);
      off(document, 'keyup', this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(evt) {
      if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

      if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

      if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

      if (evt && evt.button !== 0) return;

      while (multiDragElements.length) {
        var el = multiDragElements[0];
        toggleClass(el, this.options.selectedClass, false);
        multiDragElements.shift();
        dispatchEvent({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: 'deselect',
          targetEl: el,
          originalEvt: evt
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = true;
      }
    },
    _checkKeyUp: function _checkKeyUp(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = false;
      }
    }
  };
  return _extends(MultiDrag, {
    // Static methods & properties
    pluginName: 'multiDrag',
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function select(el) {
        var sortable = el.parentNode[expando];
        if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

        if (multiDragSortable && multiDragSortable !== sortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();

          multiDragSortable = sortable;
        }

        toggleClass(el, sortable.options.selectedClass, true);
        multiDragElements.push(el);
      },

      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function deselect(el) {
        var sortable = el.parentNode[expando],
            index = multiDragElements.indexOf(el);
        if (!sortable || !sortable.options.multiDrag || !~index) return;
        toggleClass(el, sortable.options.selectedClass, false);
        multiDragElements.splice(index, 1);
      }
    },
    eventProperties: function eventProperties() {
      var _this3 = this;

      var oldIndicies = [],
          newIndicies = [];
      multiDragElements.forEach(function (multiDragElement) {
        oldIndicies.push({
          multiDragElement: multiDragElement,
          index: multiDragElement.sortableIndex
        }); // multiDragElements will already be sorted if folding

        var newIndex;

        if (folding && multiDragElement !== dragEl$1) {
          newIndex = -1;
        } else if (folding) {
          newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
        } else {
          newIndex = index(multiDragElement);
        }

        newIndicies.push({
          multiDragElement: multiDragElement,
          index: newIndex
        });
      });
      return {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies: oldIndicies,
        newIndicies: newIndicies
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(key) {
        key = key.toLowerCase();

        if (key === 'ctrl') {
          key = 'Control';
        } else if (key.length > 1) {
          key = key.charAt(0).toUpperCase() + key.substr(1);
        }

        return key;
      }
    }
  });
}

function insertMultiDragElements(clonesInserted, rootEl) {
  multiDragElements.forEach(function (multiDragElement, i) {
    var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(multiDragElement, target);
    } else {
      rootEl.appendChild(multiDragElement);
    }
  });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */


function insertMultiDragClones(elementsInserted, rootEl) {
  multiDragClones.forEach(function (clone, i) {
    var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(clone, target);
    } else {
      rootEl.appendChild(clone);
    }
  });
}

function removeMultiDragElements() {
  multiDragElements.forEach(function (multiDragElement) {
    if (multiDragElement === dragEl$1) return;
    multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
  });
}

Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);

/* harmony default export */ __webpack_exports__["default"] = (Sortable);



/***/ }),

/***/ "aa94":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-investigation.svg";

/***/ }),

/***/ "aab0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-learning-guide.svg";

/***/ }),

/***/ "ab9d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ac96":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ad32":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-assignment.svg";

/***/ }),

/***/ "adb8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPagination_vue_vue_type_style_index_0_id_dedeedfa_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0b65");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPagination_vue_vue_type_style_index_0_id_dedeedfa_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPagination_vue_vue_type_style_index_0_id_dedeedfa_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ae14":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-title-full-video.svg";

/***/ }),

/***/ "aea7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-article.svg";

/***/ }),

/***/ "b118":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaThumbnail_vue_vue_type_style_index_0_id_bd3c9958_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e3f1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaThumbnail_vue_vue_type_style_index_0_id_bd3c9958_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaThumbnail_vue_vue_type_style_index_0_id_bd3c9958_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b135":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b16f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-science-sleuth.svg";

/***/ }),

/***/ "b23a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b37a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardHeader_vue_vue_type_style_index_0_id_b92b0200_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1a18");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardHeader_vue_vue_type_style_index_0_id_b92b0200_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardHeader_vue_vue_type_style_index_0_id_b92b0200_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b440":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaButton_vue_vue_type_style_index_0_id_d0b54b94_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9a37");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaButton_vue_vue_type_style_index_0_id_d0b54b94_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaButton_vue_vue_type_style_index_0_id_d0b54b94_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b50d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var settle = __webpack_require__("467f");
var cookies = __webpack_require__("7aac");
var buildURL = __webpack_require__("30b5");
var buildFullPath = __webpack_require__("83b9");
var parseHeaders = __webpack_require__("c345");
var isURLSameOrigin = __webpack_require__("3934");
var createError = __webpack_require__("2d83");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "b526":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-exploration.svg";

/***/ }),

/***/ "b5b9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardLinks_vue_vue_type_style_index_0_id_037c7572_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("27ec");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardLinks_vue_vue_type_style_index_0_id_037c7572_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardLinks_vue_vue_type_style_index_0_id_037c7572_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b5f6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b76a":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__("8bbf"), __webpack_require__("aa47"));
	else {}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_a352__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyNames = __webpack_require__("241c").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "13d5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $reduce = __webpack_require__("d58f").left;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('reduce');
var USES_TO_LENGTH = arrayMethodUsesToLength('reduce', { 1: 0 });

// `Array.prototype.reduce` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('forEach');
var USES_TO_LENGTH = arrayMethodUsesToLength('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
module.exports = (!STRICT_METHOD || !USES_TO_LENGTH) ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__("6eeb");
var anObject = __webpack_require__("825a");
var fails = __webpack_require__("d039");
var flags = __webpack_require__("ad6d");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "2ca0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var toLength = __webpack_require__("50c4");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");
var IS_PURE = __webpack_require__("c430");

var nativeStartsWith = ''.startsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.github.io/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = String(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return nativeStartsWith
      ? nativeStartsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "4160":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var forEach = __webpack_require__("17c2");

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var definePropertyModule = __webpack_require__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('filter');

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("0366");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var getIteratorMethod = __webpack_require__("35a1");

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "4fad":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var $entries = __webpack_require__("6f53").entries;

// `Object.entries` method
// https://tc39.github.io/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5135":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "5319":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.5',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "5a34":
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__("44e7");

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5db7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var flattenIntoArray = __webpack_require__("a2bf");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var aFunction = __webpack_require__("1c0b");
var arraySpeciesCreate = __webpack_require__("65f0");

// `Array.prototype.flatMap` method
// https://github.com/tc39/proposal-flatMap
$({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A;
    aFunction(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "6f53":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var objectKeys = __webpack_require__("df75");
var toIndexedObject = __webpack_require__("fc6a");
var propertyIsEnumerable = __webpack_require__("d1e7").f;

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.github.io/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.github.io/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ "73d9":
/***/ (function(module, exports, __webpack_require__) {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__("44d2");

addToUnscopables('flatMap');


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var has = __webpack_require__("5135");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("c6cd");

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;

/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__("d039");

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

exports.UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ "a2bf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__("e8b5");
var toLength = __webpack_require__("50c4");
var bind = __webpack_require__("0366");

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg, 3) : false;
  var element;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

module.exports = flattenIntoArray;


/***/ }),

/***/ "a352":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_a352__;

/***/ }),

/***/ "a434":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var toAbsoluteIndex = __webpack_require__("23cb");
var toInteger = __webpack_require__("a691");
var toLength = __webpack_require__("50c4");
var toObject = __webpack_require__("7b0b");
var arraySpeciesCreate = __webpack_require__("65f0");
var createProperty = __webpack_require__("8418");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
var USES_TO_LENGTH = arrayMethodUsesToLength('splice', { ACCESSORS: true, 0: 0, 1: 2 });

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a630":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var from = __webpack_require__("4df4");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.github.io/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "ab13":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "ae40":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

module.exports = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !DESCRIPTORS) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__("e163");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c740":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $findIndex = __webpack_require__("b727").findIndex;
var addToUnscopables = __webpack_require__("44d2");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND_INDEX);

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c975":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $indexOf = __webpack_require__("4d64").indexOf;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');
var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "caad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $includes = __webpack_require__("4d64").includes;
var addToUnscopables = __webpack_require__("44d2");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: !USES_TO_LENGTH }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var redefine = __webpack_require__("6eeb");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d58f":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");
var toLength = __webpack_require__("50c4");

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var regexpExec = __webpack_require__("9263");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('map');

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "dbb4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var ownKeys = __webpack_require__("56ef");
var toIndexedObject = __webpack_require__("fc6a");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var createProperty = __webpack_require__("8418");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "dbf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return console; });
function getConsole() {
  if (typeof window !== "undefined") {
    return window.console;
  }

  return global.console;
}

var console = getConsole();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.github.io/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var has = __webpack_require__("5135");
var isObject = __webpack_require__("861d");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "e439":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
var DESCRIPTORS = __webpack_require__("83ab");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("4160");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__("a434");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("e439");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("dbb4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js







function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js







function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js








function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: external {"commonjs":"sortablejs","commonjs2":"sortablejs","amd":"sortablejs","root":"Sortable"}
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_ = __webpack_require__("a352");
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_);

// CONCATENATED MODULE: ./src/util/htmlHelper.js
function removeNode(node) {
  if (node.parentElement !== null) {
    node.parentElement.removeChild(node);
  }
}

function insertNodeAt(fatherNode, node, position) {
  var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
  fatherNode.insertBefore(node, refNode);
}


// EXTERNAL MODULE: ./src/util/console.js
var console = __webpack_require__("dbf1");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("13d5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("4fad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// CONCATENATED MODULE: ./src/util/string.js



function cached(fn) {
  var cache = Object.create(null);
  return function cachedFn(str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}

var regex = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(regex, function (_, c) {
    return c.toUpperCase();
  });
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.flat-map.js
var es_array_flat_map = __webpack_require__("5db7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unscopables.flat-map.js
var es_array_unscopables_flat_map = __webpack_require__("73d9");

// CONCATENATED MODULE: ./src/core/sortableEvents.js




var manageAndEmit = ["Start", "Add", "Remove", "Update", "End"];
var emit = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
var manage = ["Move"];
var eventHandlerNames = [manage, manageAndEmit, emit].flatMap(function (events) {
  return events;
}).map(function (evt) {
  return "on".concat(evt);
});
var events = {
  manage: manage,
  manageAndEmit: manageAndEmit,
  emit: emit
};

function isReadOnly(eventName) {
  return eventHandlerNames.indexOf(eventName) !== -1;
}


// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("2ca0");

// CONCATENATED MODULE: ./src/util/tags.js


var tags = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "label", "legend", "li", "link", "main", "map", "mark", "math", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rb", "rp", "rt", "rtc", "ruby", "s", "samp", "script", "section", "select", "slot", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "svg", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr"];

function isHtmlTag(name) {
  return tags.includes(name);
}

function isTransition(name) {
  return ["transition-group", "TransitionGroup"].includes(name);
}

function isHtmlAttribute(value) {
  return ["id", "class", "role", "style"].includes(value) || value.startsWith("data-") || value.startsWith("aria-") || value.startsWith("on");
}


// CONCATENATED MODULE: ./src/core/componentBuilderHelper.js












function project(entries) {
  return entries.reduce(function (res, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    res[key] = value;
    return res;
  }, {});
}

function getComponentAttributes(_ref3) {
  var $attrs = _ref3.$attrs,
      _ref3$componentData = _ref3.componentData,
      componentData = _ref3$componentData === void 0 ? {} : _ref3$componentData;
  var attributes = project(Object.entries($attrs).filter(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        _ = _ref5[1];

    return isHtmlAttribute(key);
  }));
  return _objectSpread2(_objectSpread2({}, attributes), componentData);
}

function createSortableOption(_ref6) {
  var $attrs = _ref6.$attrs,
      callBackBuilder = _ref6.callBackBuilder;
  var options = project(getValidSortableEntries($attrs));
  Object.entries(callBackBuilder).forEach(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        eventType = _ref8[0],
        eventBuilder = _ref8[1];

    events[eventType].forEach(function (event) {
      options["on".concat(event)] = eventBuilder(event);
    });
  });
  var draggable = "[data-draggable]".concat(options.draggable || "");
  return _objectSpread2(_objectSpread2({}, options), {}, {
    draggable: draggable
  });
}

function getValidSortableEntries(value) {
  return Object.entries(value).filter(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
        key = _ref10[0],
        _ = _ref10[1];

    return !isHtmlAttribute(key);
  }).map(function (_ref11) {
    var _ref12 = _slicedToArray(_ref11, 2),
        key = _ref12[0],
        value = _ref12[1];

    return [camelize(key), value];
  }).filter(function (_ref13) {
    var _ref14 = _slicedToArray(_ref13, 2),
        key = _ref14[0],
        _ = _ref14[1];

    return !isReadOnly(key);
  });
}


// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("c740");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
// CONCATENATED MODULE: ./src/core/componentStructure.js








var getHtmlElementFromNode = function getHtmlElementFromNode(_ref) {
  var el = _ref.el;
  return el;
};

var addContext = function addContext(domElement, context) {
  return domElement.__draggable_context = context;
};

var getContext = function getContext(domElement) {
  return domElement.__draggable_context;
};

var componentStructure_ComponentStructure = /*#__PURE__*/function () {
  function ComponentStructure(_ref2) {
    var _ref2$nodes = _ref2.nodes,
        header = _ref2$nodes.header,
        defaultNodes = _ref2$nodes.default,
        footer = _ref2$nodes.footer,
        root = _ref2.root,
        realList = _ref2.realList;

    _classCallCheck(this, ComponentStructure);

    this.defaultNodes = defaultNodes;
    this.children = [].concat(_toConsumableArray(header), _toConsumableArray(defaultNodes), _toConsumableArray(footer));
    this.externalComponent = root.externalComponent;
    this.rootTransition = root.transition;
    this.tag = root.tag;
    this.realList = realList;
  }

  _createClass(ComponentStructure, [{
    key: "render",
    value: function render(h, attributes) {
      var tag = this.tag,
          children = this.children,
          _isRootComponent = this._isRootComponent;
      var option = !_isRootComponent ? children : {
        default: function _default() {
          return children;
        }
      };
      return h(tag, attributes, option);
    }
  }, {
    key: "updated",
    value: function updated() {
      var defaultNodes = this.defaultNodes,
          realList = this.realList;
      defaultNodes.forEach(function (node, index) {
        addContext(getHtmlElementFromNode(node), {
          element: realList[index],
          index: index
        });
      });
    }
  }, {
    key: "getUnderlyingVm",
    value: function getUnderlyingVm(domElement) {
      return getContext(domElement);
    }
  }, {
    key: "getVmIndexFromDomIndex",
    value: function getVmIndexFromDomIndex(domIndex, element) {
      var defaultNodes = this.defaultNodes;
      var length = defaultNodes.length;
      var domChildren = element.children;
      var domElement = domChildren.item(domIndex);

      if (domElement === null) {
        return length;
      }

      var context = getContext(domElement);

      if (context) {
        return context.index;
      }

      if (length === 0) {
        return 0;
      }

      var firstDomListElement = getHtmlElementFromNode(defaultNodes[0]);

      var indexFirstDomListElement = _toConsumableArray(domChildren).findIndex(function (element) {
        return element === firstDomListElement;
      });

      return domIndex < indexFirstDomListElement ? 0 : length;
    }
  }, {
    key: "_isRootComponent",
    get: function get() {
      return this.externalComponent || this.rootTransition;
    }
  }]);

  return ComponentStructure;
}();


// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");

// CONCATENATED MODULE: ./src/core/renderHelper.js









function getSlot(slots, key) {
  var slotValue = slots[key];
  return slotValue ? slotValue() : [];
}

function computeNodes(_ref) {
  var $slots = _ref.$slots,
      realList = _ref.realList,
      getKey = _ref.getKey;
  var normalizedList = realList || [];

  var _map = ["header", "footer"].map(function (name) {
    return getSlot($slots, name);
  }),
      _map2 = _slicedToArray(_map, 2),
      header = _map2[0],
      footer = _map2[1];

  var item = $slots.item;

  if (!item) {
    throw new Error("draggable element must have an item slot");
  }

  var defaultNodes = normalizedList.flatMap(function (element, index) {
    return item({
      element: element,
      index: index
    }).map(function (node) {
      node.key = getKey(element);
      node.props = _objectSpread2(_objectSpread2({}, node.props || {}), {}, {
        "data-draggable": true
      });
      return node;
    });
  });

  if (defaultNodes.length !== normalizedList.length) {
    throw new Error("Item slot must have only one child");
  }

  return {
    header: header,
    footer: footer,
    default: defaultNodes
  };
}

function getRootInformation(tag) {
  var transition = isTransition(tag);
  var externalComponent = !isHtmlTag(tag) && !transition;
  return {
    transition: transition,
    externalComponent: externalComponent,
    tag: externalComponent ? Object(external_commonjs_vue_commonjs2_vue_root_Vue_["resolveComponent"])(tag) : transition ? external_commonjs_vue_commonjs2_vue_root_Vue_["TransitionGroup"] : tag
  };
}

function computeComponentStructure(_ref2) {
  var $slots = _ref2.$slots,
      tag = _ref2.tag,
      realList = _ref2.realList,
      getKey = _ref2.getKey;
  var nodes = computeNodes({
    $slots: $slots,
    realList: realList,
    getKey: getKey
  });
  var root = getRootInformation(tag);
  return new componentStructure_ComponentStructure({
    nodes: nodes,
    root: root,
    realList: realList
  });
}


// CONCATENATED MODULE: ./src/vuedraggable.js


















function _emit(evtName, evtData) {
  var _this = this;

  Object(external_commonjs_vue_commonjs2_vue_root_Vue_["nextTick"])(function () {
    return _this.$emit(evtName.toLowerCase(), evtData);
  });
}

function _manage(evtName) {
  var _this2 = this;

  return function (evtData, originalElement) {
    if (_this2.realList !== null) {
      return _this2["onDrag".concat(evtName)](evtData, originalElement);
    }
  };
}

function _manageAndEmit(evtName) {
  var _this3 = this;

  var delegateCallBack = _manage.call(this, evtName);

  return function (evtData, originalElement) {
    delegateCallBack.call(_this3, evtData, originalElement);

    _emit.call(_this3, evtName, evtData);
  };
}

var draggingElement = null;
var props = {
  list: {
    type: Array,
    required: false,
    default: null
  },
  modelValue: {
    type: Array,
    required: false,
    default: null
  },
  itemKey: {
    type: [String, Function],
    required: true
  },
  clone: {
    type: Function,
    default: function _default(original) {
      return original;
    }
  },
  tag: {
    type: String,
    default: "div"
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: false,
    default: null
  }
};
var emits = ["update:modelValue", "change"].concat(_toConsumableArray([].concat(_toConsumableArray(events.manageAndEmit), _toConsumableArray(events.emit)).map(function (evt) {
  return evt.toLowerCase();
})));
var draggableComponent = Object(external_commonjs_vue_commonjs2_vue_root_Vue_["defineComponent"])({
  name: "draggable",
  inheritAttrs: false,
  props: props,
  emits: emits,
  data: function data() {
    return {
      error: false
    };
  },
  render: function render() {
    try {
      this.error = false;
      var $slots = this.$slots,
          $attrs = this.$attrs,
          tag = this.tag,
          componentData = this.componentData,
          realList = this.realList,
          getKey = this.getKey;
      var componentStructure = computeComponentStructure({
        $slots: $slots,
        tag: tag,
        realList: realList,
        getKey: getKey
      });
      this.componentStructure = componentStructure;
      var attributes = getComponentAttributes({
        $attrs: $attrs,
        componentData: componentData
      });
      return componentStructure.render(external_commonjs_vue_commonjs2_vue_root_Vue_["h"], attributes);
    } catch (err) {
      this.error = true;
      return Object(external_commonjs_vue_commonjs2_vue_root_Vue_["h"])("pre", {
        style: {
          color: "red"
        }
      }, err.stack);
    }
  },
  created: function created() {
    if (this.list !== null && this.modelValue !== null) {
      console["a" /* console */].error("modelValue and list props are mutually exclusive! Please set one or another.");
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    if (this.error) {
      return;
    }

    var $attrs = this.$attrs,
        $el = this.$el,
        componentStructure = this.componentStructure;
    componentStructure.updated();
    var sortableOptions = createSortableOption({
      $attrs: $attrs,
      callBackBuilder: {
        manageAndEmit: function manageAndEmit(event) {
          return _manageAndEmit.call(_this4, event);
        },
        emit: function emit(event) {
          return _emit.bind(_this4, event);
        },
        manage: function manage(event) {
          return _manage.call(_this4, event);
        }
      }
    });
    var targetDomElement = $el.nodeType === 1 ? $el : $el.parentElement;
    this._sortable = new external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default.a(targetDomElement, sortableOptions);
    this.targetDomElement = targetDomElement;
    targetDomElement.__draggable_component__ = this;
  },
  updated: function updated() {
    this.componentStructure.updated();
  },
  beforeUnmount: function beforeUnmount() {
    if (this._sortable !== undefined) this._sortable.destroy();
  },
  computed: {
    realList: function realList() {
      var list = this.list;
      return list ? list : this.modelValue;
    },
    getKey: function getKey() {
      var itemKey = this.itemKey;

      if (typeof itemKey === "function") {
        return itemKey;
      }

      return function (element) {
        return element[itemKey];
      };
    }
  },
  watch: {
    $attrs: {
      handler: function handler(newOptionValue) {
        var _sortable = this._sortable;
        if (!_sortable) return;
        getValidSortableEntries(newOptionValue).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          _sortable.option(key, value);
        });
      },
      deep: true
    }
  },
  methods: {
    getUnderlyingVm: function getUnderlyingVm(domElement) {
      return this.componentStructure.getUnderlyingVm(domElement) || null;
    },
    getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(htmElement) {
      //TODO check case where you need to see component children
      return htmElement.__draggable_component__;
    },
    emitChanges: function emitChanges(evt) {
      var _this5 = this;

      Object(external_commonjs_vue_commonjs2_vue_root_Vue_["nextTick"])(function () {
        return _this5.$emit("change", evt);
      });
    },
    alterList: function alterList(onList) {
      if (this.list) {
        onList(this.list);
        return;
      }

      var newList = _toConsumableArray(this.modelValue);

      onList(newList);
      this.$emit("update:modelValue", newList);
    },
    spliceList: function spliceList() {
      var _arguments = arguments;

      var spliceList = function spliceList(list) {
        return list.splice.apply(list, _toConsumableArray(_arguments));
      };

      this.alterList(spliceList);
    },
    updatePosition: function updatePosition(oldIndex, newIndex) {
      var updatePosition = function updatePosition(list) {
        return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
      };

      this.alterList(updatePosition);
    },
    getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref3) {
      var to = _ref3.to,
          related = _ref3.related;
      var component = this.getUnderlyingPotencialDraggableComponent(to);

      if (!component) {
        return {
          component: component
        };
      }

      var list = component.realList;
      var context = {
        list: list,
        component: component
      };

      if (to !== related && list) {
        var destination = component.getUnderlyingVm(related) || {};
        return _objectSpread2(_objectSpread2({}, destination), context);
      }

      return context;
    },
    getVmIndexFromDomIndex: function getVmIndexFromDomIndex(domIndex) {
      return this.componentStructure.getVmIndexFromDomIndex(domIndex, this.targetDomElement);
    },
    onDragStart: function onDragStart(evt) {
      this.context = this.getUnderlyingVm(evt.item);
      evt.item._underlying_vm_ = this.clone(this.context.element);
      draggingElement = evt.item;
    },
    onDragAdd: function onDragAdd(evt) {
      var element = evt.item._underlying_vm_;

      if (element === undefined) {
        return;
      }

      removeNode(evt.item);
      var newIndex = this.getVmIndexFromDomIndex(evt.newIndex);
      this.spliceList(newIndex, 0, element);
      var added = {
        element: element,
        newIndex: newIndex
      };
      this.emitChanges({
        added: added
      });
    },
    onDragRemove: function onDragRemove(evt) {
      insertNodeAt(this.$el, evt.item, evt.oldIndex);

      if (evt.pullMode === "clone") {
        removeNode(evt.clone);
        return;
      }

      var _this$context = this.context,
          oldIndex = _this$context.index,
          element = _this$context.element;
      this.spliceList(oldIndex, 1);
      var removed = {
        element: element,
        oldIndex: oldIndex
      };
      this.emitChanges({
        removed: removed
      });
    },
    onDragUpdate: function onDragUpdate(evt) {
      removeNode(evt.item);
      insertNodeAt(evt.from, evt.item, evt.oldIndex);
      var oldIndex = this.context.index;
      var newIndex = this.getVmIndexFromDomIndex(evt.newIndex);
      this.updatePosition(oldIndex, newIndex);
      var moved = {
        element: this.context.element,
        oldIndex: oldIndex,
        newIndex: newIndex
      };
      this.emitChanges({
        moved: moved
      });
    },
    computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
      if (!relatedContext.element) {
        return 0;
      }

      var domChildren = _toConsumableArray(evt.to.children).filter(function (el) {
        return el.style["display"] !== "none";
      });

      var currentDomIndex = domChildren.indexOf(evt.related);
      var currentIndex = relatedContext.component.getVmIndexFromDomIndex(currentDomIndex);
      var draggedInList = domChildren.indexOf(draggingElement) !== -1;
      return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
    },
    onDragMove: function onDragMove(evt, originalEvent) {
      var move = this.move,
          realList = this.realList;

      if (!move || !realList) {
        return true;
      }

      var relatedContext = this.getRelatedContextFromMoveEvent(evt);
      var futureIndex = this.computeFutureIndex(relatedContext, evt);

      var draggedContext = _objectSpread2(_objectSpread2({}, this.context), {}, {
        futureIndex: futureIndex
      });

      var sendEvent = _objectSpread2(_objectSpread2({}, evt), {}, {
        relatedContext: relatedContext,
        draggedContext: draggedContext
      });

      return move(sendEvent, originalEvent);
    },
    onDragEnd: function onDragEnd() {
      draggingElement = null;
    }
  }
});
/* harmony default export */ var vuedraggable = (draggableComponent);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (vuedraggable);



/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
var USES_TO_LENGTH = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ })

/******/ })["default"];
});
//# sourceMappingURL=vuedraggable.umd.js.map

/***/ }),

/***/ "b809":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardDescription_vue_vue_type_style_index_0_id_335848e0_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5c70");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardDescription_vue_vue_type_style_index_0_id_335848e0_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardDescription_vue_vue_type_style_index_0_id_335848e0_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b8f4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaAccordion_vue_vue_type_style_index_0_id_0c3a48bd_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c839");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaAccordion_vue_vue_type_style_index_0_id_0c3a48bd_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaAccordion_vue_vue_type_style_index_0_id_0c3a48bd_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b948":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ba01":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-5-minute-prep.svg";

/***/ }),

/***/ "bbfa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-subskill.svg";

/***/ }),

/***/ "bc0a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/zoe_footer.png";

/***/ }),

/***/ "bc3a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cee4");

/***/ }),

/***/ "bcc7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-state-standards.svg";

/***/ }),

/***/ "bdd9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-interactive-video.svg";

/***/ }),

/***/ "be52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaQuicklinks_vue_vue_type_style_index_0_id_7adb0c51_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a594");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaQuicklinks_vue_vue_type_style_index_0_id_7adb0c51_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaQuicklinks_vue_vue_type_style_index_0_id_7adb0c51_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c0aa":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c134":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardLogos_vue_vue_type_style_index_0_id_4e9ca70a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e577");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardLogos_vue_vue_type_style_index_0_id_4e9ca70a_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardLogos_vue_vue_type_style_index_0_id_4e9ca70a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c345":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "c401":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var defaults = __webpack_require__("2444");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ "c414":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTooltip_vue_vue_type_style_index_0_id_58b1eca2_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0cf8");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTooltip_vue_vue_type_style_index_0_id_58b1eca2_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTooltip_vue_vue_type_style_index_0_id_58b1eca2_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("1d2b");

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ "c54a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-higher-ed-unit.svg";

/***/ }),

/***/ "c65e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCarouselArrow_vue_vue_type_style_index_0_id_77d09fbe_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b948");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCarouselArrow_vue_vue_type_style_index_0_id_77d09fbe_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCarouselArrow_vue_vue_type_style_index_0_id_77d09fbe_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c6eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5ea3");


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("dd40")(module)))

/***/ }),

/***/ "c72f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/profile-background-user.png";

/***/ }),

/***/ "c839":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c887":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCarouselDots_vue_vue_type_style_index_0_id_00e45105_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dd82");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCarouselDots_vue_vue_type_style_index_0_id_00e45105_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCarouselDots_vue_vue_type_style_index_0_id_00e45105_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c8af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8f2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/profile-background-impersonate.png";

/***/ }),

/***/ "c9d9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCarouselSlide_vue_vue_type_style_index_0_id_6c2ebe27_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("da24");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCarouselSlide_vue_vue_type_style_index_0_id_6c2ebe27_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCarouselSlide_vue_vue_type_style_index_0_id_6c2ebe27_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "cdee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MultiLevelNav_vue_vue_type_style_index_0_id_03066134_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9469");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MultiLevelNav_vue_vue_type_style_index_0_id_03066134_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MultiLevelNav_vue_vue_type_style_index_0_id_03066134_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "cee4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var bind = __webpack_require__("1d2b");
var Axios = __webpack_require__("0a06");
var mergeConfig = __webpack_require__("4a7b");
var defaults = __webpack_require__("2444");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("7a77");
axios.CancelToken = __webpack_require__("8df4");
axios.isCancel = __webpack_require__("2e67");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("0df6");

// Expose isAxiosError
axios.isAxiosError = __webpack_require__("5f02");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "d00d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-integrated-science-simulation.svg";

/***/ }),

/***/ "d17d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTableHeader_vue_vue_type_style_index_0_id_f28aff2e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b5f6");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTableHeader_vue_vue_type_style_index_0_id_f28aff2e_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTableHeader_vue_vue_type_style_index_0_id_f28aff2e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d1cd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaSelect_vue_vue_type_style_index_0_id_c3d9728a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e2fb");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaSelect_vue_vue_type_style_index_0_id_c3d9728a_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaSelect_vue_vue_type_style_index_0_id_c3d9728a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d1d8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaVideoSegmentCarousel_vue_vue_type_style_index_0_id_7dd00434_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ecc4");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaVideoSegmentCarousel_vue_vue_type_style_index_0_id_7dd00434_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaVideoSegmentCarousel_vue_vue_type_style_index_0_id_7dd00434_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d201":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaLabel_vue_vue_type_style_index_0_id_0fa21cc8_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a3fe");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaLabel_vue_vue_type_style_index_0_id_0fa21cc8_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaLabel_vue_vue_type_style_index_0_id_0fa21cc8_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d2f1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaProductBlock_vue_vue_type_style_index_0_id_c71da114_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0b58");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaProductBlock_vue_vue_type_style_index_0_id_c71da114_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaProductBlock_vue_vue_type_style_index_0_id_c71da114_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d3ae":
/***/ (function(module, exports, __webpack_require__) {

// In the Core app where this package is used through requirejs, we need
// to tell the entrypoint where to find nebula-components' assets, like images

/* eslint-disable no-undef */
if (typeof window !== 'undefined' && window.require && window.require.toUrl && !__webpack_require__.p) {
  __webpack_require__.p = window.require.toUrl('@discoveryedu/nebula-components').replace(/(nebula-components\/dist\/)(.*)/, '$1');
} else if (!__webpack_require__.p) {
  __webpack_require__.p = '/_nuxt/';
}

/***/ }),

/***/ "d3fe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTable_vue_vue_type_style_index_0_id_7ed75fd4_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3e75");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTable_vue_vue_type_style_index_0_id_7ed75fd4_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTable_vue_vue_type_style_index_0_id_7ed75fd4_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d4ab":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-activity.svg";

/***/ }),

/***/ "d54b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-resource.svg";

/***/ }),

/***/ "d56c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTableCell_vue_vue_type_style_index_0_id_49eb0797_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a7c2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTableCell_vue_vue_type_style_index_0_id_49eb0797_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTableCell_vue_vue_type_style_index_0_id_49eb0797_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d6b0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBadge_vue_vue_type_style_index_0_id_2eaa25d0_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8866");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBadge_vue_vue_type_style_index_0_id_2eaa25d0_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaBadge_vue_vue_type_style_index_0_id_2eaa25d0_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d707":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-multi-layer-map.svg";

/***/ }),

/***/ "d761":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-resource-page-content-collection.svg";

/***/ }),

/***/ "d76a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCopyButton_vue_vue_type_style_index_0_id_3feee9a7_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3ec6");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCopyButton_vue_vue_type_style_index_0_id_3feee9a7_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCopyButton_vue_vue_type_style_index_0_id_3feee9a7_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d797":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPageShell_vue_vue_type_style_index_0_id_3a162186_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5160");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPageShell_vue_vue_type_style_index_0_id_3a162186_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPageShell_vue_vue_type_style_index_0_id_3a162186_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d82b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d893":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-review-sheet.svg";

/***/ }),

/***/ "d8b5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d925":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "d984":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardTitle_vue_vue_type_style_index_0_id_0df201f6_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ff8d");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardTitle_vue_vue_type_style_index_0_id_0df201f6_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardTitle_vue_vue_type_style_index_0_id_0df201f6_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d9cd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaInput_vue_vue_type_style_index_0_id_232a3873_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0282");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaInput_vue_vue_type_style_index_0_id_232a3873_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaInput_vue_vue_type_style_index_0_id_232a3873_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d9ef":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-quiz-question.svg";

/***/ }),

/***/ "da24":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "db8f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "dd40":
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if (!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "dd49":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-slideshow.svg";

/***/ }),

/***/ "dd51":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "dd82":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "dd86":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaSticker_vue_vue_type_style_index_0_id_0a8e5c34_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8461");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaSticker_vue_vue_type_style_index_0_id_0a8e5c34_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaSticker_vue_vue_type_style_index_0_id_0a8e5c34_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "deb4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "df7c":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362")))

/***/ }),

/***/ "e023":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFeatureRow_vue_vue_type_style_index_0_id_10768716_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6181");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFeatureRow_vue_vue_type_style_index_0_id_10768716_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaFeatureRow_vue_vue_type_style_index_0_id_10768716_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e03b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-section.svg";

/***/ }),

/***/ "e0ac":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e0e1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e25b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e2fb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e3a6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e3af":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_css_loader_dist_cjs_js_ref_7_oneOf_1_1_vue_loader_v16_dist_stylePostLoader_js_postcss_loader_src_index_js_ref_7_oneOf_1_2_vue_select_css_vue_type_style_index_0_lang_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("36b6");
/* harmony import */ var _mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_css_loader_dist_cjs_js_ref_7_oneOf_1_1_vue_loader_v16_dist_stylePostLoader_js_postcss_loader_src_index_js_ref_7_oneOf_1_2_vue_select_css_vue_type_style_index_0_lang_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_mini_css_extract_plugin_dist_loader_js_ref_7_oneOf_1_0_css_loader_dist_cjs_js_ref_7_oneOf_1_1_vue_loader_v16_dist_stylePostLoader_js_postcss_loader_src_index_js_ref_7_oneOf_1_2_vue_select_css_vue_type_style_index_0_lang_css__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e3f1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e429":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPaginationButtonItem_vue_vue_type_style_index_0_id_3d1f70ac_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("633b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPaginationButtonItem_vue_vue_type_style_index_0_id_3d1f70ac_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPaginationButtonItem_vue_vue_type_style_index_0_id_3d1f70ac_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e4fa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ThumbnailLoader_vue_vue_type_style_index_0_id_ff046410_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a3cd");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ThumbnailLoader_vue_vue_type_style_index_0_id_ff046410_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ThumbnailLoader_vue_vue_type_style_index_0_id_ff046410_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e55f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-video-guide.svg";

/***/ }),

/***/ "e577":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e5cc":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e683":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "e888":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTag_vue_vue_type_style_index_0_id_391f3e66_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2ddf");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTag_vue_vue_type_style_index_0_id_391f3e66_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaTag_vue_vue_type_style_index_0_id_391f3e66_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e9ca":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-general-graphic-organizer.svg";

/***/ }),

/***/ "ea31":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "eb18":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "eb52":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-technology-enhanced-assessment.svg";

/***/ }),

/***/ "ebaa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-brain-game.svg";

/***/ }),

/***/ "ebb3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaProductBar_vue_vue_type_style_index_0_id_c76f172e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("88ad");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaProductBar_vue_vue_type_style_index_0_id_c76f172e_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaProductBar_vue_vue_type_style_index_0_id_c76f172e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ec47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaQuickList_vue_vue_type_style_index_0_id_5d6ca8bc_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("74bc");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaQuickList_vue_vue_type_style_index_0_id_5d6ca8bc_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaQuickList_vue_vue_type_style_index_0_id_5d6ca8bc_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ecc4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ecfc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-flash.svg";

/***/ }),

/***/ "ef87":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-science-tool.svg";

/***/ }),

/***/ "f012":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaActionBar_vue_vue_type_style_index_0_id_b8afe756_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0a7b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaActionBar_vue_vue_type_style_index_0_id_b8afe756_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaActionBar_vue_vue_type_style_index_0_id_b8afe756_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f148":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardThumbnail_vue_vue_type_style_index_0_id_c5506394_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7573");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardThumbnail_vue_vue_type_style_index_0_id_c5506394_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCardThumbnail_vue_vue_type_style_index_0_id_c5506394_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f156":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPanel_vue_vue_type_style_index_0_id_8204a2ba_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("089c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPanel_vue_vue_type_style_index_0_id_8204a2ba_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaPanel_vue_vue_type_style_index_0_id_8204a2ba_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f25c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-title-chapter-section-video-segment.svg";

/***/ }),

/***/ "f4a8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIconButton_vue_vue_type_style_index_0_id_238ed0ba_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5f1b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIconButton_vue_vue_type_style_index_0_id_238ed0ba_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaIconButton_vue_vue_type_style_index_0_id_238ed0ba_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f4b8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-podcast.svg";

/***/ }),

/***/ "f4ec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaToastMessage_vue_vue_type_style_index_0_id_f8950b9e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a14a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaToastMessage_vue_vue_type_style_index_0_id_f8950b9e_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaToastMessage_vue_vue_type_style_index_0_id_f8950b9e_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f5b6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f624":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaModal_vue_vue_type_style_index_0_id_8787f17a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1d1d");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaModal_vue_vue_type_style_index_0_id_8787f17a_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaModal_vue_vue_type_style_index_0_id_8787f17a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f6b4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "f6bf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCallout_vue_vue_type_style_index_0_id_897453b6_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ac96");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCallout_vue_vue_type_style_index_0_id_897453b6_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaCallout_vue_vue_type_style_index_0_id_897453b6_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f815":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-techbook-concept-page.svg";

/***/ }),

/***/ "f91b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-interactive-lesson.svg";

/***/ }),

/***/ "f962":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-theme.svg";

/***/ }),

/***/ "f996":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "NebulaAccordion", function() { return /* reexport */ main_lib_NebulaAccordion; });
__webpack_require__.d(__webpack_exports__, "NebulaActionBar", function() { return /* reexport */ main_lib_NebulaActionBar; });
__webpack_require__.d(__webpack_exports__, "NebulaBadge", function() { return /* reexport */ main_lib_NebulaBadge; });
__webpack_require__.d(__webpack_exports__, "NebulaBanner", function() { return /* reexport */ main_lib_NebulaBanner; });
__webpack_require__.d(__webpack_exports__, "NebulaBlockMessage", function() { return /* reexport */ main_lib_NebulaBlockMessage; });
__webpack_require__.d(__webpack_exports__, "NebulaBreadcrumbs", function() { return /* reexport */ main_lib_NebulaBreadcrumbs; });
__webpack_require__.d(__webpack_exports__, "NebulaBackToTop", function() { return /* reexport */ main_lib_NebulaBackToTop; });
__webpack_require__.d(__webpack_exports__, "NebulaButton", function() { return /* reexport */ main_lib_NebulaButton; });
__webpack_require__.d(__webpack_exports__, "NebulaCopyButton", function() { return /* reexport */ main_lib_NebulaCopyButton; });
__webpack_require__.d(__webpack_exports__, "NebulaFavoritesButton", function() { return /* reexport */ main_lib_NebulaFavoritesButton; });
__webpack_require__.d(__webpack_exports__, "NebulaFloatingActionButton", function() { return /* reexport */ main_lib_NebulaFloatingActionButton; });
__webpack_require__.d(__webpack_exports__, "NebulaFullscreenButton", function() { return /* reexport */ main_lib_NebulaFullscreenButton; });
__webpack_require__.d(__webpack_exports__, "NebulaIconButton", function() { return /* reexport */ main_lib_NebulaIconButton; });
__webpack_require__.d(__webpack_exports__, "NebulaButtonGroup", function() { return /* reexport */ main_lib_NebulaButtonGroup; });
__webpack_require__.d(__webpack_exports__, "NebulaCallout", function() { return /* reexport */ main_lib_NebulaCallout; });
__webpack_require__.d(__webpack_exports__, "NebulaCallToAction", function() { return /* reexport */ main_lib_NebulaCallToAction; });
__webpack_require__.d(__webpack_exports__, "NebulaActivityCard", function() { return /* reexport */ main_lib_NebulaActivityCard; });
__webpack_require__.d(__webpack_exports__, "NebulaAssetCard", function() { return /* reexport */ main_lib_NebulaAssetCard; });
__webpack_require__.d(__webpack_exports__, "NebulaAssignmentCard", function() { return /* reexport */ main_lib_NebulaAssignmentCard; });
__webpack_require__.d(__webpack_exports__, "NebulaCard", function() { return /* reexport */ main_lib_NebulaCard; });
__webpack_require__.d(__webpack_exports__, "NebulaChannelCard", function() { return /* reexport */ main_lib_NebulaChannelCard; });
__webpack_require__.d(__webpack_exports__, "NebulaClassroomCard", function() { return /* reexport */ main_lib_NebulaClassroomCard; });
__webpack_require__.d(__webpack_exports__, "NebulaContainerCard", function() { return /* reexport */ main_lib_NebulaContainerCard; });
__webpack_require__.d(__webpack_exports__, "NebulaLessonCard", function() { return /* reexport */ main_lib_NebulaLessonCard; });
__webpack_require__.d(__webpack_exports__, "NebulaVideoCard", function() { return /* reexport */ main_lib_NebulaVideoCard; });
__webpack_require__.d(__webpack_exports__, "NebulaCardDescription", function() { return /* reexport */ main_lib_NebulaCardDescription; });
__webpack_require__.d(__webpack_exports__, "NebulaCardHeader", function() { return /* reexport */ main_lib_NebulaCardHeader; });
__webpack_require__.d(__webpack_exports__, "NebulaCardLabel", function() { return /* reexport */ main_lib_NebulaCardLabel; });
__webpack_require__.d(__webpack_exports__, "NebulaCardLinks", function() { return /* reexport */ main_lib_NebulaCardLinks; });
__webpack_require__.d(__webpack_exports__, "NebulaCardLogos", function() { return /* reexport */ main_lib_NebulaCardLogos; });
__webpack_require__.d(__webpack_exports__, "NebulaCardMetadata", function() { return /* reexport */ main_lib_NebulaCardMetadata; });
__webpack_require__.d(__webpack_exports__, "NebulaCardThumbnail", function() { return /* reexport */ main_lib_NebulaCardThumbnail; });
__webpack_require__.d(__webpack_exports__, "NebulaCardTitle", function() { return /* reexport */ main_lib_NebulaCardTitle; });
__webpack_require__.d(__webpack_exports__, "NebulaCardGrid", function() { return /* reexport */ main_lib_NebulaCardGrid; });
__webpack_require__.d(__webpack_exports__, "NebulaCardRow", function() { return /* reexport */ main_lib_NebulaCardRow; });
__webpack_require__.d(__webpack_exports__, "NebulaCardCarousel", function() { return /* reexport */ main_lib_NebulaCardCarousel; });
__webpack_require__.d(__webpack_exports__, "NebulaCarousel", function() { return /* reexport */ main_lib_NebulaCarousel; });
__webpack_require__.d(__webpack_exports__, "NebulaCombobox", function() { return /* reexport */ main_lib_NebulaCombobox; });
__webpack_require__.d(__webpack_exports__, "NebulaDatepicker", function() { return /* reexport */ main_lib_NebulaDatepicker; });
__webpack_require__.d(__webpack_exports__, "NebulaDialog", function() { return /* reexport */ main_lib_NebulaDialog; });
__webpack_require__.d(__webpack_exports__, "NebulaDraggableCards", function() { return /* reexport */ main_lib_NebulaDraggableCards; });
__webpack_require__.d(__webpack_exports__, "NebulaDropdown", function() { return /* reexport */ main_lib_NebulaDropdown; });
__webpack_require__.d(__webpack_exports__, "NebulaDropdownItem", function() { return /* reexport */ main_lib_NebulaDropdownItem; });
__webpack_require__.d(__webpack_exports__, "NebulaFooter", function() { return /* reexport */ main_lib_NebulaFooter; });
__webpack_require__.d(__webpack_exports__, "NebulaVueSelect", function() { return /* reexport */ main_lib_NebulaVueSelect; });
__webpack_require__.d(__webpack_exports__, "NebulaCheckbox", function() { return /* reexport */ main_lib_NebulaCheckbox; });
__webpack_require__.d(__webpack_exports__, "NebulaFieldGroup", function() { return /* reexport */ main_lib_NebulaFieldGroup; });
__webpack_require__.d(__webpack_exports__, "NebulaFormHelper", function() { return /* reexport */ main_lib_NebulaFormHelper; });
__webpack_require__.d(__webpack_exports__, "NebulaInput", function() { return /* reexport */ main_lib_NebulaInput; });
__webpack_require__.d(__webpack_exports__, "NebulaInputWithButtons", function() { return /* reexport */ main_lib_NebulaInputWithButtons; });
__webpack_require__.d(__webpack_exports__, "NebulaLabel", function() { return /* reexport */ main_lib_NebulaLabel; });
__webpack_require__.d(__webpack_exports__, "NebulaRadio", function() { return /* reexport */ main_lib_NebulaRadio; });
__webpack_require__.d(__webpack_exports__, "NebulaSelect", function() { return /* reexport */ main_lib_NebulaSelect; });
__webpack_require__.d(__webpack_exports__, "NebulaSelectOption", function() { return /* reexport */ main_lib_NebulaSelectOption; });
__webpack_require__.d(__webpack_exports__, "NebulaSwitch", function() { return /* reexport */ main_lib_NebulaSwitch; });
__webpack_require__.d(__webpack_exports__, "NebulaTextarea", function() { return /* reexport */ main_lib_NebulaTextarea; });
__webpack_require__.d(__webpack_exports__, "NebulaGlobalNav", function() { return /* reexport */ main_lib_NebulaGlobalNav; });
__webpack_require__.d(__webpack_exports__, "NebulaGrid", function() { return /* reexport */ NebulaGrid; });
__webpack_require__.d(__webpack_exports__, "NebulaHero", function() { return /* reexport */ main_lib_NebulaHero; });
__webpack_require__.d(__webpack_exports__, "NebulaIcon", function() { return /* reexport */ main_lib_NebulaIcon; });
__webpack_require__.d(__webpack_exports__, "NebulaImage", function() { return /* reexport */ main_lib_NebulaImage; });
__webpack_require__.d(__webpack_exports__, "NebulaListboxItem", function() { return /* reexport */ main_lib_NebulaListboxItem; });
__webpack_require__.d(__webpack_exports__, "NebulaListGroup", function() { return /* reexport */ main_lib_NebulaListGroup; });
__webpack_require__.d(__webpack_exports__, "NebulaListItem", function() { return /* reexport */ main_lib_NebulaListItem; });
__webpack_require__.d(__webpack_exports__, "NebulaListItemExpandable", function() { return /* reexport */ main_lib_NebulaListItemExpandable; });
__webpack_require__.d(__webpack_exports__, "NebulaMenuBar", function() { return /* reexport */ main_lib_NebulaMenuBar; });
__webpack_require__.d(__webpack_exports__, "NebulaModal", function() { return /* reexport */ main_lib_NebulaModal; });
__webpack_require__.d(__webpack_exports__, "MultiLevelNav", function() { return /* reexport */ main_lib_MultiLevelNav; });
__webpack_require__.d(__webpack_exports__, "NebulaMultiLevelNavItem", function() { return /* reexport */ NebulaMultiLevelNavItem; });
__webpack_require__.d(__webpack_exports__, "NebulaMultiLevelNavPanel", function() { return /* reexport */ NebulaMultiLevelNavPanel; });
__webpack_require__.d(__webpack_exports__, "NebulaPageShell", function() { return /* reexport */ main_lib_NebulaPageShell; });
__webpack_require__.d(__webpack_exports__, "NebulaDropdownPagination", function() { return /* reexport */ main_lib_NebulaDropdownPagination; });
__webpack_require__.d(__webpack_exports__, "NebulaPagination", function() { return /* reexport */ main_lib_NebulaPagination; });
__webpack_require__.d(__webpack_exports__, "NebulaPaginationButtonItem", function() { return /* reexport */ main_lib_NebulaPaginationButtonItem; });
__webpack_require__.d(__webpack_exports__, "NebulaPanel", function() { return /* reexport */ main_lib_NebulaPanel; });
__webpack_require__.d(__webpack_exports__, "NebulaPicture", function() { return /* reexport */ main_lib_NebulaPicture; });
__webpack_require__.d(__webpack_exports__, "NebulaPopover", function() { return /* reexport */ main_lib_NebulaPopover; });
__webpack_require__.d(__webpack_exports__, "NebulaProductBar", function() { return /* reexport */ main_lib_NebulaProductBar; });
__webpack_require__.d(__webpack_exports__, "NebulaProductBarSearch", function() { return /* reexport */ main_lib_NebulaProductBarSearch; });
__webpack_require__.d(__webpack_exports__, "NebulaProductBlock", function() { return /* reexport */ main_lib_NebulaProductBlock; });
__webpack_require__.d(__webpack_exports__, "NebulaProfilePanel", function() { return /* reexport */ main_lib_NebulaProfilePanel; });
__webpack_require__.d(__webpack_exports__, "NebulaProfilePanelToggle", function() { return /* reexport */ main_lib_NebulaProfilePanelToggle; });
__webpack_require__.d(__webpack_exports__, "NebulaQuicklinks", function() { return /* reexport */ main_lib_NebulaQuicklinks; });
__webpack_require__.d(__webpack_exports__, "NebulaQuickList", function() { return /* reexport */ main_lib_NebulaQuickList; });
__webpack_require__.d(__webpack_exports__, "NebulaQuickListCard", function() { return /* reexport */ main_lib_NebulaQuickListCard; });
__webpack_require__.d(__webpack_exports__, "NebulaContentRow", function() { return /* reexport */ main_lib_NebulaContentRow; });
__webpack_require__.d(__webpack_exports__, "NebulaFeatureRow", function() { return /* reexport */ main_lib_NebulaFeatureRow; });
__webpack_require__.d(__webpack_exports__, "NebulaImageRow", function() { return /* reexport */ main_lib_NebulaImageRow; });
__webpack_require__.d(__webpack_exports__, "NebulaRow", function() { return /* reexport */ main_lib_NebulaRow; });
__webpack_require__.d(__webpack_exports__, "NebulaIconSidebar", function() { return /* reexport */ main_lib_NebulaIconSidebar; });
__webpack_require__.d(__webpack_exports__, "NebulaSidebar", function() { return /* reexport */ main_lib_NebulaSidebar; });
__webpack_require__.d(__webpack_exports__, "NebulaSidebarItem", function() { return /* reexport */ main_lib_NebulaSidebarItem; });
__webpack_require__.d(__webpack_exports__, "NebulaSidebarSectionHeader", function() { return /* reexport */ main_lib_NebulaSidebarSectionHeader; });
__webpack_require__.d(__webpack_exports__, "NebulaSticker", function() { return /* reexport */ main_lib_NebulaSticker; });
__webpack_require__.d(__webpack_exports__, "NebulaTable", function() { return /* reexport */ main_lib_NebulaTable; });
__webpack_require__.d(__webpack_exports__, "NebulaTableCell", function() { return /* reexport */ main_lib_NebulaTableCell; });
__webpack_require__.d(__webpack_exports__, "NebulaTableHeader", function() { return /* reexport */ main_lib_NebulaTableHeader; });
__webpack_require__.d(__webpack_exports__, "NebulaTabDropdown", function() { return /* reexport */ main_lib_NebulaTabDropdown; });
__webpack_require__.d(__webpack_exports__, "NebulaTabItem", function() { return /* reexport */ main_lib_NebulaTabItem; });
__webpack_require__.d(__webpack_exports__, "NebulaTabs", function() { return /* reexport */ main_lib_NebulaTabs; });
__webpack_require__.d(__webpack_exports__, "NebulaTag", function() { return /* reexport */ main_lib_NebulaTag; });
__webpack_require__.d(__webpack_exports__, "NebulaTestimonial", function() { return /* reexport */ main_lib_NebulaTestimonial; });
__webpack_require__.d(__webpack_exports__, "NebulaThumbnail", function() { return /* reexport */ main_lib_NebulaThumbnail; });
__webpack_require__.d(__webpack_exports__, "NebulaTitleBlock", function() { return /* reexport */ main_lib_NebulaTitleBlock; });
__webpack_require__.d(__webpack_exports__, "NebulaToastMessage", function() { return /* reexport */ main_lib_NebulaToastMessage; });
__webpack_require__.d(__webpack_exports__, "NebulaToastMessages", function() { return /* reexport */ main_lib_NebulaToastMessages; });
__webpack_require__.d(__webpack_exports__, "NebulaTooltip", function() { return /* reexport */ main_lib_NebulaTooltip; });
__webpack_require__.d(__webpack_exports__, "NebulaTitleTooltip", function() { return /* reexport */ main_lib_NebulaTitleTooltip; });
__webpack_require__.d(__webpack_exports__, "NebulaVideoSegmentCard", function() { return /* reexport */ main_lib_NebulaVideoSegmentCard; });
__webpack_require__.d(__webpack_exports__, "NebulaVideoSegmentCarousel", function() { return /* reexport */ main_lib_NebulaVideoSegmentCarousel; });
__webpack_require__.d(__webpack_exports__, "nebulaAriaDisabledEvents", function() { return /* reexport */ nebulaAriaDisabledEvents; });
__webpack_require__.d(__webpack_exports__, "nebulaI18nPluralTerms", function() { return /* reexport */ nebulaI18nPluralTerms; });
__webpack_require__.d(__webpack_exports__, "NebulaPaginationLinkGenerators", function() { return /* reexport */ NebulaPaginationLinkGenerators; });
__webpack_require__.d(__webpack_exports__, "NebulaGetOrdinalSuffix", function() { return /* reexport */ NebulaGetOrdinalSuffix; });
__webpack_require__.d(__webpack_exports__, "NebulaThemingUtils", function() { return /* reexport */ NebulaThemingUtils; });
__webpack_require__.d(__webpack_exports__, "NebulaFullscreenMixin", function() { return /* reexport */ NebulaFullscreenMixin; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/utils/public-path.js
var public_path = __webpack_require__("d3ae");

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Accordion/NebulaAccordion.vue?vue&type=template&id=0c3a48bd

const _hoisted_1 = {
  key: 0,
  class: "nebula-accordion__menu-item"
};
const _hoisted_2 = ["id", "aria-expanded", "aria-controls", "aria-label"];
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = ["id", "aria-expanded", "aria-controls"];
const _hoisted_5 = {
  key: 0,
  class: "nebula-accordion__header"
};
const _hoisted_6 = {
  key: 1,
  class: "nebula-accordion__title"
};
const _hoisted_7 = {
  key: 0,
  class: "nebula-accordion__preview"
};
const _hoisted_8 = ["id", "aria-labelledby"];
const _hoisted_9 = {
  ref: "contentContainer",
  class: "nebula-accordion__content-container"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.menuItem ? 'div' : $props.element), {
    class: Object(external_vue_["normalizeClass"])(["nebula-accordion", $options.modeClass]),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, {
    default: Object(external_vue_["withCtx"])(() => [$props.menuItem ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", _hoisted_1, [$props.menuItem.url || $props.menuItem.useRouterLink ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, Object(external_vue_["mergeProps"])({
      key: 0,
      class: $props.menuItem.selected && 'nebula-accordion__menu-item--selected',
      text: $props.menuItem.name,
      size: "s",
      type: "flat",
      link: $props.menuItem.url ? $props.menuItem.url : null,
      routerLink: $props.menuItem.useRouterLink ? $props.menuItem.useRouterLink : null
    }, $props.buttonDataAttributes), null, 16, ["class", "text", "link", "routerLink"])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, Object(external_vue_["mergeProps"])({
      key: 1,
      text: $props.menuItem.name,
      size: "s",
      type: "flat",
      "aria-expanded": `${$data.isExpanded}`,
      "aria-controls": $options.formattedId,
      "aria-label": _ctx.$t('expand menu'),
      onClick: _cache[0] || (_cache[0] = $event => $options.toggle()),
      onKeydown: $options.handleKeydown
    }, $props.buttonDataAttributes), null, 16, ["text", "aria-expanded", "aria-controls", "aria-label", "onKeydown"])), $options.showContent ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", Object(external_vue_["mergeProps"])({
      key: 2,
      id: `${$options.formattedId}-button`,
      class: $options.buttonClass,
      "aria-expanded": `${$data.isExpanded}`,
      "aria-controls": $options.formattedId,
      "aria-label": _ctx.$t('expand menu'),
      onClick: _cache[1] || (_cache[1] = $event => $options.toggle()),
      onKeydown: _cache[2] || (_cache[2] = (...args) => $options.handleKeydown && $options.handleKeydown(...args)),
      type: "button"
    }, $props.buttonDataAttributes), [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      size: "s",
      symbolId: "caret-down",
      class: "nebula-accordion-caret"
    })], 16, _hoisted_2)) : Object(external_vue_["createCommentVNode"])("", true)])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", _hoisted_3, [Object(external_vue_["createElementVNode"])("button", Object(external_vue_["mergeProps"])({
      id: `${$options.formattedId}-button`,
      class: $options.buttonClass,
      "aria-expanded": `${$data.isExpanded}`,
      "aria-controls": $options.formattedId,
      onClick: _cache[3] || (_cache[3] = $event => $options.toggle()),
      onKeydown: _cache[4] || (_cache[4] = (...args) => $options.handleKeydown && $options.handleKeydown(...args)),
      type: "button"
    }, $props.buttonDataAttributes), [(Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.accordionSummaryElement), {
      class: "nebula-accordion__summary"
    }, {
      default: Object(external_vue_["withCtx"])(() => [_ctx.$slots.header ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", _hoisted_5, [$props.icon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
        key: 0,
        symbolId: $props.icon,
        class: "nebula-accordion-icon"
      }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["renderSlot"])(_ctx.$slots, "header")])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", _hoisted_6, [$props.icon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
        key: 0,
        symbolId: $props.icon,
        class: "nebula-accordion-icon"
      }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createTextVNode"])(" " + Object(external_vue_["toDisplayString"])($props.text), 1)])), Object(external_vue_["createVNode"])(_component_NebulaIcon, {
        size: "s",
        symbolId: "caret-down",
        class: "nebula-accordion-caret"
      })]),
      _: 3
    })), _ctx.$slots.preview ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", _hoisted_7, [Object(external_vue_["renderSlot"])(_ctx.$slots, "preview")])) : Object(external_vue_["createCommentVNode"])("", true)], 16, _hoisted_4)])), $options.showContent ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
      key: 2,
      ref: "contentEl",
      role: "region",
      class: Object(external_vue_["normalizeClass"])($options.contentClass),
      id: $options.formattedId,
      "aria-labelledby": `${$options.formattedId}-button`,
      style: Object(external_vue_["normalizeStyle"])({
        height: $data.expandHeight
      })
    }, [Object(external_vue_["createElementVNode"])("div", _hoisted_9, [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")], 512)], 14, _hoisted_8)) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 3
  }, 8, ["class", "style"]);
}
// CONCATENATED MODULE: ./src/components/Accordion/NebulaAccordion.vue?vue&type=template&id=0c3a48bd

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Button/NebulaButton.vue?vue&type=template&id=d0b54b94

const NebulaButtonvue_type_template_id_d0b54b94_hoisted_1 = ["aria-hidden"];
const NebulaButtonvue_type_template_id_d0b54b94_hoisted_2 = {
  key: 1,
  class: "nebula-button__badge-with-text"
};
function NebulaButtonvue_type_template_id_d0b54b94_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($options.buttonElement), Object(external_vue_["mergeProps"])({
    class: $options.buttonClassName,
    "aria-disabled": $props.isDisabled || $props.disabledLink || null,
    "aria-label": $props.ariaLabel ? $props.ariaLabel : null,
    target: $options.validTarget,
    type: $options.getButtonType,
    role: $options.buttonRole,
    tabindex: $props.disabledLink ? 0 : null
  }, { ...$options.parsedPath,
    ..._ctx.$attrs
  }, {
    style: _ctx.cssProps
  }), {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "slotIconLeft", {}, () => [$props.iconLeft ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
      key: 0,
      symbolId: $props.iconLeft,
      class: "nebula-button__icon"
    }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true)]), $props.text ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", {
      key: 0,
      class: "nebula-button__text",
      "aria-hidden": $props.ariaLabel ? 'true' : null
    }, Object(external_vue_["toDisplayString"])($props.text), 9, NebulaButtonvue_type_template_id_d0b54b94_hoisted_1)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["renderSlot"])(_ctx.$slots, "slotIconRight", {}, () => [$props.iconRight ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
      key: 0,
      symbolId: $props.iconRight,
      class: "nebula-button__icon"
    }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true)]), $options.hasBadgeWithText ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaButtonvue_type_template_id_d0b54b94_hoisted_2, [Object(external_vue_["renderSlot"])(_ctx.$slots, "badgeWithText")])) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 3
  }, 16, ["class", "aria-disabled", "aria-label", "target", "type", "role", "tabindex", "style"]);
}
// CONCATENATED MODULE: ./src/components/Button/NebulaButton.vue?vue&type=template&id=d0b54b94

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Icon/NebulaIcon.vue?vue&type=template&id=5feb93fc

const NebulaIconvue_type_template_id_5feb93fc_hoisted_1 = ["xlink:href"];
function NebulaIconvue_type_template_id_5feb93fc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("svg", {
    class: Object(external_vue_["normalizeClass"])($options.className),
    "aria-hidden": "true",
    focusable: "false"
  }, [Object(external_vue_["createElementVNode"])("use", {
    "xlink:href": $options.href
  }, null, 8, NebulaIconvue_type_template_id_5feb93fc_hoisted_1)], 2);
}
// CONCATENATED MODULE: ./src/components/Icon/NebulaIcon.vue?vue&type=template&id=5feb93fc

// EXTERNAL MODULE: ./node_modules/@discoveryedu/nebula-icons/nebula.svg
var nebula = __webpack_require__("8303");
var nebula_default = /*#__PURE__*/__webpack_require__.n(nebula);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Icon/NebulaIcon.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaIconvue_type_script_lang_js = ({
  name: 'NebulaIcon',
  computed: {
    className() {
      const className = ['nebula-icon', `nebula-icon--${this.size}`];
      return this.classOverride ? this.classOverride : className;
    },

    href() {
      if (this.spritePath) {
        return `${this.spritePath}#${this.symbolId}`;
      }

      return this.$nebulaSVGPath ? `${this.$nebulaSVGPath}#${this.symbolId}` : `${nebula_default.a}#${this.symbolId}`;
    }

  },
  props: {
    classOverride: {
      required: false,
      type: [String, Object, Array]
    },
    size: {
      default: 'm',
      // Nebula icons default to 24px
      required: false,
      type: String
    },
    spritePath: {
      default: null,
      type: String
    },
    symbolId: {
      required: true,
      type: String
    }
  }
});
// CONCATENATED MODULE: ./src/components/Icon/NebulaIcon.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Icon/NebulaIcon.vue?vue&type=style&index=0&id=5feb93fc&lang=stylus
var NebulaIconvue_type_style_index_0_id_5feb93fc_lang_stylus = __webpack_require__("0b85");

// EXTERNAL MODULE: ./node_modules/vue-loader-v16/dist/exportHelper.js
var exportHelper = __webpack_require__("6b0d");
var exportHelper_default = /*#__PURE__*/__webpack_require__.n(exportHelper);

// CONCATENATED MODULE: ./src/components/Icon/NebulaIcon.vue







const __exports__ = /*#__PURE__*/exportHelper_default()(NebulaIconvue_type_script_lang_js, [['render',NebulaIconvue_type_template_id_5feb93fc_render]])

/* harmony default export */ var NebulaIcon = (__exports__);
// CONCATENATED MODULE: ./src/utils/theming/themingUtils.js
/* harmony default export */ var themingUtils = ({
  props: {
    customStyles: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      // default to nebula
      // can be overridden by setting this value to a different namespace
      // use only for other brands/applications
      themePrefix: 'nebula'
    };
  },

  methods: {
    cssPropsCompute(customStyles, prefix = 'nebula', cb) {
      // if you need to do something fancy with the custom styles, just add it as
      // a function in the second argument.
      // See NebulaFeatureRow for example
      const customProps = {};

      if (customStyles) {
        // Loop through the customStyles object, and for each entry creates the css custom property and assigns it the value of the entry
        Object.entries(customStyles).forEach( // eslint-disable-next-line no-return-assign, prefer-destructuring
        entry => customProps[`--${prefix}-${entry[0].replace(/([A-Z])/g, g => `-${g[0].toLowerCase()}`)}`] = entry[1] // The regex here is converting the camelCase object keys to hyphen-case for use as css custom properties
        );
      }

      if (cb && typeof cb === 'function') {
        cb(customProps);
      }

      return customProps;
    }

  },
  computed: {
    cssProps() {
      return this.cssPropsCompute(this.customStyles, this.themePrefix);
    }

  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Button/NebulaButton.vue?vue&type=script&lang=js
/*
    Make sure there is no whitespace around
    the "{{ text }}" otherwise it will end up
    rendering the whitespace in the DOM and
    affect offset-based component calculations
    like the ones used in highlighting during
    rendering.
*/


/* harmony default export */ var NebulaButtonvue_type_script_lang_js = ({
  name: 'NebulaButton',
  components: {
    NebulaIcon: NebulaIcon
  },
  mixins: [themingUtils],
  props: {
    ariaLabel: {
      type: String,
      default: null
    },
    disabledLink: {
      type: Boolean,
      default: false
    },
    iconLeft: {
      type: String,
      default: null
    },
    iconRight: {
      type: String,
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isStatic: {
      type: Boolean,
      default: false
    },
    isSubmit: {
      type: Boolean,
      default: false
    },
    link: {
      type: [String, Object],
      default: ''
    },
    //
    // pushStateLink has been deprecated.
    // Prefer use of usePushState prop instead.
    //
    pushStateLink: {
      type: Boolean,
      default: false
    },
    role: {
      type: String,
      default: null
    },
    routerLink: {
      type: Boolean,
      default: false
    },
    shape: {
      type: String,
      default: 'square',
      enum: ['square', 'pill'] // for docs site

    },
    size: {
      type: String,
      default: 'm',
      enum: ['xs', 's', 'm', 'l']
    },
    target: {
      type: [String, Boolean],
      default: null,
      enum: ['_blank', '_self', '_parent', '_top'] // for docs site

    },
    text: {
      type: [String, Number],
      default: null
    },
    type: {
      type: String,
      default: 'fill',
      enum: ['fill', 'ghost', 'flat'] // for docs site

    },
    usePushState: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClassName() {
      const className = ['nebula-button', `nebula-button--${this.size}`, `nebula-button--${this.shape}`, `nebula-button--${this.type}`, {
        'nebula-button--icon-left': this.iconLeft || this.usesIconLeftSlot,
        'nebula-button--icon-right': this.iconRight || this.usesIconRightSlot,
        'nebula-button--icon-only': !this.text
      }];

      if (this.pushStateLink || this.usePushState) {
        className.push('do-push-state');
      } //
      //  TODO: Once pushStateLink is removed uncomment this in favor of the above condition.
      //
      // if (this.usePushState) {
      //     className.push('do-push-state');
      // }


      return className;
    },

    buttonElement() {
      return this.getButtonElement();
    },

    buttonRole() {
      if (this.role) {
        return this.role;
      }

      if (this.disabledLink) {
        return 'link';
      }

      return null;
    },

    getButtonType() {
      let type = 'button';

      if (this.isSubmit) {
        type = 'submit';
      }

      if (this.routerLink || this.link || this.disabledLink || this.isStatic) {
        type = null;
      }

      return type;
    },

    validTarget() {
      if (this.isDisabled || !this.target) {
        return null;
      }

      return this.target;
    },

    hasBadgeWithText() {
      return !!this.$slots.badgeWithText;
    },

    usesIconLeftSlot() {
      return !!this.$slots.slotIconLeft;
    },

    usesIconRightSlot() {
      return !!this.$slots.slotIconRight;
    },

    parsedPath() {
      const {
        link
      } = this;
      const buttonEl = this.getButtonElement();
      let parsedLink = {};

      if (this.disabledLink) {
        return parsedLink;
      }

      switch (buttonEl) {
        case 'a':
          parsedLink = {
            href: link
          };
          break;

        case 'routerLink':
          parsedLink = {
            to: link
          };
          break;

        default:
          break;
      }

      return parsedLink;
    }

  },
  methods: {
    getButtonElement() {
      let buttonElement = 'button';

      if (this.routerLink && !this.disabledLink) {
        buttonElement = 'routerLink';
      } else if (this.isStatic) {
        buttonElement = 'div';
      } else if (this.link || this.disabledLink) {
        buttonElement = 'a';
      }

      return buttonElement;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Button/NebulaButton.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Button/NebulaButton.vue?vue&type=style&index=0&id=d0b54b94&lang=stylus
var NebulaButtonvue_type_style_index_0_id_d0b54b94_lang_stylus = __webpack_require__("b440");

// CONCATENATED MODULE: ./src/components/Button/NebulaButton.vue







const NebulaButton_exports_ = /*#__PURE__*/exportHelper_default()(NebulaButtonvue_type_script_lang_js, [['render',NebulaButtonvue_type_template_id_d0b54b94_render]])

/* harmony default export */ var NebulaButton = (NebulaButton_exports_);
// CONCATENATED MODULE: ./src/utils/randomString.js
/* eslint-disable import/prefer-default-export */
function randomStringId(propValue) {
  if (propValue) {
    // truncating the passed id here in case it's very long
    return propValue.substring(0, 63);
  }

  return Math.random().toString(36).substring(2, 10);
}


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Accordion/NebulaAccordion.vue?vue&type=script&lang=js




/* harmony default export */ var NebulaAccordionvue_type_script_lang_js = ({
  name: 'NebulaAccordion',
  components: {
    NebulaButton: NebulaButton,
    NebulaIcon: NebulaIcon
  },
  mixins: [themingUtils],

  data() {
    return {
      contentElAnimation: null,
      isExpanded: false,
      expandHeight: 0
    };
  },

  props: {
    accordionSummaryElement: {
      type: String,
      default: 'div'
    },
    element: {
      type: String,
      default: 'section'
    },
    icon: {
      type: String
    },
    id: {
      type: [String, Number]
    },
    isExpandedOnLoad: {
      type: Boolean,
      default: false
    },
    menuItem: {
      type: [Array, Object],
      default: null
    },
    mode: {
      default: 'outline',
      type: String
    },
    text: {
      default: 'Accordion',
      type: String
    },
    buttonDataAttributes: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['accordion-action'],

  mounted() {
    if (this.isExpandedOnLoad || this.hasSubMenuItems && this.containsSelectedItem) {
      this.isExpanded = true;
      this.expandHeight = 'auto';
    }
  },

  computed: {
    buttonClass() {
      const className = ['nebula-accordion__button', {
        'nebula-accordion__button--expanded': this.isExpanded
      }];
      return className;
    },

    containsSelectedItem() {
      let containsSelectedItem = false;
      Object.keys(this.menuItem.items).forEach(key => {
        if (this.menuItem.items[key].selected) {
          containsSelectedItem = true;
        }
      });
      return containsSelectedItem;
    },

    contentClass() {
      const className = ['nebula-accordion__content', {
        'nebula-accordion__content--hidden': !this.isExpanded
      }];
      return className;
    },

    formattedId() {
      return randomStringId(this.$props.id);
    },

    hasSubMenuItems() {
      return this.menuItem && this.menuItem.items;
    },

    modeValid() {
      const supportedModes = ['outline', 'flat', 'ruled'];
      const selectedMode = this.$props.mode;

      if (supportedModes.includes(selectedMode)) {
        return selectedMode;
      }

      return 'outline';
    },

    modeClass() {
      return `nebula-accordion--${this.modeValid}`;
    },

    showContent() {
      if (this.menuItem && !this.menuItem.items) {
        return false;
      }

      return true;
    }

  },
  methods: {
    collapse() {
      this.toggle(false);
    },

    expand() {
      this.toggle(true);
    },

    getContentHeight() {
      return Math.ceil(this.$refs.contentContainer.getBoundingClientRect().height);
    },

    handleExpand() {
      if (!this.$refs.contentContainer) {
        // When there is no content in the accordion
        // i.e. the `contentContainer` does NOT exist,
        // the code for `getContentHeight()` fails.
        //
        // Since there is nothing to expand when there's
        // no content, we silently return from here.
        //
        // A prime example of this scenario is the
        // NebulaAccordion sink page, where the first few
        // examples do NOT have any content.
        //
        return;
      }

      const {
        isExpanded
      } = this;
      const expandedHeight = `${this.getContentHeight()}px`;

      if (isExpanded) {
        // Open accordion
        this.contentElAnimation = this.$refs.contentEl.animate({
          height: [0, expandedHeight]
        }, {
          easing: 'ease-in-out',
          duration: 250,
          iterations: 1
        });
      } else {
        // Close accordion
        this.contentElAnimation = this.$refs.contentEl.animate({
          height: [expandedHeight, 0]
        }, {
          easing: 'ease-in-out',
          duration: 250,
          iterations: 1
        });
      }

      this.contentElAnimation.onfinish = () => {
        // After the animation is finished, update the element's
        // style so the new height sticks
        if (isExpanded) {
          this.expandHeight = 'auto';
        } else {
          this.expandHeight = 0;
        }
      };
    },

    handleKeydown(e) {
      const handledKeys = ['ArrowUp', 'ArrowDown', 'End', 'Home'];
      const keyCode = e.code;

      if (!handledKeys.includes(keyCode)) {
        // bail if not a key we're handling
        return;
      }

      e.preventDefault();
      const directChildren = this.$el.parentNode.children;
      const filtered = Array.from(directChildren).filter(each => each.matches('.nebula-accordion'));
      const btnSelector = 'button.nebula-accordion__button';

      if (keyCode === 'ArrowUp' || keyCode === 'ArrowDown') {
        filtered.forEach((each, idx) => {
          each.setAttribute('data-index', idx);
        });
        const index = Number(this.$el.getAttribute('data-index') || '0');

        if (keyCode === 'ArrowUp') {
          if (index === 0) {
            filtered[filtered.length - 1].querySelector(btnSelector).focus();
          } else {
            filtered[index - 1].querySelector(btnSelector).focus();
          }
        }

        if (keyCode === 'ArrowDown') {
          if (index + 1 < filtered.length) {
            filtered[index + 1].querySelector(btnSelector).focus();
          } else {
            filtered[0].querySelector(btnSelector).focus();
          }
        }
      }

      if (keyCode === 'Home') {
        filtered[0].querySelector(btnSelector).focus();
      }

      if (keyCode === 'End') {
        filtered[filtered.length - 1].querySelector(btnSelector).focus();
      }
    },

    toggle(_expand = null) {
      let expand = null;

      if (_expand === null) {
        // A specific state was NOT provided.
        // Toggle the expanded state.
        expand = !this.isExpanded;
      } else {
        // A specific state WAS provided.
        // Convert to a boolean before processing
        // further.
        expand = !!_expand;
      }

      if (expand === this.isExpanded) {
        // There is no change in state.
        // DO NOT waste time processing this.
        return;
      } // Once we reach here, the state is set
      // to change.


      this.isExpanded = expand;
      /*--
          Fire off an event when an accordion opens or closes with the
          component as a parameter.
      --*/

      this.$emit('accordion-action', this); // Trip the dominoes to make the component
      // handle the new expand/collapse state.

      this.handleExpand();
    }

  }
});
// CONCATENATED MODULE: ./src/components/Accordion/NebulaAccordion.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Accordion/NebulaAccordion.vue?vue&type=style&index=0&id=0c3a48bd&lang=stylus
var NebulaAccordionvue_type_style_index_0_id_0c3a48bd_lang_stylus = __webpack_require__("b8f4");

// CONCATENATED MODULE: ./src/components/Accordion/NebulaAccordion.vue







const NebulaAccordion_exports_ = /*#__PURE__*/exportHelper_default()(NebulaAccordionvue_type_script_lang_js, [['render',render]])

/* harmony default export */ var NebulaAccordion = (NebulaAccordion_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ActionBar/NebulaActionBar.vue?vue&type=template&id=b8afe756

const NebulaActionBarvue_type_template_id_b8afe756_hoisted_1 = {
  class: "nebula-action-bar__group"
};
const NebulaActionBarvue_type_template_id_b8afe756_hoisted_2 = {
  key: 0,
  class: "nebula-action-bar__button--back"
};
const NebulaActionBarvue_type_template_id_b8afe756_hoisted_3 = {
  key: 0,
  class: "nebula-action-bar__title-grid-inner"
};
const NebulaActionBarvue_type_template_id_b8afe756_hoisted_4 = {
  class: "nebula-action-bar__title"
};

const NebulaActionBarvue_type_template_id_b8afe756_hoisted_5 = /*#__PURE__*/Object(external_vue_["createElementVNode"])("span", {
  class: "nebula-action-bar__pipe",
  "aria-hidden": "true"
}, "|", -1);

const NebulaActionBarvue_type_template_id_b8afe756_hoisted_6 = {
  class: "nebula-action-bar__breadcrumbs"
};
const NebulaActionBarvue_type_template_id_b8afe756_hoisted_7 = ["href"];
const NebulaActionBarvue_type_template_id_b8afe756_hoisted_8 = {
  class: "nebula-action-bar__tabs"
};
const NebulaActionBarvue_type_template_id_b8afe756_hoisted_9 = {
  key: 3,
  class: "nebula-action-bar__tabs"
};
const _hoisted_10 = {
  key: 0,
  class: "nebula-action-bar__title"
};
const _hoisted_11 = {
  class: "nebula-action-bar__group"
};
const _hoisted_12 = {
  key: 1,
  class: "responsive-actions-area"
};
const _hoisted_13 = {
  class: "responsive-actions-area__content"
};
const _hoisted_14 = {
  class: "responsive-actions-area__dropdown-list"
};
const _hoisted_15 = {
  key: 0,
  class: "responsive-actions-area__buttons-container"
};
const _hoisted_16 = {
  class: "responsive-actions-area__dropdown-list"
};
const _hoisted_17 = {
  key: 0,
  class: "responsive-actions-area__buttons-container"
};
const _hoisted_18 = {
  key: 1,
  class: "responsive-actions-area__buttons-container"
};
const _hoisted_19 = {
  class: "responsive-actions-area__buttons-container"
};
const _hoisted_20 = {
  key: 2,
  class: "nebula-action-bar__actions-area"
};
const _hoisted_21 = {
  key: 0,
  class: "nebula-action-bar__buttons-container"
};
const _hoisted_22 = {
  key: 3,
  class: "nebula-action-bar__buttons-container"
};
const _hoisted_23 = {
  key: 3,
  class: "nebula-action-bar__avatar"
};
const _hoisted_24 = ["src", "alt"];
function NebulaActionBarvue_type_template_id_b8afe756_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaBreadcrumbs = Object(external_vue_["resolveComponent"])("NebulaBreadcrumbs");

  const _component_NebulaImage = Object(external_vue_["resolveComponent"])("NebulaImage");

  const _component_NebulaTabs = Object(external_vue_["resolveComponent"])("NebulaTabs");

  const _component_NebulaDropdownPagination = Object(external_vue_["resolveComponent"])("NebulaDropdownPagination");

  const _component_NebulaDropdownItem = Object(external_vue_["resolveComponent"])("NebulaDropdownItem");

  const _component_NebulaDropdown = Object(external_vue_["resolveComponent"])("NebulaDropdown");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])(["nebula-action-bar", $options.outerWrapperClasses]),
    ref: "actionBarContainer"
  }, [Object(external_vue_["createElementVNode"])("div", NebulaActionBarvue_type_template_id_b8afe756_hoisted_1, [$props.backButton && $props.backButton.isEnabled ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaActionBarvue_type_template_id_b8afe756_hoisted_2, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
    "aria-label": _ctx.$t('Back'),
    link: $props.backButton.url,
    routerLink: $props.backButton.routerLink,
    type: "flat",
    "icon-right": "arrow-left",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('onBackButtonClick'))
  }, null, 8, ["aria-label", "link", "routerLink"])])) : Object(external_vue_["createCommentVNode"])("", true), $props.breadcrumbs && $props.breadcrumbs.length ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    key: 1,
    class: Object(external_vue_["normalizeClass"])($options.getWrapperClass)
  }, [$props.title ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaActionBarvue_type_template_id_b8afe756_hoisted_3, [Object(external_vue_["createElementVNode"])("h3", NebulaActionBarvue_type_template_id_b8afe756_hoisted_4, Object(external_vue_["toDisplayString"])($props.title), 1), NebulaActionBarvue_type_template_id_b8afe756_hoisted_5])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaActionBarvue_type_template_id_b8afe756_hoisted_6, [Object(external_vue_["createVNode"])(_component_NebulaBreadcrumbs, {
    breadcrumbs: $props.breadcrumbs,
    actionBar: "",
    actionBarWithBack: $props.backButton && $props.backButton.isEnabled,
    actionBarWithTitle: $props.title !== null,
    dropdownUseRouterLinks: $props.breadcrumbDropdownUseRouterLinks,
    responsivePageWidthThreshold: $props.responsiveBreadcrumbsPageWidthThreshold,
    showDimText: $props.showDimText
  }, null, 8, ["breadcrumbs", "actionBarWithBack", "actionBarWithTitle", "dropdownUseRouterLinks", "responsivePageWidthThreshold", "showDimText"])])], 2)) : $options.hasMenuSlot ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    key: 2,
    class: Object(external_vue_["normalizeClass"])(['nebula-action-bar__menu-container', !$props.logoConfig && 'nebula-action-bar__menu-container--no-logo'])
  }, [$props.logoConfig && $props.logoConfig.logoLink ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("a", {
    key: 0,
    href: $props.logoConfig.logoLink
  }, [Object(external_vue_["createVNode"])(_component_NebulaImage, Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])($props.logoConfig)), null, 16)], 8, NebulaActionBarvue_type_template_id_b8afe756_hoisted_7)) : $props.logoConfig ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaImage, Object(external_vue_["normalizeProps"])(Object(external_vue_["mergeProps"])({
    key: 1
  }, $props.logoConfig)), null, 16)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaActionBarvue_type_template_id_b8afe756_hoisted_8, [Object(external_vue_["renderSlot"])(_ctx.$slots, "menu")])], 2)) : $props.tabs ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaActionBarvue_type_template_id_b8afe756_hoisted_9, [Object(external_vue_["createVNode"])(_component_NebulaTabs, {
    noBorderBottom: $props.hideTabBorders,
    tabs: $props.tabs
  }, null, 8, ["noBorderBottom", "tabs"])])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    key: 4,
    class: Object(external_vue_["normalizeClass"])(["nebula-action-bar__title-grid--title-only", $options.getWrapperClass])
  }, [$props.title ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("h3", _hoisted_10, Object(external_vue_["toDisplayString"])($props.title), 1)) : Object(external_vue_["createCommentVNode"])("", true)], 2))]), Object(external_vue_["createElementVNode"])("div", _hoisted_11, [$props.paging ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdownPagination, {
    key: 0,
    "link-generator": $options.linkGenerator,
    onSelectPage: $options.selectNextPage
  }, null, 8, ["link-generator", "onSelectPage"])) : Object(external_vue_["createCommentVNode"])("", true), $data.showResponsiveActionsView ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", _hoisted_12, [$props.dropdownItems ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdown, {
    key: 0,
    buttonType: "actionBar",
    contentElement: "div",
    useWhiteBackground: ""
  }, {
    trigger: Object(external_vue_["withCtx"])(({
      toggleDropdown,
      checkArrowKeyOnTrigger,
      checkArrowKeyAfterTrigger,
      isOpen
    }) => [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      class: "nebula-action-bar__ellipses",
      "aria-controls": $options.getDropdownMenuId,
      "aria-expanded": isOpen && 'true' || 'false',
      "aria-haspopup": "true",
      "aria-label": _ctx.$t('open more actions menu'),
      onClick: toggleDropdown,
      onKeydown: checkArrowKeyOnTrigger,
      onKeyup: checkArrowKeyAfterTrigger
    }, null, 8, ["aria-controls", "aria-expanded", "aria-label", "onClick", "onKeydown", "onKeyup"])]),
    content: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("div", _hoisted_13, [Object(external_vue_["createElementVNode"])("div", _hoisted_14, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.parsedItems, (item, index) => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdownItem, Object(external_vue_["mergeProps"])({
        key: index
      }, item), null, 16);
    }), 128))]), $options.hasActionBarButtonsSlot ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", _hoisted_15, [Object(external_vue_["renderSlot"])(_ctx.$slots, "actionBarButtons")])) : Object(external_vue_["createCommentVNode"])("", true)])]),
    _: 3
  })) : $options.hasDropdownItemsSlot ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdown, {
    key: 1,
    contentElement: "div",
    buttonId: $options.getDropdownButtonId,
    dropdownId: $options.getDropdownMenuId,
    useWhiteBackground: ""
  }, {
    trigger: Object(external_vue_["withCtx"])(({
      toggleDropdown,
      checkArrowKeyOnTrigger,
      checkArrowKeyAfterTrigger,
      isOpen
    }) => [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      class: "nebula-action-bar__ellipses",
      iconLeft: "ellipses-vertical",
      id: $options.getDropdownButtonId,
      shape: "square",
      size: "s",
      type: "flat",
      "aria-controls": $options.getDropdownMenuId,
      "aria-expanded": isOpen && 'true' || 'false',
      "aria-haspopup": "true",
      "aria-label": _ctx.$t('open more actions menu'),
      onClick: toggleDropdown,
      onKeydown: checkArrowKeyOnTrigger,
      onKeyup: checkArrowKeyAfterTrigger
    }, null, 8, ["id", "aria-controls", "aria-expanded", "aria-label", "onClick", "onKeydown", "onKeyup"])]),
    content: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("ul", _hoisted_16, [Object(external_vue_["renderSlot"])(_ctx.$slots, "dropdownItems")]), $options.hasResponsiveActionButtonsSlot ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", _hoisted_17, [Object(external_vue_["renderSlot"])(_ctx.$slots, "responsiveActionButtons")])) : $options.hasActionBarButtonsSlot && !$options.hasResponsiveActionButtonsSlot ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", _hoisted_18, [Object(external_vue_["renderSlot"])(_ctx.$slots, "actionBarButtons")])) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 3
  }, 8, ["buttonId", "dropdownId"])) : !$props.dropdownItems && !$options.hasDropdownItemsSlot && $options.hasActionBarButtonsSlot ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdown, {
    key: 2,
    buttonType: "actionBar",
    contentElement: "div",
    useWhiteBackground: ""
  }, {
    content: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("div", _hoisted_19, [Object(external_vue_["renderSlot"])(_ctx.$slots, "actionBarButtons")])]),
    _: 3
  })) : Object(external_vue_["createCommentVNode"])("", true)])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", _hoisted_20, [$options.showActionMenuPositionFirst ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", _hoisted_21, [Object(external_vue_["renderSlot"])(_ctx.$slots, "actionBarButtons")])) : Object(external_vue_["createCommentVNode"])("", true), $props.dropdownItems ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdown, {
    key: 1,
    buttonType: "actionBar",
    items: $props.dropdownItems,
    actions: $props.dropdownActions,
    ariaLabel: _ctx.$t('open more actions menu'),
    useWhiteBackground: ""
  }, null, 8, ["items", "actions", "ariaLabel"])) : $options.hasDropdownItemsSlot ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdown, {
    key: 2,
    buttonId: $options.getDropdownButtonId,
    dropdownId: $options.getDropdownMenuId,
    useWhiteBackground: ""
  }, {
    trigger: Object(external_vue_["withCtx"])(({
      toggleDropdown,
      checkArrowKeyOnTrigger,
      checkArrowKeyAfterTrigger,
      isOpen
    }) => [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      class: "nebula-action-bar__ellipses",
      iconLeft: "ellipses-vertical",
      id: $options.getDropdownButtonId,
      shape: "square",
      size: "s",
      type: "flat",
      "aria-controls": $options.getDropdownMenuId,
      "aria-expanded": isOpen && 'true' || 'false',
      "aria-haspopup": "true",
      "aria-label": _ctx.$t('open more actions menu'),
      onClick: toggleDropdown,
      onKeydown: checkArrowKeyOnTrigger,
      onKeyup: checkArrowKeyAfterTrigger
    }, null, 8, ["id", "aria-controls", "aria-expanded", "aria-label", "onClick", "onKeydown", "onKeyup"])]),
    content: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "dropdownItems")]),
    _: 3
  }, 8, ["buttonId", "dropdownId"])) : Object(external_vue_["createCommentVNode"])("", true), $options.showActionMenuPositionLast ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", _hoisted_22, [Object(external_vue_["renderSlot"])(_ctx.$slots, "actionBarButtons")])) : Object(external_vue_["createCommentVNode"])("", true)])), Object(external_vue_["renderSlot"])(_ctx.$slots, "buttons"), $props.profileAvatar ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", _hoisted_23, [Object(external_vue_["createElementVNode"])("img", {
    class: "nebula-action-bar__avatar-image",
    src: $props.profileAvatar.link,
    alt: _ctx.$t('An image representing the current user.')
  }, null, 8, _hoisted_24)])) : Object(external_vue_["createCommentVNode"])("", true)])], 2);
}
// CONCATENATED MODULE: ./src/components/ActionBar/NebulaActionBar.vue?vue&type=template&id=b8afe756

// CONCATENATED MODULE: ./node_modules/lodash-es/isObject.js
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ var lodash_es_isObject = (isObject);

// EXTERNAL MODULE: ./node_modules/lodash-es/_root.js
var _root = __webpack_require__("26ee");

// CONCATENATED MODULE: ./node_modules/lodash-es/now.js


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return _root["a" /* default */].Date.now();
};

/* harmony default export */ var lodash_es_now = (now);

// CONCATENATED MODULE: ./node_modules/lodash-es/_trimmedEndIndex.js
/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/* harmony default export */ var _trimmedEndIndex = (trimmedEndIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseTrim.js


/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, _trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

/* harmony default export */ var _baseTrim = (baseTrim);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var _Symbol_Symbol = _root["a" /* default */].Symbol;

/* harmony default export */ var _Symbol = (_Symbol_Symbol);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = (baseGetTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);

// CONCATENATED MODULE: ./node_modules/lodash-es/isSymbol.js



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (lodash_es_isObjectLike(value) && _baseGetTag(value) == symbolTag);
}

/* harmony default export */ var lodash_es_isSymbol = (isSymbol);

// CONCATENATED MODULE: ./node_modules/lodash-es/toNumber.js




/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (lodash_es_isSymbol(value)) {
    return NAN;
  }
  if (lodash_es_isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = lodash_es_isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = _baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ var lodash_es_toNumber = (toNumber);

// CONCATENATED MODULE: ./node_modules/lodash-es/debounce.js




/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = lodash_es_toNumber(wait) || 0;
  if (lodash_es_isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(lodash_es_toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = lodash_es_now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(lodash_es_now());
  }

  function debounced() {
    var time = lodash_es_now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* harmony default export */ var lodash_es_debounce = (debounce);

// CONCATENATED MODULE: ./node_modules/lodash-es/throttle.js



/** Error message constants. */
var throttle_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(throttle_FUNC_ERROR_TEXT);
  }
  if (lodash_es_isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return lodash_es_debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/* harmony default export */ var lodash_es_throttle = (throttle);

// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__("6dd8");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Breadcrumbs/NebulaBreadcrumbs.vue?vue&type=template&id=70094768

const NebulaBreadcrumbsvue_type_template_id_70094768_hoisted_1 = {
  class: "nebula-breadcrumbs__outer"
};
const NebulaBreadcrumbsvue_type_template_id_70094768_hoisted_2 = {
  class: "nebula-breadcrumbs__responsive-menu"
};
const NebulaBreadcrumbsvue_type_template_id_70094768_hoisted_3 = ["aria-label", "id"];
const NebulaBreadcrumbsvue_type_template_id_70094768_hoisted_4 = {
  class: "nebula-breadcrumbs__list"
};
const NebulaBreadcrumbsvue_type_template_id_70094768_hoisted_5 = {
  key: 0,
  class: "nebula-breadcrumbs__dropdown-container"
};
const NebulaBreadcrumbsvue_type_template_id_70094768_hoisted_6 = ["href"];
const NebulaBreadcrumbsvue_type_template_id_70094768_hoisted_7 = {
  key: 4,
  class: "nebula-breadcrumbs__icon-container"
};
function NebulaBreadcrumbsvue_type_template_id_70094768_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaBreadcrumbDropdownButton = Object(external_vue_["resolveComponent"])("NebulaBreadcrumbDropdownButton");

  const _component_NebulaListItem = Object(external_vue_["resolveComponent"])("NebulaListItem");

  const _component_NebulaListgroup = Object(external_vue_["resolveComponent"])("NebulaListgroup");

  const _component_NebulaDropdown = Object(external_vue_["resolveComponent"])("NebulaDropdown");

  const _component_router_link = Object(external_vue_["resolveComponent"])("router-link");

  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaBreadcrumbsvue_type_template_id_70094768_hoisted_1, [$data.responsiveMenuView ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdown, {
    key: 0,
    buttonId: $options.getResponsiveDropdownButtonId,
    dropdownId: $options.getResponsiveDropdownMenuId,
    class: "nebula-breadcrumbs__responsive-dropdown",
    id: $options.getResponsiveDropdownId,
    alignToButtonStart: "",
    contentElement: "div",
    useWhiteBackground: ""
  }, {
    trigger: Object(external_vue_["withCtx"])(({
      toggleDropdown,
      checkArrowKeyOnTrigger,
      checkArrowKeyAfterTrigger,
      isOpen
    }) => [Object(external_vue_["createVNode"])(_component_NebulaBreadcrumbDropdownButton, {
      id: $options.getResponsiveDropdownButtonId,
      "aria-haspopup": "true",
      "aria-expanded": isOpen && 'true' || 'false',
      "aria-controls": $options.getResponsiveDropdownMenuId,
      text: $options.breadcrumbsDropdownList ? $options.getDropdownSelectedItemText($options.breadcrumbsDropdownList) : $options.getLastBreadcrumbItem.text,
      onClick: toggleDropdown,
      onKeydown: checkArrowKeyOnTrigger,
      onKeyup: checkArrowKeyAfterTrigger,
      "aria-label": !$options.breadcrumbsDropdownList ? _ctx.$t('open breadcrumbs menu') : null
    }, null, 8, ["id", "aria-expanded", "aria-controls", "text", "onClick", "onKeydown", "onKeyup", "aria-label"])]),
    content: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("div", NebulaBreadcrumbsvue_type_template_id_70094768_hoisted_2, [$options.breadcrumbsExcludeDropdown.length > 0 ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaListgroup, {
      key: 0,
      class: "nebula-breadcrumbs__responsive-listgroup",
      nested: ""
    }, {
      content: Object(external_vue_["withCtx"])(() => [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.breadcrumbsExcludeDropdown, (item, i) => {
        return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaListItem, {
          key: i,
          text: item.text,
          link: !$props.dropdownUseRouterLinks ? item.link : null,
          routerLink: $props.dropdownUseRouterLinks ? item.link : null,
          icon: "arrow-left-circle",
          iconSize: "s",
          badgeColor: $props.showDimText && item.dim_text !== '' ? 'light-gray' : null,
          badgeText: $props.showDimText && item.dim_text !== '' ? item.dim_text : null
        }, null, 8, ["text", "link", "routerLink", "badgeColor", "badgeText"]);
      }), 128))]),
      _: 1
    })) : Object(external_vue_["createCommentVNode"])("", true), $options.breadcrumbsDropdownList ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaListgroup, {
      key: 1,
      class: "nebula-breadcrumbs__responsive-listgroup",
      nested: "",
      header: $props.responsiveBreadcrumbDropdownHeader
    }, {
      content: Object(external_vue_["withCtx"])(() => [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.breadcrumbsDropdownList, (item, i) => {
        return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaListItem, {
          key: i,
          link: !$props.dropdownUseRouterLinks ? item.link : null,
          routerLink: $props.dropdownUseRouterLinks ? item.link : null,
          text: item.text,
          badgeColor: $props.showDimText && item.dim_text !== '' ? 'light-gray' : null,
          badgeText: $props.showDimText && item.dim_text !== '' ? item.dim_text : null,
          isSelected: item.selected
        }, null, 8, ["link", "routerLink", "text", "badgeColor", "badgeText", "isSelected"]);
      }), 128))]),
      _: 1
    }, 8, ["header"])) : Object(external_vue_["createCommentVNode"])("", true)])]),
    _: 1
  }, 8, ["buttonId", "dropdownId", "id"])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("nav", {
    key: 1,
    "aria-label": $options.getAriaLabel,
    class: "nebula-breadcrumbs",
    id: $options.getBreadcrumbsId
  }, [Object(external_vue_["createElementVNode"])("ol", NebulaBreadcrumbsvue_type_template_id_70094768_hoisted_4, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.breadcrumbs, (item, i) => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
      key: i,
      class: Object(external_vue_["normalizeClass"])($options.breadcrumbsItemClassName(i))
    }, [item.dropdown ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaBreadcrumbsvue_type_template_id_70094768_hoisted_5, [Object(external_vue_["createVNode"])(_component_NebulaDropdown, {
      alignToButtonStart: "",
      buttonId: $options.getDropdownButtonId,
      iconTransition: $props.dropdownUseIconTransition,
      dropdownId: $options.getDropdownMenuId,
      useWhiteBackground: ""
    }, {
      trigger: Object(external_vue_["withCtx"])(({
        toggleDropdown,
        checkArrowKeyOnTrigger,
        checkArrowKeyAfterTrigger,
        isOpen
      }) => [Object(external_vue_["createVNode"])(_component_NebulaBreadcrumbDropdownButton, {
        id: $options.getDropdownButtonId,
        "aria-haspopup": "true",
        "aria-controls": $options.getDropdownMenuId,
        "aria-expanded": isOpen && 'true' || 'false',
        text: $options.getDropdownSelectedItemText(item.dropdown),
        onClick: toggleDropdown,
        onKeydown: checkArrowKeyOnTrigger,
        onKeyup: checkArrowKeyAfterTrigger
      }, null, 8, ["id", "aria-controls", "aria-expanded", "text", "onClick", "onKeydown", "onKeyup"])]),
      content: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaListgroup, {
        nested: "",
        header: $props.responsiveBreadcrumbDropdownHeader
      }, {
        content: Object(external_vue_["withCtx"])(() => [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(item.dropdown, dropdownItem => {
          return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaListItem, {
            key: dropdownItem.text,
            link: !$props.dropdownUseRouterLinks ? dropdownItem.link : null,
            routerLink: $props.dropdownUseRouterLinks ? dropdownItem.link : null,
            isSelected: dropdownItem.selected,
            badgeColor: $props.showDimText && dropdownItem.dim_text !== '' ? 'light-gray' : null,
            badgeText: $props.showDimText && dropdownItem.dim_text !== '' ? dropdownItem.dim_text : null,
            text: dropdownItem.text
          }, null, 8, ["link", "routerLink", "isSelected", "badgeColor", "badgeText", "text"]);
        }), 128))]),
        _: 2
      }, 1032, ["header"])]),
      _: 2
    }, 1032, ["buttonId", "iconTransition", "dropdownId"])])) : $options.isCurrentBreadcrumb(i) && !item.dropdown ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", {
      key: 1,
      style: Object(external_vue_["normalizeStyle"])($options.getBreadcrumbItemMinWidth),
      class: "nebula-breadcrumbs__item-inner nebula-breadcrumbs__item-inner--current"
    }, Object(external_vue_["toDisplayString"])(item.text), 5)) : !$options.isCurrentBreadcrumb(i) && $props.dropdownUseRouterLinks ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_router_link, {
      key: 2,
      to: item.link,
      style: Object(external_vue_["normalizeStyle"])($options.getBreadcrumbItemMinWidth),
      class: "nebula-breadcrumbs__link nebula-breadcrumbs__item-inner"
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(item.text), 1)]),
      _: 2
    }, 1032, ["to", "style"])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("a", {
      key: 3,
      href: item.link,
      style: Object(external_vue_["normalizeStyle"])($options.getBreadcrumbItemMinWidth),
      class: "nebula-breadcrumbs__link nebula-breadcrumbs__item-inner"
    }, Object(external_vue_["toDisplayString"])(item.text), 13, NebulaBreadcrumbsvue_type_template_id_70094768_hoisted_6)), !$options.isCurrentBreadcrumb(i) ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", NebulaBreadcrumbsvue_type_template_id_70094768_hoisted_7, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      class: "nebula-breadcrumbs__icon",
      symbolId: "caret-right",
      size: "s"
    })])) : Object(external_vue_["createCommentVNode"])("", true)], 2);
  }), 128))])], 8, NebulaBreadcrumbsvue_type_template_id_70094768_hoisted_3))]);
}
// CONCATENATED MODULE: ./src/components/Breadcrumbs/NebulaBreadcrumbs.vue?vue&type=template&id=70094768

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Breadcrumbs/NebulaBreadcrumbsDropdownButton.vue?vue&type=template&id=2fd34e2e

const NebulaBreadcrumbsDropdownButtonvue_type_template_id_2fd34e2e_hoisted_1 = {
  class: "nebula-breadcrumbs__dropdown-button"
};
const NebulaBreadcrumbsDropdownButtonvue_type_template_id_2fd34e2e_hoisted_2 = {
  key: 0,
  class: "nebula-button__text"
};
const NebulaBreadcrumbsDropdownButtonvue_type_template_id_2fd34e2e_hoisted_3 = {
  class: "nebula-button__icon-container"
};
function NebulaBreadcrumbsDropdownButtonvue_type_template_id_2fd34e2e_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", NebulaBreadcrumbsDropdownButtonvue_type_template_id_2fd34e2e_hoisted_1, [$props.text ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", NebulaBreadcrumbsDropdownButtonvue_type_template_id_2fd34e2e_hoisted_2, Object(external_vue_["toDisplayString"])($props.text), 1)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("span", NebulaBreadcrumbsDropdownButtonvue_type_template_id_2fd34e2e_hoisted_3, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
    class: "nebula-button__icon",
    size: "s",
    symbolId: $props.iconRight
  }, null, 8, ["symbolId"])])]);
}
// CONCATENATED MODULE: ./src/components/Breadcrumbs/NebulaBreadcrumbsDropdownButton.vue?vue&type=template&id=2fd34e2e

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Breadcrumbs/NebulaBreadcrumbsDropdownButton.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaBreadcrumbsDropdownButtonvue_type_script_lang_js = ({
  name: 'NebulaBreadcrumbDropdownButton',
  components: {
    NebulaIcon: NebulaIcon
  },
  props: {
    iconRight: {
      type: String,
      default: 'caret-down'
    },
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./src/components/Breadcrumbs/NebulaBreadcrumbsDropdownButton.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Breadcrumbs/NebulaBreadcrumbsDropdownButton.vue?vue&type=style&index=0&id=2fd34e2e&lang=stylus
var NebulaBreadcrumbsDropdownButtonvue_type_style_index_0_id_2fd34e2e_lang_stylus = __webpack_require__("5830");

// CONCATENATED MODULE: ./src/components/Breadcrumbs/NebulaBreadcrumbsDropdownButton.vue







const NebulaBreadcrumbsDropdownButton_exports_ = /*#__PURE__*/exportHelper_default()(NebulaBreadcrumbsDropdownButtonvue_type_script_lang_js, [['render',NebulaBreadcrumbsDropdownButtonvue_type_template_id_2fd34e2e_render]])

/* harmony default export */ var NebulaBreadcrumbsDropdownButton = (NebulaBreadcrumbsDropdownButton_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Dropdown/NebulaDropdown.vue?vue&type=template&id=14cec1d8

const NebulaDropdownvue_type_template_id_14cec1d8_hoisted_1 = ["id", "aria-hidden", "aria-labelledby"];
function NebulaDropdownvue_type_template_id_14cec1d8_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaDropdownItem = Object(external_vue_["resolveComponent"])("NebulaDropdownItem");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.dropdownElement), {
    class: Object(external_vue_["normalizeClass"])($options.dropdownClassName),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, {
    default: Object(external_vue_["withCtx"])(() => [$options.usesTriggerSlot ? Object(external_vue_["renderSlot"])(_ctx.$slots, "trigger", {
      key: 0,
      id: $options.formattedId,
      toggleDropdown: _ctx.toggleDropdown,
      checkArrowKeyOnTrigger: _ctx.checkArrowKeyOnTrigger,
      checkArrowKeyAfterTrigger: _ctx.checkArrowKeyAfterTrigger,
      isOpen: $data.dropdownOpen
    }) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, Object(external_vue_["mergeProps"])({
      key: 1
    }, $options.buttonProps, {
      id: $options.formattedId,
      "aria-label": $props.ariaLabel,
      "aria-expanded": `${$data.dropdownOpen}`,
      "aria-controls": $options.childId,
      "aria-haspopup": "true",
      onClick: _ctx.toggleDropdown,
      onKeydown: _ctx.checkArrowKeyOnTrigger,
      onKeyup: _ctx.checkArrowKeyAfterTrigger
    }), null, 16, ["id", "aria-label", "aria-expanded", "aria-controls", "onClick", "onKeydown", "onKeyup"])), $props.items ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("ul", {
      key: 2,
      class: "nebula-dropdown__content",
      id: $options.childId,
      "aria-hidden": !$data.dropdownOpen,
      "aria-labelledby": $options.formattedId,
      onKeyup: _cache[0] || (_cache[0] = (...args) => _ctx.checkKeyup && _ctx.checkKeyup(...args)),
      onKeydown: _cache[1] || (_cache[1] = (...args) => _ctx.checkKeydown && _ctx.checkKeydown(...args)),
      ref: "dropdownContent",
      role: "menu"
    }, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.parsedItems, (item, index) => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdownItem, Object(external_vue_["mergeProps"])({
        onDropdownItemClicked: _ctx.handleItemClick,
        key: index
      }, item), null, 16, ["onDropdownItemClicked"]);
    }), 128))], 40, NebulaDropdownvue_type_template_id_14cec1d8_hoisted_1)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($options.element), {
      key: 3,
      class: "nebula-dropdown__content",
      id: $props.dropdownId ? $props.dropdownId : $options.childId,
      "aria-hidden": !$data.dropdownOpen,
      "aria-labelledby": $options.formattedId,
      onKeyup: _ctx.checkKeyup,
      onKeydown: _ctx.checkKeydown,
      ref: "dropdownContent",
      role: $props.role
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "content", {
        toggleDropdown: _ctx.toggleDropdown
      })]),
      _: 3
    }, 40, ["id", "aria-hidden", "aria-labelledby", "onKeyup", "onKeydown", "role"]))]),
    _: 3
  }, 8, ["class", "style"]);
}
// CONCATENATED MODULE: ./src/components/Dropdown/NebulaDropdown.vue?vue&type=template&id=14cec1d8

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Dropdown/NebulaDropdownItem.vue?vue&type=template&id=33408c85

const NebulaDropdownItemvue_type_template_id_33408c85_hoisted_1 = {
  class: "nebula-dropdown-item__text"
};
const NebulaDropdownItemvue_type_template_id_33408c85_hoisted_2 = ["aria-label", "href", "id", "role", "target"];
const NebulaDropdownItemvue_type_template_id_33408c85_hoisted_3 = {
  class: "nebula-dropdown-item__text"
};
const NebulaDropdownItemvue_type_template_id_33408c85_hoisted_4 = {
  key: 2,
  class: "nebula-dropdown-item__inner nebula-dropdown-item__inner--heading"
};
const NebulaDropdownItemvue_type_template_id_33408c85_hoisted_5 = {
  class: "nebula-dropdown-item__text"
};
const NebulaDropdownItemvue_type_template_id_33408c85_hoisted_6 = ["aria-label", "id", "role", "aria-selected"];
const NebulaDropdownItemvue_type_template_id_33408c85_hoisted_7 = {
  class: "nebula-dropdown-item__text"
};
function NebulaDropdownItemvue_type_template_id_33408c85_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  const _component_router_link = Object(external_vue_["resolveComponent"])("router-link");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
    class: Object(external_vue_["normalizeClass"])(["nebula-dropdown__item", $props.isSelected ? 'nebula-dropdown__item--selected' : null]),
    role: "presentation"
  }, [$props.routerLink ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_router_link, Object(external_vue_["mergeProps"])({
    key: 0,
    "aria-label": $props.ariaLabel ? $props.ariaLabel : null,
    to: $props.routerLink,
    class: "nebula-dropdown-item__inner nebula-dropdown-item__inner--router-link",
    id: $props.navElementId,
    role: $props.role
  }, $props.trackingData), {
    default: Object(external_vue_["withCtx"])(() => [$props.icon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
      key: 0,
      symbolId: $props.icon,
      class: "nebula-dropdown-item__icon"
    }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("span", NebulaDropdownItemvue_type_template_id_33408c85_hoisted_1, Object(external_vue_["toDisplayString"])($props.text), 1)]),
    _: 1
  }, 16, ["aria-label", "to", "id", "role"])) : $props.link ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("a", Object(external_vue_["mergeProps"])({
    key: 1,
    "aria-label": $props.ariaLabel ? $props.ariaLabel : null,
    href: $props.link,
    class: "nebula-dropdown-item__inner nebula-dropdown-item__inner--link",
    id: $props.navElementId,
    role: $props.role,
    target: $props.target
  }, $props.trackingData), [$props.icon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
    key: 0,
    symbolId: $props.icon,
    class: "nebula-dropdown-item__icon"
  }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("span", NebulaDropdownItemvue_type_template_id_33408c85_hoisted_3, Object(external_vue_["toDisplayString"])($props.text), 1)], 16, NebulaDropdownItemvue_type_template_id_33408c85_hoisted_2)) : $props.heading ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaDropdownItemvue_type_template_id_33408c85_hoisted_4, [$props.icon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
    key: 0,
    symbolId: $props.icon,
    class: "nebula-dropdown-item__icon"
  }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("span", NebulaDropdownItemvue_type_template_id_33408c85_hoisted_5, Object(external_vue_["toDisplayString"])($props.text), 1)])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", {
    key: 3,
    "aria-label": $props.ariaLabel ? $props.ariaLabel : null,
    class: "nebula-dropdown-item__inner",
    id: $props.navElementId,
    role: $props.role,
    "aria-selected": $options.isAriaSelected,
    type: "button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleClick && $options.handleClick(...args))
  }, [$props.icon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
    key: 0,
    symbolId: $props.icon,
    class: "nebula-dropdown-item__icon"
  }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("span", NebulaDropdownItemvue_type_template_id_33408c85_hoisted_7, Object(external_vue_["toDisplayString"])($props.text), 1)], 8, NebulaDropdownItemvue_type_template_id_33408c85_hoisted_6))], 2);
}
// CONCATENATED MODULE: ./src/components/Dropdown/NebulaDropdownItem.vue?vue&type=template&id=33408c85

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Dropdown/NebulaDropdownItem.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaDropdownItemvue_type_script_lang_js = ({
  name: 'NebulaDropdownItem',
  components: {
    NebulaIcon: NebulaIcon
  },
  props: {
    ariaLabel: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    isSelected: {
      default: false,
      type: Boolean
    },
    heading: {
      type: Boolean,
      default: false
    },
    link: {
      type: String,
      default: null
    },
    navElementId: {
      type: String,
      default: null
    },
    role: {
      type: String,
      default: 'menuitem'
    },
    routerLink: {
      type: String,
      default: null
    },
    action: {
      type: Function
    },
    text: String,
    target: String,
    trackingData: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['dropdown-item-clicked'],
  computed: {
    isAriaSelected() {
      let isAriaSelected = null;

      if (this.role === 'option') {
        isAriaSelected = this.isSelected ? 'true' : 'false';
      }

      return isAriaSelected;
    }

  },
  methods: {
    handleClick() {
      if (this.action) {
        this.action();
      }

      this.$emit('dropdown-item-clicked');
    }

  }
});
// CONCATENATED MODULE: ./src/components/Dropdown/NebulaDropdownItem.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Dropdown/NebulaDropdownItem.vue?vue&type=style&index=0&id=33408c85&lang=stylus
var NebulaDropdownItemvue_type_style_index_0_id_33408c85_lang_stylus = __webpack_require__("4e166");

// CONCATENATED MODULE: ./src/components/Dropdown/NebulaDropdownItem.vue







const NebulaDropdownItem_exports_ = /*#__PURE__*/exportHelper_default()(NebulaDropdownItemvue_type_script_lang_js, [['render',NebulaDropdownItemvue_type_template_id_33408c85_render]])

/* harmony default export */ var NebulaDropdownItem = (NebulaDropdownItem_exports_);
// CONCATENATED MODULE: ./src/utils/focus.js
const focusableSelector = 'button, [href], input, area, object, select, textarea, [tabindex]:not([tabindex="-1"])';

function getFocusableElements(context) {
  const baseTabbable = Array.from(context.querySelectorAll(focusableSelector));
  const visible = baseTabbable.filter(item => {
    const rectangle = item.getBoundingClientRect();
    return rectangle.width !== 0 && rectangle.height !== 0;
  });
  return visible;
}


// CONCATENATED MODULE: ./src/utils/dropdown.js
/*

    As of Jan 2022

    Combobox functionality based on:
    https://w3c.github.io/aria-practices/examples/combobox/combobox-select-only.html

    Menu functions based on:
    https://www.w3.org/WAI/GL/wiki/Using_ARIA_menus#Example_Keyboard_Behavior

*/

/* harmony default export */ var dropdown = ({
  data() {
    return {
      dropdownOpen: false,
      keyInput: '',
      keyTimeOut: null
    };
  },

  methods: {
    closeDropdown() {
      this.dropdownOpen = false;
      this.$emit('dropdownOpen', this.dropdownOpen);
    },

    onBodyClick({
      target
    }) {
      // Do nothing if click is within dropdown or toggle button.
      // The toggle button can sometimes be elsewhere in the DOM
      // even though it's included in this component
      const toggleButton = document.getElementById(this.formattedId);

      if (this.$el.contains(target) || !this.dropdownOpen || toggleButton && toggleButton.contains(target)) {
        return;
      } // detect any exceptions to the body click


      const exceptions = [];
      const modalContainer = document.querySelector('.nebula-modal-container');
      const isDropdownInModal = this.$el.closest('.nebula-modal-container') !== null;
      const modalXButton = target.closest('.nebula-modal__x-button');
      const modalActionsCloseButton = target.closest('.nebula-modal__actions-container');
      const modalParent = target.closest('.nebula-modal-container');
      const modalExceptionCases = [modalContainer, modalXButton, modalActionsCloseButton, modalParent];
      modalExceptionCases.forEach(exceptionCase => {
        if (exceptionCase && !isDropdownInModal) {
          exceptions.push(exceptionCase);
        }
      }); // dialog exceptions

      const dialog = target.closest('.nebula-dialog');
      const isDropdownInDialog = this.$el.closest('.nebula-dialog') !== null;
      const dialogExceptionsCases = [dialog];
      dialogExceptionsCases.forEach(exceptionCase => {
        if (exceptionCase && !isDropdownInDialog) {
          exceptions.push(exceptionCase);
        }
      });
      const isWithinException = exceptions.find(exception => exception.contains(target)); // do nothing if the click is detected inside an exception area

      if (isWithinException) {
        return;
      } // close the dropdown if neither exceptions nor clicks within dropdown are detected


      this.closeDropdown();
    },

    openDropdown() {
      this.dropdownOpen = true;
    },

    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
      this.$emit('dropdownOpen', this.dropdownOpen);

      if (this.isComboBox) {
        this.handleTrigger();
      }
    },

    checkKeydown(e) {
      if (!this.checkArrowKey(e)) {
        // tab key, close if exiting menu
        if (e.code === 'Tab') {
          const focusable = this.getFocusable();
          const index = Array.prototype.indexOf.call(focusable, document.activeElement);

          if (e.shiftKey) {
            /* eslint-disable no-unused-expressions */
            index === 0 && this.closeDropdown();
          } else {
            index === focusable.length - 1 && this.closeDropdown();
          } // end key select last

        } else if (e.code === 'End') {
          const focusable = this.getFocusable();
          focusable.length && focusable[focusable.length - 1].focus();
          e.preventDefault(); // home key select first
        } else if (e.code === 'Home') {
          const focusable = this.getFocusable();
          focusable.length && focusable[0].focus();
          e.preventDefault(); // regular menu trigger click with space
        } else if (e.keyCode === 32 && !this.isComboBox) {
          e.target.click();
          e.preventDefault();
        }
      }
    },

    handleItemClick() {
      if (this.closeOnSelect) {
        this.closeDropdown();
      }
    },

    async closeAndFocus() {
      await this.closeDropdown(); // if btn that controls the dropdown is detected, return focus to that button

      const triggerBtn = document.getElementById(this.formattedId);
      triggerBtn.focus();
    },

    checkKeyup(e) {
      // modal is not in the DOM on load but added when triggered
      const modalOpen = document.querySelector('.nebula-modal-container'); // dialog is always in the DOM, and set to be visible with 'open'

      const dialog = document.querySelector('.nebula-dialog');
      const dialogOpen = dialog && dialog.open; // closeOnSelect is set to true, handle `Enter` key

      if (this.closeOnSelect && e.key === 'Enter') {
        this.closeAndFocus();
      }

      if (e.key === 'Escape') {
        // do not close dropdown on esc when modal or dialog open
        if (modalOpen || dialogOpen) {
          return;
        }

        this.closeAndFocus();
      } else if (e.keyCode >= 65 && e.keyCode <= 90) {
        if (this.keyTimeOut) {
          clearTimeout(this.keyTimeOut);
        }

        this.keyInput += String.fromCharCode(e.keyCode);
        this.keyTimeOut = setTimeout(() => {
          this.keyInput = '';
        }, 500);
        const focusable = this.getFocusable();
        const match = Array.from(focusable).find(element => element.innerText.toUpperCase().startsWith(this.keyInput));
        match && match.focus();
      }
    },

    checkArrowKeyOnTrigger(e) {
      // up arrow pressed open
      if (e.keyCode === 38) {
        e.preventDefault();
        this.openDropdown(); // down arrow pressed open
      } else if (e.keyCode === 40) {
        e.preventDefault();
        this.openDropdown(); // open when letter pressed
      } else if (e.keyCode >= 65 && e.keyCode <= 90) {
        this.openDropdown();
      }

      if (this.isComboBox) {
        // combobox open when home or end pressed
        if (e.keyCode === 36 || e.keyCode === 35) {
          this.openDropdown();
          e.preventDefault();
        } // menu clicking space selects first

      } else if (e.keyCode === 32) {
        this.toggleDropdown();
        e.preventDefault();
      }
    },

    // runs on keyup after menu was opened
    checkArrowKeyAfterTrigger(e) {
      const modalOpen = document.querySelector('.nebula-modal-container'); // escape key close

      if (e.keyCode === 27) {
        // do not close dropdown on esc when modal is open
        if (modalOpen) {
          return;
        }

        this.closeDropdown(); // up arrow pressed select first
      } else if (e.keyCode === 38) {
        this.selectFirst(); // letter...
      } else if (e.keyCode >= 65 && e.keyCode <= 90) {
        this.keyInput += String.fromCharCode(e.keyCode);
        this.keyTimeOut = setTimeout(() => {
          this.keyInput = '';
        }, 500);
        const focusable = this.getFocusable();
        const match = Array.from(focusable).find(element => element.innerText.toUpperCase().startsWith(this.keyInput));
        match && match.focus(); // normal menu select first item if menu was opened with down arrow space or enter
      } else if (!this.isComboBox) {
        if (e.keyCode === 40 || e.keyCode === 32 || e.keyCode === 13) {
          if (this.dropdownOpen) {
            this.selectFirst();
          }
        } // if combobox...

      } else if (this.isComboBox) {
        // homekey selects first
        if (e.keyCode === 36) {
          this.selectFirst(); // end key selects last
        } else if (e.keyCode === 35) {
          const focusable = this.getFocusable();
          focusable.length && focusable[focusable.length - 1].focus();
        }
      }
    },

    checkArrowKey(e) {
      // up arrow pressed
      // combo box pressing alt and up will select and close
      // this is handled in combobox item
      if (e.keyCode === 38 && (this.isComboBox && !e.altKey || !this.isComboBox)) {
        e.preventDefault();
        this.selectNextUp(e);
        return true;
      } // down arrow pressed


      if (e.keyCode === 40) {
        e.preventDefault();
        this.selectNextDown(e);
        return true;
      }

      return false;
    },

    selectFirst() {
      this.$nextTick(() => {
        const focusable = this.getFocusable();

        if (focusable.length > 0) {
          focusable[0].focus();
        }
      });
    },

    selectNextUp() {
      const focusable = this.getFocusable();
      const index = Array.prototype.indexOf.call(focusable, document.activeElement);

      if (index > 0) {
        focusable[index - 1].focus();
      } else if (!this.isComboBox) {
        focusable[focusable.length - 1].focus();
      }
    },

    selectNextDown() {
      const focusable = this.getFocusable();
      const index = Array.prototype.indexOf.call(focusable, document.activeElement);

      if (index < focusable.length - 1) {
        focusable[index + 1].focus();
      } else if (!this.isComboBox) {
        focusable[0].focus();
      }
    },

    getFocusable() {
      // focusable element types within dropdown
      return getFocusableElements(this.$refs.dropdownContent);
    }

  },

  mounted() {
    document.addEventListener('click', this.onBodyClick);
  },

  beforeUnmount() {
    document.removeEventListener('click', this.onBodyClick);
  }

});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Dropdown/NebulaDropdown.vue?vue&type=script&lang=js





/* harmony default export */ var NebulaDropdownvue_type_script_lang_js = ({
  name: 'NebulaDropdown',
  components: {
    NebulaButton: NebulaButton,
    NebulaDropdownItem: NebulaDropdownItem
  },
  mixins: [dropdown, themingUtils],
  props: {
    alignToButtonStart: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Object
    },
    ariaLabel: {
      type: String
    },
    buttonId: {
      // optional, random string will be used if not present
      type: [String, Number]
    },
    buttonText: {
      type: String,
      default: 'Open'
    },
    buttonType: {
      // default enforced in the buttonProps computed property
      // by which props get passed to NebulaButton
      type: String
    },
    closeOnSelect: {
      type: Boolean
    },
    contentElement: {
      type: String
    },
    dropdownElement: {
      type: String,
      default: 'div'
    },
    dropdownId: {
      type: String,
      default: null
    },
    dropdownWrapperClass: {
      type: String
    },
    gridSelector: {
      type: String
    },
    iconTransition: {
      default: false,
      type: Boolean
    },
    items: {
      type: Array
    },
    role: {
      type: String,
      default: 'menu'
    },
    useWhiteBackground: {
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      adjustDropdownPositionEnd: false,
      dropdownOpen: false
    };
  },

  watch: {
    dropdownOpen() {
      this.$nextTick(() => {
        const elComputedStyles = window.getComputedStyle(this.$el);
        const isRtl = elComputedStyles.getPropertyValue('direction') === 'rtl';
        const dropdownEl = this.$el.querySelector('.nebula-dropdown__content');
        const dropdownElPosition = dropdownEl.getBoundingClientRect();
        let containerLeft = 0;
        let containerRight = window.innerWidth; // if a gridSelector is passed in, use that as the bounding rectangle check

        if (this.gridSelector) {
          const container = document.querySelector(this.gridSelector);

          if (container) {
            containerRight = container.getBoundingClientRect().right;
            containerLeft = container.getBoundingClientRect().left;
          }
        }

        if (this.dropdownOpen === true) {
          if (isRtl) {
            if (dropdownElPosition.left < containerLeft && !this.adjustDropdownPositionEnd) {
              this.adjustDropdownPositionEnd = true;
            }
          }

          if (!isRtl) {
            if (dropdownElPosition.right > containerRight && !this.adjustDropdownPositionEnd) {
              this.adjustDropdownPositionEnd = true;
            }
          }
        } else {
          this.adjustDropdownPositionEnd = false;
        }
      });
    }

  },
  computed: {
    dropdownClassName() {
      const className = ['nebula-dropdown', this.dropdownWrapperClass ? this.dropdownWrapperClass : '', {
        'nebula-dropdown--align-to-button-start': this.alignToButtonStart && !this.adjustDropdownPositionEnd,
        'nebula-dropdown--align-to-button-end': this.adjustDropdownPositionEnd,
        'nebula-dropdown--icon-transition': this.iconTransition,
        'nebula-dropdown--open': this.dropdownOpen,
        'nebula-dropdown--white-background': this.useWhiteBackground
      }];
      return className;
    },

    element() {
      const supportedComponents = ['div', 'ul'];
      const {
        contentElement
      } = this.$props;

      if (!supportedComponents.includes(contentElement)) {
        return 'ul';
      }

      return contentElement;
    },

    formattedId() {
      return randomStringId(this.$props.buttonId);
    },

    childId() {
      return randomStringId();
    },

    usesTriggerSlot() {
      return !!this.$slots.trigger;
    },

    buttonProps() {
      let typeGroup;
      const ellipsesProps = {
        iconLeft: 'ellipses-vertical',
        shape: 'pill',
        size: 's',
        type: 'flat',
        class: 'nebula-action-menu'
      };
      const caretProps = {
        iconRight: 'caret-down',
        text: this.buttonText
      };
      const actionBarProps = {
        iconLeft: 'ellipses-vertical',
        shape: 'square',
        size: 's',
        type: 'flat',
        class: 'nebula-action-bar__ellipses'
      };
      const smallButtonProps = {
        shape: 'square',
        size: 's',
        text: this.buttonText
      }; // map prop groups to supported types to pass to NebulaButton

      const supportedTypes = {
        ellipses: ellipsesProps,
        caret: caretProps,
        actionBar: actionBarProps,
        smallButton: smallButtonProps
      };

      if (Object.keys(supportedTypes).includes(this.buttonType)) {
        typeGroup = supportedTypes[this.buttonType];
      } else {
        typeGroup = caretProps;
      }

      return typeGroup;
    },

    parsedItems() {
      let matchIndex;
      const items = [...this.items]; // if actions are passed in, include them in the DropdownItem data

      if (this.actions) {
        Object.keys(this.actions).forEach(text => {
          const match = items.find((each, idx) => {
            // for each dropdown item, check if there's a matching action being
            // passed through via actions prop
            if (each.text === text) {
              matchIndex = idx;
            }

            return each.text === text;
          });

          if (match) {
            const actionObj = {
              action: this.actions[text]
            };
            items[matchIndex] = { ...items[matchIndex],
              ...actionObj
            };
          }
        });
      }

      return items;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Dropdown/NebulaDropdown.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Dropdown/NebulaDropdown.vue?vue&type=style&index=0&id=14cec1d8&lang=stylus
var NebulaDropdownvue_type_style_index_0_id_14cec1d8_lang_stylus = __webpack_require__("4890");

// CONCATENATED MODULE: ./src/components/Dropdown/NebulaDropdown.vue







const NebulaDropdown_exports_ = /*#__PURE__*/exportHelper_default()(NebulaDropdownvue_type_script_lang_js, [['render',NebulaDropdownvue_type_template_id_14cec1d8_render]])

/* harmony default export */ var NebulaDropdown = (NebulaDropdown_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Listgroup/NebulaListGroup.vue?vue&type=template&id=0c0581b4

const NebulaListGroupvue_type_template_id_0c0581b4_hoisted_1 = {
  key: 0,
  class: "nebula-list-group__header"
};
const NebulaListGroupvue_type_template_id_0c0581b4_hoisted_2 = ["aria-label"];
function NebulaListGroupvue_type_template_id_0c0581b4_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.element), {
    class: Object(external_vue_["normalizeClass"])(["nebula-list-group", $props.nested && 'nebula-list-group--nested'])
  }, {
    default: Object(external_vue_["withCtx"])(() => [$props.header ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("h4", NebulaListGroupvue_type_template_id_0c0581b4_hoisted_1, Object(external_vue_["toDisplayString"])($props.header), 1)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("ul", {
      "aria-label": $props.ariaLabel,
      class: "nebula-list-group__content"
    }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "content")], 8, NebulaListGroupvue_type_template_id_0c0581b4_hoisted_2)]),
    _: 3
  }, 8, ["class"]);
}
// CONCATENATED MODULE: ./src/components/Listgroup/NebulaListGroup.vue?vue&type=template&id=0c0581b4

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Listgroup/NebulaListGroup.vue?vue&type=script&lang=js
/* harmony default export */ var NebulaListGroupvue_type_script_lang_js = ({
  name: 'NebulaListGroup',
  props: {
    ariaLabel: {
      type: String,
      default: null
    },
    element: {
      type: String,
      default: 'div'
    },
    header: {
      type: String
    },
    nested: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/Listgroup/NebulaListGroup.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Listgroup/NebulaListGroup.vue?vue&type=style&index=0&id=0c0581b4&lang=stylus
var NebulaListGroupvue_type_style_index_0_id_0c0581b4_lang_stylus = __webpack_require__("0f96");

// CONCATENATED MODULE: ./src/components/Listgroup/NebulaListGroup.vue







const NebulaListGroup_exports_ = /*#__PURE__*/exportHelper_default()(NebulaListGroupvue_type_script_lang_js, [['render',NebulaListGroupvue_type_template_id_0c0581b4_render]])

/* harmony default export */ var NebulaListGroup = (NebulaListGroup_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Listgroup/NebulaListItem.vue?vue&type=template&id=0cc0263f

const NebulaListItemvue_type_template_id_0cc0263f_hoisted_1 = {
  key: 2,
  class: "nebula-list-item__avatar-container"
};
const NebulaListItemvue_type_template_id_0cc0263f_hoisted_2 = ["src"];
const NebulaListItemvue_type_template_id_0cc0263f_hoisted_3 = {
  class: "nebula-list-item__text"
};
function NebulaListItemvue_type_template_id_0cc0263f_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  const _component_NebulaBadge = Object(external_vue_["resolveComponent"])("NebulaBadge");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
    class: Object(external_vue_["normalizeClass"])(["nebula-list-item", $props.isSelected ? 'nebula-list-item--selected' : null])
  }, [(Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($options.getElement), Object(external_vue_["mergeProps"])({
    class: $options.getInnerClass,
    href: $options.getLink,
    target: $props.target ? $props.target : null,
    to: $props.routerLink ? $props.routerLink : null,
    "aria-label": $props.linkAriaLabel
  }, $props.dataAttrs), {
    default: Object(external_vue_["withCtx"])(() => [$props.icon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
      key: 0,
      size: $props.iconSize,
      symbolId: $props.icon,
      class: "nebula-list-item__icon"
    }, null, 8, ["size", "symbolId"])) : Object(external_vue_["createCommentVNode"])("", true), $props.badgeText ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaBadge, {
      key: 1,
      size: "s",
      color: $props.badgeColor,
      type: $props.badgeType,
      text: $props.badgeText
    }, null, 8, ["color", "type", "text"])) : Object(external_vue_["createCommentVNode"])("", true), $props.avatarImgUrl ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaListItemvue_type_template_id_0cc0263f_hoisted_1, [Object(external_vue_["createElementVNode"])("img", {
      class: "nebula-list-item__avatar-img",
      src: $props.avatarImgUrl,
      alt: ""
    }, null, 8, NebulaListItemvue_type_template_id_0cc0263f_hoisted_2)])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("span", NebulaListItemvue_type_template_id_0cc0263f_hoisted_3, Object(external_vue_["toDisplayString"])($props.text), 1)]),
    _: 1
  }, 16, ["class", "href", "target", "to", "aria-label"])), $props.secondaryActionIcon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, Object(external_vue_["mergeProps"])({
    key: 0
  }, $props.secondaryActionDataAttrs, {
    class: "nebula-list-item__secondary-action",
    "icon-left": $props.secondaryActionIcon,
    size: "s",
    type: "flat",
    "aria-label": $options.getSecondaryActionAriaLabel,
    link: $props.secondaryActionLink,
    target: $props.secondaryActionTarget,
    routerLink: $props.secondaryActionUseRouterLink,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('secondaryActionEvent'))
  }), null, 16, ["icon-left", "aria-label", "link", "target", "routerLink"])) : Object(external_vue_["createCommentVNode"])("", true)], 2);
}
// CONCATENATED MODULE: ./src/components/Listgroup/NebulaListItem.vue?vue&type=template&id=0cc0263f

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Badge/NebulaBadge.vue?vue&type=template&id=2eaa25d0

const NebulaBadgevue_type_template_id_2eaa25d0_hoisted_1 = {
  key: 0,
  class: "nebula-badge__outer-text-start"
};
const NebulaBadgevue_type_template_id_2eaa25d0_hoisted_2 = {
  key: 1,
  class: "nebula-badge__outer-text-end"
};
function NebulaBadgevue_type_template_id_2eaa25d0_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.parentClasses),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [$options.hasOuterTextStart ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaBadgevue_type_template_id_2eaa25d0_hoisted_1, [Object(external_vue_["renderSlot"])(_ctx.$slots, "outerTextStart")])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.className)
  }, [$props.icon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
    key: 0,
    symbolId: $props.icon,
    class: "nebula-badge__icon"
  }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["renderSlot"])(_ctx.$slots, "default", {}, () => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])($props.text), 1)])], 2), $options.hasOuterTextEnd ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaBadgevue_type_template_id_2eaa25d0_hoisted_2, [Object(external_vue_["renderSlot"])(_ctx.$slots, "outerTextEnd")])) : Object(external_vue_["createCommentVNode"])("", true)], 6);
}
// CONCATENATED MODULE: ./src/components/Badge/NebulaBadge.vue?vue&type=template&id=2eaa25d0

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Badge/NebulaBadge.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaBadgevue_type_script_lang_js = ({
  name: 'NebulaBadge',
  components: {
    NebulaIcon: NebulaIcon
  },
  mixins: [themingUtils],
  props: {
    color: {
      type: String,
      default: 'gray',
      enum: ['gray', 'light-gray', 'dark-gray', 'white', 'blue', 'orange', 'overlay'] // for docs site

    },
    icon: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'm',
      enum: ['s', 'm'] // for docs site

    },
    text: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'fill',
      enum: ['fill', 'outline', 'duration', 'anchored'] // for docs site

    }
  },
  computed: {
    className() {
      const className = ['nebula-badge', `nebula-badge--${this.color}`, `nebula-badge--${this.size}`, `nebula-badge--${this.type}`, {
        'nebula-badge--icon': this.icon
      }];
      return className;
    },

    hasOuterTextStart() {
      return !!this.$slots.outerTextStart;
    },

    hasOuterTextEnd() {
      return !!this.$slots.outerTextEnd;
    },

    parentClasses() {
      const className = ['nebula-badge__container', {
        'nebula-badge__container--outer-text-start': this.hasOuterTextStart,
        'nebula-badge__container--outer-text-end': this.hasOuterTextEnd
      }];
      return className;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Badge/NebulaBadge.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Badge/NebulaBadge.vue?vue&type=style&index=0&id=2eaa25d0&lang=stylus
var NebulaBadgevue_type_style_index_0_id_2eaa25d0_lang_stylus = __webpack_require__("d6b0");

// CONCATENATED MODULE: ./src/components/Badge/NebulaBadge.vue







const NebulaBadge_exports_ = /*#__PURE__*/exportHelper_default()(NebulaBadgevue_type_script_lang_js, [['render',NebulaBadgevue_type_template_id_2eaa25d0_render]])

/* harmony default export */ var NebulaBadge = (NebulaBadge_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Listgroup/NebulaListItem.vue?vue&type=script&lang=js



/* harmony default export */ var NebulaListItemvue_type_script_lang_js = ({
  name: 'NebulaListItem',
  components: {
    NebulaIcon: NebulaIcon,
    NebulaButton: NebulaButton,
    NebulaBadge: NebulaBadge
  },
  props: {
    badgeColor: {
      type: String,
      default: 'gray',
      // options: 'gray', 'light-gray', 'dark-gray', 'white', 'blue', 'orange', 'overlay'
      enum: ['gray', 'light-gray', 'dark-gray', 'white', 'blue', 'orange', 'overlay'] // for docs site

    },
    badgeType: {
      type: String,
      default: 'fill',
      // options: 'fill', 'outline'
      enum: ['fill', 'outline'] // for docs site

    },
    badgeText: {
      type: String,
      default: null
    },
    dataAttrs: {
      type: Object,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconSize: {
      type: String,
      default: 'm'
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    link: {
      type: String,
      default: null
    },
    linkAriaLabel: {
      type: String,
      default: null
    },
    avatarImgUrl: {
      type: String,
      default: null
    },
    routerLink: {
      type: String,
      default: null
    },
    secondaryActionUseRouterLink: {
      type: Boolean,
      default: false
    },
    secondaryActionAriaLabel: {
      type: String,
      default: null
    },
    secondaryActionDataAttrs: {
      type: Object,
      default: null
    },
    secondaryActionIcon: {
      type: String,
      default: null
    },
    secondaryActionLink: {
      type: String,
      default: null
    },
    secondaryActionTarget: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: null
    },
    text: String,
    usePushState: {
      type: Boolean,
      default: false
    }
  },
  emits: ['secondaryActionEvent'],
  computed: {
    getInnerClass() {
      return ['nebula-list-item__inner', {
        'nebula-list-item__inner--secondary-action': this.secondaryActionIcon
      }, {
        'do-push-state': this.usePushState
      }];
    },

    getElement() {
      let element = 'button';

      if (this.routerLink) {
        element = 'routerLink';
      } else if (this.link) {
        element = 'a';
      }

      return element;
    },

    getLink() {
      let link = null;

      if (this.routerLink) {
        link = this.routerLink;
      } else if (this.link) {
        link = this.link;
      }

      return link;
    },

    getSecondaryActionAriaLabel() {
      return this.secondaryActionAriaLabel ? this.secondaryActionAriaLabel : this.$t('Download');
    }

  }
});
// CONCATENATED MODULE: ./src/components/Listgroup/NebulaListItem.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Listgroup/NebulaListItem.vue?vue&type=style&index=0&id=0cc0263f&lang=stylus
var NebulaListItemvue_type_style_index_0_id_0cc0263f_lang_stylus = __webpack_require__("05e7");

// CONCATENATED MODULE: ./src/components/Listgroup/NebulaListItem.vue







const NebulaListItem_exports_ = /*#__PURE__*/exportHelper_default()(NebulaListItemvue_type_script_lang_js, [['render',NebulaListItemvue_type_template_id_0cc0263f_render]])

/* harmony default export */ var NebulaListItem = (NebulaListItem_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Breadcrumbs/NebulaBreadcrumbs.vue?vue&type=script&lang=js







/* harmony default export */ var NebulaBreadcrumbsvue_type_script_lang_js = ({
  name: 'NebulaBreadcrumbs',
  components: {
    NebulaIcon: NebulaIcon,
    NebulaBreadcrumbDropdownButton: NebulaBreadcrumbsDropdownButton,
    NebulaDropdown: NebulaDropdown,
    NebulaListgroup: NebulaListGroup,
    NebulaListItem: NebulaListItem
  },
  props: {
    actionBar: {
      type: Boolean,
      default: false
    },
    actionBarWithBack: {
      type: Boolean,
      default: false
    },
    actionBarWithTitle: {
      type: Boolean,
      default: false
    },
    ariaLabel: String,
    breadcrumbs: Array,
    breadcrumbsId: {
      type: [String, Number]
    },
    breadcrumbItemMinWidth: {
      type: Number,
      default: 50
    },
    dropdownIcon: {
      type: String,
      default: 'caret-down'
    },
    dropdownUseRouterLinks: {
      type: Boolean,
      default: false
    },
    dropdownUseIconTransition: {
      type: Boolean,
      default: false
    },
    responsiveBreadcrumbDropdownHeader: {
      type: String,
      default: null
    },
    responsivePageWidthThreshold: {
      type: Number,
      default: 480
    },
    showDimText: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      breadcrumbsListSmallestWidth: 0,
      responsiveMenuView: false
    };
  },

  computed: {
    breadcrumbsDropdownList() {
      let breadcrumbsDropdownList;
      this.breadcrumbs.forEach(item => {
        if (item.dropdown !== undefined) {
          breadcrumbsDropdownList = item.dropdown;
        }
      });
      return breadcrumbsDropdownList;
    },

    breadcrumbsExcludeDropdown() {
      const breadcrumbsList = [];
      this.breadcrumbs.forEach(item => {
        if (item.dropdown === undefined) {
          breadcrumbsList.push(item);
        }
      });
      return breadcrumbsList;
    },

    checkIfOneBreadcrumb() {
      return this.breadcrumbs.length === 1;
    },

    getAriaLabel() {
      return this.ariaLabel ? this.ariaLabel : this.$t('Breadcrumbs');
    },

    getBreadcrumbsId() {
      return `nebula-breadcrumbs--${this.randomStringId}`;
    },

    getBreadcrumbItemMinWidth() {
      return `min-width: ${this.breadcrumbItemMinWidth}px`;
    },

    getDropdownButtonId() {
      return `nebula-breadcrumb__dropdown-button--${this.randomStringId}`;
    },

    getDropdownMenuId() {
      return `nebula-breadcrumb__dropdown-menu--${this.randomStringId}`;
    },

    getLastBreadcrumbItem() {
      return this.breadcrumbsExcludeDropdown[this.breadcrumbsExcludeDropdown.length - 1];
    },

    getResponsiveDropdownId() {
      return `nebula-responsive-breadcrumbs--${this.randomStringId}`;
    },

    getResponsiveDropdownButtonId() {
      return `nebula-responsive-breadcrumbs__dropdown-button--${this.randomStringId}`;
    },

    getResponsiveDropdownMenuId() {
      return `nebula-responsive-breadcrumbs__dropdown-menu--${this.randomStringId}`;
    },

    randomStringId() {
      return randomStringId();
    }

  },
  methods: {
    breadcrumbsItemClassName(i) {
      return ['nebula-breadcrumbs__item', {
        'nebula-breadcrumbs__item--current': this.isCurrentBreadcrumb(i)
      }];
    },

    checkBreadcrumbsView() {
      const breadcrumbs = document.getElementById(this.getBreadcrumbsId);
      const responsiveMenuBreadcrumbs = document.getElementById(this.getResponsiveDropdownId);
      const documentClientWidth = document.documentElement.clientWidth;

      if (breadcrumbs) {
        const breadcrumbsClientWidth = breadcrumbs.clientWidth;

        if (this.breadcrumbsListSmallestWidth < breadcrumbsClientWidth) {
          this.responsiveMenuView = false;
        } else if (documentClientWidth <= this.responsivePageWidthThreshold) {
          this.responsiveMenuView = true;
        } else if (this.breadcrumbsListSmallestWidth > breadcrumbsClientWidth) {
          this.responsiveMenuView = true;
        }
      }

      if (responsiveMenuBreadcrumbs) {
        let responsiveMenuBreadcrumbsWidth = 0;

        if (this.actionBarWithTitle || this.actionBarWithTitle && this.actionBarWithBack) {
          responsiveMenuBreadcrumbsWidth = responsiveMenuBreadcrumbs.closest('.nebula-breadcrumbs__outer').clientWidth;
        } else if (this.actionBar || this.actionBar && this.actionBarWithBack) {
          responsiveMenuBreadcrumbsWidth = responsiveMenuBreadcrumbs.closest('.nebula-action-bar__group').clientWidth;
        } else {
          responsiveMenuBreadcrumbsWidth = responsiveMenuBreadcrumbs.parentNode.clientWidth;
        }

        if (this.breadcrumbsListSmallestWidth > responsiveMenuBreadcrumbsWidth) {
          this.responsiveMenuView = true;
        } else if (documentClientWidth <= this.responsivePageWidthThreshold) {
          this.responsiveMenuView = true;
        } else if (this.breadcrumbsListSmallestWidth < responsiveMenuBreadcrumbsWidth) {
          this.responsiveMenuView = false;
        }
      }
    },

    getDropdownSelectedItemText(dropdown) {
      const selectedItem = dropdown.find(o => o.selected === true);
      return selectedItem.text;
    },

    isCurrentBreadcrumb(i) {
      let isCurrent = false;

      if (i === this.breadcrumbs.length - 1) {
        isCurrent = true;
      }

      return isCurrent;
    },

    setBreadcrumbsListSmallestWidth() {
      const breadcrumbs = document.getElementById(this.getBreadcrumbsId);
      const breadcrumbsList = breadcrumbs.childNodes[0];
      const breadcrumbsListItemsLength = breadcrumbsList.childNodes.length;

      if (this.breadcrumbsDropdownList) {
        // get the length of breadcrumbs, excluding the dropdown
        const breadcrumbsLengthNoDropdown = breadcrumbsListItemsLength - 1; // multiply the length by the breadcrumbItemMinWidth

        const breadcrumbsOnlyWidth = breadcrumbsLengthNoDropdown * this.breadcrumbItemMinWidth; // get width of breadcrumb dropdown

        const breadcrumbDropdownWidth = document.getElementById(this.getDropdownButtonId).offsetWidth; // get width of the icon separators

        const breadcrumbIconWidth = breadcrumbsLengthNoDropdown * 40; // icons separator is 40px
        // add the width of the breadcrumbs, dropdown and icon separators

        this.breadcrumbsListSmallestWidth = breadcrumbsOnlyWidth + breadcrumbDropdownWidth + breadcrumbIconWidth;
      } else {
        // get width of the icon separators
        const breadcrumbIconWidth = (breadcrumbsListItemsLength - 1) * 40; // icons separator is 40px
        // get smallest width of the breadcrumbs

        const breadcrumbWidth = breadcrumbsListItemsLength * this.breadcrumbItemMinWidth; // add the width of the breadcrumbs and icon separators

        this.breadcrumbsListSmallestWidth = breadcrumbWidth + breadcrumbIconWidth;
      }
    }

  },

  mounted() {
    if (!this.checkIfOneBreadcrumb) {
      this.throttledHandleResize = lodash_es_throttle(this.checkBreadcrumbsView, 500);
      window.addEventListener('resize', this.throttledHandleResize);
      this.setBreadcrumbsListSmallestWidth();
      this.checkBreadcrumbsView();
    }
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.throttledHandleResize);
  }

});
// CONCATENATED MODULE: ./src/components/Breadcrumbs/NebulaBreadcrumbs.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Breadcrumbs/NebulaBreadcrumbs.vue?vue&type=style&index=0&id=70094768&lang=stylus
var NebulaBreadcrumbsvue_type_style_index_0_id_70094768_lang_stylus = __webpack_require__("287c");

// CONCATENATED MODULE: ./src/components/Breadcrumbs/NebulaBreadcrumbs.vue







const NebulaBreadcrumbs_exports_ = /*#__PURE__*/exportHelper_default()(NebulaBreadcrumbsvue_type_script_lang_js, [['render',NebulaBreadcrumbsvue_type_template_id_70094768_render]])

/* harmony default export */ var NebulaBreadcrumbs = (NebulaBreadcrumbs_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Pagination/NebulaDropdownPagination.vue?vue&type=template&id=619ecd74

const NebulaDropdownPaginationvue_type_template_id_619ecd74_hoisted_1 = ["aria-label"];
const NebulaDropdownPaginationvue_type_template_id_619ecd74_hoisted_2 = {
  class: "nebula-dropdown-pagination"
};
const NebulaDropdownPaginationvue_type_template_id_619ecd74_hoisted_3 = {
  class: "nebula-dropdown-pagination__item"
};
const NebulaDropdownPaginationvue_type_template_id_619ecd74_hoisted_4 = {
  class: "nebula-dropdown-pagination__item"
};
const NebulaDropdownPaginationvue_type_template_id_619ecd74_hoisted_5 = {
  class: "nebula-dropdown-pagination__item"
};
function NebulaDropdownPaginationvue_type_template_id_619ecd74_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaPaginationButtonItem = Object(external_vue_["resolveComponent"])("NebulaPaginationButtonItem");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaDropdownItem = Object(external_vue_["resolveComponent"])("NebulaDropdownItem");

  const _component_NebulaDropdown = Object(external_vue_["resolveComponent"])("NebulaDropdown");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [Object(external_vue_["createElementVNode"])("nav", {
    "aria-label": $options.getPaginationAriaLabel
  }, [Object(external_vue_["createElementVNode"])("ul", NebulaDropdownPaginationvue_type_template_id_619ecd74_hoisted_2, [Object(external_vue_["createElementVNode"])("li", NebulaDropdownPaginationvue_type_template_id_619ecd74_hoisted_3, [Object(external_vue_["createVNode"])(_component_NebulaPaginationButtonItem, {
    pageLabel: "Back",
    onClick: _cache[0] || (_cache[0] = $event => $options.onClickPage($event, $options.currentPage - 1)),
    link: $props.linkGenerator.getPrevPageLink(),
    usePushState: $options.usePushState,
    isDisabled: $props.linkGenerator.isFirstPage,
    type: "flat",
    shape: "pill",
    size: "s"
  }, null, 8, ["link", "usePushState", "isDisabled"])]), Object(external_vue_["createElementVNode"])("li", NebulaDropdownPaginationvue_type_template_id_619ecd74_hoisted_4, [Object(external_vue_["createVNode"])(_component_NebulaDropdown, {
    buttonId: $options.getDropdownButtonId,
    dropdownId: $options.getDropdownMenuId
  }, {
    trigger: Object(external_vue_["withCtx"])(({
      toggleDropdown,
      checkArrowKeyOnTrigger,
      checkArrowKeyAfterTrigger,
      isOpen
    }) => [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      id: $options.getDropdownButtonId,
      "aria-expanded": isOpen && 'true' || 'false',
      "aria-haspopup": "true",
      "aria-controls": $options.getDropdownMenuId,
      text: _ctx.$t($options.pageRangeText($options.currentPage, $options.totalPages)),
      iconRight: "caret-down",
      type: "flat",
      size: "s",
      onClick: toggleDropdown,
      onKeydown: checkArrowKeyOnTrigger,
      onKeyup: checkArrowKeyAfterTrigger
    }, null, 8, ["id", "aria-expanded", "aria-controls", "text", "onClick", "onKeydown", "onKeyup"])]),
    content: Object(external_vue_["withCtx"])(() => [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.range(1, $options.totalPages + 1), i => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        class: "nebula-dropdown-pagination__item",
        key: i
      }, [Object(external_vue_["createVNode"])(_component_NebulaDropdownItem, {
        link: $props.linkGenerator.getPageLink(i),
        text: _ctx.$t($options.pageText(i)),
        onClick: $event => $options.onClickPage($event, i)
      }, null, 8, ["link", "text", "onClick"])]);
    }), 128))]),
    _: 1
  }, 8, ["buttonId", "dropdownId"])]), Object(external_vue_["createElementVNode"])("li", NebulaDropdownPaginationvue_type_template_id_619ecd74_hoisted_5, [Object(external_vue_["createVNode"])(_component_NebulaPaginationButtonItem, {
    pageLabel: "Next",
    onClick: _cache[1] || (_cache[1] = $event => $options.onClickPage($event, $options.currentPage + 1)),
    link: $props.linkGenerator.getNextPageLink(),
    isDisabled: $props.linkGenerator.isLastPage,
    usePushState: $options.usePushState,
    type: "flat",
    shape: "pill",
    size: "s"
  }, null, 8, ["link", "isDisabled", "usePushState"])])])], 8, NebulaDropdownPaginationvue_type_template_id_619ecd74_hoisted_1)], 4);
}
// CONCATENATED MODULE: ./src/components/Pagination/NebulaDropdownPagination.vue?vue&type=template&id=619ecd74

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Pagination/NebulaPaginationButtonItem.vue?vue&type=template&id=3d1f70ac

const NebulaPaginationButtonItemvue_type_template_id_3d1f70ac_hoisted_1 = {
  key: 2,
  class: "nebula-pagination__item--ellipsis nebula-button nebula-button--m nebula-button--square nebula-button--flat nebula-button--icon-left nebula-button--icon-only nebula-pagination__link",
  "aria-hidden": "true"
};
function NebulaPaginationButtonItemvue_type_template_id_3d1f70ac_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return $props.pageLabel === 'Back' ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
    key: 0,
    iconLeft: "caret-left",
    class: Object(external_vue_["normalizeClass"])(['nebula-pagination__link', $props.usePushState && 'do-push-state']),
    type: $props.type,
    shape: $props.shape,
    size: $props.size,
    disabledLink: $props.isDisabled,
    link: $options.formattedLink,
    "aria-disabled": $props.isDisabled ? 'true' : 'false',
    "aria-label": $options.prevAriaLabel,
    routerLink: $props.routerLink
  }, null, 8, ["class", "type", "shape", "size", "disabledLink", "link", "aria-disabled", "aria-label", "routerLink"])) : $props.pageLabel === 'Next' ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
    key: 1,
    iconLeft: "caret-right",
    class: Object(external_vue_["normalizeClass"])(['nebula-pagination__link', $props.usePushState && 'do-push-state']),
    type: $props.type,
    shape: $props.shape,
    size: $props.size,
    disabledLink: $props.isDisabled,
    link: $options.formattedLink,
    "aria-disabled": $props.isDisabled ? 'true' : 'false',
    "aria-label": $options.nextAriaLabel,
    routerLink: $props.routerLink
  }, null, 8, ["class", "type", "shape", "size", "disabledLink", "link", "aria-disabled", "aria-label", "routerLink"])) : $props.pageLabel === 'Ellipsis' ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaPaginationButtonItemvue_type_template_id_3d1f70ac_hoisted_1, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
    size: "s",
    symbolId: "ellipses"
  })])) : $props.isCurrentPage ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
    key: 3,
    class: Object(external_vue_["normalizeClass"])(['nebula-pagination__link', 'nebula-pagination__link--active', $props.usePushState && 'do-push-state']),
    text: $props.pageLabel,
    type: $props.type,
    shape: $props.shape,
    size: $props.size,
    link: $options.formattedLink,
    "aria-label": $options.currentAriaLabel,
    routerLink: $props.routerLink
  }, null, 8, ["class", "text", "type", "shape", "size", "link", "aria-label", "routerLink"])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
    key: 4,
    class: Object(external_vue_["normalizeClass"])(['nebula-pagination__link', $props.usePushState && 'do-push-state']),
    text: $props.pageLabel,
    type: $props.type,
    shape: $props.shape,
    size: $props.size,
    link: $options.formattedLink,
    routerLink: $props.routerLink,
    ariaLabel: $options.ariaLabel
  }, null, 8, ["class", "text", "type", "shape", "size", "link", "routerLink", "ariaLabel"]));
}
// CONCATENATED MODULE: ./src/components/Pagination/NebulaPaginationButtonItem.vue?vue&type=template&id=3d1f70ac

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Pagination/NebulaPaginationButtonItem.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaPaginationButtonItemvue_type_script_lang_js = ({
  name: 'NebulaPaginationButtonItem',
  components: {
    NebulaButton: NebulaButton,
    NebulaIcon: NebulaIcon
  },
  props: {
    isCurrentPage: Boolean,
    pageLabel: [String, Number],
    // either 'Back', 'Next', 'Ellipsis', or a page number
    link: String,
    isDisabled: Boolean,
    routerLink: Boolean,
    usePushState: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'flat'
    },
    shape: {
      type: String,
      default: 'square'
    },
    size: {
      type: String,
      default: 'm'
    }
  },
  computed: {
    ariaLabel() {
      return this.$t('page %(t)d', {
        t: this.pageLabel
      });
    },

    currentAriaLabel() {
      return this.$t('current page, page %(t)d', {
        t: this.pageLabel
      });
    },

    formattedLink() {
      // Router links will complain if the link is null, but won't
      // if it's an empty string. This happens on the first page when
      // making the back button, and the last page when making
      // the next button
      return this.link || '';
    },

    nextAriaLabel() {
      return !this.isDisabled ? this.$t('go to next page') : this.$t('go to next page unavailable. end of pagination');
    },

    prevAriaLabel() {
      return !this.isDisabled ? this.$t('go to previous page') : this.$t('go to previous page unavailable. start of pagination');
    }

  }
});
// CONCATENATED MODULE: ./src/components/Pagination/NebulaPaginationButtonItem.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Pagination/NebulaPaginationButtonItem.vue?vue&type=style&index=0&id=3d1f70ac&lang=stylus
var NebulaPaginationButtonItemvue_type_style_index_0_id_3d1f70ac_lang_stylus = __webpack_require__("e429");

// CONCATENATED MODULE: ./src/components/Pagination/NebulaPaginationButtonItem.vue







const NebulaPaginationButtonItem_exports_ = /*#__PURE__*/exportHelper_default()(NebulaPaginationButtonItemvue_type_script_lang_js, [['render',NebulaPaginationButtonItemvue_type_template_id_3d1f70ac_render]])

/* harmony default export */ var NebulaPaginationButtonItem = (NebulaPaginationButtonItem_exports_);
// CONCATENATED MODULE: ./src/utils/pagination/link-generators/base.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-underscore-dangle */

/**
 * PaginationLinkGeneratorBase
 *
 * This is the base class from which all page-link
 * generator classes are derived from.
 *
 * DO NOT use this directly as a page-link generator.
 * It is designed to fail by default. Use a derived
 * implementation instead.
 *
 * The structure for the methods here are what the
 * NebulaPagination components will be accessing to
 * render the UI correctly.
 */
class PaginationLinkGeneratorBase {
  constructor(...allArgs) {
    _defineProperty(this, "_currentPageNumber", void 0);

    _defineProperty(this, "_numberOfPages", void 0);

    this._currentPageNumber = 1;
    this._numberOfPages = 1;
    this.initialize(...allArgs);
  }

  get currentPageNumber() {
    return this._currentPageNumber;
  }

  set currentPageNumber(val) {
    this._currentPageNumber = this.getMinDefaultNumber(val, 1);
  }

  get hasMultiplePages() {
    return this.numberOfPages > 1;
  }

  get isFirstPage() {
    return this.currentPageNumber === 1;
  }

  get isLastPage() {
    return this.currentPageNumber === this.numberOfPages;
  }

  get numberOfPages() {
    return this._numberOfPages;
  }

  set numberOfPages(val) {
    this._numberOfPages = this.getMinDefaultNumber(val, 1);
  }
  /* eslint-disable class-methods-use-this */


  getMinDefaultNumber(curVal, minVal) {
    const newVal = Number(curVal);

    if (Number.isNaN(newVal)) {
      return minVal;
    }

    return Math.max(newVal, minVal);
  }
  /* eslint-enable class-methods-use-this */


  getNextPageLink() {
    if (this.isLastPage) {
      return null;
    }

    return this.getPageLink(this.currentPageNumber + 1);
  }

  getPageLink() {
    return this.needsImplementation();
  }

  getPrevPageLink() {
    if (this.isFirstPage) {
      return null;
    }

    return this.getPageLink(this.currentPageNumber - 1);
  }
  /* eslint-disable class-methods-use-this */


  getQueryStringFromUrl(url) {
    let queryString = '';

    if (url.indexOf('?') > 0) {
      queryString = url.replace(/^[^?]*\?/, '');
    }

    return queryString;
  }
  /* eslint-enable class-methods-use-this */


  getUrlWithQueryParams(urlParams, baseUrl = null) {
    const params = urlParams || {}; // This will strip the URL of any URL params being newly
    // set later on.
    // Think `page` or `per_page` or `skip` or `limit` get
    // removed before being set to new values later on in
    // this method.

    const url = this.stripQueryParamsFromUrl(Object.keys(urlParams), baseUrl || this.baseUrl);

    if (!url) {
      return null;
    }

    const strippedUrl = url.replace(/\?.*$/, '');
    const urlSearchParams = new URLSearchParams(this.getQueryStringFromUrl(url));
    Object.keys(params).forEach(paramName => {
      urlSearchParams.append(paramName, params[paramName]);
    });
    const newQueryString = urlSearchParams.toString();

    if (!newQueryString.length) {
      return strippedUrl;
    }

    return `${strippedUrl}?${newQueryString}`;
  }

  initialize(opts) {
    this.baseUrl = opts.baseUrl || this.baseUrl || null;
    this.currentPageNumber = opts.currentPageNumber || this.currentPageNumber;
    this.numberOfPages = opts.numberOfPages || this.numberOfPages;
    this.usePushState = !!opts.usePushState;
    this.useRouterLink = !!opts.useRouterLink;
    this.updateMetadata();
  }
  /* eslint-disable class-methods-use-this */


  needsImplementation() {
    throw new Error('Needs to be implemented by derived class!');
  }
  /* eslint-enable class-methods-use-this */


  stripQueryParamsFromUrl(paramsToStrip = null, url = null) {
    const urlToStrip = url || this.baseUrl;

    if (!urlToStrip) {
      return null;
    }

    const strippedUrl = urlToStrip.replace(/\?.*$/, '');

    if (!paramsToStrip) {
      // strip all params
      return strippedUrl;
    }

    const urlSearchParams = new URLSearchParams(this.getQueryStringFromUrl(urlToStrip));
    const newUrlSearchParams = new URLSearchParams();
    urlSearchParams.forEach((paramValue, paramName) => {
      if (paramsToStrip.indexOf(paramName) > -1) {
        // excluding the param
        return;
      }

      newUrlSearchParams.append(paramName, paramValue);
    });
    const newQueryString = newUrlSearchParams.toString();

    if (!newQueryString.length) {
      return strippedUrl;
    }

    return `${strippedUrl}?${newQueryString}`;
  }

  updateMetadata() {
    this.needsImplementation();
  }

}

/* harmony default export */ var base = (PaginationLinkGeneratorBase);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Pagination/NebulaDropdownPagination.vue?vue&type=script&lang=js







/* harmony default export */ var NebulaDropdownPaginationvue_type_script_lang_js = ({
  name: 'NebulaDropdownPagination',
  components: {
    NebulaButton: NebulaButton,
    NebulaDropdown: NebulaDropdown,
    NebulaDropdownItem: NebulaDropdownItem,
    NebulaPaginationButtonItem: NebulaPaginationButtonItem
  },
  mixins: [themingUtils],
  props: {
    linkGenerator: {
      type: [base, Object]
    },
    paginationAriaLabel: {
      type: String
    }
  },
  emits: ['selectPage'],
  computed: {
    currentPage() {
      return this.linkGenerator.currentPageNumber;
    },

    getDropdownButtonId() {
      return `nebula-dropdown-pagination__button--${this.randomStringId}`;
    },

    getDropdownMenuId() {
      return `nebula-dropdown-pagination__menu--${this.randomStringId}`;
    },

    getPaginationAriaLabel() {
      return this.paginationAriaLabel ? this.paginationAriaLabel : this.$t('Pagination');
    },

    randomStringId() {
      return randomStringId();
    },

    routerLink() {
      return this.linkGenerator.useRouterLink;
    },

    totalPages() {
      return this.linkGenerator.numberOfPages;
    },

    usePushState() {
      return this.linkGenerator.usePushState;
    }

  },
  methods: {
    pageText(page) {
      return `Page ${page}`;
    },

    pageRangeText(current, total) {
      return `${current} of ${total}`;
    },

    range(start, end) {
      // Return an array from start to end, similar to Jinja's range()
      // The start is included; end is not
      const pageRange = [];

      for (let i = start; i < end; i += 1) {
        pageRange.push(i);
      }

      return pageRange;
    },

    onClickPage(e, page) {
      if (e.target.getAttribute('aria-disabled') === 'true') {
        return;
      }

      this.$emit('selectPage', page);
    }

  }
});
// CONCATENATED MODULE: ./src/components/Pagination/NebulaDropdownPagination.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Pagination/NebulaDropdownPagination.vue?vue&type=style&index=0&id=619ecd74&lang=stylus
var NebulaDropdownPaginationvue_type_style_index_0_id_619ecd74_lang_stylus = __webpack_require__("76f6");

// CONCATENATED MODULE: ./src/components/Pagination/NebulaDropdownPagination.vue







const NebulaDropdownPagination_exports_ = /*#__PURE__*/exportHelper_default()(NebulaDropdownPaginationvue_type_script_lang_js, [['render',NebulaDropdownPaginationvue_type_template_id_619ecd74_render]])

/* harmony default export */ var NebulaDropdownPagination = (NebulaDropdownPagination_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Image/NebulaImage.vue?vue&type=template&id=769a0fc8

const NebulaImagevue_type_template_id_769a0fc8_hoisted_1 = ["id"];
const NebulaImagevue_type_template_id_769a0fc8_hoisted_2 = ["alt", "id", "src"];
const NebulaImagevue_type_template_id_769a0fc8_hoisted_3 = ["alt", "id", "sizes", "src", "srcset"];
function NebulaImagevue_type_template_id_769a0fc8_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: "nebula-image__wrapper",
    id: $props.pictureComponent ? $options.tempId : $props.id
  }, [$props.assetId && $data.imageExists ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("img", {
    key: 0,
    alt: $props.alt ? $props.alt : '',
    class: Object(external_vue_["normalizeClass"])($options.getClasses),
    id: $props.pictureComponent ? $props.id : null,
    src: $options.getImageSrc,
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, null, 14, NebulaImagevue_type_template_id_769a0fc8_hoisted_2)) : $props.assetId && !$data.imageExists ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
    key: 1,
    class: "nebula-image__icon",
    symbolId: $options.iconId
  }, null, 8, ["symbolId"])) : !$props.assetId ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("img", {
    key: 2,
    alt: $props.alt ? $props.alt : '',
    class: Object(external_vue_["normalizeClass"])($options.getClasses),
    id: $props.pictureComponent ? $props.id : null,
    sizes: $props.sizes ? $props.sizes : $options.getSizes,
    src: $options.getImageSrc,
    srcset: $props.srcset ? $props.srcset : $options.getSrcset,
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, null, 14, NebulaImagevue_type_template_id_769a0fc8_hoisted_3)) : Object(external_vue_["createCommentVNode"])("", true)], 8, NebulaImagevue_type_template_id_769a0fc8_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/Image/NebulaImage.vue?vue&type=template&id=769a0fc8

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("bc3a");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/@discoveryedu/nebula-icons/icons.json
var icons = __webpack_require__("772d");

// CONCATENATED MODULE: ./src/utils/nebula-icon-names.js

let flattenedIcons = [];
Object.keys(icons).forEach(key => {
  flattenedIcons = flattenedIcons.concat(icons[key]);
});
function nebulaIconNames() {
  return flattenedIcons;
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Image/NebulaImage.vue?vue&type=script&lang=js





/* eslint-disable global-require */

/* harmony default export */ var NebulaImagevue_type_script_lang_js = ({
  name: 'NebulaImage',
  mixins: [themingUtils],
  components: {
    NebulaIcon: NebulaIcon
  },

  data() {
    return {
      availableIcons: nebulaIconNames(),
      errorCounter: 0,
      imageExists: false,
      loading: false,
      loaded: false
    };
  },

  props: {
    alt: {
      type: String,
      default: null
    },
    assetId: {
      type: String,
      default: null
    },
    assetType: {
      type: String,
      default: null
    },
    contained: {
      type: Boolean,
      default: false
    },
    coreStaticAssetsPath: {
      type: String
    },
    covered: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    imageSize: {
      type: String,
      default: 'medium'
    },
    pictureComponent: {
      type: Boolean,
      default: false
    },
    sizes: {
      type: String,
      default: null
    },
    sizesItems: {
      type: [Object, Array],
      default: null
    },
    src: {
      type: String,
      default: null
    },
    srcset: {
      type: String,
      default: null
    },
    srcsetItems: {
      type: [Object, Array],
      default: null
    },
    thumbnailUrlOverride: {
      type: String
    }
  },
  computed: {
    getClasses() {
      return ['nebula-image', {
        'nebula-image--contained': this.contained,
        'nebula-image--covered': this.covered
      }];
    },

    getImageSrc() {
      // the additional props (thumbnailUrlOverride, coreStaticAssetsPath)
      // are so that NebulaImage is backwards compatible with ThumbnailLoader
      let imageSrc = '';

      if (this.assetId) {
        imageSrc = `https://d1m0scxbrw6oep.cloudfront.net/thumbnails/${this.assetId}-${this.imageSize}`;
      } else if (this.src) {
        imageSrc = this.src;
      } else if (this.thumbnailUrlOverride) {
        imageSrc = this.thumbnailUrlOverride;
      } else if (this.coreStaticAssetsPath) {
        imageSrc = this.coreStaticAssetsPath;
      }

      return imageSrc;
    },

    getSizes() {
      let sizesString = null;

      if (this.sizesItems) {
        const sizesMapped = this.sizesItems.map(item => `(${item.constraint}) ${item.size},\n\t`);
        sizesString = sizesMapped.join('');
      }

      return sizesString;
    },

    getSrcset() {
      let srcsetString = null;

      if (this.srcsetItems) {
        const srcsetMapped = this.srcsetItems.map(item => `${item.src} ${item.size},\n\t`);
        srcsetString = srcsetMapped.join('');
      }

      return srcsetString;
    },

    iconId() {
      if (this.assetType) {
        const assetTypeSlug = this.assetType.toLowerCase().replace(/[^a-z]/gi, '-');

        if (this.availableIcons.includes(`asset-${assetTypeSlug}`)) {
          return `asset-${assetTypeSlug}`;
        }
      }

      return 'asset-document';
    },

    iconSrc() {
      // eslint-disable-next-line import/no-dynamic-require
      return __webpack_require__("6b84")(`./${this.iconId}.svg`);
    },

    randomStringId() {
      return randomStringId();
    },

    tempEl() {
      return document.getElementById(this.tempId);
    },

    tempId() {
      return `nebula-image-tempid--${this.randomStringId}`;
    }

  },
  methods: {
    async checkImageUrl() {
      if (this.coreStaticAssetsPath) {
        this.setImageStatus();
        return;
      }

      try {
        const response = await axios_default.a.get(`${this.getImageSrc}?cacheline=corshead`).then(resp => resp).catch(err => err);
        if (response.status === 200) this.setImageStatus();
      } catch (err) {
        // TODO: handle errors in this api call.
        // eslint-disable-next-line
        console.log(`Image with asset id of ${this.assetId} has an err of ${err}`);
      }
    },

    removeWrapper() {
      // NebulaPicture component is broken by NebulaImage's logic containing div wrapper.
      // Extract the image node by checking for `nebula-image` class.
      // Replace the div wrapper with the image node.
      const nodes = [...this.tempEl.childNodes];
      let image;
      nodes.forEach(node => {
        if (node.classList && node.classList.contains('nebula-image')) {
          image = node;
        }
      });
      this.tempEl.replaceWith(image);
    },

    setImageStatus() {
      this.loading = true;
      setTimeout(() => {
        this.imageExists = true;
        setTimeout(() => {
          this.loaded = true;

          if (this.pictureComponent) {
            this.removeWrapper();
          }
        }, 200);
      }, 450);
    }

  },

  mounted() {
    if (this.assetId) {
      this.checkImageUrl();
    } else if (!this.assetId && this.pictureComponent) {
      this.removeWrapper();
    }
  }

});
// CONCATENATED MODULE: ./src/components/Image/NebulaImage.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Image/NebulaImage.vue?vue&type=style&index=0&id=769a0fc8&lang=stylus
var NebulaImagevue_type_style_index_0_id_769a0fc8_lang_stylus = __webpack_require__("82e1");

// CONCATENATED MODULE: ./src/components/Image/NebulaImage.vue







const NebulaImage_exports_ = /*#__PURE__*/exportHelper_default()(NebulaImagevue_type_script_lang_js, [['render',NebulaImagevue_type_template_id_769a0fc8_render]])

/* harmony default export */ var NebulaImage = (NebulaImage_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Tabs/NebulaTabs.vue?vue&type=template&id=011a329e

const NebulaTabsvue_type_template_id_011a329e_hoisted_1 = ["aria-label"];
const NebulaTabsvue_type_template_id_011a329e_hoisted_2 = ["role"];
const NebulaTabsvue_type_template_id_011a329e_hoisted_3 = {
  class: "nebula-menu-bar__responsive-menu"
};
const NebulaTabsvue_type_template_id_011a329e_hoisted_4 = {
  key: 0,
  class: "nebula-menu-bar__responsive-extras"
};

const NebulaTabsvue_type_template_id_011a329e_hoisted_5 = /*#__PURE__*/Object(external_vue_["createElementVNode"])("div", {
  class: "nebula-tabs__fade nebula-tabs__fade--left"
}, null, -1);

const NebulaTabsvue_type_template_id_011a329e_hoisted_6 = /*#__PURE__*/Object(external_vue_["createElementVNode"])("div", {
  class: "nebula-tabs__fade nebula-tabs__fade--right"
}, null, -1);

function NebulaTabsvue_type_template_id_011a329e_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaTabItem = Object(external_vue_["resolveComponent"])("NebulaTabItem");

  const _component_NebulaTabDropdown = Object(external_vue_["resolveComponent"])("NebulaTabDropdown");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaAccordionMenu = Object(external_vue_["resolveComponent"])("NebulaAccordionMenu");

  const _component_NebulaDropdown = Object(external_vue_["resolveComponent"])("NebulaDropdown");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: "nebula-tabs__container",
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [Object(external_vue_["createElementVNode"])("nav", {
    "aria-label": $options.getAriaLabel,
    class: Object(external_vue_["normalizeClass"])({
      'nebula-tabs__scrollable': !$props.tabs && !$props.menuBar
    }),
    ref: "tabsNav"
  }, [Object(external_vue_["createElementVNode"])("ul", {
    class: Object(external_vue_["normalizeClass"])($options.tabsClassName),
    ref: "tabsList",
    role: $props.roleTabList ? 'tablist' : null
  }, [$props.tabs && !$data.useResponsiveAccordion ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
    key: 0
  }, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.tabs, (tab, index) => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaTabItem, Object(external_vue_["mergeProps"])({
      key: tab.badgeText || tab.name || tab.tab.name
    }, tab, {
      "aria-controls": $props.roleTabList && $props.ariaControls ? $props.ariaControls : null,
      role: $props.roleTabList ? 'tab' : null,
      style: {
        display: $data.visibleTabs.includes(index) ? 'block' : 'none'
      }
    }), null, 16, ["aria-controls", "role", "style"]);
  }), 128)), Object(external_vue_["createVNode"])(_component_NebulaTabDropdown, {
    class: "nebula-tab-dropdown--overflow",
    closeOnSelect: "",
    name: $props.overflowLabel || _ctx.$t('More')
  }, {
    default: Object(external_vue_["withCtx"])(() => [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.tabs, (tab, index) => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaTabItem, Object(external_vue_["mergeProps"])({
        key: tab.badgeText || tab.name || tab.tab.name
      }, tab, {
        "aria-controls": $props.roleTabList && $props.ariaControls ? $props.ariaControls : null,
        role: $props.roleTabList ? 'tab' : null,
        style: {
          display: $data.overflowTabs.includes(index) ? 'block' : 'none'
        }
      }), null, 16, ["aria-controls", "role", "style"]);
    }), 128))]),
    _: 1
  }, 8, ["name"])], 64)) : Object(external_vue_["createCommentVNode"])("", true), $props.tabs && $data.useResponsiveAccordion ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
    key: 1
  }, [$data.showResponsiveAccordionView ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdown, Object(external_vue_["mergeProps"])({
    key: 0,
    buttonId: $options.getResponsiveDropdownButtonId,
    dropdownId: $options.getResponsiveDropdownMenuId,
    class: "nebula-menu-bar__responsive-dropdown",
    id: $options.getResponsiveDropdownId,
    alignToButtonStart: $props.responsiveMenuAlignToButtonStart,
    contentElement: "div",
    useWhiteBackground: ""
  }, $props.dropdownProps), {
    trigger: Object(external_vue_["withCtx"])(({
      toggleDropdown,
      checkArrowKeyOnTrigger,
      checkArrowKeyAfterTrigger,
      isOpen
    }) => [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      id: $options.getResponsiveDropdownButtonId,
      "aria-haspopup": "true",
      "aria-expanded": isOpen && 'true' || 'false',
      "aria-controls": $options.getResponsiveDropdownMenuId,
      text: $props.responsiveMenuButtonText ? $props.responsiveMenuButtonText : null,
      "icon-right": $props.responsiveMenuButtonIcon ? $props.responsiveMenuButtonText : 'menu',
      onClick: toggleDropdown,
      onKeydown: checkArrowKeyOnTrigger,
      onKeyup: checkArrowKeyAfterTrigger,
      "aria-label": !$props.responsiveMenuButtonText ? _ctx.$t('open menu') : null
    }, null, 8, ["id", "aria-expanded", "aria-controls", "text", "icon-right", "onClick", "onKeydown", "onKeyup", "aria-label"])]),
    content: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("div", NebulaTabsvue_type_template_id_011a329e_hoisted_3, [Object(external_vue_["createVNode"])(_component_NebulaAccordionMenu, {
      menuItems: $props.tabs
    }, null, 8, ["menuItems"]), $options.hasResponsiveExtrasSlot ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaTabsvue_type_template_id_011a329e_hoisted_4, [Object(external_vue_["renderSlot"])(_ctx.$slots, "responsiveExtras")])) : Object(external_vue_["createCommentVNode"])("", true)])]),
    _: 3
  }, 16, ["buttonId", "dropdownId", "id", "alignToButtonStart"])) : (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
    key: 1
  }, Object(external_vue_["renderList"])($props.tabs, tab => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])(tab.items ? 'NebulaTabDropdown' : 'NebulaTabItem'), Object(external_vue_["mergeProps"])({
      key: tab.badgeText || tab.name || tab.tab.name
    }, tab, {
      dropdownProps: $props.dropdownProps,
      role: !tab.items && $props.roleTabList ? 'tab' : null
    }), {
      default: Object(external_vue_["withCtx"])(() => [tab.items ? (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
        key: 0
      }, Object(external_vue_["renderList"])(tab.items, item => {
        return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaTabItem, Object(external_vue_["mergeProps"])({
          key: item.name,
          "aria-controls": $props.roleTabList && $props.ariaControls ? $props.ariaControls : null,
          role: $props.roleTabList ? 'tab' : null
        }, item), null, 16, ["aria-controls", "role"]);
      }), 128)) : Object(external_vue_["createCommentVNode"])("", true)]),
      _: 2
    }, 1040, ["dropdownProps", "role"]);
  }), 128))], 64)) : Object(external_vue_["createCommentVNode"])("", true), $options.hasTabsSlot ? Object(external_vue_["renderSlot"])(_ctx.$slots, "tabs", {
    key: 2
  }) : Object(external_vue_["createCommentVNode"])("", true)], 10, NebulaTabsvue_type_template_id_011a329e_hoisted_2)], 10, NebulaTabsvue_type_template_id_011a329e_hoisted_1), !$props.tabs && !$props.menuBar && $data.showFades ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
    key: 0
  }, [NebulaTabsvue_type_template_id_011a329e_hoisted_5, NebulaTabsvue_type_template_id_011a329e_hoisted_6], 64)) : Object(external_vue_["createCommentVNode"])("", true)], 4);
}
// CONCATENATED MODULE: ./src/components/Tabs/NebulaTabs.vue?vue&type=template&id=011a329e

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Accordion/NebulaAccordionMenu.vue?vue&type=template&id=568ecda6

const NebulaAccordionMenuvue_type_template_id_568ecda6_hoisted_1 = {
  class: "nebula-accordion-menu"
};
const NebulaAccordionMenuvue_type_template_id_568ecda6_hoisted_2 = {
  key: 0
};
function NebulaAccordionMenuvue_type_template_id_568ecda6_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaAccordion = Object(external_vue_["resolveComponent"])("NebulaAccordion");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaAccordionMenuvue_type_template_id_568ecda6_hoisted_1, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.menuItems, menuItem => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaAccordion, {
      key: menuItem.name,
      menuItem: menuItem,
      mode: "flat"
    }, {
      default: Object(external_vue_["withCtx"])(() => [menuItem.items ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaAccordionMenuvue_type_template_id_568ecda6_hoisted_2, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(menuItem.items, subMenuItem => {
        return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
          key: subMenuItem.name,
          text: subMenuItem.name,
          class: Object(external_vue_["normalizeClass"])(subMenuItem.selected && 'nebula-accordion__menu-item--selected'),
          size: "s",
          type: "flat",
          link: subMenuItem.url ? subMenuItem.url : null,
          routerLink: subMenuItem.useRouterLink ? subMenuItem.useRouterLink : null
        }, null, 8, ["text", "class", "link", "routerLink"]);
      }), 128))])) : Object(external_vue_["createCommentVNode"])("", true)]),
      _: 2
    }, 1032, ["menuItem"]);
  }), 128))]);
}
// CONCATENATED MODULE: ./src/components/Accordion/NebulaAccordionMenu.vue?vue&type=template&id=568ecda6

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Accordion/NebulaAccordionMenu.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaAccordionMenuvue_type_script_lang_js = ({
  name: 'NebulaAccordionMenu',
  components: {
    NebulaAccordion: NebulaAccordion,
    NebulaButton: NebulaButton
  },
  props: {
    menuItems: {
      type: [Array, Object],
      default: null
    }
  }
});
// CONCATENATED MODULE: ./src/components/Accordion/NebulaAccordionMenu.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Accordion/NebulaAccordionMenu.vue?vue&type=style&index=0&id=568ecda6&lang=stylus
var NebulaAccordionMenuvue_type_style_index_0_id_568ecda6_lang_stylus = __webpack_require__("5a33");

// CONCATENATED MODULE: ./src/components/Accordion/NebulaAccordionMenu.vue







const NebulaAccordionMenu_exports_ = /*#__PURE__*/exportHelper_default()(NebulaAccordionMenuvue_type_script_lang_js, [['render',NebulaAccordionMenuvue_type_template_id_568ecda6_render]])

/* harmony default export */ var NebulaAccordionMenu = (NebulaAccordionMenu_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Tabs/NebulaTabDropdown.vue?vue&type=template&id=482cb0a6

function NebulaTabDropdownvue_type_template_id_482cb0a6_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaTabItem = Object(external_vue_["resolveComponent"])("NebulaTabItem");

  const _component_NebulaDropdown = Object(external_vue_["resolveComponent"])("NebulaDropdown");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdown, Object(external_vue_["mergeProps"])({
    alignToButtonStart: "",
    dropdownWrapperClass: "nebula-tab-dropdown",
    useWhiteBackground: "",
    dropdownElement: "li",
    dropdownId: $options.getDropdownId,
    style: _ctx.cssProps
  }, $props.dropdownProps), {
    trigger: Object(external_vue_["withCtx"])(({
      toggleDropdown,
      checkArrowKeyOnTrigger,
      checkArrowKeyAfterTrigger,
      isOpen,
      id
    }) => [Object(external_vue_["createVNode"])(_component_NebulaTabItem, Object(external_vue_["mergeProps"])(_ctx.$attrs, {
      buttonId: id,
      dropdownId: $options.getDropdownId,
      isOpen: isOpen,
      isDropdown: true,
      onToggleTabDropdown: toggleDropdown,
      tabItemElement: "div",
      checkArrowKeyOnTrigger: checkArrowKeyOnTrigger,
      checkArrowKeyAfterTrigger: checkArrowKeyAfterTrigger
    }), null, 16, ["buttonId", "dropdownId", "isOpen", "onToggleTabDropdown", "checkArrowKeyOnTrigger", "checkArrowKeyAfterTrigger"])]),
    content: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")]),
    _: 3
  }, 16, ["dropdownId", "style"]);
}
// CONCATENATED MODULE: ./src/components/Tabs/NebulaTabDropdown.vue?vue&type=template&id=482cb0a6

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Tabs/NebulaTabItem.vue?vue&type=template&id=6c86c15e

function NebulaTabItemvue_type_template_id_6c86c15e_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaBadge = Object(external_vue_["resolveComponent"])("NebulaBadge");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.tabItemElement), {
    class: Object(external_vue_["normalizeClass"])($options.tabItemClassName),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, {
    default: Object(external_vue_["withCtx"])(() => [$props.tab && $props.tab.url || $props.url ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
      key: 0,
      class: Object(external_vue_["normalizeClass"])(['nebula-tabs__tab-link', {
        'do-push-state': $props.pushStateLink === true || $props.usePushState === true // TODO: Remove pushStateLink condition

      }]),
      ariaLabel: $props.tab && $props.tab.ariaLabel ? $props.tab.ariaLabel : $props.ariaLabel,
      "aria-control": $props.ariaControls,
      "aria-selected": $options.ariaSelected,
      "data-skip-load": $props.skipLoad,
      id: $props.buttonId,
      isDisabled: $options.getIsDisabled,
      link: $props.tab && $props.tab.url ? $props.tab.url : $props.url,
      role: $props.role,
      routerLink: $props.tab && $props.tab.useRouterLink ? $props.tab.useRouterLink : $props.useRouterLink,
      size: $props.buttonSize,
      text: $options.getTabName,
      type: "flat",
      onFocus: _cache[0] || (_cache[0] = $event => _ctx.$emit('focus')),
      onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('click', $event))
    }, Object(external_vue_["createSlots"])({
      _: 2
    }, [$props.badgeText ? {
      name: "badgeWithText",
      fn: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaBadge, {
        color: $props.badgeColor ? $props.badgeColor : null,
        size: $props.badgeSize ? $props.badgeSize : null,
        type: $props.badgeType
      }, {
        outerTextStart: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])($options.getBadgeOuterText), 1)]),
        default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(" " + Object(external_vue_["toDisplayString"])($props.badgeText), 1)]),
        _: 1
      }, 8, ["color", "size", "type"])]),
      key: "0"
    } : undefined]), 1032, ["class", "ariaLabel", "aria-control", "aria-selected", "data-skip-load", "id", "isDisabled", "link", "role", "routerLink", "size", "text"])) : (!$props.tab || !$props.url) && $props.isDropdown ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
      key: 1,
      id: $props.buttonId,
      class: Object(external_vue_["normalizeClass"])(['nebula-tabs__tab-link', {
        'do-push-state': $props.pushStateLink === true || $props.usePushState === true // TODO: Remove pushStateLink condition

      }]),
      "data-skip-load": $props.skipLoad,
      type: "flat",
      size: $props.buttonSize,
      text: $options.getTabName,
      "aria-haspopup": "true",
      isDisabled: $options.getIsDisabled,
      "aria-label": _ctx.$t('open menu'),
      "aria-controls": $props.dropdownId,
      "aria-expanded": $props.isOpen && 'true' || 'false',
      onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('toggle-tab-dropdown')),
      onKeydown: $props.checkArrowKeyOnTrigger,
      onKeyup: $props.checkArrowKeyAfterTrigger
    }, Object(external_vue_["createSlots"])({
      _: 2
    }, [$props.badgeText ? {
      name: "badgeWithText",
      fn: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaBadge, {
        color: $props.badgeColor ? $props.badgeColor : null,
        size: $props.badgeSize ? $props.badgeSize : null,
        type: $props.badgeType
      }, {
        outerTextStart: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])($options.getBadgeOuterText), 1)]),
        default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(" " + Object(external_vue_["toDisplayString"])($props.badgeText), 1)]),
        _: 1
      }, 8, ["color", "size", "type"])]),
      key: "0"
    } : undefined]), 1032, ["id", "class", "data-skip-load", "size", "text", "isDisabled", "aria-label", "aria-controls", "aria-expanded", "onKeydown", "onKeyup"])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
      key: 2,
      class: Object(external_vue_["normalizeClass"])(['nebula-tabs__tab-link', {
        'do-push-state': $props.pushStateLink === true || $props.usePushState === true // TODO: Remove pushStateLink condition

      }]),
      ariaLabel: $props.tab && $props.tab.ariaLabel ? $props.tab.ariaLabel : $props.ariaLabel,
      "aria-control": $props.ariaControls,
      "aria-selected": $options.ariaSelected,
      "data-skip-load": $props.skipLoad,
      isDisabled: $options.getIsDisabled,
      role: $props.role,
      size: $props.buttonSize,
      text: $options.getTabName,
      type: "flat",
      onFocus: _cache[3] || (_cache[3] = $event => _ctx.$emit('focus')),
      onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('click', $event))
    }, Object(external_vue_["createSlots"])({
      _: 2
    }, [$props.badgeText ? {
      name: "badgeWithText",
      fn: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaBadge, {
        color: $props.badgeColor,
        size: $props.badgeSize ? $props.badgeSize : null,
        type: $props.badgeType
      }, {
        outerTextStart: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])($options.getBadgeOuterText), 1)]),
        default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(" " + Object(external_vue_["toDisplayString"])($props.badgeText), 1)]),
        _: 1
      }, 8, ["color", "size", "type"])]),
      key: "0"
    } : undefined]), 1032, ["class", "ariaLabel", "aria-control", "aria-selected", "data-skip-load", "isDisabled", "role", "size", "text"])), $props.isDropdown ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
      key: 3,
      "aria-label": _ctx.$t('open menu'),
      "aria-controls": $props.dropdownId,
      "aria-expanded": $props.isOpen && 'true' || 'false',
      "aria-haspopup": "true",
      class: "nebula-tabs__tab-dropdown-btn",
      iconLeft: "caret-down",
      size: $props.buttonSize,
      type: "flat",
      onClick: _cache[5] || (_cache[5] = $event => _ctx.$emit('toggle-tab-dropdown')),
      onKeydown: $props.checkArrowKeyOnTrigger,
      onKeyup: $props.checkArrowKeyAfterTrigger
    }, null, 8, ["aria-label", "aria-controls", "aria-expanded", "size", "onKeydown", "onKeyup"])) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 1
  }, 8, ["class", "style"]);
}
// CONCATENATED MODULE: ./src/components/Tabs/NebulaTabItem.vue?vue&type=template&id=6c86c15e

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Tabs/NebulaTabItem.vue?vue&type=script&lang=js



/* harmony default export */ var NebulaTabItemvue_type_script_lang_js = ({
  name: 'NebulaTabItem',
  components: {
    NebulaButton: NebulaButton,
    NebulaBadge: NebulaBadge
  },
  mixins: [themingUtils],
  props: {
    ariaControls: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String
    },
    badgeColor: {
      default: 'gray',
      type: String
    },
    badgeSize: {
      type: String
    },
    badgeText: {
      type: String
    },
    badgeType: {
      type: String
    },
    buttonId: {
      type: String
    },
    buttonSize: {
      default: 's',
      type: String
    },
    checkArrowKeyAfterTrigger: {
      type: Function
    },
    checkArrowKeyOnTrigger: {
      type: Function
    },
    dropdownId: {
      type: String,
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isDropdown: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    //
    // pushStateLink has been deprecated.
    // Prefer use of usePushState prop instead.
    //
    pushStateLink: {
      type: Boolean,
      default: false
    },
    role: {
      type: String,
      default: null
    },
    selected: {
      type: Boolean,
      default: false
    },
    skipLoad: {
      type: Boolean,
      default: false
    },
    tab: {
      type: Object
    },
    tabItemElement: {
      default: 'li',
      type: String
    },
    url: {
      type: String
    },
    usePushState: {
      type: Boolean,
      default: false
    },
    useRouterLink: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click', 'focus', 'toggle-tab-dropdown'],
  computed: {
    ariaSelected() {
      return this.selected ? 'true' : 'false';
    },

    getBadgeOuterText() {
      let badgeOuterText = this.name;

      if (this.tab && this.tab.name && this.badgeText) {
        badgeOuterText = this.tab.name;
      }

      return badgeOuterText;
    },

    getIsDisabled() {
      let isDisabled = false;

      if (this.tab && this.tab.isDisabled === 'true' || this.isDisabled) {
        isDisabled = true;
      }

      return isDisabled;
    },

    getTabName() {
      let tabName = null;

      if (this.tab && this.tab.name && !this.badgeText) {
        tabName = this.tab.name;
      } else if (this.name && !this.badgeText) {
        tabName = this.name;
      }

      return tabName;
    },

    isSelected() {
      return this.tab && this.tab.selected || this.selected;
    },

    tabItemClassName() {
      const className = ['nebula-tabs__list-item', {
        'nebula-tabs__list-item--selected': this.isSelected,
        'nebula-tabs__list-item--disabled': this.getIsDisabled,
        'nebula-tabs__list-item--dropdown': this.isDropdown
      }];
      return className;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Tabs/NebulaTabItem.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Tabs/NebulaTabItem.vue?vue&type=style&index=0&id=6c86c15e&lang=stylus
var NebulaTabItemvue_type_style_index_0_id_6c86c15e_lang_stylus = __webpack_require__("a846");

// CONCATENATED MODULE: ./src/components/Tabs/NebulaTabItem.vue







const NebulaTabItem_exports_ = /*#__PURE__*/exportHelper_default()(NebulaTabItemvue_type_script_lang_js, [['render',NebulaTabItemvue_type_template_id_6c86c15e_render]])

/* harmony default export */ var NebulaTabItem = (NebulaTabItem_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Tabs/NebulaTabDropdown.vue?vue&type=script&lang=js




/* harmony default export */ var NebulaTabDropdownvue_type_script_lang_js = ({
  name: 'NebulaTabDropdown',
  inheritAttrs: false,
  components: {
    NebulaDropdown: NebulaDropdown,
    NebulaTabItem: NebulaTabItem
  },
  mixins: [themingUtils],
  computed: {
    getDropdownId() {
      return `nebula-tab-dropdown--${this.randomStringId}`;
    },

    randomStringId() {
      return randomStringId();
    }

  },
  props: {
    dropdownProps: {
      type: Object
    }
  }
});
// CONCATENATED MODULE: ./src/components/Tabs/NebulaTabDropdown.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Tabs/NebulaTabDropdown.vue?vue&type=style&index=0&id=482cb0a6&lang=stylus
var NebulaTabDropdownvue_type_style_index_0_id_482cb0a6_lang_stylus = __webpack_require__("a536");

// CONCATENATED MODULE: ./src/components/Tabs/NebulaTabDropdown.vue







const NebulaTabDropdown_exports_ = /*#__PURE__*/exportHelper_default()(NebulaTabDropdownvue_type_script_lang_js, [['render',NebulaTabDropdownvue_type_template_id_482cb0a6_render]])

/* harmony default export */ var NebulaTabDropdown = (NebulaTabDropdown_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Tabs/NebulaTabs.vue?vue&type=script&lang=js









const MIN_BUFFER_LENGTH = 8; // Pixels. This should provide some extra space on the right of the more button.

const TAB_GAP = 24; // Pixels. This should match the size of the gap between tabs in CSS.

/* harmony default export */ var NebulaTabsvue_type_script_lang_js = ({
  name: 'NebulaTabs',
  components: {
    NebulaAccordionMenu: NebulaAccordionMenu,
    NebulaButton: NebulaButton,
    NebulaDropdown: NebulaDropdown,
    NebulaTabDropdown: NebulaTabDropdown,
    NebulaTabItem: NebulaTabItem
  },
  mixins: [themingUtils],

  data() {
    return {
      lastContainerWidth: -1,
      // -1 means this the first time reading this value.
      maxMenuBarWidth: 0,
      overflowButtonWidth: 0,
      overflowResizeListener: null,
      overflowTabs: [],
      // An array of indices of tabs that should show in the overflow menu
      resizeObserver: null,
      showResponsiveAccordionView: false,
      scrollResizeListener: null,
      showFades: false,
      tabWidths: [],
      useResponsiveAccordion: false,
      visibleTabs: [],
      // An array of indices of tabs that should show normally
      widthsCalculated: false
    };
  },

  props: {
    ariaControls: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String
    },
    buttonMarginInline: {
      type: Number,
      default: 16
    },
    dropdownProps: {
      type: Object
    },
    id: {
      type: [String, Number]
    },
    noBorderBottom: {
      type: Boolean,
      default: false
    },
    menuItems: {
      type: Array,
      default: null
    },
    menuBar: {
      type: Boolean,
      default: false
    },
    overflowLabel: {
      type: String,
      default: null // the fallback is handled in the template since $t is not available here

    },
    responsiveMenuAlignToButtonStart: {
      type: Boolean,
      default: true
    },
    responsiveMenuButtonIcon: {
      type: String,
      default: null
    },
    responsiveMenuButtonText: {
      type: String,
      default: null
    },
    roleTabList: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Array,
      default: null
    },
    useFlatButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getAriaLabel() {
      return this.ariaLabel ? this.ariaLabel : this.$t('tab navigation');
    },

    getResponsiveDropdownId() {
      return `nebula-tabs-responsive--${this.randomStringId}`;
    },

    getResponsiveDropdownButtonId() {
      return `nebula-tabs-responsive__dropdown-button--${this.randomStringId}`;
    },

    getResponsiveDropdownMenuId() {
      return `nebula-tabs-responsive__dropdown-menu--${this.randomStringId}`;
    },

    getTabsListEl() {
      return this.$el.getElementsByClassName('nebula-tabs__list')[0];
    },

    hasTabsSlot() {
      return !!this.$slots.tabs;
    },

    hasResponsiveExtrasSlot() {
      return !!this.$slots.responsiveExtras;
    },

    randomStringId() {
      return randomStringId();
    },

    tabsClassName() {
      const className = ['nebula-tabs__list', {
        'nebula-tabs__list--border': this.noBorderBottom === false,
        'nebula-tabs__list--no-border': this.noBorderBottom === true,
        'nebula-tabs__list--no-flat-buttons': this.useFlatButton === false,
        'nebula-tabs__list--widths-calculated': !this.tabs || this.widthsCalculated === true,
        'nebula-tabs__list--overflow-empty': this.overflowTabs.length === 0 && !this.menuBar
      }];
      return className;
    }

  },
  methods: {
    async calculateMaxTabsWidth() {
      const tabList = this.getTabsListEl;
      /* eslint-disable prefer-destructuring */

      const children = tabList.children;
      /* eslint-enable prefer-destructuring */

      this.$nextTick(() => {
        for (let i = 0; i < children.length; i += 1) {
          this.maxMenuBarWidth += children[i].clientWidth + this.buttonMarginInline;
        }
      });
    },

    async calculateWidths() {
      var _children$item;

      this.widthsCalculated = false;
      this.visibleTabs = [...Array(this.tabs.length).keys()];
      this.overflowTabs = [];
      await this.$nextTick(); // flush changes so we can measure all tabs

      const newTabWidths = [];
      const {
        children
      } = this.$refs.tabsList;

      for (let i = 0; i < this.visibleTabs.length; i += 1) {
        newTabWidths.push(children.item(i).clientWidth);
      }

      this.overflowButtonWidth = ((_children$item = children.item(this.visibleTabs.length)) === null || _children$item === void 0 ? void 0 : _children$item.clientWidth) || 0;
      this.tabWidths = newTabWidths;
      this.widthsCalculated = true;
    },

    determineView(newWidth) {
      let increasing = true;

      if (newWidth <= this.lastContainerWidth) {
        increasing = false;
      }

      if (increasing) {
        if (this.maxMenuBarWidth < newWidth) {
          this.showResponsiveAccordionView = false;
        }
      }

      if (this.maxMenuBarWidth > newWidth) {
        this.showResponsiveAccordionView = true;
      } else {
        this.showResponsiveAccordionView = false;
      }

      this.lastContainerWidth = newWidth;
      this.widthsCalculated = true;
    },

    shiftToOverflow() {
      if (!this.visibleTabs.length) return;
      const newVisible = [...this.visibleTabs];
      const newOverflow = [newVisible.pop(), ...this.overflowTabs];
      this.visibleTabs = newVisible;
      this.overflowTabs = newOverflow;
    },

    shiftToVisible() {
      if (!this.overflowTabs.length) return;
      const newOverflow = [...this.overflowTabs];
      const newVisible = [...this.visibleTabs, newOverflow.shift()];
      this.visibleTabs = newVisible;
      this.overflowTabs = newOverflow;
    },

    updateFades() {
      const scrollableEl = this.$refs.tabsNav;
      const tabsListEl = this.$refs.tabsList;

      if (scrollableEl.clientWidth < tabsListEl.scrollWidth) {
        this.showFades = true;
      } else {
        this.showFades = false;
      }
    },

    updateOverflow(newSize) {
      var _this$$refs$tabsList;

      if (!this.tabs) return; // Determine if the container is increasing or decreasing

      const containerWidth = newSize || ((_this$$refs$tabsList = this.$refs.tabsList) === null || _this$$refs$tabsList === void 0 ? void 0 : _this$$refs$tabsList.clientWidth) || 0;
      let increasing = true;

      if (containerWidth <= this.lastContainerWidth) {
        increasing = false;
      } // Figure out how much space we currently need to show all visible tabs


      let requiredWidth = this.overflowButtonWidth + MIN_BUFFER_LENGTH;
      this.tabWidths.forEach((tabWidth, index) => {
        if (this.visibleTabs.includes(index)) {
          requiredWidth += this.tabWidths[index];
        }
      }); // Add space for gaps between tabs

      requiredWidth += this.visibleTabs.length > 0 ? (this.visibleTabs.length - 1) * TAB_GAP : 0; // Logic to either add/remove elements to the tab overflow dropdown

      if (requiredWidth > containerWidth && (this.lastContainerWidth === -1 || !increasing)) {
        // Container is too small, we need to hide some tabs
        while (this.visibleTabs.length && requiredWidth > containerWidth) {
          // If we can still hide more, hide an element and queue another run.
          const widthToHide = this.tabWidths[this.visibleTabs[this.visibleTabs.length - 1]];
          requiredWidth -= widthToHide + TAB_GAP;
          this.shiftToOverflow();
        }
      } else if (increasing) {
        // Container may have enough space for more tabs, show more items (if any)
        while (this.overflowTabs.length && requiredWidth < containerWidth) {
          // Calculate the new width if we add back the next tab.
          const widthToShow = this.tabWidths[this.overflowTabs[0]];
          requiredWidth += widthToShow + TAB_GAP; // If we don't have enough space to add back any more tabs, then break;

          if (requiredWidth > containerWidth) break;
          this.shiftToVisible();
        }
      }

      this.lastContainerWidth = containerWidth;
    }

  },

  mounted() {
    if (this.tabs) {
      // if tabs array contains submenus, use responsive accordion dropdown
      // else use More overflow dropdown
      // if no tabs array use scrollbar container
      // check for items to indicate dropdown
      Object.entries(this.tabs).forEach(tab => {
        Object.entries(tab[1]).forEach(tabItems => {
          if (tabItems[0] === 'items') {
            this.useResponsiveAccordion = true;
          }
        });
      });

      if (this.useResponsiveAccordion) {
        this.accordionListener = lodash_es_throttle(this.determineView.bind(this), 100, {
          trailing: true
        });
        this.resizeAccordionObserver = new ResizeObserver_es["a" /* default */](entries => {
          entries.forEach(entry => {
            if (entry.contentBoxSize) {
              this.accordionListener(entry.contentBoxSize[0].inlineSize);
            } else {
              this.accordionListener(entry.contentRect.width);
            }
          });
        });
        this.resizeAccordionObserver.observe(this.$refs.tabsList);
        this.calculateMaxTabsWidth().then(() => this.determineView());
      } else {
        this.overflowResizeListener = lodash_es_throttle(this.updateOverflow.bind(this), 100, {
          trailing: true
        });
        this.resizeObserver = new ResizeObserver_es["a" /* default */](entries => {
          entries.forEach(entry => {
            if (entry.contentBoxSize) {
              this.overflowResizeListener(entry.contentBoxSize[0].inlineSize);
            } else {
              this.overflowResizeListener(entry.contentRect.width);
            }
          });
        });
        this.resizeObserver.observe(this.$refs.tabsList);
        this.calculateWidths().then(() => this.updateOverflow());
      }
    } else if (!this.menuBar && !this.useResponsiveAccordion) {
      this.scrollResizeListener = lodash_es_throttle(this.updateFades.bind(this), 150);
      window.addEventListener('resize', this.scrollResizeListener);
      this.updateFades();
    }
  },

  watch: {
    tabs(newVal) {
      // Whenever the tabs array is updated, recalculate widths
      if (newVal && newVal.length) {
        if (this.useResponsiveAccordion) {
          this.calculateMaxTabsWidth();
        } else {
          this.calculateWidths();
        }
      }
    }

  },

  beforeUnmount() {
    window.removeEventListener('resize', this.scrollResizeListener);

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    if (this.resizeAccordionObserver) {
      this.resizeAccordionObserver.disconnect();
    }
  }

});
// CONCATENATED MODULE: ./src/components/Tabs/NebulaTabs.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Tabs/NebulaTabs.vue?vue&type=style&index=0&id=011a329e&lang=stylus
var NebulaTabsvue_type_style_index_0_id_011a329e_lang_stylus = __webpack_require__("9020");

// CONCATENATED MODULE: ./src/components/Tabs/NebulaTabs.vue







const NebulaTabs_exports_ = /*#__PURE__*/exportHelper_default()(NebulaTabsvue_type_script_lang_js, [['render',NebulaTabsvue_type_template_id_011a329e_render]])

/* harmony default export */ var NebulaTabs = (NebulaTabs_exports_);
// CONCATENATED MODULE: ./src/utils/pagination/link-generators/page.js

/**
 * PageGenerator
 *
 * This page-link generator is based on the "per-page"
 * pagination model.
 *
 * const generator = new PageGenerator({
 *      baseUrl: '/cards-sink?q=&language_family_code=eng&sort_by=popular',
 *      page: 526,
 *      perPage: 19,
 *      totalRecords: 72567,
 *      usePushState: false,
 *      useRouterLink: true,
 * });
 *
 */

class page_PageGenerator extends base {
  getPageLink(pageNumber) {
    const params = {};
    params[this.perPageParamName] = this.perPage;
    params[this.pageParamName] = pageNumber;
    const pageUrl = this.getUrlWithQueryParams(params);
    return pageUrl;
  }

  initialize(opts) {
    this.page = opts.page || 1;
    this.perPage = opts.perPage || 10;
    this.totalRecords = opts.totalRecords || 0;
    this.pageParamName = opts.pageParamName || 'page';
    this.perPageParamName = opts.perPageParamName || 'per_page';
    super.initialize(opts);
  }

  updateMetadata() {
    this.currentPageNumber = this.page;
    this.numberOfPages = Math.ceil(this.totalRecords / this.perPage);
  }

}

/* harmony default export */ var page = (page_PageGenerator);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ActionBar/NebulaActionBar.vue?vue&type=script&lang=js











/* harmony default export */ var NebulaActionBarvue_type_script_lang_js = ({
  name: 'NebulaActionBar',
  components: {
    NebulaBreadcrumbs: NebulaBreadcrumbs,
    NebulaButton: NebulaButton,
    NebulaDropdown: NebulaDropdown,
    NebulaDropdownItem: NebulaDropdownItem,
    NebulaDropdownPagination: NebulaDropdownPagination,
    NebulaImage: NebulaImage,
    NebulaTabs: NebulaTabs
  },

  data() {
    return {
      showResponsiveActionsView: false
    };
  },

  props: {
    backButton: Object,
    breadcrumbDropdownUseRouterLinks: Boolean,
    breadcrumbs: Array,
    dropdownActions: Object,
    dropdownButtonId: {
      type: String,
      default: null
    },
    dropdownItems: Array,
    dropdownItemsPosition: {
      type: String,
      default: 'first',

      validator(val) {
        const supported = ['first', 'last'];
        return supported.includes(val);
      }

    },
    ellipsisActionsAreaByDefault: Boolean,
    ellipsisTitleAtMobile: Boolean,
    hideTabBorders: Boolean,
    hideTitleAtMobile: Boolean,
    logoConfig: {
      type: Object,
      default: null
    },
    paging: Object,
    profileAvatar: Object,
    responsiveActionsWidthThreshold: {
      type: Number,
      default: null
    },
    responsiveBreadcrumbsPageWidthThreshold: {
      type: Number,
      default: 480
    },
    showDimText: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Array,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  },
  emits: ['onBackButtonClick'],
  computed: {
    getDropdownButtonId() {
      return `nebula-action-bar__dropdown-button--${this.randomStringId}`;
    },

    getDropdownMenuId() {
      return `nebula-action-bar__dropdown-menu--${this.randomStringId}`;
    },

    getWrapperClass() {
      const className = [{
        'nebula-action-bar__breadcrumbs-container': !this.title,
        'nebula-action-bar__title-grid': this.title,
        'nebula-action-bar__title-grid--hide-title-mobile': this.title && this.hideTitleAtMobile,
        'nebula-action-bar__title-grid--ellipsis-title-mobile': this.title && this.ellipsisTitleAtMobile
      }];
      return className;
    },

    showActionMenuPositionFirst() {
      return !(this.dropdownItemsPosition === 'first' && this.hasActionBarButtonsSlot);
    },

    showActionMenuPositionLast() {
      return !(this.dropdownItemsPosition === 'last' && this.hasActionBarButtonsSlot);
    },

    hasActionBarButtonsSlot() {
      return !!this.$slots.actionBarButtons;
    },

    hasDropdownItemsSlot() {
      return !!this.$slots.dropdownItems;
    },

    hasMenuSlot() {
      return !!this.$slots.menu;
    },

    hasResponsiveActionButtonsSlot() {
      return !!this.$slots.responsiveActionButtons;
    },

    linkGenerator() {
      if (!this.paging) {
        return null;
      }

      const linkGenerator = new page({
        page: this.paging.page,
        perPage: this.paging.per_page,
        totalRecords: this.paging.total_count || this.paging.total_recs || 0
      });
      return linkGenerator;
    },

    parsedItems() {
      let matchIndex;
      const dropdownItems = [...this.dropdownItems]; // if actions are passed in, include them in the DropdownItem data

      if (this.dropdownActions) {
        Object.keys(this.dropdownActions).forEach(text => {
          const match = dropdownItems.find((each, idx) => {
            // for each dropdown item, check if there's a matching action being
            // passed through via actions prop
            if (each.text === text) {
              matchIndex = idx;
            }

            return each.text === text;
          });

          if (match) {
            const actionObj = {
              action: this.dropdownActions[text]
            };
            dropdownItems[matchIndex] = { ...dropdownItems[matchIndex],
              ...actionObj
            };
          }
        });
      }

      return dropdownItems;
    },

    randomStringId() {
      return randomStringId();
    },

    outerWrapperClasses() {
      return {
        'nebula-action-bar--with-tabs': !!this.tabs
      };
    }

  },
  methods: {
    checkResponsiveActionsView(newWidth) {
      if (this.responsiveActionsWidthThreshold) {
        if (newWidth <= this.responsiveActionsWidthThreshold) {
          this.showResponsiveActionsView = true;
        } else {
          this.showResponsiveActionsView = false;
        }
      } else if (newWidth <= 767 && (this.hasActionBarButtonsSlot || this.dropdownItems || this.hasDropdownItemsSlot) || this.ellipsisActionsAreaByDefault) {
        this.showResponsiveActionsView = true;
      } else {
        this.showResponsiveActionsView = false;
      }
    },

    selectNextPage(page) {
      this.page = page - 1;
    }

  },

  mounted() {
    this.actionBarResizeListener = lodash_es_throttle(this.checkResponsiveActionsView.bind(this), 100, {
      trailing: true
    });
    this.resizeObserver = new ResizeObserver_es["a" /* default */](entries => {
      entries.forEach(entry => {
        if (entry.contentBoxSize) {
          this.actionBarResizeListener(entry.contentBoxSize[0].inlineSize);
        } else {
          this.actionBarResizeListener(entry.contentRect.width);
        }
      });
    });
    this.resizeObserver.observe(this.$refs.actionBarContainer);
    this.checkResponsiveActionsView();
  },

  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

});
// CONCATENATED MODULE: ./src/components/ActionBar/NebulaActionBar.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/ActionBar/NebulaActionBar.vue?vue&type=style&index=0&id=b8afe756&lang=stylus
var NebulaActionBarvue_type_style_index_0_id_b8afe756_lang_stylus = __webpack_require__("f012");

// CONCATENATED MODULE: ./src/components/ActionBar/NebulaActionBar.vue







const NebulaActionBar_exports_ = /*#__PURE__*/exportHelper_default()(NebulaActionBarvue_type_script_lang_js, [['render',NebulaActionBarvue_type_template_id_b8afe756_render]])

/* harmony default export */ var NebulaActionBar = (NebulaActionBar_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Banner/NebulaBanner.vue?vue&type=template&id=619c3c24

const NebulaBannervue_type_template_id_619c3c24_hoisted_1 = {
  class: "nebula-banner__inner"
};
const NebulaBannervue_type_template_id_619c3c24_hoisted_2 = ["src"];
const NebulaBannervue_type_template_id_619c3c24_hoisted_3 = {
  class: "nebula-banner__content"
};
const NebulaBannervue_type_template_id_619c3c24_hoisted_4 = {
  class: "nebula-banner__headline"
};
const NebulaBannervue_type_template_id_619c3c24_hoisted_5 = {
  key: 0,
  class: "nebula-banner__description"
};
const NebulaBannervue_type_template_id_619c3c24_hoisted_6 = {
  key: 1,
  class: "nebula-banner__buttons"
};
function NebulaBannervue_type_template_id_619c3c24_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: "nebula-banner__container",
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [Object(external_vue_["createElementVNode"])("div", NebulaBannervue_type_template_id_619c3c24_hoisted_1, [(Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.bannerElement), {
    class: Object(external_vue_["normalizeClass"])($options.bannerClassName),
    href: $props.link && $options.bannerElementIsLink ? $props.link : null,
    style: Object(external_vue_["normalizeStyle"])($options.gradientValues),
    target: $props.target && $options.bannerElementIsLink ? $props.target : null
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("img", {
      src: $props.image,
      alt: "",
      class: Object(external_vue_["normalizeClass"])($options.imageClassNames)
    }, null, 10, NebulaBannervue_type_template_id_619c3c24_hoisted_2), Object(external_vue_["createElementVNode"])("section", NebulaBannervue_type_template_id_619c3c24_hoisted_3, [Object(external_vue_["createElementVNode"])("h3", NebulaBannervue_type_template_id_619c3c24_hoisted_4, Object(external_vue_["toDisplayString"])($props.headline), 1), $props.description ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", NebulaBannervue_type_template_id_619c3c24_hoisted_5, Object(external_vue_["toDisplayString"])($props.description), 1)) : Object(external_vue_["createCommentVNode"])("", true), $props.buttons ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaBannervue_type_template_id_619c3c24_hoisted_6, [Object(external_vue_["renderSlot"])(_ctx.$slots, "button-area")])) : Object(external_vue_["createCommentVNode"])("", true)])]),
    _: 3
  }, 8, ["class", "href", "style", "target"])), $props.dismissible ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
    key: 0,
    "aria-label": _ctx.$t('close banner'),
    class: "nebula-banner__close-button",
    type: "flat",
    "icon-right": "x",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('dismissBanner'))
  }, null, 8, ["aria-label"])) : Object(external_vue_["createCommentVNode"])("", true)])], 4);
}
// CONCATENATED MODULE: ./src/components/Banner/NebulaBanner.vue?vue&type=template&id=619c3c24

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Banner/NebulaBanner.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaBannervue_type_script_lang_js = ({
  name: 'NebulaBanner',
  components: {
    NebulaButton: NebulaButton
  },
  mixins: [themingUtils],
  props: {
    bannerElement: {
      type: String,
      default: 'a',
      // Options: a, div
      enum: ['a', 'div'] // for docs site

    },
    buttons: {
      type: Boolean,
      default: true
    },
    contentInset: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: null
    },
    dismissible: {
      type: Boolean,
      default: false
    },
    gradient: {
      type: Boolean,
      default: false
    },
    gradientStart: {
      type: String
    },
    gradientEnd: {
      type: String
    },
    headline: {
      type: String,
      default: null
    },
    image: {
      type: String,
      default: null
    },
    imageInset: {
      type: Boolean,
      default: false
    },
    link: {
      type: String
    },
    target: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'text-right',
      // Options: text-right, text-left
      enum: ['text-right', 'text-left'] // for docs site

    },
    useFloatingImage: {
      type: Boolean,
      default: false
    }
  },
  emits: ['dismissBanner'],
  computed: {
    bannerClassName() {
      const className = ['nebula-banner', `nebula-banner--${this.type}`, {
        'nebula-banner--gradient': this.gradient,
        'nebula-banner--content-inset': this.contentInset,
        'nebula-banner--image-inset': this.imageInset
      }];
      return className;
    },

    bannerElementIsLink() {
      return this.bannerElement === 'a';
    },

    imageClassNames() {
      return this.useFloatingImage ? 'nebula-banner__image nebula-banner__image--floating' : 'nebula-banner__image';
    },

    gradientValues() {
      return {
        '--gradient-start': this.gradientStart,
        '--gradient-end': this.gradientEnd
      };
    }

  }
});
// CONCATENATED MODULE: ./src/components/Banner/NebulaBanner.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Banner/NebulaBanner.vue?vue&type=style&index=0&id=619c3c24&lang=stylus
var NebulaBannervue_type_style_index_0_id_619c3c24_lang_stylus = __webpack_require__("1340");

// CONCATENATED MODULE: ./src/components/Banner/NebulaBanner.vue







const NebulaBanner_exports_ = /*#__PURE__*/exportHelper_default()(NebulaBannervue_type_script_lang_js, [['render',NebulaBannervue_type_template_id_619c3c24_render]])

/* harmony default export */ var NebulaBanner = (NebulaBanner_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/BlockMessage/NebulaBlockMessage.vue?vue&type=template&id=4e5d908e

const NebulaBlockMessagevue_type_template_id_4e5d908e_hoisted_1 = {
  key: 0,
  class: "nebula-block-message__icon-container"
};
const NebulaBlockMessagevue_type_template_id_4e5d908e_hoisted_2 = {
  class: "nebula-block-message__content"
};
const NebulaBlockMessagevue_type_template_id_4e5d908e_hoisted_3 = {
  key: 0,
  class: "nebula-block-message__header-container"
};
const NebulaBlockMessagevue_type_template_id_4e5d908e_hoisted_4 = ["textContent"];
const NebulaBlockMessagevue_type_template_id_4e5d908e_hoisted_5 = ["textContent"];
const NebulaBlockMessagevue_type_template_id_4e5d908e_hoisted_6 = {
  key: 3,
  class: "nebula-block-message__action-container"
};
function NebulaBlockMessagevue_type_template_id_4e5d908e_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  const _component_NebulaIconButton = Object(external_vue_["resolveComponent"])("NebulaIconButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.element), {
    class: Object(external_vue_["normalizeClass"])(['nebula-block-message', `nebula-block-message--${$props.color}`, {
      'nebula-block-message--contained': $props.contained === true,
      'nebula-block-message--dismissible': $props.dismissible === true,
      'nebula-block-message--white-background': $props.whiteBackground === true
    }]),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, {
    default: Object(external_vue_["withCtx"])(() => [$props.icon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaBlockMessagevue_type_template_id_4e5d908e_hoisted_1, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      class: "nebula-block-message__icon",
      symbolId: $props.icon
    }, null, 8, ["symbolId"])])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaBlockMessagevue_type_template_id_4e5d908e_hoisted_2, [$props.header ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaBlockMessagevue_type_template_id_4e5d908e_hoisted_3, [$props.header ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", {
      key: 0,
      class: "nebula-block-message__header",
      textContent: Object(external_vue_["toDisplayString"])($props.header)
    }, null, 8, NebulaBlockMessagevue_type_template_id_4e5d908e_hoisted_4)) : Object(external_vue_["createCommentVNode"])("", true)])) : Object(external_vue_["createCommentVNode"])("", true), $props.description ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", {
      key: 1,
      class: "nebula-block-message__text",
      textContent: Object(external_vue_["toDisplayString"])($props.description)
    }, null, 8, NebulaBlockMessagevue_type_template_id_4e5d908e_hoisted_5)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($options.slotHasHTML ? 'div' : 'p'), {
      key: 2,
      class: "nebula-block-message__text"
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")]),
      _: 3
    })), $options.hasAction ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaBlockMessagevue_type_template_id_4e5d908e_hoisted_6, [Object(external_vue_["renderSlot"])(_ctx.$slots, "action")])) : Object(external_vue_["createCommentVNode"])("", true)]), $props.dismissible ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIconButton, {
      key: 1,
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('closeBlockMessage')),
      class: "nebula-block-message__close-button",
      icon: "x",
      size: "s",
      type: "flat"
    })) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 3
  }, 8, ["class", "style"]);
}
// CONCATENATED MODULE: ./src/components/BlockMessage/NebulaBlockMessage.vue?vue&type=template&id=4e5d908e

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Button/NebulaIconButton.vue?vue&type=template&id=238ed0ba

function NebulaIconButtonvue_type_template_id_238ed0ba_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  const _component_NebulaTitleTooltip = Object(external_vue_["resolveComponent"])("NebulaTitleTooltip");

  return $props.tooltipProps ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaTitleTooltip, Object(external_vue_["normalizeProps"])(Object(external_vue_["mergeProps"])({
    key: 0
  }, $props.tooltipProps)), {
    default: Object(external_vue_["withCtx"])(() => [(Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($options.buttonElement), Object(external_vue_["mergeProps"])({
      class: $options.buttonClassName,
      "aria-disabled": $props.isDisabled || $props.disabledLink ? 'true' : null,
      "aria-label": $props.ariaLabel ? $props.ariaLabel : null,
      target: $props.target ? $props.target : null,
      type: $options.getButtonType,
      role: $props.disabledLink ? 'link' : null,
      tabindex: $props.disabledLink ? 0 : null
    }, $options.parsedPath, {
      style: _ctx.cssProps,
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click', $event))
    }), {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
        symbolId: $props.icon,
        class: "nebula-icon-button__icon"
      }, null, 8, ["symbolId"])]),
      _: 1
    }, 16, ["class", "aria-disabled", "aria-label", "target", "type", "role", "tabindex", "style"]))]),
    _: 1
  }, 16)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($options.buttonElement), Object(external_vue_["mergeProps"])({
    key: 1,
    class: $options.buttonClassName,
    "aria-disabled": $props.isDisabled || $props.disabledLink ? 'true' : null,
    "aria-label": $props.ariaLabel ? $props.ariaLabel : null,
    target: $props.target ? $props.target : null,
    type: $options.getButtonType,
    role: $props.disabledLink ? 'link' : null,
    tabindex: $props.disabledLink ? 0 : null
  }, { ...$options.parsedPath,
    ..._ctx.$attrs
  }, {
    style: _ctx.cssProps,
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('click', $event))
  }), {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      symbolId: $props.icon,
      class: "nebula-icon-button__icon"
    }, null, 8, ["symbolId"])]),
    _: 1
  }, 16, ["class", "aria-disabled", "aria-label", "target", "type", "role", "tabindex", "style"]));
}
// CONCATENATED MODULE: ./src/components/Button/NebulaIconButton.vue?vue&type=template&id=238ed0ba

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Tooltip/NebulaTitleTooltip.vue?vue&type=template&id=e0e1f9c8

const NebulaTitleTooltipvue_type_template_id_e0e1f9c8_hoisted_1 = {
  class: "nebula-title-tooltip__container"
};
const NebulaTitleTooltipvue_type_template_id_e0e1f9c8_hoisted_2 = ["data-position"];
const NebulaTitleTooltipvue_type_template_id_e0e1f9c8_hoisted_3 = {
  class: "nebula-title-tooltip__text"
};
function NebulaTitleTooltipvue_type_template_id_e0e1f9c8_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaTitleTooltipvue_type_template_id_e0e1f9c8_hoisted_1, [Object(external_vue_["createElementVNode"])("div", {
    class: "nebula-title-tooltip__trigger",
    onKeyup: _cache[0] || (_cache[0] = $event => $options.triggerMouseOver()),
    onMouseover: _cache[1] || (_cache[1] = $event => $options.triggerMouseOver())
  }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")], 32), Object(external_vue_["createElementVNode"])("div", {
    class: Object(external_vue_["normalizeClass"])(["nebula-title-tooltip", $props.usesLightTheme && 'nebula-title-tooltip--light']),
    "data-position": $props.position,
    "aria-hidden": "true",
    ref: "nebulaTitleTooltip",
    style: Object(external_vue_["normalizeStyle"])($data.toolTipStyle)
  }, [Object(external_vue_["createElementVNode"])("p", NebulaTitleTooltipvue_type_template_id_e0e1f9c8_hoisted_3, Object(external_vue_["toDisplayString"])($props.text), 1), Object(external_vue_["createElementVNode"])("span", {
    class: "nebula-title-tooltip__nub",
    style: Object(external_vue_["normalizeStyle"])($data.toolTipNubStyle)
  }, null, 4)], 14, NebulaTitleTooltipvue_type_template_id_e0e1f9c8_hoisted_2)]);
}
// CONCATENATED MODULE: ./src/components/Tooltip/NebulaTitleTooltip.vue?vue&type=template&id=e0e1f9c8

// CONCATENATED MODULE: ./src/utils/getBoundingClientRect.js
/* eslint-disable import/prefer-default-export */
const getBoundingClientRect = element => {
  const {
    top,
    right,
    bottom,
    left,
    width,
    height,
    x,
    y
  } = element.getBoundingClientRect();
  return {
    top,
    right,
    bottom,
    left,
    width,
    height,
    x,
    y
  };
};


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Tooltip/NebulaTitleTooltip.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaTitleTooltipvue_type_script_lang_js = ({
  name: 'NebulaTitleTooltip',
  props: {
    text: String,
    id: String,
    usesLightTheme: {
      type: Boolean,
      default: false
    },
    nub: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'block-start',
      // Options: block-start, block-end, inline-start, inline-end
      enum: ['block-start', 'block-end', 'block-end', 'inline-start', 'inline-end'] // for docs site

    }
  },

  data() {
    return {
      toolTipStyle: {},
      toolTipNubStyle: {}
    };
  },

  methods: {
    triggerMouseOver() {
      this.toolTipStyle = {};
      this.toolTipNubStyle = {};
      this.$nextTick(() => {
        const isRtl = getComputedStyle(this.$el).getPropertyValue('direction') === 'rtl';
        const {
          right,
          left
        } = getBoundingClientRect(this.$refs.nebulaTitleTooltip); // only applicable to tooltip positioned top/block-start or bottom/block-end

        if (this.position === 'block-start' || this.position === 'block-end') {
          if (isRtl) {
            // if the tooltip is bleeding out of the page to the right, adjust position
            if (right > document.documentElement.clientWidth) {
              this.toolTipStyle = {
                'inset-inline-start': `calc(50% + ${right - window.innerWidth + 16}px)`
              };
              this.toolTipNubStyle = {
                'inset-inline-start': `calc(50% - ${right - window.innerWidth + 16}px)`
              };
            } else if (left < 0) {
              // if the tooltip is bleeding out of the page to the left, adjust position
              this.toolTipStyle = {
                'inset-inline-start': `calc(50% + ${left - 16}px)`
              };
              this.toolTipNubStyle = {
                'inset-inline-start': `calc(50% - ${left - 16}px)`
              };
            }

            return;
          } // if the tooltip is bleeding out of the page to the right, adjust position


          if (right > document.documentElement.clientWidth) {
            this.toolTipStyle = {
              'inset-inline-start': `calc(50% - ${right - window.innerWidth + 16}px)`
            };
            this.toolTipNubStyle = {
              'inset-inline-start': `calc(50% + ${right - window.innerWidth + 16}px)`
            };
          } else if (left < 0) {
            // if the tooltip is bleeding out of the page to the left, adjust position
            this.toolTipStyle = {
              'inset-inline-start': `calc(50% - ${left - 16}px)`
            };
            this.toolTipNubStyle = {
              'inset-inline-start': `calc(50% + ${left - 16}px)`
            };
          }
        }
      });
    }

  }
});
// CONCATENATED MODULE: ./src/components/Tooltip/NebulaTitleTooltip.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Tooltip/NebulaTitleTooltip.vue?vue&type=style&index=0&id=e0e1f9c8&lang=stylus
var NebulaTitleTooltipvue_type_style_index_0_id_e0e1f9c8_lang_stylus = __webpack_require__("6a6f");

// CONCATENATED MODULE: ./src/components/Tooltip/NebulaTitleTooltip.vue







const NebulaTitleTooltip_exports_ = /*#__PURE__*/exportHelper_default()(NebulaTitleTooltipvue_type_script_lang_js, [['render',NebulaTitleTooltipvue_type_template_id_e0e1f9c8_render]])

/* harmony default export */ var NebulaTitleTooltip = (NebulaTitleTooltip_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Button/NebulaIconButton.vue?vue&type=script&lang=js



/* harmony default export */ var NebulaIconButtonvue_type_script_lang_js = ({
  name: 'NebulaIconButton',
  components: {
    NebulaIcon: NebulaIcon,
    NebulaTitleTooltip: NebulaTitleTooltip
  },
  mixins: [themingUtils],
  props: {
    ariaLabel: {
      type: String,
      default: null
    },
    disabledLink: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isStatic: {
      type: Boolean,
      default: false
    },
    isSubmit: {
      type: Boolean,
      default: false
    },
    link: {
      type: [String, Object],
      default: ''
    },
    //
    // pushStateLink has been deprecated.
    // Prefer use of usePushState prop instead.
    //
    pushStateLink: {
      type: Boolean,
      default: false
    },
    routerLink: {
      type: Boolean,
      default: false
    },
    shape: {
      type: String,
      default: 'square',
      enum: ['square', 'pill'] // for docs site

    },
    size: {
      type: String,
      default: 'm',
      enum: ['s', 'm', 'l']
    },
    target: {
      type: [String, Boolean],
      default: null,
      enum: ['_blank', '_self', '_parent', '_top'] // for docs site

    },
    tooltipProps: {
      type: Object
    },
    type: {
      type: String,
      default: 'fill',
      enum: ['fill', 'ghost', 'flat'] // for docs site

    },
    usePushState: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  computed: {
    buttonClassName() {
      const className = ['nebula-icon-button', `nebula-icon-button--${this.size}`, `nebula-icon-button--${this.shape}`, `nebula-icon-button--${this.type}`];

      if (this.pushStateLink || this.usePushState) {
        className.push('do-push-state');
      } //
      //  TODO: Once pushStateLink is removed uncomment this in favor of the above condition.
      //
      // if (this.usePushState) {
      //     className.push('do-push-state');
      // }


      return className;
    },

    buttonElement() {
      return this.getButtonElement();
    },

    getButtonType() {
      let type = 'button';

      if (this.isSubmit) {
        type = 'submit';
      }

      if (this.routerLink || this.link || this.disabledLink || this.isStatic) {
        type = null;
      }

      return type;
    },

    parsedPath() {
      const {
        link
      } = this;
      const buttonEl = this.getButtonElement();
      let parsedLink = {};

      switch (buttonEl) {
        case 'a':
          parsedLink = {
            href: link
          };
          break;

        case 'routerLink':
          parsedLink = {
            to: link
          };
          break;

        default:
          break;
      }

      return parsedLink;
    }

  },
  methods: {
    getButtonElement() {
      let buttonElement = 'button';

      if (this.routerLink) {
        buttonElement = 'routerLink';
      } else if (this.isStatic) {
        buttonElement = 'div';
      } else if (this.link || this.disabledLink) {
        buttonElement = 'a';
      }

      return buttonElement;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Button/NebulaIconButton.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Button/NebulaIconButton.vue?vue&type=style&index=0&id=238ed0ba&lang=stylus
var NebulaIconButtonvue_type_style_index_0_id_238ed0ba_lang_stylus = __webpack_require__("f4a8");

// CONCATENATED MODULE: ./src/components/Button/NebulaIconButton.vue







const NebulaIconButton_exports_ = /*#__PURE__*/exportHelper_default()(NebulaIconButtonvue_type_script_lang_js, [['render',NebulaIconButtonvue_type_template_id_238ed0ba_render]])

/* harmony default export */ var NebulaIconButton = (NebulaIconButton_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/BlockMessage/NebulaBlockMessage.vue?vue&type=script&lang=js



/* harmony default export */ var NebulaBlockMessagevue_type_script_lang_js = ({
  name: 'NebulaBlockMessage',
  components: {
    NebulaIconButton: NebulaIconButton,
    NebulaIcon: NebulaIcon
  },
  mixins: [themingUtils],
  props: {
    color: {
      type: String,
      default: 'gray',
      enum: ['gray', 'green', 'orange', 'red']
    },
    contained: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: null
    },
    dismissible: {
      type: Boolean,
      default: false
    },
    element: {
      type: String,
      default: 'div'
    },
    header: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    whiteBackground: {
      type: Boolean,
      default: false
    }
  },
  emits: ['closeBlockMessage'],
  computed: {
    slotHasHTML() {
      var _this$$slots$default, _this$$slots;

      const slotContent = (_this$$slots$default = (_this$$slots = this.$slots).default) === null || _this$$slots$default === void 0 ? void 0 : _this$$slots$default.call(_this$$slots);
      let hasHTML = false;

      if (slotContent) {
        slotContent.forEach(contentObject => {
          if (contentObject.tag) {
            hasHTML = true;
          }
        });
      }

      return hasHTML;
    },

    hasAction() {
      return !!this.$slots.action;
    }

  }
});
// CONCATENATED MODULE: ./src/components/BlockMessage/NebulaBlockMessage.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/BlockMessage/NebulaBlockMessage.vue?vue&type=style&index=0&id=4e5d908e&lang=stylus
var NebulaBlockMessagevue_type_style_index_0_id_4e5d908e_lang_stylus = __webpack_require__("a1306");

// CONCATENATED MODULE: ./src/components/BlockMessage/NebulaBlockMessage.vue







const NebulaBlockMessage_exports_ = /*#__PURE__*/exportHelper_default()(NebulaBlockMessagevue_type_script_lang_js, [['render',NebulaBlockMessagevue_type_template_id_4e5d908e_render]])

/* harmony default export */ var NebulaBlockMessage = (NebulaBlockMessage_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Button/NebulaBackToTop.vue?vue&type=template&id=c7bd3592

function NebulaBackToTopvue_type_template_id_c7bd3592_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaFloatingActionButton = Object(external_vue_["resolveComponent"])("NebulaFloatingActionButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaFloatingActionButton, {
    class: "nebula-back-to-top",
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps),
    tooltipText: this.tooltipText
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      iconLeft: "arrow-up-circle",
      onClick: this.scrollToTop
    }, {
      slotIconLeft: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
        symbolId: "arrow-up-circle"
      })]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }, 8, ["style", "tooltipText"]);
}
// CONCATENATED MODULE: ./src/components/Button/NebulaBackToTop.vue?vue&type=template&id=c7bd3592

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Button/NebulaFloatingActionButton.vue?vue&type=template&id=43ac5d7a

function NebulaFloatingActionButtonvue_type_template_id_43ac5d7a_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaTitleTooltip = Object(external_vue_["resolveComponent"])("NebulaTitleTooltip");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: "nebula-fab",
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [this.tooltipText ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaTitleTooltip, {
    key: 0,
    text: this.tooltipText,
    class: "nebula-fab__tooltip"
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")]),
    _: 3
  }, 8, ["text"])) : Object(external_vue_["renderSlot"])(_ctx.$slots, "default", {
    key: 1
  })], 4);
}
// CONCATENATED MODULE: ./src/components/Button/NebulaFloatingActionButton.vue?vue&type=template&id=43ac5d7a

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Button/NebulaFloatingActionButton.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaFloatingActionButtonvue_type_script_lang_js = ({
  name: 'NebulaFloatingActionButton',
  components: {
    NebulaTitleTooltip: NebulaTitleTooltip
  },
  mixins: [themingUtils],
  props: {
    tooltipText: {
      type: String,
      default: null
    }
  }
});
// CONCATENATED MODULE: ./src/components/Button/NebulaFloatingActionButton.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Button/NebulaFloatingActionButton.vue?vue&type=style&index=0&id=43ac5d7a&lang=stylus
var NebulaFloatingActionButtonvue_type_style_index_0_id_43ac5d7a_lang_stylus = __webpack_require__("9af3");

// CONCATENATED MODULE: ./src/components/Button/NebulaFloatingActionButton.vue







const NebulaFloatingActionButton_exports_ = /*#__PURE__*/exportHelper_default()(NebulaFloatingActionButtonvue_type_script_lang_js, [['render',NebulaFloatingActionButtonvue_type_template_id_43ac5d7a_render]])

/* harmony default export */ var NebulaFloatingActionButton = (NebulaFloatingActionButton_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Button/NebulaBackToTop.vue?vue&type=script&lang=js




/* harmony default export */ var NebulaBackToTopvue_type_script_lang_js = ({
  name: 'NebulaBackToTop',
  components: {
    NebulaButton: NebulaButton,
    NebulaFloatingActionButton: NebulaFloatingActionButton,
    NebulaIcon: NebulaIcon
  },
  computed: {
    tooltipText() {
      return this.$t('Back to Top');
    }

  },
  mixins: [themingUtils],
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }

  }
});
// CONCATENATED MODULE: ./src/components/Button/NebulaBackToTop.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Button/NebulaBackToTop.vue?vue&type=style&index=0&id=c7bd3592&lang=stylus
var NebulaBackToTopvue_type_style_index_0_id_c7bd3592_lang_stylus = __webpack_require__("9e0c");

// CONCATENATED MODULE: ./src/components/Button/NebulaBackToTop.vue







const NebulaBackToTop_exports_ = /*#__PURE__*/exportHelper_default()(NebulaBackToTopvue_type_script_lang_js, [['render',NebulaBackToTopvue_type_template_id_c7bd3592_render]])

/* harmony default export */ var NebulaBackToTop = (NebulaBackToTop_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Button/NebulaCopyButton.vue?vue&type=template&id=3feee9a7

function NebulaCopyButtonvue_type_template_id_3feee9a7_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
    class: "nebula-copy__button",
    onClick: $options.onClickCopy,
    role: $data.copyActive ? 'alert' : undefined,
    "icon-left": $options.copyButtonIcon,
    shape: "pill",
    size: "s",
    text: $options.copyButtonText,
    type: "flat",
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, null, 8, ["onClick", "role", "icon-left", "text", "style"]);
}
// CONCATENATED MODULE: ./src/components/Button/NebulaCopyButton.vue?vue&type=template&id=3feee9a7

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Button/NebulaCopyButton.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaCopyButtonvue_type_script_lang_js = ({
  name: 'NebulaCopyButton',
  mixins: [themingUtils],
  components: {
    NebulaButton: NebulaButton
  },
  props: {
    text: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      copyActive: false,
      copyError: false
    };
  },

  methods: {
    onClickCopy() {
      const textArea = document.createElement('textarea');
      textArea.value = this.text;
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.position = 'fixed';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        this.copyActive = true;
        setTimeout(() => {
          this.setCopyInactive();
        }, 1500);
      } catch {
        this.copyError = true;
      }

      document.body.removeChild(textArea);
    },

    setCopyInactive() {
      this.copyActive = false;
    }

  },
  computed: {
    copyButtonIcon() {
      let copyButtonIcon = 'link';

      if (this.copyActive) {
        copyButtonIcon = 'check-circle';
      } else if (this.copyError) {
        copyButtonIcon = 'message-error';
      }

      return copyButtonIcon;
    },

    copyButtonText() {
      let copyButtonText = 'Copy Code';

      if (this.copyActive) {
        copyButtonText = 'Copied!';
      } else if (this.copyError) {
        copyButtonText = 'Copy error!';
      }

      return copyButtonText;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Button/NebulaCopyButton.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Button/NebulaCopyButton.vue?vue&type=style&index=0&id=3feee9a7&lang=stylus
var NebulaCopyButtonvue_type_style_index_0_id_3feee9a7_lang_stylus = __webpack_require__("d76a");

// CONCATENATED MODULE: ./src/components/Button/NebulaCopyButton.vue







const NebulaCopyButton_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCopyButtonvue_type_script_lang_js, [['render',NebulaCopyButtonvue_type_template_id_3feee9a7_render]])

/* harmony default export */ var NebulaCopyButton = (NebulaCopyButton_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Button/NebulaFavoritesButton.vue?vue&type=template&id=c1d30804

function NebulaFavoritesButtonvue_type_template_id_c1d30804_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIconButton = Object(external_vue_["resolveComponent"])("NebulaIconButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIconButton, {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('favoriteButtonClick', $event)),
    class: Object(external_vue_["normalizeClass"])(["nebula-favorites-button", {
      'nebula-favorites-button--favorite': $props.isFavorite
    }]),
    "aria-label": $options.tooltipText,
    icon: $options.icon,
    tooltipProps: {
      position: 'block-start',
      text: `${$options.tooltipText}`
    }
  }, null, 8, ["class", "aria-label", "icon", "tooltipProps"]);
}
// CONCATENATED MODULE: ./src/components/Button/NebulaFavoritesButton.vue?vue&type=template&id=c1d30804

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Button/NebulaFavoritesButton.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaFavoritesButtonvue_type_script_lang_js = ({
  name: 'NebulaFavoritesButton',
  components: {
    NebulaIconButton: NebulaIconButton
  },
  emits: ['favoriteButtonClick'],
  props: {
    isFavorite: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tooltipText() {
      return this.isFavorite ? this.$t('Remove from Favorites') : this.$t('Add to Favorites');
    },

    icon() {
      return this.isFavorite ? 'heart--filled' : 'heart';
    }

  },
  mixins: [themingUtils]
});
// CONCATENATED MODULE: ./src/components/Button/NebulaFavoritesButton.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Button/NebulaFavoritesButton.vue?vue&type=style&index=0&id=c1d30804&lang=stylus
var NebulaFavoritesButtonvue_type_style_index_0_id_c1d30804_lang_stylus = __webpack_require__("8b54");

// CONCATENATED MODULE: ./src/components/Button/NebulaFavoritesButton.vue







const NebulaFavoritesButton_exports_ = /*#__PURE__*/exportHelper_default()(NebulaFavoritesButtonvue_type_script_lang_js, [['render',NebulaFavoritesButtonvue_type_template_id_c1d30804_render]])

/* harmony default export */ var NebulaFavoritesButton = (NebulaFavoritesButton_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Button/NebulaFullscreenButton.vue?vue&type=template&id=70ba15ff

function NebulaFullscreenButtonvue_type_template_id_70ba15ff_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIconButton = Object(external_vue_["resolveComponent"])("NebulaIconButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIconButton, {
    "aria-label": "Open in fullscreen",
    class: "nebula-fullscreen-button",
    icon: $data.isFullscreen ? 'fullscreen-exit' : 'fullscreen',
    type: "flat",
    size: "m",
    onClick: $options.onClick
  }, null, 8, ["icon", "onClick"]);
}
// CONCATENATED MODULE: ./src/components/Button/NebulaFullscreenButton.vue?vue&type=template&id=70ba15ff

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Button/NebulaFullscreenButton.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaFullscreenButtonvue_type_script_lang_js = ({
  name: 'NebulaFullscreenButton',
  components: {
    NebulaIconButton: NebulaIconButton
  },
  emits: ['toggle-fullscreen'],

  data() {
    return {
      isFullscreen: false
    };
  },

  mixins: [themingUtils],
  methods: {
    onClick() {
      this.isFullscreen = !this.isFullscreen;
      this.$emit('toggle-fullscreen');
    }

  }
});
// CONCATENATED MODULE: ./src/components/Button/NebulaFullscreenButton.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/components/Button/NebulaFullscreenButton.vue





const NebulaFullscreenButton_exports_ = /*#__PURE__*/exportHelper_default()(NebulaFullscreenButtonvue_type_script_lang_js, [['render',NebulaFullscreenButtonvue_type_template_id_70ba15ff_render]])

/* harmony default export */ var NebulaFullscreenButton = (NebulaFullscreenButton_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ButtonGroup/NebulaButtonGroup.vue?vue&type=template&id=36453965

function NebulaButtonGroupvue_type_template_id_36453965_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButtonGroupItem = Object(external_vue_["resolveComponent"])("NebulaButtonGroupItem");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.buttonGroupClass),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [$options.usesButtonSlot ? Object(external_vue_["renderSlot"])(_ctx.$slots, "buttons", {
    key: 0
  }) : (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
    key: 1
  }, Object(external_vue_["renderList"])($options.parsedItems, (item, index) => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButtonGroupItem, {
      key: index,
      buttonData: item,
      customStyles: $props.customButtonStyles ? $props.customButtonStyles : null,
      pill: $props.pill ? 'pill' : null,
      size: $props.size
    }, null, 8, ["buttonData", "customStyles", "pill", "size"]);
  }), 128))], 6);
}
// CONCATENATED MODULE: ./src/components/ButtonGroup/NebulaButtonGroup.vue?vue&type=template&id=36453965

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ButtonGroup/NebulaButtonGroupItem.vue?vue&type=template&id=c56100fa

function NebulaButtonGroupItemvue_type_template_id_c56100fa_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaTitleTooltip = Object(external_vue_["resolveComponent"])("NebulaTitleTooltip");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.containerClass)
  }, [$props.buttonData.tooltipText ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaTitleTooltip, {
    key: 0,
    text: $props.buttonData.tooltipText,
    position: "block-end"
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaButton, Object(external_vue_["mergeProps"])({
      onClick: $options.handleClick
    }, $props.buttonData, {
      style: _ctx.cssProps,
      shape: $props.pill ? 'pill' : null,
      size: $props.size
    }), null, 16, ["onClick", "style", "shape", "size"])]),
    _: 1
  }, 8, ["text"])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, Object(external_vue_["mergeProps"])({
    key: 1,
    onClick: $options.handleClick
  }, $props.buttonData, {
    style: _ctx.cssProps,
    shape: $props.pill ? 'pill' : null,
    size: $props.size
  }), null, 16, ["onClick", "style", "shape", "size"]))], 2);
}
// CONCATENATED MODULE: ./src/components/ButtonGroup/NebulaButtonGroupItem.vue?vue&type=template&id=c56100fa

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ButtonGroup/NebulaButtonGroupItem.vue?vue&type=script&lang=js



/* harmony default export */ var NebulaButtonGroupItemvue_type_script_lang_js = ({
  name: 'NebulaButtonGroupItem',
  components: {
    NebulaButton: NebulaButton,
    NebulaTitleTooltip: NebulaTitleTooltip
  },
  mixins: [themingUtils],
  props: {
    buttonData: {
      type: Object,
      default: null
    },
    customStyles: {
      type: Object,
      default: null
    },
    pill: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'm',
      enum: ['s', 'm', 'l']
    },
    tooltipText: {
      type: String,
      default: null
    }
  },
  methods: {
    handleClick() {
      if (this.buttonData.action) {
        this.buttonData.action();
      }
    }

  },
  computed: {
    containerClass() {
      const className = ['nebula-button-group__item-container', {
        'nebula-button-group__item-container--active': this.buttonData.active === true
      }];
      return className;
    }

  }
});
// CONCATENATED MODULE: ./src/components/ButtonGroup/NebulaButtonGroupItem.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/ButtonGroup/NebulaButtonGroupItem.vue?vue&type=style&index=0&id=c56100fa&lang=stylus
var NebulaButtonGroupItemvue_type_style_index_0_id_c56100fa_lang_stylus = __webpack_require__("469b");

// CONCATENATED MODULE: ./src/components/ButtonGroup/NebulaButtonGroupItem.vue







const NebulaButtonGroupItem_exports_ = /*#__PURE__*/exportHelper_default()(NebulaButtonGroupItemvue_type_script_lang_js, [['render',NebulaButtonGroupItemvue_type_template_id_c56100fa_render]])

/* harmony default export */ var NebulaButtonGroupItem = (NebulaButtonGroupItem_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ButtonGroup/NebulaButtonGroup.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaButtonGroupvue_type_script_lang_js = ({
  name: 'NebulaButtonGroup',
  components: {
    NebulaButtonGroupItem: NebulaButtonGroupItem
  },
  mixins: [themingUtils],
  props: {
    actions: {
      type: Object
    },
    buttons: {
      type: Array,
      default: () => []
    },
    customButtonStyles: {
      type: Object,
      default: null
    },
    pill: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'm',
      enum: ['s', 'm', 'l']
    }
  },
  computed: {
    buttonGroupClass() {
      const className = ['nebula-button-group', {
        'nebula-button-group--pill': this.pill
      }];
      return className;
    },

    parsedItems() {
      let matchIndex;
      const buttons = [...this.buttons]; // if actions are passed in, include them in the buttonGroup data

      if (this.actions) {
        Object.keys(this.actions).forEach(text => {
          const match = buttons.find((each, idx) => {
            // for each dropdown item, check if there's a matching action being
            // passed through via actions prop
            if (each.text === text) {
              matchIndex = idx;
            }

            return each.text === text;
          });

          if (match) {
            const actionObj = {
              action: this.actions[text]
            };
            buttons[matchIndex] = { ...buttons[matchIndex],
              ...actionObj
            };
          }
        });
      }

      return buttons;
    },

    usesButtonSlot() {
      return !!this.$slots.buttons;
    }

  }
});
// CONCATENATED MODULE: ./src/components/ButtonGroup/NebulaButtonGroup.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/ButtonGroup/NebulaButtonGroup.vue?vue&type=style&index=0&id=36453965&lang=stylus
var NebulaButtonGroupvue_type_style_index_0_id_36453965_lang_stylus = __webpack_require__("0663");

// CONCATENATED MODULE: ./src/components/ButtonGroup/NebulaButtonGroup.vue







const NebulaButtonGroup_exports_ = /*#__PURE__*/exportHelper_default()(NebulaButtonGroupvue_type_script_lang_js, [['render',NebulaButtonGroupvue_type_template_id_36453965_render]])

/* harmony default export */ var NebulaButtonGroup = (NebulaButtonGroup_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Callout/NebulaCallout.vue?vue&type=template&id=897453b6

const NebulaCalloutvue_type_template_id_897453b6_hoisted_1 = {
  class: "nebula-callout__icon-container"
};
const NebulaCalloutvue_type_template_id_897453b6_hoisted_2 = {
  class: "nebula-callout__text-container"
};
const NebulaCalloutvue_type_template_id_897453b6_hoisted_3 = ["textContent"];
const NebulaCalloutvue_type_template_id_897453b6_hoisted_4 = ["textContent"];
function NebulaCalloutvue_type_template_id_897453b6_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaSticker = Object(external_vue_["resolveComponent"])("NebulaSticker");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])(['nebula-callout', `nebula-callout--${$props.color}`]),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [Object(external_vue_["createElementVNode"])("div", NebulaCalloutvue_type_template_id_897453b6_hoisted_1, [Object(external_vue_["createVNode"])(_component_NebulaSticker, {
    class: "nebula-callout__sticker",
    icon: $props.icon,
    size: "m",
    customStyles: {
      stickerBackgroundColor: 'var(--nebula-callout-highlight-color)'
    }
  }, null, 8, ["icon", "customStyles"])]), Object(external_vue_["createElementVNode"])("div", NebulaCalloutvue_type_template_id_897453b6_hoisted_2, [$props.header ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", {
    key: 0,
    class: "nebula-callout__header",
    textContent: Object(external_vue_["toDisplayString"])($props.header)
  }, null, 8, NebulaCalloutvue_type_template_id_897453b6_hoisted_3)) : Object(external_vue_["createCommentVNode"])("", true), $props.text ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", {
    key: 1,
    class: "nebula-callout__text",
    textContent: Object(external_vue_["toDisplayString"])($props.text)
  }, null, 8, NebulaCalloutvue_type_template_id_897453b6_hoisted_4)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($options.slotHasHTML ? 'div' : 'p'), {
    key: 2,
    class: "nebula-callout__text"
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")]),
    _: 3
  }))])], 6);
}
// CONCATENATED MODULE: ./src/components/Callout/NebulaCallout.vue?vue&type=template&id=897453b6

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Sticker/NebulaSticker.vue?vue&type=template&id=0a8e5c34

const NebulaStickervue_type_template_id_0a8e5c34_hoisted_1 = {
  key: 0,
  class: "nebula-sticker__text"
};
function NebulaStickervue_type_template_id_0a8e5c34_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])(["nebula-sticker", `nebula-sticker--${this.size}`]),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [$props.text ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", NebulaStickervue_type_template_id_0a8e5c34_hoisted_1, Object(external_vue_["toDisplayString"])($props.text), 1)) : $props.icon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
    key: 1,
    class: "nebula-sticker__icon",
    symbolId: $props.icon,
    size: "m"
  }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true)], 6);
}
// CONCATENATED MODULE: ./src/components/Sticker/NebulaSticker.vue?vue&type=template&id=0a8e5c34

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Sticker/NebulaSticker.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaStickervue_type_script_lang_js = ({
  name: 'NebulaSticker',
  components: {
    NebulaIcon: NebulaIcon
  },
  mixins: [themingUtils],
  props: {
    icon: {
      type: String,
      default: 'information'
    },
    size: {
      type: String,
      default: 'm',
      enum: ['s', 'm', 'l'] // for docs site

    },
    text: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'icon',
      enum: ['icon', 'text'] // for docs site

    }
  }
});
// CONCATENATED MODULE: ./src/components/Sticker/NebulaSticker.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Sticker/NebulaSticker.vue?vue&type=style&index=0&id=0a8e5c34&lang=stylus
var NebulaStickervue_type_style_index_0_id_0a8e5c34_lang_stylus = __webpack_require__("dd86");

// CONCATENATED MODULE: ./src/components/Sticker/NebulaSticker.vue







const NebulaSticker_exports_ = /*#__PURE__*/exportHelper_default()(NebulaStickervue_type_script_lang_js, [['render',NebulaStickervue_type_template_id_0a8e5c34_render]])

/* harmony default export */ var NebulaSticker = (NebulaSticker_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Callout/NebulaCallout.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaCalloutvue_type_script_lang_js = ({
  name: 'NebulaCallout',
  components: {
    NebulaSticker: NebulaSticker
  },
  mixins: [themingUtils],
  props: {
    color: {
      type: String,
      default: 'gray',
      enum: ['gray', 'green', 'blue', 'orange', 'pink', 'purple', 'teal', 'yellow'] // for docs site

    },
    header: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: 'information'
    },
    text: {
      type: String,
      default: null
    }
  },
  computed: {
    slotHasHTML() {
      var _this$$slots$default, _this$$slots;

      const slotContent = (_this$$slots$default = (_this$$slots = this.$slots).default) === null || _this$$slots$default === void 0 ? void 0 : _this$$slots$default.call(_this$$slots);
      let hasHTML = false;

      if (slotContent) {
        slotContent.forEach(contentObject => {
          if (contentObject.tag) {
            hasHTML = true;
          }
        });
      }

      return hasHTML;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Callout/NebulaCallout.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Callout/NebulaCallout.vue?vue&type=style&index=0&id=897453b6&lang=stylus
var NebulaCalloutvue_type_style_index_0_id_897453b6_lang_stylus = __webpack_require__("f6bf");

// CONCATENATED MODULE: ./src/components/Callout/NebulaCallout.vue







const NebulaCallout_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCalloutvue_type_script_lang_js, [['render',NebulaCalloutvue_type_template_id_897453b6_render]])

/* harmony default export */ var NebulaCallout = (NebulaCallout_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/CallToAction/NebulaCallToAction.vue?vue&type=template&id=6a5d98c8

const NebulaCallToActionvue_type_template_id_6a5d98c8_hoisted_1 = {
  key: 0,
  class: "nebula-call-to-action__icon"
};
const NebulaCallToActionvue_type_template_id_6a5d98c8_hoisted_2 = {
  key: 1,
  class: "nebula-call-to-action__image"
};
const NebulaCallToActionvue_type_template_id_6a5d98c8_hoisted_3 = {
  class: "nebula-call-to-action__text-wrapper"
};
const NebulaCallToActionvue_type_template_id_6a5d98c8_hoisted_4 = {
  key: 0,
  class: "nebula-call-to-action__title"
};
const NebulaCallToActionvue_type_template_id_6a5d98c8_hoisted_5 = ["innerHTML"];
const NebulaCallToActionvue_type_template_id_6a5d98c8_hoisted_6 = {
  key: 2,
  class: "nebula-call-to-action__arrow"
};
function NebulaCallToActionvue_type_template_id_6a5d98c8_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  const _component_NebulaImage = Object(external_vue_["resolveComponent"])("NebulaImage");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($options.componentEl), {
    "aria-label": $props.linkAriaLabel || _ctx.$t('Call To Action Link'),
    class: Object(external_vue_["normalizeClass"])(["nebula-call-to-action", $options.wrapperClasses]),
    href: $props.link,
    target: $props.target ? $props.target : null,
    to: $props.useRouterLink ? $props.link : null,
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, {
    default: Object(external_vue_["withCtx"])(() => [$props.icon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaCallToActionvue_type_template_id_6a5d98c8_hoisted_1, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      size: "xl",
      symbolId: $props.icon
    }, null, 8, ["symbolId"])])) : $props.imageAssetId || $props.imageUrl ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaCallToActionvue_type_template_id_6a5d98c8_hoisted_2, [Object(external_vue_["createVNode"])(_component_NebulaImage, {
      alt: "",
      assetId: $props.imageAssetId,
      covered: "",
      imageSize: "small",
      src: $props.imageUrl,
      customStyles: {
        imageHeight: '100%'
      }
    }, null, 8, ["assetId", "src"])])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaCallToActionvue_type_template_id_6a5d98c8_hoisted_3, [$props.title ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("h4", NebulaCallToActionvue_type_template_id_6a5d98c8_hoisted_4, Object(external_vue_["toDisplayString"])($props.title), 1)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("p", {
      class: "nebula-call-to-action__text",
      innerHTML: $props.text
    }, null, 8, NebulaCallToActionvue_type_template_id_6a5d98c8_hoisted_5)]), !$props.hideArrow ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaCallToActionvue_type_template_id_6a5d98c8_hoisted_6, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      symbolId: "caret-right"
    })])) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 1
  }, 8, ["aria-label", "class", "href", "target", "to", "style"]);
}
// CONCATENATED MODULE: ./src/components/CallToAction/NebulaCallToAction.vue?vue&type=template&id=6a5d98c8

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/CallToAction/NebulaCallToAction.vue?vue&type=script&lang=js




/* harmony default export */ var NebulaCallToActionvue_type_script_lang_js = ({
  name: 'NebulaCallToAction',
  components: {
    NebulaButton: NebulaButton,
    NebulaIcon: NebulaIcon,
    NebulaImage: NebulaImage
  },
  mixins: [themingUtils],
  props: {
    hideArrow: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    imageAssetId: {
      type: String,
      default: null
    },
    imageShape: {
      type: String,
      default: 'square',

      validator(val) {
        const types = ['square', 'round'];
        return types.includes(val);
      }

    },
    imageUrl: {
      type: String,
      default: null
    },
    link: {
      type: String,
      required: true
    },
    linkAriaLabel: {
      type: String,
      default: null // this default is handled in the template

    },
    shape: {
      type: String,
      default: 'square',

      validator(val) {
        const types = ['square', 'rounded', 'pill'];
        return types.includes(val);
      }

    },
    target: {
      type: String,
      default: null
    },
    text: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: null
    },
    useRouterLink: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    componentEl() {
      return this.useRouterLink ? 'routerLink' : 'a';
    },

    wrapperClasses() {
      return {
        [`nebula-call-to-action--${this.shape}`]: true,
        [`nebula-call-to-action--${this.imageShape}-img`]: true
      };
    }

  }
});
// CONCATENATED MODULE: ./src/components/CallToAction/NebulaCallToAction.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/CallToAction/NebulaCallToAction.vue?vue&type=style&index=0&id=6a5d98c8&lang=stylus
var NebulaCallToActionvue_type_style_index_0_id_6a5d98c8_lang_stylus = __webpack_require__("9ffd");

// CONCATENATED MODULE: ./src/components/CallToAction/NebulaCallToAction.vue







const NebulaCallToAction_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCallToActionvue_type_script_lang_js, [['render',NebulaCallToActionvue_type_template_id_6a5d98c8_render]])

/* harmony default export */ var NebulaCallToAction = (NebulaCallToAction_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaActivityCard.vue?vue&type=template&id=1f850cec

const NebulaActivityCardvue_type_template_id_1f850cec_hoisted_1 = {
  class: "nebula-card__media"
};
const NebulaActivityCardvue_type_template_id_1f850cec_hoisted_2 = ["aria-label"];
const NebulaActivityCardvue_type_template_id_1f850cec_hoisted_3 = {
  class: "nebula-card__main"
};
const NebulaActivityCardvue_type_template_id_1f850cec_hoisted_4 = {
  class: "nebula-card__content"
};
const NebulaActivityCardvue_type_template_id_1f850cec_hoisted_5 = {
  class: "nebula-card__meta"
};
function NebulaActivityCardvue_type_template_id_1f850cec_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaCardThumbnail = Object(external_vue_["resolveComponent"])("NebulaCardThumbnail");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaCardHeader = Object(external_vue_["resolveComponent"])("NebulaCardHeader");

  const _component_NebulaCardTitle = Object(external_vue_["resolveComponent"])("NebulaCardTitle");

  const _component_NebulaCardDescription = Object(external_vue_["resolveComponent"])("NebulaCardDescription");

  const _component_NebulaCardMetadata = Object(external_vue_["resolveComponent"])("NebulaCardMetadata");

  const _component_NebulaContainerCard = Object(external_vue_["resolveComponent"])("NebulaContainerCard");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaContainerCard, Object(external_vue_["mergeProps"])({
    element: $props.element,
    padded: "",
    "card-class": "nebula-card--activity"
  }, $props.cardProps), {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("div", NebulaActivityCardvue_type_template_id_1f850cec_hoisted_1, [Object(external_vue_["createVNode"])(_component_NebulaCardThumbnail, {
      assetId: $props.asset.id,
      assetType: $options.assetTypeFriendly,
      cardIds: _ctx.cardIds,
      clickTrackSegment: _ctx.clickTrackSegment,
      dataAttrs: $props.dataAttrs,
      duration: $options.formattedDuration,
      embed: $props.embed,
      image: $props.imageOverride,
      isHighlighted: $props.asset.is_highlighted,
      linkAriaLabel: $props.asset.link_aria_label,
      productName: $props.productName,
      segmentTrackingData: _ctx.segmentTrackingData,
      target: $props.asset.target,
      title: $options.assetTitle,
      url: $options.cardLink && !$props.showPreview ? $options.cardLink : null,
      usePushState: $props.usePushState
    }, null, 8, ["assetId", "assetType", "cardIds", "clickTrackSegment", "dataAttrs", "duration", "embed", "image", "isHighlighted", "linkAriaLabel", "productName", "segmentTrackingData", "target", "title", "url", "usePushState"]), $props.showPreview ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", {
      key: 0,
      class: "nebula-card__preview-button",
      "aria-label": _ctx.$t('Open preview'),
      onClick: _cache[0] || (_cache[0] = (...args) => $options.previewButtonClick && $options.previewButtonClick(...args))
    }, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      class: "nebula-card__preview-button-visual",
      text: _ctx.$t('Preview'),
      shape: "pill",
      size: "s",
      "aria-hidden": "true",
      isStatic: ""
    }, null, 8, ["text"])], 8, NebulaActivityCardvue_type_template_id_1f850cec_hoisted_2)) : Object(external_vue_["createCommentVNode"])("", true), $props.showEmbedButton ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
      key: 1,
      class: "nebula-card__embed-button",
      text: _ctx.$t('Embed'),
      onClick: $options.embedAssetButtonClick
    }, null, 8, ["text", "onClick"])) : Object(external_vue_["createCommentVNode"])("", true)]), Object(external_vue_["createElementVNode"])("div", NebulaActivityCardvue_type_template_id_1f850cec_hoisted_3, [Object(external_vue_["createElementVNode"])("div", NebulaActivityCardvue_type_template_id_1f850cec_hoisted_4, [Object(external_vue_["createVNode"])(_component_NebulaCardHeader, {
      assetType: $options.assetTypeFriendly,
      iconOverride: "notes",
      showIcon: "",
      showFavoritesButton: ""
    }, {
      actionsMenu: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "actionsMenu")]),
      _: 3
    }, 8, ["assetType"]), Object(external_vue_["createVNode"])(_component_NebulaCardTitle, {
      assetId: $props.asset.id,
      cardIds: _ctx.cardIds,
      clickTrackSegment: _ctx.clickTrackSegment,
      dataAttrs: $props.dataAttrs,
      embed: $props.embed,
      linkAriaLabel: $props.asset.link_aria_label,
      segmentTrackingData: _ctx.segmentTrackingData,
      tabIndex: $props.showPreview ? null : '-1',
      target: $props.asset.target,
      title: $options.assetTitle,
      url: $options.cardLink,
      usePushState: $props.usePushState
    }, null, 8, ["assetId", "cardIds", "clickTrackSegment", "dataAttrs", "embed", "linkAriaLabel", "segmentTrackingData", "tabIndex", "target", "title", "url", "usePushState"]), Object(external_vue_["createVNode"])(_component_NebulaCardDescription, {
      text: $props.asset.description,
      htmlDescription: $props.asset.html_description
    }, null, 8, ["text", "htmlDescription"])]), Object(external_vue_["createElementVNode"])("div", NebulaActivityCardvue_type_template_id_1f850cec_hoisted_5, [Object(external_vue_["createVNode"])(_component_NebulaCardMetadata, {
      metadata: $props.asset.info_pills
    }, null, 8, ["metadata"])])])]),
    _: 3
  }, 16, ["element"]);
}
// CONCATENATED MODULE: ./src/components/Card/NebulaActivityCard.vue?vue&type=template&id=1f850cec

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaContainerCard.vue?vue&type=template&id=13884a24

function NebulaContainerCardvue_type_template_id_13884a24_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.element), Object(external_vue_["mergeProps"])({
    class: ["nebula-container-card", {
      'nebula-container-card--padded': $props.padded
    }]
  }, _ctx.$attrs, {
    style: _ctx.cssProps
  }), {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("div", {
      class: Object(external_vue_["normalizeClass"])(["nebula-container-card__inner", $props.cardClass])
    }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")], 2)]),
    _: 3
  }, 16, ["class", "style"]);
}
// CONCATENATED MODULE: ./src/components/Card/NebulaContainerCard.vue?vue&type=template&id=13884a24

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaContainerCard.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaContainerCardvue_type_script_lang_js = ({
  name: 'NebulaContainerCard',
  mixins: [themingUtils],
  props: {
    cardClass: {
      type: String
    },
    element: {
      type: String,
      default: 'li'
    },
    padded: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/Card/NebulaContainerCard.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Card/NebulaContainerCard.vue?vue&type=style&index=0&id=13884a24&lang=stylus
var NebulaContainerCardvue_type_style_index_0_id_13884a24_lang_stylus = __webpack_require__("4502");

// CONCATENATED MODULE: ./src/components/Card/NebulaContainerCard.vue







const NebulaContainerCard_exports_ = /*#__PURE__*/exportHelper_default()(NebulaContainerCardvue_type_script_lang_js, [['render',NebulaContainerCardvue_type_template_id_13884a24_render]])

/* harmony default export */ var NebulaContainerCard = (NebulaContainerCard_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/Partials/NebulaCardThumbnail.vue?vue&type=template&id=c5506394

const NebulaCardThumbnailvue_type_template_id_c5506394_hoisted_1 = {
  class: "nebula-screenreader-only"
};
const NebulaCardThumbnailvue_type_template_id_c5506394_hoisted_2 = {
  class: "nebula-card__product-indicator-inner"
};
function NebulaCardThumbnailvue_type_template_id_c5506394_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaThumbnail = Object(external_vue_["resolveComponent"])("NebulaThumbnail");

  const _component_NebulaBadge = Object(external_vue_["resolveComponent"])("NebulaBadge");

  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.url ? 'a' : 'div'), Object(external_vue_["mergeProps"])({
    href: $props.url || undefined
  }, $props.dataAttrs, {
    class: ["nebula-card__thumbnail-container", $props.usePushState && 'do-push-state'],
    onClick: $options.onClick,
    "aria-label": $props.linkAriaLabel,
    target: $props.target,
    style: _ctx.cssProps
  }), {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaThumbnail, {
      class: "nebula-thumbnail-theme",
      assetId: $props.assetId,
      assetType: $props.assetType,
      imageSize: "medium",
      image: $props.image,
      contained: $props.contained
    }, null, 8, ["assetId", "assetType", "image", "contained"]), Object(external_vue_["createElementVNode"])("span", NebulaCardThumbnailvue_type_template_id_c5506394_hoisted_1, Object(external_vue_["toDisplayString"])($options.stripTags($props.title)), 1), $props.anchorBadge ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaBadge, {
      key: 0,
      class: "nebula-card__anchor-badge",
      type: "anchored"
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])($props.anchorBadge), 1)]),
      _: 1
    })) : Object(external_vue_["createCommentVNode"])("", true), $props.duration ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaBadge, {
      key: 1,
      class: "nebula-card__duration",
      type: "duration"
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])($props.duration), 1)]),
      _: 1
    })) : Object(external_vue_["createCommentVNode"])("", true), $props.isHighlighted ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaBadge, {
      key: 2,
      class: "nebula-card__flag nebula-card__flag--new",
      color: "green"
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(_ctx.$t('New')), 1)]),
      _: 1
    })) : Object(external_vue_["createCommentVNode"])("", true), $props.productName ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
      key: 3,
      class: Object(external_vue_["normalizeClass"])($options.productClass)
    }, [Object(external_vue_["createElementVNode"])("div", NebulaCardThumbnailvue_type_template_id_c5506394_hoisted_2, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      class: "nebula-card__product-indicator-icon",
      symbolId: $options.productIcon,
      size: "s"
    }, null, 8, ["symbolId"]), Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      class: Object(external_vue_["normalizeClass"])($options.productLogoClass),
      symbolId: $options.productLogo
    }, null, 8, ["class", "symbolId"])])], 2)) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 1
  }, 16, ["href", "class", "onClick", "aria-label", "target", "style"]);
}
// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardThumbnail.vue?vue&type=template&id=c5506394

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Thumbnail/NebulaThumbnail.vue?vue&type=template&id=bd3c9958

const NebulaThumbnailvue_type_template_id_bd3c9958_hoisted_1 = ["data-ratio"];
function NebulaThumbnailvue_type_template_id_bd3c9958_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaImage = Object(external_vue_["resolveComponent"])("NebulaImage");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])(['nebula-thumbnail', {
      'nebula-thumbnail--contained': $props.contained
    }]),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps),
    "data-ratio": $props.ratio
  }, [Object(external_vue_["createVNode"])(_component_NebulaImage, {
    assetId: $props.assetId,
    covered: $props.covered,
    contained: $props.contained || !$props.covered,
    customStyles: {
      nebulaImageWidth: '100%'
    },
    imageSize: $props.imageSize,
    alt: $props.altText,
    thumbnailUrlOverride: $props.image,
    assetType: $props.assetType
  }, null, 8, ["assetId", "covered", "contained", "imageSize", "alt", "thumbnailUrlOverride", "assetType"])], 14, NebulaThumbnailvue_type_template_id_bd3c9958_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/Thumbnail/NebulaThumbnail.vue?vue&type=template&id=bd3c9958

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Thumbnail/NebulaThumbnail.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaThumbnailvue_type_script_lang_js = ({
  name: 'NebulaThumbnail',
  components: {
    NebulaImage: NebulaImage
  },
  mixins: [themingUtils],
  props: {
    assetId: {
      type: String,
      validator: prop => typeof prop === 'string' || prop === null || prop === undefined
    },
    altText: {
      type: String,
      default: null
    },
    contained: {
      type: Boolean,
      default: false
    },
    covered: {
      type: Boolean,
      default: true
    },
    image: {
      type: String,
      default: null
    },
    imageSize: {
      type: String,
      default: 'small',
      validator: size => ['small', 'medium', 'large', 'xlarge'].indexOf(size) !== -1
    },
    ratio: {
      type: String,
      default: '16:9',
      // 16:9, 4:3, 1:1, 30:39 (channels)
      enum: ['16:9', '4:3', '1:1', '30:39'] // for docs site

    },
    assetType: String
  },
  computed: {
    style() {
      return `background-image: url( ${this.image} );`;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Thumbnail/NebulaThumbnail.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Thumbnail/NebulaThumbnail.vue?vue&type=style&index=0&id=bd3c9958&lang=stylus
var NebulaThumbnailvue_type_style_index_0_id_bd3c9958_lang_stylus = __webpack_require__("b118");

// CONCATENATED MODULE: ./src/components/Thumbnail/NebulaThumbnail.vue







const NebulaThumbnail_exports_ = /*#__PURE__*/exportHelper_default()(NebulaThumbnailvue_type_script_lang_js, [['render',NebulaThumbnailvue_type_template_id_bd3c9958_render]])

/* harmony default export */ var NebulaThumbnail = (NebulaThumbnail_exports_);
// CONCATENATED MODULE: ./src/utils/segment-card-click-track.js
/* harmony default export */ var segment_card_click_track = ({
  name: 'SegmentCardClickTrack',
  props: {
    cardIds: {
      type: Array,

      default() {
        return [];
      }

    },
    clickTrackSegment: {
      type: Boolean,
      default: false
    },
    segmentTrackingData: {
      type: Object,

      default() {
        return {};
      }

    }
  },
  methods: {
    trackClick() {
      if (this.clickTrackSegment) {
        const opts = { ...this.segmentTrackingData,
          assetId: this.assetId || this.asset.id,
          assetTitle: this.title || this.assetTitle,
          impressions: this.cardIds
        };
        window.DEAnalytics.carouselTrack('clicked', opts);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/utils/parsing/stripTags.js
function stripTags(value) {
  // NOTE: Always escape UCC asset titles and descriptions after calling stripTags.
  // This stripTags filter is not XSS safe so do not use v-html on anything that
  // may contain user content.
  if (!value) return '';
  let text = value.toString(); // Unescape HTML Entities (prevents double escaping)

  text = text.replace('&gt;', '>').replace('&lt;', '<').replace('&amp', '&').replace('&#34;', '"').replace('&#39', '\''); // Strip HTML tags

  return text.replace(/(<([^>]+)>)/gi, '');
}

/* harmony default export */ var parsing_stripTags = (stripTags);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/Partials/NebulaCardThumbnail.vue?vue&type=script&lang=js






/* harmony default export */ var NebulaCardThumbnailvue_type_script_lang_js = ({
  name: 'NebulaCardThumbnail',
  mixins: [segment_card_click_track, themingUtils],
  components: {
    NebulaThumbnail: NebulaThumbnail,
    NebulaBadge: NebulaBadge,
    NebulaIcon: NebulaIcon
  },
  props: {
    anchorBadge: String,
    assetId: String,
    assetType: String,
    dataAttrs: Object,
    duration: String,
    embed: {
      type: Boolean,
      required: false
    },
    isHighlighted: {
      type: Boolean,
      default: false
    },
    productName: {
      type: String,
      validator: value => ['Science Techbook', 'Science for Texas', 'Math Techbook', 'Social Studies Techbook'].includes(value)
    },
    linkAriaLabel: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: null
    },
    title: String,
    url: {
      type: String,
      default: null
    },
    image: String,
    contained: {
      type: Boolean,
      default: false
    },
    usePushState: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    productClass() {
      let productClass = '';
      const baseClass = 'nebula-card__product-indicator';

      switch (this.productName) {
        case 'Science Techbook':
        case 'Science for Texas':
          productClass = `${baseClass}--science-techbook`;
          break;

        case 'Math Techbook':
          productClass = `${baseClass}--math-techbook`;
          break;

        case 'Social Studies Techbook':
          productClass = `${baseClass}--social-studies-techbook`;
          break;

        default:
          break;
      }

      return `${baseClass} ${productClass}`;
    },

    productIcon() {
      let productIcon = '';

      switch (this.productName) {
        case 'Science Techbook':
        case 'Science for Texas':
          productIcon = 'science-flask';
          break;

        case 'Math Techbook':
          productIcon = 'math';
          break;

        case 'Social Studies Techbook':
          productIcon = 'social-studies';
          break;

        default:
          break;
      }

      return productIcon;
    },

    productLogo() {
      let productLogo = '';

      switch (this.productName) {
        case 'Science Techbook':
          productLogo = 'science-techbook-horizontal';
          break;

        case 'Science for Texas':
          productLogo = 'science-for-texas-horizontal';
          break;

        case 'Math Techbook':
          productLogo = 'math-techbook-horizontal';
          break;

        case 'Social Studies Techbook':
          productLogo = 'social-studies-techbook-horizontal';
          break;

        default:
          break;
      }

      return productLogo;
    },

    productLogoClass() {
      let modifier = '';

      switch (this.productName) {
        case 'Science Techbook':
          modifier = 'science';
          break;

        case 'Science for Texas':
          modifier = 'science-for-texas';
          break;

        case 'Math Techbook':
          modifier = 'math';
          break;

        case 'Social Studies Techbook':
          modifier = 'social-studies';
          break;

        default:
          break;
      }

      return `nebula-card__product-indicator-logo--${modifier}`;
    }

  },
  methods: {
    onClick() {
      if (this.url) {
        this.trackClick();
      }
    },

    stripTags: parsing_stripTags
  }
});
// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardThumbnail.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Card/Partials/NebulaCardThumbnail.vue?vue&type=style&index=0&id=c5506394&lang=stylus
var NebulaCardThumbnailvue_type_style_index_0_id_c5506394_lang_stylus = __webpack_require__("f148");

// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardThumbnail.vue







const NebulaCardThumbnail_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCardThumbnailvue_type_script_lang_js, [['render',NebulaCardThumbnailvue_type_template_id_c5506394_render]])

/* harmony default export */ var NebulaCardThumbnail = (NebulaCardThumbnail_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/Partials/NebulaCardHeader.vue?vue&type=template&id=b92b0200

const NebulaCardHeadervue_type_template_id_b92b0200_hoisted_1 = {
  class: "nebula-card__header"
};
const NebulaCardHeadervue_type_template_id_b92b0200_hoisted_2 = {
  key: 0,
  class: "nebula-card__type"
};
function NebulaCardHeadervue_type_template_id_b92b0200_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaCardHeadervue_type_template_id_b92b0200_hoisted_1, [Object(external_vue_["renderSlot"])(_ctx.$slots, "default", {}, () => [$props.assetType ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", NebulaCardHeadervue_type_template_id_b92b0200_hoisted_2, [$props.showIcon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
    key: 0,
    size: "s",
    symbolId: $options.icon,
    class: "nebula-card__type-icon"
  }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createTextVNode"])(" " + Object(external_vue_["toDisplayString"])(_ctx.$t($props.assetType)), 1)])) : Object(external_vue_["createCommentVNode"])("", true)]), Object(external_vue_["renderSlot"])(_ctx.$slots, "actionsMenu")]);
}
// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardHeader.vue?vue&type=template&id=b92b0200

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/Partials/NebulaCardHeader.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaCardHeadervue_type_script_lang_js = ({
  name: 'NebulaCardHeader',
  components: {
    NebulaIcon: NebulaIcon
  },
  props: {
    assetType: {
      type: String,
      default: null
    },
    iconOverride: {
      type: String,
      default: null
    },
    showIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icon() {
      let icon = '';

      if (this.assetType) {
        // assetType is passed as a human-friendly string,
        // we need to re-hyphenate and lowercase it to find the correct asset icon
        const assetType = this.assetType.replace(/\s/g, '-').toLowerCase();
        icon = `asset-${assetType}`;
      }

      if (this.iconOverride) {
        icon = this.iconOverride;
      }

      return icon;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardHeader.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Card/Partials/NebulaCardHeader.vue?vue&type=style&index=0&id=b92b0200&lang=stylus
var NebulaCardHeadervue_type_style_index_0_id_b92b0200_lang_stylus = __webpack_require__("b37a");

// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardHeader.vue







const NebulaCardHeader_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCardHeadervue_type_script_lang_js, [['render',NebulaCardHeadervue_type_template_id_b92b0200_render]])

/* harmony default export */ var NebulaCardHeader = (NebulaCardHeader_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/Partials/NebulaCardTitle.vue?vue&type=template&id=0df201f6

const NebulaCardTitlevue_type_template_id_0df201f6_hoisted_1 = ["href", "tabindex", "aria-label", "target"];
function NebulaCardTitlevue_type_template_id_0df201f6_render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.url ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("a", Object(external_vue_["mergeProps"])({
    key: 0,
    href: $props.url
  }, $props.dataAttrs, {
    tabindex: $props.tabIndex,
    class: ["nebula-card__title", $props.usePushState && 'do-push-state'],
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.trackClick && _ctx.trackClick(...args)),
    "aria-label": $props.linkAriaLabel,
    target: $props.target
  }), Object(external_vue_["toDisplayString"])($options.stripTags($props.title)), 17, NebulaCardTitlevue_type_template_id_0df201f6_hoisted_1)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", Object(external_vue_["mergeProps"])({
    key: 1
  }, $props.dataAttrs, {
    class: "nebula-card__title"
  }), Object(external_vue_["toDisplayString"])($options.stripTags($props.title)), 17));
}
// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardTitle.vue?vue&type=template&id=0df201f6

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/Partials/NebulaCardTitle.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaCardTitlevue_type_script_lang_js = ({
  name: 'NebulaCardTitle',
  mixins: [segment_card_click_track],
  props: {
    assetId: String,
    dataAttrs: Object,
    embed: {
      type: Boolean,
      required: false
    },
    linkAriaLabel: {
      type: String,
      default: null
    },
    tabIndex: {
      type: String,
      default: '1'
    },
    target: {
      type: String,
      default: null
    },
    title: String,
    url: {
      type: String,
      default: null
    },
    usePushState: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    stripTags: parsing_stripTags
  }
});
// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardTitle.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Card/Partials/NebulaCardTitle.vue?vue&type=style&index=0&id=0df201f6&lang=stylus
var NebulaCardTitlevue_type_style_index_0_id_0df201f6_lang_stylus = __webpack_require__("d984");

// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardTitle.vue







const NebulaCardTitle_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCardTitlevue_type_script_lang_js, [['render',NebulaCardTitlevue_type_template_id_0df201f6_render]])

/* harmony default export */ var NebulaCardTitle = (NebulaCardTitle_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/Partials/NebulaCardDescription.vue?vue&type=template&id=335848e0

const NebulaCardDescriptionvue_type_template_id_335848e0_hoisted_1 = ["innerHTML"];
const NebulaCardDescriptionvue_type_template_id_335848e0_hoisted_2 = {
  key: 1,
  class: "nebula-card__description"
};
function NebulaCardDescriptionvue_type_template_id_335848e0_render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.htmlDescription ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", {
    key: 0,
    innerHTML: $props.htmlDescription,
    class: "nebula-card__description"
  }, null, 8, NebulaCardDescriptionvue_type_template_id_335848e0_hoisted_1)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", NebulaCardDescriptionvue_type_template_id_335848e0_hoisted_2, [Object(external_vue_["renderSlot"])(_ctx.$slots, "default", {}, () => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])($options.stripTags($options.description)), 1)])]));
}
// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardDescription.vue?vue&type=template&id=335848e0

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/Partials/NebulaCardDescription.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaCardDescriptionvue_type_script_lang_js = ({
  name: 'NebulaCardDescription',
  props: {
    text: String,
    htmlDescription: String
  },
  computed: {
    description() {
      return this.text;
    }

  },
  methods: {
    stripTags: parsing_stripTags
  }
});
// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardDescription.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Card/Partials/NebulaCardDescription.vue?vue&type=style&index=0&id=335848e0&lang=stylus
var NebulaCardDescriptionvue_type_style_index_0_id_335848e0_lang_stylus = __webpack_require__("b809");

// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardDescription.vue







const NebulaCardDescription_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCardDescriptionvue_type_script_lang_js, [['render',NebulaCardDescriptionvue_type_template_id_335848e0_render]])

/* harmony default export */ var NebulaCardDescription = (NebulaCardDescription_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/Partials/NebulaCardMetadata.vue?vue&type=template&id=669c7497

const NebulaCardMetadatavue_type_template_id_669c7497_hoisted_1 = {
  key: 0,
  class: "nebula-card__metadata"
};
const NebulaCardMetadatavue_type_template_id_669c7497_hoisted_2 = {
  key: 0,
  class: "nebula-card__metada-item nebula-card__metada-item--lesson-duration"
};
function NebulaCardMetadatavue_type_template_id_669c7497_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaBadge = Object(external_vue_["resolveComponent"])("NebulaBadge");

  return $props.metadata ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("ul", NebulaCardMetadatavue_type_template_id_669c7497_hoisted_1, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.metadata, (badge, index) => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
      class: Object(external_vue_["normalizeClass"])(["nebula-card__metada-item", badge.type]),
      key: index
    }, [Object(external_vue_["createVNode"])(_component_NebulaBadge, {
      type: badge.type === 'grade-band' ? 'fill' : 'outline',
      color: badge.type === 'grade-band' ? 'null' : 'dark-gray',
      size: "s"
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(badge.value || badge.name), 1)]),
      _: 2
    }, 1032, ["type", "color"])], 2);
  }), 128)), $props.lessonDuration ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", NebulaCardMetadatavue_type_template_id_669c7497_hoisted_2, [Object(external_vue_["createVNode"])(_component_NebulaBadge, {
    color: "green",
    icon: "clock",
    size: "s"
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])($props.lessonDuration) + " mins ", 1)]),
    _: 1
  })])) : Object(external_vue_["createCommentVNode"])("", true)])) : Object(external_vue_["createCommentVNode"])("", true);
}
// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardMetadata.vue?vue&type=template&id=669c7497

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/Partials/NebulaCardMetadata.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaCardMetadatavue_type_script_lang_js = ({
  name: 'NebulaCardMetadata',
  components: {
    NebulaBadge: NebulaBadge
  },
  props: {
    metadata: Array,
    lessonDuration: Number
  }
});
// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardMetadata.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Card/Partials/NebulaCardMetadata.vue?vue&type=style&index=0&id=669c7497&lang=stylus
var NebulaCardMetadatavue_type_style_index_0_id_669c7497_lang_stylus = __webpack_require__("a1ab");

// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardMetadata.vue







const NebulaCardMetadata_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCardMetadatavue_type_script_lang_js, [['render',NebulaCardMetadatavue_type_template_id_669c7497_render]])

/* harmony default export */ var NebulaCardMetadata = (NebulaCardMetadata_exports_);
// CONCATENATED MODULE: ./src/utils/formatDuration.js
function formatDuration(durationInSeconds) {
  let hours;
  let formattedDuration = ''; // We only need to list hours if the duration is longer than 1 hour (60 * 60)

  if (durationInSeconds >= 3600) {
    hours = Math.floor(durationInSeconds / 3600);
    formattedDuration += `${hours}:`;
  }

  let minutes = Math.floor(durationInSeconds % 3600 / 60);

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  formattedDuration += `${minutes}:`;
  let seconds = durationInSeconds % 60;

  if (seconds < 10) {
    seconds = `0${seconds}`;
  }

  formattedDuration += seconds;
  return formattedDuration;
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaActivityCard.vue?vue&type=script&lang=js









/* harmony default export */ var NebulaActivityCardvue_type_script_lang_js = ({
  name: 'NebulaActivityCard',
  components: {
    NebulaButton: NebulaButton,
    NebulaContainerCard: NebulaContainerCard,
    NebulaCardThumbnail: NebulaCardThumbnail,
    NebulaCardHeader: NebulaCardHeader,
    NebulaCardTitle: NebulaCardTitle,
    NebulaCardDescription: NebulaCardDescription,
    NebulaCardMetadata: NebulaCardMetadata
  },
  emits: ['previewEvent', 'embedAssetEvent'],
  mixins: [segment_card_click_track],
  props: {
    asset: Object,
    assetType: String,
    cardProps: Object,
    dataAttrs: Object,
    element: {
      type: String,
      default: 'li'
    },
    embed: {
      type: Boolean,
      required: false
    },
    imageOverride: {
      type: String,
      default: null
    },
    productName: {
      type: String,
      default: null,
      enum: ['Science Techbook', 'Math Techbook', 'Social Studies Techbook']
    },
    showPreview: {
      type: Boolean,
      default: false
    },
    showEmbedButton: {
      type: Boolean,
      default: false
    },
    title: String,
    url: String,
    usePushState: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    assetTitle() {
      let title = '';

      if (this.title) {
        title = this.title;
      }

      if (this.asset.title) {
        title = this.asset.title;
      } else {
        title = this.asset.name;
      }

      return title;
    },

    assetTypeFriendly() {
      if (this.assetType) {
        return this.assetType;
      }

      if (this.asset.type && this.asset.type.name) {
        return this.asset.type.name;
      }

      return null;
    },

    cardLink() {
      const url = this.url || `/learn/player/${this.asset.id}`;
      return this.embed ? `${url}?embed=true` : url;
    },

    formattedDuration() {
      if (this.asset.duration) {
        return formatDuration(this.asset.duration);
      }

      return null;
    }

  },
  methods: {
    previewButtonClick() {
      this.$emit('previewEvent');
    },

    embedAssetButtonClick() {
      this.$emit('embedAssetEvent', this.asset);
    }

  }
});
// CONCATENATED MODULE: ./src/components/Card/NebulaActivityCard.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Card/NebulaActivityCard.vue?vue&type=style&index=0&id=1f850cec&lang=stylus
var NebulaActivityCardvue_type_style_index_0_id_1f850cec_lang_stylus = __webpack_require__("1614");

// CONCATENATED MODULE: ./src/components/Card/NebulaActivityCard.vue







const NebulaActivityCard_exports_ = /*#__PURE__*/exportHelper_default()(NebulaActivityCardvue_type_script_lang_js, [['render',NebulaActivityCardvue_type_template_id_1f850cec_render]])

/* harmony default export */ var NebulaActivityCard = (NebulaActivityCard_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaAssetCard.vue?vue&type=template&id=5bb755db

const NebulaAssetCardvue_type_template_id_5bb755db_hoisted_1 = ["aria-label"];
function NebulaAssetCardvue_type_template_id_5bb755db_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaCardThumbnail = Object(external_vue_["resolveComponent"])("NebulaCardThumbnail");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaCardHeader = Object(external_vue_["resolveComponent"])("NebulaCardHeader");

  const _component_NebulaCardTitle = Object(external_vue_["resolveComponent"])("NebulaCardTitle");

  const _component_NebulaCardDescription = Object(external_vue_["resolveComponent"])("NebulaCardDescription");

  const _component_NebulaCardMetadata = Object(external_vue_["resolveComponent"])("NebulaCardMetadata");

  const _component_NebulaCardLinks = Object(external_vue_["resolveComponent"])("NebulaCardLinks");

  const _component_NebulaCardLogos = Object(external_vue_["resolveComponent"])("NebulaCardLogos");

  const _component_NebulaCard = Object(external_vue_["resolveComponent"])("NebulaCard");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaCard, Object(external_vue_["mergeProps"])({
    element: $props.element,
    asset: $props.asset,
    class: ["nebula-card--asset", {
      'nebula-card--asset--horizontal': $props.horizontal
    }],
    "data-asset-id": $props.asset.id,
    usePushState: $props.usePushState
  }, $props.cardProps), {
    thumbnail: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaCardThumbnail, {
      assetId: $props.asset.id,
      assetType: $options.assetTypeFriendly,
      cardIds: _ctx.cardIds,
      clickTrackSegment: _ctx.clickTrackSegment,
      dataAttrs: $props.dataAttrs,
      duration: $options.formattedDuration,
      embed: $props.embed,
      image: $props.imageOverride,
      isHighlighted: $props.asset.is_highlighted,
      linkAriaLabel: $props.asset.link_aria_label,
      productName: $props.productName,
      segmentTrackingData: _ctx.segmentTrackingData,
      target: $props.asset.target,
      title: $options.assetTitle,
      url: $options.cardLink && !$props.showPreview ? $options.cardLink : null,
      usePushState: $props.usePushState
    }, null, 8, ["assetId", "assetType", "cardIds", "clickTrackSegment", "dataAttrs", "duration", "embed", "image", "isHighlighted", "linkAriaLabel", "productName", "segmentTrackingData", "target", "title", "url", "usePushState"]), $props.showPreview ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", {
      key: 0,
      class: "nebula-card__preview-button",
      "aria-label": _ctx.$t('Open preview'),
      onClick: _cache[0] || (_cache[0] = (...args) => $options.previewButtonClick && $options.previewButtonClick(...args))
    }, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      class: "nebula-card__preview-button-visual",
      text: _ctx.$t('Preview'),
      shape: "pill",
      size: "s",
      "aria-hidden": "true",
      isStatic: ""
    }, null, 8, ["text"])], 8, NebulaAssetCardvue_type_template_id_5bb755db_hoisted_1)) : Object(external_vue_["createCommentVNode"])("", true), $props.showEmbedButton ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
      key: 1,
      class: "nebula-card__embed-button",
      text: _ctx.$t('Embed'),
      onClick: $options.embedAssetButtonClick
    }, null, 8, ["text", "onClick"])) : Object(external_vue_["createCommentVNode"])("", true)]),
    content: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaCardHeader, {
      assetType: $options.assetTypeFriendly
    }, {
      actionsMenu: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "actionsMenu")]),
      _: 3
    }, 8, ["assetType"]), Object(external_vue_["createVNode"])(_component_NebulaCardTitle, {
      assetId: $props.asset.id,
      cardIds: _ctx.cardIds,
      clickTrackSegment: _ctx.clickTrackSegment,
      dataAttrs: $props.dataAttrs,
      embed: $props.embed,
      linkAriaLabel: $props.asset.link_aria_label,
      segmentTrackingData: _ctx.segmentTrackingData,
      tabIndex: $props.showPreview ? null : '-1',
      target: $props.asset.target,
      title: $options.assetTitle,
      url: $options.cardLink,
      usePushState: $props.usePushState
    }, null, 8, ["assetId", "cardIds", "clickTrackSegment", "dataAttrs", "embed", "linkAriaLabel", "segmentTrackingData", "tabIndex", "target", "title", "url", "usePushState"]), Object(external_vue_["createVNode"])(_component_NebulaCardDescription, {
      text: $props.asset.description,
      htmlDescription: $props.asset.html_description
    }, null, 8, ["text", "htmlDescription"]), Object(external_vue_["createVNode"])(_component_NebulaCardMetadata, {
      metadata: $props.asset.info_pills
    }, null, 8, ["metadata"]), $props.cardLinks || $props.asset.links ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaCardLinks, {
      key: 0,
      data: $props.cardLinks || $props.asset.links
    }, null, 8, ["data"])) : Object(external_vue_["createCommentVNode"])("", true), $options.cardHasLogos ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaCardLogos, {
      key: 1,
      asset: $props.asset
    }, null, 8, ["asset"])) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 3
  }, 16, ["element", "asset", "class", "data-asset-id", "usePushState"]);
}
// CONCATENATED MODULE: ./src/components/Card/NebulaAssetCard.vue?vue&type=template&id=5bb755db

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaCard.vue?vue&type=template&id=74c1e8b8

const NebulaCardvue_type_template_id_74c1e8b8_hoisted_1 = {
  key: 0,
  class: "nebula-card__media"
};
const NebulaCardvue_type_template_id_74c1e8b8_hoisted_2 = {
  class: "nebula-card__content"
};
const NebulaCardvue_type_template_id_74c1e8b8_hoisted_3 = {
  key: 1,
  class: "nebula-card__footer"
};
function NebulaCardvue_type_template_id_74c1e8b8_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaCardLabel = Object(external_vue_["resolveComponent"])("NebulaCardLabel");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.element), Object(external_vue_["mergeProps"])({
    class: "nebula-card"
  }, _ctx.$attrs, {
    style: _ctx.cssProps
  }), {
    default: Object(external_vue_["withCtx"])(() => [$options.hasMediaSlot ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaCardvue_type_template_id_74c1e8b8_hoisted_1, [Object(external_vue_["renderSlot"])(_ctx.$slots, "thumbnail")])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaCardvue_type_template_id_74c1e8b8_hoisted_2, [Object(external_vue_["renderSlot"])(_ctx.$slots, "content")]), $options.hasFooterSlot ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaCardvue_type_template_id_74c1e8b8_hoisted_3, [Object(external_vue_["renderSlot"])(_ctx.$slots, "footer")])) : Object(external_vue_["createCommentVNode"])("", true), $props.userGenContent ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaCardLabel, {
      key: 2,
      type: "user-generated"
    })) : Object(external_vue_["createCommentVNode"])("", true), $props.cardLabel ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaCardLabel, Object(external_vue_["normalizeProps"])(Object(external_vue_["mergeProps"])({
      key: 3
    }, $props.cardLabel)), null, 16)) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 3
  }, 16, ["style"]);
}
// CONCATENATED MODULE: ./src/components/Card/NebulaCard.vue?vue&type=template&id=74c1e8b8

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/Partials/NebulaCardLabel.vue?vue&type=template&id=53d91362

const NebulaCardLabelvue_type_template_id_53d91362_hoisted_1 = {
  key: 1
};
const NebulaCardLabelvue_type_template_id_53d91362_hoisted_2 = {
  key: 1,
  class: "nebula-card__label-text"
};
function NebulaCardLabelvue_type_template_id_53d91362_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  const _component_NebulaTitleTooltip = Object(external_vue_["resolveComponent"])("NebulaTitleTooltip");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.styleClass)
  }, [$options.validTooltipText ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaTitleTooltip, {
    key: 0,
    text: $options.validTooltipText
  }, {
    default: Object(external_vue_["withCtx"])(() => [$options.validIcon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
      key: 0,
      symbolId: $options.validIcon,
      class: "nebula-card__label-icon",
      size: "s"
    }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true), $options.validText ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", NebulaCardLabelvue_type_template_id_53d91362_hoisted_1, Object(external_vue_["toDisplayString"])($options.validText), 1)) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 1
  }, 8, ["text"])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaCardLabelvue_type_template_id_53d91362_hoisted_2, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
    symbolId: $options.validIcon,
    size: "s"
  }, null, 8, ["symbolId"]), Object(external_vue_["createTextVNode"])(" " + Object(external_vue_["toDisplayString"])($options.validText), 1)]))], 2);
}
// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardLabel.vue?vue&type=template&id=53d91362

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/Partials/NebulaCardLabel.vue?vue&type=script&lang=js


const NebulaCardLabelvue_type_script_lang_js_options = {
  // add new supported options here, with the key as the string being passed to
  // prop 'type' (see NebulaCard where NebulaCardLabel is rendered)
  'user-generated': {
    text: 'User-Generated Content',
    icon: 'information',
    tooltipText: `The views and opinions expressed in this content are solely
            those of the content creator and do not reflect or represent
            the views, opinions, or positions held by Discovery Education, Inc.`
  }
};
const supportedIcons = ['information', 'exclamation'];
/* harmony default export */ var NebulaCardLabelvue_type_script_lang_js = ({
  name: 'NebulaCardLabel',
  components: {
    NebulaIcon: NebulaIcon,
    NebulaTitleTooltip: NebulaTitleTooltip
  },
  props: {
    color: String,
    text: String,
    tooltipText: String,
    icon: {
      type: String,
      validator: value => supportedIcons.includes(value)
    },
    type: {
      type: String,
      validator: value => Object.keys(NebulaCardLabelvue_type_script_lang_js_options).includes(value)
    }
  },
  computed: {
    validText() {
      var _options$this$type;

      return this.text || ((_options$this$type = NebulaCardLabelvue_type_script_lang_js_options[this.type]) === null || _options$this$type === void 0 ? void 0 : _options$this$type.text);
    },

    validIcon() {
      var _options$this$type2;

      return this.icon || ((_options$this$type2 = NebulaCardLabelvue_type_script_lang_js_options[this.type]) === null || _options$this$type2 === void 0 ? void 0 : _options$this$type2.icon);
    },

    validTooltipText() {
      var _options$this$type3;

      return this.tooltipText || ((_options$this$type3 = NebulaCardLabelvue_type_script_lang_js_options[this.type]) === null || _options$this$type3 === void 0 ? void 0 : _options$this$type3.tooltipText);
    },

    styleClass() {
      const classBase = 'nebula-card__label';
      const classes = [classBase];

      if (this.type) {
        classes.push(`${classBase}--${this.type}`);
      }

      if (this.color) {
        classes.push(`${classBase}--${this.color}`);
      }

      return classes;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardLabel.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Card/Partials/NebulaCardLabel.vue?vue&type=style&index=0&id=53d91362&lang=stylus
var NebulaCardLabelvue_type_style_index_0_id_53d91362_lang_stylus = __webpack_require__("28be");

// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardLabel.vue







const NebulaCardLabel_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCardLabelvue_type_script_lang_js, [['render',NebulaCardLabelvue_type_template_id_53d91362_render]])

/* harmony default export */ var NebulaCardLabel = (NebulaCardLabel_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaCard.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaCardvue_type_script_lang_js = ({
  name: 'NebulaCard',
  components: {
    NebulaCardLabel: NebulaCardLabel
  },
  mixins: [themingUtils],
  props: {
    element: {
      type: String,
      default: 'li'
    },
    cardLabel: {
      type: Object
    },
    userGenContent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasFooterSlot() {
      return !!this.$slots.footer;
    },

    hasMediaSlot() {
      return !!this.$slots.thumbnail;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Card/NebulaCard.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Card/NebulaCard.vue?vue&type=style&index=0&id=74c1e8b8&lang=stylus
var NebulaCardvue_type_style_index_0_id_74c1e8b8_lang_stylus = __webpack_require__("880f");

// CONCATENATED MODULE: ./src/components/Card/NebulaCard.vue







const NebulaCard_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCardvue_type_script_lang_js, [['render',NebulaCardvue_type_template_id_74c1e8b8_render]])

/* harmony default export */ var NebulaCard = (NebulaCard_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/Partials/NebulaCardLinks.vue?vue&type=template&id=037c7572

function NebulaCardLinksvue_type_template_id_037c7572_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaListItem = Object(external_vue_["resolveComponent"])("NebulaListItem");

  const _component_NebulaListGroup = Object(external_vue_["resolveComponent"])("NebulaListGroup");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaListGroup, {
    class: "nebula-card__links",
    nested: ""
  }, {
    content: Object(external_vue_["withCtx"])(() => [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.data, (link, idx) => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaListItem, {
        class: "nebula-card__link",
        key: idx,
        icon: link.icon,
        text: link.text,
        link: link.link,
        dataAttrs: link.dataAttrs,
        linkAriaLabel: link.link_aria_label,
        target: link.target
      }, null, 8, ["icon", "text", "link", "dataAttrs", "linkAriaLabel", "target"]);
    }), 128))]),
    _: 1
  });
}
// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardLinks.vue?vue&type=template&id=037c7572

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/Partials/NebulaCardLinks.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaCardLinksvue_type_script_lang_js = ({
  name: 'NebulaCardLinks',
  components: {
    NebulaListGroup: NebulaListGroup,
    NebulaListItem: NebulaListItem
  },
  props: {
    data: {
      type: Array,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardLinks.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Card/Partials/NebulaCardLinks.vue?vue&type=style&index=0&id=037c7572&lang=stylus
var NebulaCardLinksvue_type_style_index_0_id_037c7572_lang_stylus = __webpack_require__("b5b9");

// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardLinks.vue







const NebulaCardLinks_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCardLinksvue_type_script_lang_js, [['render',NebulaCardLinksvue_type_template_id_037c7572_render]])

/* harmony default export */ var NebulaCardLinks = (NebulaCardLinks_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/Partials/NebulaCardLogos.vue?vue&type=template&id=4e9ca70a

const NebulaCardLogosvue_type_template_id_4e9ca70a_hoisted_1 = {
  class: "nebula-card__partner-logo"
};
const NebulaCardLogosvue_type_template_id_4e9ca70a_hoisted_2 = ["src", "alt"];
function NebulaCardLogosvue_type_template_id_4e9ca70a_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaCardLogosvue_type_template_id_4e9ca70a_hoisted_1, [Object(external_vue_["createElementVNode"])("img", {
    class: "nebula-card__logo",
    src: $options.logoSource,
    alt: $options.logoAlt
  }, null, 8, NebulaCardLogosvue_type_template_id_4e9ca70a_hoisted_2)]);
}
// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardLogos.vue?vue&type=template&id=4e9ca70a

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/Partials/NebulaCardLogos.vue?vue&type=script&lang=js
/* harmony default export */ var NebulaCardLogosvue_type_script_lang_js = ({
  name: 'NebulaCardLogos',
  props: {
    asset: Object
  },
  computed: {
    logoSource() {
      let source;

      if (this.asset.de_original_partner_logo) {
        source = this.asset.de_original_partner_logo.url;
      }

      if (this.asset.logos) {
        source = this.asset.logos[0].file_path;
      }

      return source;
    },

    logoAlt() {
      let alt;

      if (this.asset.de_original_partner_logo) {
        alt = this.asset.de_original_partner_logo.alt;
      }

      if (this.asset.logos) {
        alt = this.asset.logos[0].description;
      }

      return alt || '';
    }

  }
});
// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardLogos.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Card/Partials/NebulaCardLogos.vue?vue&type=style&index=0&id=4e9ca70a&lang=stylus
var NebulaCardLogosvue_type_style_index_0_id_4e9ca70a_lang_stylus = __webpack_require__("c134");

// CONCATENATED MODULE: ./src/components/Card/Partials/NebulaCardLogos.vue







const NebulaCardLogos_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCardLogosvue_type_script_lang_js, [['render',NebulaCardLogosvue_type_template_id_4e9ca70a_render]])

/* harmony default export */ var NebulaCardLogos = (NebulaCardLogos_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaAssetCard.vue?vue&type=script&lang=js











/* harmony default export */ var NebulaAssetCardvue_type_script_lang_js = ({
  name: 'NebulaAssetCard',
  components: {
    NebulaButton: NebulaButton,
    NebulaCard: NebulaCard,
    NebulaCardThumbnail: NebulaCardThumbnail,
    NebulaCardHeader: NebulaCardHeader,
    NebulaCardTitle: NebulaCardTitle,
    NebulaCardDescription: NebulaCardDescription,
    NebulaCardMetadata: NebulaCardMetadata,
    NebulaCardLinks: NebulaCardLinks,
    NebulaCardLogos: NebulaCardLogos
  },
  mixins: [segment_card_click_track],
  props: {
    asset: Object,
    assetType: String,
    dataAttrs: Object,
    // for anything to be passed through to the base NebulaCard
    cardProps: Object,
    element: {
      type: String,
      default: 'li'
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    imageOverride: {
      type: String,
      default: null
    },
    productName: {
      type: String,
      default: null,
      enum: ['Science Techbook', 'Math Techbook', 'Social Studies Techbook']
    },
    showPreview: {
      type: Boolean,
      default: false
    },
    showEmbedButton: {
      type: Boolean,
      default: false
    },
    title: String,
    url: String,
    usePushState: {
      type: Boolean,
      default: false
    },
    embed: {
      type: Boolean,
      required: false
    },
    cardLinks: {
      type: Array
    }
  },
  emits: ['previewEvent', 'embedAssetEvent'],
  computed: {
    assetTitle() {
      let title = '';

      if (this.title) {
        title = this.title;
      }

      if (this.asset.title) {
        title = this.asset.title;
      } else {
        title = this.asset.name;
      }

      return title;
    },

    assetTypeFriendly() {
      if (this.assetType) {
        return this.assetType;
      }

      if (this.asset.type && this.asset.type.name) {
        return this.asset.type.name;
      }

      return null;
    },

    cardHasLogos() {
      var _this$asset$de_origin, _this$asset$logos, _this$asset$logos$;

      // Sometimes this.asset.de_original_partner_logo is an object
      // without any url inside. Make sure we don't try to show
      // a logo for that case
      return ((_this$asset$de_origin = this.asset.de_original_partner_logo) === null || _this$asset$de_origin === void 0 ? void 0 : _this$asset$de_origin.url) || ((_this$asset$logos = this.asset.logos) === null || _this$asset$logos === void 0 ? void 0 : (_this$asset$logos$ = _this$asset$logos[0]) === null || _this$asset$logos$ === void 0 ? void 0 : _this$asset$logos$.file_path);
    },

    cardLink() {
      const url = this.url || `/learn/player/${this.asset.id}`;
      return this.embed ? `${url}?embed=true` : url;
    },

    formattedDuration() {
      if (this.asset.duration) {
        return formatDuration(this.asset.duration);
      }

      return null;
    }

  },
  methods: {
    previewButtonClick() {
      this.$emit('previewEvent');
    },

    embedAssetButtonClick() {
      this.$emit('embedAssetEvent', this.asset);
    }

  }
});
// CONCATENATED MODULE: ./src/components/Card/NebulaAssetCard.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Card/NebulaAssetCard.vue?vue&type=style&index=0&id=5bb755db&lang=stylus
var NebulaAssetCardvue_type_style_index_0_id_5bb755db_lang_stylus = __webpack_require__("51e0");

// CONCATENATED MODULE: ./src/components/Card/NebulaAssetCard.vue







const NebulaAssetCard_exports_ = /*#__PURE__*/exportHelper_default()(NebulaAssetCardvue_type_script_lang_js, [['render',NebulaAssetCardvue_type_template_id_5bb755db_render]])

/* harmony default export */ var NebulaAssetCard = (NebulaAssetCard_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaAssignmentCard.vue?vue&type=template&id=69c1524f

const NebulaAssignmentCardvue_type_template_id_69c1524f_hoisted_1 = {
  key: 0,
  class: "nebula-card__classroom"
};
const NebulaAssignmentCardvue_type_template_id_69c1524f_hoisted_2 = {
  key: 1,
  class: "nebula-card__teacher"
};
const NebulaAssignmentCardvue_type_template_id_69c1524f_hoisted_3 = {
  class: "nebula-card__metadata"
};
function NebulaAssignmentCardvue_type_template_id_69c1524f_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaCardThumbnail = Object(external_vue_["resolveComponent"])("NebulaCardThumbnail");

  const _component_NebulaCardHeader = Object(external_vue_["resolveComponent"])("NebulaCardHeader");

  const _component_NebulaCardTitle = Object(external_vue_["resolveComponent"])("NebulaCardTitle");

  const _component_NebulaCardDescription = Object(external_vue_["resolveComponent"])("NebulaCardDescription");

  const _component_NebulaCard = Object(external_vue_["resolveComponent"])("NebulaCard");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaCard, Object(external_vue_["mergeProps"])({
    element: $props.element,
    asset: $props.assignmentData,
    class: "nebula-card--assignment",
    "data-asset-id": $props.assignmentData.asset_id,
    usePushState: $props.usePushState
  }, $props.cardProps), Object(external_vue_["createSlots"])({
    content: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaCardHeader, null, {
      actionsMenu: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "actionsMenu")]),
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "AssignmentStatus")]),
      _: 3
    }), Object(external_vue_["createVNode"])(_component_NebulaCardTitle, {
      dataAttrs: $props.dataAttrs,
      tabIndex: $props.hasThumbnail && '-1' || null,
      title: $props.assignmentData.name,
      url: $props.assignmentData.url,
      usePushState: $props.usePushState
    }, null, 8, ["dataAttrs", "tabIndex", "title", "url", "usePushState"]), Object(external_vue_["createVNode"])(_component_NebulaCardDescription, null, {
      default: Object(external_vue_["withCtx"])(() => [$props.assignmentData.classroom ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", NebulaAssignmentCardvue_type_template_id_69c1524f_hoisted_1, Object(external_vue_["toDisplayString"])($props.assignmentData.classroom), 1)) : Object(external_vue_["createCommentVNode"])("", true), $props.assignmentData.teacher ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", NebulaAssignmentCardvue_type_template_id_69c1524f_hoisted_2, Object(external_vue_["toDisplayString"])($props.assignmentData.teacher.first_name) + " " + Object(external_vue_["toDisplayString"])($props.assignmentData.teacher.last_name), 1)) : Object(external_vue_["createCommentVNode"])("", true)]),
      _: 1
    }), Object(external_vue_["createElementVNode"])("div", NebulaAssignmentCardvue_type_template_id_69c1524f_hoisted_3, [Object(external_vue_["renderSlot"])(_ctx.$slots, "AssignmentBadges")])]),
    _: 2
  }, [$props.hasThumbnail ? {
    name: "thumbnail",
    fn: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaCardThumbnail, {
      assetId: $props.assignmentData.asset_id,
      assetType: $props.assignmentData.asset_type,
      dataAttrs: $props.dataAttrs,
      title: $props.assignmentData.name,
      url: $props.assignmentData.url,
      usePushState: $props.usePushState
    }, null, 8, ["assetId", "assetType", "dataAttrs", "title", "url", "usePushState"])]),
    key: "0"
  } : undefined]), 1040, ["element", "asset", "data-asset-id", "usePushState"]);
}
// CONCATENATED MODULE: ./src/components/Card/NebulaAssignmentCard.vue?vue&type=template&id=69c1524f

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaAssignmentCard.vue?vue&type=script&lang=js





/* harmony default export */ var NebulaAssignmentCardvue_type_script_lang_js = ({
  name: 'NebulaAssignmentCard',
  components: {
    NebulaCard: NebulaCard,
    NebulaCardThumbnail: NebulaCardThumbnail,
    NebulaCardHeader: NebulaCardHeader,
    NebulaCardTitle: NebulaCardTitle,
    NebulaCardDescription: NebulaCardDescription
  },
  props: {
    assignmentData: {
      type: Object,
      default: () => ({})
    },
    // for anything to be passed through to the base NebulaCard
    cardProps: Object,
    dataAttrs: Object,
    element: {
      type: String,
      default: 'li'
    },
    hasThumbnail: {
      type: Boolean,
      default: true
    },
    usePushState: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/Card/NebulaAssignmentCard.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Card/NebulaAssignmentCard.vue?vue&type=style&index=0&id=69c1524f&lang=stylus
var NebulaAssignmentCardvue_type_style_index_0_id_69c1524f_lang_stylus = __webpack_require__("9b74");

// CONCATENATED MODULE: ./src/components/Card/NebulaAssignmentCard.vue







const NebulaAssignmentCard_exports_ = /*#__PURE__*/exportHelper_default()(NebulaAssignmentCardvue_type_script_lang_js, [['render',NebulaAssignmentCardvue_type_template_id_69c1524f_render]])

/* harmony default export */ var NebulaAssignmentCard = (NebulaAssignmentCard_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaChannelCard.vue?vue&type=template&id=3c11b1ee

const NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_1 = ["href", "tabindex"];
const NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_2 = {
  class: "nebula-screenreader-only"
};
const NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_3 = {
  key: 1,
  class: "nebula-card__thumbnail-container"
};
const NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_4 = {
  class: "nebula-screenreader-only"
};
const NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_5 = {
  class: "nebula-card__content-placeholder"
};
const NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_6 = {
  class: "nebula-card__header"
};
const NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_7 = {
  key: 0,
  class: "nebula-card__type"
};
const NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_8 = {
  class: "nebula-card__title"
};
const NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_9 = {
  class: "nebula-card__content"
};
const NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_10 = {
  class: "nebula-card__header"
};
const NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_11 = {
  key: 0,
  class: "nebula-card__type"
};
const NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_12 = ["href"];
const NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_13 = {
  key: 1,
  class: "nebula-card__title"
};
function NebulaChannelCardvue_type_template_id_3c11b1ee_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaThumbnail = Object(external_vue_["resolveComponent"])("NebulaThumbnail");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.element), Object(external_vue_["mergeProps"])({
    class: "nebula-card nebula-card--channel"
  }, _ctx.$attrs, {
    "data-asset-id": $props.asset.id
  }), {
    default: Object(external_vue_["withCtx"])(() => [$props.useLink ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("a", {
      key: 0,
      href: $options.cardLink,
      class: Object(external_vue_["normalizeClass"])(["nebula-card__thumbnail-container", $props.usePushState && 'do-push-state scroll-top-on-click']),
      tabindex: $options.tabIndexValue,
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.trackClick && _ctx.trackClick(...args))
    }, [Object(external_vue_["createVNode"])(_component_NebulaThumbnail, {
      assetId: $props.asset.id,
      assetType: $options.assetTypeFriendly,
      imageSize: "medium",
      ratio: "30:39"
    }, null, 8, ["assetId", "assetType"]), Object(external_vue_["createElementVNode"])("span", NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_2, Object(external_vue_["toDisplayString"])($options.stripTags($options.assetTitle)), 1)], 10, NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_1)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_3, [Object(external_vue_["createVNode"])(_component_NebulaThumbnail, {
      assetId: $props.asset.id,
      assetType: $options.assetTypeFriendly,
      imageSize: "medium",
      ratio: "30:39"
    }, null, 8, ["assetId", "assetType"]), Object(external_vue_["createElementVNode"])("span", NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_4, Object(external_vue_["toDisplayString"])($options.stripTags($options.assetTitle)), 1)])), Object(external_vue_["createElementVNode"])("div", NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_5, [Object(external_vue_["createElementVNode"])("div", NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_6, [$options.assetTypeFriendly ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_7, Object(external_vue_["toDisplayString"])(_ctx.$t($options.assetTypeFriendly)), 1)) : Object(external_vue_["createCommentVNode"])("", true)]), Object(external_vue_["createElementVNode"])("div", NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_8, Object(external_vue_["toDisplayString"])($options.stripTags($options.assetTitle)), 1)]), Object(external_vue_["createElementVNode"])("div", NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_9, [Object(external_vue_["createElementVNode"])("div", NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_10, [$options.assetTypeFriendly ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_11, Object(external_vue_["toDisplayString"])(_ctx.$t($options.assetTypeFriendly)), 1)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["renderSlot"])(_ctx.$slots, "actionsMenu")]), $props.useLink ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("a", {
      key: 0,
      href: $options.cardLink,
      tabindex: "-1",
      class: Object(external_vue_["normalizeClass"])(["nebula-card__title", $props.usePushState && 'do-push-state scroll-top-on-click']),
      onClick: _cache[1] || (_cache[1] = (...args) => _ctx.trackClick && _ctx.trackClick(...args))
    }, Object(external_vue_["toDisplayString"])($options.stripTags($options.assetTitle)), 11, NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_12)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", NebulaChannelCardvue_type_template_id_3c11b1ee_hoisted_13, Object(external_vue_["toDisplayString"])($options.stripTags($options.assetTitle)), 1))]), $props.showEmbedButton ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
      key: 2,
      class: "nebula-card__embed-button",
      text: _ctx.$t('Embed'),
      onClick: $options.embedAssetButtonClick
    }, null, 8, ["text", "onClick"])) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 3
  }, 16, ["data-asset-id"]);
}
// CONCATENATED MODULE: ./src/components/Card/NebulaChannelCard.vue?vue&type=template&id=3c11b1ee

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaChannelCard.vue?vue&type=script&lang=js




/* harmony default export */ var NebulaChannelCardvue_type_script_lang_js = ({
  name: 'NebulaChannelCard',
  mixins: [segment_card_click_track],
  components: {
    NebulaButton: NebulaButton,
    NebulaThumbnail: NebulaThumbnail
  },
  props: {
    asset: Object,
    assetType: String,
    element: {
      type: String,
      default: 'li'
    },
    url: String,
    usePushState: {
      type: Boolean,
      default: false
    },
    title: String,
    embed: {
      type: Boolean,
      required: false
    },
    useLink: {
      type: Boolean,
      default: true
    },
    isFocusable: {
      type: Boolean,
      default: true
    },
    showEmbedButton: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      default: '_self'
    }
  },
  emits: ['embedAssetEvent'],
  computed: {
    assetTitle() {
      let title = '';

      if (this.title) {
        title = this.title;
      }

      if (this.asset.title) {
        title = this.asset.title;
      } else {
        title = this.asset.name;
      }

      return title;
    },

    assetTypeFriendly() {
      if (this.assetType) {
        return this.assetType;
      }

      if (this.asset.type && this.asset.type.name) {
        return this.asset.type.name;
      }

      return null;
    },

    cardLink() {
      const url = this.url || `/learn/player/${this.asset.id}`;
      return this.embed ? `${url}?embed=true` : url;
    },

    tabIndexValue() {
      return this.isFocusable ? 0 : -1;
    }

  },
  methods: {
    embedAssetButtonClick() {
      this.$emit('embedAssetEvent', this.asset);
    },

    stripTags: parsing_stripTags
  }
});
// CONCATENATED MODULE: ./src/components/Card/NebulaChannelCard.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Card/NebulaChannelCard.vue?vue&type=style&index=0&id=3c11b1ee&lang=stylus
var NebulaChannelCardvue_type_style_index_0_id_3c11b1ee_lang_stylus = __webpack_require__("6418");

// CONCATENATED MODULE: ./src/components/Card/NebulaChannelCard.vue







const NebulaChannelCard_exports_ = /*#__PURE__*/exportHelper_default()(NebulaChannelCardvue_type_script_lang_js, [['render',NebulaChannelCardvue_type_template_id_3c11b1ee_render]])

/* harmony default export */ var NebulaChannelCard = (NebulaChannelCard_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaClassroomCard.vue?vue&type=template&id=2deea084

const NebulaClassroomCardvue_type_template_id_2deea084_hoisted_1 = {
  class: "nebula-card__badges"
};
function NebulaClassroomCardvue_type_template_id_2deea084_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaCardThumbnail = Object(external_vue_["resolveComponent"])("NebulaCardThumbnail");

  const _component_NebulaCardTitle = Object(external_vue_["resolveComponent"])("NebulaCardTitle");

  const _component_NebulaCardHeader = Object(external_vue_["resolveComponent"])("NebulaCardHeader");

  const _component_NebulaCardDescription = Object(external_vue_["resolveComponent"])("NebulaCardDescription");

  const _component_NebulaBadge = Object(external_vue_["resolveComponent"])("NebulaBadge");

  const _component_NebulaCard = Object(external_vue_["resolveComponent"])("NebulaCard");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaCard, Object(external_vue_["mergeProps"])({
    element: $props.element,
    class: "nebula-card--classroom"
  }, $props.cardProps), {
    thumbnail: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaCardThumbnail, {
      assetType: $props.classroomData.name,
      dataAttrs: $props.dataAttrs,
      title: $props.classroomData.name,
      url: $props.url,
      usePushState: $props.usePushState,
      image: $props.themeImage
    }, null, 8, ["assetType", "dataAttrs", "title", "url", "usePushState", "image"])]),
    content: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaCardHeader, null, {
      actionsMenu: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "actionsMenu")]),
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaCardTitle, {
        dataAttrs: $props.dataAttrs,
        tabIndex: "-1",
        title: $props.classroomData.name,
        url: $props.url,
        usePushState: $props.usePushState
      }, null, 8, ["dataAttrs", "title", "url", "usePushState"])]),
      _: 3
    }), $props.classroomData.create_datetime ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaCardDescription, {
      key: 0
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])($options.formatDate($props.classroomData.create_datetime)), 1)]),
      _: 1
    })) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaClassroomCardvue_type_template_id_2deea084_hoisted_1, [$props.classroomData.num_remaining ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaBadge, {
      key: 0,
      color: "orange",
      size: "s",
      icon: "circle-info"
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(_ctx.$t("%(count)d Student Not Imported", {
        count: $props.classroomData.num_students
      })), 1)]),
      _: 1
    })) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createVNode"])(_component_NebulaBadge, {
      color: "light-gray",
      size: "s"
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(_ctx.$t("%(count)d Student", {
        count: $props.classroomData.num_students
      })), 1)]),
      _: 1
    }), Object(external_vue_["createVNode"])(_component_NebulaBadge, {
      color: "light-gray",
      size: "s"
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(_ctx.$t("%(count)d Teacher", {
        count: $props.classroomData.teachers.length
      })), 1)]),
      _: 1
    })])]),
    _: 3
  }, 16, ["element"]);
}
// CONCATENATED MODULE: ./src/components/Card/NebulaClassroomCard.vue?vue&type=template&id=2deea084

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaClassroomCard.vue?vue&type=script&lang=js






/* harmony default export */ var NebulaClassroomCardvue_type_script_lang_js = ({
  name: 'NebulaClassroomCard',
  components: {
    NebulaCard: NebulaCard,
    NebulaCardThumbnail: NebulaCardThumbnail,
    NebulaCardHeader: NebulaCardHeader,
    NebulaCardTitle: NebulaCardTitle,
    NebulaCardDescription: NebulaCardDescription,
    NebulaBadge: NebulaBadge
  },
  props: {
    // for anything to be passed through to the base NebulaCard
    cardProps: Object,
    classroomData: {
      type: Object,
      default: () => ({})
    },
    dataAttrs: Object,
    element: {
      type: String,
      default: 'li'
    },
    usePushState: {
      type: Boolean,
      default: false
    },
    url: String,
    themeImage: String
  },
  methods: {
    formatDate(date) {
      const d = date.split(' ').slice(0, 4);
      return this.$t('Created %(day)d %(month)d, %(year)d', {
        day: d[1],
        month: d[2],
        year: d[3]
      });
    }

  }
});
// CONCATENATED MODULE: ./src/components/Card/NebulaClassroomCard.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Card/NebulaClassroomCard.vue?vue&type=style&index=0&id=2deea084&lang=stylus
var NebulaClassroomCardvue_type_style_index_0_id_2deea084_lang_stylus = __webpack_require__("8532");

// CONCATENATED MODULE: ./src/components/Card/NebulaClassroomCard.vue







const NebulaClassroomCard_exports_ = /*#__PURE__*/exportHelper_default()(NebulaClassroomCardvue_type_script_lang_js, [['render',NebulaClassroomCardvue_type_template_id_2deea084_render]])

/* harmony default export */ var NebulaClassroomCard = (NebulaClassroomCard_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaLessonCard.vue?vue&type=template&id=7c8b86ad

function NebulaLessonCardvue_type_template_id_7c8b86ad_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaCardThumbnail = Object(external_vue_["resolveComponent"])("NebulaCardThumbnail");

  const _component_NebulaCardHeader = Object(external_vue_["resolveComponent"])("NebulaCardHeader");

  const _component_NebulaCardTitle = Object(external_vue_["resolveComponent"])("NebulaCardTitle");

  const _component_NebulaCardDescription = Object(external_vue_["resolveComponent"])("NebulaCardDescription");

  const _component_NebulaCardMetadata = Object(external_vue_["resolveComponent"])("NebulaCardMetadata");

  const _component_NebulaCard = Object(external_vue_["resolveComponent"])("NebulaCard");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaCard, Object(external_vue_["mergeProps"])({
    element: $props.element,
    class: "nebula-card--lesson"
  }, $props.cardProps), {
    thumbnail: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaCardThumbnail, {
      assetId: $props.asset.id,
      assetType: $options.assetTypeFriendly,
      dataAttrs: $props.dataAttrs,
      title: $options.assetTitle,
      url: $options.cardLink,
      usePushState: $props.usePushState,
      customStyles: $props.cardProps
    }, null, 8, ["assetId", "assetType", "dataAttrs", "title", "url", "usePushState", "customStyles"])]),
    content: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaCardHeader, {
      assetType: $options.assetTypeFriendly
    }, {
      actionsMenu: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "actionsMenu")]),
      _: 3
    }, 8, ["assetType"]), Object(external_vue_["createVNode"])(_component_NebulaCardTitle, {
      dataAttrs: $props.dataAttrs,
      embed: $props.embed,
      tabIndex: "-1",
      title: $options.assetTitle,
      url: $options.cardLink,
      usePushState: $props.usePushState
    }, null, 8, ["dataAttrs", "embed", "title", "url", "usePushState"]), Object(external_vue_["createVNode"])(_component_NebulaCardDescription, {
      text: $props.asset.description
    }, null, 8, ["text"]), Object(external_vue_["renderSlot"])(_ctx.$slots, "metadata", {}, () => [Object(external_vue_["createVNode"])(_component_NebulaCardMetadata, {
      metadata: $props.asset.tags,
      lessonDuration: $props.asset.duration
    }, null, 8, ["metadata", "lessonDuration"])])]),
    _: 3
  }, 16, ["element"]);
}
// CONCATENATED MODULE: ./src/components/Card/NebulaLessonCard.vue?vue&type=template&id=7c8b86ad

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaLessonCard.vue?vue&type=script&lang=js






/* harmony default export */ var NebulaLessonCardvue_type_script_lang_js = ({
  name: 'NebulaAssetCard',
  components: {
    NebulaCard: NebulaCard,
    NebulaCardThumbnail: NebulaCardThumbnail,
    NebulaCardHeader: NebulaCardHeader,
    NebulaCardTitle: NebulaCardTitle,
    NebulaCardDescription: NebulaCardDescription,
    NebulaCardMetadata: NebulaCardMetadata
  },
  props: {
    anchorBadge: String,
    asset: Object,
    assetType: String,
    cardType: {
      type: String,
      default: ''
    },
    // for anything to be passed through to the base NebulaCard
    cardProps: Object,
    dataAttrs: Object,
    description: String,
    element: {
      type: String,
      default: 'li'
    },
    title: String,
    url: String,
    usePushState: {
      type: Boolean,
      default: false
    },
    embed: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    assetTitle() {
      let title = '';

      if (this.title) {
        title = this.title;
      }

      if (this.asset.title) {
        title = this.asset.title;
      } else {
        title = this.asset.name;
      }

      return title;
    },

    assetTypeFriendly() {
      if (this.assetType) {
        return this.assetType;
      }

      if (this.asset.type && this.asset.type.name) {
        return this.asset.type.name;
      }

      return null;
    },

    cardLink() {
      const url = this.url || `/learn/player/${this.asset.id}`;
      return this.embed ? `${url}?embed=true` : url;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Card/NebulaLessonCard.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/components/Card/NebulaLessonCard.vue





const NebulaLessonCard_exports_ = /*#__PURE__*/exportHelper_default()(NebulaLessonCardvue_type_script_lang_js, [['render',NebulaLessonCardvue_type_template_id_7c8b86ad_render]])

/* harmony default export */ var NebulaLessonCard = (NebulaLessonCard_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaVideoCard.vue?vue&type=template&id=5c2cae84

const NebulaVideoCardvue_type_template_id_5c2cae84_hoisted_1 = {
  class: "nebula-card__media"
};
const NebulaVideoCardvue_type_template_id_5c2cae84_hoisted_2 = ["aria-label"];
const NebulaVideoCardvue_type_template_id_5c2cae84_hoisted_3 = {
  class: "nebula-card__main"
};
const NebulaVideoCardvue_type_template_id_5c2cae84_hoisted_4 = {
  class: "nebula-card__content"
};
const NebulaVideoCardvue_type_template_id_5c2cae84_hoisted_5 = {
  class: "nebula-card__meta"
};
const NebulaVideoCardvue_type_template_id_5c2cae84_hoisted_6 = {
  key: 0,
  class: "nebula-card__footer"
};
function NebulaVideoCardvue_type_template_id_5c2cae84_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaCardThumbnail = Object(external_vue_["resolveComponent"])("NebulaCardThumbnail");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaDropdownItem = Object(external_vue_["resolveComponent"])("NebulaDropdownItem");

  const _component_NebulaDropdown = Object(external_vue_["resolveComponent"])("NebulaDropdown");

  const _component_NebulaCardHeader = Object(external_vue_["resolveComponent"])("NebulaCardHeader");

  const _component_NebulaCardTitle = Object(external_vue_["resolveComponent"])("NebulaCardTitle");

  const _component_NebulaCardDescription = Object(external_vue_["resolveComponent"])("NebulaCardDescription");

  const _component_NebulaCardMetadata = Object(external_vue_["resolveComponent"])("NebulaCardMetadata");

  const _component_NebulaVideoSegmentCarousel = Object(external_vue_["resolveComponent"])("NebulaVideoSegmentCarousel");

  const _component_NebulaAccordion = Object(external_vue_["resolveComponent"])("NebulaAccordion");

  const _component_NebulaContainerCard = Object(external_vue_["resolveComponent"])("NebulaContainerCard");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaContainerCard, Object(external_vue_["mergeProps"])({
    element: $props.element,
    padded: "",
    "card-class": "nebula-card--video"
  }, $props.cardProps), {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("div", NebulaVideoCardvue_type_template_id_5c2cae84_hoisted_1, [Object(external_vue_["createVNode"])(_component_NebulaCardThumbnail, {
      assetId: $props.asset.id,
      assetType: $options.assetTypeFriendly,
      cardIds: _ctx.cardIds,
      clickTrackSegment: _ctx.clickTrackSegment,
      dataAttrs: $props.dataAttrs,
      duration: $options.formattedDuration,
      embed: $props.embed,
      image: $props.imageOverride,
      isHighlighted: $props.asset.is_highlighted,
      linkAriaLabel: $props.asset.link_aria_label,
      productName: $props.productName,
      segmentTrackingData: _ctx.segmentTrackingData,
      target: $props.asset.target,
      title: $options.assetTitle,
      url: $options.cardLink && !$props.showPreview ? $options.cardLink : null,
      usePushState: $props.usePushState
    }, null, 8, ["assetId", "assetType", "cardIds", "clickTrackSegment", "dataAttrs", "duration", "embed", "image", "isHighlighted", "linkAriaLabel", "productName", "segmentTrackingData", "target", "title", "url", "usePushState"]), $props.showPreview ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", {
      key: 0,
      class: "nebula-card__preview-button",
      "aria-label": _ctx.$t('Open preview'),
      onClick: _cache[0] || (_cache[0] = (...args) => $options.previewButtonClick && $options.previewButtonClick(...args))
    }, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      class: "nebula-card__preview-button-visual",
      text: _ctx.$t('Preview'),
      shape: "pill",
      size: "s",
      "aria-hidden": "true",
      isStatic: ""
    }, null, 8, ["text"])], 8, NebulaVideoCardvue_type_template_id_5c2cae84_hoisted_2)) : Object(external_vue_["createCommentVNode"])("", true), $props.showEmbedButton ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
      key: 1,
      class: "nebula-card__embed-button",
      text: _ctx.$t('Embed'),
      onClick: $options.embedAssetButtonClick
    }, null, 8, ["text", "onClick"])) : Object(external_vue_["createCommentVNode"])("", true)]), Object(external_vue_["createElementVNode"])("div", NebulaVideoCardvue_type_template_id_5c2cae84_hoisted_3, [Object(external_vue_["createElementVNode"])("div", NebulaVideoCardvue_type_template_id_5c2cae84_hoisted_4, [Object(external_vue_["createVNode"])(_component_NebulaCardHeader, {
      assetType: $options.assetTypeFriendly,
      iconOverride: "circle-play",
      showIcon: "",
      showFavoritesButton: ""
    }, {
      actionsMenu: Object(external_vue_["withCtx"])(() => [$options.hasOtherLanguages ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdown, {
        key: 0,
        buttonId: 'language-dropdown-button-' + $props.asset.id,
        dropdownId: 'language-dropdown-menu-' + $props.asset.id
      }, {
        trigger: Object(external_vue_["withCtx"])(({
          toggleDropdown,
          checkArrowKeyOnTrigger,
          checkArrowKeyAfterTrigger,
          isOpen
        }) => [Object(external_vue_["createVNode"])(_component_NebulaButton, {
          id: 'language-dropdown-button-' + $props.asset.id,
          text: $props.asset.language_name,
          iconLeft: "globe",
          type: "ghost",
          size: "s",
          "aria-expanded": isOpen && 'true' || 'false',
          "aria-haspopup": "true",
          "aria-controls": 'language-dropdown-menu-' + $props.asset.id,
          onClick: toggleDropdown,
          onKeydown: checkArrowKeyOnTrigger,
          onKeyup: checkArrowKeyAfterTrigger
        }, null, 8, ["id", "text", "aria-expanded", "aria-controls", "onClick", "onKeydown", "onKeyup"])]),
        content: Object(external_vue_["withCtx"])(() => [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.assetLanguages, (language, index) => {
          return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdownItem, Object(external_vue_["mergeProps"])({
            onDropdownItemClicked: $options.emitLangEvent,
            key: index
          }, language, {
            "data-lang-id": language.id
          }), null, 16, ["onDropdownItemClicked", "data-lang-id"]);
        }), 128))]),
        _: 1
      }, 8, ["buttonId", "dropdownId"])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["renderSlot"])(_ctx.$slots, "actionsMenu")]),
      _: 3
    }, 8, ["assetType"]), Object(external_vue_["createVNode"])(_component_NebulaCardTitle, {
      assetId: $props.asset.id,
      cardIds: _ctx.cardIds,
      clickTrackSegment: _ctx.clickTrackSegment,
      dataAttrs: $props.dataAttrs,
      embed: $props.embed,
      linkAriaLabel: $props.asset.link_aria_label,
      segmentTrackingData: _ctx.segmentTrackingData,
      tabIndex: $props.showPreview ? null : '-1',
      target: $props.asset.target,
      title: $options.assetTitle,
      url: $options.cardLink,
      usePushState: $props.usePushState
    }, null, 8, ["assetId", "cardIds", "clickTrackSegment", "dataAttrs", "embed", "linkAriaLabel", "segmentTrackingData", "tabIndex", "target", "title", "url", "usePushState"]), Object(external_vue_["createVNode"])(_component_NebulaCardDescription, {
      text: $props.asset.description,
      htmlDescription: $props.asset.html_description
    }, null, 8, ["text", "htmlDescription"])]), Object(external_vue_["createElementVNode"])("div", NebulaVideoCardvue_type_template_id_5c2cae84_hoisted_5, [Object(external_vue_["createVNode"])(_component_NebulaCardMetadata, {
      metadata: $options.metadata
    }, null, 8, ["metadata"])])]), $props.asset.segments && $props.asset.segments.length > 0 ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaVideoCardvue_type_template_id_5c2cae84_hoisted_6, [Object(external_vue_["createVNode"])(_component_NebulaAccordion, {
      class: "nebula-card__video-segments",
      text: $props.asset.segments_length + ' video segments',
      icon: "video"
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("section", null, [Object(external_vue_["createVNode"])(_component_NebulaVideoSegmentCarousel, {
        "scroll-all": $props.scrollAll,
        "video-segments": $props.asset.segments,
        "visible-cards": $props.visibleCards
      }, null, 8, ["scroll-all", "video-segments", "visible-cards"])])]),
      _: 1
    }, 8, ["text"])])) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 3
  }, 16, ["element"]);
}
// CONCATENATED MODULE: ./src/components/Card/NebulaVideoCard.vue?vue&type=template&id=5c2cae84

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/VideoSegmentCarousel/NebulaVideoSegmentCarousel.vue?vue&type=template&id=7dd00434

const NebulaVideoSegmentCarouselvue_type_template_id_7dd00434_hoisted_1 = {
  class: "card-carousel-wrapper"
};
const NebulaVideoSegmentCarouselvue_type_template_id_7dd00434_hoisted_2 = {
  class: "card-carousel"
};
const NebulaVideoSegmentCarouselvue_type_template_id_7dd00434_hoisted_3 = {
  class: "card-carousel--overflow-container"
};
function NebulaVideoSegmentCarouselvue_type_template_id_7dd00434_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIconButton = Object(external_vue_["resolveComponent"])("NebulaIconButton");

  const _component_NebulaVideoSegmentCard = Object(external_vue_["resolveComponent"])("NebulaVideoSegmentCard");

  const _component_NebulaCardRow = Object(external_vue_["resolveComponent"])("NebulaCardRow");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaVideoSegmentCarouselvue_type_template_id_7dd00434_hoisted_1, [Object(external_vue_["createVNode"])(_component_NebulaIconButton, {
    ariaLabel: _ctx.$t('View Previous'),
    onClick: _cache[0] || (_cache[0] = $event => $options.scrollTo('prev')),
    icon: $options.rtl ? 'caret-right' : 'caret-left',
    isDisabled: $options.atHeadOfList,
    shape: "pill",
    tabindex: "-1"
  }, null, 8, ["ariaLabel", "icon", "isDisabled"]), Object(external_vue_["createElementVNode"])("div", NebulaVideoSegmentCarouselvue_type_template_id_7dd00434_hoisted_2, [Object(external_vue_["createElementVNode"])("div", NebulaVideoSegmentCarouselvue_type_template_id_7dd00434_hoisted_3, [Object(external_vue_["createVNode"])(_component_NebulaCardRow, {
    style: Object(external_vue_["normalizeStyle"])({
      transform: 'translateX(' + $data.currentOffset + 'px)'
    })
  }, {
    default: Object(external_vue_["withCtx"])(() => [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.videoSegments, (segment, index) => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaVideoSegmentCard, {
        class: "nebula-card-carousel__list-item",
        key: index,
        segment: segment
      }, null, 8, ["segment"]);
    }), 128))]),
    _: 1
  }, 8, ["style"])])]), Object(external_vue_["createVNode"])(_component_NebulaIconButton, {
    ariaLabel: _ctx.$t('View Next'),
    onClick: _cache[1] || (_cache[1] = $event => $options.scrollTo('next')),
    icon: $options.rtl ? 'caret-left' : 'caret-right',
    isDisabled: $options.atEndOfList,
    shape: "pill",
    tabindex: "-1"
  }, null, 8, ["ariaLabel", "icon", "isDisabled"])]);
}
// CONCATENATED MODULE: ./src/components/VideoSegmentCarousel/NebulaVideoSegmentCarousel.vue?vue&type=template&id=7dd00434

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/CardContainers/NebulaCardRow.vue?vue&type=template&id=18fef746

function NebulaCardRowvue_type_template_id_18fef746_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.element), {
    class: Object(external_vue_["normalizeClass"])(['nebula-card-row', $props.container && 'nebula-card-row--container'])
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")]),
    _: 3
  }, 8, ["class"]);
}
// CONCATENATED MODULE: ./src/components/CardContainers/NebulaCardRow.vue?vue&type=template&id=18fef746

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/CardContainers/NebulaCardRow.vue?vue&type=script&lang=js
/* harmony default export */ var NebulaCardRowvue_type_script_lang_js = ({
  name: 'NebulaCardRow',
  props: {
    element: {
      type: String,
      default: 'ul'
    },
    container: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/CardContainers/NebulaCardRow.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/CardContainers/NebulaCardRow.vue?vue&type=style&index=0&id=18fef746&lang=stylus
var NebulaCardRowvue_type_style_index_0_id_18fef746_lang_stylus = __webpack_require__("1e73");

// CONCATENATED MODULE: ./src/components/CardContainers/NebulaCardRow.vue







const NebulaCardRow_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCardRowvue_type_script_lang_js, [['render',NebulaCardRowvue_type_template_id_18fef746_render]])

/* harmony default export */ var NebulaCardRow = (NebulaCardRow_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/VideoSegmentCarousel/NebulaVideoSegmentCard.vue?vue&type=template&id=32b7ebcb

const NebulaVideoSegmentCardvue_type_template_id_32b7ebcb_hoisted_1 = {
  class: "nebula-card--video-segment"
};
const NebulaVideoSegmentCardvue_type_template_id_32b7ebcb_hoisted_2 = ["href"];
const NebulaVideoSegmentCardvue_type_template_id_32b7ebcb_hoisted_3 = {
  class: "segment-card__image"
};
const NebulaVideoSegmentCardvue_type_template_id_32b7ebcb_hoisted_4 = {
  class: "segment-card__title"
};
function NebulaVideoSegmentCardvue_type_template_id_32b7ebcb_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaImage = Object(external_vue_["resolveComponent"])("NebulaImage");

  const _component_NebulaBadge = Object(external_vue_["resolveComponent"])("NebulaBadge");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", NebulaVideoSegmentCardvue_type_template_id_32b7ebcb_hoisted_1, [Object(external_vue_["createElementVNode"])("a", {
    href: '/learn/player/' + $props.segment.id,
    class: "segment-card__link"
  }, [Object(external_vue_["createElementVNode"])("div", NebulaVideoSegmentCardvue_type_template_id_32b7ebcb_hoisted_3, [Object(external_vue_["createVNode"])(_component_NebulaImage, {
    assetId: $props.segment.id,
    covered: "",
    customStyles: {
      nebulaImageWidth: '100%'
    },
    alt: $props.segment.title
  }, null, 8, ["assetId", "alt"]), $props.segment.duration_in_seconds ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaBadge, {
    key: 0,
    class: "segment-card__duration",
    type: "duration"
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])($options.formatDuration($props.segment.duration_in_seconds)), 1)]),
    _: 1
  })) : Object(external_vue_["createCommentVNode"])("", true)]), Object(external_vue_["createElementVNode"])("p", NebulaVideoSegmentCardvue_type_template_id_32b7ebcb_hoisted_4, Object(external_vue_["toDisplayString"])($props.segment.title), 1)], 8, NebulaVideoSegmentCardvue_type_template_id_32b7ebcb_hoisted_2)]);
}
// CONCATENATED MODULE: ./src/components/VideoSegmentCarousel/NebulaVideoSegmentCard.vue?vue&type=template&id=32b7ebcb

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/VideoSegmentCarousel/NebulaVideoSegmentCard.vue?vue&type=script&lang=js




/* harmony default export */ var NebulaVideoSegmentCardvue_type_script_lang_js = ({
  name: 'NebulaVideoSegmentCard',
  components: {
    NebulaBadge: NebulaBadge,
    NebulaImage: NebulaImage
  },
  mixins: [segment_card_click_track],
  props: {
    segment: Object
  },
  computed: {
    cardLink() {
      const url = this.url || `/learn/player/${this.asset.id}`;
      return this.embed ? `${url}?embed=true` : url;
    }

  },
  methods: {
    formatDuration: formatDuration
  }
});
// CONCATENATED MODULE: ./src/components/VideoSegmentCarousel/NebulaVideoSegmentCard.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/VideoSegmentCarousel/NebulaVideoSegmentCard.vue?vue&type=style&index=0&id=32b7ebcb&lang=stylus
var NebulaVideoSegmentCardvue_type_style_index_0_id_32b7ebcb_lang_stylus = __webpack_require__("7b05");

// CONCATENATED MODULE: ./src/components/VideoSegmentCarousel/NebulaVideoSegmentCard.vue







const NebulaVideoSegmentCard_exports_ = /*#__PURE__*/exportHelper_default()(NebulaVideoSegmentCardvue_type_script_lang_js, [['render',NebulaVideoSegmentCardvue_type_template_id_32b7ebcb_render]])

/* harmony default export */ var NebulaVideoSegmentCard = (NebulaVideoSegmentCard_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/VideoSegmentCarousel/NebulaVideoSegmentCarousel.vue?vue&type=script&lang=js





/* harmony default export */ var NebulaVideoSegmentCarouselvue_type_script_lang_js = ({
  name: 'NebulaVideoSegmentCarousel',
  components: {
    NebulaCardRow: NebulaCardRow,
    NebulaIconButton: NebulaIconButton,
    NebulaVideoSegmentCard: NebulaVideoSegmentCard
  },
  mixins: [themingUtils],
  props: {
    scrollAll: {
      type: Boolean,
      default: false
    },
    videoSegments: {
      type: Array,
      require: true
    },
    visibleCards: {
      type: Number,
      default: 4
    }
  },

  data() {
    return {
      carouselWidth: 0,
      currentOffset: 0,
      throttledResizeHandler: null
    };
  },

  computed: {
    atEndOfList() {
      if (this.rtl) {
        return this.currentOffset >= (this.itemWidth + this.carouselGap) * (this.videoSegments.length - this.visibleCards);
      }

      return this.currentOffset <= (this.itemWidth + this.carouselGap) * -1 * (this.videoSegments.length - this.visibleCards);
    },

    atHeadOfList() {
      return this.currentOffset === 0;
    },

    rtl() {
      const htmlElement = document.getElementsByTagName('html')[0];
      const mainElement = document.getElementsByTagName('main')[0];
      const htmlDirection = window.getComputedStyle(htmlElement, null).getPropertyValue('direction');
      const mainDirection = window.getComputedStyle(mainElement, null).getPropertyValue('direction');
      let isRTL = false;

      if (htmlDirection === 'rtl' || mainDirection === 'rtl') {
        isRTL = true;
      } else if (this.setRtl === true) {
        isRTL = true;
      } else if (window.initData && window.initData.ltr === false) {
        isRTL = true;
      }

      return isRTL;
    }

  },
  watch: {
    carouselWidth() {
      this.resizeItems();
    }

  },
  methods: {
    init() {
      this.throttledResizeHandler = lodash_es_throttle(this.updateCarouselWidth, 150);
      this.setEventListeners();
      this.$nextTick(() => {
        this.resizeItems();
        const carousel = this.$el.getElementsByClassName('nebula-card-row')[0];
        const carouselGap = 16;
        const carouselWidth = carousel.offsetWidth;
        const segmentItem = this.$el.getElementsByClassName('nebula-card--video-segment')[0];
        const itemWidth = segmentItem.getBoundingClientRect().width;
        this.carouselGap = carouselGap;
        this.carouselWidth = carouselWidth;
        this.itemWidth = itemWidth;

        if (this.scrollAll) {
          // Scroll all items on a "page"
          this.pageWidth = (itemWidth + carouselGap) * this.visibleCards;
        } else {
          // Use .getBoundingClientRect().width over .offsetWidth because we need the fractional value.
          this.pageWidth = itemWidth + carouselGap;
        }
      });
    },

    scrollTo(direction) {
      if (direction === 'prev' && this.atHeadOfList || direction === 'next' && this.atEndOfList) return;

      if (this.rtl) {
        if (direction === 'next') {
          this.currentOffset += this.pageWidth;
        } else if (direction === 'prev') {
          this.currentOffset -= this.pageWidth;
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (direction === 'next') {
          this.currentOffset -= this.pageWidth;
        } else if (direction === 'prev') {
          this.currentOffset += this.pageWidth;
        }
      }
    },

    resizeItems() {
      const segmentItems = this.$el.getElementsByClassName('nebula-card--video-segment');
      const segmentItemsArray = Array.from(segmentItems);
      const carousel = this.$el.getElementsByClassName('nebula-card-row')[0];
      const carouselGap = 16;
      const carouselWidth = carousel.offsetWidth;
      const itemWidth = (carouselWidth - carouselGap * (this.visibleCards - 1)) / this.visibleCards;
      segmentItemsArray.forEach(element => {
        // eslint-disable-next-line no-param-reassign
        element.style.width = `${itemWidth}px`;
      });
    },

    setEventListeners() {
      window.addEventListener('resize', this.throttledResizeHandler);
    },

    updateCarouselWidth() {
      this.carouselWidth = this.$el.clientWidth;
    }

  },

  mounted() {
    this.init();
  }

});
// CONCATENATED MODULE: ./src/components/VideoSegmentCarousel/NebulaVideoSegmentCarousel.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/VideoSegmentCarousel/NebulaVideoSegmentCarousel.vue?vue&type=style&index=0&id=7dd00434&lang=stylus
var NebulaVideoSegmentCarouselvue_type_style_index_0_id_7dd00434_lang_stylus = __webpack_require__("d1d8");

// CONCATENATED MODULE: ./src/components/VideoSegmentCarousel/NebulaVideoSegmentCarousel.vue







const NebulaVideoSegmentCarousel_exports_ = /*#__PURE__*/exportHelper_default()(NebulaVideoSegmentCarouselvue_type_script_lang_js, [['render',NebulaVideoSegmentCarouselvue_type_template_id_7dd00434_render]])

/* harmony default export */ var NebulaVideoSegmentCarousel = (NebulaVideoSegmentCarousel_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Card/NebulaVideoCard.vue?vue&type=script&lang=js













/* harmony default export */ var NebulaVideoCardvue_type_script_lang_js = ({
  name: 'NebulaVideoCard',
  components: {
    NebulaAccordion: NebulaAccordion,
    NebulaButton: NebulaButton,
    NebulaDropdown: NebulaDropdown,
    NebulaDropdownItem: NebulaDropdownItem,
    NebulaContainerCard: NebulaContainerCard,
    NebulaCardThumbnail: NebulaCardThumbnail,
    NebulaCardHeader: NebulaCardHeader,
    NebulaCardTitle: NebulaCardTitle,
    NebulaVideoSegmentCarousel: NebulaVideoSegmentCarousel,
    NebulaCardDescription: NebulaCardDescription,
    NebulaCardMetadata: NebulaCardMetadata
  },
  emits: ['previewEvent', 'embedAssetEvent', 'videoLanguageItemClick'],
  mixins: [segment_card_click_track],
  props: {
    asset: Object,
    assetType: String,
    cardProps: Object,
    dataAttrs: Object,
    element: {
      type: String,
      default: 'li'
    },
    embed: {
      type: Boolean,
      required: false
    },
    imageOverride: {
      type: String,
      default: null
    },
    productName: {
      type: String,
      default: null,
      enum: ['Science Techbook', 'Math Techbook', 'Social Studies Techbook']
    },
    scrollAll: {
      type: Boolean,
      default: false
    },
    showPreview: {
      type: Boolean,
      default: false
    },
    showEmbedButton: {
      type: Boolean,
      default: false
    },
    title: String,
    url: String,
    usePushState: {
      type: Boolean,
      default: false
    },
    visibleCards: {
      type: Number,
      default: 4
    }
  },
  computed: {
    assetLanguages() {
      const languages = [];
      const langArray = this.asset.other_languages;

      if (langArray.length > 0) {
        langArray.forEach(language => {
          const obj = {};
          obj.text = language.language_name;
          obj.id = language.id;
          languages.push(obj);
        });
      }

      return languages;
    },

    assetTitle() {
      let title = '';

      if (this.title) {
        title = this.title;
      }

      if (this.asset.title) {
        title = this.asset.title;
      } else {
        title = this.asset.name;
      }

      return title;
    },

    assetTypeFriendly() {
      if (this.assetType) {
        return this.assetType;
      }

      if (this.asset.type && this.asset.type.name) {
        return this.asset.type.name;
      }

      return null;
    },

    breakpoints() {
      return [{
        bleed: 0,
        itemMargin: 0,
        minWidth: 1200,
        name: 'largeDesktop',
        showFades: true,
        showScrollPreview: false,
        visibleItems: 5
      }, {
        bleed: 0,
        itemMargin: 0,
        minWidth: 1000,
        name: 'desktop',
        showFades: true,
        showScrollPreview: false,
        visibleItems: 5
      }, {
        bleed: 0,
        itemMargin: 0,
        minWidth: 800,
        name: 'tabletLandscape',
        showFades: true,
        showScrollPreview: true,
        visibleItems: 5
      }, {
        bleed: 0,
        itemMargin: 0,
        minWidth: 500,
        name: 'tabletPortrait',
        showFades: true,
        showScrollPreview: true,
        visibleItems: 5
      }, {
        bleed: 0,
        itemMargin: 0,
        minWidth: 0,
        name: 'mobile',
        showFades: true,
        showScrollPreview: true,
        visibleItems: 5
      }];
    },

    cardLink() {
      const url = this.url || `/learn/player/${this.asset.id}`;
      return this.embed ? `${url}?embed=true` : url;
    },

    formattedDuration() {
      if (this.asset.duration) {
        return formatDuration(this.asset.duration);
      }

      return null;
    },

    hasOtherLanguages() {
      return this.asset.other_languages.length > 0;
    },

    metadata() {
      const metadata = [];
      const gradeArray = this.asset.grades;
      const infoPills = this.asset.info_pills;
      infoPills.forEach(infoPill => {
        const obj = {};
        obj.value = infoPill.value;
        obj.type = 'info-pill';
        metadata.push(obj);
      });
      gradeArray.forEach(grade => {
        if (!metadata.some(i => i.value.includes(grade.grade_band))) {
          const obj = {};
          obj.value = grade.grade_band;
          obj.type = 'grade-band';
          metadata.push(obj);
        }
      });
      return metadata;
    }

  },
  methods: {
    previewButtonClick() {
      this.$emit('previewEvent');
    },

    embedAssetButtonClick() {
      this.$emit('embedAssetEvent', this.asset);
    },

    emitLangEvent() {
      this.$emit('videoLanguageItemClick');
    },

    formatDuration: formatDuration
  }
});
// CONCATENATED MODULE: ./src/components/Card/NebulaVideoCard.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Card/NebulaVideoCard.vue?vue&type=style&index=0&id=5c2cae84&lang=stylus
var NebulaVideoCardvue_type_style_index_0_id_5c2cae84_lang_stylus = __webpack_require__("0422");

// CONCATENATED MODULE: ./src/components/Card/NebulaVideoCard.vue







const NebulaVideoCard_exports_ = /*#__PURE__*/exportHelper_default()(NebulaVideoCardvue_type_script_lang_js, [['render',NebulaVideoCardvue_type_template_id_5c2cae84_render]])

/* harmony default export */ var NebulaVideoCard = (NebulaVideoCard_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/CardContainers/NebulaCardGrid.vue?vue&type=template&id=182af3f6

function NebulaCardGridvue_type_template_id_182af3f6_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.element), {
    class: Object(external_vue_["normalizeClass"])(['nebula-card-grid', $props.container && 'nebula-card-grid--container'])
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")]),
    _: 3
  }, 8, ["class"]);
}
// CONCATENATED MODULE: ./src/components/CardContainers/NebulaCardGrid.vue?vue&type=template&id=182af3f6

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/CardContainers/NebulaCardGrid.vue?vue&type=script&lang=js
/* harmony default export */ var NebulaCardGridvue_type_script_lang_js = ({
  name: 'NebulaCardGrid',
  props: {
    element: {
      type: String,
      default: 'ul'
    },
    container: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/CardContainers/NebulaCardGrid.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/CardContainers/NebulaCardGrid.vue?vue&type=style&index=0&id=182af3f6&lang=stylus
var NebulaCardGridvue_type_style_index_0_id_182af3f6_lang_stylus = __webpack_require__("5024");

// CONCATENATED MODULE: ./src/components/CardContainers/NebulaCardGrid.vue







const NebulaCardGrid_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCardGridvue_type_script_lang_js, [['render',NebulaCardGridvue_type_template_id_182af3f6_render]])

/* harmony default export */ var NebulaCardGrid = (NebulaCardGrid_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/CardCarousel/NebulaCardCarousel.vue?vue&type=template&id=bad1ae54

const NebulaCardCarouselvue_type_template_id_bad1ae54_hoisted_1 = ["dir"];
const NebulaCardCarouselvue_type_template_id_bad1ae54_hoisted_2 = ["aria-label"];
const NebulaCardCarouselvue_type_template_id_bad1ae54_hoisted_3 = {
  class: "nebula-card-carousel__mask"
};
const NebulaCardCarouselvue_type_template_id_bad1ae54_hoisted_4 = ["aria-label"];
function NebulaCardCarouselvue_type_template_id_bad1ae54_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])(["nebula-card-carousel", `nebula-card-carousel__${$props.carouselName}`]),
    dir: $options.rtl ? 'rtl' : 'ltr',
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [Object(external_vue_["createElementVNode"])("div", {
    class: "nebula-card-carousel__outer-wrap",
    ref: "carouselRef",
    style: Object(external_vue_["normalizeStyle"])($options.carouselStyle),
    onFocusin: _cache[3] || (_cache[3] = (...args) => $options.onFocusin && $options.onFocusin(...args)),
    onTouchstart: _cache[4] || (_cache[4] = (...args) => $options.onTouchstart && $options.onTouchstart(...args)),
    onTouchend: _cache[5] || (_cache[5] = (...args) => $options.onTouchend && $options.onTouchend(...args))
  }, [Object(external_vue_["withDirectives"])(Object(external_vue_["createElementVNode"])("div", {
    class: "nebula-card-carousel__controls-wrapper",
    style: Object(external_vue_["normalizeStyle"])($options.btnStyle)
  }, [Object(external_vue_["createElementVNode"])("button", {
    class: "nebula-card-carousel__controls nebula-card-carousel__controls--prev",
    tabIndex: "-1",
    "aria-label": $options.rtl ? _ctx.$t('scroll right') : _ctx.$t('scroll left'),
    onClick: _cache[0] || (_cache[0] = $event => $options.scrollTo('prev'))
  }, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
    size: "m",
    symbolId: "caret-left"
  })], 8, NebulaCardCarouselvue_type_template_id_bad1ae54_hoisted_2)], 4), [[external_vue_["vShow"], $data.showBtns && $options.showPrevBtn]]), Object(external_vue_["createElementVNode"])("div", NebulaCardCarouselvue_type_template_id_bad1ae54_hoisted_3, [Object(external_vue_["createElementVNode"])("div", {
    ref: "innerWrap",
    class: "nebula-card-carousel__inner-wrap",
    style: Object(external_vue_["normalizeStyle"])($options.carouselInnerWrapStyle)
  }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "default", {
    "onHook:mounted": _cache[1] || (_cache[1] = (...args) => $options.resizeCarousel && $options.resizeCarousel(...args))
  })], 4)]), Object(external_vue_["withDirectives"])(Object(external_vue_["createElementVNode"])("div", {
    class: "nebula-card-carousel__controls-wrapper",
    style: Object(external_vue_["normalizeStyle"])($options.btnStyle)
  }, [Object(external_vue_["createElementVNode"])("button", {
    class: "nebula-card-carousel__controls nebula-card-carousel__controls--next",
    tabIndex: "-1",
    "aria-label": $options.rtl ? _ctx.$t('scroll left') : _ctx.$t('scroll right'),
    onClick: _cache[2] || (_cache[2] = $event => $options.scrollTo('next'))
  }, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
    size: "m",
    symbolId: "caret-right"
  })], 8, NebulaCardCarouselvue_type_template_id_bad1ae54_hoisted_4)], 4), [[external_vue_["vShow"], $data.showBtns && $options.showNextBtn]])], 36), $options.showScrollPreview ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    key: 0,
    class: "nebula-card-carousel__scroll-preview",
    style: Object(external_vue_["normalizeStyle"])($options.scrollPreviewStyle)
  }, null, 4)) : Object(external_vue_["createCommentVNode"])("", true)], 14, NebulaCardCarouselvue_type_template_id_bad1ae54_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/CardCarousel/NebulaCardCarousel.vue?vue&type=template&id=bad1ae54

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/CardCarousel/NebulaCardCarousel.vue?vue&type=script&lang=js


 // These are the default options for each breakpoint. Any options
// can be overridden with the breakpoints prop, which gets merged
// into this array.

const breakpoints = [{
  bleed: 64,
  itemMargin: 16,
  minWidth: 1200,
  name: 'largeDesktop',
  showFades: true,
  showScrollPreview: false,
  visibleItems: 5
}, {
  bleed: 64,
  itemMargin: 16,
  minWidth: 1000,
  name: 'desktop',
  showFades: true,
  showScrollPreview: false,
  visibleItems: 4
}, {
  bleed: 32,
  itemMargin: 16,
  minWidth: 800,
  name: 'tabletLandscape',
  showFades: true,
  showScrollPreview: true,
  visibleItems: 3
}, {
  bleed: 32,
  itemMargin: 8,
  minWidth: 500,
  name: 'tabletPortrait',
  showFades: true,
  showScrollPreview: true,
  visibleItems: 2
}, {
  bleed: 16,
  itemMargin: 8,
  minWidth: 0,
  name: 'mobile',
  showFades: true,
  showScrollPreview: true,
  visibleItems: 1
}];
/* harmony default export */ var NebulaCardCarouselvue_type_script_lang_js = ({
  name: 'NebulaCardCarousel',
  components: {
    NebulaIcon: NebulaIcon
  },
  mixins: [themingUtils],
  props: {
    breakpoints: {
      type: Array
    },
    carouselName: {
      type: String,
      required: true
    },
    enableSegmentTracking: {
      type: Boolean,
      default: true
    },
    extraTrackingData: {
      type: Object,

      default() {
        return {};
      }

    },
    setRtl: Boolean
  },

  data() {
    return {
      activelyScrolling: false,
      amountScrolledRight: 0,
      // number of "chunks" scrolled
      cardHeight: 0,
      // px
      carouselListItemArray: undefined,
      carouselRef: undefined,
      carouselScroll: null,
      // px
      carouselWidth: 0,
      // px
      currentBreakpoint: 'desktop',
      positionOneCardIndex: 0,
      positionOneNextIndex: 0,
      promoCardsViewed: [],
      showBtns: true,
      // toggled off if a user starts entering touch events
      throttledResizeHandler: null,
      totalListItems: 0,
      touchOrigin: {},
      // used during touch events
      trackCardsViewedTimeout: null,
      visibleItems: 0
    };
  },

  computed: {
    bleed() {
      // Bleed is the distance the carousel extends past its bounding box
      // so you can see the edges of the next and previous cards
      return this.currentBreakpoint.bleed;
    },

    btnStyle() {
      // This will only evaluate once, on the first render. It can't use css-only
      // positioning since the carousel height can be changed manually with a prop
      const topPadding = 16;
      return {
        top: `calc(100% / 2 + ${topPadding}px)`
      };
    },

    carouselStyle() {
      const topPadding = 16;
      const bottomPadding = 44;
      return {
        height: `${this.cardHeight + topPadding + bottomPadding}px`,
        marginLeft: `-${this.bleed}px`,
        marginRight: `-${this.bleed}px`,
        width: `calc(100% + ${this.bleed * 2}px)`
      };
    },

    carouselInnerWrapStyle() {
      // For notes about animating using transform instead of left, see:
      // https://www.paulirish.com/2012/why-moving-elements-with-translate-is-better-than-posabs-topleft/
      return {
        transform: this.rtl ? `translateX(${this.carouselScroll - this.bleed}px)` : `translateX(${this.carouselScroll + this.bleed}px)`
      };
    },

    carouselFadeStyle() {
      // We apply a gradient mask on the parent container, which partially
      // covers the next and previous cards
      if (this.showFades) {
        const gradient = `linear-gradient(
                    90deg,
                    rgba(255,255,255,0) 0,
                    #fff ${this.bleed}px,
                    #fff calc(100% - ${this.bleed}px),
                    rgba(255,255,255,0) 100%
                )`;
        return {
          '-webkit-mask-image': gradient,
          'mask-image': gradient
        };
      }

      return {};
    },

    mergedBreakpoints() {
      // Merge together the default breakpoints and their options
      // with the overrides passed in via prop
      if (!this.breakpoints) return breakpoints;
      const mergedBreakpoints = [];
      breakpoints.forEach(bp => {
        const bpOverride = this.breakpoints.find(override => override.name === bp.name);
        mergedBreakpoints.push({ ...bp,
          ...bpOverride
        });
      });
      return mergedBreakpoints;
    },

    rtl() {
      const htmlElement = document.getElementsByTagName('html')[0];
      const direction = window.getComputedStyle(htmlElement, null).getPropertyValue('direction');
      let isRTL = false;

      if (direction === 'rtl') {
        isRTL = true;
      } else if (this.setRtl === true) {
        isRTL = true;
      } else if (window.initData && window.initData.ltr === false) {
        isRTL = true;
      }

      return isRTL;
    },

    scrollPreviewStyle() {
      const widthPercent = 100 / Math.ceil(this.totalListItems / this.visibleItems);
      const transformXPercent = 100 * this.amountScrolledRight;
      return {
        top: `${this.cardHeight + 32}px`,
        // clear card margins
        transform: this.rtl ? `translateX(${transformXPercent * -1}%)` : `translateX(${transformXPercent}%)`,
        width: `${widthPercent}%`
      };
    },

    showScrollPreview() {
      return this.currentBreakpoint.showScrollPreview && this.totalListItems > this.visibleItems;
    },

    showPrevBtn() {
      return this.amountScrolledRight !== 0;
    },

    showNextBtn() {
      return (this.amountScrolledRight + 1) * this.visibleItems < this.totalListItems;
    },

    showFades() {
      return this.currentBreakpoint.showFades;
    },

    side() {
      // The property to use when checking how far the carousel
      // has been scrolled
      return this.rtl ? 'right' : 'left';
    }

  },
  watch: {
    carouselScroll() {
      this.updateCardOpacity();
    },

    carouselWidth(carouselWidth) {
      // When the carousel width changes, resize the cards and adjust the number
      // of cards shown based on screen size
      const availableWidth = carouselWidth;

      if (this.carouselListItemArray.length > 0) {
        this.visibleItems = this.currentBreakpoint.visibleItems;
        const marginsBetweenItems = (this.visibleItems - 1) * this.currentBreakpoint.itemMargin;
        const listItemWidth = (availableWidth - marginsBetweenItems) / this.visibleItems;
        this.carouselListItemArray.forEach(listItem => {
          /* eslint-disable no-param-reassign */
          listItem.style.minWidth = `${listItemWidth}px`;
          listItem.style.width = `${listItemWidth}px`;

          if (this.rtl) {
            listItem.style.marginLeft = `${this.currentBreakpoint.itemMargin}px`;
          } else {
            listItem.style.marginRight = `${this.currentBreakpoint.itemMargin}px`;
          }
          /* eslint-enable no-param-reassign */

        });
        this.resizeCarousel();

        if (this.$refs.innerWrap) {
          this.resetScrollParameters();
        }
      }
    },

    visibleItems() {
      this.updateCardOpacity();
    }

  },

  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }

    this.$refs.innerWrap.removeEventListener('transitionend', this.checkBtnConfig);
    window.removeEventListener('resize', this.throttledResizeHandler);
    this.carouselListItemArray[0].children[0].removeEventListener('focus', this.resetScrollParameters);
  },

  mounted() {
    this.init(); // segment tracking this will run observeCarouselCards once the carousel is visible in the viewport

    if (this.enableSegmentTracking) {
      this.$nextTick(() => {
        this.intersectionObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.observeCarouselCards();
              this.intersectionObserver.unobserve(entry.target);
            }
          });
        }, {
          threshold: 0.5
        });
        this.intersectionObserver.observe(this.$refs.carouselRef);
      });
    }
  },

  methods: {
    init() {
      // The carousel must be manually initialized by the parent app
      this.carouselRef = this.$refs.carouselRef;
      this.carouselListItemArray = this.carouselRef.querySelectorAll('.nebula-card-carousel__list-item');
      this.throttledResizeHandler = lodash_es_throttle(this.updateBreakpoint, 150);

      if (this.carouselListItemArray.length > 0) {
        this.totalListItems = this.carouselListItemArray.length;
        this.positionOneNextIndex = this.currentBreakpoint.visibleItems;
        this.updateBreakpoint();
        this.setEventListeners();
        this.$nextTick(() => {
          this.setParentOfListItems();
        });
      }
    },

    observeCarouselCards() {
      // track when cards are visible
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const assetId = entry.target.getAttribute('data-asset-id');

              if (assetId) {
                this.promoCardsViewed.push(assetId);
              }

              if (this.trackCardsViewedTimeout) {
                clearTimeout(this.trackCardsViewedTimeout);
              } // timeout trickery here to send impressions in batches instead of 1 at a time


              this.trackCardsViewedTimeout = setTimeout(() => {
                this.sendSegmentData('viewed', { ...this.extraTrackingData,
                  impressions: this.promoCardsViewed
                });
                this.promoCardsViewed = [];
              }, 250);
              this.observer.unobserve(entry.target);
            }
          });
        }, {
          root: this.$refs.carouselRef,
          rootMargin: '0px',
          threshold: 0.5
        });
        this.carouselListItemArray.forEach(card => {
          this.observer.observe(card);
        });
      }
    },

    sendSegmentData(type, opts) {
      if (window.DEAnalytics) {
        window.DEAnalytics.carouselTrack(type, opts);
      }
    },

    onFocusin(event) {
      // Whenever focus changes in the carousel, check to see if an out-of-view
      // card has been focused. If so, scroll it into view
      const card = event.target.closest('.nebula-card');
      if (!card) return;

      if (card.hasAttribute('data-is-in-view-prev')) {
        this.scrollTo('prev');
      } else if (card.hasAttribute('data-is-in-view-next')) {
        this.scrollTo('next');
      }
    },

    onTouchstart(e) {
      this.touchOrigin = {
        x: e.changedTouches[0].pageX
      }; // As soon as someone begins using touch gestures, hide nav buttons

      this.showBtns = false;
    },

    onTouchend(e) {
      const currentTouch = {
        x: e.changedTouches[0].pageX
      };
      const deltaX = currentTouch.x - this.touchOrigin.x;

      if (deltaX < -150) {
        this.scrollTo(this.rtl ? 'prev' : 'next');
      } else if (deltaX > 150) {
        this.scrollTo(this.rtl ? 'next' : 'prev');
      }
    },

    resizeCarousel() {
      // After child elements complete render, get height and set it on the Carousel element
      this.cardHeight = 0;
      this.$nextTick(() => {
        let maxHeight = 0;
        this.carouselListItemArray.forEach(element => {
          const elemClientHeight = element.clientHeight;

          if (elemClientHeight > maxHeight) {
            maxHeight = elemClientHeight;
          }
        });
        this.cardHeight = maxHeight;
      });
    },

    setEventListeners() {
      window.addEventListener('resize', this.throttledResizeHandler); // When focus is on first card, Carousel will scroll to place first card in view and resets parameters

      this.carouselListItemArray[0].children[0].addEventListener('focus', this.resetScrollParameters);
      this.carouselListItemArray.forEach(element => {
        // eslint-disable-next-line no-param-reassign
        element.style.transition = 'opacity 0.25s ease-in-out';
      });
    },

    setParentOfListItems() {
      // Whatever element wraps the list items will receive 'nebula-card-carousel__list' classname, among other things.
      this.carouselListItemArray[0].parentElement.classList.add('nebula-card-carousel__list'); // Shows/hides controls after transition has ended

      this.$refs.innerWrap.addEventListener('transitionend', this.checkBtnConfig);
    },

    resetScrollParameters() {
      this.carouselScroll = 0;
      this.amountScrolledRight = 0;
      this.positionOneCardIndex = 0;
      this.positionOneNextIndex = this.visibleItems;
    },

    updateBreakpoint() {
      this.carouselWidth = this.$el.clientWidth; // Find the largest possible breakpoint. Default to the desktop breakpoint.

      this.currentBreakpoint = this.mergedBreakpoints.find(bp => this.carouselWidth > bp.minWidth) || this.mergedBreakpoints[0];
    },

    updateCardOpacity() {
      this.carouselListItemArray.forEach((element, i) => {
        const isInView = i >= this.positionOneCardIndex && i < this.positionOneCardIndex + this.visibleItems;
        /* eslint-disable no-param-reassign */

        element.style.opacity = !isInView && this.showFades ? '0' : '1.0';
        element.style.pointerEvents = element.style.opacity === '0' ? 'none' : 'all';
        element.toggleAttribute('data-is-in-view-prev', i < this.positionOneCardIndex);
        element.toggleAttribute('data-is-in-view-next', i >= this.positionOneCardIndex + this.visibleItems);
        this.handleMask(i, element);
      });
    },

    handleMask(cardIndex, element) {
      const prevGradient = `linear-gradient(90deg, transparent calc(100% - ${this.bleed * 0.8}px), white 100%`;
      const nextGradient = `linear-gradient(90deg, white 0, transparent ${this.bleed * 0.8}px)`;
      const isPrevCard = cardIndex === this.positionOneCardIndex - 1;
      const isNextCard = cardIndex === this.positionOneCardIndex + this.visibleItems;

      if (!isNextCard && !isPrevCard) {
        element.style.webkitMask = 'none';
        element.style.mask = 'none';
      }

      if (this.showFades) {
        if (isPrevCard && !isNextCard) {
          element.style.webkitMask = prevGradient;
          element.style.mask = prevGradient;
          element.style.opacity = 0.2;
        } else if (isNextCard && !isPrevCard) {
          element.style.webkitMask = nextGradient;
          element.style.mask = nextGradient;
          element.style.opacity = 0.2;
        }
      }
    },

    scrollTo(direction) {
      // Prevents rapid tabbing to distort carousel during transition/scroll
      if (this.activelyScrolling) return; // If we're trying to over-scroll in a direction where there are
      // no cards, exit early

      if (direction === 'next' && !this.showNextBtn || direction === 'prev' && !this.showPrevBtn) return;
      this.activelyScrolling = true;
      let scrollWidth;

      if (direction === 'next' && this.showNextBtn) {
        // Increment data first before scroll takes action
        this.amountScrolledRight += 1;
        this.positionOneCardIndex += this.visibleItems;
        const nextIndex = this.positionOneNextIndex;
        scrollWidth = this.totalScrollWidthToNextCard(nextIndex) * -1;

        if (this.totalListItems - this.positionOneNextIndex > this.visibleItems) {
          this.positionOneNextIndex += this.visibleItems;
        }
      } else if (direction === 'prev' && this.showPrevBtn) {
        // Decrement data first before scroll takes action
        this.amountScrolledRight -= 1;
        this.positionOneCardIndex -= this.visibleItems;
        const nextIndex = this.positionOneCardIndex;
        scrollWidth = this.totalScrollWidthToNextCard(nextIndex);

        if (this.positionOneNextIndex > this.positionOneCardIndex + this.visibleItems) {
          this.positionOneNextIndex -= this.visibleItems;
        }
      }

      this.carouselScroll = scrollWidth;
    },

    totalScrollWidthToNextCard(nextCardIndex) {
      const nextCardLeftPosition = this.carouselListItemArray[nextCardIndex].getBoundingClientRect()[this.side];
      const carouselLeftPosition = this.rtl ? this.carouselRef.getBoundingClientRect()[this.side] - this.bleed : this.carouselRef.getBoundingClientRect()[this.side] + this.bleed;
      return (nextCardLeftPosition - carouselLeftPosition) * this.amountScrolledRight;
    },

    checkBtnConfig() {
      // Marks end of transition
      this.activelyScrolling = false;
    }

  }
});
// CONCATENATED MODULE: ./src/components/CardCarousel/NebulaCardCarousel.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/CardCarousel/NebulaCardCarousel.vue?vue&type=style&index=0&id=bad1ae54&lang=stylus
var NebulaCardCarouselvue_type_style_index_0_id_bad1ae54_lang_stylus = __webpack_require__("6456");

// CONCATENATED MODULE: ./src/components/CardCarousel/NebulaCardCarousel.vue







const NebulaCardCarousel_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCardCarouselvue_type_script_lang_js, [['render',NebulaCardCarouselvue_type_template_id_bad1ae54_render]])

/* harmony default export */ var NebulaCardCarousel = (NebulaCardCarousel_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Carousel/NebulaCarousel.vue?vue&type=template&id=2e936875

const NebulaCarouselvue_type_template_id_2e936875_hoisted_1 = {
  class: "nebula-carousel__inner"
};
const NebulaCarouselvue_type_template_id_2e936875_hoisted_2 = {
  class: "nebula-screenreader-only",
  "aria-live": "polite",
  "aria-atomic": "true"
};
function NebulaCarouselvue_type_template_id_2e936875_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaCarouselArrow = Object(external_vue_["resolveComponent"])("NebulaCarouselArrow");

  const _component_NebulaCarouselSlide = Object(external_vue_["resolveComponent"])("NebulaCarouselSlide");

  const _component_NebulaCarouselDots = Object(external_vue_["resolveComponent"])("NebulaCarouselDots");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: "nebula-carousel",
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [Object(external_vue_["createElementVNode"])("div", NebulaCarouselvue_type_template_id_2e936875_hoisted_1, [Object(external_vue_["createVNode"])(_component_NebulaCarouselArrow, {
    arrowType: "left",
    onClick: $options.showPrevElement,
    "aria-disabled": this.reachedMaxLeft ? 'true' : 'false',
    customStyles: $props.customStyles && $options.arrowProps ? $options.arrowProps : null
  }, null, 8, ["onClick", "aria-disabled", "customStyles"]), Object(external_vue_["createVNode"])(_component_NebulaCarouselSlide, {
    class: "nebula-carousel-slide--active",
    image: $options.currentElement.image,
    mobileImage: $options.currentElement.mobileImage,
    altText: $options.currentElement.altText,
    title: $options.currentElement.title,
    description: $options.currentElement.description,
    caption: $options.currentElement.caption,
    customStyles: $props.customStyles && $options.slideProps ? $options.slideProps : null
  }, null, 8, ["image", "mobileImage", "altText", "title", "description", "caption", "customStyles"]), Object(external_vue_["createElementVNode"])("div", NebulaCarouselvue_type_template_id_2e936875_hoisted_2, Object(external_vue_["toDisplayString"])($options.screenreaderItemProgress), 1), Object(external_vue_["createVNode"])(_component_NebulaCarouselArrow, {
    arrowType: "right",
    onClick: $options.showNextElement,
    "aria-disabled": this.reachedMaxRight ? 'true' : 'false',
    customStyles: $props.customStyles && $options.arrowProps ? $options.arrowProps : null
  }, null, 8, ["onClick", "aria-disabled", "customStyles"]), Object(external_vue_["createVNode"])(_component_NebulaCarouselDots, {
    slides: this.slides,
    currentElementIndex: this.currentElementIndex,
    showElement: this.showElement,
    customStyles: $props.customStyles && $options.dotProps ? $options.dotProps : null
  }, null, 8, ["slides", "currentElementIndex", "showElement", "customStyles"])])], 4);
}
// CONCATENATED MODULE: ./src/components/Carousel/NebulaCarousel.vue?vue&type=template&id=2e936875

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Carousel/NebulaCarouselArrow.vue?vue&type=template&id=77d09fbe

const NebulaCarouselArrowvue_type_template_id_77d09fbe_hoisted_1 = ["aria-label"];
function NebulaCarouselArrowvue_type_template_id_77d09fbe_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", {
    "aria-label": $options.ariaLabel,
    class: Object(external_vue_["normalizeClass"])(["nebula-carousel__arrow", `nebula-carousel__arrow--${$props.arrowType}`]),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
    symbolId: `caret-${$props.arrowType}`,
    class: "nebula-carousel__arrow-icon"
  }, null, 8, ["symbolId"])], 14, NebulaCarouselArrowvue_type_template_id_77d09fbe_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/Carousel/NebulaCarouselArrow.vue?vue&type=template&id=77d09fbe

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Carousel/NebulaCarouselArrow.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaCarouselArrowvue_type_script_lang_js = ({
  name: 'NebulaCarouselArrow',
  components: {
    NebulaIcon: NebulaIcon
  },
  mixins: [themingUtils],
  props: {
    arrowType: String
  },
  computed: {
    ariaLabel() {
      if (this.arrowType === 'left') {
        return this.$t('Previous Slide');
      }

      return this.$t('Next Slide');
    }

  }
});
// CONCATENATED MODULE: ./src/components/Carousel/NebulaCarouselArrow.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Carousel/NebulaCarouselArrow.vue?vue&type=style&index=0&id=77d09fbe&lang=stylus
var NebulaCarouselArrowvue_type_style_index_0_id_77d09fbe_lang_stylus = __webpack_require__("c65e");

// CONCATENATED MODULE: ./src/components/Carousel/NebulaCarouselArrow.vue







const NebulaCarouselArrow_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCarouselArrowvue_type_script_lang_js, [['render',NebulaCarouselArrowvue_type_template_id_77d09fbe_render]])

/* harmony default export */ var NebulaCarouselArrow = (NebulaCarouselArrow_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Carousel/NebulaCarouselDots.vue?vue&type=template&id=00e45105

const NebulaCarouselDotsvue_type_template_id_00e45105_hoisted_1 = {
  class: "nebula-carousel__dots"
};
const NebulaCarouselDotsvue_type_template_id_00e45105_hoisted_2 = ["aria-label", "onClick", "disabled"];
function NebulaCarouselDotsvue_type_template_id_00e45105_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("ul", NebulaCarouselDotsvue_type_template_id_00e45105_hoisted_1, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.slides, (slide, index) => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
      class: Object(external_vue_["normalizeClass"])(["nebula-carousel-dot", {
        'nebula-carousel-dot--active': $props.currentElementIndex === index
      }]),
      key: index,
      style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
    }, [Object(external_vue_["createElementVNode"])("button", {
      "aria-label": $options.ariaLabel(index),
      class: "nebula-carousel-dot__button",
      onClick: $event => $props.showElement(index),
      disabled: $props.currentElementIndex === index
    }, null, 8, NebulaCarouselDotsvue_type_template_id_00e45105_hoisted_2)], 6);
  }), 128))]);
}
// CONCATENATED MODULE: ./src/components/Carousel/NebulaCarouselDots.vue?vue&type=template&id=00e45105

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Carousel/NebulaCarouselDots.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaCarouselDotsvue_type_script_lang_js = ({
  name: 'NebulaCarouselDots',
  props: {
    slides: Array,
    currentElementIndex: Number,
    showElement: Function
  },
  mixins: [themingUtils],
  methods: {
    ariaLabel(slideIndex) {
      return this.$t('Slide %(number)d', {
        number: slideIndex + 1
      });
    }

  }
});
// CONCATENATED MODULE: ./src/components/Carousel/NebulaCarouselDots.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Carousel/NebulaCarouselDots.vue?vue&type=style&index=0&id=00e45105&lang=stylus
var NebulaCarouselDotsvue_type_style_index_0_id_00e45105_lang_stylus = __webpack_require__("c887");

// CONCATENATED MODULE: ./src/components/Carousel/NebulaCarouselDots.vue







const NebulaCarouselDots_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCarouselDotsvue_type_script_lang_js, [['render',NebulaCarouselDotsvue_type_template_id_00e45105_render]])

/* harmony default export */ var NebulaCarouselDots = (NebulaCarouselDots_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Carousel/NebulaCarouselSlide.vue?vue&type=template&id=6c2ebe27

const NebulaCarouselSlidevue_type_template_id_6c2ebe27_hoisted_1 = ["src", "alt"];
const NebulaCarouselSlidevue_type_template_id_6c2ebe27_hoisted_2 = ["src", "alt"];
const NebulaCarouselSlidevue_type_template_id_6c2ebe27_hoisted_3 = {
  key: 1,
  class: "nebula-carousel-slide__title"
};
const NebulaCarouselSlidevue_type_template_id_6c2ebe27_hoisted_4 = {
  key: 2,
  class: "nebula-carousel-slide__description"
};
const NebulaCarouselSlidevue_type_template_id_6c2ebe27_hoisted_5 = {
  key: 3,
  class: "nebula-carousel-slide__caption"
};
function NebulaCarouselSlidevue_type_template_id_6c2ebe27_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])(["nebula-carousel-slide", {
      'nebula-carousel-slide--no-mobile': !$props.mobileImage
    }]),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [Object(external_vue_["createElementVNode"])("img", {
    src: $props.image,
    alt: $props.altText,
    class: "nebula-carousel-slide__image",
    height: "600",
    width: "1232"
  }, null, 8, NebulaCarouselSlidevue_type_template_id_6c2ebe27_hoisted_1), $props.mobileImage ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("img", {
    key: 0,
    src: $props.mobileImage,
    alt: $props.altText,
    class: "nebula-carousel-slide__image--mobile",
    height: "600",
    width: "600"
  }, null, 8, NebulaCarouselSlidevue_type_template_id_6c2ebe27_hoisted_2)) : Object(external_vue_["createCommentVNode"])("", true), $props.title ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("h4", NebulaCarouselSlidevue_type_template_id_6c2ebe27_hoisted_3, Object(external_vue_["toDisplayString"])($props.title), 1)) : Object(external_vue_["createCommentVNode"])("", true), $props.description ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", NebulaCarouselSlidevue_type_template_id_6c2ebe27_hoisted_4, Object(external_vue_["toDisplayString"])($props.description), 1)) : Object(external_vue_["createCommentVNode"])("", true), $props.caption && !$options.hideCaption ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", NebulaCarouselSlidevue_type_template_id_6c2ebe27_hoisted_5, Object(external_vue_["toDisplayString"])($props.caption), 1)) : Object(external_vue_["createCommentVNode"])("", true)], 6);
}
// CONCATENATED MODULE: ./src/components/Carousel/NebulaCarouselSlide.vue?vue&type=template&id=6c2ebe27

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Carousel/NebulaCarouselSlide.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaCarouselSlidevue_type_script_lang_js = ({
  name: 'NebulaCarouselSlide',
  mixins: [themingUtils],
  props: {
    image: String,
    mobileImage: String,
    altText: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    caption: String,
    slideProps: {
      type: Object,
      default: null
    }
  },
  computed: {
    hideCaption() {
      var _this$title, _this$description;

      // We do not want to show captions if a title or description prop is given
      return ((_this$title = this.title) === null || _this$title === void 0 ? void 0 : _this$title.length) || ((_this$description = this.description) === null || _this$description === void 0 ? void 0 : _this$description.length);
    }

  }
});
// CONCATENATED MODULE: ./src/components/Carousel/NebulaCarouselSlide.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Carousel/NebulaCarouselSlide.vue?vue&type=style&index=0&id=6c2ebe27&lang=stylus
var NebulaCarouselSlidevue_type_style_index_0_id_6c2ebe27_lang_stylus = __webpack_require__("c9d9");

// CONCATENATED MODULE: ./src/components/Carousel/NebulaCarouselSlide.vue







const NebulaCarouselSlide_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCarouselSlidevue_type_script_lang_js, [['render',NebulaCarouselSlidevue_type_template_id_6c2ebe27_render]])

/* harmony default export */ var NebulaCarouselSlide = (NebulaCarouselSlide_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Carousel/NebulaCarousel.vue?vue&type=script&lang=js




/* harmony default export */ var NebulaCarouselvue_type_script_lang_js = ({
  name: 'NebulaCarousel',
  components: {
    NebulaCarouselArrow: NebulaCarouselArrow,
    NebulaCarouselDots: NebulaCarouselDots,
    NebulaCarouselSlide: NebulaCarouselSlide
  },
  mixins: [themingUtils],
  props: {
    customStyles: {
      type: Object,
      default: null
    },
    title: String,
    description: String,
    slides: Array
  },
  emits: ['img-update'],

  data() {
    return {
      currentElementIndex: 0
    };
  },

  computed: {
    currentElement() {
      return this.slides[this.currentElementIndex];
    },

    arrowProps() {
      return this.getStyles('arrow');
    },

    dotProps() {
      return this.getStyles('dot');
    },

    slideProps() {
      return this.getStyles('slide');
    },

    reachedMaxLeft() {
      return this.currentElementIndex === 0;
    },

    reachedMaxRight() {
      return this.currentElementIndex === this.slides.length - 1;
    },

    screenreaderItemProgress() {
      return this.$t('Item %(currentSlide)d of %(slideCount)d', {
        currentSlide: this.currentElementIndex + 1,
        slideCount: this.slides.length
      });
    }

  },
  methods: {
    getStyles(text) {
      const styleObj = {};
      Object.entries(this.customStyles).forEach(style => {
        const styleLowercase = style[0].toLowerCase();

        if (styleLowercase.includes(text)) {
          const key = style[0];
          const val = style[1];
          styleObj[key] = val;
        }
      });
      return styleObj;
    },

    showNextElement(e) {
      e.preventDefault();

      if (e.target.getAttribute('aria-disabled') === 'true') {
        return;
      }

      this.currentElementIndex += 1;
      this.$emit('img-update', this.currentElementIndex);
    },

    showPrevElement(e) {
      e.preventDefault();

      if (e.target.getAttribute('aria-disabled') === 'true') {
        return;
      }

      this.currentElementIndex -= 1;
      this.$emit('img-update', this.currentElementIndex);
    },

    showElement(elementIndex) {
      this.currentElementIndex = elementIndex;
      this.$emit('img-update', this.currentElementIndex);
    }

  }
});
// CONCATENATED MODULE: ./src/components/Carousel/NebulaCarousel.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Carousel/NebulaCarousel.vue?vue&type=style&index=0&id=2e936875&lang=stylus
var NebulaCarouselvue_type_style_index_0_id_2e936875_lang_stylus = __webpack_require__("6ef7");

// CONCATENATED MODULE: ./src/components/Carousel/NebulaCarousel.vue







const NebulaCarousel_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCarouselvue_type_script_lang_js, [['render',NebulaCarouselvue_type_template_id_2e936875_render]])

/* harmony default export */ var NebulaCarousel = (NebulaCarousel_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Combobox/NebulaCombobox.vue?vue&type=template&id=5b4befd4

const NebulaComboboxvue_type_template_id_5b4befd4_hoisted_1 = ["aria-labelledby"];
function NebulaComboboxvue_type_template_id_5b4befd4_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])(["nebula-combobox", $options.dropdownClass]),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "trigger", {
    toggleDropdown: _ctx.toggleDropdown,
    checkArrowKeyOnTrigger: _ctx.checkArrowKeyOnTrigger,
    checkArrowKeyAfterTrigger: _ctx.checkArrowKeyAfterTrigger,
    isOpen: _ctx.dropdownOpen
  }), Object(external_vue_["createElementVNode"])("ul", {
    class: "nebula-listbox__content",
    "aria-labelledby": $props.buttonId,
    onKeyup: _cache[0] || (_cache[0] = (...args) => _ctx.checkKeyup && _ctx.checkKeyup(...args)),
    onKeydown: _cache[1] || (_cache[1] = (...args) => _ctx.checkKeydown && _ctx.checkKeydown(...args)),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.handleSelect && $options.handleSelect(...args)),
    ref: "dropdownContent",
    role: "listbox"
  }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "content")], 40, NebulaComboboxvue_type_template_id_5b4befd4_hoisted_1)], 6);
}
// CONCATENATED MODULE: ./src/components/Combobox/NebulaCombobox.vue?vue&type=template&id=5b4befd4

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Combobox/NebulaCombobox.vue?vue&type=script&lang=js



/* harmony default export */ var NebulaComboboxvue_type_script_lang_js = ({
  name: 'NebulaCombobox',
  mixins: [dropdown, themingUtils],

  data() {
    return {
      isComboBox: true,
      triggerBtn: null,
      selected: null
    };
  },

  props: {
    items: {
      default() {
        return [];
      },

      type: Array
    },
    buttonId: {
      type: [String, Number]
    },
    dropdownWrapperClass: {
      required: false,
      type: String
    }
  },
  computed: {
    dropdownClass() {
      const retVal = [];

      if (this.dropdownOpen) {
        retVal.push('nebula-combobox--open');
      }

      if (this.dropdownWrapperClass) {
        retVal.push(this.dropdownWrapperClass);
      }

      return retVal.join(' ');
    },

    formattedId() {
      return randomStringId(this.buttonId);
    }

  },

  mounted() {
    // store trigger button on mount
    this.triggerBtn = document.getElementById(this.formattedId);
  },

  methods: {
    handleSelect() {
      // put focus on trigger button when option is selected
      this.selected = document.activeElement;
      this.triggerBtn.focus();
    },

    handleTrigger() {
      // put focus on current selection on trigger
      // this is called in `toggleDropdown`,
      // store first item in list as default selected
      // toggleDropdown kept in place for backward compatibility
      this.$nextTick(() => {
        const [firstItem] = this.getFocusable();
        this.selected = firstItem;
        this.selected.focus();
      });
    }

  }
});
// CONCATENATED MODULE: ./src/components/Combobox/NebulaCombobox.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Combobox/NebulaCombobox.vue?vue&type=style&index=0&id=5b4befd4&lang=stylus
var NebulaComboboxvue_type_style_index_0_id_5b4befd4_lang_stylus = __webpack_require__("4ca2");

// CONCATENATED MODULE: ./src/components/Combobox/NebulaCombobox.vue







const NebulaCombobox_exports_ = /*#__PURE__*/exportHelper_default()(NebulaComboboxvue_type_script_lang_js, [['render',NebulaComboboxvue_type_template_id_5b4befd4_render]])

/* harmony default export */ var NebulaCombobox = (NebulaCombobox_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Datepicker/NebulaDatepicker.vue?vue&type=template&id=11782aa8

const NebulaDatepickervue_type_template_id_11782aa8_hoisted_1 = ["onClick", "aria-label", "tabindex"];
const NebulaDatepickervue_type_template_id_11782aa8_hoisted_2 = {
  class: "action-row"
};
function NebulaDatepickervue_type_template_id_11782aa8_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaInput = Object(external_vue_["resolveComponent"])("NebulaInput");

  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_VueDatepicker = Object(external_vue_["resolveComponent"])("VueDatepicker");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_VueDatepicker, Object(external_vue_["mergeProps"])({
    modelValue: $data.date,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.date = $event)
  }, _ctx.$attrs, {
    class: $options.datepickerClasses,
    "enable-time-picker": $props.showTimePicker ? true : false,
    "month-name-format": $props.useShortMonthName ? 'short' : 'long',
    "month-change-on-scroll": false,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = newDate => _ctx.$emit('date-change', newDate)),
    onOpen: _cache[2] || (_cache[2] = $event => _ctx.$emit('datepicker-open')),
    onClosed: _cache[3] || (_cache[3] = $event => _ctx.$emit('datepicker-closed')),
    style: _ctx.cssProps
  }), {
    "dp-input": Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaInput, {
      isDisabled: $props.disabled,
      id: $options.getId,
      placeholder: $props.placeholder,
      value: $options.formattedDate,
      class: Object(external_vue_["normalizeClass"])(!$props.hideIcon ? 'dp__input_icon_pad' : ''),
      size: $props.inputSize,
      status: $props.inputStatus
    }, null, 8, ["isDisabled", "id", "placeholder", "value", "class", "size", "status"])]),
    "input-icon": Object(external_vue_["withCtx"])(() => [!$props.hideIcon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
      key: 0,
      symbolId: $props.iconName,
      class: "dp__icon dp__input_icon dp__input_icons"
    }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true)]),
    "clear-icon": Object(external_vue_["withCtx"])(({
      clear
    }) => [Object(external_vue_["createElementVNode"])("button", {
      onClick: clear,
      "aria-label": $props.clearAriaText,
      class: "dp__icon dp__clear_icon dp__input_icons",
      tabindex: $props.disabled ? '-1' : null
    }, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      symbolId: "x",
      size: "s"
    })], 8, NebulaDatepickervue_type_template_id_11782aa8_hoisted_1)]),
    "arrow-left": Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      symbolId: "caret-left",
      class: "dp__icon"
    })]),
    "arrow-right": Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      symbolId: "caret-right",
      class: "dp__icon"
    })]),
    "arrow-up": Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      symbolId: "caret-up",
      class: "dp__icon"
    })]),
    "arrow-down": Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      symbolId: "caret-down",
      class: "dp__icon"
    })]),
    "clock-icon": Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      symbolId: "clock",
      class: "dp__icon"
    })]),
    "action-row": Object(external_vue_["withCtx"])(({
      selectDate,
      closePicker
    }) => [Object(external_vue_["createElementVNode"])("div", NebulaDatepickervue_type_template_id_11782aa8_hoisted_2, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      size: "xs",
      type: "ghost",
      text: $props.closePickerText,
      onClick: closePicker
    }, null, 8, ["text", "onClick"]), Object(external_vue_["createVNode"])(_component_NebulaButton, {
      size: "xs",
      text: $props.selectDateText,
      onClick: selectDate
    }, null, 8, ["text", "onClick"])])]),
    _: 1
  }, 16, ["modelValue", "class", "enable-time-picker", "month-name-format", "style"]);
}
// CONCATENATED MODULE: ./src/components/Datepicker/NebulaDatepicker.vue?vue&type=template&id=11782aa8

// EXTERNAL MODULE: ./node_modules/@vuepic/vue-datepicker/dist/main.css
var main = __webpack_require__("1465");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/requiredArgs/index.js
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/isDate/index.js


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/toDate/index.js


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/isValid/index.js



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);

  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/toInteger/index.js
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/addMilliseconds/index.js



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/subMilliseconds/index.js



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js


function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js



function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/defaultOptions/index.js
var defaultOptions_defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions_defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions_defaultOptions = newOptions;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var getUTCWeek_MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / getUTCWeek_MILLISECONDS_IN_WEEK) + 1;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

/* harmony default export */ var format_formatters = (formatters_formatters);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};

var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};

var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ var format_longFormatters = (longFormatters);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

/* harmony default export */ var _lib_formatDistance = (formatDistance);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // TODO: Remove String()

    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

/* harmony default export */ var _lib_formatRelative = (formatRelative);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize_localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize_localize);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match_match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match_match);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/locale/en-US/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var en_US_locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (en_US_locale);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/defaultLocale/index.js

/* harmony default export */ var defaultLocale = (en_US);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = format_longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = format_formatters[firstCharacter];

    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }

      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/assign/index.js
function assign_assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      ;
      target[property] = object[property];
    }
  }

  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js



function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js


function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function defineProperty_defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/Setter.js






var TIMEZONE_UNIT_PRIORITY = 10;
var Setter_Setter = /*#__PURE__*/function () {
  function Setter() {
    _classCallCheck(this, Setter);

    defineProperty_defineProperty(this, "priority", void 0);

    defineProperty_defineProperty(this, "subPriority", 0);
  }

  _createClass(Setter, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);

  return Setter;
}();
var Setter_ValueSetter = /*#__PURE__*/function (_Setter) {
  _inherits(ValueSetter, _Setter);

  var _super = _createSuper(ValueSetter);

  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this;

    _classCallCheck(this, ValueSetter);

    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;

    if (subPriority) {
      _this.subPriority = subPriority;
    }

    return _this;
  }

  _createClass(ValueSetter, [{
    key: "validate",
    value: function validate(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);

  return ValueSetter;
}(Setter_Setter);
var Setter_DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
  _inherits(DateToSystemTimezoneSetter, _Setter2);

  var _super2 = _createSuper(DateToSystemTimezoneSetter);

  function DateToSystemTimezoneSetter() {
    var _this2;

    _classCallCheck(this, DateToSystemTimezoneSetter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this2), "priority", TIMEZONE_UNIT_PRIORITY);

    defineProperty_defineProperty(_assertThisInitialized(_this2), "subPriority", -1);

    return _this2;
  }

  _createClass(DateToSystemTimezoneSetter, [{
    key: "set",
    value: function set(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }

      var convertedDate = new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);

  return DateToSystemTimezoneSetter;
}(Setter_Setter);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/Parser.js




var Parser_Parser = /*#__PURE__*/function () {
  function Parser() {
    _classCallCheck(this, Parser);

    defineProperty_defineProperty(this, "incompatibleTokens", void 0);

    defineProperty_defineProperty(this, "priority", void 0);

    defineProperty_defineProperty(this, "subPriority", void 0);
  }

  _createClass(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);

      if (!result) {
        return null;
      }

      return {
        setter: new Setter_ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);

  return Parser;
}();
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/EraParser.js







var EraParser_EraParser = /*#__PURE__*/function (_Parser) {
  _inherits(EraParser, _Parser);

  var _super = _createSuper(EraParser);

  function EraParser() {
    var _this;

    _classCallCheck(this, EraParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 140);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);

    return _this;
  }

  _createClass(EraParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(dateString, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(dateString, {
            width: 'wide'
          }) || match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return EraParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/constants/index.js
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;
/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */

var daysInYear = 365.2425;
/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */

var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInHour = 3600000;
/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInSecond = 1000;
/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */

var minTime = -maxTime;
/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */

var minutesInHour = 60;
/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var monthsInQuarter = 3;
/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */

var monthsInYear = 12;
/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */

var quartersInYear = 4;
/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */

var secondsInHour = 3600;
/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var secondsInMinute = 60;
/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */

var secondsInDay = secondsInHour * 24;
/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */

var secondsInWeek = secondsInDay * 7;
/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */

var secondsInYear = secondsInDay * daysInYear;
/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */

var secondsInMonth = secondsInYear / 12;
/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */

var secondsInQuarter = secondsInMonth * 3;
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/constants.js
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/utils.js


function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }

  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/YearParser.js







 // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

var YearParser_YearParser = /*#__PURE__*/function (_Parser) {
  _inherits(YearParser, _Parser);

  var _super = _createSuper(YearParser);

  function YearParser() {
    var _this;

    _classCallCheck(this, YearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 130);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass(YearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return mapValue(parseNDigits(4, dateString), valueCallback);

        case 'yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);

        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return YearParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekYearParser.js









 // Local week-numbering year

var LocalWeekYearParser_LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekYearParser, _Parser);

  var _super = _createSuper(LocalWeekYearParser);

  function LocalWeekYearParser() {
    var _this;

    _classCallCheck(this, LocalWeekYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 130);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);

    return _this;
  }

  _createClass(LocalWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return mapValue(parseNDigits(4, dateString), valueCallback);

        case 'Yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);

        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value, options) {
      var currentYear = getUTCWeekYear(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    }
  }]);

  return LocalWeekYearParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekYearParser.js








 // ISO week-numbering year

var ISOWeekYearParser_ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekYearParser, _Parser);

  var _super = _createSuper(ISOWeekYearParser);

  function ISOWeekYearParser() {
    var _this;

    _classCallCheck(this, ISOWeekYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 130);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass(ISOWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'R') {
        return parseNDigitsSigned(4, dateString);
      }

      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    }
  }]);

  return ISOWeekYearParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/ExtendedYearParser.js








var ExtendedYearParser_ExtendedYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ExtendedYearParser, _Parser);

  var _super = _createSuper(ExtendedYearParser);

  function ExtendedYearParser() {
    var _this;

    _classCallCheck(this, ExtendedYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 130);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass(ExtendedYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'u') {
        return parseNDigitsSigned(4, dateString);
      }

      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return ExtendedYearParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/QuarterParser.js








var QuarterParser_QuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(QuarterParser, _Parser);

  var _super = _createSuper(QuarterParser);

  function QuarterParser() {
    var _this;

    _classCallCheck(this, QuarterParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 120);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass(QuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return QuarterParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/StandAloneQuarterParser.js








var StandAloneQuarterParser_StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneQuarterParser, _Parser);

  var _super = _createSuper(StandAloneQuarterParser);

  function StandAloneQuarterParser() {
    var _this;

    _classCallCheck(this, StandAloneQuarterParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 120);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass(StandAloneQuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return StandAloneQuarterParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/MonthParser.js









var MonthParser_MonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(MonthParser, _Parser);

  var _super = _createSuper(MonthParser);

  function MonthParser() {
    var _this;

    _classCallCheck(this, MonthParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 110);

    return _this;
  }

  _createClass(MonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return MonthParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/StandAloneMonthParser.js









var StandAloneMonthParser_StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneMonthParser, _Parser);

  var _super = _createSuper(StandAloneMonthParser);

  function StandAloneMonthParser() {
    var _this;

    _classCallCheck(this, StandAloneMonthParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 110);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass(StandAloneMonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return StandAloneMonthParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/setUTCWeek/index.js




function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekParser.js










 // Local week of year

var LocalWeekParser_LocalWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekParser, _Parser);

  var _super = _createSuper(LocalWeekParser);

  function LocalWeekParser() {
    var _this;

    _classCallCheck(this, LocalWeekParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 100);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);

    return _this;
  }

  _createClass(LocalWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, dateString);

        case 'wo':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    }
  }]);

  return LocalWeekParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js




function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekParser.js










 // ISO week of year

var ISOWeekParser_ISOWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekParser, _Parser);

  var _super = _createSuper(ISOWeekParser);

  function ISOWeekParser() {
    var _this;

    _classCallCheck(this, ISOWeekParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 100);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass(ISOWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, dateString);

        case 'Io':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value));
    }
  }]);

  return ISOWeekParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/DateParser.js









var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Day of the month

var DateParser_DateParser = /*#__PURE__*/function (_Parser) {
  _inherits(DateParser, _Parser);

  var _super = _createSuper(DateParser);

  function DateParser() {
    var _this;

    _classCallCheck(this, DateParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 90);

    defineProperty_defineProperty(_assertThisInitialized(_this), "subPriority", 1);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass(DateParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, dateString);

        case 'do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return DateParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/DayOfYearParser.js









var DayOfYearParser_DayOfYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayOfYearParser, _Parser);

  var _super = _createSuper(DayOfYearParser);

  function DayOfYearParser() {
    var _this;

    _classCallCheck(this, DayOfYearParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 90);

    defineProperty_defineProperty(_assertThisInitialized(_this), "subpriority", 1);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass(DayOfYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);

        case 'Do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return DayOfYearParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/setUTCDay/index.js




function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(2, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/DayParser.js







 // Day of week

var DayParser_DayParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayParser, _Parser);

  var _super = _createSuper(DayParser);

  function DayParser() {
    var _this;

    _classCallCheck(this, DayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 90);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass(DayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return DayParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/LocalDayParser.js








 // Local day of week

var LocalDayParser_LocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalDayParser, _Parser);

  var _super = _createSuper(LocalDayParser);

  function LocalDayParser() {
    var _this;

    _classCallCheck(this, LocalDayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 90);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);

    return _this;
  }

  _createClass(LocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd

        case 'eo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue

        case 'eee':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return LocalDayParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/StandAloneLocalDayParser.js








 // Stand-alone local day of week

var StandAloneLocalDayParser_StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneLocalDayParser, _Parser);

  var _super = _createSuper(StandAloneLocalDayParser);

  function StandAloneLocalDayParser() {
    var _this;

    _classCallCheck(this, StandAloneLocalDayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 90);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);

    return _this;
  }

  _createClass(StandAloneLocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd

        case 'co':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue

        case 'ccc':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return StandAloneLocalDayParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/_lib/setUTCISODay/index.js



function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/ISODayParser.js








 // ISO day of week

var ISODayParser_ISODayParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISODayParser, _Parser);

  var _super = _createSuper(ISODayParser);

  function ISODayParser() {
    var _this;

    _classCallCheck(this, ISODayParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 90);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);

    return _this;
  }

  _createClass(ISODayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, dateString);
        // 2nd

        case 'io':
          return match.ordinalNumber(dateString, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return mapValue(match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // T

        case 'iiiii':
          return mapValue(match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tu

        case 'iiiiii':
          return mapValue(match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tuesday

        case 'iiii':
        default:
          return mapValue(match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date = setUTCISODay(date, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);

  return ISODayParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/AMPMParser.js








var AMPMParser_AMPMParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMParser, _Parser);

  var _super = _createSuper(AMPMParser);

  function AMPMParser() {
    var _this;

    _classCallCheck(this, AMPMParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 80);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);

    return _this;
  }

  _createClass(AMPMParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);

  return AMPMParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/AMPMMidnightParser.js








var AMPMMidnightParser_AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMMidnightParser, _Parser);

  var _super = _createSuper(AMPMMidnightParser);

  function AMPMMidnightParser() {
    var _this;

    _classCallCheck(this, AMPMMidnightParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 80);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);

    return _this;
  }

  _createClass(AMPMMidnightParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);

  return AMPMMidnightParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/DayPeriodParser.js







 // in the morning, in the afternoon, in the evening, at night

var DayPeriodParser_DayPeriodParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayPeriodParser, _Parser);

  var _super = _createSuper(DayPeriodParser);

  function DayPeriodParser() {
    var _this;

    _classCallCheck(this, DayPeriodParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 80);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);

    return _this;
  }

  _createClass(DayPeriodParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);

  return DayPeriodParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/Hour1to12Parser.js









var Hour1to12Parser_Hour1to12Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1to12Parser, _Parser);

  var _super = _createSuper(Hour1to12Parser);

  function Hour1to12Parser() {
    var _this;

    _classCallCheck(this, Hour1to12Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 70);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);

    return _this;
  }

  _createClass(Hour1to12Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, dateString);

        case 'ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    }
  }]);

  return Hour1to12Parser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/Hour0to23Parser.js









var Hour0to23Parser_Hour0to23Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0to23Parser, _Parser);

  var _super = _createSuper(Hour0to23Parser);

  function Hour0to23Parser() {
    var _this;

    _classCallCheck(this, Hour0to23Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 70);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);

    return _this;
  }

  _createClass(Hour0to23Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, dateString);

        case 'Ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  }]);

  return Hour0to23Parser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/Hour0To11Parser.js









var Hour0To11Parser_Hour0To11Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0To11Parser, _Parser);

  var _super = _createSuper(Hour0To11Parser);

  function Hour0To11Parser() {
    var _this;

    _classCallCheck(this, Hour0To11Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 70);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);

    return _this;
  }

  _createClass(Hour0To11Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, dateString);

        case 'Ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    }
  }]);

  return Hour0To11Parser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/Hour1To24Parser.js









var Hour1To24Parser_Hour1To24Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1To24Parser, _Parser);

  var _super = _createSuper(Hour1To24Parser);

  function Hour1To24Parser() {
    var _this;

    _classCallCheck(this, Hour1To24Parser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 70);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);

    return _this;
  }

  _createClass(Hour1To24Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, dateString);

        case 'ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);

  return Hour1To24Parser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/MinuteParser.js









var MinuteParser_MinuteParser = /*#__PURE__*/function (_Parser) {
  _inherits(MinuteParser, _Parser);

  var _super = _createSuper(MinuteParser);

  function MinuteParser() {
    var _this;

    _classCallCheck(this, MinuteParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 60);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);

    return _this;
  }

  _createClass(MinuteParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, dateString);

        case 'mo':
          return match.ordinalNumber(dateString, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  }]);

  return MinuteParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/SecondParser.js









var SecondParser_SecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(SecondParser, _Parser);

  var _super = _createSuper(SecondParser);

  function SecondParser() {
    var _this;

    _classCallCheck(this, SecondParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 50);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);

    return _this;
  }

  _createClass(SecondParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, dateString);

        case 'so':
          return match.ordinalNumber(dateString, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  }]);

  return SecondParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/FractionOfSecondParser.js








var FractionOfSecondParser_FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(FractionOfSecondParser, _Parser);

  var _super = _createSuper(FractionOfSecondParser);

  function FractionOfSecondParser() {
    var _this;

    _classCallCheck(this, FractionOfSecondParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 30);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T']);

    return _this;
  }

  _createClass(FractionOfSecondParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMilliseconds(value);
      return date;
    }
  }]);

  return FractionOfSecondParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneWithZParser.js








 // Timezone (ISO-8601. +00:00 is `'Z'`)

var ISOTimezoneWithZParser_ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneWithZParser, _Parser);

  var _super = _createSuper(ISOTimezoneWithZParser);

  function ISOTimezoneWithZParser() {
    var _this;

    _classCallCheck(this, ISOTimezoneWithZParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 10);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'x']);

    return _this;
  }

  _createClass(ISOTimezoneWithZParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, dateString);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    }
  }]);

  return ISOTimezoneWithZParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneParser.js








 // Timezone (ISO-8601)

var ISOTimezoneParser_ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneParser, _Parser);

  var _super = _createSuper(ISOTimezoneParser);

  function ISOTimezoneParser() {
    var _this;

    _classCallCheck(this, ISOTimezoneParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 10);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ['t', 'T', 'X']);

    return _this;
  }

  _createClass(ISOTimezoneParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, dateString);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    }
  }]);

  return ISOTimezoneParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/TimestampSecondsParser.js








var TimestampSecondsParser_TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampSecondsParser, _Parser);

  var _super = _createSuper(TimestampSecondsParser);

  function TimestampSecondsParser() {
    var _this;

    _classCallCheck(this, TimestampSecondsParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 40);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", '*');

    return _this;
  }

  _createClass(TimestampSecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    }
  }]);

  return TimestampSecondsParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/TimestampMillisecondsParser.js








var TimestampMillisecondsParser_TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampMillisecondsParser, _Parser);

  var _super = _createSuper(TimestampMillisecondsParser);

  function TimestampMillisecondsParser() {
    var _this;

    _classCallCheck(this, TimestampMillisecondsParser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    defineProperty_defineProperty(_assertThisInitialized(_this), "priority", 20);

    defineProperty_defineProperty(_assertThisInitialized(_this), "incompatibleTokens", '*');

    return _this;
  }

  _createClass(TimestampMillisecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);

  return TimestampMillisecondsParser;
}(Parser_Parser);
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/_lib/parsers/index.js































/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */

var parsers = {
  G: new EraParser_EraParser(),
  y: new YearParser_YearParser(),
  Y: new LocalWeekYearParser_LocalWeekYearParser(),
  R: new ISOWeekYearParser_ISOWeekYearParser(),
  u: new ExtendedYearParser_ExtendedYearParser(),
  Q: new QuarterParser_QuarterParser(),
  q: new StandAloneQuarterParser_StandAloneQuarterParser(),
  M: new MonthParser_MonthParser(),
  L: new StandAloneMonthParser_StandAloneMonthParser(),
  w: new LocalWeekParser_LocalWeekParser(),
  I: new ISOWeekParser_ISOWeekParser(),
  d: new DateParser_DateParser(),
  D: new DayOfYearParser_DayOfYearParser(),
  E: new DayParser_DayParser(),
  e: new LocalDayParser_LocalDayParser(),
  c: new StandAloneLocalDayParser_StandAloneLocalDayParser(),
  i: new ISODayParser_ISODayParser(),
  a: new AMPMParser_AMPMParser(),
  b: new AMPMMidnightParser_AMPMMidnightParser(),
  B: new DayPeriodParser_DayPeriodParser(),
  h: new Hour1to12Parser_Hour1to12Parser(),
  H: new Hour0to23Parser_Hour0to23Parser(),
  K: new Hour0To11Parser_Hour0To11Parser(),
  k: new Hour1To24Parser_Hour1To24Parser(),
  m: new MinuteParser_MinuteParser(),
  s: new SecondParser_SecondParser(),
  S: new FractionOfSecondParser_FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser_ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser_ISOTimezoneParser(),
  t: new TimestampSecondsParser_TimestampSecondsParser(),
  T: new TimestampMillisecondsParser_TimestampMillisecondsParser()
};
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parse/index.js













 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var parse_formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var parse_longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var parse_escapedStringRegExp = /^'([^]*?)'?$/;
var parse_doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var parse_unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse_parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  }; // If timezone isn't specified, it will be set to the system timezone

  var setters = [new Setter_DateToSystemTimezoneSetter()];
  var tokens = formatString.match(parse_longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter in format_longFormatters) {
      var longFormatter = format_longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }

    return substring;
  }).join('').match(parse_formattingTokensRegExp);
  var usedTokens = [];

  var _iterator = _createForOfIteratorHelper(tokens),
      _step;

  try {
    var _loop = function _loop() {
      var token = _step.value;

      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token)) {
        throwProtectedError(token, formatString, dirtyDateString);
      }

      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token)) {
        throwProtectedError(token, formatString, dirtyDateString);
      }

      var firstCharacter = token[0];
      var parser = parsers[firstCharacter];

      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;

        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function (usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });

          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
        }

        usedTokens.push({
          token: firstCharacter,
          fullToken: token
        });
        var parseResult = parser.run(dateString, token, locale.match, subFnOptions);

        if (!parseResult) {
          return {
            v: new Date(NaN)
          };
        }

        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(parse_unescapedLatinCharacterRegExp)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        } // Replace two single quote characters with one single quote character


        if (token === "''") {
          token = "'";
        } else if (firstCharacter === "'") {
          token = parse_cleanEscapedString(token);
        } // Cut token from string, or, if string doesn't match the token, return Invalid Date


        if (dateString.indexOf(token) === 0) {
          dateString = dateString.slice(token.length);
        } else {
          return {
            v: new Date(NaN)
          };
        }
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();

      if (_typeof(_ret) === "object") return _ret.v;
    } // Check if the remaining input contains something other than whitespace

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.


  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};

  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var setter = _step2.value;

      if (!setter.validate(utcDate, subFnOptions)) {
        return new Date(NaN);
      }

      var result = setter.set(utcDate, flags, subFnOptions); // Result is tuple (date, flags)

      if (Array.isArray(result)) {
        utcDate = result[0];
        assign_assign(flags, result[1]); // Result is date
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return utcDate;
}

function parse_cleanEscapedString(input) {
  return input.match(parse_escapedStringRegExp)[1].replace(parse_doubleQuoteRegExp, "'");
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/getDaysInMonth/index.js


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/setMonth/index.js




/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/set/index.js





/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Object} values - an object with options
 * @param {Number} [values.year] - the number of years to be set
 * @param {Number} [values.month] - the number of months to be set
 * @param {Number} [values.date] - the number of days to be set
 * @param {Number} [values.hours] - the number of hours to be set
 * @param {Number} [values.minutes] - the number of minutes to be set
 * @param {Number} [values.seconds] - the number of seconds to be set
 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
 * @returns {Date} the new date with options set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `values` must be an object
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */

function set_set(dirtyDate, values) {
  requiredArgs(2, arguments);

  if (_typeof(values) !== 'object' || values === null) {
    throw new RangeError('values parameter must be an object');
  }

  var date = toDate(dirtyDate); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  if (values.year != null) {
    date.setFullYear(values.year);
  }

  if (values.month != null) {
    date = setMonth(date, values.month);
  }

  if (values.date != null) {
    date.setDate(toInteger(values.date));
  }

  if (values.hours != null) {
    date.setHours(toInteger(values.hours));
  }

  if (values.minutes != null) {
    date.setMinutes(toInteger(values.minutes));
  }

  if (values.seconds != null) {
    date.setSeconds(toInteger(values.seconds));
  }

  if (values.milliseconds != null) {
    date.setMilliseconds(toInteger(values.milliseconds));
  }

  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/setHours/index.js



/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var hours = toInteger(dirtyHours);
  date.setHours(hours);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/setMinutes/index.js



/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var minutes = toInteger(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/setSeconds/index.js



/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var seconds = toInteger(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/setMilliseconds/index.js



/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @returns {Date} the new date with the milliseconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */

function setMilliseconds(dirtyDate, dirtyMilliseconds) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var milliseconds = toInteger(dirtyMilliseconds);
  date.setMilliseconds(milliseconds);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/isBefore/index.js


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/isEqual/index.js


/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/isAfter/index.js


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/getHours/index.js


/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var hours = date.getHours();
  return hours;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/getMinutes/index.js


/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */

function getMinutes(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/getSeconds/index.js


/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/getYear/index.js


/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getFullYear();
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/getMonth/index.js


/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */

function getMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  return month;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/parseISO/index.js



/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, options) {
  var _options$additionalDi;

  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both

  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function parseISO_isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (parseISO_isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (parseISO_isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/eachDayOfInterval/index.js


/**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.step` must be a number greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */

function eachDayOfInterval(dirtyInterval, options) {
  var _options$step;

  requiredArgs(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = toDate(interval.start);
  var endDate = toDate(interval.end);
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');

  while (currentDate.getTime() <= endTime) {
    dates.push(toDate(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }

  return dates;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/addMonths/index.js



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/startOfWeek/index.js




/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/endOfWeek/index.js




/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */

function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/setYear/index.js



/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var year = toInteger(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/subMonths/index.js



/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */

function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/addYears/index.js



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/subYears/index.js



/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */

function subYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addYears(dirtyDate, -amount);
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/addDays/index.js



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/getDay/index.js


/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var day = date.getDay();
  return day;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/startOfDay/index.js


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/differenceInCalendarDays/index.js



var differenceInCalendarDays_MILLISECONDS_IN_DAY = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / differenceInCalendarDays_MILLISECONDS_IN_DAY);
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/add/index.js






/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */

function add(dirtyDate, duration) {
  requiredArgs(2, arguments);
  if (!duration || _typeof(duration) !== 'object') return new Date(NaN);
  var years = duration.years ? toInteger(duration.years) : 0;
  var months = duration.months ? toInteger(duration.months) : 0;
  var weeks = duration.weeks ? toInteger(duration.weeks) : 0;
  var days = duration.days ? toInteger(duration.days) : 0;
  var hours = duration.hours ? toInteger(duration.hours) : 0;
  var minutes = duration.minutes ? toInteger(duration.minutes) : 0;
  var seconds = duration.seconds ? toInteger(duration.seconds) : 0; // Add years and months

  var date = toDate(dirtyDate);
  var dateWithMonths = months || years ? addMonths(date, months + years * 12) : date; // Add weeks and days

  var dateWithDays = days || weeks ? addDays(dateWithMonths, days + weeks * 7) : dateWithMonths; // Add days, hours, minutes and seconds

  var minutesToAdd = minutes + hours * 60;
  var secondsToAdd = seconds + minutesToAdd * 60;
  var msToAdd = secondsToAdd * 1000;
  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
  return finalDate;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/subDays/index.js



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */

function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/sub/index.js





/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */

function sub(date, duration) {
  requiredArgs(2, arguments);
  if (!duration || _typeof(duration) !== 'object') return new Date(NaN);
  var years = duration.years ? toInteger(duration.years) : 0;
  var months = duration.months ? toInteger(duration.months) : 0;
  var weeks = duration.weeks ? toInteger(duration.weeks) : 0;
  var days = duration.days ? toInteger(duration.days) : 0;
  var hours = duration.hours ? toInteger(duration.hours) : 0;
  var minutes = duration.minutes ? toInteger(duration.minutes) : 0;
  var seconds = duration.seconds ? toInteger(duration.seconds) : 0; // Subtract years and months

  var dateWithoutMonths = subMonths(date, months + years * 12); // Subtract weeks and days

  var dateWithoutDays = subDays(dateWithoutMonths, days + weeks * 7); // Subtract hours, minutes and seconds

  var minutestoSub = minutes + hours * 60;
  var secondstoSub = seconds + minutestoSub * 60;
  var mstoSub = secondstoSub * 1000;
  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
  return finalDate;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/getWeekYear/index.js





/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the local week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */

function getWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfWeek(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/startOfWeekYear/index.js





/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the start of a week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */

function startOfWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  var date = startOfWeek(firstWeek, options);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/getWeek/index.js




var getWeek_MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfWeek(date, options).getTime() - startOfWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / getWeek_MILLISECONDS_IN_WEEK) + 1;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/startOfISOWeek/index.js


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/getISOWeekYear/index.js



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */

function getISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/startOfISOWeekYear/index.js



/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */

function startOfISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/node_modules/date-fns/esm/getISOWeek/index.js




var getISOWeek_MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */

function getISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / getISOWeek_MILLISECONDS_IN_WEEK) + 1;
}
// CONCATENATED MODULE: ./node_modules/@vuepic/vue-datepicker/dist/vue-datepicker.js



function It() {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    "aria-hidden": "true",
    class: "dp__icon"
  }, [Object(external_vue_["createElementVNode"])("path", {
    d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
  }), Object(external_vue_["createElementVNode"])("path", {
    d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
  }), Object(external_vue_["createElementVNode"])("path", {
    d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
  }), Object(external_vue_["createElementVNode"])("path", {
    d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
  })]);
}

It.compatConfig = {
  MODE: 3
};

function ba() {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    "aria-hidden": "true",
    class: "dp__icon"
  }, [Object(external_vue_["createElementVNode"])("path", {
    d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
  }), Object(external_vue_["createElementVNode"])("path", {
    d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
  })]);
}

ba.compatConfig = {
  MODE: 3
};

function Rn() {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    "aria-hidden": "true",
    class: "dp__icon"
  }, [Object(external_vue_["createElementVNode"])("path", {
    d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
  })]);
}

Rn.compatConfig = {
  MODE: 3
};

function On() {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    "aria-hidden": "true",
    class: "dp__icon"
  }, [Object(external_vue_["createElementVNode"])("path", {
    d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
  })]);
}

On.compatConfig = {
  MODE: 3
};

function Nn() {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    "aria-hidden": "true",
    class: "dp__icon"
  }, [Object(external_vue_["createElementVNode"])("path", {
    d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
  }), Object(external_vue_["createElementVNode"])("path", {
    d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
  })]);
}

Nn.compatConfig = {
  MODE: 3
};

function Yn() {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    "aria-hidden": "true",
    class: "dp__icon"
  }, [Object(external_vue_["createElementVNode"])("path", {
    d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
  })]);
}

Yn.compatConfig = {
  MODE: 3
};

function In() {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    "aria-hidden": "true",
    class: "dp__icon"
  }, [Object(external_vue_["createElementVNode"])("path", {
    d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
  })]);
}

In.compatConfig = {
  MODE: 3
};

function Bn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

var ka = {
  exports: {}
};

(function (e) {
  function n(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }

  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ka);

var xa = ka.exports,
    wn = {
  exports: {}
};

(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = a;

  function a(t) {
    if (t === null || t === !0 || t === !1) return NaN;
    var r = Number(t);
    return isNaN(r) ? r : r < 0 ? Math.ceil(r) : Math.floor(r);
  }

  e.exports = n.default;
})(wn, wn.exports);

var Qa = wn.exports;
const er = /* @__PURE__ */Bn(Qa);
var Dn = {
  exports: {}
};

(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = a;

  function a(t) {
    var r = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
    return r.setUTCFullYear(t.getFullYear()), t.getTime() - r.getTime();
  }

  e.exports = n.default;
})(Dn, Dn.exports);

var tr = Dn.exports;
const Gn = /* @__PURE__ */Bn(tr);

function nr(e, n) {
  var a = or(n);
  return a.formatToParts ? rr(a, e) : lr(a, e);
}

var ar = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};

function rr(e, n) {
  try {
    for (var a = e.formatToParts(n), t = [], r = 0; r < a.length; r++) {
      var l = ar[a[r].type];
      l >= 0 && (t[l] = parseInt(a[r].value, 10));
    }

    return t;
  } catch (c) {
    if (c instanceof RangeError) return [NaN];
    throw c;
  }
}

function lr(e, n) {
  var a = e.format(n).replace(/\u200E/g, ""),
      t = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(a);
  return [t[3], t[1], t[2], t[4], t[5], t[6]];
}

var sn = {};

function or(e) {
  if (!sn[e]) {
    var n = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format( /* @__PURE__ */new Date("2014-06-25T04:00:00.123Z")),
        a = n === "06/25/2014, 00:00:00" || n === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    sn[e] = a ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }

  return sn[e];
}

function En(e, n, a, t, r, l, c) {
  var y = /* @__PURE__ */new Date(0);
  return y.setUTCFullYear(e, n, a), y.setUTCHours(t, r, l, c), y;
}

var Zn = 36e5,
    sr = 6e4,
    un = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};

function Fn(e, n, a) {
  var t, r;
  if (!e || (t = un.timezoneZ.exec(e), t)) return 0;
  var l;
  if (t = un.timezoneHH.exec(e), t) return l = parseInt(t[1], 10), qn(l) ? -(l * Zn) : NaN;

  if (t = un.timezoneHHMM.exec(e), t) {
    l = parseInt(t[1], 10);
    var c = parseInt(t[2], 10);
    return qn(l, c) ? (r = Math.abs(l) * Zn + c * sr, l > 0 ? -r : r) : NaN;
  }

  if (dr(e)) {
    n = new Date(n || Date.now());
    var y = a ? n : ur(n),
        D = Mn(y, e),
        S = a ? D : ir(n, D, e);
    return -S;
  }

  return NaN;
}

function ur(e) {
  return En(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
}

function Mn(e, n) {
  var a = nr(e, n),
      t = En(a[0], a[1] - 1, a[2], a[3] % 24, a[4], a[5], 0).getTime(),
      r = e.getTime(),
      l = r % 1e3;
  return r -= l >= 0 ? l : 1e3 + l, t - r;
}

function ir(e, n, a) {
  var t = e.getTime(),
      r = t - n,
      l = Mn(new Date(r), a);
  if (n === l) return n;
  r -= l - n;
  var c = Mn(new Date(r), a);
  return l === c ? l : Math.max(l, c);
}

function qn(e, n) {
  return -23 <= e && e <= 23 && (n == null || 0 <= n && n <= 59);
}

var Xn = {};

function dr(e) {
  if (Xn[e]) return !0;

  try {
    return new Intl.DateTimeFormat(void 0, {
      timeZone: e
    }), Xn[e] = !0, !0;
  } catch {
    return !1;
  }
}

var wa = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/,
    dn = 36e5,
    Jn = 6e4,
    cr = 2,
    Ye = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [/^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [/^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: wa
};

function $n(e, n) {
  if (arguments.length < 1) throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null) return /* @__PURE__ */new Date(NaN);
  var a = n || {},
      t = a.additionalDigits == null ? cr : er(a.additionalDigits);
  if (t !== 2 && t !== 1 && t !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]") return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]") return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]")) return /* @__PURE__ */new Date(NaN);
  var r = fr(e),
      l = vr(r.date, t),
      c = l.year,
      y = l.restDateString,
      D = mr(y, c);
  if (isNaN(D)) return /* @__PURE__ */new Date(NaN);

  if (D) {
    var S = D.getTime(),
        g = 0,
        Y;
    if (r.time && (g = gr(r.time), isNaN(g))) return /* @__PURE__ */new Date(NaN);

    if (r.timeZone || a.timeZone) {
      if (Y = Fn(r.timeZone || a.timeZone, new Date(S + g)), isNaN(Y)) return /* @__PURE__ */new Date(NaN);
    } else Y = Gn(new Date(S + g)), Y = Gn(new Date(S + g + Y));

    return new Date(S + g + Y);
  } else return /* @__PURE__ */new Date(NaN);
}

function fr(e) {
  var n = {},
      a = Ye.dateTimePattern.exec(e),
      t;

  if (a ? (n.date = a[1], t = a[3]) : (a = Ye.datePattern.exec(e), a ? (n.date = a[1], t = a[2]) : (n.date = null, t = e)), t) {
    var r = Ye.timeZone.exec(t);
    r ? (n.time = t.replace(r[1], ""), n.timeZone = r[1].trim()) : n.time = t;
  }

  return n;
}

function vr(e, n) {
  var a = Ye.YYY[n],
      t = Ye.YYYYY[n],
      r;

  if (r = Ye.YYYY.exec(e) || t.exec(e), r) {
    var l = r[1];
    return {
      year: parseInt(l, 10),
      restDateString: e.slice(l.length)
    };
  }

  if (r = Ye.YY.exec(e) || a.exec(e), r) {
    var c = r[1];
    return {
      year: parseInt(c, 10) * 100,
      restDateString: e.slice(c.length)
    };
  }

  return {
    year: null
  };
}

function mr(e, n) {
  if (n === null) return null;
  var a, t, r, l;
  if (e.length === 0) return t = /* @__PURE__ */new Date(0), t.setUTCFullYear(n), t;
  if (a = Ye.MM.exec(e), a) return t = /* @__PURE__ */new Date(0), r = parseInt(a[1], 10) - 1, Qn(n, r) ? (t.setUTCFullYear(n, r), t) : /* @__PURE__ */new Date(NaN);

  if (a = Ye.DDD.exec(e), a) {
    t = /* @__PURE__ */new Date(0);
    var c = parseInt(a[1], 10);
    return pr(n, c) ? (t.setUTCFullYear(n, 0, c), t) : /* @__PURE__ */new Date(NaN);
  }

  if (a = Ye.MMDD.exec(e), a) {
    t = /* @__PURE__ */new Date(0), r = parseInt(a[1], 10) - 1;
    var y = parseInt(a[2], 10);
    return Qn(n, r, y) ? (t.setUTCFullYear(n, r, y), t) : /* @__PURE__ */new Date(NaN);
  }

  if (a = Ye.Www.exec(e), a) return l = parseInt(a[1], 10) - 1, ea(n, l) ? xn(n, l) : /* @__PURE__ */new Date(NaN);

  if (a = Ye.WwwD.exec(e), a) {
    l = parseInt(a[1], 10) - 1;
    var D = parseInt(a[2], 10) - 1;
    return ea(n, l, D) ? xn(n, l, D) : /* @__PURE__ */new Date(NaN);
  }

  return null;
}

function gr(e) {
  var n, a, t;
  if (n = Ye.HH.exec(e), n) return a = parseFloat(n[1].replace(",", ".")), cn(a) ? a % 24 * dn : NaN;
  if (n = Ye.HHMM.exec(e), n) return a = parseInt(n[1], 10), t = parseFloat(n[2].replace(",", ".")), cn(a, t) ? a % 24 * dn + t * Jn : NaN;

  if (n = Ye.HHMMSS.exec(e), n) {
    a = parseInt(n[1], 10), t = parseInt(n[2], 10);
    var r = parseFloat(n[3].replace(",", "."));
    return cn(a, t, r) ? a % 24 * dn + t * Jn + r * 1e3 : NaN;
  }

  return null;
}

function xn(e, n, a) {
  n = n || 0, a = a || 0;
  var t = /* @__PURE__ */new Date(0);
  t.setUTCFullYear(e, 0, 4);
  var r = t.getUTCDay() || 7,
      l = n * 7 + a + 1 - r;
  return t.setUTCDate(t.getUTCDate() + l), t;
}

var yr = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    hr = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function Da(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}

function Qn(e, n, a) {
  if (n < 0 || n > 11) return !1;

  if (a != null) {
    if (a < 1) return !1;
    var t = Da(e);
    if (t && a > hr[n] || !t && a > yr[n]) return !1;
  }

  return !0;
}

function pr(e, n) {
  if (n < 1) return !1;
  var a = Da(e);
  return !(a && n > 366 || !a && n > 365);
}

function ea(e, n, a) {
  return !(n < 0 || n > 52 || a != null && (a < 0 || a > 6));
}

function cn(e, n, a) {
  return !(e != null && (e < 0 || e >= 25) || n != null && (n < 0 || n >= 60) || a != null && (a < 0 || a >= 60));
}

var Tn = {
  exports: {}
},
    An = {
  exports: {}
};

(function (e, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = a;

  function a(t, r) {
    if (t == null) throw new TypeError("assign requires that input parameter not be null or undefined");

    for (var l in r) Object.prototype.hasOwnProperty.call(r, l) && (t[l] = r[l]);

    return t;
  }

  e.exports = n.default;
})(An, An.exports);

var br = An.exports;

(function (e, n) {
  var a = xa.default;
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = r;
  var t = a(br);

  function r(l) {
    return (0, t.default)({}, l);
  }

  e.exports = n.default;
})(Tn, Tn.exports);

var kr = Tn.exports;
const wr = /* @__PURE__ */Bn(kr);

function Dr(e, n, a) {
  var t = $n(e, a),
      r = Fn(n, t, !0),
      l = new Date(t.getTime() - r),
      c = /* @__PURE__ */new Date(0);
  return c.setFullYear(l.getUTCFullYear(), l.getUTCMonth(), l.getUTCDate()), c.setHours(l.getUTCHours(), l.getUTCMinutes(), l.getUTCSeconds(), l.getUTCMilliseconds()), c;
}

function Mr(e, n, a) {
  if (typeof e == "string" && !e.match(wa)) {
    var t = wr(a);
    return t.timeZone = n, $n(e, t);
  }

  var r = $n(e, a),
      l = En(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()).getTime(),
      c = Fn(n, new Date(l));
  return new Date(l + c);
}

function ta(e) {
  return n => new Intl.DateTimeFormat(e, {
    weekday: "short",
    timeZone: "UTC"
  }).format( /* @__PURE__ */new Date(`2017-01-0${n}T00:00:00+00:00`)).slice(0, 2);
}

function $r(e) {
  return n => format( /* @__PURE__ */new Date(`2017-01-0${n}T00:00:00+00:00`), "EEEEEE", {
    locale: e
  });
}

const Tr = (e, n, a) => {
  const t = [1, 2, 3, 4, 5, 6, 7];
  let r;
  if (e !== null) try {
    r = t.map($r(e));
  } catch {
    r = t.map(ta(n));
  } else r = t.map(ta(n));
  const l = r.slice(0, a),
        c = r.slice(a + 1, r.length);
  return [r[a]].concat(...c).concat(...l);
},
      Vn = (e, n) => {
  const a = [];

  for (let t = +e[0]; t <= +e[1]; t++) a.push({
    value: +t,
    text: `${t}`
  });

  return n ? a.reverse() : a;
},
      Ma = (e, n, a) => {
  const t = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(l => {
    const c = l < 10 ? `0${l}` : l;
    return /* @__PURE__ */new Date(`2017-${c}-01T00:00:00+00:00`);
  });
  if (e !== null) try {
    const l = a === "long" ? "MMMM" : "MMM";
    return t.map((c, y) => {
      const D = format(c, l, {
        locale: e
      });
      return {
        text: D.charAt(0).toUpperCase() + D.substring(1),
        value: y
      };
    });
  } catch {}
  const r = new Intl.DateTimeFormat(n, {
    month: a,
    timeZone: "UTC"
  });
  return t.map((l, c) => {
    const y = r.format(l);
    return {
      text: y.charAt(0).toUpperCase() + y.substring(1),
      value: c
    };
  });
},
      Ar = e => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e],
      Ae = e => {
  const n = Object(external_vue_["unref"])(e);
  return n != null && n.$el ? n == null ? void 0 : n.$el : n;
},
      Sr = e => Object.assign({
  type: "dot"
}, e),
      $a = e => Array.isArray(e) ? !!e[0] && !!e[1] : !1,
      Gt = {
  prop: e => `"${e}" prop must be enabled!`,
  dateArr: e => `You need to use array as "model-value" binding in order to support "${e}"`
},
      $e = e => e,
      na = e => e === 0 ? e : !e || isNaN(+e) ? null : +e,
      aa = e => e === null,
      _r = e => {
  if (e) return [...e.querySelectorAll("input, button, select, textarea, a[href]")][0];
},
      Pr = e => {
  const n = [],
        a = t => t.filter(r => r);

  for (let t = 0; t < e.length; t += 3) {
    const r = [e[t], e[t + 1], e[t + 2]];
    n.push(a(r));
  }

  return n;
},
      Rt = (e, n, a) => {
  const t = a !== null && a !== void 0 ? a : a === 0,
        r = n !== null && n !== void 0 ? n : n === 0;
  if (!t && !r) return !1;
  const l = +a,
        c = +n;
  return t && r ? +e > l || +e < c : t ? +e > l : r ? +e < c : !1;
},
      kt = (e, n) => Pr(e).map(a => a.map(t => {
  const {
    active: r,
    disabled: l,
    isBetween: c
  } = n(t);
  return { ...t,
    active: r,
    disabled: l,
    className: {
      dp__overlay_cell_active: r,
      dp__overlay_cell: !r,
      dp__overlay_cell_disabled: l,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: l && r,
      dp__cell_in_between: c
    }
  };
})),
      tt = (e, n, a = !1) => {
  e && n.allowStopPropagation && (a && e.stopImmediatePropagation(), e.stopPropagation());
},
      ra = (e, n, a, t, r) => {
  const l = parse_parse(e, n.slice(0, e.length), /* @__PURE__ */new Date());
  return isValid(l) && isDate(l) ? t || r ? l : set_set(l, {
    hours: +a.hours,
    minutes: +(a == null ? void 0 : a.minutes),
    seconds: +(a == null ? void 0 : a.seconds),
    milliseconds: 0
  }) : null;
},
      Cr = (e, n, a, t, r) => {
  const l = Array.isArray(a) ? a[0] : a;
  if (typeof n == "string") return ra(e, n, l, t, r);

  if (Array.isArray(n)) {
    let c = null;

    for (const y of n) if (c = ra(e, y, l, t, r), c) break;

    return c;
  }

  return typeof n == "function" ? n(e) : null;
},
      P = e => e ? new Date(e) : /* @__PURE__ */new Date(),
      Rr = (e, n, a) => {
  if (n) {
    const r = (e.getMonth() + 1).toString().padStart(2, "0"),
          l = e.getDate().toString().padStart(2, "0"),
          c = e.getHours().toString().padStart(2, "0"),
          y = e.getMinutes().toString().padStart(2, "0"),
          D = a ? e.getSeconds().toString().padStart(2, "0") : "00";
    return `${e.getFullYear()}-${r}-${l}T${c}:${y}:${D}.000Z`;
  }

  const t = Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate(), e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds());
  return new Date(t).toISOString();
},
      He = e => {
  let n = P(JSON.parse(JSON.stringify(e)));
  return n = setHours(n, 0), n = setMinutes(n, 0), n = setSeconds(n, 0), n = setMilliseconds(n, 0), n;
},
      nt = (e, n, a, t) => {
  let r = e ? P(e) : P();
  return (n || n === 0) && (r = setHours(r, +n)), (a || a === 0) && (r = setMinutes(r, +a)), (t || t === 0) && (r = setSeconds(r, +t)), setMilliseconds(r, 0);
},
      Pe = (e, n) => !e || !n ? !1 : isBefore(He(e), He(n)),
      ge = (e, n) => !e || !n ? !1 : isEqual(He(e), He(n)),
      Re = (e, n) => !e || !n ? !1 : isAfter(He(e), He(n)),
      Hn = (e, n, a) => e != null && e[0] && e != null && e[1] ? Re(a, e[0]) && Pe(a, e[1]) : e != null && e[0] && n ? Re(a, e[0]) && Pe(a, n) || Pe(a, e[0]) && Re(a, n) : !1,
      We = e => {
  const n = set_set(new Date(e), {
    date: 1
  });
  return He(n);
},
      vue_datepicker_fn = (e, n, a) => n && (a || a === 0) ? Object.fromEntries(["hours", "minutes", "seconds"].map(t => t === n ? [t, a] : [t, isNaN(+e[t]) ? void 0 : +e[t]])) : {
  hours: isNaN(+e.hours) ? void 0 : +e.hours,
  minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
  seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
},
      vt = e => ({
  hours: getHours(e),
  minutes: getMinutes(e),
  seconds: getSeconds(e)
}),
      Ta = (e, n) => {
  if (n) {
    const a = getYear(P(n));
    if (a > e) return 12;
    if (a === e) return getMonth(P(n));
  }
},
      Aa = (e, n) => {
  if (n) {
    const a = getYear(P(n));
    return a < e ? -1 : a === e ? getMonth(P(n)) : void 0;
  }
},
      wt = e => {
  if (e) return getYear(P(e));
},
      Ge = (e, n) => n ? Dr(e, n) : e,
      Sa = (e, n) => n ? Mr(e, n) : e,
      la = e => e instanceof Date ? e : parseISO(e),
      _a = (e, n) => {
  const a = Re(e, n) ? n : e,
        t = Re(n, e) ? n : e;
  return eachDayOfInterval({
    start: a,
    end: t
  });
},
      Or = e => {
  const n = addMonths(e, 1);
  return {
    month: getMonth(n),
    year: getYear(n)
  };
},
      jt = (e, n, a) => {
  const t = startOfWeek(Ge(e, n), {
    weekStartsOn: +a
  }),
        r = endOfWeek(Ge(e, n), {
    weekStartsOn: +a
  });
  return [t, r];
},
      Pa = (e, n) => {
  const a = {
    hours: getHours(P()),
    minutes: getMinutes(P()),
    seconds: n ? getSeconds(P()) : 0
  };
  return Object.assign(a, e);
},
      et = (e, n, a) => [set_set(P(e), {
  date: 1
}), set_set(P(), {
  month: n,
  year: a,
  date: 1
})],
      Je = (e, n, a) => {
  let t = e ? P(e) : P();
  return (n || n === 0) && (t = setMonth(t, n)), a && (t = setYear(t, a)), t;
},
      Ca = (e, n, a, t, r) => {
  if (!t || r && !n || !r && !a) return !1;
  const l = r ? addMonths(e, 1) : subMonths(e, 1),
        c = [getMonth(l), getYear(l)];
  return r ? !Yr(...c, n) : !Nr(...c, a);
},
      Nr = (e, n, a) => Pe(...et(a, e, n)) || ge(...et(a, e, n)),
      Yr = (e, n, a) => Re(...et(a, e, n)) || ge(...et(a, e, n)),
      Ra = (e, n, a, t, r, l) => {
  if (typeof n == "function") return n(e);
  const c = a ? {
    locale: a
  } : void 0;
  return Array.isArray(e) ? `${format(e[0], l, c)}${r && !e[1] ? "" : t}${e[1] ? format(e[1], l, c) : ""}` : format(e, l, c);
},
      yt = e => {
  if (e) return null;
  throw new Error(Gt.prop("partial-range"));
},
      Ht = (e, n) => {
  if (n) return e();
  throw new Error(Gt.prop("range"));
},
      Sn = e => Array.isArray(e) ? isValid(e[0]) && (e[1] ? isValid(e[1]) : !0) : e ? isValid(e) : !1,
      Ir = e => set_set(P(), {
  hours: +e.hours || 0,
  minutes: +e.minutes || 0,
  seconds: +e.seconds || 0
}),
      vn = (e, n, a, t) => {
  if (!e) return !0;

  if (t) {
    const r = a === "max" ? isBefore(e, n) : isAfter(e, n),
          l = {
      seconds: 0,
      milliseconds: 0
    };
    return r || isEqual(set_set(e, l), set_set(n, l));
  }

  return a === "max" ? e.getTime() <= n.getTime() : e.getTime() >= n.getTime();
},
      oa = (e, n, a, t, r) => {
  const l = e ? Ir(e) : P(n);
  return Array.isArray(t) ? vn(t[0], l, a, !!n) && vn(t[1], l, a, !!n) && r : vn(t, l, a, !!n) && r;
},
      mn = e => set_set(P(), vt(e)),
      Br = (e, n) => Array.isArray(e) ? e.map(a => P(a)).filter(a => getYear(P(a)) === n).map(a => getMonth(a)) : [],
      At = Object(external_vue_["reactive"])({
  menuFocused: !1,
  shiftKeyInMenu: !1
}),
      Oa = () => {
  const e = t => {
    At.menuFocused = t;
  },
        n = t => {
    At.shiftKeyInMenu !== t && (At.shiftKeyInMenu = t);
  };

  return {
    control: Object(external_vue_["computed"])(() => ({
      shiftKeyInMenu: At.shiftKeyInMenu,
      menuFocused: At.menuFocused
    })),
    setMenuFocused: e,
    setShiftKey: n
  };
},
      ke = Object(external_vue_["reactive"])({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}),
      gn = Object(external_vue_["ref"])(null),
      Ut = Object(external_vue_["ref"])(!1),
      yn = Object(external_vue_["ref"])(!1),
      hn = Object(external_vue_["ref"])(!1),
      pn = Object(external_vue_["ref"])(!1),
      Oe = Object(external_vue_["ref"])(0),
      _e = Object(external_vue_["ref"])(0),
      lt = () => {
  const e = Object(external_vue_["computed"])(() => Ut.value ? [...ke.selectionGrid, ke.actionRow].filter(p => p.length) : yn.value ? [...ke.timePicker[0], ...ke.timePicker[1], pn.value ? [] : [gn.value], ke.actionRow].filter(p => p.length) : hn.value ? [...ke.monthPicker, ke.actionRow] : [ke.monthYear, ...ke.calendar, ke.time, ke.actionRow].filter(p => p.length)),
        n = p => {
    Oe.value = p ? Oe.value + 1 : Oe.value - 1;
    let M = null;
    e.value[_e.value] && (M = e.value[_e.value][Oe.value]), M || (Oe.value = p ? Oe.value - 1 : Oe.value + 1);
  },
        a = p => {
    if (_e.value === 0 && !p || _e.value === e.value.length && p) return;
    _e.value = p ? _e.value + 1 : _e.value - 1, e.value[_e.value] ? e.value[_e.value] && !e.value[_e.value][Oe.value] && Oe.value !== 0 && (Oe.value = e.value[_e.value].length - 1) : _e.value = p ? _e.value - 1 : _e.value + 1;
  },
        t = p => {
    let M = null;
    e.value[_e.value] && (M = e.value[_e.value][Oe.value]), M ? M.focus({
      preventScroll: !Ut.value
    }) : Oe.value = p ? Oe.value - 1 : Oe.value + 1;
  },
        r = () => {
    n(!0), t(!0);
  },
        l = () => {
    n(!1), t(!1);
  },
        c = () => {
    a(!1), t(!0);
  },
        y = () => {
    a(!0), t(!0);
  },
        D = (p, M) => {
    ke[M] = p;
  },
        S = (p, M) => {
    ke[M] = p;
  },
        g = () => {
    Oe.value = 0, _e.value = 0;
  };

  return {
    buildMatrix: D,
    buildMultiLevelMatrix: S,
    setTimePickerBackRef: p => {
      gn.value = p;
    },
    setSelectionGrid: p => {
      Ut.value = p, g(), p || (ke.selectionGrid = []);
    },
    setTimePicker: (p, M = !1) => {
      yn.value = p, pn.value = M, g(), p || (ke.timePicker[0] = [], ke.timePicker[1] = []);
    },
    setTimePickerElements: (p, M = 0) => {
      ke.timePicker[M] = p;
    },
    arrowRight: r,
    arrowLeft: l,
    arrowUp: c,
    arrowDown: y,
    clearArrowNav: () => {
      ke.monthYear = [], ke.calendar = [], ke.time = [], ke.actionRow = [], ke.selectionGrid = [], ke.timePicker[0] = [], ke.timePicker[1] = [], Ut.value = !1, yn.value = !1, pn.value = !1, hn.value = !1, g(), gn.value = null;
    },
    setMonthPicker: p => {
      hn.value = p, g();
    },
    refSets: ke // exposed for testing

  };
},
      sa = e => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...(e !== null && e !== void 0 ? e : {})
}),
      Er = e => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  calendarWrap: "Calendar wrapper",
  calendarDays: "Calendar days",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: n => `Increment ${n}`,
  decrementValue: n => `Decrement ${n}`,
  openTpOverlay: n => `Open ${n} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: () => "",
  ...(e !== null && e !== void 0 ? e : {})
}),
      ua = e => e ? typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2 : 0,
      Fr = e => {
  var _t$count;

  const n = typeof e == "object" && e,
        a = {
    static: !0,
    solo: !1
  };
  if (!e) return { ...a,
    count: ua(!1)
  };
  const t = n ? e : {},
        r = n ? (_t$count = t.count) !== null && _t$count !== void 0 ? _t$count : !0 : e,
        l = ua(r);
  return Object.assign(a, t, {
    count: l
  });
},
      Vr = (e, n, a) => e || (typeof a == "string" ? a : n),
      Hr = e => typeof e == "boolean" ? e ? sa({}) : !1 : sa(e),
      Ur = e => {
  const n = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: !0,
    rangeSeparator: " - "
  };
  return typeof e == "object" ? { ...n,
    ...(e !== null && e !== void 0 ? e : {}),
    enabled: !0
  } : { ...n,
    enabled: e
  };
},
      Lr = e => ({
  months: [],
  years: [],
  times: {
    hours: [],
    minutes: [],
    seconds: []
  },
  ...(e !== null && e !== void 0 ? e : {})
}),
      Wr = e => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...(e !== null && e !== void 0 ? e : {})
}),
      zr = e => {
  const n = {
    input: !1
  };
  return typeof e == "object" ? { ...n,
    ...(e !== null && e !== void 0 ? e : {}),
    enabled: !0
  } : {
    enabled: e,
    ...n
  };
},
      jr = e => ({ ...{
    allowStopPropagation: !0,
    closeOnScroll: !1,
    modeHeight: 255,
    allowPreventDefault: !1,
    closeOnClearValue: !0,
    closeOnAutoApply: !0,
    noSwipe: !1,
    keepActionRow: !1,
    onClickOutside: void 0
  },
  ...(e !== null && e !== void 0 ? e : {})
}),
      Se = e => {
  const n = () => {
    const J = e.enableSeconds ? ":ss" : "";
    return e.is24 ? `HH:mm${J}` : `hh:mm${J} aa`;
  },
        a = () => e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? n() : e.weekPicker ? "MM/dd/yyyy" : e.yearPicker ? "yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${n()}` : "MM/dd/yyyy",
        t = J => Pa(J, e.enableSeconds),
        r = () => e.range ? e.startTime && Array.isArray(e.startTime) ? [t(e.startTime[0]), t(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? t(e.startTime) : null,
        l = Object(external_vue_["computed"])(() => Fr(e.multiCalendars)),
        c = Object(external_vue_["computed"])(() => r()),
        y = Object(external_vue_["computed"])(() => Er(e.ariaLabels)),
        D = Object(external_vue_["computed"])(() => Lr(e.filters)),
        S = Object(external_vue_["computed"])(() => Hr(e.transitions)),
        g = Object(external_vue_["computed"])(() => Wr(e.actionRow)),
        Y = Object(external_vue_["computed"])(() => Vr(e.previewFormat, e.format, a())),
        R = Object(external_vue_["computed"])(() => Ur(e.textInput)),
        G = Object(external_vue_["computed"])(() => zr(e.inline)),
        q = Object(external_vue_["computed"])(() => jr(e.config));

  return {
    defaultedTransitions: S,
    defaultedMultiCalendars: l,
    defaultedStartTime: c,
    defaultedAriaLabels: y,
    defaultedFilters: D,
    defaultedActionRow: g,
    defaultedPreviewFormat: Y,
    defaultedTextInput: R,
    defaultedInline: G,
    defaultedConfig: q,
    getDefaultPattern: a,
    getDefaultStartTime: r
  };
},
      Kr = (e, n, a) => {
  const t = Object(external_vue_["ref"])(),
        {
    defaultedTextInput: r,
    getDefaultPattern: l
  } = Se(n),
        c = Object(external_vue_["ref"])(""),
        y = Object(external_vue_["toRef"])(n, "format");
  Object(external_vue_["watch"])(t, () => {
    e("internal-model-change", t.value);
  }), Object(external_vue_["watch"])(y, () => {
    v();
  });

  const D = s => Sa(s, n.timezone),
        S = s => Ge(s, n.timezone),
        g = (s, u) => Ra(s, n.format, n.formatLocale, r.value.rangeSeparator, n.modelAuto, u !== null && u !== void 0 ? u : l()),
        Y = s => {
    const u = s !== null && s !== void 0 ? s : P();
    return n.modelType ? f(u) : {
      hours: getHours(u),
      minutes: getMinutes(u),
      seconds: n.enableSeconds ? getSeconds(u) : 0
    };
  },
        R = s => n.modelType ? f(s) : {
    month: getMonth(s),
    year: getYear(s)
  },
        G = s => Array.isArray(s) ? Ht(() => [setYear(P(), s[0]), s[1] ? setYear(P(), s[1]) : yt(n.partialRange)], n.range) : setYear(P(), +s),
        q = (s, u) => (typeof s == "string" || typeof s == "number") && n.modelType ? I(s) : u,
        J = s => Array.isArray(s) ? [q(s[0], nt(null, +s[0].hours, +s[0].minutes, s[0].seconds)), q(s[1], nt(null, +s[1].hours, +s[1].minutes, s[1].seconds))] : q(s, nt(null, s.hours, s.minutes, s.seconds)),
        Q = s => Array.isArray(s) ? n.multiDates ? s.map(u => q(u, Je(null, +u.month, +u.year))) : Ht(() => [q(s[0], Je(null, +s[0].month, +s[0].year)), q(s[1], s[1] ? Je(null, +s[1].month, +s[1].year) : yt(n.partialRange))], n.range) : q(s, Je(null, +s.month, +s.year)),
        p = s => {
    if (Array.isArray(s)) return s.map(u => I(u));
    throw new Error(Gt.dateArr("multi-dates"));
  },
        M = s => {
    if (Array.isArray(s)) return [P(s[0]), P(s[1])];
    throw new Error(Gt.dateArr("week-picker"));
  },
        E = s => n.modelAuto ? Array.isArray(s) ? [I(s[0]), I(s[1])] : n.autoApply ? [I(s)] : [I(s), null] : Array.isArray(s) ? Ht(() => [I(s[0]), s[1] ? I(s[1]) : yt(n.partialRange)], n.range) : I(s),
        z = () => {
    Array.isArray(t.value) && n.range && t.value.length === 1 && t.value.push(yt(n.partialRange));
  },
        K = () => {
    const s = t.value;
    return [f(s[0]), s[1] ? f(s[1]) : yt(n.partialRange)];
  },
        _ = () => t.value[1] ? K() : f($e(t.value[0])),
        re = () => (t.value || []).map(s => f(s)),
        x = () => (z(), n.modelAuto ? _() : n.multiDates ? re() : Array.isArray(t.value) ? Ht(() => K(), n.range) : f($e(t.value))),
        L = s => !s || Array.isArray(s) && !s.length ? null : n.timePicker ? J($e(s)) : n.monthPicker ? Q($e(s)) : n.yearPicker ? G($e(s)) : n.multiDates ? p($e(s)) : n.weekPicker ? M($e(s)) : E($e(s)),
        h = s => {
    const u = L(s);
    Sn($e(u)) ? (t.value = $e(u), v()) : (t.value = null, c.value = "");
  },
        T = () => {
    const s = u => format(u, r.value.format);

    return `${s(t.value[0])} ${r.value.rangeSeparator} ${t.value[1] ? s(t.value[1]) : ""}`;
  },
        H = () => a.value && t.value ? Array.isArray(t.value) ? T() : format(t.value, r.value.format) : g(t.value),
        ee = () => t.value ? n.multiDates ? t.value.map(s => g(s)).join("; ") : r.value.enabled && typeof r.value.format == "string" ? H() : g(t.value) : "",
        v = () => {
    !n.format || typeof n.format == "string" || r.value.enabled && typeof r.value.format == "string" ? c.value = ee() : c.value = n.format(t.value);
  },
        I = s => {
    if (n.utc) {
      const u = new Date(s);
      return n.utc === "preserve" ? new Date(u.getTime() + u.getTimezoneOffset() * 6e4) : u;
    }

    return n.modelType ? n.modelType === "date" || n.modelType === "timestamp" ? S(new Date(s)) : n.modelType === "format" && (typeof n.format == "string" || !n.format) ? parse_parse(s, l(), /* @__PURE__ */new Date()) : S(parse_parse(s, n.modelType, /* @__PURE__ */new Date())) : S(new Date(s));
  },
        f = s => s ? n.utc ? Rr(s, n.utc === "preserve", n.enableSeconds) : n.modelType ? n.modelType === "timestamp" ? +D(s) : n.modelType === "format" && (typeof n.format == "string" || !n.format) ? g(D(s)) : g(D(s), n.modelType) : D(s) : "",
        k = (s, u = !1) => {
    if (e("update:model-value", s), n.emitTimezone && u) {
      const C = Array.isArray(s) ? s.map(O => Ge($e(O)), n.emitTimezone) : Ge($e(s), n.emitTimezone);
      e("update:model-timezone-value", C);
    }
  },
        d = s => Array.isArray(t.value) ? n.multiDates ? t.value.map(u => s(u)) : [s(t.value[0]), t.value[1] ? s(t.value[1]) : yt(n.partialRange)] : s($e(t.value)),
        o = s => k($e(d(s)));

  return {
    inputValue: c,
    internalModelValue: t,
    checkBeforeEmit: () => t.value ? n.range ? n.partialRange ? t.value.length >= 1 : t.value.length === 2 : !!t.value : !1,
    parseExternalModelValue: h,
    formatInputValue: v,
    emitModelValue: () => (v(), n.monthPicker ? o(R) : n.timePicker ? o(Y) : n.yearPicker ? o(getYear) : n.weekPicker ? k(t.value, !0) : k(x(), !0))
  };
},
      Gr = (e, n) => {
  const {
    defaultedFilters: a
  } = Se(e),
        {
    validateMonthYearInRange: t
  } = Et(e),
        r = (S, g) => {
    let Y = S;
    return a.value.months.includes(getMonth(Y)) ? (Y = g ? addMonths(S, 1) : subMonths(S, 1), r(Y, g)) : Y;
  },
        l = (S, g) => {
    let Y = S;
    return a.value.years.includes(getYear(Y)) ? (Y = g ? addYears(S, 1) : subYears(S, 1), l(Y, g)) : Y;
  },
        c = (S, g = !1) => {
    const Y = set_set( /* @__PURE__ */new Date(), {
      month: e.month,
      year: e.year
    });
    let R = S ? addMonths(Y, 1) : subMonths(Y, 1);
    e.disableYearSelect && (R = setYear(R, e.year));
    let G = getMonth(R),
        q = getYear(R);
    a.value.months.includes(G) && (R = r(R, S), G = getMonth(R), q = getYear(R)), a.value.years.includes(q) && (R = l(R, S), q = getYear(R)), t(G, q, S, e.preventMinMaxNavigation) && y(G, q, g);
  },
        y = (S, g, Y) => {
    n("update-month-year", {
      month: S,
      year: g,
      fromNav: Y
    });
  },
        D = Object(external_vue_["computed"])(() => S => Ca(set_set( /* @__PURE__ */new Date(), {
    month: e.month,
    year: e.year
  }), e.maxDate, e.minDate, e.preventMinMaxNavigation, S));

  return {
    handleMonthYearChange: c,
    isDisabled: D,
    updateMonthYear: y
  };
};

var ht = /* @__PURE__ */(e => (e.center = "center", e.left = "left", e.right = "right", e))(ht || {}),
    Le = /* @__PURE__ */(e => (e.month = "month", e.year = "year", e))(Le || {}),
    ut = /* @__PURE__ */(e => (e.top = "top", e.bottom = "bottom", e))(ut || {}),
    mt = /* @__PURE__ */(e => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(mt || {}),
    je = /* @__PURE__ */(e => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(je || {});

const Zr = ({
  menuRef: e,
  menuRefInner: n,
  inputRef: a,
  pickerWrapperRef: t,
  inline: r,
  emit: l,
  props: c,
  slots: y
}) => {
  const D = Object(external_vue_["ref"])({}),
        S = Object(external_vue_["ref"])(!1),
        g = Object(external_vue_["ref"])({
    top: "0",
    left: "0"
  }),
        Y = Object(external_vue_["ref"])(!1),
        R = Object(external_vue_["toRef"])(c, "teleportCenter");
  Object(external_vue_["watch"])(R, () => {
    g.value = JSON.parse(JSON.stringify({})), z();
  });

  const G = f => {
    if (c.teleport) {
      const k = f.getBoundingClientRect();
      return {
        left: k.left + window.scrollX,
        top: k.top + window.scrollY
      };
    }

    return {
      top: 0,
      left: 0
    };
  },
        q = (f, k) => {
    g.value.left = `${f + k - D.value.width}px`;
  },
        J = f => {
    g.value.left = `${f}px`;
  },
        Q = (f, k) => {
    c.position === ht.left && J(f), c.position === ht.right && q(f, k), c.position === ht.center && (g.value.left = `${f + k / 2 - D.value.width / 2}px`);
  },
        p = f => {
    const {
      width: k,
      height: d
    } = f.getBoundingClientRect(),
          {
      top: o,
      left: $
    } = c.altPosition ? c.altPosition(f) : G(f);
    return {
      top: +o,
      left: +$,
      width: k,
      height: d
    };
  },
        M = () => {
    g.value.left = "50%", g.value.top = "50%", g.value.transform = "translate(-50%, -50%)", g.value.position = "fixed", delete g.value.opacity;
  },
        E = () => {
    const f = Ae(a),
          {
      top: k,
      left: d,
      transform: o
    } = c.altPosition(f);
    g.value = {
      top: `${k}px`,
      left: `${d}px`,
      transform: o !== null && o !== void 0 ? o : ""
    };
  },
        z = (f = !0) => {
    var k;

    if (!r.value.enabled) {
      if (R.value) return M();
      if (c.altPosition !== null) return E();

      if (f) {
        const d = c.teleport ? (k = n.value) == null ? void 0 : k.$el : e.value;
        d && (D.value = d.getBoundingClientRect()), l("recalculate-position");
      }

      return T();
    }
  },
        K = ({
    inputEl: f,
    left: k,
    width: d
  }) => {
    window.screen.width > 768 && !S.value && Q(k, d), x(f);
  },
        _ = f => {
    const {
      top: k,
      left: d,
      height: o,
      width: $
    } = p(f);
    g.value.top = `${o + k + +c.offset}px`, Y.value = !1, S.value || (g.value.left = `${d + $ / 2 - D.value.width / 2}px`), K({
      inputEl: f,
      left: d,
      width: $
    });
  },
        re = f => {
    const {
      top: k,
      left: d,
      width: o
    } = p(f);
    g.value.top = `${k - +c.offset - D.value.height}px`, Y.value = !0, K({
      inputEl: f,
      left: d,
      width: o
    });
  },
        x = f => {
    if (c.autoPosition) {
      const {
        left: k,
        width: d
      } = p(f),
            {
        left: o,
        right: $
      } = D.value;

      if (!S.value) {
        if (Math.abs(o) !== Math.abs($)) {
          if (o <= 0) return S.value = !0, J(k);
          if ($ >= document.documentElement.clientWidth) return S.value = !0, q(k, d);
        }

        return Q(k, d);
      }
    }
  },
        L = () => {
    const f = Ae(a);

    if (f) {
      const {
        height: k
      } = D.value,
            {
        top: d,
        height: o
      } = f.getBoundingClientRect(),
            X = window.innerHeight - d - o,
            s = d;
      return k <= X ? ut.bottom : k > X && k <= s ? ut.top : X >= s ? ut.bottom : ut.top;
    }

    return ut.bottom;
  },
        h = f => L() === ut.bottom ? _(f) : re(f),
        T = () => {
    const f = Ae(a);
    if (f) return c.autoPosition ? h(f) : _(f);
  },
        H = function (f) {
    if (f) {
      const k = f.scrollHeight > f.clientHeight,
            o = window.getComputedStyle(f).overflowY.indexOf("hidden") !== -1;
      return k && !o;
    }

    return !0;
  },
        ee = function (f) {
    return !f || f === document.body || f.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : H(f) ? f : ee(f.parentNode);
  },
        v = f => {
    if (f) switch (c.position) {
      case ht.left:
        return {
          left: 0,
          transform: "translateX(0)"
        };

      case ht.right:
        return {
          left: `${f.width}px`,
          transform: "translateX(-100%)"
        };

      default:
        return {
          left: `${f.width / 2}px`,
          transform: "translateX(-50%)"
        };
    }
    return {};
  };

  return {
    openOnTop: Y,
    menuStyle: g,
    xCorrect: S,
    setMenuPosition: z,
    getScrollableParent: ee,
    shadowRender: (f, k) => {
      var C, O, A;
      const d = document.createElement("div"),
            o = (C = Ae(a)) == null ? void 0 : C.getBoundingClientRect();
      d.setAttribute("id", "dp--temp-container");
      const $ = (O = t.value) != null && O.clientWidth ? t.value : document.body;
      $.append(d);
      const X = document.getElementById("dp--temp-container"),
            s = v(o),
            u = Object(external_vue_["h"])(f, { ...k,
        shadow: !0,
        style: {
          opacity: 0,
          position: "absolute",
          ...s
        }
      }, Object.fromEntries(Object.keys(y).map(te => [te, y[te]])));
      Object(external_vue_["render"])(u, X), D.value = (A = u.el) == null ? void 0 : A.getBoundingClientRect(), Object(external_vue_["render"])(null, X), $.removeChild(X);
    }
  };
},
      st = [{
  name: "clock-icon",
  use: ["time", "calendar", "shared"]
}, {
  name: "arrow-left",
  use: ["month-year", "calendar", "shared"]
}, {
  name: "arrow-right",
  use: ["month-year", "calendar", "shared"]
}, {
  name: "arrow-up",
  use: ["time", "calendar", "month-year", "shared"]
}, {
  name: "arrow-down",
  use: ["time", "calendar", "month-year", "shared"]
}, {
  name: "calendar-icon",
  use: ["month-year", "time", "calendar", "shared"]
}, {
  name: "day",
  use: ["calendar", "shared"]
}, {
  name: "month-overlay-value",
  use: ["calendar", "month-year", "shared"]
}, {
  name: "year-overlay-value",
  use: ["calendar", "month-year", "shared"]
}, {
  name: "year-overlay",
  use: ["month-year", "shared"]
}, {
  name: "month-overlay",
  use: ["month-year", "shared"]
}, {
  name: "month-overlay-header",
  use: ["month-year", "shared"]
}, {
  name: "year-overlay-header",
  use: ["month-year", "shared"]
}, {
  name: "hours-overlay-value",
  use: ["calendar", "time", "shared"]
}, {
  name: "minutes-overlay-value",
  use: ["calendar", "time", "shared"]
}, {
  name: "seconds-overlay-value",
  use: ["calendar", "time", "shared"]
}, {
  name: "hours",
  use: ["calendar", "time", "shared"]
}, {
  name: "minutes",
  use: ["calendar", "time", "shared"]
}, {
  name: "month",
  use: ["calendar", "month-year", "shared"]
}, {
  name: "year",
  use: ["calendar", "month-year", "shared"]
}, {
  name: "action-buttons",
  use: ["action"]
}, {
  name: "action-preview",
  use: ["action"]
}, {
  name: "calendar-header",
  use: ["calendar", "shared"]
}, {
  name: "marker-tooltip",
  use: ["calendar", "shared"]
}, {
  name: "action-extra",
  use: ["menu"]
}, {
  name: "time-picker-overlay",
  use: ["calendar", "time", "shared"]
}, {
  name: "am-pm-button",
  use: ["calendar", "time", "shared"]
}, {
  name: "left-sidebar",
  use: ["menu"]
}, {
  name: "right-sidebar",
  use: ["menu"]
}, {
  name: "month-year",
  use: ["month-year", "shared"]
}, {
  name: "time-picker",
  use: ["menu", "shared"]
}, {
  name: "action-row",
  use: ["action"]
}, {
  name: "marker",
  use: ["calendar", "shared"]
}],
      qr = [{
  name: "trigger"
}, {
  name: "input-icon"
}, {
  name: "clear-icon"
}, {
  name: "dp-input"
}],
      Xr = {
  all: () => st,
  monthYear: () => st.filter(e => e.use.includes("month-year")),
  input: () => qr,
  timePicker: () => st.filter(e => e.use.includes("time")),
  action: () => st.filter(e => e.use.includes("action")),
  calendar: () => st.filter(e => e.use.includes("calendar")),
  menu: () => st.filter(e => e.use.includes("menu")),
  shared: () => st.filter(e => e.use.includes("shared"))
},
      ze = (e, n, a) => {
  const t = [];
  return Xr[n]().forEach(r => {
    e[r.name] && t.push(r.name);
  }), a != null && a.length && a.forEach(r => {
    r.slot && t.push(r.slot);
  }), t;
},
      Bt = e => {
  const n = Object(external_vue_["computed"])(() => t => e.value ? t ? e.value.open : e.value.close : ""),
        a = Object(external_vue_["computed"])(() => t => e.value ? t ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return {
    transitionName: n,
    showTransition: !!e.value,
    menuTransition: a
  };
},
      Zt = (e, n) => {
  const a = Object(external_vue_["ref"])([{
    month: getMonth(P()),
    year: getYear(P())
  }]),
        t = Object(external_vue_["reactive"])({
    hours: e.range ? [getHours(P()), getHours(P())] : getHours(P()),
    minutes: e.range ? [getMinutes(P()), getMinutes(P())] : getMinutes(P()),
    seconds: e.range ? [0, 0] : 0
  }),
        r = Object(external_vue_["computed"])({
    get: () => e.internalModelValue,
    set: y => {
      !e.readonly && !e.disabled && n("update:internal-model-value", y);
    }
  }),
        l = Object(external_vue_["computed"])(() => y => a.value[y] ? a.value[y].month : 0),
        c = Object(external_vue_["computed"])(() => y => a.value[y] ? a.value[y].year : 0);
  return {
    calendars: a,
    time: t,
    modelValue: r,
    month: l,
    year: c
  };
},
      Jr = (e, n) => {
  const {
    defaultedMultiCalendars: a
  } = Se(n),
        {
    isDisabled: t,
    matchDate: r
  } = Et(n),
        l = Object(external_vue_["ref"])(null),
        c = Object(external_vue_["ref"])(P()),
        y = o => {
    !o.current && n.hideOffsetDates || (l.value = o.value);
  },
        D = () => {
    l.value = null;
  },
        S = o => Array.isArray(e.value) && n.range && e.value[0] && l.value ? o ? Re(l.value, e.value[0]) : Pe(l.value, e.value[0]) : !0,
        g = (o, $) => {
    const X = () => e.value ? $ ? e.value[0] || null : e.value[1] : null,
          s = e.value && Array.isArray(e.value) ? X() : null;

    return ge(P(o.value), s);
  },
        Y = o => {
    var _l$value;

    const $ = Array.isArray(e.value) ? e.value[0] : null;
    return o ? !Pe((_l$value = l.value) !== null && _l$value !== void 0 ? _l$value : null, $) : !0;
  },
        R = (o, $ = !0) => (n.range || n.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? n.hideOffsetDates && !o.current ? !1 : ge(P(o.value), e.value[$ ? 0 : 1]) : n.range ? g(o, $) && Y($) || ge(o.value, Array.isArray(e.value) ? e.value[0] : null) && S($) : !1,
        G = (o, $, X) => Array.isArray(e.value) && e.value[0] && e.value.length === 1 ? o ? !1 : X ? Re(e.value[0], $.value) : Pe(e.value[0], $.value) : !1,
        q = o => !e.value || n.hideOffsetDates && !o.current ? !1 : n.range ? n.modelAuto && Array.isArray(e.value) ? ge(o.value, e.value[0] ? e.value[0] : c.value) : !1 : n.multiDates && Array.isArray(e.value) ? e.value.some($ => ge($, o.value)) : ge(o.value, e.value ? e.value : c.value),
        J = o => {
    if (n.autoRange || n.weekPicker) {
      if (l.value) {
        if (n.hideOffsetDates && !o.current) return !1;
        const $ = addDays(l.value, +n.autoRange),
              X = jt(P(l.value), n.timezone, n.weekStart);
        return n.weekPicker ? ge(X[1], P(o.value)) : ge($, P(o.value));
      }

      return !1;
    }

    return !1;
  },
        Q = o => {
    if (n.autoRange || n.weekPicker) {
      if (l.value) {
        const $ = addDays(l.value, +n.autoRange);
        if (n.hideOffsetDates && !o.current) return !1;
        const X = jt(P(l.value), n.timezone, n.weekStart);
        return n.weekPicker ? Re(o.value, X[0]) && Pe(o.value, X[1]) : Re(o.value, l.value) && Pe(o.value, $);
      }

      return !1;
    }

    return !1;
  },
        p = o => {
    if (n.autoRange || n.weekPicker) {
      if (l.value) {
        if (n.hideOffsetDates && !o.current) return !1;
        const $ = jt(P(l.value), n.timezone, n.weekStart);
        return n.weekPicker ? ge($[0], o.value) : ge(l.value, o.value);
      }

      return !1;
    }

    return !1;
  },
        M = o => Hn(e.value, l.value, o.value),
        E = () => n.modelAuto && Array.isArray(n.internalModelValue) ? !!n.internalModelValue[0] : !1,
        z = () => n.modelAuto ? $a(n.internalModelValue) : !0,
        K = o => {
    if (Array.isArray(e.value) && e.value.length || n.weekPicker) return !1;
    const $ = n.range ? !R(o) && !R(o, !1) : !0;
    return !t(o.value) && !q(o) && !(!o.current && n.hideOffsetDates) && $;
  },
        _ = o => n.range ? n.modelAuto ? E() && q(o) : !1 : q(o),
        re = o => {
    var $;
    return n.highlight ? r(o.value, ($ = n.arrMapValues) != null && $.highlightedDates ? n.arrMapValues.highlightedDates : n.highlight) : !1;
  },
        x = o => t(o.value) && n.highlightDisabledDays === !1,
        L = o => {
    var $;
    return ($ = n.highlightWeekDays) == null ? void 0 : $.includes(o.value.getDay());
  },
        h = o => (n.range || n.weekPicker) && (!(a.value.count > 0) || o.current) && z() && !(!o.current && n.hideOffsetDates) && !q(o) ? M(o) : !1,
        T = o => {
    const {
      isRangeStart: $,
      isRangeEnd: X
    } = v(o),
          s = n.range ? $ || X : !1;
    return {
      dp__cell_offset: !o.current,
      dp__pointer: !n.disabled && !(!o.current && n.hideOffsetDates) && !t(o.value),
      dp__cell_disabled: t(o.value),
      dp__cell_highlight: !x(o) && (re(o) || L(o)) && !_(o) && !s,
      dp__cell_highlight_active: !x(o) && (re(o) || L(o)) && _(o),
      dp__today: !n.noToday && ge(o.value, c.value) && o.current
    };
  },
        H = o => ({
    dp__active_date: _(o),
    dp__date_hover: K(o)
  }),
        ee = o => ({ ...I(o),
    ...f(o),
    dp__range_between_week: h(o) && n.weekPicker
  }),
        v = o => {
    const $ = a.value.count > 0 ? o.current && R(o) && z() : R(o) && z(),
          X = a.value.count > 0 ? o.current && R(o, !1) && z() : R(o, !1) && z();
    return {
      isRangeStart: $,
      isRangeEnd: X
    };
  },
        I = o => {
    const {
      isRangeStart: $,
      isRangeEnd: X
    } = v(o);
    return {
      dp__range_start: $,
      dp__range_end: X,
      dp__range_between: h(o) && !n.weekPicker,
      dp__date_hover_start: G(K(o), o, !0),
      dp__date_hover_end: G(K(o), o, !1)
    };
  },
        f = o => ({ ...I(o),
    dp__cell_auto_range: Q(o),
    dp__cell_auto_range_start: p(o),
    dp__cell_auto_range_end: J(o)
  }),
        k = o => n.range ? n.autoRange ? f(o) : n.modelAuto ? { ...H(o),
    ...I(o)
  } : I(o) : n.weekPicker ? ee(o) : H(o);

  return {
    setHoverDate: y,
    clearHoverDate: D,
    getDayClassData: o => n.hideOffsetDates && !o.current ? {} : { ...T(o),
      ...k(o),
      [n.dayClass ? n.dayClass(o.value) : ""]: !0,
      [n.calendarCellClassName]: !!n.calendarCellClassName
    }
  };
},
      Et = e => {
  const {
    defaultedFilters: n
  } = Se(e),
        a = () => {
    if (e.timezone) return e.timezone;
    if (e.utc) return "UTC";
  },
        t = h => {
    const T = He(r(P(h))).toISOString(),
          [H] = T.split("T");
    return H;
  },
        r = h => e.utc === "preserve" ? Sa(h, a()) : Ge(h, a()),
        l = h => {
    var $;
    const T = e.maxDate ? Re(r(h), r(P(e.maxDate))) : !1,
          H = e.minDate ? Pe(r(h), r(P(e.minDate))) : !1,
          ee = S(r(h), ($ = e.arrMapValues) != null && $.disabledDates ? e.arrMapValues.disabledDates : e.disabledDates),
          I = n.value.months.map(X => +X).includes(getMonth(h)),
          f = e.disabledWeekDays.length ? e.disabledWeekDays.some(X => +X === getDay(h)) : !1,
          k = Y(h),
          d = getYear(h),
          o = d < +e.yearRange[0] || d > +e.yearRange[1];
    return !(T || H || ee || I || o || f || k);
  },
        c = (h, T) => Pe(...et(e.minDate, h, T)) || ge(...et(e.minDate, h, T)),
        y = (h, T) => Re(...et(e.maxDate, h, T)) || ge(...et(e.maxDate, h, T)),
        D = (h, T, H) => {
    let ee = !1;
    return e.maxDate && H && y(h, T) && (ee = !0), e.minDate && !H && c(h, T) && (ee = !0), ee;
  },
        S = (h, T) => h ? T instanceof Map ? !!T.get(t(h)) : Array.isArray(T) ? T.some(H => ge(r(P(H)), r(h))) : T ? T(P(JSON.parse(JSON.stringify(h)))) : !1 : !0,
        g = (h, T, H, ee) => {
    let v = !1;
    return ee ? e.minDate && e.maxDate ? v = D(h, T, H) : (e.minDate && c(h, T) || e.maxDate && y(h, T)) && (v = !0) : v = !0, v;
  },
        Y = h => {
    var T, H, ee, v, I;
    return Array.isArray(e.allowedDates) && !((T = e.allowedDates) != null && T.length) ? !0 : (H = e.arrMapValues) != null && H.allowedDates ? !S(h, (ee = e.arrMapValues) == null ? void 0 : ee.allowedDates) : (v = e.allowedDates) != null && v.length ? !((I = e.allowedDates) != null && I.some(f => ge(r(P(f)), r(h)))) : !1;
  },
        R = h => !l(h),
        G = h => e.noDisabledRange ? !eachDayOfInterval({
    start: h[0],
    end: h[1]
  }).some(H => R(H)) : !0,
        q = (h, T, H = 0) => {
    if (Array.isArray(T) && T[H]) {
      const ee = differenceInCalendarDays(h, T[H]),
            v = _a(T[H], h),
            I = v.length === 1 ? 0 : v.filter(k => R(k)).length,
            f = Math.abs(ee) - I;

      if (e.minRange && e.maxRange) return f >= +e.minRange && f <= +e.maxRange;
      if (e.minRange) return f >= +e.minRange;
      if (e.maxRange) return f <= +e.maxRange;
    }

    return !0;
  },
        J = h => new Map(h.map(T => [t(T), !0])),
        Q = h => Array.isArray(h) && h.length > 0,
        p = () => {
    const h = {
      disabledDates: null,
      allowedDates: null,
      highlightedDates: null
    };
    return Q(e.allowedDates) && (h.allowedDates = J(e.allowedDates)), Q(e.highlight) && (h.highlightedDates = J(e.highlight)), Q(e.disabledDates) && (h.disabledDates = J(e.disabledDates)), h;
  },
        M = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation,
        E = h => Array.isArray(h) ? [h[0] ? mn(h[0]) : null, h[1] ? mn(h[1]) : null] : mn(h),
        z = (h, T, H) => h.find(ee => +ee.hours === getHours(T) && ee.minutes === "*" ? !0 : +ee.minutes === getMinutes(T)) && H,
        K = (h, T, H) => {
    const [ee, v] = h,
          [I, f] = T;
    return !z(ee, I, H) && !z(v, f, H) && H;
  },
        _ = (h, T) => {
    const H = Array.isArray(T) ? T : [T];
    return Array.isArray(e.disabledTimes) ? Array.isArray(e.disabledTimes[0]) ? K(e.disabledTimes, H, h) : !H.some(ee => z(e.disabledTimes, ee, h)) : h;
  },
        re = (h, T) => {
    const H = Array.isArray(T) ? [vt(T[0]), T[1] ? vt(T[1]) : void 0] : vt(T),
          ee = !e.disabledTimes(H);
    return h && ee;
  },
        x = (h, T) => e.disabledTimes ? Array.isArray(e.disabledTimes) ? _(T, h) : re(T, h) : T;

  return {
    isDisabled: R,
    validateDate: l,
    validateMonthYearInRange: g,
    isDateRangeAllowed: G,
    checkMinMaxRange: q,
    matchDate: S,
    mapDatesArrToMap: p,
    isValidTime: h => {
      let T = !0;
      if (!h || M()) return !0;
      const H = !e.minDate && !e.maxDate ? E(h) : h;
      return (e.maxTime || e.maxDate) && (T = oa(e.maxTime, e.maxDate, "max", $e(H), T)), (e.minTime || e.minDate) && (T = oa(e.minTime, e.minDate, "min", $e(H), T)), x(h, T);
    }
  };
},
      qt = () => {
  const e = Object(external_vue_["computed"])(() => (t, r) => t == null ? void 0 : t.includes(r)),
        n = Object(external_vue_["computed"])(() => (t, r) => t.count ? t.solo ? !0 : r === 0 : !0),
        a = Object(external_vue_["computed"])(() => (t, r) => t.count ? t.solo ? !0 : r === t.count - 1 : !0);
  return {
    hideNavigationButtons: e,
    showLeftIcon: n,
    showRightIcon: a
  };
},
      xr = (e, n, a) => {
  const t = Object(external_vue_["ref"])(0),
        r = Object(external_vue_["reactive"])({
    // monthYearInput: !!props.timePicker,
    [mt.timePicker]: !e.enableTimePicker || e.timePicker || e.monthPicker,
    [mt.calendar]: !1,
    [mt.header]: !1
  }),
        l = g => {
    var Y;
    (Y = e.flow) != null && Y.length && (r[g] = !0, Object.keys(r).filter(R => !r[R]).length || S());
  },
        c = () => {
    var g;
    (g = e.flow) != null && g.length && t.value !== -1 && (t.value += 1, n("flow-step", t.value), S());
  },
        y = () => {
    t.value = -1;
  },
        D = (g, Y, ...R) => {
    e.flow[t.value] === g && a.value && a.value[Y](...R);
  },
        S = () => {
    D(je.month, "toggleMonthPicker", !0), D(je.year, "toggleYearPicker", !0), D(je.calendar, "toggleTimePicker", !1, !0), D(je.time, "toggleTimePicker", !0, !0);
    const g = e.flow[t.value];
    (g === je.hours || g === je.minutes || g === je.seconds) && D(g, "toggleTimePicker", !0, !0, g);
  };

  return {
    childMount: l,
    updateFlowStep: c,
    resetFlow: y,
    flowStep: t
  };
},
      Xt = {
  multiCalendars: {
    type: [Boolean, Number, String, Object],
    default: void 0
  },
  modelValue: {
    type: [String, Date, Array, Object, Number],
    default: null
  },
  modelType: {
    type: String,
    default: null
  },
  position: {
    type: String,
    default: "center"
  },
  dark: {
    type: Boolean,
    default: !1
  },
  format: {
    type: [String, Function],
    default: () => null
  },
  closeOnScroll: {
    type: Boolean,
    default: !1
  },
  autoPosition: {
    type: Boolean,
    default: !0
  },
  closeOnAutoApply: {
    type: Boolean,
    default: !0
  },
  altPosition: {
    type: Function,
    default: null
  },
  transitions: {
    type: [Boolean, Object],
    default: !0
  },
  formatLocale: {
    type: Object,
    default: null
  },
  utc: {
    type: [Boolean, String],
    default: !1
  },
  ariaLabels: {
    type: Object,
    default: () => ({})
  },
  offset: {
    type: [Number, String],
    default: 10
  },
  hideNavigation: {
    type: Array,
    default: () => []
  },
  timezone: {
    type: String,
    default: null
  },
  emitTimezone: {
    type: String,
    default: null
  },
  vertical: {
    type: Boolean,
    default: !1
  },
  disableMonthYearSelect: {
    type: Boolean,
    default: !1
  },
  disableYearSelect: {
    type: Boolean,
    default: !1
  },
  menuClassName: {
    type: String,
    default: null
  },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: {
    type: Array,
    default: () => [1900, 2100]
  },
  calendarCellClassName: {
    type: String,
    default: null
  },
  enableTimePicker: {
    type: Boolean,
    default: !0
  },
  autoApply: {
    type: Boolean,
    default: !1
  },
  disabledDates: {
    type: [Array, Function],
    default: () => []
  },
  monthNameFormat: {
    type: String,
    default: "short"
  },
  startDate: {
    type: [Date, String],
    default: null
  },
  startTime: {
    type: [Object, Array],
    default: null
  },
  hideOffsetDates: {
    type: Boolean,
    default: !1
  },
  autoRange: {
    type: [Number, String],
    default: null
  },
  noToday: {
    type: Boolean,
    default: !1
  },
  disabledWeekDays: {
    type: Array,
    default: () => []
  },
  allowedDates: {
    type: Array,
    default: null
  },
  nowButtonLabel: {
    type: String,
    default: "Now"
  },
  markers: {
    type: Array,
    default: () => []
  },
  modeHeight: {
    type: [Number, String],
    default: 255
  },
  escClose: {
    type: Boolean,
    default: !0
  },
  spaceConfirm: {
    type: Boolean,
    default: !0
  },
  monthChangeOnArrows: {
    type: Boolean,
    default: !0
  },
  presetDates: {
    type: Array,
    default: () => []
  },
  flow: {
    type: Array,
    default: () => []
  },
  partialFlow: {
    type: Boolean,
    default: !1
  },
  preventMinMaxNavigation: {
    type: Boolean,
    default: !1
  },
  minRange: {
    type: [Number, String],
    default: null
  },
  maxRange: {
    type: [Number, String],
    default: null
  },
  multiDatesLimit: {
    type: [Number, String],
    default: null
  },
  reverseYears: {
    type: Boolean,
    default: !1
  },
  keepActionRow: {
    type: Boolean,
    default: !1
  },
  weekPicker: {
    type: Boolean,
    default: !1
  },
  filters: {
    type: Object,
    default: () => ({})
  },
  arrowNavigation: {
    type: Boolean,
    default: !1
  },
  disableTimeRangeValidation: {
    type: Boolean,
    default: !1
  },
  highlight: {
    type: [Array, Function],
    default: null
  },
  highlightWeekDays: {
    type: Array,
    default: null
  },
  highlightDisabledDays: {
    type: Boolean,
    default: !1
  },
  teleport: {
    type: [String, Boolean],
    default: null
  },
  teleportCenter: {
    type: Boolean,
    default: !1
  },
  locale: {
    type: String,
    default: "en-Us"
  },
  weekNumName: {
    type: String,
    default: "W"
  },
  weekStart: {
    type: [Number, String],
    default: 1
  },
  weekNumbers: {
    type: [String, Function],
    default: null
  },
  calendarClassName: {
    type: String,
    default: null
  },
  noSwipe: {
    type: Boolean,
    default: !1
  },
  monthChangeOnScroll: {
    type: [Boolean, String],
    default: !0
  },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: {
    type: Boolean,
    default: !1
  },
  customProps: {
    type: Object,
    default: null
  },
  yearPicker: {
    type: Boolean,
    default: !1
  },
  modelAuto: {
    type: Boolean,
    default: !1
  },
  selectText: {
    type: String,
    default: "Select"
  },
  cancelText: {
    type: String,
    default: "Cancel"
  },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: {
    type: Boolean,
    default: !1
  },
  partialRange: {
    type: Boolean,
    default: !0
  },
  ignoreTimeValidation: {
    type: Boolean,
    default: !1
  },
  minDate: {
    type: [Date, String],
    default: null
  },
  maxDate: {
    type: [Date, String],
    default: null
  },
  minTime: {
    type: Object,
    default: null
  },
  maxTime: {
    type: Object,
    default: null
  },
  name: {
    type: String,
    default: null
  },
  placeholder: {
    type: String,
    default: ""
  },
  hideInputIcon: {
    type: Boolean,
    default: !1
  },
  clearable: {
    type: Boolean,
    default: !0
  },
  state: {
    type: Boolean,
    default: null
  },
  required: {
    type: Boolean,
    default: !1
  },
  autocomplete: {
    type: String,
    default: "off"
  },
  inputClassName: {
    type: String,
    default: null
  },
  fixedStart: {
    type: Boolean,
    default: !1
  },
  fixedEnd: {
    type: Boolean,
    default: !1
  },
  timePicker: {
    type: Boolean,
    default: !1
  },
  enableSeconds: {
    type: Boolean,
    default: !1
  },
  is24: {
    type: Boolean,
    default: !0
  },
  noHoursOverlay: {
    type: Boolean,
    default: !1
  },
  noMinutesOverlay: {
    type: Boolean,
    default: !1
  },
  noSecondsOverlay: {
    type: Boolean,
    default: !1
  },
  hoursGridIncrement: {
    type: [String, Number],
    default: 1
  },
  minutesGridIncrement: {
    type: [String, Number],
    default: 5
  },
  secondsGridIncrement: {
    type: [String, Number],
    default: 5
  },
  hoursIncrement: {
    type: [Number, String],
    default: 1
  },
  minutesIncrement: {
    type: [Number, String],
    default: 1
  },
  secondsIncrement: {
    type: [Number, String],
    default: 1
  },
  range: {
    type: Boolean,
    default: !1
  },
  uid: {
    type: String,
    default: null
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  readonly: {
    type: Boolean,
    default: !1
  },
  inline: {
    type: [Boolean, Object],
    default: !1
  },
  textInput: {
    type: [Boolean, Object],
    default: !1
  },
  onClickOutside: {
    type: Function,
    default: null
  },
  noDisabledRange: {
    type: Boolean,
    default: !1
  },
  sixWeeks: {
    type: [Boolean, String],
    default: !1
  },
  actionRow: {
    type: Object,
    default: () => ({})
  },
  allowPreventDefault: {
    type: Boolean,
    default: !1
  },
  closeOnClearValue: {
    type: Boolean,
    default: !0
  },
  focusStartDate: {
    type: Boolean,
    default: !1
  },
  disabledTimes: {
    type: [Function, Array],
    default: void 0
  },
  showLastInRange: {
    type: Boolean,
    default: !0
  },
  timePickerInline: {
    type: Boolean,
    default: !1
  },
  calendar: {
    type: Function,
    default: null
  },
  config: {
    type: Object,
    default: void 0
  }
},
      xe = { ...Xt,
  shadow: {
    type: Boolean,
    default: !1
  },
  flowStep: {
    type: Number,
    default: 0
  },
  internalModelValue: {
    type: [Date, Array],
    default: null
  },
  arrMapValues: {
    type: Object,
    default: () => ({})
  }
},
      Qr = {
  key: 1,
  class: "dp__input_wrap"
},
      vue_datepicker_el = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid", "onKeydown"],
      tl = {
  key: 2,
  class: "dp__clear_icon"
},
      nl = /* @__PURE__ */Object(external_vue_["defineComponent"])({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: {
      type: Boolean,
      default: !1
    },
    inputValue: {
      type: String,
      default: ""
    },
    ...Xt
  },
  emits: ["clear", "open", "update:input-value", "set-input-date", "close", "select-date", "set-empty-date", "toggle", "focus-prev", "focus", "blur", "real-blur"],

  setup(e, {
    expose: n,
    emit: a
  }) {
    const t = e,
          {
      defaultedTextInput: r,
      defaultedAriaLabels: l,
      defaultedInline: c,
      defaultedConfig: y,
      getDefaultPattern: D,
      getDefaultStartTime: S
    } = Se(t),
          g = Object(external_vue_["ref"])(),
          Y = Object(external_vue_["ref"])(null),
          R = Object(external_vue_["ref"])(!1),
          G = Object(external_vue_["ref"])(!1),
          q = Object(external_vue_["computed"])(() => ({
      dp__pointer: !t.disabled && !t.readonly && !r.value.enabled,
      dp__disabled: t.disabled,
      dp__input_readonly: !r.value.enabled,
      dp__input: !0,
      dp__input_icon_pad: !t.hideInputIcon,
      dp__input_valid: !!t.state,
      dp__input_invalid: t.state === !1,
      dp__input_focus: R.value || t.isMenuOpen,
      dp__input_reg: !r.value.enabled,
      [t.inputClassName]: !!t.inputClassName
    })),
          J = () => {
      a("set-input-date", null), t.autoApply && (a("set-empty-date"), g.value = null);
    },
          Q = v => {
      var _r$value$format;

      const I = S();
      return Cr(v, (_r$value$format = r.value.format) !== null && _r$value$format !== void 0 ? _r$value$format : D(), I !== null && I !== void 0 ? I : Pa({}, t.enableSeconds), t.inputValue, G.value);
    },
          p = v => {
      const {
        rangeSeparator: I
      } = r.value,
            [f, k] = v.split(`${I}`);

      if (f) {
        const d = Q(f.trim()),
              o = k ? Q(k.trim()) : null,
              $ = d && o ? [d, o] : [d];
        g.value = d ? $ : null;
      }
    },
          M = () => {
      G.value = !0;
    },
          E = v => {
      if (t.range) p(v);else if (t.multiDates) {
        const I = v.split(";");
        g.value = I.map(f => Q(f.trim())).filter(f => f);
      } else g.value = Q(v);
    },
          z = v => {
      var f;
      const I = typeof v == "string" ? v : (f = v.target) == null ? void 0 : f.value;
      I !== "" ? (r.value.openMenu && !t.isMenuOpen && a("open"), E(I), a("set-input-date", g.value)) : J(), G.value = !1, a("update:input-value", I);
    },
          K = v => {
      r.value.enabled ? (E(v.target.value), r.value.enterSubmit && Sn(g.value) && t.inputValue !== "" ? (a("set-input-date", g.value, !0), g.value = null) : r.value.enterSubmit && t.inputValue === "" && (g.value = null, a("clear"))) : x(v);
    },
          _ = v => {
      r.value.enabled && r.value.tabSubmit && E(v.target.value), r.value.tabSubmit && Sn(g.value) && t.inputValue !== "" ? (a("set-input-date", g.value, !0), g.value = null) : r.value.tabSubmit && t.inputValue === "" && (g.value = null, a("clear"));
    },
          re = () => {
      R.value = !0, a("focus");
    },
          x = v => {
      v.preventDefault(), tt(v, y.value, !0), r.value.enabled && r.value.openMenu && !c.value.input && !t.isMenuOpen ? a("open") : r.value.enabled || a("toggle");
    },
          L = () => {
      a("real-blur"), R.value = !1, (!t.isMenuOpen || c.value.enabled && c.value.input) && a("blur"), t.autoApply && r.value.enabled && g.value && !t.isMenuOpen && (a("set-input-date", g.value), a("select-date"), g.value = null);
    },
          h = v => {
      tt(v, y.value, !0), a("clear");
    },
          T = v => {
      if (!r.value.enabled) {
        if (v.code === "Tab") return;
        v.preventDefault();
      }
    };

    return n({
      focusInput: () => {
        var v;
        (v = Y.value) == null || v.focus({
          preventScroll: !0
        });
      },
      setParsedDate: v => {
        g.value = v;
      }
    }), (v, I) => {
      var f;
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        onClick: x
      }, [v.$slots.trigger && !v.$slots["dp-input"] && !Object(external_vue_["unref"])(c).enabled ? Object(external_vue_["renderSlot"])(v.$slots, "trigger", {
        key: 0
      }) : Object(external_vue_["createCommentVNode"])("", !0), !v.$slots.trigger && (!Object(external_vue_["unref"])(c).enabled || Object(external_vue_["unref"])(c).input) ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", Qr, [v.$slots["dp-input"] && !v.$slots.trigger && !Object(external_vue_["unref"])(c).enabled ? Object(external_vue_["renderSlot"])(v.$slots, "dp-input", {
        key: 0,
        value: e.inputValue,
        isMenuOpen: e.isMenuOpen,
        onInput: z,
        onEnter: K,
        onTab: _,
        onClear: h,
        onBlur: L,
        onKeypress: T,
        onPaste: M
      }) : Object(external_vue_["createCommentVNode"])("", !0), v.$slots["dp-input"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("input", {
        key: 1,
        ref_key: "inputRef",
        ref: Y,
        id: v.uid ? `dp-input-${v.uid}` : void 0,
        name: v.name,
        class: Object(external_vue_["normalizeClass"])(q.value),
        inputmode: Object(external_vue_["unref"])(r).enabled ? "text" : "none",
        placeholder: v.placeholder,
        disabled: v.disabled,
        readonly: v.readonly,
        required: v.required,
        value: e.inputValue,
        autocomplete: v.autocomplete,
        "aria-label": (f = Object(external_vue_["unref"])(l)) == null ? void 0 : f.input,
        "aria-disabled": v.disabled || void 0,
        "aria-invalid": v.state === !1 ? !0 : void 0,
        onInput: z,
        onKeydown: [Object(external_vue_["withKeys"])(K, ["enter"]), Object(external_vue_["withKeys"])(_, ["tab"]), T],
        onBlur: L,
        onFocus: re,
        onKeypress: T,
        onPaste: M
      }, null, 42, vue_datepicker_el)), Object(external_vue_["createElementVNode"])("div", {
        onClick: I[2] || (I[2] = k => a("toggle"))
      }, [v.$slots["input-icon"] && !v.hideInputIcon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", {
        key: 0,
        class: "dp__input_icon",
        onClick: I[0] || (I[0] = k => a("toggle"))
      }, [Object(external_vue_["renderSlot"])(v.$slots, "input-icon")])) : Object(external_vue_["createCommentVNode"])("", !0), !v.$slots["input-icon"] && !v.hideInputIcon && !v.$slots["dp-input"] ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["unref"])(It), {
        key: 1,
        onClick: I[1] || (I[1] = k => a("toggle")),
        class: "dp__input_icon dp__input_icons"
      })) : Object(external_vue_["createCommentVNode"])("", !0)]), v.$slots["clear-icon"] && e.inputValue && v.clearable && !v.disabled && !v.readonly ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", tl, [Object(external_vue_["renderSlot"])(v.$slots, "clear-icon", {
        clear: h
      })])) : Object(external_vue_["createCommentVNode"])("", !0), v.clearable && !v.$slots["clear-icon"] && e.inputValue && !v.disabled && !v.readonly ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["unref"])(ba), {
        key: 3,
        class: "dp__clear_icon dp__input_icons",
        onClick: I[3] || (I[3] = Object(external_vue_["withModifiers"])(k => h(k), ["prevent"]))
      })) : Object(external_vue_["createCommentVNode"])("", !0)])) : Object(external_vue_["createCommentVNode"])("", !0)]);
    };
  }

}),
      al = ["title"],
      rl = {
  class: "dp__action_buttons"
},
      ll = ["onKeydown", "disabled"],
      ol = /* @__PURE__ */Object(external_vue_["defineComponent"])({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: {
      type: Boolean,
      default: !1
    },
    calendarWidth: {
      type: Number,
      default: 0
    },
    ...xe
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],

  setup(e, {
    emit: n
  }) {
    const a = e,
          {
      defaultedActionRow: t,
      defaultedPreviewFormat: r,
      defaultedMultiCalendars: l,
      defaultedTextInput: c,
      defaultedInline: y,
      getDefaultPattern: D
    } = Se(a),
          {
      isValidTime: S
    } = Et(a),
          {
      buildMatrix: g
    } = lt(),
          Y = Object(external_vue_["ref"])(null),
          R = Object(external_vue_["ref"])(null);
    Object(external_vue_["onMounted"])(() => {
      a.arrowNavigation && g([Ae(Y), Ae(R)], "actionRow");
    });

    const G = Object(external_vue_["computed"])(() => a.range && !a.partialRange && a.internalModelValue ? a.internalModelValue.length === 2 : !0),
          q = Object(external_vue_["computed"])(() => !J.value || !Q.value || !G.value),
          J = Object(external_vue_["computed"])(() => !a.enableTimePicker || a.ignoreTimeValidation ? !0 : S(a.internalModelValue)),
          Q = Object(external_vue_["computed"])(() => a.monthPicker ? a.range && Array.isArray(a.internalModelValue) ? !a.internalModelValue.filter(h => !re(h)).length : re(a.internalModelValue) : !0),
          p = () => {
      const L = r.value;
      return a.timePicker || a.monthPicker, L($e(a.internalModelValue));
    },
          M = () => {
      const L = a.internalModelValue;
      return l.value.count > 0 ? `${E(L[0])} - ${E(L[1])}` : [E(L[0]), E(L[1])];
    },
          E = L => Ra(L, r.value, a.formatLocale, c.value.rangeSeparator, a.modelAuto, D()),
          z = Object(external_vue_["computed"])(() => !a.internalModelValue || !a.menuMount ? "" : typeof r.value == "string" ? Array.isArray(a.internalModelValue) ? a.internalModelValue.length === 2 && a.internalModelValue[1] ? M() : a.multiDates ? a.internalModelValue.map(L => `${E(L)}`) : a.modelAuto ? `${E(a.internalModelValue[0])}` : `${E(a.internalModelValue[0])} -` : E(a.internalModelValue) : p()),
          K = () => a.multiDates ? "; " : " - ",
          _ = Object(external_vue_["computed"])(() => Array.isArray(z.value) ? z.value.join(K()) : z.value),
          re = L => {
      if (!a.monthPicker) return !0;
      let h = !0;
      const T = P(We(L));

      if (a.minDate && a.maxDate) {
        const H = P(We(a.minDate)),
              ee = P(We(a.maxDate));
        return Re(T, H) && Pe(T, ee) || ge(T, H) || ge(T, ee);
      }

      if (a.minDate) {
        const H = P(We(a.minDate));
        h = Re(T, H) || ge(T, H);
      }

      if (a.maxDate) {
        const H = P(We(a.maxDate));
        h = Pe(T, H) || ge(T, H);
      }

      return h;
    },
          x = () => {
      J.value && Q.value && G.value ? n("select-date") : n("invalid-select");
    };

    return (L, h) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
      class: "dp__action_row",
      style: Object(external_vue_["normalizeStyle"])(e.calendarWidth ? {
        width: `${e.calendarWidth}px`
      } : {})
    }, [L.$slots["action-row"] ? Object(external_vue_["renderSlot"])(L.$slots, "action-row", Object(external_vue_["normalizeProps"])(Object(external_vue_["mergeProps"])({
      key: 0
    }, {
      internalModelValue: L.internalModelValue,
      disabled: q.value,
      selectDate: () => L.$emit("select-date"),
      closePicker: () => L.$emit("close-picker")
    }))) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
      key: 1
    }, [Object(external_vue_["unref"])(t).showPreview ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
      key: 0,
      class: "dp__selection_preview",
      title: _.value
    }, [L.$slots["action-preview"] ? Object(external_vue_["renderSlot"])(L.$slots, "action-preview", {
      key: 0,
      value: L.internalModelValue
    }) : Object(external_vue_["createCommentVNode"])("", !0), L.$slots["action-preview"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
      key: 1
    }, [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(_.value), 1)], 64))], 8, al)) : Object(external_vue_["createCommentVNode"])("", !0), Object(external_vue_["createElementVNode"])("div", rl, [L.$slots["action-buttons"] ? Object(external_vue_["renderSlot"])(L.$slots, "action-buttons", {
      key: 0,
      value: L.internalModelValue
    }) : Object(external_vue_["createCommentVNode"])("", !0), L.$slots["action-buttons"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
      key: 1
    }, [!Object(external_vue_["unref"])(y).enabled && Object(external_vue_["unref"])(t).showCancel ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", {
      key: 0,
      type: "button",
      ref_key: "cancelButtonRef",
      ref: Y,
      class: "dp__action_button dp__action_cancel",
      onClick: h[0] || (h[0] = T => L.$emit("close-picker")),
      onKeydown: [h[1] || (h[1] = Object(external_vue_["withKeys"])(T => L.$emit("close-picker"), ["enter"])), h[2] || (h[2] = Object(external_vue_["withKeys"])(T => L.$emit("close-picker"), ["space"]))]
    }, Object(external_vue_["toDisplayString"])(L.cancelText), 545)) : Object(external_vue_["createCommentVNode"])("", !0), Object(external_vue_["unref"])(t).showNow ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", {
      key: 1,
      type: "button",
      ref_key: "cancelButtonRef",
      ref: Y,
      class: "dp__action_button dp__action_cancel",
      onClick: h[3] || (h[3] = T => L.$emit("select-now")),
      onKeydown: [h[4] || (h[4] = Object(external_vue_["withKeys"])(T => L.$emit("select-now"), ["enter"])), h[5] || (h[5] = Object(external_vue_["withKeys"])(T => L.$emit("select-now"), ["space"]))]
    }, Object(external_vue_["toDisplayString"])(L.nowButtonLabel), 545)) : Object(external_vue_["createCommentVNode"])("", !0), Object(external_vue_["unref"])(t).showSelect ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", {
      key: 2,
      type: "button",
      class: "dp__action_button dp__action_select",
      onKeydown: [Object(external_vue_["withKeys"])(x, ["enter"]), Object(external_vue_["withKeys"])(x, ["space"])],
      onClick: x,
      disabled: q.value,
      ref_key: "selectButtonRef",
      ref: R
    }, Object(external_vue_["toDisplayString"])(L.selectText), 41, ll)) : Object(external_vue_["createCommentVNode"])("", !0)], 64))])], 64))], 4));
  }

}),
      sl = ["onKeydown"],
      ul = {
  class: "dp__selection_grid_header"
},
      il = ["aria-selected", "aria-disabled", "onClick", "onKeydown", "onMouseover"],
      dl = ["aria-label", "onKeydown"],
      Ot = /* @__PURE__ */Object(external_vue_["defineComponent"])({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: {
      type: Boolean
    },
    arrowNavigation: {
      type: Boolean
    },
    skipButtonRef: {
      type: Boolean
    },
    headerRefs: {},
    hideNavigation: {},
    escClose: {
      type: Boolean
    },
    useRelative: {
      type: Boolean
    },
    height: {},
    textInput: {
      type: [Boolean, Object]
    },
    config: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],

  setup(e, {
    expose: n,
    emit: a
  }) {
    const t = e,
          {
      setSelectionGrid: r,
      buildMultiLevelMatrix: l,
      setMonthPicker: c
    } = lt(),
          {
      defaultedAriaLabels: y,
      defaultedTextInput: D,
      defaultedConfig: S
    } = Se(t),
          {
      hideNavigationButtons: g
    } = qt(),
          Y = Object(external_vue_["ref"])(!1),
          R = Object(external_vue_["ref"])(null),
          G = Object(external_vue_["ref"])(null),
          q = Object(external_vue_["ref"])([]),
          J = Object(external_vue_["ref"])(),
          Q = Object(external_vue_["ref"])(null),
          p = Object(external_vue_["ref"])(0),
          M = Object(external_vue_["ref"])(null);
    Object(external_vue_["onBeforeUpdate"])(() => {
      R.value = null;
    }), Object(external_vue_["onMounted"])(() => {
      Object(external_vue_["nextTick"])().then(() => h()), z(), E(!0);
    }), Object(external_vue_["onUnmounted"])(() => E(!1));

    const E = d => {
      var o;
      t.arrowNavigation && ((o = t.headerRefs) != null && o.length ? c(d) : r(d));
    },
          z = () => {
      var o;
      const d = Ae(G);
      d && (D.value.enabled || (R.value ? (o = R.value) == null || o.focus({
        preventScroll: !0
      }) : d.focus({
        preventScroll: !0
      })), Y.value = d.clientHeight < d.scrollHeight);
    },
          K = Object(external_vue_["computed"])(() => ({
      dp__overlay: !0,
      "dp--overlay-absolute": !t.useRelative,
      "dp--overlay-relative": t.useRelative
    })),
          _ = Object(external_vue_["computed"])(() => t.useRelative ? {
      height: `${t.height}px`,
      width: "260px"
    } : void 0),
          re = Object(external_vue_["computed"])(() => ({
      dp__overlay_col: !0
    })),
          x = Object(external_vue_["computed"])(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__overlay_action: !0,
      dp__over_action_scroll: Y.value,
      dp__button_bottom: t.isLast
    })),
          L = Object(external_vue_["computed"])(() => {
      var d, o;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((d = t.items) == null ? void 0 : d.length) <= 6,
        dp__container_block: ((o = t.items) == null ? void 0 : o.length) > 6
      };
    }),
          h = () => {
      Object(external_vue_["nextTick"])().then(() => {
        const d = Ae(R),
              o = Ae(G),
              $ = Ae(Q),
              X = Ae(M),
              s = $ ? $.getBoundingClientRect().height : 0;
        o && (p.value = o.getBoundingClientRect().height - s), d && X && (X.scrollTop = d.offsetTop - X.offsetTop - (p.value / 2 - d.getBoundingClientRect().height) - s);
      });
    },
          T = d => {
      d.disabled || a("selected", d.value);
    },
          H = () => {
      a("toggle"), a("reset-flow");
    },
          ee = () => {
      t.escClose && H();
    },
          v = (d, o, $, X) => {
      d && (o.active && (R.value = d), t.arrowNavigation && (Array.isArray(q.value[$]) ? q.value[$][X] = d : q.value[$] = [d], I()));
    },
          I = () => {
      var o, $;
      const d = (o = t.headerRefs) != null && o.length ? [t.headerRefs].concat(q.value) : q.value.concat([t.skipButtonRef ? [] : [Q.value]]);
      l($e(d), ($ = t.headerRefs) != null && $.length ? "monthPicker" : "selectionGrid");
    },
          f = d => {
      t.arrowNavigation || tt(d, S.value, !0);
    },
          k = d => {
      J.value = d, a("hover-value", d);
    };

    return n({
      focusGrid: z
    }), (d, o) => {
      var $;
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        ref_key: "gridWrapRef",
        ref: G,
        class: Object(external_vue_["normalizeClass"])(K.value),
        style: Object(external_vue_["normalizeStyle"])(_.value),
        role: "dialog",
        tabindex: "0",
        onKeydown: [Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(ee, ["prevent"]), ["esc"]), o[0] || (o[0] = Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(X => f(X), ["prevent"]), ["left"])), o[1] || (o[1] = Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(X => f(X), ["prevent"]), ["up"])), o[2] || (o[2] = Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(X => f(X), ["prevent"]), ["down"])), o[3] || (o[3] = Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(X => f(X), ["prevent"]), ["right"]))]
      }, [Object(external_vue_["createElementVNode"])("div", {
        class: Object(external_vue_["normalizeClass"])(L.value),
        ref_key: "containerRef",
        ref: M,
        role: "grid",
        style: Object(external_vue_["normalizeStyle"])({
          height: `${p.value}px`
        })
      }, [Object(external_vue_["createElementVNode"])("div", ul, [Object(external_vue_["renderSlot"])(d.$slots, "header")]), d.$slots.overlay ? Object(external_vue_["renderSlot"])(d.$slots, "overlay", {
        key: 0
      }) : (Object(external_vue_["openBlock"])(!0), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
        key: 1
      }, Object(external_vue_["renderList"])(d.items, (X, s) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        class: Object(external_vue_["normalizeClass"])(["dp__overlay_row", {
          dp__flex_row: d.items.length >= 3
        }]),
        key: s,
        role: "row"
      }, [(Object(external_vue_["openBlock"])(!0), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(X, (u, C) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        role: "gridcell",
        class: Object(external_vue_["normalizeClass"])(re.value),
        key: u.value,
        "aria-selected": u.active,
        "aria-disabled": u.disabled || void 0,
        ref_for: !0,
        ref: O => v(O, u, s, C),
        tabindex: "0",
        onClick: O => T(u),
        onKeydown: [Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(O => T(u), ["prevent"]), ["enter"]), Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(O => T(u), ["prevent"]), ["space"])],
        onMouseover: O => k(u.value)
      }, [Object(external_vue_["createElementVNode"])("div", {
        class: Object(external_vue_["normalizeClass"])(u.className)
      }, [d.$slots.item ? Object(external_vue_["renderSlot"])(d.$slots, "item", {
        key: 0,
        item: u
      }) : Object(external_vue_["createCommentVNode"])("", !0), d.$slots.item ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
        key: 1
      }, [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(u.text), 1)], 64))], 2)], 42, il))), 128))], 2))), 128))], 6), d.$slots["button-icon"] ? Object(external_vue_["withDirectives"])((Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", {
        key: 0,
        type: "button",
        "aria-label": ($ = Object(external_vue_["unref"])(y)) == null ? void 0 : $.toggleOverlay,
        class: Object(external_vue_["normalizeClass"])(x.value),
        tabindex: "0",
        ref_key: "toggleButton",
        ref: Q,
        onClick: H,
        onKeydown: [Object(external_vue_["withKeys"])(H, ["enter"]), Object(external_vue_["withKeys"])(H, ["tab"])]
      }, [Object(external_vue_["renderSlot"])(d.$slots, "button-icon")], 42, dl)), [[external_vue_["vShow"], !Object(external_vue_["unref"])(g)(d.hideNavigation, d.type)]]) : Object(external_vue_["createCommentVNode"])("", !0)], 46, sl);
    };
  }

}),
      Un = /* @__PURE__ */Object(external_vue_["defineComponent"])({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: {
      type: Boolean
    }
  },

  setup(e) {
    const n = e,
          a = Object(external_vue_["computed"])(() => n.multiCalendars > 0 ? [...Array(n.multiCalendars).keys()] : [0]),
          t = Object(external_vue_["computed"])(() => ({
      dp__instance_calendar: n.multiCalendars > 0
    }));
    return (r, l) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
      class: Object(external_vue_["normalizeClass"])({
        dp__menu_inner: !r.stretch,
        "dp--menu--inner-stretched": r.stretch,
        dp__flex_display: r.multiCalendars > 0
      })
    }, [(Object(external_vue_["openBlock"])(!0), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(a.value, (c, y) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
      key: c,
      class: Object(external_vue_["normalizeClass"])(t.value)
    }, [Object(external_vue_["renderSlot"])(r.$slots, "default", {
      instance: c,
      index: y
    })], 2))), 128))], 2));
  }

}),
      cl = ["aria-label", "aria-disabled"],
      St = /* @__PURE__ */Object(external_vue_["defineComponent"])({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    disabled: {
      type: Boolean
    }
  },
  emits: ["activate", "set-ref"],

  setup(e, {
    emit: n
  }) {
    const a = Object(external_vue_["ref"])(null);
    return Object(external_vue_["onMounted"])(() => n("set-ref", a)), (t, r) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", {
      type: "button",
      class: "dp__btn dp--arrow-btn-nav",
      onClick: r[0] || (r[0] = l => t.$emit("activate")),
      onKeydown: [r[1] || (r[1] = Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(l => t.$emit("activate"), ["prevent"]), ["enter"])), r[2] || (r[2] = Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(l => t.$emit("activate"), ["prevent"]), ["space"]))],
      tabindex: "0",
      "aria-label": t.ariaLabel,
      "aria-disabled": t.disabled || void 0,
      ref_key: "elRef",
      ref: a
    }, [Object(external_vue_["createElementVNode"])("span", {
      class: Object(external_vue_["normalizeClass"])(["dp__inner_nav", {
        dp__inner_nav_disabled: t.disabled
      }])
    }, [Object(external_vue_["renderSlot"])(t.$slots, "default")], 2)], 40, cl));
  }

}),
      Ln = (e, n, a) => {
  if (n.value && Array.isArray(n.value)) {
    if (n.value.some(t => ge(e, t))) {
      const t = n.value.filter(r => !ge(r, e));
      n.value = t.length ? t : null;
    } else (a && +a > n.value.length || !a) && n.value.push(e);
  } else n.value = [e];
},
      Na = (e, n, a) => {
  let t = e.value ? e.value.slice() : [];
  return t.length === 2 && t[1] !== null && (t = []), t.length ? Pe(n, t[0]) ? (t.unshift(n), a("range-start", t[0]), a("range-start", t[1])) : (t[1] = n, a("range-end", n)) : (t = [n], a("range-start", n)), e.value = t, t;
},
      Wn = (e, n, a, t) => {
  e[0] && e[1] && a && n("auto-apply"), e[0] && !e[1] && t && a && n("auto-apply");
},
      fl = (e, n) => {
  const {
    defaultedMultiCalendars: a,
    defaultedAriaLabels: t,
    defaultedTransitions: r,
    defaultedConfig: l
  } = Se(e),
        {
    modelValue: c,
    year: y,
    month: D,
    calendars: S
  } = Zt(e, n),
        g = Object(external_vue_["computed"])(() => Ma(e.formatLocale, e.locale, e.monthNameFormat)),
        Y = Object(external_vue_["computed"])(() => Vn(e.yearRange, e.reverseYears)),
        R = Object(external_vue_["ref"])(null),
        G = () => {
    for (let f = 0; f < a.value.count; f++) if (f === 0) S.value[f] = S.value[0];else {
      const k = set_set(P(), S.value[f - 1]);
      S.value[f] = {
        month: getMonth(k),
        year: getYear(addYears(k, f))
      };
    }
  },
        q = f => {
    if (!f) return G();
    const k = set_set(P(), S.value[f]);
    return S.value[0].year = getYear(subYears(k, a.value.count - 1)), G();
  },
        J = f => e.focusStartDate ? f[0] : f[1] ? f[1] : f[0],
        Q = () => {
    if (c.value) {
      const f = Array.isArray(c.value) ? J(c.value) : c.value;
      S.value[0] = {
        month: getMonth(f),
        year: getYear(f)
      };
    }
  };

  Object(external_vue_["onMounted"])(() => {
    Q(), a.value.count && G();
  });

  const p = Object(external_vue_["computed"])(() => (f, k) => {
    const d = set_set(We( /* @__PURE__ */new Date()), {
      month: D.value(f),
      year: y.value(f)
    });
    return Ca(d, e.maxDate, e.minDate, e.preventMinMaxNavigation, k);
  }),
        M = f => f ? {
    month: getMonth(f),
    year: getYear(f)
  } : {
    month: null,
    year: null
  },
        E = () => c.value ? Array.isArray(c.value) ? c.value.map(f => M(f)) : M(c.value) : M(),
        z = (f, k) => {
    const d = S.value[f],
          o = E();
    return Array.isArray(o) ? o.some($ => $.year === (d == null ? void 0 : d.year) && $.month === k) : (d == null ? void 0 : d.year) === o.year && k === o.month;
  },
        K = (f, k, d) => {
    var $, X;
    const o = E();
    return Array.isArray(o) ? y.value(k) === (($ = o[d]) == null ? void 0 : $.year) && f === ((X = o[d]) == null ? void 0 : X.month) : !1;
  },
        _ = (f, k) => {
    if (e.range) {
      const d = E();

      if (Array.isArray(c.value) && Array.isArray(d)) {
        const o = K(f, k, 0) || K(f, k, 1),
              $ = Je(We(P()), f, y.value(k));
        return Hn(c.value, R.value, $) && !o;
      }

      return !1;
    }

    return !1;
  },
        re = Object(external_vue_["computed"])(() => f => kt(g.value, k => {
    const d = z(f, k.value),
          o = Rt(k.value, Ta(y.value(f), e.minDate), Aa(y.value(f), e.maxDate)) || Br(e.disabledDates, y.value(f)).includes(k.value),
          $ = _(k.value, f);

    return {
      active: d,
      disabled: o,
      isBetween: $
    };
  })),
        x = Object(external_vue_["computed"])(() => f => kt(Y.value, k => {
    const d = y.value(f) === k.value,
          o = Rt(k.value, wt(e.minDate), wt(e.maxDate));
    return {
      active: d,
      disabled: o
    };
  })),
        L = (f, k) => Je(We(P()), f, y.value(k)),
        h = (f, k) => {
    const d = c.value ? c.value : We( /* @__PURE__ */new Date());
    c.value = Je(d, f, y.value(k)), n("auto-apply");
  },
        T = (f, k) => {
    const d = Na(c, L(f, k), n);
    Wn(d, n, e.autoApply, e.modelAuto);
  },
        H = (f, k) => {
    Ln(L(f, k), c, e.multiDatesLimit), n("auto-apply", !0);
  };

  return {
    groupedMonths: re,
    groupedYears: x,
    year: y,
    isDisabled: p,
    defaultedMultiCalendars: a,
    defaultedAriaLabels: t,
    defaultedTransitions: r,
    defaultedConfig: l,
    setHoverDate: (f, k) => {
      R.value = L(f, k);
    },
    selectMonth: (f, k) => (S.value[k].month = f, e.multiDates ? H(f, k) : e.range ? T(f, k) : h(f, k)),
    selectYear: (f, k) => {
      S.value[k].year = f, a.value.count && !a.value.solo && q(k);
    }
  };
},
      vl = {
  class: "dp__month_picker_header"
},
      ml = ["aria-label", "onClick", "onKeydown"],
      gl = /* @__PURE__ */Object(external_vue_["defineComponent"])({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: { ...xe
  },
  emits: ["update:internal-model-value", "overlay-closed", "reset-flow", "range-start", "range-end", "auto-apply"],

  setup(e, {
    emit: n
  }) {
    const a = e,
          {
      groupedMonths: t,
      groupedYears: r,
      year: l,
      isDisabled: c,
      defaultedMultiCalendars: y,
      defaultedAriaLabels: D,
      defaultedTransitions: S,
      defaultedConfig: g,
      setHoverDate: Y,
      selectMonth: R,
      selectYear: G
    } = fl(a, n),
          {
      transitionName: q,
      showTransition: J
    } = Bt(S),
          {
      showRightIcon: Q,
      showLeftIcon: p
    } = qt(),
          M = Object(external_vue_["ref"])([!1]),
          E = (_, re) => {
      G(_, re), K(re);
    },
          z = (_, re = !1) => {
      if (!c.value(_, re)) {
        const x = re ? l.value(_) + 1 : l.value(_) - 1;
        G(x, _);
      }
    },
          K = (_, re = !1, x) => {
      re || n("reset-flow"), x !== void 0 ? M.value[_] = x : M.value[_] = !M.value[_], M.value || n("overlay-closed");
    };

    return (_, re) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Un, {
      "multi-calendars": Object(external_vue_["unref"])(y).count,
      stretch: ""
    }, {
      default: Object(external_vue_["withCtx"])(({
        instance: x
      }) => [_.$slots["month-year"] ? Object(external_vue_["renderSlot"])(_.$slots, "month-year", Object(external_vue_["normalizeProps"])(Object(external_vue_["mergeProps"])({
        key: 0
      }, {
        year: Object(external_vue_["unref"])(l),
        months: Object(external_vue_["unref"])(t)(x),
        years: Object(external_vue_["unref"])(r)(x),
        selectMonth: Object(external_vue_["unref"])(R),
        selectYear: Object(external_vue_["unref"])(G),
        instance: x
      }))) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Ot, {
        key: 1,
        items: Object(external_vue_["unref"])(t)(x),
        "arrow-navigation": _.arrowNavigation,
        "is-last": _.autoApply && !_.keepActionRow && !Object(external_vue_["unref"])(g).keepActionRow,
        "esc-close": _.escClose,
        height: _.modeHeight !== 255 ? _.modeHeight : Object(external_vue_["unref"])(g).modeHeight,
        config: _.config,
        onSelected: L => Object(external_vue_["unref"])(R)(L, x),
        onHoverValue: L => Object(external_vue_["unref"])(Y)(L, x),
        "use-relative": "",
        type: "month"
      }, {
        header: Object(external_vue_["withCtx"])(() => {
          var L, h, T;
          return [Object(external_vue_["createElementVNode"])("div", vl, [Object(external_vue_["unref"])(p)(Object(external_vue_["unref"])(y), x) ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(St, {
            key: 0,
            ref: "mpPrevIconRef",
            "aria-label": (L = Object(external_vue_["unref"])(D)) == null ? void 0 : L.prevYear,
            disabled: Object(external_vue_["unref"])(c)(x, !1),
            onActivate: H => z(x, !1)
          }, {
            default: Object(external_vue_["withCtx"])(() => [_.$slots["arrow-left"] ? Object(external_vue_["renderSlot"])(_.$slots, "arrow-left", {
              key: 0
            }) : Object(external_vue_["createCommentVNode"])("", !0), _.$slots["arrow-left"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["unref"])(Rn), {
              key: 1
            }))]),
            _: 2
          }, 1032, ["aria-label", "disabled", "onActivate"])) : Object(external_vue_["createCommentVNode"])("", !0), Object(external_vue_["createElementVNode"])("div", {
            class: "dp--year-select",
            role: "button",
            ref: "mpYearButtonRef",
            "aria-label": (h = Object(external_vue_["unref"])(D)) == null ? void 0 : h.openYearsOverlay,
            tabindex: "0",
            onClick: () => K(x, !1),
            onKeydown: Object(external_vue_["withKeys"])(() => K(x, !1), ["enter"])
          }, [_.$slots.year ? Object(external_vue_["renderSlot"])(_.$slots, "year", {
            key: 0,
            year: Object(external_vue_["unref"])(l)(x)
          }) : Object(external_vue_["createCommentVNode"])("", !0), _.$slots.year ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
            key: 1
          }, [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(Object(external_vue_["unref"])(l)(x)), 1)], 64))], 40, ml), Object(external_vue_["unref"])(Q)(Object(external_vue_["unref"])(y), x) ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(St, {
            key: 1,
            ref: "mpNextIconRef",
            "aria-label": (T = Object(external_vue_["unref"])(D)) == null ? void 0 : T.nextYear,
            disabled: Object(external_vue_["unref"])(c)(x, !1),
            onActivate: H => z(x, !0)
          }, {
            default: Object(external_vue_["withCtx"])(() => [_.$slots["arrow-right"] ? Object(external_vue_["renderSlot"])(_.$slots, "arrow-right", {
              key: 0
            }) : Object(external_vue_["createCommentVNode"])("", !0), _.$slots["arrow-right"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["unref"])(On), {
              key: 1
            }))]),
            _: 2
          }, 1032, ["aria-label", "disabled", "onActivate"])) : Object(external_vue_["createCommentVNode"])("", !0), Object(external_vue_["createVNode"])(external_vue_["Transition"], {
            name: Object(external_vue_["unref"])(q)(M.value[x]),
            css: Object(external_vue_["unref"])(J)
          }, {
            default: Object(external_vue_["withCtx"])(() => [M.value[x] ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Ot, {
              key: 0,
              items: Object(external_vue_["unref"])(r)(x),
              "text-input": _.textInput,
              "esc-close": _.escClose,
              config: _.config,
              onToggle: H => K(x),
              onSelected: H => E(H, x),
              "is-last": _.autoApply && !_.keepActionRow && !Object(external_vue_["unref"])(g).keepActionRow,
              type: "year"
            }, Object(external_vue_["createSlots"])({
              "button-icon": Object(external_vue_["withCtx"])(() => [_.$slots["calendar-icon"] ? Object(external_vue_["renderSlot"])(_.$slots, "calendar-icon", {
                key: 0
              }) : Object(external_vue_["createCommentVNode"])("", !0), _.$slots["calendar-icon"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["unref"])(It), {
                key: 1
              }))]),
              _: 2
            }, [_.$slots["year-overlay-value"] ? {
              name: "item",
              fn: Object(external_vue_["withCtx"])(({
                item: H
              }) => [Object(external_vue_["renderSlot"])(_.$slots, "year-overlay-value", {
                text: H.text,
                value: H.value
              })]),
              key: "0"
            } : void 0]), 1032, ["items", "text-input", "esc-close", "config", "onToggle", "onSelected", "is-last"])) : Object(external_vue_["createCommentVNode"])("", !0)]),
            _: 2
          }, 1032, ["name", "css"])])];
        }),
        _: 2
      }, 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "onSelected", "onHoverValue"]))]),
      _: 3
    }, 8, ["multi-calendars"]));
  }

}),
      yl = (e, n) => {
  const {
    modelValue: a
  } = Zt(e, n),
        t = Object(external_vue_["ref"])(null),
        r = g => Array.isArray(a.value) ? a.value.some(Y => getYear(Y) === g) : a.value ? getYear(a.value) === g : !1,
        l = g => e.range && Array.isArray(a.value) ? Hn(a.value, t.value, y(g)) : !1,
        c = Object(external_vue_["computed"])(() => kt(Vn(e.yearRange, e.reverseYears), g => {
    const Y = r(g.value),
          R = Rt(g.value, wt(e.minDate), wt(e.maxDate)),
          G = l(g.value);
    return {
      active: Y,
      disabled: R,
      isBetween: G
    };
  })),
        y = g => setYear(We( /* @__PURE__ */new Date()), g);

  return {
    groupedYears: c,
    setHoverValue: g => {
      t.value = setYear(We( /* @__PURE__ */new Date()), g);
    },
    selectYear: g => {
      if (e.multiDates) return Ln(y(g), a, e.multiDatesLimit), n("auto-apply", !0);

      if (e.range) {
        const Y = Na(a, y(g), n);
        return Wn(Y, n, e.autoApply, e.modelAuto);
      }

      a.value = y(g), n("auto-apply");
    }
  };
},
      hl = /* @__PURE__ */Object(external_vue_["defineComponent"])({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: { ...xe
  },
  emits: ["update:internal-model-value", "reset-flow", "range-start", "range-end", "auto-apply"],

  setup(e, {
    emit: n
  }) {
    const a = e,
          {
      groupedYears: t,
      selectYear: r,
      setHoverValue: l
    } = yl(a, n),
          {
      defaultedConfig: c
    } = Se(a);
    return (y, D) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", null, [y.$slots["month-year"] ? Object(external_vue_["renderSlot"])(y.$slots, "month-year", Object(external_vue_["normalizeProps"])(Object(external_vue_["mergeProps"])({
      key: 0
    }, {
      years: Object(external_vue_["unref"])(t),
      selectYear: Object(external_vue_["unref"])(r)
    }))) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Ot, {
      key: 1,
      items: Object(external_vue_["unref"])(t),
      "is-last": y.autoApply && !y.keepActionRow && !Object(external_vue_["unref"])(c).keepActionRow,
      height: y.modeHeight !== 255 ? y.modeHeight : Object(external_vue_["unref"])(c).modeHeight,
      config: y.config,
      type: "year",
      "use-relative": "",
      onSelected: Object(external_vue_["unref"])(r),
      onHoverValue: Object(external_vue_["unref"])(l)
    }, Object(external_vue_["createSlots"])({
      _: 2
    }, [y.$slots["year-overlay-value"] ? {
      name: "item",
      fn: Object(external_vue_["withCtx"])(({
        item: S
      }) => [Object(external_vue_["renderSlot"])(y.$slots, "year-overlay-value", {
        text: S.text,
        value: S.value
      })]),
      key: "0"
    } : void 0]), 1032, ["items", "is-last", "height", "config", "onSelected", "onHoverValue"]))]));
  }

}),
      pl = {
  key: 0,
  class: "dp__time_input"
},
      bl = ["aria-label", "onKeydown", "onClick"],
      kl = /* @__PURE__ */Object(external_vue_["createElementVNode"])("span", {
  class: "dp__tp_inline_btn_bar dp__tp_btn_in_l"
}, null, -1),
      wl = /* @__PURE__ */Object(external_vue_["createElementVNode"])("span", {
  class: "dp__tp_inline_btn_bar dp__tp_btn_in_r"
}, null, -1),
      Dl = ["aria-label", "disabled", "onKeydown", "onClick"],
      Ml = ["aria-label", "onKeydown", "onClick"],
      $l = /* @__PURE__ */Object(external_vue_["createElementVNode"])("span", {
  class: "dp__tp_inline_btn_bar dp__tp_btn_in_l"
}, null, -1),
      Tl = /* @__PURE__ */Object(external_vue_["createElementVNode"])("span", {
  class: "dp__tp_inline_btn_bar dp__tp_btn_in_r"
}, null, -1),
      Al = {
  key: 0
},
      Sl = ["aria-label", "onKeydown"],
      _l = /* @__PURE__ */Object(external_vue_["defineComponent"])({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: {
      type: Number,
      default: 0
    },
    minutes: {
      type: Number,
      default: 0
    },
    seconds: {
      type: Number,
      default: 0
    },
    closeTimePickerBtn: {
      type: Object,
      default: null
    },
    order: {
      type: Number,
      default: 0
    },
    disabledTimesConfig: {
      type: Function,
      default: null
    },
    ...xe
  },
  emits: ["set-hours", "set-minutes", "update:hours", "update:minutes", "update:seconds", "reset-flow", "mounted", "overlay-closed", "am-pm-change"],

  setup(e, {
    expose: n,
    emit: a
  }) {
    const t = e,
          {
      setTimePickerElements: r,
      setTimePickerBackRef: l
    } = lt(),
          {
      defaultedAriaLabels: c,
      defaultedTransitions: y,
      defaultedFilters: D,
      defaultedConfig: S
    } = Se(t),
          {
      transitionName: g,
      showTransition: Y
    } = Bt(y),
          R = Object(external_vue_["reactive"])({
      hours: !1,
      minutes: !1,
      seconds: !1
    }),
          G = Object(external_vue_["ref"])("AM"),
          q = Object(external_vue_["ref"])(null),
          J = Object(external_vue_["ref"])([]);
    Object(external_vue_["onMounted"])(() => {
      a("mounted");
    });

    const Q = u => set_set( /* @__PURE__ */new Date(), {
      hours: u.hours,
      minutes: u.minutes,
      seconds: t.enableSeconds ? u.seconds : 0,
      milliseconds: 0
    }),
          p = Object(external_vue_["computed"])(() => u => T(u, t[u])),
          M = Object(external_vue_["computed"])(() => ({
      hours: t.hours,
      minutes: t.minutes,
      seconds: t.seconds
    })),
          E = Object(external_vue_["computed"])(() => u => !ee(+t[u] + +t[`${u}Increment`], u)),
          z = Object(external_vue_["computed"])(() => u => !ee(+t[u] - +t[`${u}Increment`], u)),
          K = (u, C) => add(set_set(P(), u), C),
          _ = (u, C) => sub(set_set(P(), u), C),
          re = Object(external_vue_["computed"])(() => ({
      dp__time_col: !0,
      dp__time_col_block: !t.timePickerInline,
      dp__time_col_reg_block: !t.enableSeconds && t.is24 && !t.timePickerInline,
      dp__time_col_reg_inline: !t.enableSeconds && t.is24 && t.timePickerInline,
      dp__time_col_reg_with_button: !t.enableSeconds && !t.is24,
      dp__time_col_sec: t.enableSeconds && t.is24,
      dp__time_col_sec_with_button: t.enableSeconds && !t.is24
    })),
          x = Object(external_vue_["computed"])(() => {
      const u = [{
        type: "hours"
      }, {
        type: "",
        separator: !0
      }, {
        type: "minutes"
      }];
      return t.enableSeconds ? u.concat([{
        type: "",
        separator: !0
      }, {
        type: "seconds"
      }]) : u;
    }),
          L = Object(external_vue_["computed"])(() => x.value.filter(u => !u.separator)),
          h = Object(external_vue_["computed"])(() => u => {
      if (u === "hours") {
        const C = d(+t.hours);
        return {
          text: C < 10 ? `0${C}` : `${C}`,
          value: C
        };
      }

      return {
        text: t[u] < 10 ? `0${t[u]}` : `${t[u]}`,
        value: t[u]
      };
    }),
          T = (u, C) => {
      var A;
      if (!t.disabledTimesConfig) return !1;
      const O = t.disabledTimesConfig(t.order, u === "hours" ? C : void 0);
      return O[u] ? !!((A = O[u]) != null && A.includes(C)) : !0;
    },
          H = u => {
      const C = t.is24 ? 24 : 12,
            O = u === "hours" ? C : 60,
            A = +t[`${u}GridIncrement`],
            te = u === "hours" && !t.is24 ? A : 0,
            B = [];

      for (let ie = te; ie < O; ie += A) B.push({
        value: ie,
        text: ie < 10 ? `0${ie}` : `${ie}`
      });

      return u === "hours" && !t.is24 && B.push({
        value: 0,
        text: "12"
      }), kt(B, ie => ({
        active: !1,
        disabled: D.value.times[u].includes(ie.value) || !ee(ie.value, u) || T(u, ie.value)
      }));
    },
          ee = (u, C) => {
      const O = t.minTime ? Q(vue_datepicker_fn(t.minTime)) : null,
            A = t.maxTime ? Q(vue_datepicker_fn(t.maxTime)) : null,
            te = Q(vue_datepicker_fn(M.value, C, u));
      return O && A ? (isBefore(te, A) || isEqual(te, A)) && (isAfter(te, O) || isEqual(te, O)) : O ? isAfter(te, O) || isEqual(te, O) : A ? isBefore(te, A) || isEqual(te, A) : !0;
    },
          v = u => t[`no${u[0].toUpperCase() + u.slice(1)}Overlay`],
          I = u => {
      v(u) || (R[u] = !R[u], R[u] || a("overlay-closed"));
    },
          f = u => u === "hours" ? getHours : u === "minutes" ? getMinutes : getSeconds,
          k = (u, C = !0) => {
      const O = C ? K : _,
            A = C ? +t[`${u}Increment`] : -+t[`${u}Increment`];
      ee(+t[u] + A, u) && a(`update:${u}`, f(u)(O({
        [u]: +t[u]
      }, {
        [u]: +t[`${u}Increment`]
      })));
    },
          d = u => t.is24 ? u : (u >= 12 ? G.value = "PM" : G.value = "AM", Ar(u)),
          o = () => {
      G.value === "PM" ? (G.value = "AM", a("update:hours", t.hours - 12)) : (G.value = "PM", a("update:hours", t.hours + 12)), a("am-pm-change", G.value);
    },
          $ = u => {
      R[u] = !0;
    },
          X = (u, C, O) => {
      if (u && t.arrowNavigation) {
        Array.isArray(J.value[C]) ? J.value[C][O] = u : J.value[C] = [u];
        const A = J.value.reduce((te, B) => B.map((ie, he) => [...(te[he] || []), B[he]]), []);
        l(t.closeTimePickerBtn), q.value && (A[1] = A[1].concat(q.value)), r(A, t.order);
      }
    },
          s = (u, C) => (I(u), u === "hours" && !t.is24 ? a(`update:${u}`, G.value === "PM" ? C + 12 : C) : a(`update:${u}`, C));

    return n({
      openChildCmp: $
    }), (u, C) => {
      var O;
      return u.disabled ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", pl, [(Object(external_vue_["openBlock"])(!0), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(x.value, (A, te) => {
        var B, ie, he;
        return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
          key: te,
          class: Object(external_vue_["normalizeClass"])(re.value)
        }, [A.separator ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
          key: 0
        }, [Object(external_vue_["createTextVNode"])(" : ")], 64)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
          key: 1
        }, [Object(external_vue_["createElementVNode"])("button", {
          type: "button",
          class: Object(external_vue_["normalizeClass"])({
            dp__btn: !0,
            dp__inc_dec_button: !t.timePickerInline,
            dp__inc_dec_button_inline: t.timePickerInline,
            dp__tp_inline_btn_top: t.timePickerInline,
            dp__inc_dec_button_disabled: E.value(A.type)
          }),
          "aria-label": (B = Object(external_vue_["unref"])(c)) == null ? void 0 : B.incrementValue(A.type),
          tabindex: "0",
          onKeydown: [Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(me => k(A.type), ["prevent"]), ["enter"]), Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(me => k(A.type), ["prevent"]), ["space"])],
          onClick: me => k(A.type),
          ref_for: !0,
          ref: me => X(me, te, 0)
        }, [t.timePickerInline ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
          key: 1
        }, [kl, wl], 64)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
          key: 0
        }, [u.$slots["arrow-up"] ? Object(external_vue_["renderSlot"])(u.$slots, "arrow-up", {
          key: 0
        }) : Object(external_vue_["createCommentVNode"])("", !0), u.$slots["arrow-up"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["unref"])(Yn), {
          key: 1
        }))], 64))], 42, bl), Object(external_vue_["createElementVNode"])("button", {
          type: "button",
          "aria-label": (ie = Object(external_vue_["unref"])(c)) == null ? void 0 : ie.openTpOverlay(A.type),
          class: Object(external_vue_["normalizeClass"])({
            dp__time_display: !0,
            dp__time_display_block: !t.timePickerInline,
            dp__time_display_inline: t.timePickerInline,
            "dp--time-invalid": p.value(A.type),
            "dp--time-overlay-btn": !p.value(A.type)
          }),
          disabled: v(A.type),
          tabindex: "0",
          onKeydown: [Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(me => I(A.type), ["prevent"]), ["enter"]), Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(me => I(A.type), ["prevent"]), ["space"])],
          onClick: me => I(A.type),
          ref_for: !0,
          ref: me => X(me, te, 1)
        }, [u.$slots[A.type] ? Object(external_vue_["renderSlot"])(u.$slots, A.type, {
          key: 0,
          text: h.value(A.type).text,
          value: h.value(A.type).value
        }) : Object(external_vue_["createCommentVNode"])("", !0), u.$slots[A.type] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
          key: 1
        }, [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(h.value(A.type).text), 1)], 64))], 42, Dl), Object(external_vue_["createElementVNode"])("button", {
          type: "button",
          class: Object(external_vue_["normalizeClass"])({
            dp__btn: !0,
            dp__inc_dec_button: !t.timePickerInline,
            dp__inc_dec_button_inline: t.timePickerInline,
            dp__tp_inline_btn_bottom: t.timePickerInline,
            dp__inc_dec_button_disabled: z.value(A.type)
          }),
          "aria-label": (he = Object(external_vue_["unref"])(c)) == null ? void 0 : he.decrementValue(A.type),
          tabindex: "0",
          onKeydown: [Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(me => k(A.type, !1), ["prevent"]), ["enter"]), Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(me => k(A.type, !1), ["prevent"]), ["space"])],
          onClick: me => k(A.type, !1),
          ref_for: !0,
          ref: me => X(me, te, 2)
        }, [t.timePickerInline ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
          key: 1
        }, [$l, Tl], 64)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
          key: 0
        }, [u.$slots["arrow-down"] ? Object(external_vue_["renderSlot"])(u.$slots, "arrow-down", {
          key: 0
        }) : Object(external_vue_["createCommentVNode"])("", !0), u.$slots["arrow-down"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["unref"])(In), {
          key: 1
        }))], 64))], 42, Ml)], 64))], 2);
      }), 128)), u.is24 ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", Al, [u.$slots["am-pm-button"] ? Object(external_vue_["renderSlot"])(u.$slots, "am-pm-button", {
        key: 0,
        toggle: o,
        value: G.value
      }) : Object(external_vue_["createCommentVNode"])("", !0), u.$slots["am-pm-button"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", {
        key: 1,
        ref_key: "amPmButton",
        ref: q,
        type: "button",
        class: "dp__pm_am_button",
        role: "button",
        "aria-label": (O = Object(external_vue_["unref"])(c)) == null ? void 0 : O.amPmButton,
        tabindex: "0",
        onClick: o,
        onKeydown: [Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(o, ["prevent"]), ["enter"]), Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(o, ["prevent"]), ["space"])]
      }, Object(external_vue_["toDisplayString"])(G.value), 41, Sl))])), (Object(external_vue_["openBlock"])(!0), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(L.value, (A, te) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(external_vue_["Transition"], {
        key: te,
        name: Object(external_vue_["unref"])(g)(R[A.type]),
        css: Object(external_vue_["unref"])(Y)
      }, {
        default: Object(external_vue_["withCtx"])(() => [R[A.type] ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Ot, {
          key: 0,
          items: H(A.type),
          "is-last": u.autoApply && !u.keepActionRow && !Object(external_vue_["unref"])(S).keepActionRow,
          "esc-close": u.escClose,
          type: A.type,
          "text-input": u.textInput,
          config: u.config,
          "arrow-navigation": u.arrowNavigation,
          onSelected: B => s(A.type, B),
          onToggle: B => I(A.type),
          onResetFlow: C[0] || (C[0] = B => u.$emit("reset-flow"))
        }, Object(external_vue_["createSlots"])({
          "button-icon": Object(external_vue_["withCtx"])(() => [u.$slots["clock-icon"] ? Object(external_vue_["renderSlot"])(u.$slots, "clock-icon", {
            key: 0
          }) : Object(external_vue_["createCommentVNode"])("", !0), u.$slots["clock-icon"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["unref"])(Nn), {
            key: 1
          }))]),
          _: 2
        }, [u.$slots[`${A.type}-overlay-value`] ? {
          name: "item",
          fn: Object(external_vue_["withCtx"])(({
            item: B
          }) => [Object(external_vue_["renderSlot"])(u.$slots, `${A.type}-overlay-value`, {
            text: B.text,
            value: B.value
          })]),
          key: "0"
        } : void 0]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "onSelected", "onToggle"])) : Object(external_vue_["createCommentVNode"])("", !0)]),
        _: 2
      }, 1032, ["name", "css"]))), 128))]));
    };
  }

}),
      Pl = ["aria-label"],
      Cl = ["tabindex"],
      Rl = ["aria-label"],
      Ya = /* @__PURE__ */Object(external_vue_["defineComponent"])({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: {
      type: [Number, Array],
      default: 0
    },
    minutes: {
      type: [Number, Array],
      default: 0
    },
    seconds: {
      type: [Number, Array],
      default: 0
    },
    disabledTimesConfig: {
      type: Function,
      default: null
    },
    ...xe
  },
  emits: ["update:hours", "update:minutes", "update:seconds", "mount", "reset-flow", "overlay-opened", "overlay-closed", "am-pm-change"],

  setup(e, {
    expose: n,
    emit: a
  }) {
    const t = e,
          {
      buildMatrix: r,
      setTimePicker: l
    } = lt(),
          c = Object(external_vue_["useSlots"])(),
          {
      defaultedTransitions: y,
      defaultedAriaLabels: D,
      defaultedTextInput: S,
      defaultedConfig: g
    } = Se(t),
          {
      transitionName: Y,
      showTransition: R
    } = Bt(y),
          {
      hideNavigationButtons: G
    } = qt(),
          q = Object(external_vue_["ref"])(null),
          J = Object(external_vue_["ref"])(null),
          Q = Object(external_vue_["ref"])([]),
          p = Object(external_vue_["ref"])(null);
    Object(external_vue_["onMounted"])(() => {
      a("mount"), !t.timePicker && t.arrowNavigation ? r([Ae(q.value)], "time") : l(!0, t.timePicker);
    });

    const M = Object(external_vue_["computed"])(() => t.range && t.modelAuto ? $a(t.internalModelValue) : !0),
          E = Object(external_vue_["ref"])(!1),
          z = v => ({
      hours: Array.isArray(t.hours) ? t.hours[v] : t.hours,
      minutes: Array.isArray(t.minutes) ? t.minutes[v] : t.minutes,
      seconds: Array.isArray(t.seconds) ? t.seconds[v] : t.seconds
    }),
          K = Object(external_vue_["computed"])(() => {
      const v = [];
      if (t.range) for (let I = 0; I < 2; I++) v.push(z(I));else v.push(z(0));
      return v;
    }),
          _ = (v, I = !1, f = "") => {
      I || a("reset-flow"), E.value = v, a(v ? "overlay-opened" : "overlay-closed"), t.arrowNavigation && l(v), Object(external_vue_["nextTick"])(() => {
        f !== "" && Q.value[0] && Q.value[0].openChildCmp(f);
      });
    },
          re = Object(external_vue_["computed"])(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: t.autoApply && !t.keepActionRow && !g.value.keepActionRow
    })),
          x = ze(c, "timePicker"),
          L = (v, I, f) => t.range ? I === 0 ? [v, K.value[1][f]] : [K.value[0][f], v] : v,
          h = v => {
      a("update:hours", v);
    },
          T = v => {
      a("update:minutes", v);
    },
          H = v => {
      a("update:seconds", v);
    },
          ee = () => {
      if (p.value && !S.value.enabled) {
        const v = _r(p.value);

        v && v.focus({
          preventScroll: !0
        });
      }
    };

    return n({
      toggleTimePicker: _
    }), (v, I) => {
      var f;
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", null, [!v.timePicker && !v.timePickerInline ? Object(external_vue_["withDirectives"])((Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", {
        key: 0,
        type: "button",
        class: Object(external_vue_["normalizeClass"])(re.value),
        "aria-label": (f = Object(external_vue_["unref"])(D)) == null ? void 0 : f.openTimePicker,
        tabindex: "0",
        ref_key: "openTimePickerBtn",
        ref: q,
        onKeydown: [I[0] || (I[0] = Object(external_vue_["withKeys"])(k => _(!0), ["enter"])), I[1] || (I[1] = Object(external_vue_["withKeys"])(k => _(!0), ["space"]))],
        onClick: I[2] || (I[2] = k => _(!0))
      }, [v.$slots["clock-icon"] ? Object(external_vue_["renderSlot"])(v.$slots, "clock-icon", {
        key: 0
      }) : Object(external_vue_["createCommentVNode"])("", !0), v.$slots["clock-icon"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["unref"])(Nn), {
        key: 1
      }))], 42, Pl)), [[external_vue_["vShow"], !Object(external_vue_["unref"])(G)(v.hideNavigation, "time")]]) : Object(external_vue_["createCommentVNode"])("", !0), Object(external_vue_["createVNode"])(external_vue_["Transition"], {
        name: Object(external_vue_["unref"])(Y)(E.value),
        css: Object(external_vue_["unref"])(R) && !v.timePickerInline
      }, {
        default: Object(external_vue_["withCtx"])(() => {
          var k;
          return [E.value || v.timePicker || v.timePickerInline ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
            key: 0,
            class: Object(external_vue_["normalizeClass"])({
              dp__overlay: !v.timePickerInline,
              "dp--overlay-absolute": !t.timePicker && !v.timePickerInline,
              "dp--overlay-relative": t.timePicker
            }),
            style: Object(external_vue_["normalizeStyle"])(v.timePicker ? {
              height: `${v.modeHeight !== 255 ? v.modeHeight : Object(external_vue_["unref"])(g).modeHeight}px`
            } : void 0),
            ref_key: "overlayRef",
            ref: p,
            tabindex: v.timePickerInline ? void 0 : 0
          }, [Object(external_vue_["createElementVNode"])("div", {
            class: Object(external_vue_["normalizeClass"])(v.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"),
            style: {
              display: "flex"
            }
          }, [v.$slots["time-picker-overlay"] ? Object(external_vue_["renderSlot"])(v.$slots, "time-picker-overlay", {
            key: 0,
            hours: e.hours,
            minutes: e.minutes,
            seconds: e.seconds,
            setHours: h,
            setMinutes: T,
            setSeconds: H
          }) : Object(external_vue_["createCommentVNode"])("", !0), v.$slots["time-picker-overlay"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
            key: 1,
            class: Object(external_vue_["normalizeClass"])(v.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
          }, [(Object(external_vue_["openBlock"])(!0), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(K.value, (d, o) => Object(external_vue_["withDirectives"])((Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_l, Object(external_vue_["mergeProps"])({
            key: o
          }, { ...v.$props,
            order: o,
            hours: d.hours,
            minutes: d.minutes,
            seconds: d.seconds,
            closeTimePickerBtn: J.value,
            disabledTimesConfig: e.disabledTimesConfig,
            disabled: o === 0 ? v.fixedStart : v.fixedEnd
          }, {
            ref_for: !0,
            ref_key: "timeInputRefs",
            ref: Q,
            "onUpdate:hours": $ => h(L($, o, "hours")),
            "onUpdate:minutes": $ => T(L($, o, "minutes")),
            "onUpdate:seconds": $ => H(L($, o, "seconds")),
            onMounted: ee,
            onOverlayClosed: ee,
            onAmPmChange: I[3] || (I[3] = $ => v.$emit("am-pm-change", $))
          }), Object(external_vue_["createSlots"])({
            _: 2
          }, [Object(external_vue_["renderList"])(Object(external_vue_["unref"])(x), ($, X) => ({
            name: $,
            fn: Object(external_vue_["withCtx"])(s => [Object(external_vue_["renderSlot"])(v.$slots, $, Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(s)))])
          }))]), 1040, ["onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [[external_vue_["vShow"], o === 0 ? !0 : M.value]])), 128))], 2)), !v.timePicker && !v.timePickerInline ? Object(external_vue_["withDirectives"])((Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", {
            key: 2,
            type: "button",
            ref_key: "closeTimePickerBtn",
            ref: J,
            class: Object(external_vue_["normalizeClass"])(re.value),
            "aria-label": (k = Object(external_vue_["unref"])(D)) == null ? void 0 : k.closeTimePicker,
            tabindex: "0",
            onKeydown: [I[4] || (I[4] = Object(external_vue_["withKeys"])(d => _(!1), ["enter"])), I[5] || (I[5] = Object(external_vue_["withKeys"])(d => _(!1), ["space"]))],
            onClick: I[6] || (I[6] = d => _(!1))
          }, [v.$slots["calendar-icon"] ? Object(external_vue_["renderSlot"])(v.$slots, "calendar-icon", {
            key: 0
          }) : Object(external_vue_["createCommentVNode"])("", !0), v.$slots["calendar-icon"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["unref"])(It), {
            key: 1
          }))], 42, Rl)), [[external_vue_["vShow"], !Object(external_vue_["unref"])(G)(v.hideNavigation, "time")]]) : Object(external_vue_["createCommentVNode"])("", !0)], 2)], 14, Cl)) : Object(external_vue_["createCommentVNode"])("", !0)];
        }),
        _: 3
      }, 8, ["name", "css"])]);
    };
  }

}),
      Ia = (e, n, a, t) => {
  const r = (p, M) => Array.isArray(n[p]) ? n[p][M] : n[p],
        l = p => e.enableSeconds ? Array.isArray(n.seconds) ? n.seconds[p] : n.seconds : 0,
        c = (p, M) => p ? M !== void 0 ? nt(p, r("hours", M), r("minutes", M), l(M)) : nt(p, n.hours, n.minutes, l()) : P(),
        y = (p, M) => {
    n[p] = M;
  },
        D = (p, M) => {
    const E = Object.fromEntries(Object.keys(n).map(z => z === p ? [z, M] : [z, n[z]].slice()));

    if (e.range && !e.disableTimeRangeValidation) {
      const z = _ => a.value ? nt(a.value[_], E.hours[_], E.minutes[_], E.seconds[_]) : null,
            K = _ => setMilliseconds(a.value[_], 0);

      return !(ge(z(0), z(1)) && (isAfter(z(0), K(1)) || isBefore(z(1), K(0))));
    }

    return !0;
  },
        S = (p, M) => {
    D(p, M) && (y(p, M), t && t());
  },
        g = p => {
    S("hours", p);
  },
        Y = p => {
    S("minutes", p);
  },
        R = p => {
    S("seconds", p);
  },
        G = (p, M, E, z) => {
    M && g(p), !M && !E && Y(p), E && R(p), a.value && z(a.value);
  },
        q = p => {
    if (p) {
      const M = Array.isArray(p),
            E = M ? [+p[0].hours, +p[1].hours] : +p.hours,
            z = M ? [+p[0].minutes, +p[1].minutes] : +p.minutes,
            K = M ? [+p[0].seconds, +p[1].seconds] : +p.seconds;
      y("hours", E), y("minutes", z), e.enableSeconds && y("seconds", K);
    }
  },
        J = (p, M) => {
    const E = {
      hours: Array.isArray(n.hours) ? n.hours[p] : n.hours,
      disabledArr: []
    };
    return (M || M === 0) && (E.hours = M), Array.isArray(e.disabledTimes) && (E.disabledArr = e.range && Array.isArray(e.disabledTimes[p]) ? e.disabledTimes[p] : e.disabledTimes), E;
  },
        Q = Object(external_vue_["computed"])(() => (p, M) => {
    var E;

    if (Array.isArray(e.disabledTimes)) {
      var _ref, _ref2;

      const {
        disabledArr: z,
        hours: K
      } = J(p, M),
            _ = z.filter(re => +re.hours === K);

      return ((E = _[0]) == null ? void 0 : E.minutes) === "*" ? {
        hours: [K],
        minutes: void 0,
        seconds: void 0
      } : {
        hours: [],
        minutes: (_ref = _ == null ? void 0 : _.map(re => +re.minutes)) !== null && _ref !== void 0 ? _ref : [],
        seconds: (_ref2 = _ == null ? void 0 : _.map(re => re.seconds ? +re.seconds : void 0)) !== null && _ref2 !== void 0 ? _ref2 : []
      };
    }

    return {
      hours: [],
      minutes: [],
      seconds: []
    };
  });

  return {
    setTime: y,
    updateHours: g,
    updateMinutes: Y,
    updateSeconds: R,
    getSetDateTime: c,
    updateTimeValues: G,
    getSecondsValue: l,
    assignStartTime: q,
    disabledTimesConfig: Q
  };
},
      Ol = (e, n) => {
  const {
    modelValue: a,
    time: t
  } = Zt(e, n),
        {
    defaultedStartTime: r
  } = Se(e),
        {
    updateTimeValues: l,
    getSetDateTime: c,
    setTime: y,
    assignStartTime: D,
    disabledTimesConfig: S
  } = Ia(e, t, a),
        g = M => {
    const {
      hours: E,
      minutes: z,
      seconds: K
    } = M;
    return {
      hours: +E,
      minutes: +z,
      seconds: K ? +K : 0
    };
  },
        Y = () => {
    if (e.startTime) {
      if (Array.isArray(e.startTime)) {
        const E = g(e.startTime[0]),
              z = g(e.startTime[1]);
        return [set_set(P(), E), set_set(P(), z)];
      }

      const M = g(e.startTime);
      return set_set(P(), M);
    }

    return e.range ? [null, null] : null;
  },
        R = () => {
    if (e.range) {
      const [M, E] = Y();
      a.value = [c(M, 0), c(E, 1)];
    } else a.value = c(Y());
  },
        G = M => Array.isArray(M) ? [vt(P(M[0])), vt(P(M[1]))] : [vt(M !== null && M !== void 0 ? M : P())],
        q = (M, E, z) => {
    y("hours", M), y("minutes", E), e.enableSeconds && y("seconds", z);
  },
        J = () => {
    const [M, E] = G(a.value);
    return e.range ? q([M.hours, E.hours], [M.minutes, E.minutes], [M.seconds, E.minutes]) : q(M.hours, M.minutes, M.seconds);
  };

  Object(external_vue_["onMounted"])(() => {
    if (!e.shadow) return D(r.value), a.value ? J() : R();
  });

  const Q = () => {
    Array.isArray(a.value) ? a.value = a.value.map((M, E) => M && c(M, E)) : a.value = c(a.value), n("time-update");
  };

  return {
    time: t,
    disabledTimesConfig: S,
    updateTime: (M, E = !0, z = !1) => {
      l(M, E, z, Q);
    }
  };
},
      Nl = /* @__PURE__ */Object(external_vue_["defineComponent"])({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: { ...xe
  },
  emits: ["update:internal-model-value", "time-update", "am-pm-change"],

  setup(e, {
    emit: n
  }) {
    const a = e,
          t = Object(external_vue_["useSlots"])(),
          r = ze(t, "timePicker"),
          {
      time: l,
      disabledTimesConfig: c,
      updateTime: y
    } = Ol(a, n);
    return (D, S) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Un, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(Ya, Object(external_vue_["mergeProps"])(D.$props, {
        hours: Object(external_vue_["unref"])(l).hours,
        minutes: Object(external_vue_["unref"])(l).minutes,
        seconds: Object(external_vue_["unref"])(l).seconds,
        "internal-model-value": D.internalModelValue,
        "disabled-times-config": Object(external_vue_["unref"])(c),
        "onUpdate:hours": S[0] || (S[0] = g => Object(external_vue_["unref"])(y)(g)),
        "onUpdate:minutes": S[1] || (S[1] = g => Object(external_vue_["unref"])(y)(g, !1)),
        "onUpdate:seconds": S[2] || (S[2] = g => Object(external_vue_["unref"])(y)(g, !1, !0)),
        onAmPmChange: S[3] || (S[3] = g => D.$emit("am-pm-change", g))
      }), Object(external_vue_["createSlots"])({
        _: 2
      }, [Object(external_vue_["renderList"])(Object(external_vue_["unref"])(r), (g, Y) => ({
        name: g,
        fn: Object(external_vue_["withCtx"])(R => [Object(external_vue_["renderSlot"])(D.$slots, g, Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(R)))])
      }))]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config"])]),
      _: 3
    }));
  }

}),
      Yl = {
  class: "dp__month_year_row"
},
      Il = ["aria-label", "onClick", "onKeydown"],
      Bl = /* @__PURE__ */Object(external_vue_["defineComponent"])({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: {
      type: Number,
      default: 0
    },
    year: {
      type: Number,
      default: 0
    },
    instance: {
      type: Number,
      default: 0
    },
    years: {
      type: Array,
      default: () => []
    },
    months: {
      type: Array,
      default: () => []
    },
    ...xe
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed"],

  setup(e, {
    expose: n,
    emit: a
  }) {
    const t = e,
          {
      defaultedTransitions: r,
      defaultedAriaLabels: l,
      defaultedMultiCalendars: c,
      defaultedFilters: y,
      defaultedConfig: D
    } = Se(t),
          {
      transitionName: S,
      showTransition: g
    } = Bt(r),
          {
      buildMatrix: Y
    } = lt(),
          {
      handleMonthYearChange: R,
      isDisabled: G,
      updateMonthYear: q
    } = Gr(t, a),
          {
      showLeftIcon: J,
      showRightIcon: Q
    } = qt(),
          p = Object(external_vue_["ref"])(!1),
          M = Object(external_vue_["ref"])(!1),
          E = Object(external_vue_["ref"])([null, null, null, null]);
    Object(external_vue_["onMounted"])(() => {
      a("mount");
    });

    const z = d => ({
      get: () => t[d],
      set: o => {
        const $ = d === Le.month ? Le.year : Le.month;
        a("update-month-year", {
          [d]: o,
          [$]: t[$]
        }), d === Le.month ? H(!0) : ee(!0);
      }
    }),
          K = Object(external_vue_["computed"])(z(Le.month)),
          _ = Object(external_vue_["computed"])(z(Le.year)),
          re = Object(external_vue_["computed"])(() => d => ({
      month: t.month,
      year: t.year,
      items: d === Le.month ? t.months : t.years,
      instance: t.instance,
      updateMonthYear: q,
      toggle: d === Le.month ? H : ee
    })),
          x = Object(external_vue_["computed"])(() => {
      const d = t.months.find(o => o.value === t.month);
      return d || {
        text: "",
        value: 0
      };
    }),
          L = Object(external_vue_["computed"])(() => kt(t.months, d => {
      const o = t.month === d.value,
            $ = Rt(d.value, Ta(t.year, t.minDate), Aa(t.year, t.maxDate)) || y.value.months.includes(d.value);
      return {
        active: o,
        disabled: $
      };
    })),
          h = Object(external_vue_["computed"])(() => kt(t.years, d => {
      const o = t.year === d.value,
            $ = Rt(d.value, wt(t.minDate), wt(t.maxDate)) || y.value.years.includes(d.value);
      return {
        active: o,
        disabled: $
      };
    })),
          T = (d, o) => {
      o !== void 0 ? d.value = o : d.value = !d.value, d.value || a("overlay-closed");
    },
          H = (d = !1, o) => {
      v(d), T(p, o);
    },
          ee = (d = !1, o) => {
      v(d), T(M, o);
    },
          v = d => {
      d || a("reset-flow");
    },
          I = (d, o) => {
      t.arrowNavigation && (E.value[o] = Ae(d), Y(E.value, "monthYear"));
    },
          f = Object(external_vue_["computed"])(() => {
      var d, o;
      return [{
        type: Le.month,
        index: 1,
        toggle: H,
        modelValue: K.value,
        updateModelValue: $ => K.value = $,
        text: x.value.text,
        showSelectionGrid: p.value,
        items: L.value,
        ariaLabel: (d = l.value) == null ? void 0 : d.openMonthsOverlay
      }, {
        type: Le.year,
        index: 2,
        toggle: ee,
        modelValue: _.value,
        updateModelValue: $ => _.value = $,
        text: t.year,
        showSelectionGrid: M.value,
        items: h.value,
        ariaLabel: (o = l.value) == null ? void 0 : o.openYearsOverlay
      }];
    }),
          k = Object(external_vue_["computed"])(() => t.disableYearSelect ? [f.value[0]] : f.value);

    return n({
      toggleMonthPicker: H,
      toggleYearPicker: ee,
      handleMonthYearChange: R
    }), (d, o) => {
      var $, X, s;
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", Yl, [d.$slots["month-year"] ? Object(external_vue_["renderSlot"])(d.$slots, "month-year", Object(external_vue_["normalizeProps"])(Object(external_vue_["mergeProps"])({
        key: 0
      }, {
        month: e.month,
        year: e.year,
        months: e.months,
        years: e.years,
        updateMonthYear: Object(external_vue_["unref"])(q),
        handleMonthYearChange: Object(external_vue_["unref"])(R),
        instance: e.instance
      }))) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
        key: 1
      }, [Object(external_vue_["unref"])(J)(Object(external_vue_["unref"])(c), e.instance) && !d.vertical ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(St, {
        key: 0,
        "aria-label": ($ = Object(external_vue_["unref"])(l)) == null ? void 0 : $.prevMonth,
        disabled: Object(external_vue_["unref"])(G)(!1),
        onActivate: o[0] || (o[0] = u => Object(external_vue_["unref"])(R)(!1, !0)),
        onSetRef: o[1] || (o[1] = u => I(u, 0))
      }, {
        default: Object(external_vue_["withCtx"])(() => [d.$slots["arrow-left"] ? Object(external_vue_["renderSlot"])(d.$slots, "arrow-left", {
          key: 0
        }) : Object(external_vue_["createCommentVNode"])("", !0), d.$slots["arrow-left"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["unref"])(Rn), {
          key: 1
        }))]),
        _: 3
      }, 8, ["aria-label", "disabled"])) : Object(external_vue_["createCommentVNode"])("", !0), Object(external_vue_["createElementVNode"])("div", {
        class: Object(external_vue_["normalizeClass"])(["dp__month_year_wrap", {
          dp__year_disable_select: d.disableYearSelect
        }])
      }, [(Object(external_vue_["openBlock"])(!0), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(k.value, (u, C) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
        key: u.type
      }, [Object(external_vue_["createElementVNode"])("button", {
        type: "button",
        class: "dp__btn dp__month_year_select",
        tabindex: "0",
        "aria-label": u.ariaLabel,
        ref_for: !0,
        ref: O => I(O, C + 1),
        onClick: u.toggle,
        onKeydown: [Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(u.toggle, ["prevent"]), ["enter"]), Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(u.toggle, ["prevent"]), ["space"])]
      }, [d.$slots[u.type] ? Object(external_vue_["renderSlot"])(d.$slots, u.type, {
        key: 0,
        text: u.text,
        value: t[u.type]
      }) : Object(external_vue_["createCommentVNode"])("", !0), d.$slots[u.type] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
        key: 1
      }, [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(u.text), 1)], 64))], 40, Il), Object(external_vue_["createVNode"])(external_vue_["Transition"], {
        name: Object(external_vue_["unref"])(S)(u.showSelectionGrid),
        css: Object(external_vue_["unref"])(g)
      }, {
        default: Object(external_vue_["withCtx"])(() => [u.showSelectionGrid ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Ot, {
          key: 0,
          items: u.items,
          "arrow-navigation": d.arrowNavigation,
          "hide-navigation": d.hideNavigation,
          "is-last": d.autoApply && !d.keepActionRow && !Object(external_vue_["unref"])(D).keepActionRow,
          "skip-button-ref": !1,
          config: d.config,
          type: u.type,
          "header-refs": [],
          "esc-close": d.escClose,
          "text-input": d.textInput,
          onSelected: u.updateModelValue,
          onToggle: u.toggle
        }, Object(external_vue_["createSlots"])({
          "button-icon": Object(external_vue_["withCtx"])(() => [d.$slots["calendar-icon"] ? Object(external_vue_["renderSlot"])(d.$slots, "calendar-icon", {
            key: 0
          }) : Object(external_vue_["createCommentVNode"])("", !0), d.$slots["calendar-icon"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["unref"])(It), {
            key: 1
          }))]),
          _: 2
        }, [d.$slots[`${u.type}-overlay-val`] ? {
          name: "item",
          fn: Object(external_vue_["withCtx"])(({
            item: O
          }) => [Object(external_vue_["renderSlot"])(d.$slots, `${u.type}-overlay-val`, {
            text: O.text,
            value: O.value
          })]),
          key: "0"
        } : void 0, d.$slots[`${u.type}-overlay`] ? {
          name: "overlay",
          fn: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(d.$slots, `${u.type}-overlay`, Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(re.value(u.type))))]),
          key: "1"
        } : void 0, d.$slots[`${u.type}-overlay-header`] ? {
          name: "header",
          fn: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(d.$slots, `${u.type}-overlay-header`, {
            toggle: u.toggle
          })]),
          key: "2"
        } : void 0]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "text-input", "onSelected", "onToggle"])) : Object(external_vue_["createCommentVNode"])("", !0)]),
        _: 2
      }, 1032, ["name", "css"])], 64))), 128))], 2), Object(external_vue_["unref"])(J)(Object(external_vue_["unref"])(c), e.instance) && d.vertical ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(St, {
        key: 1,
        "aria-label": (X = Object(external_vue_["unref"])(l)) == null ? void 0 : X.prevMonth,
        disabled: Object(external_vue_["unref"])(G)(!1),
        onActivate: o[2] || (o[2] = u => Object(external_vue_["unref"])(R)(!1, !0))
      }, {
        default: Object(external_vue_["withCtx"])(() => [d.$slots["arrow-up"] ? Object(external_vue_["renderSlot"])(d.$slots, "arrow-up", {
          key: 0
        }) : Object(external_vue_["createCommentVNode"])("", !0), d.$slots["arrow-up"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["unref"])(Yn), {
          key: 1
        }))]),
        _: 3
      }, 8, ["aria-label", "disabled"])) : Object(external_vue_["createCommentVNode"])("", !0), Object(external_vue_["unref"])(Q)(Object(external_vue_["unref"])(c), e.instance) ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(St, {
        key: 2,
        ref: "rightIcon",
        disabled: Object(external_vue_["unref"])(G)(!0),
        "aria-label": (s = Object(external_vue_["unref"])(l)) == null ? void 0 : s.nextMonth,
        onActivate: o[3] || (o[3] = u => Object(external_vue_["unref"])(R)(!0, !0)),
        onSetRef: o[4] || (o[4] = u => I(u, d.disableYearSelect ? 2 : 3))
      }, {
        default: Object(external_vue_["withCtx"])(() => [d.$slots[d.vertical ? "arrow-down" : "arrow-right"] ? Object(external_vue_["renderSlot"])(d.$slots, d.vertical ? "arrow-down" : "arrow-right", {
          key: 0
        }) : Object(external_vue_["createCommentVNode"])("", !0), d.$slots[d.vertical ? "arrow-down" : "arrow-right"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])(d.vertical ? Object(external_vue_["unref"])(In) : Object(external_vue_["unref"])(On)), {
          key: 1
        }))]),
        _: 3
      }, 8, ["disabled", "aria-label"])) : Object(external_vue_["createCommentVNode"])("", !0)], 64))]);
    };
  }

}),
      El = ["aria-label"],
      Fl = {
  class: "dp__calendar_header",
  role: "row"
},
      Vl = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
},
      Hl = /* @__PURE__ */Object(external_vue_["createElementVNode"])("div", {
  class: "dp__calendar_header_separator"
}, null, -1),
      Ul = ["aria-label"],
      Ll = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
},
      Wl = {
  class: "dp__cell_inner"
},
      zl = ["aria-selected", "aria-disabled", "aria-label", "onClick", "onKeydown", "onMouseenter", "onMouseleave"],
      jl = /* @__PURE__ */Object(external_vue_["defineComponent"])({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: {
      type: Array,
      default: () => []
    },
    instance: {
      type: Number,
      default: 0
    },
    month: {
      type: Number,
      default: 0
    },
    year: {
      type: Number,
      default: 0
    },
    ...xe
  },
  emits: ["select-date", "set-hover-date", "handle-scroll", "mount", "handle-swipe", "handle-space", "tooltip-open", "tooltip-close"],

  setup(e, {
    expose: n,
    emit: a
  }) {
    const t = e,
          {
      buildMultiLevelMatrix: r
    } = lt(),
          {
      defaultedTransitions: l,
      defaultedConfig: c,
      defaultedAriaLabels: y,
      defaultedMultiCalendars: D
    } = Se(t),
          S = Object(external_vue_["ref"])(null),
          g = Object(external_vue_["ref"])({
      bottom: "",
      left: "",
      transform: ""
    }),
          Y = Object(external_vue_["ref"])([]),
          R = Object(external_vue_["ref"])(null),
          G = Object(external_vue_["ref"])(!0),
          q = Object(external_vue_["ref"])(""),
          J = Object(external_vue_["ref"])({
      startX: 0,
      endX: 0,
      startY: 0,
      endY: 0
    }),
          Q = Object(external_vue_["ref"])([]),
          p = Object(external_vue_["ref"])({
      left: "50%"
    }),
          M = Object(external_vue_["computed"])(() => t.calendar ? t.calendar(t.mappedDates) : t.mappedDates),
          E = Object(external_vue_["computed"])(() => t.dayNames ? Array.isArray(t.dayNames) ? t.dayNames : t.dayNames(t.locale, +t.weekStart) : Tr(t.formatLocale, t.locale, +t.weekStart));
    Object(external_vue_["onMounted"])(() => {
      a("mount", {
        cmp: "calendar",
        refs: Y
      }), !t.noSwipe && !c.value.noSwipe && R.value && (R.value.addEventListener("touchstart", ee, {
        passive: !1
      }), R.value.addEventListener("touchend", v, {
        passive: !1
      }), R.value.addEventListener("touchmove", I, {
        passive: !1
      })), t.monthChangeOnScroll && R.value && R.value.addEventListener("wheel", d, {
        passive: !1
      });
    });

    const z = s => s ? t.vertical ? "vNext" : "next" : t.vertical ? "vPrevious" : "previous",
          K = (s, u) => {
      if (t.transitions) {
        const C = He(Je(P(), t.month, t.year));
        q.value = Re(He(Je(P(), s, u)), C) ? l.value[z(!0)] : l.value[z(!1)], G.value = !1, Object(external_vue_["nextTick"])(() => {
          G.value = !0;
        });
      }
    },
          _ = Object(external_vue_["computed"])(() => ({
      [t.calendarClassName]: !!t.calendarClassName
    })),
          re = Object(external_vue_["computed"])(() => s => {
      const u = Sr(s);
      return {
        dp__marker_dot: u.type === "dot",
        dp__marker_line: u.type === "line"
      };
    }),
          x = Object(external_vue_["computed"])(() => s => ge(s, S.value)),
          L = Object(external_vue_["computed"])(() => ({
      dp__calendar: !0,
      dp__calendar_next: D.value.count > 0 && t.instance !== 0
    })),
          h = Object(external_vue_["computed"])(() => s => t.hideOffsetDates ? s.current : !0),
          T = async (s, u, C) => {
      var O, A;

      if (a("set-hover-date", s), (A = (O = s.marker) == null ? void 0 : O.tooltip) != null && A.length) {
        const te = Ae(Y.value[u][C]);

        if (te) {
          const {
            width: B,
            height: ie
          } = te.getBoundingClientRect();
          S.value = s.value;
          let he = {
            left: `${B / 2}px`
          },
              me = -50;

          if (await Object(external_vue_["nextTick"])(), Q.value[0]) {
            const {
              left: N,
              width: j
            } = Q.value[0].getBoundingClientRect();
            N < 0 && (he = {
              left: "0"
            }, me = 0, p.value.left = `${B / 2}px`), window.innerWidth < N + j && (he = {
              right: "0"
            }, me = 0, p.value.left = `${j - B / 2}px`);
          }

          g.value = {
            bottom: `${ie}px`,
            ...he,
            transform: `translateX(${me}%)`
          }, a("tooltip-open", s.marker);
        }
      }
    },
          H = s => {
      S.value && (S.value = null, g.value = JSON.parse(JSON.stringify({
        bottom: "",
        left: "",
        transform: ""
      })), a("tooltip-close", s.marker));
    },
          ee = s => {
      J.value.startX = s.changedTouches[0].screenX, J.value.startY = s.changedTouches[0].screenY;
    },
          v = s => {
      J.value.endX = s.changedTouches[0].screenX, J.value.endY = s.changedTouches[0].screenY, f();
    },
          I = s => {
      t.vertical && !t.inline && s.preventDefault();
    },
          f = () => {
      const s = t.vertical ? "Y" : "X";
      Math.abs(J.value[`start${s}`] - J.value[`end${s}`]) > 10 && a("handle-swipe", J.value[`start${s}`] > J.value[`end${s}`] ? "right" : "left");
    },
          k = (s, u, C) => {
      s && (Array.isArray(Y.value[u]) ? Y.value[u][C] = s : Y.value[u] = [s]), t.arrowNavigation && r(Y.value, "calendar");
    },
          d = s => {
      t.monthChangeOnScroll && (s.preventDefault(), a("handle-scroll", s));
    },
          o = s => {
      const u = s[0];
      return t.weekNumbers === "local" ? getWeek(u.value, {
        weekStartsOn: +t.weekStart
      }) : t.weekNumbers === "iso" ? getISOWeek(u.value) : typeof t.weekNumbers == "function" ? t.weekNumbers(u.value) : "";
    },
          $ = (s, u) => {
      tt(s, c.value), a("select-date", u);
    },
          X = s => {
      tt(s, c.value);
    };

    return n({
      triggerTransition: K
    }), (s, u) => {
      var C;
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        class: Object(external_vue_["normalizeClass"])(L.value)
      }, [Object(external_vue_["createElementVNode"])("div", {
        ref_key: "calendarWrapRef",
        ref: R,
        role: "grid",
        class: Object(external_vue_["normalizeClass"])(_.value),
        "aria-label": (C = Object(external_vue_["unref"])(y)) == null ? void 0 : C.calendarWrap
      }, [(Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
        key: 0
      }, [Object(external_vue_["createElementVNode"])("div", Fl, [s.weekNumbers ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", Vl, Object(external_vue_["toDisplayString"])(s.weekNumName), 1)) : Object(external_vue_["createCommentVNode"])("", !0), (Object(external_vue_["openBlock"])(!0), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(E.value, (O, A) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        class: "dp__calendar_header_item",
        role: "gridcell",
        key: A
      }, [s.$slots["calendar-header"] ? Object(external_vue_["renderSlot"])(s.$slots, "calendar-header", {
        key: 0,
        day: O,
        index: A
      }) : Object(external_vue_["createCommentVNode"])("", !0), s.$slots["calendar-header"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
        key: 1
      }, [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(O), 1)], 64))]))), 128))]), Hl, Object(external_vue_["createVNode"])(external_vue_["Transition"], {
        name: q.value,
        css: !!s.transitions
      }, {
        default: Object(external_vue_["withCtx"])(() => {
          var O;
          return [G.value ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
            key: 0,
            class: "dp__calendar",
            role: "grid",
            "aria-label": ((O = Object(external_vue_["unref"])(y)) == null ? void 0 : O.calendarDays) || void 0
          }, [(Object(external_vue_["openBlock"])(!0), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(M.value, (A, te) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
            class: "dp__calendar_row",
            role: "row",
            key: te
          }, [s.weekNumbers ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", Ll, [Object(external_vue_["createElementVNode"])("div", Wl, Object(external_vue_["toDisplayString"])(o(A.days)), 1)])) : Object(external_vue_["createCommentVNode"])("", !0), (Object(external_vue_["openBlock"])(!0), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(A.days, (B, ie) => {
            var he, me, N;
            return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
              role: "gridcell",
              class: "dp__calendar_item",
              ref_for: !0,
              ref: j => k(j, te, ie),
              key: ie + te,
              "aria-selected": B.classData.dp__active_date || B.classData.dp__range_start || B.classData.dp__range_start,
              "aria-disabled": B.classData.dp__cell_disabled || void 0,
              "aria-label": (me = (he = Object(external_vue_["unref"])(y)) == null ? void 0 : he.day) == null ? void 0 : me.call(he, B),
              tabindex: "0",
              onClick: Object(external_vue_["withModifiers"])(j => $(j, B), ["prevent"]),
              onKeydown: [Object(external_vue_["withKeys"])(j => s.$emit("select-date", B), ["enter"]), Object(external_vue_["withKeys"])(j => s.$emit("handle-space", B), ["space"])],
              onMouseenter: j => T(B, te, ie),
              onMouseleave: j => H(B)
            }, [Object(external_vue_["createElementVNode"])("div", {
              class: Object(external_vue_["normalizeClass"])(["dp__cell_inner", B.classData])
            }, [s.$slots.day && h.value(B) ? Object(external_vue_["renderSlot"])(s.$slots, "day", {
              key: 0,
              day: +B.text,
              date: B.value
            }) : Object(external_vue_["createCommentVNode"])("", !0), s.$slots.day ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
              key: 1
            }, [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(B.text), 1)], 64)), B.marker && h.value(B) ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
              key: 2
            }, [s.$slots.marker ? Object(external_vue_["renderSlot"])(s.$slots, "marker", {
              key: 0,
              marker: B.marker,
              day: +B.text,
              date: B.value
            }) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
              key: 1,
              class: Object(external_vue_["normalizeClass"])(re.value(B.marker)),
              style: Object(external_vue_["normalizeStyle"])(B.marker.color ? {
                backgroundColor: B.marker.color
              } : {})
            }, null, 6))], 64)) : Object(external_vue_["createCommentVNode"])("", !0), x.value(B.value) ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
              key: 3,
              class: "dp__marker_tooltip",
              ref_for: !0,
              ref_key: "activeTooltip",
              ref: Q,
              style: Object(external_vue_["normalizeStyle"])(g.value)
            }, [(N = B.marker) != null && N.tooltip ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
              key: 0,
              class: "dp__tooltip_content",
              onClick: X
            }, [(Object(external_vue_["openBlock"])(!0), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(B.marker.tooltip, (j, De) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
              key: De,
              class: "dp__tooltip_text"
            }, [s.$slots["marker-tooltip"] ? Object(external_vue_["renderSlot"])(s.$slots, "marker-tooltip", {
              key: 0,
              tooltip: j,
              day: B.value
            }) : Object(external_vue_["createCommentVNode"])("", !0), s.$slots["marker-tooltip"] ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
              key: 1
            }, [Object(external_vue_["createElementVNode"])("div", {
              class: "dp__tooltip_mark",
              style: Object(external_vue_["normalizeStyle"])(j.color ? {
                backgroundColor: j.color
              } : {})
            }, null, 4), Object(external_vue_["createElementVNode"])("div", null, Object(external_vue_["toDisplayString"])(j.text), 1)], 64))]))), 128)), Object(external_vue_["createElementVNode"])("div", {
              class: "dp__arrow_bottom_tp",
              style: Object(external_vue_["normalizeStyle"])(p.value)
            }, null, 4)])) : Object(external_vue_["createCommentVNode"])("", !0)], 4)) : Object(external_vue_["createCommentVNode"])("", !0)], 2)], 40, zl);
          }), 128))]))), 128))], 8, Ul)) : Object(external_vue_["createCommentVNode"])("", !0)];
        }),
        _: 3
      }, 8, ["name", "css"])], 64))], 10, El)], 2);
    };
  }

}),
      ia = e => Array.isArray(e),
      Kl = (e, n, a, t) => {
  const r = Object(external_vue_["ref"])([]),
        {
    modelValue: l,
    calendars: c,
    time: y
  } = Zt(e, n),
        {
    defaultedMultiCalendars: D,
    defaultedStartTime: S
  } = Se(e),
        {
    validateMonthYearInRange: g,
    isDisabled: Y,
    isDateRangeAllowed: R,
    checkMinMaxRange: G
  } = Et(e),
        {
    updateTimeValues: q,
    getSetDateTime: J,
    setTime: Q,
    assignStartTime: p,
    disabledTimesConfig: M
  } = Ia(e, y, l, t),
        E = Object(external_vue_["computed"])(() => i => c.value[i] ? c.value[i].month : 0),
        z = Object(external_vue_["computed"])(() => i => c.value[i] ? c.value[i].year : 0),
        K = (i, w, U) => {
    var se, be;
    c.value[i] || (c.value[i] = {
      month: 0,
      year: 0
    }), c.value[i].month = aa(w) ? (se = c.value[i]) == null ? void 0 : se.month : w, c.value[i].year = aa(U) ? (be = c.value[i]) == null ? void 0 : be.year : U;
  },
        _ = () => {
    e.autoApply && n("select-date");
  };

  Object(external_vue_["watch"])(l, (i, w) => {
    JSON.stringify(i) !== JSON.stringify(w) && L();
  }), Object(external_vue_["onMounted"])(() => {
    e.shadow || (l.value || (o(), S.value && p(S.value)), L(!0), e.focusStartDate && e.startDate && o());
  });

  const re = Object(external_vue_["computed"])(() => {
    var i;
    return (i = e.flow) != null && i.length && !e.partialFlow ? e.flowStep === e.flow.length : !0;
  }),
        x = () => {
    e.autoApply && re.value && n("auto-apply", e.partialFlow);
  },
        L = (i = !1) => {
    if (l.value) return Array.isArray(l.value) ? (r.value = l.value, I(i)) : T(l.value, i);
    if (D.value.count && i && !e.startDate) return h(P(), i);
  },
        h = (i, w = !1) => {
    if ((!D.value.count || !D.value.static || w) && K(0, getMonth(i), getYear(i)), D.value.count) for (let U = 1; U < D.value.count; U++) {
      const se = set_set(P(), {
        month: E.value(U - 1),
        year: z.value(U - 1)
      }),
            be = add(se, {
        months: 1
      });
      c.value[U] = {
        month: getMonth(be),
        year: getYear(be)
      };
    }
  },
        T = (i, w) => {
    h(i), Q("hours", getHours(i)), Q("minutes", getMinutes(i)), Q("seconds", getSeconds(i)), D.value.count && w && d();
  },
        H = i => {
    if (D.value.count) {
      if (D.value.solo) return 0;
      const w = getMonth(i[0]),
            U = getMonth(i[1]);
      return Math.abs(U - w) < D.value.count ? 0 : 1;
    }

    return 1;
  },
        ee = (i, w) => {
    i[1] && e.showLastInRange ? h(i[H(i)], w) : h(i[0], w);

    const U = (se, be) => [se(i[0]), i[1] ? se(i[1]) : y[be][1]];

    Q("hours", U(getHours, "hours")), Q("minutes", U(getMinutes, "minutes")), Q("seconds", U(getSeconds, "seconds"));
  },
        v = (i, w) => {
    if ((e.range || e.weekPicker) && !e.multiDates) return ee(i, w);

    if (e.multiDates && w) {
      const U = i[i.length - 1];
      return T(U, w);
    }
  },
        I = i => {
    const w = l.value;
    v(w, i), D.value.count && D.value.solo && d();
  },
        f = (i, w) => {
    const U = set_set(P(), {
      month: E.value(w),
      year: z.value(w)
    }),
          se = i < 0 ? addMonths(U, 1) : subMonths(U, 1);
    g(getMonth(se), getYear(se), i < 0, e.preventMinMaxNavigation) && (K(w, getMonth(se), getYear(se)), D.value.count && !D.value.solo && k(w), a());
  },
        k = i => {
    for (let w = i - 1; w >= 0; w--) {
      const U = subMonths(set_set(P(), {
        month: E.value(w + 1),
        year: z.value(w + 1)
      }), 1);
      K(w, getMonth(U), getYear(U));
    }

    for (let w = i + 1; w <= D.value.count - 1; w++) {
      const U = addMonths(set_set(P(), {
        month: E.value(w - 1),
        year: z.value(w - 1)
      }), 1);
      K(w, getMonth(U), getYear(U));
    }
  },
        d = () => {
    if (Array.isArray(l.value) && l.value.length === 2) {
      const i = P(P(l.value[1] ? l.value[1] : addMonths(l.value[0], 1))),
            [w, U] = [getMonth(l.value[0]), getYear(l.value[0])],
            [se, be] = [getMonth(l.value[1]), getYear(l.value[1])];
      (w !== se || w === se && U !== be) && D.value.solo && K(1, getMonth(i), getYear(i));
    } else l.value && !Array.isArray(l.value) && (K(0, getMonth(l.value), getYear(l.value)), h(P()));
  },
        o = () => {
    e.startDate && (K(0, getMonth(P(e.startDate)), getYear(P(e.startDate))), D.value.count && k(0));
  },
        $ = (i, w) => {
    e.monthChangeOnScroll && f(e.monthChangeOnScroll !== "inverse" ? -i.deltaY : i.deltaY, w);
  },
        X = (i, w, U = !1) => {
    e.monthChangeOnArrows && e.vertical === U && s(i, w);
  },
        s = (i, w) => {
    f(i === "right" ? -1 : 1, w);
  },
        u = i => e.markers.find(w => ge(la(i.value), la(w.date))),
        C = (i, w) => {
    switch (e.sixWeeks === !0 ? "append" : e.sixWeeks) {
      case "prepend":
        return [!0, !1];

      case "center":
        return [i == 0, !0];

      case "fair":
        return [i == 0 || w > i, !0];

      case "append":
        return [!1, !1];

      default:
        return [!1, !1];
    }
  },
        O = (i, w, U, se) => {
    if (e.sixWeeks && i.length < 6) {
      const be = 6 - i.length,
            Qe = (w.getDay() + 7 - se) % 7,
            Ft = 6 - (U.getDay() + 7 - se) % 7,
            [Tt, ln] = C(Qe, Ft);

      for (let ot = 1; ot <= be; ot++) if (ln ? !!(ot % 2) == Tt : Tt) {
        const Vt = i[0].days[0],
              on = A(addDays(Vt.value, -7), getMonth(w));
        i.unshift({
          days: on
        });
      } else {
        const Vt = i[i.length - 1],
              on = Vt.days[Vt.days.length - 1],
              Ea = A(addDays(on.value, 1), getMonth(w));
        i.push({
          days: Ea
        });
      }
    }

    return i;
  },
        A = (i, w) => {
    const U = P(i),
          se = [];

    for (let be = 0; be < 7; be++) {
      const Qe = addDays(U, be),
            $t = getMonth(Qe) !== w;
      se.push({
        text: e.hideOffsetDates && $t ? "" : Qe.getDate(),
        value: Qe,
        current: !$t,
        classData: {}
      });
    }

    return se;
  },
        te = (i, w) => {
    const U = [],
          se = P(Ge(new Date(w, i), e.timezone)),
          be = P(Ge(new Date(w, i + 1, 0), e.timezone)),
          Qe = e.weekStart,
          $t = startOfWeek(se, {
      weekStartsOn: Qe
    }),
          Ft = Tt => {
      const ln = A(Tt, i);

      if (U.push({
        days: ln
      }), !U[U.length - 1].days.some(ot => ge(He(ot.value), He(be)))) {
        const ot = addDays(Tt, 7);
        Ft(ot);
      }
    };

    return Ft($t), O(U, se, be, Qe);
  },
        B = i => (l.value = jt(P(i.value), e.timezone, e.weekStart), x()),
        ie = i => {
    const w = nt(P(i.value), y.hours, y.minutes, Te());
    e.multiDates ? Ln(w, l, e.multiDatesLimit) : l.value = w, t(), Object(external_vue_["nextTick"])().then(() => {
      x();
    });
  },
        he = i => e.noDisabledRange ? _a(r.value[0], i).some(U => Y(U)) : !1,
        me = () => {
    r.value = l.value ? l.value.slice() : [], r.value.length === 2 && !(e.fixedStart || e.fixedEnd) && (r.value = []);
  },
        N = (i, w) => {
    const U = [P(i.value), addDays(P(i.value), +e.autoRange)];
    R(U) && (w && j(i.value), r.value = U);
  },
        j = i => {
    const w = getMonth(P(i)),
          U = getYear(P(i));
    if (K(0, w, U), D.value.count > 0) for (let se = 1; se < D.value.count; se++) {
      const be = Or(set_set(P(i), {
        year: E.value(se - 1),
        month: z.value(se - 1)
      }));
      K(se, be.month, be.year);
    }
  },
        De = i => Array.isArray(l.value) && l.value.length === 2 ? e.fixedStart && (Re(i, l.value[0]) || ge(i, l.value[0])) ? [l.value[0], i] : e.fixedEnd && (Pe(i, l.value[1]) || ge(i, l.value[1])) ? [i, l.value[1]] : (n("invalid-fixed-range", i), l.value) : [],
        ne = i => {
    he(i.value) || !G(i.value, l.value, e.fixedStart ? 0 : 1) || (r.value = De(P(i.value)));
  },
        Fe = (i, w) => {
    if (me(), e.autoRange) return N(i, w);
    if (e.fixedStart || e.fixedEnd) return ne(i);
    r.value[0] ? G(P(i.value), l.value) && !he(i.value) && (Pe(P(i.value), P(r.value[0])) ? (r.value.unshift(P(i.value)), n("range-end", r.value[0])) : (r.value[1] = P(i.value), n("range-end", r.value[1]))) : (r.value[0] = P(i.value), n("range-start", r.value[0]));
  },
        Te = (i = !0) => e.enableSeconds ? Array.isArray(y.seconds) ? i ? y.seconds[0] : y.seconds[1] : y.seconds : 0,
        Mt = i => {
    r.value[i] = nt(r.value[i], y.hours[i], y.minutes[i], Te(i !== 1));
  },
        Jt = () => {
    var i, w;
    r.value[0] && r.value[1] && +((i = r.value) == null ? void 0 : i[0]) > +((w = r.value) == null ? void 0 : w[1]) && (r.value.reverse(), n("range-start", r.value[0]), n("range-end", r.value[1]));
  },
        xt = () => {
    r.value.length && (r.value[0] && !r.value[1] ? Mt(0) : (Mt(0), Mt(1), t()), Jt(), l.value = r.value.slice(), Wn(r.value, n, e.autoApply, e.modelAuto));
  },
        Qt = (i, w = !1) => {
    if (!(Y(i.value) || !i.current && e.hideOffsetDates)) {
      if (e.weekPicker) return B(i);
      if (!e.range) return ie(i);
      ia(y.hours) && ia(y.minutes) && !e.multiDates && (Fe(i, w), xt());
    }
  },
        en = (i, w) => {
    var se;
    K(i, w.month, w.year), D.value.count && !D.value.solo && k(i), n("update-month-year", {
      instance: i,
      month: w.month,
      year: w.year
    }), a(D.value.solo ? i : void 0);
    const U = (se = e.flow) != null && se.length ? e.flow[e.flowStep] : void 0;
    !w.fromNav && (U === je.month || U === je.year) && t();
  },
        tn = (i, w) => {
    Array.isArray(i) && i.length <= 2 && e.range ? l.value = i.map(U => Ge(P(U), w ? void 0 : e.timezone)) : Array.isArray(i) || (l.value = Ge(P(i), w ? void 0 : e.timezone)), _(), e.multiCalendars && Object(external_vue_["nextTick"])().then(() => L(!0));
  },
        nn = () => {
    e.range ? l.value && Array.isArray(l.value) && l.value[0] ? l.value = Pe(P(), l.value[0]) ? [P(), l.value[0]] : [l.value[0], P()] : l.value = [P()] : l.value = P(), _();
  },
        an = () => {
    if (Array.isArray(l.value)) {
      if (e.multiDates) {
        const i = rn();
        l.value[l.value.length - 1] = J(i);
      } else l.value = l.value.map((i, w) => i && J(i, w));
    } else l.value = J(l.value);
    n("time-update");
  },
        rn = () => Array.isArray(l.value) && l.value.length ? l.value[l.value.length - 1] : null;

  return {
    calendars: c,
    modelValue: l,
    month: E,
    year: z,
    time: y,
    disabledTimesConfig: M,
    getCalendarDays: te,
    getMarker: u,
    handleScroll: $,
    handleSwipe: s,
    handleArrow: X,
    selectDate: Qt,
    updateMonthYear: en,
    presetDate: tn,
    selectCurrentDate: nn,
    updateTime: (i, w = !0, U = !1) => {
      q(i, w, U, an);
    }
  };
},
      Gl = {
  key: 0
},
      Zl = /* @__PURE__ */Object(external_vue_["defineComponent"])({
  __name: "DatePicker",
  props: { ...xe
  },
  emits: ["tooltip-open", "tooltip-close", "mount", "update:internal-model-value", "update-flow-step", "reset-flow", "auto-apply", "focus-menu", "select-date", "range-start", "range-end", "invalid-fixed-range", "time-update", "am-pm-change", "time-picker-open", "time-picker-close", "recalculate-position", "update-month-year"],

  setup(e, {
    expose: n,
    emit: a
  }) {
    const t = e,
          {
      calendars: r,
      month: l,
      year: c,
      modelValue: y,
      time: D,
      disabledTimesConfig: S,
      getCalendarDays: g,
      getMarker: Y,
      handleArrow: R,
      handleScroll: G,
      handleSwipe: q,
      selectDate: J,
      updateMonthYear: Q,
      presetDate: p,
      selectCurrentDate: M,
      updateTime: E
    } = Kl(t, a, k, d),
          z = Object(external_vue_["useSlots"])(),
          {
      setHoverDate: K,
      getDayClassData: _,
      clearHoverDate: re
    } = Jr(y, t),
          {
      defaultedMultiCalendars: x
    } = Se(t),
          L = Object(external_vue_["ref"])([]),
          h = Object(external_vue_["ref"])([]),
          T = Object(external_vue_["ref"])(null),
          H = ze(z, "calendar"),
          ee = ze(z, "monthYear"),
          v = ze(z, "timePicker"),
          I = C => {
      t.shadow || a("mount", C);
    };

    Object(external_vue_["watch"])(r, () => {
      t.shadow || setTimeout(() => {
        a("recalculate-position");
      }, 0);
    }, {
      deep: !0
    });
    const f = Object(external_vue_["computed"])(() => C => g(l.value(C), c.value(C)).map(O => ({ ...O,
      days: O.days.map(A => (A.marker = Y(A), A.classData = _(A), A))
    })));

    function k(C) {
      var O;
      C || C === 0 ? (O = h.value[C]) == null || O.triggerTransition(l.value(C), c.value(C)) : h.value.forEach((A, te) => A.triggerTransition(l.value(te), c.value(te)));
    }

    function d() {
      a("update-flow-step");
    }

    const o = (C, O = !1) => {
      J(C, O), t.spaceConfirm && a("select-date");
    };

    return n({
      clearHoverDate: re,
      presetDate: p,
      selectCurrentDate: M,
      toggleMonthPicker: (C, O, A = 0) => {
        var te;
        (te = L.value[A]) == null || te.toggleMonthPicker(C, O);
      },
      toggleYearPicker: (C, O, A = 0) => {
        var te;
        (te = L.value[A]) == null || te.toggleYearPicker(C, O);
      },
      toggleTimePicker: (C, O, A) => {
        var te;
        (te = T.value) == null || te.toggleTimePicker(C, O, A);
      },
      handleArrow: R,
      updateMonthYear: Q,
      getSidebarProps: () => ({
        modelValue: y,
        month: l,
        year: c,
        time: D,
        updateTime: E,
        updateMonthYear: Q,
        selectDate: J,
        presetDate: p
      })
    }), (C, O) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, [Object(external_vue_["createVNode"])(Un, {
      "multi-calendars": Object(external_vue_["unref"])(x).count
    }, {
      default: Object(external_vue_["withCtx"])(({
        instance: A,
        index: te
      }) => [C.disableMonthYearSelect ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Bl, Object(external_vue_["mergeProps"])({
        key: 0,
        ref: B => {
          B && (L.value[te] = B);
        },
        months: Object(external_vue_["unref"])(Ma)(C.formatLocale, C.locale, C.monthNameFormat),
        years: Object(external_vue_["unref"])(Vn)(C.yearRange, C.reverseYears),
        month: Object(external_vue_["unref"])(l)(A),
        year: Object(external_vue_["unref"])(c)(A),
        instance: A
      }, C.$props, {
        onMount: O[0] || (O[0] = B => I(Object(external_vue_["unref"])(mt).header)),
        onResetFlow: O[1] || (O[1] = B => C.$emit("reset-flow")),
        onUpdateMonthYear: B => Object(external_vue_["unref"])(Q)(A, B),
        onOverlayClosed: O[2] || (O[2] = B => C.$emit("focus-menu"))
      }), Object(external_vue_["createSlots"])({
        _: 2
      }, [Object(external_vue_["renderList"])(Object(external_vue_["unref"])(ee), (B, ie) => ({
        name: B,
        fn: Object(external_vue_["withCtx"])(he => [Object(external_vue_["renderSlot"])(C.$slots, B, Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(he)))])
      }))]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])), Object(external_vue_["createVNode"])(jl, Object(external_vue_["mergeProps"])({
        ref: B => {
          B && (h.value[te] = B);
        },
        "mapped-dates": f.value(A),
        month: Object(external_vue_["unref"])(l)(A),
        year: Object(external_vue_["unref"])(c)(A)
      }, C.$props, {
        onSelectDate: B => Object(external_vue_["unref"])(J)(B, A !== 1),
        onHandleSpace: B => o(B, A !== 1),
        onSetHoverDate: O[3] || (O[3] = B => Object(external_vue_["unref"])(K)(B)),
        onHandleScroll: B => Object(external_vue_["unref"])(G)(B, A),
        onHandleSwipe: B => Object(external_vue_["unref"])(q)(B, A),
        onMount: O[4] || (O[4] = B => I(Object(external_vue_["unref"])(mt).calendar)),
        onResetFlow: O[5] || (O[5] = B => C.$emit("reset-flow")),
        onTooltipOpen: O[6] || (O[6] = B => C.$emit("tooltip-open", B)),
        onTooltipClose: O[7] || (O[7] = B => C.$emit("tooltip-close", B))
      }), Object(external_vue_["createSlots"])({
        _: 2
      }, [Object(external_vue_["renderList"])(Object(external_vue_["unref"])(H), (B, ie) => ({
        name: B,
        fn: Object(external_vue_["withCtx"])(he => [Object(external_vue_["renderSlot"])(C.$slots, B, Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])({ ...he
        })))])
      }))]), 1040, ["mapped-dates", "month", "year", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])]),
      _: 3
    }, 8, ["multi-calendars"]), C.enableTimePicker ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", Gl, [C.$slots["time-picker"] ? Object(external_vue_["renderSlot"])(C.$slots, "time-picker", Object(external_vue_["normalizeProps"])(Object(external_vue_["mergeProps"])({
      key: 0
    }, {
      time: Object(external_vue_["unref"])(D),
      updateTime: Object(external_vue_["unref"])(E)
    }))) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Ya, Object(external_vue_["mergeProps"])({
      key: 1,
      ref_key: "timePickerRef",
      ref: T
    }, C.$props, {
      hours: Object(external_vue_["unref"])(D).hours,
      minutes: Object(external_vue_["unref"])(D).minutes,
      seconds: Object(external_vue_["unref"])(D).seconds,
      "internal-model-value": C.internalModelValue,
      "disabled-times-config": Object(external_vue_["unref"])(S),
      onMount: O[8] || (O[8] = A => I(Object(external_vue_["unref"])(mt).timePicker)),
      "onUpdate:hours": O[9] || (O[9] = A => Object(external_vue_["unref"])(E)(A)),
      "onUpdate:minutes": O[10] || (O[10] = A => Object(external_vue_["unref"])(E)(A, !1)),
      "onUpdate:seconds": O[11] || (O[11] = A => Object(external_vue_["unref"])(E)(A, !1, !0)),
      onResetFlow: O[12] || (O[12] = A => C.$emit("reset-flow")),
      onOverlayClosed: O[13] || (O[13] = A => C.$emit("time-picker-close")),
      onOverlayOpened: O[14] || (O[14] = A => C.$emit("time-picker-open", A)),
      onAmPmChange: O[15] || (O[15] = A => C.$emit("am-pm-change", A))
    }), Object(external_vue_["createSlots"])({
      _: 2
    }, [Object(external_vue_["renderList"])(Object(external_vue_["unref"])(v), (A, te) => ({
      name: A,
      fn: Object(external_vue_["withCtx"])(B => [Object(external_vue_["renderSlot"])(C.$slots, A, Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(B)))])
    }))]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config"]))])) : Object(external_vue_["createCommentVNode"])("", !0)], 64));
  }

}),
      ql = ["id", "onKeydown"],
      Xl = {
  key: 0,
  class: "dp__sidebar_left"
},
      Jl = {
  key: 1,
  class: "dp--preset-dates"
},
      xl = ["onClick", "onKeydown"],
      Ql = {
  key: 2,
  class: "dp__sidebar_right"
},
      eo = {
  key: 3,
  class: "dp__action_extra"
},
      da = /* @__PURE__ */Object(external_vue_["defineComponent"])({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: { ...Xt,
    shadow: {
      type: Boolean,
      default: !1
    },
    openOnTop: {
      type: Boolean,
      default: !1
    },
    internalModelValue: {
      type: [Date, Array],
      default: null
    },
    arrMapValues: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["close-picker", "select-date", "auto-apply", "time-update", "flow-step", "update-month-year", "invalid-select", "update:internal-model-value", "recalculate-position", "invalid-fixed-range", "tooltip-open", "tooltip-close", "time-picker-open", "time-picker-close", "am-pm-change", "range-start", "range-end"],

  setup(e, {
    expose: n,
    emit: a
  }) {
    const t = e,
          r = Object(external_vue_["computed"])(() => {
      const {
        openOnTop: N,
        ...j
      } = t;
      return { ...j,
        flowStep: re.value
      };
    }),
          {
      setMenuFocused: l,
      setShiftKey: c,
      control: y
    } = Oa(),
          D = Object(external_vue_["useSlots"])(),
          {
      defaultedTextInput: S,
      defaultedInline: g,
      defaultedConfig: Y
    } = Se(t),
          R = Object(external_vue_["ref"])(null),
          G = Object(external_vue_["ref"])(0),
          q = Object(external_vue_["ref"])(null),
          J = Object(external_vue_["ref"])(null),
          Q = Object(external_vue_["ref"])(!1),
          p = Object(external_vue_["ref"])(null);
    Object(external_vue_["onMounted"])(() => {
      if (!t.shadow) {
        Q.value = !0, M(), window.addEventListener("resize", M);
        const N = Ae(q);

        if (N && !S.value.enabled && !g.value.enabled && (l(!0), H()), N) {
          const j = De => {
            (t.allowPreventDefault || Y.value.allowPreventDefault) && De.preventDefault(), tt(De, Y.value, !0);
          };

          N.addEventListener("pointerdown", j), N.addEventListener("mousedown", j);
        }
      }
    }), Object(external_vue_["onUnmounted"])(() => {
      window.removeEventListener("resize", M);
    });

    const M = () => {
      const N = Ae(J);
      N && (G.value = N.getBoundingClientRect().width);
    },
          {
      arrowRight: E,
      arrowLeft: z,
      arrowDown: K,
      arrowUp: _
    } = lt(),
          {
      flowStep: re,
      updateFlowStep: x,
      childMount: L,
      resetFlow: h
    } = xr(t, a, p),
          T = Object(external_vue_["computed"])(() => t.monthPicker ? gl : t.yearPicker ? hl : t.timePicker ? Nl : Zl),
          H = () => {
      const N = Ae(q);
      N && N.focus({
        preventScroll: !0
      });
    },
          ee = Object(external_vue_["computed"])(() => {
      var N;
      return ((N = p.value) == null ? void 0 : N.getSidebarProps()) || {};
    }),
          v = () => {
      t.openOnTop && a("recalculate-position");
    },
          I = ze(D, "action"),
          f = Object(external_vue_["computed"])(() => t.monthPicker || t.yearPicker ? ze(D, "monthYear") : t.timePicker ? ze(D, "timePicker") : ze(D, "shared")),
          k = Object(external_vue_["computed"])(() => t.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"),
          d = Object(external_vue_["computed"])(() => ({
      dp__menu_disabled: t.disabled,
      dp__menu_readonly: t.readonly
    })),
          o = Object(external_vue_["computed"])(() => ({
      dp__menu: !0,
      dp__menu_index: !g.value.enabled,
      dp__relative: g.value.enabled,
      [t.menuClassName]: !!t.menuClassName
    })),
          $ = N => {
      tt(N, Y.value, !0);
    },
          X = () => {
      t.escClose && a("close-picker");
    },
          s = N => {
      if (t.arrowNavigation) {
        if (N === "up") return _();
        if (N === "down") return K();
        if (N === "left") return z();
        if (N === "right") return E();
      } else N === "left" || N === "up" ? te("handleArrow", "left", 0, N === "up") : te("handleArrow", "right", 0, N === "down");
    },
          u = N => {
      c(N.shiftKey), !t.disableMonthYearSelect && N.code === "Tab" && N.target.classList.contains("dp__menu") && y.value.shiftKeyInMenu && (N.preventDefault(), tt(N, Y.value, !0), a("close-picker"));
    },
          C = () => {
      H(), a("time-picker-close");
    },
          O = N => {
      var j, De, ne;
      (j = p.value) == null || j.toggleTimePicker(!1, !1), (De = p.value) == null || De.toggleMonthPicker(!1, !1, N), (ne = p.value) == null || ne.toggleYearPicker(!1, !1, N);
    },
          A = (N, j = 0) => {
      var De, ne, Fe;
      return N === "month" ? (De = p.value) == null ? void 0 : De.toggleMonthPicker(!1, !0, j) : N === "year" ? (ne = p.value) == null ? void 0 : ne.toggleYearPicker(!1, !0, j) : N === "time" ? (Fe = p.value) == null ? void 0 : Fe.toggleTimePicker(!0, !1) : O(j);
    },
          te = (N, ...j) => {
      var De, ne;
      (De = p.value) != null && De[N] && ((ne = p.value) == null || ne[N](...j));
    },
          B = () => {
      te("selectCurrentDate");
    },
          ie = (N, j) => {
      te("presetDate", N, j);
    },
          he = () => {
      te("clearHoverDate");
    };

    return n({
      updateMonthYear: (N, j) => {
        te("updateMonthYear", N, j);
      },
      switchView: A
    }), (N, j) => {
      var De;
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        id: N.uid ? `dp-menu-${N.uid}` : void 0,
        tabindex: "0",
        ref_key: "dpMenuRef",
        ref: q,
        role: "dialog",
        class: Object(external_vue_["normalizeClass"])(o.value),
        onMouseleave: he,
        onClick: $,
        onKeydown: [Object(external_vue_["withKeys"])(X, ["esc"]), j[15] || (j[15] = Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(ne => s("left"), ["prevent"]), ["left"])), j[16] || (j[16] = Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(ne => s("up"), ["prevent"]), ["up"])), j[17] || (j[17] = Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(ne => s("down"), ["prevent"]), ["down"])), j[18] || (j[18] = Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(ne => s("right"), ["prevent"]), ["right"])), u]
      }, [(N.disabled || N.readonly) && Object(external_vue_["unref"])(g).enabled ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        key: 0,
        class: Object(external_vue_["normalizeClass"])(d.value)
      }, null, 2)) : Object(external_vue_["createCommentVNode"])("", !0), !Object(external_vue_["unref"])(g).enabled && !N.teleportCenter ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        key: 1,
        class: Object(external_vue_["normalizeClass"])(k.value)
      }, null, 2)) : Object(external_vue_["createCommentVNode"])("", !0), Object(external_vue_["createElementVNode"])("div", {
        ref_key: "innerMenuRef",
        ref: J,
        class: Object(external_vue_["normalizeClass"])({
          dp__menu_content_wrapper: ((De = N.presetDates) == null ? void 0 : De.length) || !!N.$slots["left-sidebar"] || !!N.$slots["right-sidebar"]
        }),
        style: Object(external_vue_["normalizeStyle"])({
          "--dp-menu-width": `${G.value}px`
        })
      }, [N.$slots["left-sidebar"] ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", Xl, [Object(external_vue_["renderSlot"])(N.$slots, "left-sidebar", Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(ee.value)))])) : Object(external_vue_["createCommentVNode"])("", !0), N.presetDates.length ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", Jl, [(Object(external_vue_["openBlock"])(!0), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(N.presetDates, (ne, Fe) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        key: Fe,
        style: Object(external_vue_["normalizeStyle"])(ne.style || {}),
        class: "dp--preset-range"
      }, [ne.slot ? Object(external_vue_["renderSlot"])(N.$slots, ne.slot, {
        key: 0,
        presetDate: ie,
        label: ne.label,
        value: ne.value
      }) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        key: 1,
        role: "button",
        tabindex: "0",
        onClick: Te => ie(ne.value, ne.noTz),
        onKeydown: [Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(Te => ie(ne.value, ne.noTz), ["prevent"]), ["enter"]), Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])(Te => ie(ne.value, ne.noTz), ["prevent"]), ["space"])]
      }, Object(external_vue_["toDisplayString"])(ne.label), 41, xl))], 4))), 128))])) : Object(external_vue_["createCommentVNode"])("", !0), Object(external_vue_["createElementVNode"])("div", {
        class: "dp__instance_calendar",
        ref_key: "calendarWrapperRef",
        ref: R,
        role: "document"
      }, [(Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])(T.value), Object(external_vue_["mergeProps"])({
        ref_key: "dynCmpRef",
        ref: p
      }, r.value, {
        "flow-step": Object(external_vue_["unref"])(re),
        onMount: Object(external_vue_["unref"])(L),
        onUpdateFlowStep: Object(external_vue_["unref"])(x),
        onResetFlow: Object(external_vue_["unref"])(h),
        onFocusMenu: H,
        onSelectDate: j[0] || (j[0] = ne => N.$emit("select-date")),
        onTooltipOpen: j[1] || (j[1] = ne => N.$emit("tooltip-open", ne)),
        onTooltipClose: j[2] || (j[2] = ne => N.$emit("tooltip-close", ne)),
        onAutoApply: j[3] || (j[3] = ne => N.$emit("auto-apply", ne)),
        onRangeStart: j[4] || (j[4] = ne => N.$emit("range-start", ne)),
        onRangeEnd: j[5] || (j[5] = ne => N.$emit("range-end", ne)),
        onInvalidFixedRange: j[6] || (j[6] = ne => N.$emit("invalid-fixed-range", ne)),
        onTimeUpdate: j[7] || (j[7] = ne => N.$emit("time-update")),
        onAmPmChange: j[8] || (j[8] = ne => N.$emit("am-pm-change", ne)),
        onTimePickerOpen: j[9] || (j[9] = ne => N.$emit("time-picker-open", ne)),
        onTimePickerClose: C,
        onRecalculatePosition: v,
        onUpdateMonthYear: j[10] || (j[10] = ne => N.$emit("update-month-year", ne)),
        "onUpdate:internalModelValue": j[11] || (j[11] = ne => N.$emit("update:internal-model-value", ne))
      }), Object(external_vue_["createSlots"])({
        _: 2
      }, [Object(external_vue_["renderList"])(f.value, (ne, Fe) => ({
        name: ne,
        fn: Object(external_vue_["withCtx"])(Te => [Object(external_vue_["renderSlot"])(N.$slots, ne, Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])({ ...Te
        })))])
      }))]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))], 512), N.$slots["right-sidebar"] ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", Ql, [Object(external_vue_["renderSlot"])(N.$slots, "right-sidebar", Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(ee.value)))])) : Object(external_vue_["createCommentVNode"])("", !0), N.$slots["action-extra"] ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", eo, [N.$slots["action-extra"] ? Object(external_vue_["renderSlot"])(N.$slots, "action-extra", {
        key: 0,
        selectCurrentDate: B
      }) : Object(external_vue_["createCommentVNode"])("", !0)])) : Object(external_vue_["createCommentVNode"])("", !0)], 6), !N.autoApply || N.keepActionRow || Object(external_vue_["unref"])(Y).keepActionRow ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(ol, Object(external_vue_["mergeProps"])({
        key: 2,
        "menu-mount": Q.value
      }, r.value, {
        "calendar-width": G.value,
        onClosePicker: j[12] || (j[12] = ne => N.$emit("close-picker")),
        onSelectDate: j[13] || (j[13] = ne => N.$emit("select-date")),
        onInvalidSelect: j[14] || (j[14] = ne => N.$emit("invalid-select")),
        onSelectNow: B
      }), Object(external_vue_["createSlots"])({
        _: 2
      }, [Object(external_vue_["renderList"])(Object(external_vue_["unref"])(I), (ne, Fe) => ({
        name: ne,
        fn: Object(external_vue_["withCtx"])(Te => [Object(external_vue_["renderSlot"])(N.$slots, ne, Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])({ ...Te
        })))])
      }))]), 1040, ["menu-mount", "calendar-width"])) : Object(external_vue_["createCommentVNode"])("", !0)], 42, ql);
    };
  }

}),
      to = typeof window < "u" ? window : void 0,
      bn = () => {},
      no = e => Object(external_vue_["getCurrentScope"])() ? (Object(external_vue_["onScopeDispose"])(e), !0) : !1,
      ao = (e, n, a, t) => {
  if (!e) return bn;
  let r = bn;

  const l = Object(external_vue_["watch"])(() => Object(external_vue_["unref"])(e), y => {
    r(), y && (y.addEventListener(n, a, t), r = () => {
      y.removeEventListener(n, a, t), r = bn;
    });
  }, {
    immediate: !0,
    flush: "post"
  }),
        c = () => {
    l(), r();
  };

  return no(c), c;
},
      ro = (e, n, a, t = {}) => {
  const {
    window: r = to,
    event: l = "pointerdown"
  } = t;
  return r ? ao(r, l, y => {
    const D = Ae(e),
          S = Ae(n);
    !D || !S || D === y.target || y.composedPath().includes(D) || y.composedPath().includes(S) || a(y);
  }, {
    passive: !0
  }) : void 0;
},
      lo = /* @__PURE__ */Object(external_vue_["defineComponent"])({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: { ...Xt
  },
  emits: ["update:model-value", "update:model-timezone-value", "text-submit", "closed", "cleared", "open", "focus", "blur", "internal-model-change", "recalculate-position", "flow-step", "update-month-year", "invalid-select", "invalid-fixed-range", "tooltip-open", "tooltip-close", "time-picker-open", "time-picker-close", "am-pm-change", "range-start", "range-end"],

  setup(e, {
    expose: n,
    emit: a
  }) {
    const t = e,
          r = Object(external_vue_["useSlots"])(),
          l = Object(external_vue_["ref"])(!1),
          c = Object(external_vue_["toRef"])(t, "modelValue"),
          y = Object(external_vue_["toRef"])(t, "timezone"),
          D = Object(external_vue_["ref"])(null),
          S = Object(external_vue_["ref"])(null),
          g = Object(external_vue_["ref"])(null),
          Y = Object(external_vue_["ref"])(!1),
          R = Object(external_vue_["ref"])(null),
          {
      setMenuFocused: G,
      setShiftKey: q
    } = Oa(),
          {
      clearArrowNav: J
    } = lt(),
          {
      mapDatesArrToMap: Q,
      validateDate: p,
      isValidTime: M
    } = Et(t),
          {
      defaultedTransitions: E,
      defaultedTextInput: z,
      defaultedInline: K,
      defaultedConfig: _
    } = Se(t),
          {
      menuTransition: re,
      showTransition: x
    } = Bt(E);
    Object(external_vue_["onMounted"])(() => {
      $(t.modelValue), Object(external_vue_["nextTick"])().then(() => {
        K.value.enabled || (f(R.value).addEventListener("scroll", te), window.addEventListener("resize", B));
      }), K.value.enabled && (l.value = !0);
    });
    const L = Object(external_vue_["computed"])(() => Q());

    Object(external_vue_["onUnmounted"])(() => {
      if (!K.value.enabled) {
        const i = f(R.value);
        i && i.removeEventListener("scroll", te), window.removeEventListener("resize", B);
      }
    });

    const h = ze(r, "all", t.presetDates),
          T = ze(r, "input");
    Object(external_vue_["watch"])([c, y], () => {
      $(c.value);
    }, {
      deep: !0
    });

    const {
      openOnTop: H,
      menuStyle: ee,
      xCorrect: v,
      setMenuPosition: I,
      getScrollableParent: f,
      shadowRender: k
    } = Zr({
      menuRef: D,
      menuRefInner: S,
      inputRef: g,
      pickerWrapperRef: R,
      inline: K,
      emit: a,
      props: t,
      slots: r
    }),
          {
      inputValue: d,
      internalModelValue: o,
      parseExternalModelValue: $,
      emitModelValue: X,
      formatInputValue: s,
      checkBeforeEmit: u
    } = Kr(a, t, Y),
          C = Object(external_vue_["computed"])(() => ({
      dp__main: !0,
      dp__theme_dark: t.dark,
      dp__theme_light: !t.dark,
      dp__flex_display: K.value.enabled,
      dp__flex_display_with_input: K.value.input
    })),
          O = Object(external_vue_["computed"])(() => t.dark ? "dp__theme_dark" : "dp__theme_light"),
          A = Object(external_vue_["computed"])(() => t.teleport ? {
      to: typeof t.teleport == "boolean" ? "body" : t.teleport,
      disabled: K.value.enabled
    } : {
      class: "dp__outer_menu_wrap"
    }),
          te = () => {
      l.value && (t.closeOnScroll || _.value.closeOnScroll ? Te() : I());
    },
          B = () => {
      l.value && I();
    },
          ie = () => {
      !t.disabled && !t.readonly && (k(da, t), I(!1), l.value = !0, l.value && a("open"), l.value || Fe(), $(t.modelValue));
    },
          he = () => {
      d.value = "", Fe(), a("update:model-value", null), a("update:model-timezone-value", null), a("cleared"), (t.closeOnClearValue || _.value.closeOnClearValue) && Te();
    },
          me = () => {
      const i = o.value;
      return !i || !Array.isArray(i) && p(i) ? !0 : Array.isArray(i) ? i.length === 2 && p(i[0]) && p(i[1]) ? !0 : t.partialRange && !t.timePicker ? p(i[0]) : !1 : !1;
    },
          N = () => {
      u() && me() ? (X(), Te()) : a("invalid-select", o.value);
    },
          j = i => {
      De(), X(), (t.closeOnAutoApply || _.value.closeOnAutoApply) && !i && Te();
    },
          De = () => {
      g.value && z.value.enabled && g.value.setParsedDate(o.value);
    },
          ne = (i = !1) => {
      t.autoApply && M(o.value) && me() && (t.range && Array.isArray(o.value) ? (t.partialRange || o.value.length === 2) && j(i) : j(i));
    },
          Fe = () => {
      z.value.enabled || (o.value = null);
    },
          Te = () => {
      K.value.enabled || (l.value && (l.value = !1, v.value = !1, G(!1), q(!1), J(), a("closed"), d.value && $(c.value)), Fe(), a("blur"));
    },
          Mt = (i, w) => {
      if (!i) {
        o.value = null;
        return;
      }

      o.value = i, w && (N(), a("text-submit"));
    },
          Jt = () => {
      t.autoApply && M(o.value) && X(), De();
    },
          xt = () => l.value ? Te() : ie(),
          Qt = i => {
      o.value = i;
    },
          en = () => {
      z.value.enabled && (Y.value = !0, s()), a("focus");
    },
          tn = () => {
      z.value.enabled && (Y.value = !1, $(t.modelValue)), a("blur");
    },
          nn = i => {
      S.value && S.value.updateMonthYear(0, {
        month: na(i.month),
        year: na(i.year)
      });
    },
          an = i => {
      $(i !== null && i !== void 0 ? i : t.modelValue);
    },
          rn = (i, w) => {
      var U;
      (U = S.value) == null || U.switchView(i, w);
    },
          zn = i => t.onClickOutside ? t.onClickOutside(i) : _.value.onClickOutside ? _.value.onClickOutside(i) : Te();

    return ro(D, g, () => zn(me)), n({
      closeMenu: Te,
      selectDate: N,
      clearValue: he,
      openMenu: ie,
      onScroll: te,
      formatInputValue: s,
      // exposed for testing purposes
      updateInternalModelValue: Qt,
      // modify internal modelValue
      setMonthYear: nn,
      parseModel: an,
      switchView: rn
    }), (i, w) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
      class: Object(external_vue_["normalizeClass"])(C.value),
      ref_key: "pickerWrapperRef",
      ref: R
    }, [Object(external_vue_["createVNode"])(nl, Object(external_vue_["mergeProps"])({
      ref_key: "inputRef",
      ref: g,
      "is-menu-open": l.value,
      "input-value": Object(external_vue_["unref"])(d),
      "onUpdate:inputValue": w[0] || (w[0] = U => Object(external_vue_["isRef"])(d) ? d.value = U : null)
    }, i.$props, {
      onClear: he,
      onOpen: ie,
      onSetInputDate: Mt,
      onSetEmptyDate: Object(external_vue_["unref"])(X),
      onSelectDate: N,
      onToggle: xt,
      onClose: Te,
      onFocus: en,
      onBlur: tn,
      onRealBlur: w[1] || (w[1] = U => Y.value = !1)
    }), Object(external_vue_["createSlots"])({
      _: 2
    }, [Object(external_vue_["renderList"])(Object(external_vue_["unref"])(T), (U, se) => ({
      name: U,
      fn: Object(external_vue_["withCtx"])(be => [Object(external_vue_["renderSlot"])(i.$slots, U, Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(be)))])
    }))]), 1040, ["is-menu-open", "input-value", "onSetEmptyDate"]), Object(external_vue_["createVNode"])(external_vue_["Transition"], {
      name: Object(external_vue_["unref"])(re)(Object(external_vue_["unref"])(H)),
      css: Object(external_vue_["unref"])(x) && !Object(external_vue_["unref"])(K).enabled
    }, {
      default: Object(external_vue_["withCtx"])(() => [l.value ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])(i.teleport ? external_vue_["Teleport"] : "div"), Object(external_vue_["mergeProps"])({
        key: 0,
        ref_key: "dpWrapMenuRef",
        ref: D
      }, A.value, {
        class: {
          "dp--menu-wrapper": !Object(external_vue_["unref"])(K).enabled
        },
        style: Object(external_vue_["unref"])(K).enabled ? void 0 : Object(external_vue_["unref"])(ee)
      }), {
        default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(da, Object(external_vue_["mergeProps"])({
          ref_key: "dpMenuRef",
          ref: S,
          class: {
            [O.value]: !0,
            "dp--menu-wrapper": i.teleport
          },
          style: i.teleport ? Object(external_vue_["unref"])(ee) : void 0,
          "open-on-top": Object(external_vue_["unref"])(H),
          "arr-map-values": L.value
        }, i.$props, {
          "internal-model-value": Object(external_vue_["unref"])(o),
          "onUpdate:internalModelValue": w[2] || (w[2] = U => Object(external_vue_["isRef"])(o) ? o.value = U : null),
          onClosePicker: Te,
          onSelectDate: N,
          onAutoApply: ne,
          onTimeUpdate: Jt,
          onFlowStep: w[3] || (w[3] = U => i.$emit("flow-step", U)),
          onUpdateMonthYear: w[4] || (w[4] = U => i.$emit("update-month-year", U)),
          onInvalidSelect: w[5] || (w[5] = U => i.$emit("invalid-select", Object(external_vue_["unref"])(o))),
          onInvalidFixedRange: w[6] || (w[6] = U => i.$emit("invalid-fixed-range", U)),
          onRecalculatePosition: Object(external_vue_["unref"])(I),
          onTooltipOpen: w[7] || (w[7] = U => i.$emit("tooltip-open", U)),
          onTooltipClose: w[8] || (w[8] = U => i.$emit("tooltip-close", U)),
          onTimePickerOpen: w[9] || (w[9] = U => i.$emit("time-picker-open", U)),
          onTimePickerClose: w[10] || (w[10] = U => i.$emit("time-picker-close", U)),
          onAmPmChange: w[11] || (w[11] = U => i.$emit("am-pm-change", U)),
          onRangeStart: w[12] || (w[12] = U => i.$emit("range-start", U)),
          onRangeEnd: w[13] || (w[13] = U => i.$emit("range-end", U))
        }), Object(external_vue_["createSlots"])({
          _: 2
        }, [Object(external_vue_["renderList"])(Object(external_vue_["unref"])(h), (U, se) => ({
          name: U,
          fn: Object(external_vue_["withCtx"])(be => [Object(external_vue_["renderSlot"])(i.$slots, U, Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])({ ...be
          })))])
        }))]), 1040, ["class", "style", "open-on-top", "arr-map-values", "internal-model-value", "onRecalculatePosition"])]),
        _: 3
      }, 16, ["class", "style"])) : Object(external_vue_["createCommentVNode"])("", !0)]),
      _: 3
    }, 8, ["name", "css"])], 2));
  }

}),
      Ba = /* @__PURE__ */(() => {
  const e = lo;
  return e.install = n => {
    n.component("Vue3DatePicker", e);
  }, e;
})(),
      oo = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
  __proto__: null,
  default: Ba
}, Symbol.toStringTag, {
  value: "Module"
}));

Object.entries(oo).forEach(([e, n]) => {
  e !== "default" && (Ba[e] = n);
});

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaInput.vue?vue&type=template&id=232a3873

const NebulaInputvue_type_template_id_232a3873_hoisted_1 = ["aria-describedby", "aria-disabled", "id", "name", "value", "maxlength"];
function NebulaInputvue_type_template_id_232a3873_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("input", {
    "aria-describedby": $props.hasHelper ? $options.getHelperId : null,
    class: Object(external_vue_["normalizeClass"])($options.inputClassName),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps),
    "aria-disabled": $props.isDisabled ? 'true' : null,
    id: $props.id,
    name: $props.name,
    value: $props.text || $props.modelValue,
    type: "text",
    maxlength: $props.maxlength,
    onInput: _cache[0] || (_cache[0] = (...args) => $options.onInput && $options.onInput(...args))
  }, null, 46, NebulaInputvue_type_template_id_232a3873_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/FormElements/NebulaInput.vue?vue&type=template&id=232a3873

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaInput.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaInputvue_type_script_lang_js = ({
  name: 'NebulaInput',
  mixins: [themingUtils],
  props: {
    hasHelper: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number]
    },
    maxlength: {
      type: [Number],
      default: null
    },
    name: {
      type: String
    },
    size: {
      type: String,
      default: 'm',
      // Options: s, m, l
      enum: ['xs', 's', 'm', 'l'] // for docs site

    },
    status: {
      type: String,
      default: null // Options: success, error

    },
    text: {
      type: String
    },
    modelValue: {
      type: String
    }
  },
  emits: ['input', 'update:model-value'],
  computed: {
    inputClassName() {
      const className = ['nebula-input', `nebula-input--${this.size}`, {
        'nebula-input--error': this.status === 'error',
        'nebula-input--success': this.status === 'success'
      }];
      return className;
    },

    getHelperId() {
      return `helper-text__${this.id}`;
    }

  },
  methods: {
    onInput(e) {
      this.$emit('update:model-value', e.target.value); // standard event for Vue 3 v-model

      this.$emit('input', e.target.value); // older code may still listen for this
    }

  }
});
// CONCATENATED MODULE: ./src/components/FormElements/NebulaInput.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/FormElements/NebulaInput.vue?vue&type=style&index=0&id=232a3873&lang=stylus
var NebulaInputvue_type_style_index_0_id_232a3873_lang_stylus = __webpack_require__("d9cd");

// CONCATENATED MODULE: ./src/components/FormElements/NebulaInput.vue







const NebulaInput_exports_ = /*#__PURE__*/exportHelper_default()(NebulaInputvue_type_script_lang_js, [['render',NebulaInputvue_type_template_id_232a3873_render]])

/* harmony default export */ var NebulaInput = (NebulaInput_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Datepicker/NebulaDatepicker.vue?vue&type=script&lang=js







/* harmony default export */ var NebulaDatepickervue_type_script_lang_js = ({
  name: 'NebulaDatepicker',
  components: {
    VueDatepicker: Ba,
    NebulaButton: NebulaButton,
    NebulaIcon: NebulaIcon,
    NebulaInput: NebulaInput
  },
  mixins: [themingUtils],

  data() {
    return {
      date: null,
      time: {}
    };
  },

  emits: ['date-change', 'datepicker-open', 'datepicker-closed'],
  inheritAttrs: false,
  props: {
    clearAriaText: {
      type: String,
      default: 'clear'
    },
    closePickerText: {
      type: String,
      default: 'Cancel'
    },
    customClass: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    iconName: {
      type: String,
      default: 'calendar'
    },
    id: {
      type: String,
      default: null
    },
    hideIcon: {
      type: Boolean,
      default: false
    },
    locale: {
      type: String,
      default: 'en-US'
    },
    placeholder: {
      type: String,
      default: null
    },
    selectDateText: {
      type: String,
      default: 'Select Date'
    },
    setDate: {
      type: [Date, Array, String, Number],
      default: null
    },
    setTime: {
      type: [Date, Object, String],
      default: null
    },
    showTimePicker: {
      type: Boolean,
      default: false
    },
    inputSize: {
      type: String,
      default: 'm' // Options: s, m, l

    },
    inputStatus: {
      type: String,
      default: null // Options: success, error

    },
    useShortMonthName: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    datepickerClasses() {
      const className = ['nebula-datepicker', this.customClass, {
        'nebula-datepicker--disabled': this.disabled
      }];
      return className;
    },

    formattedDate() {
      let formattedDate = null;
      const attrs = this.getAttrs;

      if (this.date) {
        if (Object.hasOwn(attrs, 'range')) {
          const dateObj = this.cloneDeep(this.date);
          const date1 = new Date(dateObj[0]);
          const date2 = new Date(dateObj[1]);
          const formattedDate1 = new Intl.DateTimeFormat(this.locale).format(date1);
          const formattedDate2 = new Intl.DateTimeFormat(this.locale).format(date2);
          formattedDate = `${formattedDate1} - ${formattedDate2}`;
        } else {
          const dateItem = new Date(this.date);
          const date = new Intl.DateTimeFormat(this.locale).format(dateItem);
          const time = new Intl.DateTimeFormat(this.locale, {
            timeStyle: 'short'
          }).format(dateItem);
          formattedDate = `${date} ${time}`;
        }
      }

      return formattedDate;
    },

    getAttrs() {
      return this.cloneDeep(this.$attrs);
    },

    getId() {
      let datepickerId = '';

      if (this.id) {
        datepickerId = this.id;
      } else {
        datepickerId = `nebula-datepicker--${this.randomStringId}`;
      }

      return datepickerId;
    },

    randomStringId() {
      return randomStringId();
    }

  },
  methods: {
    cloneDeep(object) {
      return JSON.parse(JSON.stringify(object));
    }

  },

  mounted() {
    if (this.setDate) {
      this.date = this.setDate;
    }

    if (this.setTime) {
      this.time = this.setTime;
    }
  }

});
// CONCATENATED MODULE: ./src/components/Datepicker/NebulaDatepicker.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Datepicker/NebulaDatepicker.vue?vue&type=style&index=0&id=11782aa8&lang=stylus
var NebulaDatepickervue_type_style_index_0_id_11782aa8_lang_stylus = __webpack_require__("fe2c");

// CONCATENATED MODULE: ./src/components/Datepicker/NebulaDatepicker.vue







const NebulaDatepicker_exports_ = /*#__PURE__*/exportHelper_default()(NebulaDatepickervue_type_script_lang_js, [['render',NebulaDatepickervue_type_template_id_11782aa8_render]])

/* harmony default export */ var NebulaDatepicker = (NebulaDatepicker_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Dialog/NebulaDialog.vue?vue&type=template&id=06e01d37

const NebulaDialogvue_type_template_id_06e01d37_hoisted_1 = {
  class: "nebula-dialog-outer"
};
const NebulaDialogvue_type_template_id_06e01d37_hoisted_2 = {
  key: 0
};
const NebulaDialogvue_type_template_id_06e01d37_hoisted_3 = ["id", "open"];
const NebulaDialogvue_type_template_id_06e01d37_hoisted_4 = {
  key: 0,
  class: "nebula-dialog__header nebula-dialog__header--sticky"
};
const NebulaDialogvue_type_template_id_06e01d37_hoisted_5 = {
  key: 0,
  class: "nebula-dialog__x-button-container"
};
const NebulaDialogvue_type_template_id_06e01d37_hoisted_6 = {
  class: "nebula-dialog__inner"
};
const NebulaDialogvue_type_template_id_06e01d37_hoisted_7 = {
  class: "nebula-dialog__content-container"
};
const NebulaDialogvue_type_template_id_06e01d37_hoisted_8 = {
  key: 1,
  class: "nebula-dialog__actions-container"
};
const NebulaDialogvue_type_template_id_06e01d37_hoisted_9 = {
  key: 1,
  class: "nebula-dialog__actions-container nebula-dialog__actions-container--sticky"
};
const NebulaDialogvue_type_template_id_06e01d37_hoisted_10 = {
  key: 2,
  class: "nebula-dialog__x-button-container"
};
function NebulaDialogvue_type_template_id_06e01d37_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaDialogvue_type_template_id_06e01d37_hoisted_1, [$options.hasTrigger ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaDialogvue_type_template_id_06e01d37_hoisted_2, [Object(external_vue_["renderSlot"])(_ctx.$slots, "trigger", {
    showDialog: $options.showDialog,
    isOpen: $data.dialogVisible
  })])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.dialogContainerClassName),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.checkOnClickClose && $options.checkOnClickClose(...args))
  }, [Object(external_vue_["createElementVNode"])("dialog", {
    class: Object(external_vue_["normalizeClass"])($options.dialogClassName),
    id: $options.getDialogId,
    open: $props.open,
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [(Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($options.getDialogElement), Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])($props.formConfig ? $props.formConfig : null)), {
    default: Object(external_vue_["withCtx"])(() => [$options.hasStickyHeader ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaDialogvue_type_template_id_06e01d37_hoisted_4, [Object(external_vue_["renderSlot"])(_ctx.$slots, "sticky-header", {
      closeDialog: $options.closeDialog,
      isOpen: $data.dialogVisible
    }), !$props.hideCloseButton ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaDialogvue_type_template_id_06e01d37_hoisted_5, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      class: "nebula-dialog__x-button",
      "icon-left": "x",
      type: "flat",
      size: "s",
      "aria-label": _ctx.$t('close dialog'),
      onClick: $options.onClickClose
    }, null, 8, ["aria-label", "onClick"])])) : Object(external_vue_["createCommentVNode"])("", true)])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaDialogvue_type_template_id_06e01d37_hoisted_6, [$options.hasHeader ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
      key: 0,
      class: Object(external_vue_["normalizeClass"])($options.headerContainerClass)
    }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "header", {
      closeDialog: $options.closeDialog,
      isOpen: $data.dialogVisible
    })], 2)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaDialogvue_type_template_id_06e01d37_hoisted_7, [Object(external_vue_["renderSlot"])(_ctx.$slots, "content", {
      closeDialog: $options.closeDialog,
      isOpen: $data.dialogVisible
    })]), $options.hasActionsRow ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaDialogvue_type_template_id_06e01d37_hoisted_8, [Object(external_vue_["renderSlot"])(_ctx.$slots, "actions-row", {
      closeDialog: $options.closeDialog,
      isOpen: $data.dialogVisible
    })])) : Object(external_vue_["createCommentVNode"])("", true)]), $options.hasStickyActionsRow ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaDialogvue_type_template_id_06e01d37_hoisted_9, [Object(external_vue_["renderSlot"])(_ctx.$slots, "sticky-actions-row", {
      closeDialog: $options.closeDialog,
      isOpen: $data.dialogVisible
    })])) : Object(external_vue_["createCommentVNode"])("", true), !$props.hideCloseButton && !$options.hasStickyHeader ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaDialogvue_type_template_id_06e01d37_hoisted_10, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      class: "nebula-dialog__x-button",
      "icon-left": "x",
      type: "flat",
      size: "s",
      "aria-label": _ctx.$t('close dialog'),
      onClick: $options.onClickClose
    }, null, 8, ["aria-label", "onClick"])])) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 3
  }, 16))], 14, NebulaDialogvue_type_template_id_06e01d37_hoisted_3)], 2)]);
}
// CONCATENATED MODULE: ./src/components/Dialog/NebulaDialog.vue?vue&type=template&id=06e01d37

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Dialog/NebulaDialog.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaDialogvue_type_script_lang_js = ({
  name: 'NebulaDialog',
  components: {
    NebulaButton: NebulaButton
  },
  emits: ['closed-dialog', 'opened-dialog'],
  mixins: [themingUtils],

  data() {
    return {
      dialogVisible: false
    };
  },

  props: {
    formConfig: {
      type: [Object, Array],
      default: null
    },
    hideCloseButton: {
      type: Boolean,
      default: false
    },
    id: {
      type: [Number, String],
      default: null
    },
    initialFocus: {
      type: [Number, String],
      default: null
    },
    open: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'm'
    },
    takeover: {
      type: Boolean,
      default: false
    }
  },

  created() {
    document.addEventListener('keyup', this.handleKeyUpEvent);
  },

  mounted() {
    // disabling browser native escape button functionality.
    // when launching dialog from dropdown and hitting escape,
    // the open state was getting lost and was not able to prevent dropdown from closing
    this.dialogEl.addEventListener('cancel', event => {
      event.preventDefault();
    });
  },

  computed: {
    dialogClassName() {
      const className = ['nebula-dialog', `nebula-dialog--${this.size}`];
      return className;
    },

    dialogContainerClassName() {
      const className = ['nebula-dialog-container', {
        'nebula-dialog-container--takeover': this.takeover === true
      }];
      return className;
    },

    dialogEl() {
      return document.getElementById(this.getDialogId);
    },

    getDialogId() {
      if (this.$props.id) {
        return this.$props.id;
      }

      return `nebula-dialog--${Math.random().toString(36).substring(2, 10)}`;
    },

    getDialogElement() {
      return this.formConfig ? 'form' : 'div';
    },

    dialogInnerEl() {
      return this.dialogEl.querySelector('.nebula-dialog__inner');
    },

    hasActionsRow() {
      return !!this.$slots['actions-row'];
    },

    hasStickyActionsRow() {
      return !!this.$slots['sticky-actions-row'];
    },

    hasStickyHeader() {
      return !!this.$slots['sticky-header'];
    },

    hasHeader() {
      return !!this.$slots.header;
    },

    hasTrigger() {
      return !!this.$slots.trigger;
    },

    headerContainerClass() {
      let className = '';

      if (this.hideCloseButton) {
        className = 'nebula-dialog__header-container--full-width';
      } else {
        className = 'nebula-dialog__header-container';
      }

      return className;
    }

  },
  methods: {
    checkOnClickClose(e) {
      if (!this.dialogInnerEl.contains(e.target)) {
        this.closeDialog();
      }
    },

    closeDialog() {
      this.dialogVisible = false;
      this.dialogEl.close();
      this.$emit('closed-dialog');
      document.body.style.overflow = 'initial';
    },

    handleKeyUpEvent(e) {
      if (e.key === 'Escape') {
        this.closeDialog();
      }
    },

    onClickClose() {
      this.closeDialog();
    },

    showDialog() {
      if (!this.dialogVisible) {
        this.dialogEl.showModal();
        this.dialogVisible = true;
        this.$emit('opened-dialog');
        document.body.style.overflow = 'hidden';
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/Dialog/NebulaDialog.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Dialog/NebulaDialog.vue?vue&type=style&index=0&id=06e01d37&lang=stylus
var NebulaDialogvue_type_style_index_0_id_06e01d37_lang_stylus = __webpack_require__("9874");

// CONCATENATED MODULE: ./src/components/Dialog/NebulaDialog.vue







const NebulaDialog_exports_ = /*#__PURE__*/exportHelper_default()(NebulaDialogvue_type_script_lang_js, [['render',NebulaDialogvue_type_template_id_06e01d37_render]])

/* harmony default export */ var NebulaDialog = (NebulaDialog_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Draggable/NebulaDraggableCards.vue?vue&type=template&id=216cc2ba

const NebulaDraggableCardsvue_type_template_id_216cc2ba_hoisted_1 = ["id"];
const NebulaDraggableCardsvue_type_template_id_216cc2ba_hoisted_2 = ["textContent"];
const NebulaDraggableCardsvue_type_template_id_216cc2ba_hoisted_3 = ["textContent"];
function NebulaDraggableCardsvue_type_template_id_216cc2ba_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_draggable = Object(external_vue_["resolveComponent"])("draggable");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: "draggable-nebula-cards",
    id: $options.getId
  }, [!$props.disableDrag ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", {
    key: 0,
    id: "reorder-instructions",
    class: "nebula-screenreader-only",
    textContent: Object(external_vue_["toDisplayString"])($options.assistiveInstructions)
  }, null, 8, NebulaDraggableCardsvue_type_template_id_216cc2ba_hoisted_2)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", {
    "aria-live": "assertive",
    class: "nebula-screenreader-only",
    textContent: Object(external_vue_["toDisplayString"])($data.assistiveText)
  }, null, 8, NebulaDraggableCardsvue_type_template_id_216cc2ba_hoisted_3), Object(external_vue_["createVNode"])(_component_draggable, {
    list: $data.listItems,
    "force-fallback": true,
    group: $props.group,
    style: Object(external_vue_["normalizeStyle"])({
      cursor: $data.dragging ? 'pointer' : undefined
    }),
    disabled: $options.isDisabled,
    handle: $props.handle,
    "drag-class": $props.dragClass,
    "ghost-class": $props.ghostClass,
    class: Object(external_vue_["normalizeClass"])($props.wrapperClass),
    "component-data": $options.getDraggableData,
    "item-key": "id",
    tag: "ol",
    onInput: _cache[0] || (_cache[0] = $event => _ctx.$emit('input', $event)),
    onChange: _cache[1] || (_cache[1] = $event => _ctx.$emit('change', $event)),
    onStart: _cache[2] || (_cache[2] = $event => $data.dragging = true),
    onEnd: $options.onDragEnd,
    onClick: $options.preventClickWhileDragging
  }, {
    header: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "header")]),
    item: Object(external_vue_["withCtx"])(({
      element,
      index
    }) => [(Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.draggableElement), Object(external_vue_["mergeProps"])({
      key: element.id
    }, $options.componentProps(element), {
      class: $options.getDraggableItemClass,
      isFocusable: false,
      role: "option",
      "aria-describedby": "reorder-instructions",
      size: $props.smallProductBlocks ? 's' : 'm',
      whiteBackground: $props.whiteBackground,
      tabindex: "0",
      onKeydown: [Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])($event => $options.toggleGrabbed(element, index), ["prevent"]), ["space"]), Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])($event => $options.moveItem($event, true, index), ["prevent"]), ["down"]), Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])($event => $options.moveItem($event, false, index), ["prevent"]), ["up"]), Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])($options.handleEnterKey, ["prevent"]), ["enter"]), Object(external_vue_["withKeys"])(Object(external_vue_["withModifiers"])($event => $options.handleEscKey(element, index), ["prevent"]), ["esc"])]
    }), {
      actionsMenu: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "quickListItemActions", {
        asset: element
      })]),
      _: 2
    }, 1040, ["class", "size", "whiteBackground", "onKeydown"]))]),
    footer: Object(external_vue_["withCtx"])(() => [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.placeholderCount, i => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
        key: i,
        class: Object(external_vue_["normalizeClass"])($options.getPlaceholderClass)
      }, null, 2);
    }), 128)), Object(external_vue_["renderSlot"])(_ctx.$slots, "footer")]),
    _: 3
  }, 8, ["list", "group", "style", "disabled", "handle", "drag-class", "ghost-class", "class", "component-data", "onEnd", "onClick"])], 8, NebulaDraggableCardsvue_type_template_id_216cc2ba_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/Draggable/NebulaDraggableCards.vue?vue&type=template&id=216cc2ba

// EXTERNAL MODULE: ./node_modules/vuedraggable/dist/vuedraggable.umd.js
var vuedraggable_umd = __webpack_require__("b76a");
var vuedraggable_umd_default = /*#__PURE__*/__webpack_require__.n(vuedraggable_umd);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseDelay.js
/** Error message constants. */
var _baseDelay_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(_baseDelay_FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

/* harmony default export */ var _baseDelay = (baseDelay);

// CONCATENATED MODULE: ./node_modules/lodash-es/identity.js
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ var lodash_es_identity = (identity);

// CONCATENATED MODULE: ./node_modules/lodash-es/_apply.js
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ var _apply = (apply);

// CONCATENATED MODULE: ./node_modules/lodash-es/_overRest.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var _overRest_nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = _overRest_nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = _overRest_nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

/* harmony default export */ var _overRest = (overRest);

// CONCATENATED MODULE: ./node_modules/lodash-es/constant.js
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ var lodash_es_constant = (constant);

// CONCATENATED MODULE: ./node_modules/lodash-es/isFunction.js



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!lodash_es_isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ var lodash_es_isFunction = (isFunction);

// CONCATENATED MODULE: ./node_modules/lodash-es/_coreJsData.js


/** Used to detect overreaching core-js shims. */
var coreJsData = _root["a" /* default */]['__core-js_shared__'];

/* harmony default export */ var _coreJsData = (coreJsData);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isMasked.js


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ var _isMasked = (isMasked);

// CONCATENATED MODULE: ./node_modules/lodash-es/_toSource.js
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ var _toSource = (toSource);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsNative.js





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var _baseIsNative_funcProto = Function.prototype,
    _baseIsNative_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var _baseIsNative_funcToString = _baseIsNative_funcProto.toString;

/** Used to check objects for own properties. */
var _baseIsNative_hasOwnProperty = _baseIsNative_objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  _baseIsNative_funcToString.call(_baseIsNative_hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!lodash_es_isObject(value) || _isMasked(value)) {
    return false;
  }
  var pattern = lodash_es_isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

/* harmony default export */ var _baseIsNative = (baseIsNative);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getValue.js
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ var _getValue = (getValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getNative.js



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

/* harmony default export */ var _getNative = (getNative);

// CONCATENATED MODULE: ./node_modules/lodash-es/_defineProperty.js


var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ var lodash_es_defineProperty = (defineProperty);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSetToString.js




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !lodash_es_defineProperty ? lodash_es_identity : function(func, string) {
  return lodash_es_defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': lodash_es_constant(string),
    'writable': true
  });
};

/* harmony default export */ var _baseSetToString = (baseSetToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_shortOut.js
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ var _shortOut = (shortOut);

// CONCATENATED MODULE: ./node_modules/lodash-es/_setToString.js



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

/* harmony default export */ var _setToString = (setToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseRest.js




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, lodash_es_identity), func + '');
}

/* harmony default export */ var _baseRest = (baseRest);

// CONCATENATED MODULE: ./node_modules/lodash-es/defer.js



/**
 * Defers invoking the `func` until the current call stack has cleared. Any
 * additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to defer.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.defer(function(text) {
 *   console.log(text);
 * }, 'deferred');
 * // => Logs 'deferred' after one millisecond.
 */
var defer = _baseRest(function(func, args) {
  return _baseDelay(func, 1, args);
});

/* harmony default export */ var lodash_es_defer = (defer);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ProductBlock/NebulaProductBlock.vue?vue&type=template&id=c71da114

const NebulaProductBlockvue_type_template_id_c71da114_hoisted_1 = ["aria-label", "href", "target", "data-click-name"];
const NebulaProductBlockvue_type_template_id_c71da114_hoisted_2 = {
  class: "nebula-product-block-card__inner"
};
const NebulaProductBlockvue_type_template_id_c71da114_hoisted_3 = {
  key: 2,
  class: "nebula-product-block-card__logo"
};
function NebulaProductBlockvue_type_template_id_c71da114_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  const _component_NebulaTitleTooltip = Object(external_vue_["resolveComponent"])("NebulaTitleTooltip");

  const _component_NebulaCard = Object(external_vue_["resolveComponent"])("NebulaCard");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaCard, Object(external_vue_["mergeProps"])({
    class: $options.className,
    element: $props.element,
    "use-push-state": $props.usePushState
  }, _ctx.$attrs, {
    style: _ctx.cssProps
  }), Object(external_vue_["createSlots"])({
    _: 2
  }, [$options.tooltip ? {
    name: "content",
    fn: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaTitleTooltip, {
      text: $options.tooltip
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("a", {
        "aria-label": $props.product.name,
        href: $options.url,
        target: $props.product.name === 'Mystery Science' ? '_blank' : null,
        class: "nebula-product-block-card__content",
        "data-click-name": $props.product.name,
        "data-click-type": "Curriculum Packs Navigation"
      }, [Object(external_vue_["createElementVNode"])("div", NebulaProductBlockvue_type_template_id_c71da114_hoisted_2, [$options.showIcon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
        key: 0,
        size: "xxl",
        "symbol-id": $options.icon,
        class: "nebula-product-block-card__icon"
      }, null, 8, ["symbol-id"])) : Object(external_vue_["createCommentVNode"])("", true), $options.logo ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
        key: 1,
        size: "xxl",
        "symbol-id": $options.logo,
        class: Object(external_vue_["normalizeClass"])(["nebula-product-block-card__logo", `nebula-product-block-card__logo--${$props.product.code.toLowerCase()}`])
      }, null, 8, ["symbol-id", "class"])) : Object(external_vue_["createCommentVNode"])("", true), !$options.logo ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", NebulaProductBlockvue_type_template_id_c71da114_hoisted_3, Object(external_vue_["toDisplayString"])($props.product.name), 1)) : Object(external_vue_["createCommentVNode"])("", true)])], 8, NebulaProductBlockvue_type_template_id_c71da114_hoisted_1)]),
      _: 1
    }, 8, ["text"])]),
    key: "0"
  } : {
    name: "content",
    fn: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("a", {
      "aria-label": $props.product.name,
      href: $options.url,
      target: $props.product.name === 'Mystery Science' && '_blank',
      class: "nebula-product-block-card__content",
      "data-click-name": $props.product.name,
      "data-click-type": "Curriculum Packs Navigation"
    }, [Object(external_vue_["createElementVNode"])("div", {
      class: "nebula-product-block-card__inner"
    }, [$options.showIcon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
      key: 0,
      size: "xxl",
      "symbol-id": $options.icon,
      class: "nebula-product-block-card__icon"
    }, null, 8, ["symbol-id"])) : Object(external_vue_["createCommentVNode"])("", true), $options.logo ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
      key: 1,
      size: "xxl",
      "symbol-id": $options.logo,
      class: Object(external_vue_["normalizeClass"])(["nebula-product-block-card__logo", `nebula-product-block-card__logo--${$props.product.code.toLowerCase()}`])
    }, null, 8, ["symbol-id", "class"])) : Object(external_vue_["createCommentVNode"])("", true), !$options.logo ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", {
      key: 2,
      class: "nebula-product-block-card__logo"
    }, Object(external_vue_["toDisplayString"])($props.product.name), 1)) : Object(external_vue_["createCommentVNode"])("", true)])], 8, ["aria-label", "href", "target", "data-click-name"])]),
    key: "1"
  }]), 1040, ["class", "element", "use-push-state", "style"]);
}
// CONCATENATED MODULE: ./src/components/ProductBlock/NebulaProductBlock.vue?vue&type=template&id=c71da114

// EXTERNAL MODULE: ./src/utils/constants/productConstant.json
var productConstant = __webpack_require__("653a");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ProductBlock/NebulaProductBlock.vue?vue&type=script&lang=js





/* harmony default export */ var NebulaProductBlockvue_type_script_lang_js = ({
  name: 'NebulaProductBlock',
  components: {
    NebulaCard: NebulaCard,
    NebulaIcon: NebulaIcon,
    NebulaTitleTooltip: NebulaTitleTooltip
  },
  mixins: [themingUtils],
  props: {
    element: {
      type: String,
      default: 'li'
    },
    product: {
      type: Object,
      required: true
    },
    size: {
      default: 'm',
      // options: s, m
      required: false,
      type: String
    },
    usePushState: {
      type: Boolean,
      default: false
    },
    whiteBackground: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    className() {
      const className = ['nebula-product-block-card', `nebula-product-block-card--${this.product.code.toLowerCase()}`, {
        'nebula-product-block-card--small': this.size === 's',
        'nebula-product-block-card--white-background': this.whiteBackground === true
      }];
      return className;
    },

    icon() {
      var _products$this$produc;

      return ((_products$this$produc = productConstant[this.product.code]) === null || _products$this$produc === void 0 ? void 0 : _products$this$produc.icon) || 'feedback-bug';
    },

    logo() {
      var _products$this$produc2, _products$this$produc4;

      if (this.size === 's' && (_products$this$produc2 = productConstant[this.product.code]) !== null && _products$this$produc2 !== void 0 && _products$this$produc2.smallLogo) {
        var _products$this$produc3;

        return (_products$this$produc3 = productConstant[this.product.code]) === null || _products$this$produc3 === void 0 ? void 0 : _products$this$produc3.smallLogo;
      }

      return (_products$this$produc4 = productConstant[this.product.code]) === null || _products$this$produc4 === void 0 ? void 0 : _products$this$produc4.logo;
    },

    showIcon() {
      return this.size === 'm';
    },

    tooltip() {
      var _products$this$produc5;

      return ((_products$this$produc5 = productConstant[this.product.code]) === null || _products$this$produc5 === void 0 ? void 0 : _products$this$produc5.tooltip) || false;
    },

    url() {
      return this.product.resume_url || this.product.url;
    }

  }
});
// CONCATENATED MODULE: ./src/components/ProductBlock/NebulaProductBlock.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/ProductBlock/NebulaProductBlock.vue?vue&type=style&index=0&id=c71da114&lang=stylus
var NebulaProductBlockvue_type_style_index_0_id_c71da114_lang_stylus = __webpack_require__("d2f1");

// CONCATENATED MODULE: ./src/components/ProductBlock/NebulaProductBlock.vue







const NebulaProductBlock_exports_ = /*#__PURE__*/exportHelper_default()(NebulaProductBlockvue_type_script_lang_js, [['render',NebulaProductBlockvue_type_template_id_c71da114_render]])

/* harmony default export */ var NebulaProductBlock = (NebulaProductBlock_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/QuickList/NebulaQuickListCard.vue?vue&type=template&id=41d81b8f

const NebulaQuickListCardvue_type_template_id_41d81b8f_hoisted_1 = ["href", "tabindex"];
const NebulaQuickListCardvue_type_template_id_41d81b8f_hoisted_2 = {
  class: "nebula-screenreader-only"
};
const NebulaQuickListCardvue_type_template_id_41d81b8f_hoisted_3 = {
  class: "nebula-quicklist-card__content"
};
const NebulaQuickListCardvue_type_template_id_41d81b8f_hoisted_4 = {
  class: "nebula-quicklist-card__header"
};
const NebulaQuickListCardvue_type_template_id_41d81b8f_hoisted_5 = {
  class: "nebula-quicklist-card__type"
};
const NebulaQuickListCardvue_type_template_id_41d81b8f_hoisted_6 = {
  class: "nebula-quicklist-card__action"
};
const NebulaQuickListCardvue_type_template_id_41d81b8f_hoisted_7 = {
  class: "nebula-quicklist-card__title"
};
const NebulaQuickListCardvue_type_template_id_41d81b8f_hoisted_8 = ["href"];
function NebulaQuickListCardvue_type_template_id_41d81b8f_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaThumbnail = Object(external_vue_["resolveComponent"])("NebulaThumbnail");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.element), Object(external_vue_["mergeProps"])({
    class: "nebula-quicklist-card"
  }, _ctx.$attrs), {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("a", Object(external_vue_["mergeProps"])({
      href: $props.itemUrl,
      class: "nebula-quicklist-card__anchor"
    }, $props.dataAttrs, {
      class: $props.usePushState && 'do-push-state',
      "data-click-name": "Quick List Item",
      "data-click-type": "Profile & Favorites Navigation",
      tabindex: $options.tabIndexValue
    }), [Object(external_vue_["createVNode"])(_component_NebulaThumbnail, {
      class: "nebula-quicklist-card__thumbnail",
      assetId: $props.asset.id,
      assetType: $props.asset.type.name,
      imageSize: "medium"
    }, null, 8, ["assetId", "assetType"]), Object(external_vue_["createElementVNode"])("span", NebulaQuickListCardvue_type_template_id_41d81b8f_hoisted_2, Object(external_vue_["toDisplayString"])($options.stripTags($options.assetTitle)), 1)], 16, NebulaQuickListCardvue_type_template_id_41d81b8f_hoisted_1), Object(external_vue_["createElementVNode"])("div", NebulaQuickListCardvue_type_template_id_41d81b8f_hoisted_3, [Object(external_vue_["createElementVNode"])("div", NebulaQuickListCardvue_type_template_id_41d81b8f_hoisted_4, [Object(external_vue_["createElementVNode"])("h4", NebulaQuickListCardvue_type_template_id_41d81b8f_hoisted_5, Object(external_vue_["toDisplayString"])(_ctx.$t($props.asset.type.name)), 1), Object(external_vue_["createElementVNode"])("div", NebulaQuickListCardvue_type_template_id_41d81b8f_hoisted_6, [Object(external_vue_["renderSlot"])(_ctx.$slots, "actionsMenu")])]), Object(external_vue_["createElementVNode"])("h3", NebulaQuickListCardvue_type_template_id_41d81b8f_hoisted_7, [Object(external_vue_["createElementVNode"])("a", {
      href: $props.itemUrl,
      class: "nebula-quicklist-card__link",
      "data-click-name": "Quick List Item",
      "data-click-type": "Profile & Favorites Navigation"
    }, Object(external_vue_["toDisplayString"])($props.asset.title), 9, NebulaQuickListCardvue_type_template_id_41d81b8f_hoisted_8)])])]),
    _: 3
  }, 16);
}
// CONCATENATED MODULE: ./src/components/QuickList/NebulaQuickListCard.vue?vue&type=template&id=41d81b8f

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/QuickList/NebulaQuickListCard.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaQuickListCardvue_type_script_lang_js = ({
  name: 'NebulaQuickListCard',
  components: {
    NebulaThumbnail: NebulaThumbnail
  },
  props: {
    asset: Object,
    dataAttrs: Object,
    itemUrl: String,
    usePushState: {
      type: Boolean,
      default: false
    },
    element: {
      type: String,
      default: 'li'
    },
    isFocusable: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    }
  },
  computed: {
    assetTitle() {
      let title = '';

      if (this.title) {
        title = this.title;
      }

      if (this.asset.title) {
        title = this.asset.title;
      } else {
        title = this.asset.name;
      }

      return title;
    },

    tabIndexValue() {
      return this.isFocusable ? 0 : -1;
    }

  },
  methods: {
    stripTags: parsing_stripTags
  }
});
// CONCATENATED MODULE: ./src/components/QuickList/NebulaQuickListCard.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/QuickList/NebulaQuickListCard.vue?vue&type=style&index=0&id=41d81b8f&lang=stylus
var NebulaQuickListCardvue_type_style_index_0_id_41d81b8f_lang_stylus = __webpack_require__("fd82");

// CONCATENATED MODULE: ./src/components/QuickList/NebulaQuickListCard.vue







const NebulaQuickListCard_exports_ = /*#__PURE__*/exportHelper_default()(NebulaQuickListCardvue_type_script_lang_js, [['render',NebulaQuickListCardvue_type_template_id_41d81b8f_render]])

/* harmony default export */ var NebulaQuickListCard = (NebulaQuickListCard_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Draggable/NebulaDraggableCards.vue?vue&type=script&lang=js
/* eslint-disable no-multiple-empty-lines, max-len */

/*
    How to use this component.
    When using the <NebulaDraggableCards> component, this component needs these props passed in:
        list:           The Array of objects that the slot(default) will be rendering with it's for-loop.
        disable-drag:   This Boolean value will not only disable/enable the draggable feature, but also disable/enable
                        some assistive technology features.

    @changes-saved-on-esc:  This emitter listener listens for the Esc key to be pressed. This NebulaDraggableCards component is
                                is only responsible for changing the state of "isGrabbed" to false. This should "drop" the list-item
                                in it's current location, update the assistiveText to inform the user that they changes has been "saved",
                                then emit the "changes-saved-esc" string.
                            It's up to the parent component to handle the state of the `disable-drag` props value and set the focused
                                element back to the controlling button, or where ever they please.

    draggable #item
        role="option"                                           This will tell the screen readers that this is one of the
                                                                    options for the order-list, listbox. If an option or item
                                                                    is focused within the list, it gets announced, followed
                                                                    by an indication of the item's position with the list if the
                                                                    screen reader supports this. As focus moves within the list,
                                                                    the screen reader announces the relevant items.
        draggable="true"                                        Assistive tech will indicate that this is a draggable item.
        aria-describedby="reorder-instructions"                 The hover-over affect will read the dynamic text to help
                                                                    users with reordering.
        tabindex="0"                                            This will ensure the <li> element gets focused on, regardless on
                                                                    whether or not the child elements has a focusable element.
        @keydown.space.prevent="toggleGrabbed(asset, index)"    Space bar is used to grab/drop the focused element.
        @keydown.down.prevent="moveItem($event, true, index)"   Up and Down keys will move the list-item when pressed.
        @keydown.up.prevent="moveItem($event, false, index)"
        @keydown.enter.prevent="handleEnterKey"                 Pressing "Enter" on the focused element will allow the click event to fire.
        @keydown.esc.prevent="handleEscKey(listItemObject, index)"      When user has a list-item grabbed, and uses the Esc key to
                                                                            save changes and escape reordering feature.
                                                                                ** listItemObject - Is the data object passed in from the "list" props.
                                                                                ** index - Is the index of the listItem that was last moved.
*/

/* eslint-enable no-multiple-empty-lines, max-len */





/* harmony default export */ var NebulaDraggableCardsvue_type_script_lang_js = ({
  name: 'NebulaDraggableCards',
  props: {
    dragClass: {
      type: String,
      default: 'sortable-drag'
    },
    draggableItemConfig: {
      type: [Object, Function],
      default: null
    },
    draggableElement: {
      type: String,
      default: 'NebulaProductBlock'
    },
    disableDrag: {
      type: Boolean,
      default: true
    },
    ghostClass: {
      type: String,
      default: 'sortable-ghost'
    },
    group: {
      type: String,
      default: null
    },
    handle: {
      type: String,
      default: '.nebula-product-block-card'
    },
    id: {
      type: [String, Number],
      default: null
    },
    list: {
      type: Array,
      default: () => []
    },
    placeholderClass: {
      type: String,
      default: null
    },
    placeholderCount: {
      type: Number,
      default: 6
    },
    smallProductBlocks: {
      type: Boolean,
      default: false
    },
    whiteBackground: {
      type: Boolean,
      default: false
    },
    wrapperClass: {
      type: String,
      default: null
    }
  },
  emits: ['input', 'change', 'changes-saved-on-esc', 'save-order'],
  components: {
    draggable: vuedraggable_umd_default.a,
    NebulaProductBlock: NebulaProductBlock,
    NebulaQuickListCard: NebulaQuickListCard
  },

  data() {
    return {
      assistiveText: '',
      dragging: false,
      isGrabbed: false,
      windowSize: null,
      keyboardMovement: false,
      listItems: [],
      activeNames: null
    };
  },

  methods: {
    cloneDeep(object) {
      return JSON.parse(JSON.stringify(object));
    },

    componentProps(element) {
      let componentProps = {};

      if (this.draggableElement === 'NebulaProductBlock') {
        componentProps = {
          product: { ...element
          }
        };
      } else if (this.draggableElement === 'NebulaQuickListCard') {
        // this might need to be approached differently
        const assetItemUrl = `/learn/player/${element.id}?utm_source=${element.id}&utm_medium=quicklist&utm_campaign=hublinks`;
        componentProps = {
          asset: { ...element
          },
          itemUrl: assetItemUrl
        };
      }

      if (this.draggableItemConfig && typeof this.draggableItemConfig === 'function') {
        Object.assign(componentProps, this.draggableItemConfig(element));
      } else if (this.draggableItemConfig) {
        Object.assign(componentProps, this.draggableItemConfig);
      }

      return componentProps;
    },

    onDragEnd() {
      lodash_es_defer(() => {
        this.dragging = false;
      });
    },

    preventClickWhileDragging(event) {
      if (this.dragging) event.preventDefault();
    },

    setWindowSize() {
      this.windowSize = window.innerWidth;
      return null;
    },

    getItemPosition(index) {
      return this.$t('%(currentIndex)s of %(total)s', {
        currentIndex: index + 1,
        total: this.listItems.length
      });
    },

    handleEnterKey(event) {
      const clickableEl = event.srcElement.querySelector('button, a');
      if (clickableEl) clickableEl.click();
    },

    handleEscKey(listItemObject, index) {
      if (this.isDisabled) return;

      if (this.isGrabbed) {
        this.assistiveText = this.$t('Saved changes.');
        setTimeout(() => {
          this.toggleGrabbed(listItemObject, index);
          this.$emit('changes-saved-on-esc');
        }, 1500);
      }
    },

    handleItemDropped(listItem) {
      const index = this.listItems.findIndex(listItemToFind => listItemToFind.id === listItem.id);
      this.$emit('change', {
        moved: {
          newIndex: index,
          element: listItem
        }
      });
      this.assistiveText = this.$t('%(name)s, dropped. Final position in list: %(currentPos)s', {
        name: listItem.name,
        currentPos: this.getItemPosition(index)
      });
    },

    handleItemGrabbed(listItem, index) {
      /* eslint-disable-next-line max-len */
      this.assistiveText = this.$t('%(name)s, grabbed. Current position in list: %(currentPos)s. Press up and down arrows to change position, spacebar to drop.', {
        name: listItem.name,
        currentPos: this.getItemPosition(index)
      });
    },

    inputChanged(value) {
      this.activeNames = value;
    },

    moveItem(event, moveDown, dragIndex) {
      const hoverIndex = moveDown ? dragIndex + 1 : dragIndex - 1;

      if (hoverIndex < 0 || hoverIndex >= this.list.length || !this.isGrabbed || this.isDisabled) {
        return;
      }

      const listCopy = this.cloneDeep(this.listItems);
      const draggedItem = listCopy[dragIndex];
      listCopy.splice(dragIndex, 1);
      listCopy.splice(hoverIndex, 0, draggedItem);
      this.listItems = listCopy;
      this.assistiveText = this.$t('%(name)s. New position in list: %(newPos)s', {
        name: draggedItem.name,
        newPos: this.getItemPosition(hoverIndex)
      });
      this.$nextTick(() => {
        const itemIndex = this.listItems.findIndex(listItemToFind => listItemToFind.id === draggedItem.id);
        this.getDraggableCardsList.children[itemIndex].focus();
      });
    },

    toggleGrabbed(listItem, index) {
      if (this.isDisabled) return;

      if (this.isGrabbed) {
        this.keyboardMovement = false;
        this.isGrabbed = false;
        this.handleItemDropped(listItem);
      } else {
        this.keyboardMovement = true;
        this.isGrabbed = true;
        this.handleItemGrabbed(listItem, index);
      }
    }

  },
  computed: {
    animateName() {
      return this.keyboardMovement ? 'draggable-nebula-cards__list-items' : 'nebula-cards__list-items';
    },

    assistiveInstructions() {
      return this.isGrabbed ? this.$t('Press the spacebar to drop this item to reorder.') : this.$t('Press the spacebar to grab this item to reorder.');
    },

    getDraggableData() {
      return {
        class: 'draggable-nebula-cards__list',
        name: this.animateName,
        onChange: this.handleChange,
        onInput: this.inputChanged,
        role: 'listbox',
        tag: 'ol',
        wrap: true,
        value: this.activeNames
      };
    },

    getDraggableCardsList() {
      return document.getElementById(this.getId).querySelector('.draggable-nebula-cards__list');
    },

    getDraggableItemClass() {
      const className = [{
        'nebula-quicklist-panel__content-item': this.draggableElement === 'NebulaQuickListCard'
      }];
      return className;
    },

    getId() {
      let dragId = '';

      if (this.id) {
        dragId = this.id;
      } else {
        dragId = `nebula-draggabled-cards--${this.randomStringId}`;
      }

      return dragId;
    },

    getPlaceholderClass() {
      let className = '';

      if (this.smallProductBlocks) {
        className = 'nebula-card nebula-card--invisible nebula-product-block-card nebula-product-block-card--small';
      } else if (this.placeholderClass) {
        className = this.placeholderClass;
      } else {
        className = 'nebula-card nebula-card--invisible nebula-product-block-card';
      }

      return className;
    },

    isDisabled() {
      // disable all drag below 1200px screen width
      if (this.isMobile) {
        return true;
      }

      let isDisabled = false;

      if (!this.list) {
        isDisabled = !this.value || this.value.length <= 1 || this.isMobile || this.disableDrag;
      } else {
        isDisabled = this.isMobile || this.disableDrag;
      }

      return isDisabled;
    },

    isMobile() {
      return this.windowSize < 1200;
    },

    listItemsDeepClone() {
      return this.cloneDeep(this.listItems);
    },

    randomStringId() {
      return randomStringId();
    }

  },

  mounted() {
    this.windowSize = window.innerWidth;
    this.listItems = this.list;
    window.addEventListener('resize', this.setWindowSize);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.setWindowSize);
  },

  watch: {
    isDisabled(next) {
      // if setting to true, disabling drag
      if (next) {
        this.$emit('save-order');
      }
    },

    list: {
      handler(newList, oldList) {
        if (newList.length !== oldList.length) {
          this.listItems = newList;
        }
      },

      deep: true
    },
    listItems: {
      handler(newList, oldList) {
        if (JSON.stringify(newList) !== JSON.stringify(oldList)) {
          this.listItems = newList;
        }
      },

      deep: true
    }
  }
});
// CONCATENATED MODULE: ./src/components/Draggable/NebulaDraggableCards.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Draggable/NebulaDraggableCards.vue?vue&type=style&index=0&id=216cc2ba&lang=stylus
var NebulaDraggableCardsvue_type_style_index_0_id_216cc2ba_lang_stylus = __webpack_require__("8294");

// CONCATENATED MODULE: ./src/components/Draggable/NebulaDraggableCards.vue







const NebulaDraggableCards_exports_ = /*#__PURE__*/exportHelper_default()(NebulaDraggableCardsvue_type_script_lang_js, [['render',NebulaDraggableCardsvue_type_template_id_216cc2ba_render]])

/* harmony default export */ var NebulaDraggableCards = (NebulaDraggableCards_exports_);
// EXTERNAL MODULE: ./src/assets/public-security-recordal.png
var public_security_recordal = __webpack_require__("270d");
var public_security_recordal_default = /*#__PURE__*/__webpack_require__.n(public_security_recordal);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Footer/NebulaFooter.vue?vue&type=template&id=7b26c40e


const NebulaFootervue_type_template_id_7b26c40e_hoisted_1 = {
  key: 1,
  class: "nebula-footer__inner-wrap"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_2 = {
  key: 0,
  class: "nebula-footer__top"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_3 = {
  class: "nebula-footer__block nebula-footer__block-start"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_4 = ["href", "aria-label"];
const NebulaFootervue_type_template_id_7b26c40e_hoisted_5 = ["alt", "src"];
const NebulaFootervue_type_template_id_7b26c40e_hoisted_6 = {
  class: "nebula-footer__links"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_7 = {
  key: 0,
  class: "nebula-footer__link-list"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_8 = {
  class: "nebula-footer__social-link-container"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_9 = {
  key: 0,
  class: "nebula-footer__social-link-list"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_10 = {
  class: "nebula-footer__block nebula-footer__block-end"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_11 = {
  key: 0,
  class: "nebula-footer__public-security-recordal-wrapper"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_12 = ["alt"];
const NebulaFootervue_type_template_id_7b26c40e_hoisted_13 = {
  class: "nebula-footer__public-security-recordal-link",
  href: "https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=64050202000147",
  target: "_blank"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_14 = {
  class: "nebula-screenreader-only"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_15 = {
  class: "nebula-footer__public-security-recordal-link",
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_16 = {
  class: "nebula-screenreader-only"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_17 = ["innerHTML"];
const NebulaFootervue_type_template_id_7b26c40e_hoisted_18 = {
  key: 2,
  class: "nebula-footer__inner-wrap"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_19 = {
  class: "nebula-footer__logo"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_20 = ["href"];
const NebulaFootervue_type_template_id_7b26c40e_hoisted_21 = ["alt", "src"];
const NebulaFootervue_type_template_id_7b26c40e_hoisted_22 = {
  class: "nebula-footer__info"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_23 = {
  class: "nebula-footer__links"
};
const NebulaFootervue_type_template_id_7b26c40e_hoisted_24 = {
  key: 0,
  class: "nebula-footer__link-list"
};
const _hoisted_25 = ["innerHTML"];
function NebulaFootervue_type_template_id_7b26c40e_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaBackToTop = Object(external_vue_["resolveComponent"])("NebulaBackToTop");

  const _component_NebulaFooterLink = Object(external_vue_["resolveComponent"])("NebulaFooterLink");

  const _component_NebulaFooterCharacter = Object(external_vue_["resolveComponent"])("NebulaFooterCharacter");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("footer", {
    class: Object(external_vue_["normalizeClass"])(['nebula-footer', {
      'nebula-footer--simple': $props.simpleFooter == true
    }]),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [this.backToTop ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaBackToTop, {
    key: 0,
    ref: "backToTop",
    style: Object(external_vue_["normalizeStyle"])(`top: -${this.backToTopHeight / 2}px`),
    customStyles: {
      fabPosition: 'absolute',
      fabBottom: 'auto'
    }
  }, null, 8, ["style"])) : Object(external_vue_["createCommentVNode"])("", true), !$props.simpleFooter && (!$props.userIsStudent || $props.userIsStudent && $props.countryCode === 'CN') ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaFootervue_type_template_id_7b26c40e_hoisted_1, [!$props.userIsStudent ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaFootervue_type_template_id_7b26c40e_hoisted_2, [Object(external_vue_["createElementVNode"])("div", NebulaFootervue_type_template_id_7b26c40e_hoisted_3, [Object(external_vue_["createElementVNode"])("a", {
    href: $options.homeLogoUrl,
    "aria-label": _ctx.$t('Home')
  }, [Object(external_vue_["createElementVNode"])("img", {
    class: "nebula-footer__de-logo",
    alt: _ctx.$t('Discovery Education Logo'),
    src: $options.homeLogo,
    height: "68",
    width: "80"
  }, null, 8, NebulaFootervue_type_template_id_7b26c40e_hoisted_5)], 8, NebulaFootervue_type_template_id_7b26c40e_hoisted_4), Object(external_vue_["createElementVNode"])("div", NebulaFootervue_type_template_id_7b26c40e_hoisted_6, [Object(external_vue_["renderSlot"])(_ctx.$slots, "customLinks"), !_ctx.$slots.customLinks ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("ul", NebulaFootervue_type_template_id_7b26c40e_hoisted_7, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.getFooterLinks, (link, i) => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, [!link.isHidden ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
      key: i,
      class: "nebula-footer__link-list-item"
    }, [Object(external_vue_["createVNode"])(_component_NebulaFooterLink, {
      link: link,
      class: Object(external_vue_["normalizeClass"])(link['custom-class-name'])
    }, null, 8, ["link", "class"])])) : Object(external_vue_["createCommentVNode"])("", true)], 64);
  }), 256))])) : Object(external_vue_["createCommentVNode"])("", true)]), Object(external_vue_["createElementVNode"])("div", NebulaFootervue_type_template_id_7b26c40e_hoisted_8, [Object(external_vue_["renderSlot"])(_ctx.$slots, "customSocialLinks"), !_ctx.$slots.customSocialLinks ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("ul", NebulaFootervue_type_template_id_7b26c40e_hoisted_9, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.getSocialLinks, (link, i) => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
      key: i,
      class: "nebula-footer__social-link-list-item"
    }, [Object(external_vue_["createVNode"])(_component_NebulaFooterLink, {
      link: link,
      socialLink: ""
    }, null, 8, ["link"])]);
  }), 128))])) : Object(external_vue_["createCommentVNode"])("", true)])]), Object(external_vue_["createElementVNode"])("div", NebulaFootervue_type_template_id_7b26c40e_hoisted_10, [Object(external_vue_["createVNode"])(_component_NebulaFooterCharacter)])])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", {
    class: Object(external_vue_["normalizeClass"])(["nebula-footer__bottom", $props.userIsStudent ? 'nebula-footer__bottom--student' : null])
  }, [$props.countryCode === 'CN' ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", NebulaFootervue_type_template_id_7b26c40e_hoisted_11, [Object(external_vue_["createElementVNode"])("img", {
    src: public_security_recordal_default.a,
    alt: _ctx.$t('public security recordal')
  }, null, 8, NebulaFootervue_type_template_id_7b26c40e_hoisted_12), Object(external_vue_["createElementVNode"])("a", NebulaFootervue_type_template_id_7b26c40e_hoisted_13, [Object(external_vue_["createTextVNode"])(" 京公网安备 11010802035977号 "), Object(external_vue_["createElementVNode"])("span", NebulaFootervue_type_template_id_7b26c40e_hoisted_14, Object(external_vue_["toDisplayString"])(_ctx.$t('opens in new window')), 1)]), Object(external_vue_["createTextVNode"])(" | "), Object(external_vue_["createElementVNode"])("a", NebulaFootervue_type_template_id_7b26c40e_hoisted_15, [Object(external_vue_["createTextVNode"])(" 京ICP备20004782号-6 "), Object(external_vue_["createElementVNode"])("span", NebulaFootervue_type_template_id_7b26c40e_hoisted_16, Object(external_vue_["toDisplayString"])(_ctx.$t('opens in new window')), 1)])])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("p", {
    innerHTML: _ctx.$t('Copyright © %(year)s %(name)s. All rights reserved. %(name)s, Inc.', {
      year: $options.getYear,
      name: 'Discovery Education'
    })
  }, null, 8, NebulaFootervue_type_template_id_7b26c40e_hoisted_17), Object(external_vue_["renderSlot"])(_ctx.$slots, "info")], 2)])) : Object(external_vue_["createCommentVNode"])("", true), $props.simpleFooter ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaFootervue_type_template_id_7b26c40e_hoisted_18, [Object(external_vue_["createElementVNode"])("div", NebulaFootervue_type_template_id_7b26c40e_hoisted_19, [Object(external_vue_["createElementVNode"])("a", {
    href: $options.discoveryEducationUrl,
    target: "_blank"
  }, [Object(external_vue_["createElementVNode"])("img", {
    class: "nebula-footer__de-logo",
    alt: _ctx.$t('Discovery Education Logo'),
    src: $options.homeLogo,
    height: "68px",
    width: "80px"
  }, null, 8, NebulaFootervue_type_template_id_7b26c40e_hoisted_21)], 8, NebulaFootervue_type_template_id_7b26c40e_hoisted_20)]), Object(external_vue_["createElementVNode"])("div", NebulaFootervue_type_template_id_7b26c40e_hoisted_22, [Object(external_vue_["createElementVNode"])("div", NebulaFootervue_type_template_id_7b26c40e_hoisted_23, [Object(external_vue_["renderSlot"])(_ctx.$slots, "customLinks"), !_ctx.$slots.customLinks ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("ul", NebulaFootervue_type_template_id_7b26c40e_hoisted_24, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.getFooterLinks, (link, i) => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
      key: i,
      class: "nebula-footer__link-list-item"
    }, [Object(external_vue_["createVNode"])(_component_NebulaFooterLink, {
      link: link,
      class: Object(external_vue_["normalizeClass"])(link['custom-class-name'])
    }, null, 8, ["link", "class"])]);
  }), 128))])) : Object(external_vue_["createCommentVNode"])("", true)]), Object(external_vue_["createElementVNode"])("p", {
    class: "nebula-footer__copyright",
    innerHTML: _ctx.$t('Copyright © %(year)s %(name)s. All rights reserved. %(name)s, Inc.', {
      year: $options.getYear,
      name: 'Discovery Education'
    })
  }, null, 8, _hoisted_25)])])) : Object(external_vue_["createCommentVNode"])("", true)], 6);
}
// CONCATENATED MODULE: ./src/components/Footer/NebulaFooter.vue?vue&type=template&id=7b26c40e

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Footer/NebulaFooterCharacter.vue?vue&type=template&id=511e6fc5

const NebulaFooterCharactervue_type_template_id_511e6fc5_hoisted_1 = {
  class: "nebula-speech-bubble__container"
};
const NebulaFooterCharactervue_type_template_id_511e6fc5_hoisted_2 = {
  class: "nebula-speech-bubble"
};

const NebulaFooterCharactervue_type_template_id_511e6fc5_hoisted_3 = /*#__PURE__*/Object(external_vue_["createStaticVNode"])("<div class=\"nebula-speech-bubble__svg-container\"><svg class=\"nebula-speech-bubble__svg\" width=\"100%\" height=\"100%\" viewBox=\"0 0 301 144\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"none\"><g filter=\"url(#filter0_d_9375_55277)\"><path d=\"M248.244 121.249L254.188 128.027C255.014 128.969 255.427 129.44 255.759 129.565C256.423 129.815 257.17 129.534 257.504 128.908C257.672 128.595 257.672 127.969 257.672 126.715C257.672 123.866 257.672 122.441 258.052 121.29C258.801 119.019 260.582 117.237 262.854 116.488C264.005 116.108 265.43 116.108 268.279 116.108H273.908C281.023 116.108 284.58 116.108 286.79 113.898C289 111.688 289 108.131 289 101.016V33.4507C289 26.5411 289 23.0863 286.874 20.8916C284.748 18.697 281.295 18.5869 274.389 18.3667L27.5727 10.4966C20.252 10.2631 16.5917 10.1464 14.2958 12.3702C12 14.594 12 18.2562 12 25.5806V101.016C12 108.131 12 111.688 14.2101 113.898C16.4203 116.108 19.9774 116.108 27.0917 116.108H236.898C240.263 116.108 241.946 116.108 243.431 116.781C244.915 117.453 246.025 118.719 248.244 121.249Z\" fill=\"white\"></path></g><defs><filter id=\"filter0_d_9375_55277\" x=\"0.209607\" y=\"0.472779\" width=\"300.581\" height=\"142.86\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\"><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"></feColorMatrix><feOffset dy=\"1.88646\"></feOffset><feGaussianBlur stdDeviation=\"5.8952\"></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"out\"></feComposite><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0\"></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_9375_55277\"></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_9375_55277\" result=\"shape\"></feBlend></filter></defs></svg></div>", 1);

const NebulaFooterCharactervue_type_template_id_511e6fc5_hoisted_4 = {
  class: "nebula-speech-bubble__text-container"
};
const NebulaFooterCharactervue_type_template_id_511e6fc5_hoisted_5 = ["textContent"];
const NebulaFooterCharactervue_type_template_id_511e6fc5_hoisted_6 = {
  class: "nebula-footer__character-container"
};
const NebulaFooterCharactervue_type_template_id_511e6fc5_hoisted_7 = ["src", "alt"];
function NebulaFooterCharactervue_type_template_id_511e6fc5_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])(['nebula-footer__character', $data.currentCharacter.bubbleOnTop && 'nebula-footer__character--bubble-on-top'])
  }, [Object(external_vue_["createElementVNode"])("div", NebulaFooterCharactervue_type_template_id_511e6fc5_hoisted_1, [Object(external_vue_["createElementVNode"])("div", NebulaFooterCharactervue_type_template_id_511e6fc5_hoisted_2, [NebulaFooterCharactervue_type_template_id_511e6fc5_hoisted_3, Object(external_vue_["createElementVNode"])("div", NebulaFooterCharactervue_type_template_id_511e6fc5_hoisted_4, [Object(external_vue_["createElementVNode"])("p", {
    class: "nebula-speech-bubble__text",
    textContent: Object(external_vue_["toDisplayString"])($data.currentCharacter.text)
  }, null, 8, NebulaFooterCharactervue_type_template_id_511e6fc5_hoisted_5)])])]), Object(external_vue_["createElementVNode"])("div", NebulaFooterCharactervue_type_template_id_511e6fc5_hoisted_6, [Object(external_vue_["createElementVNode"])("img", {
    class: "nebula-footer__character-image",
    src: $data.currentCharacter.imgPath,
    alt: $data.currentCharacter.alt
  }, null, 8, NebulaFooterCharactervue_type_template_id_511e6fc5_hoisted_7)])], 2);
}
// CONCATENATED MODULE: ./src/components/Footer/NebulaFooterCharacter.vue?vue&type=template&id=511e6fc5

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Footer/NebulaFooterCharacter.vue?vue&type=script&lang=js
/* eslint-disable global-require */
/* harmony default export */ var NebulaFooterCharactervue_type_script_lang_js = ({
  name: 'NebulaFooterCharacter',

  data() {
    return {
      currentCharacter: [],
      // These images are loaded here dynamically since they live in different places for
      // each parent app. require() takes care of finding the right path to the images
      character_bios: [{
        alt: this.$t('Disco the dog'),
        imgPath: __webpack_require__("a266"),
        text: this.$t('This is Disco. She loves to bring you helpful things every day. Do you need this backpack?'),
        bubbleOnTop: true
      }, {
        alt: this.$t('Keiki'),
        imgPath: __webpack_require__("2858"),
        text: this.$t('These are the Keiki. They love fuzzy things, new sounds and blowing bubbles. Isn’t the world AMAZING?')
      }, {
        alt: this.$t('Victor with a spaceship'),
        imgPath: __webpack_require__("8916"),
        text: this.$t('I’m Victor. I spend a lot of time wondering about stuff. Do you?')
      }, {
        alt: this.$t('Mei with a solar system model'),
        imgPath: __webpack_require__("5822"),
        text: this.$t('I’m Mei. I love to take things apart and see what they’re made of!')
      }, {
        alt: this.$t('Zoe wondering'),
        imgPath: __webpack_require__("bc0a"),
        text: this.$t('I’m Zoe and I love organizing my friends. Let’s do a project together RIGHT NOW!')
      }, {
        alt: this.$t('Eduardo reading a book'),
        imgPath: __webpack_require__("28f8"),
        text: this.$t('I’m Eduardo. Sometimes I stay up way too late solving complicated math problems. Can’t put ‘em down!')
      }, {
        alt: this.$t('Abuelo holding apples'),
        imgPath: __webpack_require__("604f"),
        text: this.$t('I am Abuelo. Delighted to meet you. How about a nice, healthy snack?')
      }]
    };
  },

  mounted() {
    this.currentCharacter = this.character_bios[this.getRandomValue];
  },

  computed: {
    getRandomValue() {
      return Math.floor(Math.random() * 7);
    }

  }
});
// CONCATENATED MODULE: ./src/components/Footer/NebulaFooterCharacter.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Footer/NebulaFooterCharacter.vue?vue&type=style&index=0&id=511e6fc5&lang=stylus
var NebulaFooterCharactervue_type_style_index_0_id_511e6fc5_lang_stylus = __webpack_require__("6eaf");

// CONCATENATED MODULE: ./src/components/Footer/NebulaFooterCharacter.vue







const NebulaFooterCharacter_exports_ = /*#__PURE__*/exportHelper_default()(NebulaFooterCharactervue_type_script_lang_js, [['render',NebulaFooterCharactervue_type_template_id_511e6fc5_render]])

/* harmony default export */ var NebulaFooterCharacter = (NebulaFooterCharacter_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Footer/NebulaFooterLink.vue?vue&type=template&id=9ca63bfa

const NebulaFooterLinkvue_type_template_id_9ca63bfa_hoisted_1 = ["href", "target", "aria-label", "data-click-name"];
const NebulaFooterLinkvue_type_template_id_9ca63bfa_hoisted_2 = {
  key: 0,
  class: "nebula-screenreader-only"
};
function NebulaFooterLinkvue_type_template_id_9ca63bfa_render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.socialLink ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("a", {
    key: 0,
    href: $props.link.link,
    class: Object(external_vue_["normalizeClass"])(`nebula-footer__social-link nebula-footer__social-link--${$props.link.text.toLowerCase()}`),
    style: Object(external_vue_["normalizeStyle"])($options.footerSpriteStyle),
    target: $props.link.target,
    "aria-label": `${_ctx.$t($props.link.text)} ${_ctx.$t('opens in new window')}`,
    "data-click-name": $props.link.text,
    "data-click-type": "Footer Navigation"
  }, [Object(external_vue_["createElementVNode"])("span", {
    class: "nebula-footer__social-link-overlay",
    style: Object(external_vue_["normalizeStyle"])($options.footerSpriteStyle)
  }, null, 4)], 14, NebulaFooterLinkvue_type_template_id_9ca63bfa_hoisted_1)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.link.routerLink ? 'nuxt-link' : 'a'), {
    key: 1,
    class: "nebula-footer__link",
    href: $props.link.link,
    target: $props.link.target,
    "data-click-name": $props.link.text,
    "data-click-type": "Footer Navigation"
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(_ctx.$t(`${$props.link.text}`)) + " ", 1), $props.link.href === '_blank' ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", NebulaFooterLinkvue_type_template_id_9ca63bfa_hoisted_2, Object(external_vue_["toDisplayString"])(_ctx.$t('opens in new window')), 1)) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 1
  }, 8, ["href", "target", "data-click-name"]));
}
// CONCATENATED MODULE: ./src/components/Footer/NebulaFooterLink.vue?vue&type=template&id=9ca63bfa

// EXTERNAL MODULE: ./src/assets/footer-sprite.png
var footer_sprite = __webpack_require__("94e3");
var footer_sprite_default = /*#__PURE__*/__webpack_require__.n(footer_sprite);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Footer/NebulaFooterLink.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaFooterLinkvue_type_script_lang_js = ({
  name: 'NebulaFooterLink',
  props: {
    link: {
      type: Object,
      default: null
    },
    socialLink: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    footerSpriteStyle() {
      // The location of assets like this footer sprite are different for each
      // parent app. That's why it has to be loaded here in js rather than
      // in the static css file
      return {
        backgroundImage: `url(${footer_sprite_default.a})`
      };
    }

  }
});
// CONCATENATED MODULE: ./src/components/Footer/NebulaFooterLink.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/components/Footer/NebulaFooterLink.vue





const NebulaFooterLink_exports_ = /*#__PURE__*/exportHelper_default()(NebulaFooterLinkvue_type_script_lang_js, [['render',NebulaFooterLinkvue_type_template_id_9ca63bfa_render]])

/* harmony default export */ var NebulaFooterLink = (NebulaFooterLink_exports_);
// CONCATENATED MODULE: ./src/utils/footerData.js
const simpleFooterLinks = [{
  link: 'https://www.discoveryeducation.com/aboutus/terms_of_use.cfm',
  target: '_blank',
  routerLink: false,
  text: 'Terms of Use'
}, {
  link: 'https://www.discoveryeducation.com/privacy-policy/',
  target: '_blank',
  routerLink: false,
  text: 'Privacy Policy'
}, {
  link: 'https://www.discoveryeducation.com/contact-us/',
  target: '_blank',
  routerLink: false,
  text: 'Contact Us'
}, {
  link: 'https://www.discoveryeducation.com/who-we-are/about-discovery-education.cfm',
  target: '_blank',
  routerLink: false,
  text: 'About Us'
}];

function facebookUrl(countryCode) {
  return countryCode === 'GB' ? 'https://www.facebook.com/DiscoveryEdUK' : 'https://www.facebook.com/discoveryed';
}

function twitterUrl(countryCode) {
  return countryCode === 'GB' ? 'https://twitter.com/DiscoveryEdUK' : 'https://twitter.com/DiscoveryEd';
}

function youtubeUrl(countryCode) {
  return countryCode === 'GB' ? 'https://www.youtube.com/channel/UC4T3jtRh8-7iW_koiRSkglQ' : 'https://www.youtube.com/user/DiscoveryEducation';
}

function instagramUrl(countryCode) {
  return countryCode === 'GB' ? 'https://www.instagram.com/discoveryeduk/' : 'https://www.instagram.com/discoveryed/';
}

function getSocialMediaLinks(countryCode) {
  return [{
    link: twitterUrl(countryCode),
    target: '_blank',
    routerLink: false,
    text: 'Twitter'
  }, {
    link: facebookUrl(countryCode),
    target: '_blank',
    routerLink: false,
    text: 'Facebook'
  }, {
    link: youtubeUrl(countryCode),
    target: '_blank',
    routerLink: false,
    text: 'YouTube'
  }, {
    link: instagramUrl(countryCode),
    target: '_blank',
    routerLink: false,
    text: 'Instagram'
  }];
}

function termsOfUseUrl(countryCode, wwwUrl) {
  return countryCode === 'GB' ? `${wwwUrl}/terms-of-use` : `${wwwUrl}/aboutus/terms_of_use.cfm`;
}

function privacyPolicyUrl(countryCode, wwwUrl) {
  return countryCode === 'GB' || countryCode === 'CA' ? `${wwwUrl}/privacy-policy` : `${wwwUrl}/aboutus/privacy-policy/us.cfm`;
}

function supportUrl(countryCode, wwwUrl) {
  let url = `${wwwUrl}/help/docs`;

  if (countryCode === 'GB') {
    url = `${wwwUrl}/support`;
  } else if (countryCode === 'CA') {
    // Note: Special case for Canada. They get the US help docs.
    url = 'https://help.discoveryeducation.com/hc/en-us';
  }

  return url;
}

function aboutUsUrl(countryCode, wwwUrl) {
  return countryCode === 'GB' ? `${wwwUrl}/who-we-are/about-discovery-education` : `${wwwUrl}/who-we-are/about-discovery-education.cfm`;
}

function getLongFooterLinks(appUrl, wwwUrl, userIsLoggedIn, userIsStudent, countryCode) {
  return [{
    link: `${appUrl}/learn/check-requirements`,
    target: '_blank',
    routerLink: false,
    text: 'Check Requirements'
  }, {
    link: termsOfUseUrl(countryCode, wwwUrl),
    routerLink: false,
    text: 'Terms of Use'
  }, {
    link: privacyPolicyUrl(countryCode, wwwUrl),
    routerLink: false,
    text: 'Privacy Policy'
  }, {
    link: supportUrl(countryCode, wwwUrl),
    routerLink: false,
    text: 'Support',
    target: '_blank',
    isHidden: !userIsLoggedIn || userIsStudent
  }, {
    link: `${wwwUrl}/contact-us/`,
    routerLink: false,
    text: 'Contact Us'
  }, {
    link: aboutUsUrl(countryCode, wwwUrl),
    routerLink: false,
    text: 'About Us'
  }, {
    link: `${appUrl}/learn/pd-checkin?ref=qr`,
    routerLink: false,
    text: 'PD Session Check-In',
    isHidden: countryCode === 'GB' || !userIsLoggedIn || userIsStudent
  }];
}


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Footer/NebulaFooter.vue?vue&type=script&lang=js






/* harmony default export */ var NebulaFootervue_type_script_lang_js = ({
  name: 'NebulaFooter',
  components: {
    NebulaBackToTop: NebulaBackToTop,
    NebulaFooterCharacter: NebulaFooterCharacter,
    NebulaFooterLink: NebulaFooterLink
  },

  data() {
    return {
      simpleFooterLinks: simpleFooterLinks,
      getLongFooterLinks: getLongFooterLinks,
      getSocialMediaLinks: getSocialMediaLinks,
      // initalize at expected height, but will be confirmed on mount
      // for resilience to design changes
      backToTopHeight: 72
    };
  },

  mixins: [themingUtils],
  props: {
    appUrl: {
      type: String,
      default: ''
    },
    backToTop: {
      type: Boolean,
      default: false
    },
    countryCode: {
      type: String,
      default: 'US'
    },
    userIsLoggedIn: {
      type: Boolean,
      default: false
    },
    userIsStudent: {
      type: Boolean,
      default: true
    },
    wwwUrl: {
      type: String,
      default: 'https://www.discoveryeducation.com'
    },
    simpleFooter: {
      type: Boolean,
      default: false
    },
    footerLinks: {
      type: Array,
      default: null
    },
    socialLinks: {
      type: Array,
      default: null
    },
    whiteLogo: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    footerSpriteStyle() {
      // The location of assets like this footer sprite are different for each
      // parent app. That's why it has to be loaded here in js rather than
      // in the static css file
      return {
        backgroundImage: `url(${footer_sprite_default.a})`
      };
    },

    homeLogoUrl() {
      return `${this.appUrl}/suite`;
    },

    discoveryEducationUrl() {
      return 'https://www.discoveryeducation.com';
    },

    getFooterLinks() {
      if (!this.footerLinks) {
        if (this.simpleFooter) {
          return simpleFooterLinks;
        }

        return getLongFooterLinks(this.appUrl, this.wwwUrl, this.userIsLoggedIn, this.userIsStudent, this.countryCode);
      }

      return this.footerLinks;
    },

    getSocialLinks() {
      if (!this.socialLinks) {
        return getSocialMediaLinks(this.countryCode);
      }

      return this.socialLinks;
    },

    getYear() {
      const currentDate = new Date();
      return currentDate.getFullYear();
    },

    homeLogo() {
      if (this.whiteLogo) {
        // eslint-disable-next-line global-require
        return __webpack_require__("4185");
      } // eslint-disable-next-line global-require


      return __webpack_require__("57f7");
    }

  },

  mounted() {
    // position back-to-top button on mount
    // for resilience to theming or other changes to height
    if (this.backToTop) {
      const backToTopEl = this.$refs.backToTop.$el;

      if (backToTopEl) {
        this.backToTopHeight = this.$refs.backToTop.offsetHeight;
      }
    }
  }

});
// CONCATENATED MODULE: ./src/components/Footer/NebulaFooter.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Footer/NebulaFooter.vue?vue&type=style&index=0&id=7b26c40e&lang=stylus
var NebulaFootervue_type_style_index_0_id_7b26c40e_lang_stylus = __webpack_require__("851a");

// CONCATENATED MODULE: ./src/components/Footer/NebulaFooter.vue







const NebulaFooter_exports_ = /*#__PURE__*/exportHelper_default()(NebulaFootervue_type_script_lang_js, [['render',NebulaFootervue_type_template_id_7b26c40e_render]])

/* harmony default export */ var NebulaFooter = (NebulaFooter_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaVueSelect/NebulaVueSelect.vue?vue&type=template&id=f8534482

const NebulaVueSelectvue_type_template_id_f8534482_hoisted_1 = {
  class: "nebula-vue-select",
  style: {}
};
function NebulaVueSelectvue_type_template_id_f8534482_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_VueSelect = Object(external_vue_["resolveComponent"])("VueSelect");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaVueSelectvue_type_template_id_f8534482_hoisted_1, [Object(external_vue_["createElementVNode"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.vueSelectClassName)
  }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "select", {}, () => [Object(external_vue_["createVNode"])(_component_VueSelect, {
    clearable: $props.clearable,
    components: {
      Deselect: $setup.Deselect,
      OpenIndicator: $setup.OpenIndicator
    },
    deselectFromDropdown: $props.deselectFromDropdown,
    disabled: $props.isDisabled,
    dir: "null",
    id: $props.selectId,
    "input-id": $props.inputId,
    multiple: $props.multiple,
    name: $props.selectNameAttr,
    options: $props.options,
    placeholder: $props.placeholder,
    searchable: $props.isSearchable,
    selectable: option => option.state !== 'disabled',
    modelValue: $data.selectValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.selectValue = $event)
  }, null, 8, ["clearable", "components", "deselectFromDropdown", "disabled", "id", "input-id", "multiple", "name", "options", "placeholder", "searchable", "selectable", "modelValue"])])], 2)]);
}
// CONCATENATED MODULE: ./src/components/FormElements/NebulaVueSelect/NebulaVueSelect.vue?vue&type=template&id=f8534482

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaVueSelect/NebulaDeselect.vue?vue&type=template&id=320a8328

function NebulaDeselectvue_type_template_id_320a8328_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])($props.multiple ? 'nebula-vue-select__deselect--multiple' : null),
    style: {}
  }, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
    class: Object(external_vue_["normalizeClass"])(["nebula-vue-select__deselect-icon", $props.multiple ? 'nebula-vue-select__deselect-icon--circle-x' : 'nebula-vue-select__deselect-icon--x']),
    symbolId: $props.multiple ? 'circle-x' : 'x'
  }, null, 8, ["class", "symbolId"]), $props.multiple ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
    key: 0,
    class: "nebula-vue-select__deselect-icon nebula-vue-select__deselect-icon--circle-x-filled",
    symbolId: "circle-x--filled"
  })) : Object(external_vue_["createCommentVNode"])("", true)], 2);
}
// CONCATENATED MODULE: ./src/components/FormElements/NebulaVueSelect/NebulaDeselect.vue?vue&type=template&id=320a8328

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaVueSelect/NebulaDeselect.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaDeselectvue_type_script_lang_js = ({
  components: {
    NebulaIcon: NebulaIcon
  },
  mixins: [themingUtils],
  props: {
    multiple: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/FormElements/NebulaVueSelect/NebulaDeselect.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/FormElements/NebulaVueSelect/NebulaDeselect.vue?vue&type=style&index=0&id=320a8328&lang=stylus
var NebulaDeselectvue_type_style_index_0_id_320a8328_lang_stylus = __webpack_require__("1f36");

// CONCATENATED MODULE: ./src/components/FormElements/NebulaVueSelect/NebulaDeselect.vue







const NebulaDeselect_exports_ = /*#__PURE__*/exportHelper_default()(NebulaDeselectvue_type_script_lang_js, [['render',NebulaDeselectvue_type_template_id_320a8328_render]])

/* harmony default export */ var NebulaDeselect = (NebulaDeselect_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaVueSelect/NebulaOpenIndicator.vue?vue&type=template&id=9b4a5bdc

function NebulaOpenIndicatorvue_type_template_id_9b4a5bdc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
    class: "nebula-vue-select__open-indicator-icon",
    symbolId: "caret-down"
  });
}
// CONCATENATED MODULE: ./src/components/FormElements/NebulaVueSelect/NebulaOpenIndicator.vue?vue&type=template&id=9b4a5bdc

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaVueSelect/NebulaOpenIndicator.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaOpenIndicatorvue_type_script_lang_js = ({
  components: {
    NebulaIcon: NebulaIcon
  },
  mixins: [themingUtils]
});
// CONCATENATED MODULE: ./src/components/FormElements/NebulaVueSelect/NebulaOpenIndicator.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/FormElements/NebulaVueSelect/NebulaOpenIndicator.vue?vue&type=style&index=0&id=9b4a5bdc&lang=stylus
var NebulaOpenIndicatorvue_type_style_index_0_id_9b4a5bdc_lang_stylus = __webpack_require__("7b74");

// CONCATENATED MODULE: ./src/components/FormElements/NebulaVueSelect/NebulaOpenIndicator.vue







const NebulaOpenIndicator_exports_ = /*#__PURE__*/exportHelper_default()(NebulaOpenIndicatorvue_type_script_lang_js, [['render',NebulaOpenIndicatorvue_type_template_id_9b4a5bdc_render]])

/* harmony default export */ var NebulaOpenIndicator = (NebulaOpenIndicator_exports_);
// CONCATENATED MODULE: ./node_modules/vue-select/dist/vue-select.es.js
var vue_select_es_E = Object.defineProperty, vue_select_es_M = Object.defineProperties;
var vue_select_es_x = Object.getOwnPropertyDescriptors;
var V = Object.getOwnPropertySymbols;
var vue_select_es_I = Object.prototype.hasOwnProperty, vue_select_es_N = Object.prototype.propertyIsEnumerable;
var vue_select_es_C = (e, t, s) => t in e ? vue_select_es_E(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, vue_select_es_f = (e, t) => {
  for (var s in t || (t = {}))
    vue_select_es_I.call(t, s) && vue_select_es_C(e, s, t[s]);
  if (V)
    for (var s of V(t))
      vue_select_es_N.call(t, s) && vue_select_es_C(e, s, t[s]);
  return e;
}, vue_select_es_m = (e, t) => vue_select_es_M(e, vue_select_es_x(t));

const vue_select_es_U = {
  props: {
    autoscroll: {
      type: Boolean,
      default: !0
    }
  },
  watch: {
    typeAheadPointer() {
      this.autoscroll && this.maybeAdjustScroll();
    },
    open(e) {
      this.autoscroll && e && this.$nextTick(() => this.maybeAdjustScroll());
    }
  },
  methods: {
    maybeAdjustScroll() {
      var t;
      const e = ((t = this.$refs.dropdownMenu) == null ? void 0 : t.children[this.typeAheadPointer]) || !1;
      if (e) {
        const s = this.getDropdownViewport(), { top: n, bottom: l, height: i } = e.getBoundingClientRect();
        if (n < s.top)
          return this.$refs.dropdownMenu.scrollTop = e.offsetTop;
        if (l > s.bottom)
          return this.$refs.dropdownMenu.scrollTop = e.offsetTop - (s.height - i);
      }
    },
    getDropdownViewport() {
      return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : {
        height: 0,
        top: 0,
        bottom: 0
      };
    }
  }
}, vue_select_es_q = {
  data() {
    return {
      typeAheadPointer: -1
    };
  },
  watch: {
    filteredOptions() {
      for (let e = 0; e < this.filteredOptions.length; e++)
        if (this.selectable(this.filteredOptions[e])) {
          this.typeAheadPointer = e;
          break;
        }
    },
    open(e) {
      e && this.typeAheadToLastSelected();
    },
    selectedValue() {
      this.open && this.typeAheadToLastSelected();
    }
  },
  methods: {
    typeAheadUp() {
      for (let e = this.typeAheadPointer - 1; e >= 0; e--)
        if (this.selectable(this.filteredOptions[e])) {
          this.typeAheadPointer = e;
          break;
        }
    },
    typeAheadDown() {
      for (let e = this.typeAheadPointer + 1; e < this.filteredOptions.length; e++)
        if (this.selectable(this.filteredOptions[e])) {
          this.typeAheadPointer = e;
          break;
        }
    },
    typeAheadSelect() {
      const e = this.filteredOptions[this.typeAheadPointer];
      e && this.selectable(e) && this.select(e);
    },
    typeAheadToLastSelected() {
      this.typeAheadPointer = this.selectedValue.length !== 0 ? this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length - 1]) : -1;
    }
  }
}, vue_select_es_J = {
  props: {
    loading: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      mutableLoading: !1
    };
  },
  watch: {
    search() {
      this.$emit("search", this.search, this.toggleLoading);
    },
    loading(e) {
      this.mutableLoading = e;
    }
  },
  methods: {
    toggleLoading(e = null) {
      return e == null ? this.mutableLoading = !this.mutableLoading : this.mutableLoading = e;
    }
  }
}, vue_select_es_S = (e, t) => {
  const s = e.__vccOpts || e;
  for (const [n, l] of t)
    s[n] = l;
  return s;
}, vue_select_es_H = {}, vue_select_es_X = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10"
}, vue_select_es_Y = /* @__PURE__ */ Object(external_vue_["createElementVNode"])("path", { d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z" }, null, -1), vue_select_es_Q = [
  vue_select_es_Y
];
function vue_select_es_G(e, t) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("svg", vue_select_es_X, vue_select_es_Q);
}
const W = /* @__PURE__ */ vue_select_es_S(vue_select_es_H, [["render", vue_select_es_G]]), Z = {}, vue_select_es_ee = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10"
}, vue_select_es_te = /* @__PURE__ */ Object(external_vue_["createElementVNode"])("path", { d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z" }, null, -1), vue_select_es_se = [
  vue_select_es_te
];
function vue_select_es_ie(e, t) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("svg", vue_select_es_ee, vue_select_es_se);
}
const oe = /* @__PURE__ */ vue_select_es_S(Z, [["render", vue_select_es_ie]]), vue_select_es_T = {
  Deselect: W,
  OpenIndicator: oe
}, vue_select_es_ne = {
  mounted(e, { instance: t }) {
    if (t.appendToBody) {
      const {
        height: s,
        top: n,
        left: l,
        width: i
      } = t.$refs.toggle.getBoundingClientRect();
      let y = window.scrollX || window.pageXOffset, o = window.scrollY || window.pageYOffset;
      e.unbindPosition = t.calculatePosition(e, t, {
        width: i + "px",
        left: y + l + "px",
        top: o + n + s + "px"
      }), document.body.appendChild(e);
    }
  },
  unmounted(e, { instance: t }) {
    t.appendToBody && (e.unbindPosition && typeof e.unbindPosition == "function" && e.unbindPosition(), e.parentNode && e.parentNode.removeChild(e));
  }
};
function le(e) {
  const t = {};
  return Object.keys(e).sort().forEach((s) => {
    t[s] = e[s];
  }), JSON.stringify(t);
}
let ae = 0;
function vue_select_es_re() {
  return ++ae;
}
const de = {
  components: vue_select_es_f({}, vue_select_es_T),
  directives: { appendToBody: vue_select_es_ne },
  mixins: [vue_select_es_U, vue_select_es_q, vue_select_es_J],
  compatConfig: {
    MODE: 3
  },
  emits: [
    "open",
    "close",
    "update:modelValue",
    "search",
    "search:compositionstart",
    "search:compositionend",
    "search:keydown",
    "search:blur",
    "search:focus",
    "search:input",
    "option:created",
    "option:selecting",
    "option:selected",
    "option:deselecting",
    "option:deselected"
  ],
  props: {
    modelValue: {},
    components: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    clearable: {
      type: Boolean,
      default: !0
    },
    deselectFromDropdown: {
      type: Boolean,
      default: !1
    },
    searchable: {
      type: Boolean,
      default: !0
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    transition: {
      type: String,
      default: "vs__fade"
    },
    clearSearchOnSelect: {
      type: Boolean,
      default: !0
    },
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    label: {
      type: String,
      default: "label"
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    reduce: {
      type: Function,
      default: (e) => e
    },
    selectable: {
      type: Function,
      default: (e) => !0
    },
    getOptionLabel: {
      type: Function,
      default(e) {
        return typeof e == "object" ? e.hasOwnProperty(this.label) ? e[this.label] : console.warn(`[vue-select warn]: Label key "option.${this.label}" does not exist in options object ${JSON.stringify(e)}.
https://vue-select.org/api/props.html#getoptionlabel`) : e;
      }
    },
    getOptionKey: {
      type: Function,
      default(e) {
        if (typeof e != "object")
          return e;
        try {
          return e.hasOwnProperty("id") ? e.id : le(e);
        } catch (t) {
          return console.warn(`[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.
https://vue-select.org/api/props.html#getoptionkey`, e, t);
        }
      }
    },
    onTab: {
      type: Function,
      default: function() {
        this.selectOnTab && !this.isComposing && this.typeAheadSelect();
      }
    },
    taggable: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: null
    },
    pushTags: {
      type: Boolean,
      default: !1
    },
    filterable: {
      type: Boolean,
      default: !0
    },
    filterBy: {
      type: Function,
      default(e, t, s) {
        return (t || "").toLocaleLowerCase().indexOf(s.toLocaleLowerCase()) > -1;
      }
    },
    filter: {
      type: Function,
      default(e, t) {
        return e.filter((s) => {
          let n = this.getOptionLabel(s);
          return typeof n == "number" && (n = n.toString()), this.filterBy(s, n, t);
        });
      }
    },
    createOption: {
      type: Function,
      default(e) {
        return typeof this.optionList[0] == "object" ? { [this.label]: e } : e;
      }
    },
    resetOnOptionsChange: {
      default: !1,
      validator: (e) => ["function", "boolean"].includes(typeof e)
    },
    clearSearchOnBlur: {
      type: Function,
      default: function({ clearSearchOnSelect: e, multiple: t }) {
        return e && !t;
      }
    },
    noDrop: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String
    },
    dir: {
      type: String,
      default: "auto"
    },
    selectOnTab: {
      type: Boolean,
      default: !1
    },
    selectOnKeyCodes: {
      type: Array,
      default: () => [13]
    },
    searchInputQuerySelector: {
      type: String,
      default: "[type=search]"
    },
    mapKeydown: {
      type: Function,
      default: (e, t) => e
    },
    appendToBody: {
      type: Boolean,
      default: !1
    },
    calculatePosition: {
      type: Function,
      default(e, t, { width: s, top: n, left: l }) {
        e.style.top = n, e.style.left = l, e.style.width = s;
      }
    },
    dropdownShouldOpen: {
      type: Function,
      default({ noDrop: e, open: t, mutableLoading: s }) {
        return e ? !1 : t && !s;
      }
    },
    uid: {
      type: [String, Number],
      default: () => vue_select_es_re()
    }
  },
  data() {
    return {
      search: "",
      open: !1,
      isComposing: !1,
      pushedTags: [],
      _value: [],
      deselectButtons: []
    };
  },
  computed: {
    isReducingValues() {
      return this.$props.reduce !== this.$options.props.reduce.default;
    },
    isTrackingValues() {
      return typeof this.modelValue == "undefined" || this.isReducingValues;
    },
    selectedValue() {
      let e = this.modelValue;
      return this.isTrackingValues && (e = this.$data._value), e != null && e !== "" ? [].concat(e) : [];
    },
    optionList() {
      return this.options.concat(this.pushTags ? this.pushedTags : []);
    },
    searchEl() {
      return this.$slots.search ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
    },
    scope() {
      const e = {
        search: this.search,
        loading: this.loading,
        searching: this.searching,
        filteredOptions: this.filteredOptions
      };
      return {
        search: {
          attributes: vue_select_es_f({
            disabled: this.disabled,
            placeholder: this.searchPlaceholder,
            tabindex: this.tabindex,
            readonly: !this.searchable,
            id: this.inputId,
            "aria-autocomplete": "list",
            "aria-labelledby": `vs${this.uid}__combobox`,
            "aria-controls": `vs${this.uid}__listbox`,
            ref: "search",
            type: "search",
            autocomplete: this.autocomplete,
            value: this.search
          }, this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? {
            "aria-activedescendant": `vs${this.uid}__option-${this.typeAheadPointer}`
          } : {}),
          events: {
            compositionstart: () => this.isComposing = !0,
            compositionend: () => this.isComposing = !1,
            keydown: this.onSearchKeyDown,
            blur: this.onSearchBlur,
            focus: this.onSearchFocus,
            input: (t) => this.search = t.target.value
          }
        },
        spinner: {
          loading: this.mutableLoading
        },
        noOptions: {
          search: this.search,
          loading: this.mutableLoading,
          searching: this.searching
        },
        openIndicator: {
          attributes: {
            ref: "openIndicator",
            role: "presentation",
            class: "vs__open-indicator"
          }
        },
        listHeader: e,
        listFooter: e,
        header: vue_select_es_m(vue_select_es_f({}, e), { deselect: this.deselect }),
        footer: vue_select_es_m(vue_select_es_f({}, e), { deselect: this.deselect })
      };
    },
    childComponents() {
      return vue_select_es_f(vue_select_es_f({}, vue_select_es_T), this.components);
    },
    stateClasses() {
      return {
        "vs--open": this.dropdownOpen,
        "vs--single": !this.multiple,
        "vs--multiple": this.multiple,
        "vs--searching": this.searching && !this.noDrop,
        "vs--searchable": this.searchable && !this.noDrop,
        "vs--unsearchable": !this.searchable,
        "vs--loading": this.mutableLoading,
        "vs--disabled": this.disabled
      };
    },
    searching() {
      return !!this.search;
    },
    dropdownOpen() {
      return this.dropdownShouldOpen(this);
    },
    searchPlaceholder() {
      return this.isValueEmpty && this.placeholder ? this.placeholder : void 0;
    },
    filteredOptions() {
      const e = [].concat(this.optionList);
      if (!this.filterable && !this.taggable)
        return e;
      const t = this.search.length ? this.filter(e, this.search, this) : e;
      if (this.taggable && this.search.length) {
        const s = this.createOption(this.search);
        this.optionExists(s) || t.unshift(s);
      }
      return t;
    },
    isValueEmpty() {
      return this.selectedValue.length === 0;
    },
    showClearButton() {
      return !this.multiple && this.clearable && !this.open && !this.isValueEmpty;
    }
  },
  watch: {
    options(e, t) {
      const s = () => typeof this.resetOnOptionsChange == "function" ? this.resetOnOptionsChange(e, t, this.selectedValue) : this.resetOnOptionsChange;
      !this.taggable && s() && this.clearSelection(), this.modelValue && this.isTrackingValues && this.setInternalValueFromOptions(this.modelValue);
    },
    modelValue: {
      immediate: !0,
      handler(e) {
        this.isTrackingValues && this.setInternalValueFromOptions(e);
      }
    },
    multiple() {
      this.clearSelection();
    },
    open(e) {
      this.$emit(e ? "open" : "close");
    }
  },
  created() {
    this.mutableLoading = this.loading;
  },
  methods: {
    setInternalValueFromOptions(e) {
      Array.isArray(e) ? this.$data._value = e.map((t) => this.findOptionFromReducedValue(t)) : this.$data._value = this.findOptionFromReducedValue(e);
    },
    select(e) {
      this.$emit("option:selecting", e), this.isOptionSelected(e) ? this.deselectFromDropdown && (this.clearable || this.multiple && this.selectedValue.length > 1) && this.deselect(e) : (this.taggable && !this.optionExists(e) && (this.$emit("option:created", e), this.pushTag(e)), this.multiple && (e = this.selectedValue.concat(e)), this.updateValue(e), this.$emit("option:selected", e)), this.onAfterSelect(e);
    },
    deselect(e) {
      this.$emit("option:deselecting", e), this.updateValue(this.selectedValue.filter((t) => !this.optionComparator(t, e))), this.$emit("option:deselected", e);
    },
    clearSelection() {
      this.updateValue(this.multiple ? [] : null);
    },
    onAfterSelect(e) {
      this.closeOnSelect && (this.open = !this.open, this.searchEl.blur()), this.clearSearchOnSelect && (this.search = "");
    },
    updateValue(e) {
      typeof this.modelValue == "undefined" && (this.$data._value = e), e !== null && (Array.isArray(e) ? e = e.map((t) => this.reduce(t)) : e = this.reduce(e)), this.$emit("update:modelValue", e);
    },
    toggleDropdown(e) {
      const t = e.target !== this.searchEl;
      t && e.preventDefault();
      const s = [
        ...this.deselectButtons || [],
        this.$refs.clearButton
      ];
      if (this.searchEl === void 0 || s.filter(Boolean).some((n) => n.contains(e.target) || n === e.target)) {
        e.preventDefault();
        return;
      }
      this.open && t ? this.searchEl.blur() : this.disabled || (this.open = !0, this.searchEl.focus());
    },
    isOptionSelected(e) {
      return this.selectedValue.some((t) => this.optionComparator(t, e));
    },
    isOptionDeselectable(e) {
      return this.isOptionSelected(e) && this.deselectFromDropdown;
    },
    optionComparator(e, t) {
      return this.getOptionKey(e) === this.getOptionKey(t);
    },
    findOptionFromReducedValue(e) {
      const t = (n) => JSON.stringify(this.reduce(n)) === JSON.stringify(e), s = [...this.options, ...this.pushedTags].filter(t);
      return s.length === 1 ? s[0] : s.find((n) => this.optionComparator(n, this.$data._value)) || e;
    },
    closeSearchOptions() {
      this.open = !1, this.$emit("search:blur");
    },
    maybeDeleteValue() {
      if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
        let e = null;
        this.multiple && (e = [
          ...this.selectedValue.slice(0, this.selectedValue.length - 1)
        ]), this.updateValue(e);
      }
    },
    optionExists(e) {
      return this.optionList.some((t) => this.optionComparator(t, e));
    },
    normalizeOptionForSlot(e) {
      return typeof e == "object" ? e : { [this.label]: e };
    },
    pushTag(e) {
      this.pushedTags.push(e);
    },
    onEscape() {
      this.search.length ? this.search = "" : this.searchEl.blur();
    },
    onSearchBlur() {
      if (this.mousedown && !this.searching)
        this.mousedown = !1;
      else {
        const { clearSearchOnSelect: e, multiple: t } = this;
        this.clearSearchOnBlur({ clearSearchOnSelect: e, multiple: t }) && (this.search = ""), this.closeSearchOptions();
        return;
      }
      if (this.search.length === 0 && this.options.length === 0) {
        this.closeSearchOptions();
        return;
      }
    },
    onSearchFocus() {
      this.open = !0, this.$emit("search:focus");
    },
    onMousedown() {
      this.mousedown = !0;
    },
    onMouseUp() {
      this.mousedown = !1;
    },
    onSearchKeyDown(e) {
      const t = (l) => (l.preventDefault(), !this.isComposing && this.typeAheadSelect()), s = {
        8: (l) => this.maybeDeleteValue(),
        9: (l) => this.onTab(),
        27: (l) => this.onEscape(),
        38: (l) => (l.preventDefault(), this.typeAheadUp()),
        40: (l) => (l.preventDefault(), this.typeAheadDown())
      };
      this.selectOnKeyCodes.forEach((l) => s[l] = t);
      const n = this.mapKeydown(s, this);
      if (typeof n[e.keyCode] == "function")
        return n[e.keyCode](e);
    }
  }
}, vue_select_es_he = ["dir"], ce = ["id", "aria-expanded", "aria-owns"], ue = {
  ref: "selectedOptions",
  class: "vs__selected-options"
}, pe = ["disabled", "title", "aria-label", "onClick"], fe = {
  ref: "actions",
  class: "vs__actions"
}, vue_select_es_ge = ["disabled"], ye = { class: "vs__spinner" }, vue_select_es_me = ["id"], vue_select_es_be = ["id", "aria-selected", "onMouseover", "onClick"], vue_select_es_e = {
  key: 0,
  class: "vs__no-options"
}, vue_select_es_Oe = /* @__PURE__ */ Object(external_vue_["createTextVNode"])(" Sorry, no matching options. "), we = ["id"];
function ve(e, t, s, n, l, i) {
  const y = Object(external_vue_["resolveDirective"])("append-to-body");
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    dir: s.dir,
    class: Object(external_vue_["normalizeClass"])(["v-select", i.stateClasses])
  }, [
    Object(external_vue_["renderSlot"])(e.$slots, "header", Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(i.scope.header))),
    Object(external_vue_["createElementVNode"])("div", {
      id: `vs${s.uid}__combobox`,
      ref: "toggle",
      class: "vs__dropdown-toggle",
      role: "combobox",
      "aria-expanded": i.dropdownOpen.toString(),
      "aria-owns": `vs${s.uid}__listbox`,
      "aria-label": "Search for option",
      onMousedown: t[1] || (t[1] = (o) => i.toggleDropdown(o))
    }, [
      Object(external_vue_["createElementVNode"])("div", ue, [
        (Object(external_vue_["openBlock"])(!0), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(i.selectedValue, (o, p) => Object(external_vue_["renderSlot"])(e.$slots, "selected-option-container", {
          option: i.normalizeOptionForSlot(o),
          deselect: i.deselect,
          multiple: s.multiple,
          disabled: s.disabled
        }, () => [
          (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", {
            key: s.getOptionKey(o),
            class: "vs__selected"
          }, [
            Object(external_vue_["renderSlot"])(e.$slots, "selected-option", Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(i.normalizeOptionForSlot(o))), () => [
              Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(s.getOptionLabel(o)), 1)
            ]),
            s.multiple ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", {
              key: 0,
              ref_for: !0,
              ref: (g) => l.deselectButtons[p] = g,
              disabled: s.disabled,
              type: "button",
              class: "vs__deselect",
              title: `Deselect ${s.getOptionLabel(o)}`,
              "aria-label": `Deselect ${s.getOptionLabel(o)}`,
              onClick: (g) => i.deselect(o)
            }, [
              (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])(i.childComponents.Deselect)))
            ], 8, pe)) : Object(external_vue_["createCommentVNode"])("", !0)
          ]))
        ])), 256)),
        Object(external_vue_["renderSlot"])(e.$slots, "search", Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(i.scope.search)), () => [
          Object(external_vue_["createElementVNode"])("input", Object(external_vue_["mergeProps"])({ class: "vs__search" }, i.scope.search.attributes, Object(external_vue_["toHandlers"])(i.scope.search.events)), null, 16)
        ])
      ], 512),
      Object(external_vue_["createElementVNode"])("div", fe, [
        Object(external_vue_["withDirectives"])(Object(external_vue_["createElementVNode"])("button", {
          ref: "clearButton",
          disabled: s.disabled,
          type: "button",
          class: "vs__clear",
          title: "Clear Selected",
          "aria-label": "Clear Selected",
          onClick: t[0] || (t[0] = (...o) => i.clearSelection && i.clearSelection(...o))
        }, [
          (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])(i.childComponents.Deselect)))
        ], 8, vue_select_es_ge), [
          [external_vue_["vShow"], i.showClearButton]
        ]),
        Object(external_vue_["renderSlot"])(e.$slots, "open-indicator", Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(i.scope.openIndicator)), () => [
          s.noDrop ? Object(external_vue_["createCommentVNode"])("", !0) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])(i.childComponents.OpenIndicator), Object(external_vue_["normalizeProps"])(Object(external_vue_["mergeProps"])({ key: 0 }, i.scope.openIndicator.attributes)), null, 16))
        ]),
        Object(external_vue_["renderSlot"])(e.$slots, "spinner", Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(i.scope.spinner)), () => [
          Object(external_vue_["withDirectives"])(Object(external_vue_["createElementVNode"])("div", ye, "Loading...", 512), [
            [external_vue_["vShow"], e.mutableLoading]
          ])
        ])
      ], 512)
    ], 40, ce),
    Object(external_vue_["createVNode"])(external_vue_["Transition"], { name: s.transition }, {
      default: Object(external_vue_["withCtx"])(() => [
        i.dropdownOpen ? Object(external_vue_["withDirectives"])((Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("ul", {
          id: `vs${s.uid}__listbox`,
          ref: "dropdownMenu",
          key: `vs${s.uid}__listbox`,
          class: "vs__dropdown-menu",
          role: "listbox",
          tabindex: "-1",
          onMousedown: t[2] || (t[2] = Object(external_vue_["withModifiers"])((...o) => i.onMousedown && i.onMousedown(...o), ["prevent"])),
          onMouseup: t[3] || (t[3] = (...o) => i.onMouseUp && i.onMouseUp(...o))
        }, [
          Object(external_vue_["renderSlot"])(e.$slots, "list-header", Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(i.scope.listHeader))),
          (Object(external_vue_["openBlock"])(!0), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(i.filteredOptions, (o, p) => (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
            id: `vs${s.uid}__option-${p}`,
            key: s.getOptionKey(o),
            role: "option",
            class: Object(external_vue_["normalizeClass"])(["vs__dropdown-option", {
              "vs__dropdown-option--deselect": i.isOptionDeselectable(o) && p === e.typeAheadPointer,
              "vs__dropdown-option--selected": i.isOptionSelected(o),
              "vs__dropdown-option--highlight": p === e.typeAheadPointer,
              "vs__dropdown-option--disabled": !s.selectable(o)
            }]),
            "aria-selected": p === e.typeAheadPointer ? !0 : null,
            onMouseover: (g) => s.selectable(o) ? e.typeAheadPointer = p : null,
            onClick: Object(external_vue_["withModifiers"])((g) => s.selectable(o) ? i.select(o) : null, ["prevent", "stop"])
          }, [
            Object(external_vue_["renderSlot"])(e.$slots, "option", Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(i.normalizeOptionForSlot(o))), () => [
              Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(s.getOptionLabel(o)), 1)
            ])
          ], 42, vue_select_es_be))), 128)),
          i.filteredOptions.length === 0 ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", vue_select_es_e, [
            Object(external_vue_["renderSlot"])(e.$slots, "no-options", Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(i.scope.noOptions)), () => [
              vue_select_es_Oe
            ])
          ])) : Object(external_vue_["createCommentVNode"])("", !0),
          Object(external_vue_["renderSlot"])(e.$slots, "list-footer", Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(i.scope.listFooter)))
        ], 40, vue_select_es_me)), [
          [y]
        ]) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("ul", {
          key: 1,
          id: `vs${s.uid}__listbox`,
          role: "listbox",
          style: { display: "none", visibility: "hidden" }
        }, null, 8, we))
      ]),
      _: 3
    }, 8, ["name"]),
    Object(external_vue_["renderSlot"])(e.$slots, "footer", Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])(i.scope.footer)))
  ], 10, vue_select_es_he);
}
const Ce = /* @__PURE__ */ vue_select_es_S(de, [["render", ve]]);


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaVueSelect/NebulaVueSelect.vue?vue&type=script&lang=js
/*
    `dir` is set to `null` on the VueSelect because of the way Nebula handles localization styles.
    When the VueSelect has a parent container with `dir="rtl"`, it will render in rtl style.
*/

/*
    To disabled individual options, add `state: disabled` to the option in the options array
    and add `:selectable="(option) => option.state !== 'disabled'"` on the select
*/





/* harmony default export */ var NebulaVueSelectvue_type_script_lang_js = ({
  name: 'NebulaVueSelect',
  components: {
    VueSelect: Ce
  },
  mixins: [themingUtils],

  data() {
    return {
      selectValue: this.value
    };
  },

  props: {
    clearable: {
      type: Boolean,
      default: true
    },
    deselectFromDropdown: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number]
    },
    inputId: {
      type: String
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isSearchable: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    },
    selectId: {
      type: String
    },
    selectNameAttr: {
      type: String
    },
    size: {
      type: String,
      default: 'm',
      // Options: s, m, l
      validate: value => ['s', 'm', 'l'].includes(value)
    },
    status: {
      type: String,
      default: null,
      // Options: success, error
      validate: value => ['success', 'error'].includes(value)
    },
    value: {
      type: [String, Number, Array],
      default: ''
    }
  },
  emits: ['change-selected', 'update:modelValue'],
  computed: {
    vueSelectClassName() {
      const className = ['nebula-vue-select__input', `nebula-vue-select__input--${this.size}`, {
        'nebula-vue-select__input--error': this.status === 'error',
        'nebula-vue-select__input--success': this.status === 'success'
      }];
      return className;
    }

  },

  setup(props) {
    // We're using shallowRef here to make sure the component itself
    // doesn't become reactive
    const Deselect = Object(external_vue_["shallowRef"])({
      render: () => Object(external_vue_["h"])(NebulaDeselect, {
        multiple: props.multiple
      })
    });
    const OpenIndicator = Object(external_vue_["shallowRef"])({
      render: () => Object(external_vue_["h"])(NebulaOpenIndicator)
    });
    return {
      Deselect,
      OpenIndicator
    };
  },

  watch: {
    selectValue(newValue) {
      this.$emit('update:modelValue', newValue); // The `change-selected` event is kept here for backwards compatibility

      this.$emit('change-selected', newValue);
    }

  }
});
// CONCATENATED MODULE: ./src/components/FormElements/NebulaVueSelect/NebulaVueSelect.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-select/dist/vue-select.css?vue&type=style&index=0&lang=css
var vue_selectvue_type_style_index_0_lang_css = __webpack_require__("e3af");

// EXTERNAL MODULE: ./src/components/FormElements/NebulaVueSelect/NebulaVueSelect.vue?vue&type=style&index=1&id=f8534482&lang=stylus
var NebulaVueSelectvue_type_style_index_1_id_f8534482_lang_stylus = __webpack_require__("50f0");

// CONCATENATED MODULE: ./src/components/FormElements/NebulaVueSelect/NebulaVueSelect.vue








const NebulaVueSelect_exports_ = /*#__PURE__*/exportHelper_default()(NebulaVueSelectvue_type_script_lang_js, [['render',NebulaVueSelectvue_type_template_id_f8534482_render]])

/* harmony default export */ var NebulaVueSelect = (NebulaVueSelect_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaCheckbox.vue?vue&type=template&id=574fc5f0

const NebulaCheckboxvue_type_template_id_574fc5f0_hoisted_1 = {
  class: "nebula-checkbox__visual"
};
const NebulaCheckboxvue_type_template_id_574fc5f0_hoisted_2 = ["textContent"];
function NebulaCheckboxvue_type_template_id_574fc5f0_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($options.getCheckboxContainerElement), {
    class: Object(external_vue_["normalizeClass"])($options.containerClassName),
    for: $options.getCheckboxFor
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "checkbox"), Object(external_vue_["createElementVNode"])("span", NebulaCheckboxvue_type_template_id_574fc5f0_hoisted_1, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      class: "nebula-checkbox__checked-icon",
      symbolId: $options.getCheckboxIcon,
      size: "s"
    }, null, 8, ["symbolId"])]), $props.labelText ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", {
      key: 0,
      class: "nebula-checkbox__text",
      textContent: Object(external_vue_["toDisplayString"])($props.labelText)
    }, null, 8, NebulaCheckboxvue_type_template_id_574fc5f0_hoisted_2)) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 3
  }, 8, ["class", "for"]);
}
// CONCATENATED MODULE: ./src/components/FormElements/NebulaCheckbox.vue?vue&type=template&id=574fc5f0

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaCheckbox.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaCheckboxvue_type_script_lang_js = ({
  name: 'NebulaCheckbox',
  components: {
    NebulaIcon: NebulaIcon
  },
  props: {
    id: {
      type: [String, Number]
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isIndeterminate: {
      type: Boolean,
      default: false
    },
    isInverted: {
      type: Boolean,
      default: false
    },
    labelText: {
      type: String
    },
    size: {
      type: String,
      default: 'm' // Options: s, m

    },
    status: {
      type: String,
      default: null // Options: error

    }
  },
  computed: {
    containerClassName() {
      const className = ['nebula-checkbox__container', `nebula-checkbox__container--${this.size}`, {
        'nebula-checkbox__container--inverted': this.isInverted === true,
        'nebula-checkbox__container--error': this.status === 'error',
        'nebula-checkbox__container--disabled': this.isDisabled === true
      }];
      return className;
    },

    getCheckboxContainerElement() {
      return this.labelText ? 'label' : 'span';
    },

    getCheckboxFor() {
      return this.labelText ? this.id : null;
    },

    getCheckboxIcon() {
      return this.isIndeterminate ? 'minus' : 'check';
    }

  }
});
// CONCATENATED MODULE: ./src/components/FormElements/NebulaCheckbox.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/FormElements/NebulaCheckbox.vue?vue&type=style&index=0&id=574fc5f0&lang=stylus
var NebulaCheckboxvue_type_style_index_0_id_574fc5f0_lang_stylus = __webpack_require__("a0f2");

// CONCATENATED MODULE: ./src/components/FormElements/NebulaCheckbox.vue







const NebulaCheckbox_exports_ = /*#__PURE__*/exportHelper_default()(NebulaCheckboxvue_type_script_lang_js, [['render',NebulaCheckboxvue_type_template_id_574fc5f0_render]])

/* harmony default export */ var NebulaCheckbox = (NebulaCheckbox_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaFieldGroup.vue?vue&type=template&id=16932657

const NebulaFieldGroupvue_type_template_id_16932657_hoisted_1 = {
  class: "nebula-field-group__element-container"
};
function NebulaFieldGroupvue_type_template_id_16932657_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaLabel = Object(external_vue_["resolveComponent"])("NebulaLabel");

  const _component_NebulaFormHelper = Object(external_vue_["resolveComponent"])("NebulaFormHelper");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.containerClassName)
  }, [$props.labelText ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaLabel, {
    key: 0,
    labelText: $props.labelText,
    for: $props.inputId,
    responsiveLabelText: $props.responsiveLabelText,
    isRequired: $props.isRequired,
    requiredLabelText: $props.requiredLabelText
  }, null, 8, ["labelText", "for", "responsiveLabelText", "isRequired", "requiredLabelText"])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaFieldGroupvue_type_template_id_16932657_hoisted_1, [Object(external_vue_["renderSlot"])(_ctx.$slots, "formElement")]), $props.helperText ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaFormHelper, {
    key: 1,
    text: $props.helperText,
    icon: $props.helperIcon,
    helperId: $options.getHelperId,
    status: $props.helperStatus
  }, null, 8, ["text", "icon", "helperId", "status"])) : Object(external_vue_["createCommentVNode"])("", true)], 2);
}
// CONCATENATED MODULE: ./src/components/FormElements/NebulaFieldGroup.vue?vue&type=template&id=16932657

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaFormHelper.vue?vue&type=template&id=9c828ff6

const NebulaFormHelpervue_type_template_id_9c828ff6_hoisted_1 = ["id", "innerHTML"];
function NebulaFormHelpervue_type_template_id_9c828ff6_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.helperClassName)
  }, [$props.icon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
    key: 0,
    class: "nebula-form-helper__icon",
    symbolId: $props.icon,
    size: "s"
  }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("span", {
    class: "nebula-form-helper__text",
    id: $props.helperId,
    innerHTML: $props.text
  }, null, 8, NebulaFormHelpervue_type_template_id_9c828ff6_hoisted_1)], 2);
}
// CONCATENATED MODULE: ./src/components/FormElements/NebulaFormHelper.vue?vue&type=template&id=9c828ff6

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaFormHelper.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaFormHelpervue_type_script_lang_js = ({
  name: 'NebulaFormHelper',
  components: {
    NebulaIcon: NebulaIcon
  },
  props: {
    icon: {
      type: String,
      default: null
    },
    helperId: {
      type: [String, Number],
      required: true
    },
    status: {
      type: String,
      default: null,
      // Options: success, error
      enum: ['success', 'error']
    },
    text: {
      type: String,
      default: null
    }
  },
  computed: {
    helperClassName() {
      const className = ['nebula-form-helper', {
        'nebula-form-helper--has-icon': this.icon,
        'nebula-form-helper--error': this.status === 'error',
        'nebula-form-helper--success': this.status === 'success'
      }];
      return className;
    }

  }
});
// CONCATENATED MODULE: ./src/components/FormElements/NebulaFormHelper.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/FormElements/NebulaFormHelper.vue?vue&type=style&index=0&id=9c828ff6&lang=stylus
var NebulaFormHelpervue_type_style_index_0_id_9c828ff6_lang_stylus = __webpack_require__("9961");

// CONCATENATED MODULE: ./src/components/FormElements/NebulaFormHelper.vue







const NebulaFormHelper_exports_ = /*#__PURE__*/exportHelper_default()(NebulaFormHelpervue_type_script_lang_js, [['render',NebulaFormHelpervue_type_template_id_9c828ff6_render]])

/* harmony default export */ var NebulaFormHelper = (NebulaFormHelper_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaLabel.vue?vue&type=template&id=0fa21cc8

const NebulaLabelvue_type_template_id_0fa21cc8_hoisted_1 = ["for"];
const NebulaLabelvue_type_template_id_0fa21cc8_hoisted_2 = {
  key: 0
};
const NebulaLabelvue_type_template_id_0fa21cc8_hoisted_3 = {
  class: "nebula-label__responsive-text"
};
const NebulaLabelvue_type_template_id_0fa21cc8_hoisted_4 = {
  class: "nebula-label__desktop-text"
};
const NebulaLabelvue_type_template_id_0fa21cc8_hoisted_5 = {
  key: 2,
  class: "nebula-label__required"
};
function NebulaLabelvue_type_template_id_0fa21cc8_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("label", {
    class: "nebula-label",
    for: $props.inputId
  }, [$props.responsiveLabelText ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", NebulaLabelvue_type_template_id_0fa21cc8_hoisted_2, [Object(external_vue_["createElementVNode"])("span", NebulaLabelvue_type_template_id_0fa21cc8_hoisted_3, Object(external_vue_["toDisplayString"])($props.responsiveLabelText), 1), Object(external_vue_["createElementVNode"])("span", NebulaLabelvue_type_template_id_0fa21cc8_hoisted_4, Object(external_vue_["toDisplayString"])($props.labelText), 1)])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
    key: 1
  }, [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])($props.labelText), 1)], 64)), $props.isRequired ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", NebulaLabelvue_type_template_id_0fa21cc8_hoisted_5, Object(external_vue_["toDisplayString"])($options.requireText), 1)) : Object(external_vue_["createCommentVNode"])("", true)], 8, NebulaLabelvue_type_template_id_0fa21cc8_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/FormElements/NebulaLabel.vue?vue&type=template&id=0fa21cc8

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaLabel.vue?vue&type=script&lang=js
/* harmony default export */ var NebulaLabelvue_type_script_lang_js = ({
  name: 'NebulaLabel',
  props: {
    inputId: {
      type: [String, Number]
    },
    labelText: {
      type: String
    },
    responsiveLabelText: {
      type: String,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    requiredLabelText: {
      type: String,
      default: null
    }
  },
  computed: {
    requireText() {
      return this.requiredLabelText ? `(${this.requiredLabelText})` : '*';
    }

  }
});
// CONCATENATED MODULE: ./src/components/FormElements/NebulaLabel.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/FormElements/NebulaLabel.vue?vue&type=style&index=0&id=0fa21cc8&lang=stylus
var NebulaLabelvue_type_style_index_0_id_0fa21cc8_lang_stylus = __webpack_require__("d201");

// CONCATENATED MODULE: ./src/components/FormElements/NebulaLabel.vue







const NebulaLabel_exports_ = /*#__PURE__*/exportHelper_default()(NebulaLabelvue_type_script_lang_js, [['render',NebulaLabelvue_type_template_id_0fa21cc8_render]])

/* harmony default export */ var NebulaLabel = (NebulaLabel_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaFieldGroup.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaFieldGroupvue_type_script_lang_js = ({
  name: 'NebulaFieldGroup',
  components: {
    NebulaFormHelper: NebulaFormHelper,
    NebulaLabel: NebulaLabel
  },
  props: {
    helperIcon: {
      type: String,
      default: null
    },
    helperStatus: {
      type: String,
      default: null
    },
    helperText: {
      type: String,
      default: null
    },
    inputId: {
      type: [String, Number]
    },
    isRequired: {
      type: Boolean
    },
    requiredLabelText: {
      type: String
    },
    labelPosition: {
      type: String,
      default: 'top',
      // Options: top, inline
      enum: ['top', 'inline']
    },
    labelText: {
      type: String,
      default: null
    },
    responsiveLabelText: {
      type: String,
      default: null
    }
  },
  computed: {
    containerClassName() {
      const className = ['nebula-field-group', {
        'nebula-field-group--label-top': this.labelText && this.labelPosition === 'top',
        'nebula-field-group--label-inline': this.labelText && this.labelPosition === 'inline',
        'nebula-field-group--label-and-helper': this.labelText && this.helperText
      }];
      return className;
    },

    getHelperId() {
      return `helper-text__${this.inputId}`;
    }

  }
});
// CONCATENATED MODULE: ./src/components/FormElements/NebulaFieldGroup.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/FormElements/NebulaFieldGroup.vue?vue&type=style&index=0&id=16932657&lang=stylus
var NebulaFieldGroupvue_type_style_index_0_id_16932657_lang_stylus = __webpack_require__("75a2");

// CONCATENATED MODULE: ./src/components/FormElements/NebulaFieldGroup.vue







const NebulaFieldGroup_exports_ = /*#__PURE__*/exportHelper_default()(NebulaFieldGroupvue_type_script_lang_js, [['render',NebulaFieldGroupvue_type_template_id_16932657_render]])

/* harmony default export */ var NebulaFieldGroup = (NebulaFieldGroup_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaInputWithButtons.vue?vue&type=template&id=504cae12

const NebulaInputWithButtonsvue_type_template_id_504cae12_hoisted_1 = {
  key: 0,
  class: "nebula-input-with-buttons__button-start"
};
const NebulaInputWithButtonsvue_type_template_id_504cae12_hoisted_2 = {
  class: "nebula-input-with-buttons__input"
};
const NebulaInputWithButtonsvue_type_template_id_504cae12_hoisted_3 = {
  key: 1,
  class: "nebula-input-with-buttons__button-end"
};
function NebulaInputWithButtonsvue_type_template_id_504cae12_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.parentClasses),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [$options.hasButtonElementStart ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaInputWithButtonsvue_type_template_id_504cae12_hoisted_1, [Object(external_vue_["renderSlot"])(_ctx.$slots, "buttonElementStart")])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaInputWithButtonsvue_type_template_id_504cae12_hoisted_2, [Object(external_vue_["renderSlot"])(_ctx.$slots, "input")]), $options.hasButtonElementEnd ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaInputWithButtonsvue_type_template_id_504cae12_hoisted_3, [Object(external_vue_["renderSlot"])(_ctx.$slots, "buttonElementEnd")])) : Object(external_vue_["createCommentVNode"])("", true)], 6);
}
// CONCATENATED MODULE: ./src/components/FormElements/NebulaInputWithButtons.vue?vue&type=template&id=504cae12

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaInputWithButtons.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaInputWithButtonsvue_type_script_lang_js = ({
  name: 'NebulaInputWithButtons',
  props: {
    borderRadiusSmall: {
      type: Boolean,
      default: false
    }
  },
  mixins: [themingUtils],
  computed: {
    parentClasses() {
      const className = ['nebula-input-with-buttons', {
        'nebula-input-with-buttons--border-radius-small': this.borderRadiusSmall,
        'nebula-input-with-buttons--button-start': this.hasButtonElementStart,
        'nebula-input-with-buttons--button-end': this.hasButtonElementEnd
      }];
      return className;
    },

    hasButtonElementStart() {
      return !!this.$slots.buttonElementStart;
    },

    hasButtonElementEnd() {
      return !!this.$slots.buttonElementEnd;
    }

  }
});
// CONCATENATED MODULE: ./src/components/FormElements/NebulaInputWithButtons.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/FormElements/NebulaInputWithButtons.vue?vue&type=style&index=0&id=504cae12&lang=stylus
var NebulaInputWithButtonsvue_type_style_index_0_id_504cae12_lang_stylus = __webpack_require__("1d2a");

// CONCATENATED MODULE: ./src/components/FormElements/NebulaInputWithButtons.vue







const NebulaInputWithButtons_exports_ = /*#__PURE__*/exportHelper_default()(NebulaInputWithButtonsvue_type_script_lang_js, [['render',NebulaInputWithButtonsvue_type_template_id_504cae12_render]])

/* harmony default export */ var NebulaInputWithButtons = (NebulaInputWithButtons_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaRadio.vue?vue&type=template&id=7c368bc0

const NebulaRadiovue_type_template_id_7c368bc0_hoisted_1 = {
  class: "nebula-radio__visual"
};
const NebulaRadiovue_type_template_id_7c368bc0_hoisted_2 = ["textContent"];
function NebulaRadiovue_type_template_id_7c368bc0_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($options.getRadioContainerElement), {
    class: Object(external_vue_["normalizeClass"])($options.containerClassName),
    for: $options.getRadioFor
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "radio"), Object(external_vue_["createElementVNode"])("span", NebulaRadiovue_type_template_id_7c368bc0_hoisted_1, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      class: "nebula-radio__checked-icon",
      symbolId: $options.getRadioIcon,
      size: "s"
    }, null, 8, ["symbolId"])]), $props.labelText ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", {
      key: 0,
      class: "nebula-radio__text",
      textContent: Object(external_vue_["toDisplayString"])($props.labelText)
    }, null, 8, NebulaRadiovue_type_template_id_7c368bc0_hoisted_2)) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 3
  }, 8, ["class", "for"]);
}
// CONCATENATED MODULE: ./src/components/FormElements/NebulaRadio.vue?vue&type=template&id=7c368bc0

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaRadio.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaRadiovue_type_script_lang_js = ({
  name: 'NebulaRadio',
  components: {
    NebulaIcon: NebulaIcon
  },
  props: {
    id: {
      type: [String, Number]
    },
    isIndeterminate: {
      type: Boolean,
      default: false
    },
    labelText: {
      type: String
    },
    status: {
      type: String,
      default: null,
      // Option: error
      enum: ['null', 'error'] // for docs site

    }
  },
  computed: {
    containerClassName() {
      const className = ['nebula-radio__container', {
        'nebula-radio__container--indeterminate': this.isIndeterminate === true,
        'nebula-radio__container--error': this.status === 'error'
      }];
      return className;
    },

    getRadioContainerElement() {
      return this.labelText ? 'label' : 'span';
    },

    getRadioFor() {
      return this.labelText ? this.id : null;
    },

    getRadioIcon() {
      return this.isIndeterminate ? 'minus' : 'circle--filled';
    }

  }
});
// CONCATENATED MODULE: ./src/components/FormElements/NebulaRadio.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/FormElements/NebulaRadio.vue?vue&type=style&index=0&id=7c368bc0&lang=stylus
var NebulaRadiovue_type_style_index_0_id_7c368bc0_lang_stylus = __webpack_require__("8f8f");

// CONCATENATED MODULE: ./src/components/FormElements/NebulaRadio.vue







const NebulaRadio_exports_ = /*#__PURE__*/exportHelper_default()(NebulaRadiovue_type_script_lang_js, [['render',NebulaRadiovue_type_template_id_7c368bc0_render]])

/* harmony default export */ var NebulaRadio = (NebulaRadio_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaSelect.vue?vue&type=template&id=c3d9728a

const NebulaSelectvue_type_template_id_c3d9728a_hoisted_1 = ["id", "aria-labelledby", "disabled", "name"];
const NebulaSelectvue_type_template_id_c3d9728a_hoisted_2 = {
  class: "nebula-select__decoration"
};

const NebulaSelectvue_type_template_id_c3d9728a_hoisted_3 = /*#__PURE__*/Object(external_vue_["createElementVNode"])("div", {
  class: "nebula-select__visual-wrap"
}, null, -1);

const NebulaSelectvue_type_template_id_c3d9728a_hoisted_4 = {
  class: "nebula-select__open-indicator"
};
function NebulaSelectvue_type_template_id_c3d9728a_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaSelectOption = Object(external_vue_["resolveComponent"])("NebulaSelectOption");

  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: "nebula-select",
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [Object(external_vue_["createElementVNode"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.selectClassName),
    onChange: _cache[1] || (_cache[1] = $event => _ctx.$emit('change', $data.selectValue))
  }, [$props.options ? Object(external_vue_["withDirectives"])((Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("select", {
    key: 0,
    id: $props.id,
    "aria-labelledby": $props.ariaLabelledBy,
    class: "nebula-select__element",
    disabled: $props.disabled,
    name: $props.name,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.selectValue = $event)
  }, [$props.defaultOptionText ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaSelectOption, {
    key: 0,
    text: $props.defaultOptionText,
    value: ""
  }, null, 8, ["text"])) : Object(external_vue_["createCommentVNode"])("", true), (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.options, option => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaSelectOption, Object(external_vue_["mergeProps"])({
      key: option.value
    }, option), null, 16);
  }), 128))], 8, NebulaSelectvue_type_template_id_c3d9728a_hoisted_1)), [[external_vue_["vModelSelect"], $data.selectValue]]) : Object(external_vue_["renderSlot"])(_ctx.$slots, "select", {
    key: 1
  }), Object(external_vue_["createElementVNode"])("div", NebulaSelectvue_type_template_id_c3d9728a_hoisted_2, [NebulaSelectvue_type_template_id_c3d9728a_hoisted_3, Object(external_vue_["createElementVNode"])("span", NebulaSelectvue_type_template_id_c3d9728a_hoisted_4, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
    class: "nebula-select__open-icon",
    symbolId: "caret-down"
  })])])], 34)], 4);
}
// CONCATENATED MODULE: ./src/components/FormElements/NebulaSelect.vue?vue&type=template&id=c3d9728a

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaSelectOption.vue?vue&type=template&id=78410ec2

const NebulaSelectOptionvue_type_template_id_78410ec2_hoisted_1 = ["disabled", "selected", "text", "value"];
function NebulaSelectOptionvue_type_template_id_78410ec2_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("option", {
    disabled: $options.getDisabled,
    selected: $options.getSelected,
    text: $options.getText,
    value: $options.getValue
  }, Object(external_vue_["toDisplayString"])($options.getText), 9, NebulaSelectOptionvue_type_template_id_78410ec2_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/FormElements/NebulaSelectOption.vue?vue&type=template&id=78410ec2

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaSelectOption.vue?vue&type=script&lang=js
/* harmony default export */ var NebulaSelectOptionvue_type_script_lang_js = ({
  name: 'NebulaSelectOption',
  props: {
    option: {
      type: Object,
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    selectedOption: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    return {
      formattedOption: this.option
    };
  },

  computed: {
    getDisabled() {
      return this.formattedOption ? this.formattedOption.isDisabled : this.isDisabled;
    },

    getSelected() {
      return this.formattedOption ? this.formattedOption.selected : this.isSelected;
    },

    getText() {
      return this.formattedOption ? this.formattedOption.text : this.text;
    },

    getValue() {
      return this.formattedOption ? this.formattedOption.value : this.value;
    }

  },

  created() {
    if (this.selectedOption && this.formattedOption) {
      Object.keys(this.formattedOption).forEach(key => {
        if (key === 'value' && this.formattedOption[key] === this.selectedOption) {
          this.formattedOption.selected = true;
        }
      });
    }
  }

});
// CONCATENATED MODULE: ./src/components/FormElements/NebulaSelectOption.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/components/FormElements/NebulaSelectOption.vue





const NebulaSelectOption_exports_ = /*#__PURE__*/exportHelper_default()(NebulaSelectOptionvue_type_script_lang_js, [['render',NebulaSelectOptionvue_type_template_id_78410ec2_render]])

/* harmony default export */ var NebulaSelectOption = (NebulaSelectOption_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaSelect.vue?vue&type=script&lang=js



/* harmony default export */ var NebulaSelectvue_type_script_lang_js = ({
  name: 'NebulaSelect',
  components: {
    NebulaIcon: NebulaIcon,
    NebulaSelectOption: NebulaSelectOption
  },

  data() {
    return {
      selectValue: this.value || this.modelValue
    };
  },

  mixins: [themingUtils],
  props: {
    isMultiple: {
      type: Boolean,
      default: false
    },
    ariaLabelledBy: {
      type: String,
      default: null
    },
    defaultOptionText: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: null
    },
    size: {
      type: String,
      default: 'm',
      // Options: s, m, l
      enum: ['xs', 's', 'm', 'l'] // for docs site

    },
    status: {
      type: String,
      default: null // Options: success, error

    },
    value: {
      type: [String, Number],
      default: ''
    },
    modelValue: {
      type: [String, Number],
      default: ''
    }
  },
  emits: ['change', 'update:model-value'],
  computed: {
    selectClassName() {
      const className = ['nebula-select__input', `nebula-select__input--${this.size}`, {
        'nebula-select__input--error': this.status === 'error',
        'nebula-select__input--multiple': this.isMultiple === true,
        'nebula-select__input--success': this.status === 'success'
      }];
      return className;
    }

  },
  watch: {
    selectValue(value) {
      this.$emit('update:model-value', value);
    }

  }
});
// CONCATENATED MODULE: ./src/components/FormElements/NebulaSelect.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/FormElements/NebulaSelect.vue?vue&type=style&index=0&id=c3d9728a&lang=stylus
var NebulaSelectvue_type_style_index_0_id_c3d9728a_lang_stylus = __webpack_require__("d1cd");

// CONCATENATED MODULE: ./src/components/FormElements/NebulaSelect.vue







const NebulaSelect_exports_ = /*#__PURE__*/exportHelper_default()(NebulaSelectvue_type_script_lang_js, [['render',NebulaSelectvue_type_template_id_c3d9728a_render]])

/* harmony default export */ var NebulaSelect = (NebulaSelect_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaSwitch.vue?vue&type=template&id=03f59b55

const NebulaSwitchvue_type_template_id_03f59b55_hoisted_1 = {
  class: "nebula-switch__visual"
};
const NebulaSwitchvue_type_template_id_03f59b55_hoisted_2 = ["textContent"];
function NebulaSwitchvue_type_template_id_03f59b55_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($options.getSwitchContainerElement), {
    class: Object(external_vue_["normalizeClass"])($options.containerClassName),
    for: $options.getSwitchFor
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "checkbox"), Object(external_vue_["createElementVNode"])("span", NebulaSwitchvue_type_template_id_03f59b55_hoisted_1, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      class: "nebula-switch__checked-icon",
      symbolId: "circle--filled",
      size: "s"
    })]), $props.labelText ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", {
      key: 0,
      class: "nebula-switch__text",
      textContent: Object(external_vue_["toDisplayString"])($props.labelText)
    }, null, 8, NebulaSwitchvue_type_template_id_03f59b55_hoisted_2)) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 3
  }, 8, ["class", "for"]);
}
// CONCATENATED MODULE: ./src/components/FormElements/NebulaSwitch.vue?vue&type=template&id=03f59b55

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaSwitch.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaSwitchvue_type_script_lang_js = ({
  name: 'NebulaSwitch',
  components: {
    NebulaIcon: NebulaIcon
  },
  props: {
    id: {
      type: [String, Number]
    },
    isCompressed: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isInverted: {
      type: Boolean,
      default: false
    },
    labelText: {
      type: String
    }
  },
  computed: {
    containerClassName() {
      const className = ['nebula-switch__container', {
        'nebula-switch__container--compressed': this.isCompressed === true,
        'nebula-switch__container--inverted': this.isInverted === true,
        'nebula-switch__container--disabled': this.isDisabled === true
      }];
      return className;
    },

    getSwitchContainerElement() {
      return this.labelText ? 'label' : 'span';
    },

    getSwitchFor() {
      return this.labelText ? this.id : null;
    }

  }
});
// CONCATENATED MODULE: ./src/components/FormElements/NebulaSwitch.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/FormElements/NebulaSwitch.vue?vue&type=style&index=0&id=03f59b55&lang=stylus
var NebulaSwitchvue_type_style_index_0_id_03f59b55_lang_stylus = __webpack_require__("77f5");

// CONCATENATED MODULE: ./src/components/FormElements/NebulaSwitch.vue







const NebulaSwitch_exports_ = /*#__PURE__*/exportHelper_default()(NebulaSwitchvue_type_script_lang_js, [['render',NebulaSwitchvue_type_template_id_03f59b55_render]])

/* harmony default export */ var NebulaSwitch = (NebulaSwitch_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaTextarea.vue?vue&type=template&id=63e72c4e

const NebulaTextareavue_type_template_id_63e72c4e_hoisted_1 = ["aria-describedby", "aria-disabled", "id", "name", "value"];
function NebulaTextareavue_type_template_id_63e72c4e_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("textarea", {
    "aria-describedby": $props.hasHelper ? $options.getHelperId : null,
    class: Object(external_vue_["normalizeClass"])($options.textareaClassName),
    "aria-disabled": $props.isDisabled ? 'true' : null,
    id: $props.id,
    name: $props.name,
    value: $props.text || $props.modelValue,
    onInput: _cache[0] || (_cache[0] = (...args) => $options.onInput && $options.onInput(...args))
  }, null, 42, NebulaTextareavue_type_template_id_63e72c4e_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/FormElements/NebulaTextarea.vue?vue&type=template&id=63e72c4e

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/FormElements/NebulaTextarea.vue?vue&type=script&lang=js
/* harmony default export */ var NebulaTextareavue_type_script_lang_js = ({
  name: 'NebulaTextarea',
  props: {
    hasHelper: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number]
    },
    name: {
      type: String
    },
    status: {
      type: String,
      default: null,
      // Options: success, error
      enum: ['success', 'error'] // for docs site

    },
    text: {
      type: String
    },
    modelValue: {
      type: String
    }
  },
  emits: ['input', 'update:model-value'],
  computed: {
    textareaClassName() {
      const className = ['nebula-textarea', {
        'nebula-textarea--error': this.status === 'error',
        'nebula-textarea--success': this.status === 'success'
      }];
      return className;
    },

    getHelperId() {
      return `helper-text__${this.id}`;
    }

  },
  methods: {
    onInput(e) {
      this.$emit('update:model-value', e.target.value); // standard event for Vue 3 v-model

      this.$emit('input', e.target.value); // older code may still listen for this
    }

  }
});
// CONCATENATED MODULE: ./src/components/FormElements/NebulaTextarea.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/FormElements/NebulaTextarea.vue?vue&type=style&index=0&id=63e72c4e&lang=stylus
var NebulaTextareavue_type_style_index_0_id_63e72c4e_lang_stylus = __webpack_require__("a8c8");

// CONCATENATED MODULE: ./src/components/FormElements/NebulaTextarea.vue







const NebulaTextarea_exports_ = /*#__PURE__*/exportHelper_default()(NebulaTextareavue_type_script_lang_js, [['render',NebulaTextareavue_type_template_id_63e72c4e_render]])

/* harmony default export */ var NebulaTextarea = (NebulaTextarea_exports_);
// EXTERNAL MODULE: ./src/assets/de-logo.png
var de_logo = __webpack_require__("57f7");
var de_logo_default = /*#__PURE__*/__webpack_require__.n(de_logo);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/GlobalNav/NebulaGlobalNav.vue?vue&type=template&id=5b481dde


const NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_1 = ["aria-label", "id"];
const NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_2 = {
  class: "nebula-global-nav__top"
};
const NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_3 = ["alt"];
const NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_4 = ["aria-label", "href"];
const NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_5 = ["alt"];
const NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_6 = {
  class: "nebula-global-nav__section"
};
const NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_7 = {
  class: "nebula-global-nav__header"
};
const NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_8 = {
  class: "nebula-global-nav__section"
};
const NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_9 = {
  class: "nebula-global-nav__header"
};
const NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_10 = {
  class: "nebula-global-nav__section"
};
const NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_11 = {
  class: "nebula-global-nav__header"
};
const NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_12 = {
  class: "nebula-global-nav__section"
};
const NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_13 = {
  class: "nebula-global-nav__header"
};
function NebulaGlobalNavvue_type_template_id_5b481dde_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RouterLink = Object(external_vue_["resolveComponent"])("RouterLink");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_GlobalNavItem = Object(external_vue_["resolveComponent"])("GlobalNavItem");

  const _component_FocusTrap = Object(external_vue_["resolveComponent"])("FocusTrap");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_FocusTrap, {
    active: $options.focusTrapActive,
    escapeDeactivates: false,
    initialFocus: ".nebula-global-nav__section .nebula-global-nav-item"
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("nav", {
      "aria-label": _ctx.$t('Global Navigation'),
      "aria-modal": "true",
      class: Object(external_vue_["normalizeClass"])(["nebula-global-nav", !$props.isOpen && 'nebula-global-nav--closed']),
      id: $props.id,
      role: "dialog",
      tabindex: "0",
      onKeydown: _cache[0] || (_cache[0] = (...args) => $options.handleKeydown && $options.handleKeydown(...args))
    }, [Object(external_vue_["createElementVNode"])("div", NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_2, [$props.routerLink ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_RouterLink, {
      key: 0,
      "aria-label": _ctx.$t('Home'),
      to: $props.homeLink,
      ref: "home",
      class: "nebula-product-bar__home",
      "data-click-name": "Logo",
      "data-click-type": "Global Navigation"
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("img", {
        src: de_logo_default.a,
        alt: _ctx.$t('Discovery Education Logo'),
        height: "40",
        width: "46"
      }, null, 8, NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_3)]),
      _: 1
    }, 8, ["aria-label", "to"])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("a", {
      key: 1,
      "aria-label": _ctx.$t('Home'),
      href: $props.homeLink,
      ref: "home",
      class: "nebula-product-bar__home",
      "data-click-name": "Logo",
      "data-click-type": "Global Navigation"
    }, [Object(external_vue_["createElementVNode"])("img", {
      src: de_logo_default.a,
      alt: _ctx.$t('Discovery Education Logo'),
      height: "40",
      width: "46"
    }, null, 8, NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_5)], 8, NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_4)), Object(external_vue_["createVNode"])(_component_NebulaButton, {
      iconLeft: "x",
      size: "s",
      type: "flat",
      class: "nebula-global-nav__close",
      "aria-label": "close global navigation",
      onClick: $options.handleClose,
      "data-click-name": "Navigation Closed",
      "data-click-type": "Global Navigation"
    }, null, 8, ["onClick"])]), $props.data && $props.data.navigation ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
      key: 0
    }, [Object(external_vue_["createElementVNode"])("section", NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_6, [Object(external_vue_["createElementVNode"])("h2", NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_7, Object(external_vue_["toDisplayString"])(_ctx.$t('My DE')), 1), (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(Object.keys($options.parsedData.myDE), link => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_GlobalNavItem, {
        styleMap: $data.GlobalNavData.supportedMyDE,
        key: link,
        data: $options.parsedData.myDE[link]
      }, null, 8, ["styleMap", "data"]);
    }), 128))]), Object(external_vue_["createElementVNode"])("section", NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_8, [Object(external_vue_["createElementVNode"])("h2", NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_9, Object(external_vue_["toDisplayString"])(_ctx.$t('Discover')), 1), (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(Object.keys($options.parsedData.discover), discoverItem => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_GlobalNavItem, {
        key: discoverItem,
        styleMap: $data.GlobalNavData.supportedDiscover,
        data: $options.parsedData.discover[discoverItem]
      }, null, 8, ["styleMap", "data"]);
    }), 128))]), Object(external_vue_["createElementVNode"])("section", NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_10, [Object(external_vue_["createElementVNode"])("h2", NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_11, Object(external_vue_["toDisplayString"])(_ctx.$t('Tools')), 1), (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(Object.keys($options.parsedData.tools), tool => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_GlobalNavItem, {
        key: tool,
        styleMap: $data.GlobalNavData.supportedTools,
        data: $options.parsedData.tools[tool]
      }, null, 8, ["styleMap", "data"]);
    }), 128))]), Object(external_vue_["createElementVNode"])("section", NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_12, [Object(external_vue_["createElementVNode"])("h2", NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_13, Object(external_vue_["toDisplayString"])(_ctx.$t('Curriculum Packs')), 1), (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(Object.keys($options.parsedData.products), product => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_GlobalNavItem, {
        key: product,
        styleMap: $data.GlobalNavData.supportedProducts,
        data: $options.parsedData.products[product]
      }, null, 8, ["styleMap", "data"]);
    }), 128))])], 64)) : Object(external_vue_["createCommentVNode"])("", true)], 42, NebulaGlobalNavvue_type_template_id_5b481dde_hoisted_1)]),
    _: 1
  }, 8, ["active"]);
}
// CONCATENATED MODULE: ./src/components/GlobalNav/NebulaGlobalNav.vue?vue&type=template&id=5b481dde

// CONCATENATED MODULE: ./node_modules/tabbable/dist/index.esm.js
/*!
* tabbable 6.1.2
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
// NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var candidateSelectors = ['input:not([inert])', 'select:not([inert])', 'textarea:not([inert])', 'a[href]:not([inert])', 'button:not([inert])', '[tabindex]:not(slot):not([inert])', 'audio[controls]:not([inert])', 'video[controls]:not([inert])', '[contenteditable]:not([contenteditable="false"]):not([inert])', 'details>summary:first-of-type:not([inert])', 'details:not([inert])'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function (element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};

/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */
var isInert = function isInert(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
  //  JS API property; we have to check the attribute, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's an active element
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
  var inert = inertAtt === '' || inertAtt === 'true';

  // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
  //  if it weren't for `matches()` not being a function on shadow roots; the following
  //  code works for any kind of node
  // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
  //  so it likely would not support `:is([inert] *)` either...
  var result = inert || lookUp && node && isInert(node.parentNode); // recursive

  return result;
};

/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */
var isContentEditable = function isContentEditable(node) {
  var _node$getAttribute2;
  // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
  //  to use the attribute directly to check for this, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's a non-editable element
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
  return attValue === '' || attValue === 'true';
};

/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */
var getCandidates = function getCandidates(el, includeContainer, filter) {
  // even if `includeContainer=false`, we still have to check it for inertness because
  //  if it's inert, all its children are inert
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};

/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */
var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      // no need to look up since we're drilling down
      // anything inside this container will also be inert
      continue;
    }
    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }

      // iterate over shadow content if possible
      var shadowRoot = element.shadowRoot ||
      // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);

      // no inert look up because we're already drilling down and checking for inertness
      //  on the way down, so all containers to this root node should have already been
      //  vetted as non-inert
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};
var getTabindex = function getTabindex(node, isScope) {
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    //
    // isScope is positive for custom element with shadow root or slot that by default
    // have tabIndex -1, but need to be sorted by document order in order for their
    // content to be inserted in the correct position
    if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && isNaN(parseInt(node.getAttribute('tabindex'), 10))) {
      return 0;
    }
  }
  return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};
var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
  var _nodeRoot;
  // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // To further complicate things, we have to look all the way up until we find a shadow HOST
  //  that is attached (or find none) because the node might be in nested shadows...
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.
  // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
  //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
  //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
  //  `ownerDocument` will be `null`, hence the optional chaining on it.
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;

  // in some cases, a detached node will return itself as the root instead of a document or
  //  shadow root object, in which case, we shouldn't try to look further up the host chain
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
      //  which means we need to get the host's host and check if that parent host is contained
      //  in (i.e. attached to) the document
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
    getShadowRoot = _ref.getShadowRoot;
  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }
  if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }
      node = originalNode;
    }
    // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled

    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.

    if (isNodeAttached(node)) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    }

    // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    //
    // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
    //  nodes as visible with the 'none' fallback.__
    if (displayCheck !== 'legacy-full') {
      return true; // hidden
    }
    // else, fallback to 'none' mode and consider the node visible
  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  }

  // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
  //  it's visible
  return false;
};

// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    // check if `node` is contained in a disabled <fieldset>
    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          // when the first <legend> (in document order) is found
          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        }
        // the disabled <fieldset> containing `node` has no <legend>
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }

  // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled ||
  // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options) ||
  // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.
  return false;
};

/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */
var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getTabindex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var focusable = function focusable(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');
var isFocusable = function isFocusable(node, options) {
  options = options || {};
  if (!node) {
    throw new Error('No node provided');
  }
  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node);
};


//# sourceMappingURL=index.esm.js.map

// CONCATENATED MODULE: ./node_modules/focus-trap/dist/focus-trap.esm.js
/*!
* focus-trap 7.4.3
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      focus_trap_esm_defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function focus_trap_esm_defineProperty(obj, key, value) {
  key = focus_trap_esm_toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function focus_trap_esm_toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function focus_trap_esm_toPropertyKey(arg) {
  var key = focus_trap_esm_toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var activeFocusTraps = {
  activateTrap: function activateTrap(trapStack, trap) {
    if (trapStack.length > 0) {
      var activeTrap = trapStack[trapStack.length - 1];
      if (activeTrap !== trap) {
        activeTrap.pause();
      }
    }
    var trapIndex = trapStack.indexOf(trap);
    if (trapIndex === -1) {
      trapStack.push(trap);
    } else {
      // move this existing trap to the front of the queue
      trapStack.splice(trapIndex, 1);
      trapStack.push(trap);
    }
  },
  deactivateTrap: function deactivateTrap(trapStack, trap) {
    var trapIndex = trapStack.indexOf(trap);
    if (trapIndex !== -1) {
      trapStack.splice(trapIndex, 1);
    }
    if (trapStack.length > 0) {
      trapStack[trapStack.length - 1].unpause();
    }
  }
};
var isSelectableInput = function isSelectableInput(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};
var isEscapeEvent = function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
};
var isTabEvent = function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
};

// checks for TAB by default
var isKeyForward = function isKeyForward(e) {
  return isTabEvent(e) && !e.shiftKey;
};

// checks for SHIFT+TAB by default
var isKeyBackward = function isKeyBackward(e) {
  return isTabEvent(e) && e.shiftKey;
};
var delay = function delay(fn) {
  return setTimeout(fn, 0);
};

// Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs
var focus_trap_esm_findIndex = function findIndex(arr, fn) {
  var idx = -1;
  arr.every(function (value, i) {
    if (fn(value)) {
      idx = i;
      return false; // break
    }

    return true; // next
  });

  return idx;
};

/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */
var valueOrHandler = function valueOrHandler(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof value === 'function' ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget(event) {
  // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
  //  shadow host. However, event.target.composedPath() will be an array of
  //  nodes "clicked" from inner-most (the actual element inside the shadow) to
  //  outer-most (the host HTML document). If we have access to composedPath(),
  //  then use its first element; otherwise, fall back to event.target (and
  //  this only works for an _open_ shadow DOM; otherwise,
  //  composedPath()[0] === event.target always).
  return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};

// NOTE: this must be _outside_ `createFocusTrap()` to make sure all traps in this
//  current instance use the same stack if `userOptions.trapStack` isn't specified
var internalTrapStack = [];
var focus_trap_esm_createFocusTrap = function createFocusTrap(elements, userOptions) {
  // SSR: a live trap shouldn't be created in this type of environment so this
  //  should be safe code to execute if the `document` option isn't specified
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
  var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || internalTrapStack;
  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true,
    isKeyForward: isKeyForward,
    isKeyBackward: isKeyBackward
  }, userOptions);
  var state = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   firstTabbableNode: HTMLElement|null,
    //   lastTabbableNode: HTMLElement|null,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list

    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: undefined
  };
  var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

  /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */
  var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };

  /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @param {Event} [event]
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */
  var findContainerIndex = function findContainerIndex(element, event) {
    var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === 'function' ? event.composedPath() : undefined;
    // NOTE: search `containerGroups` because it's possible a group contains no tabbable
    //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
    //  and we still need to find the element in there
    return state.containerGroups.findIndex(function (_ref) {
      var container = _ref.container,
        tabbableNodes = _ref.tabbableNodes;
      return container.contains(element) || ( // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function (node) {
        return node === element;
      });
    });
  };

  /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */
  var getNodeForOption = function getNodeForOption(optionName) {
    var optionValue = config[optionName];
    if (typeof optionValue === 'function') {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }
      optionValue = optionValue.apply(void 0, params);
    }
    if (optionValue === true) {
      optionValue = undefined; // use default value
    }

    if (!optionValue) {
      if (optionValue === undefined || optionValue === false) {
        return optionValue;
      }
      // else, empty string (invalid), null (invalid), 0 (invalid)

      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }
    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue); // resolve to node, or null if fails
      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }
    return node;
  };
  var getInitialFocusNode = function getInitialFocusNode() {
    var node = getNodeForOption('initialFocus');

    // false explicitly indicates we want no initialFocus at all
    if (node === false) {
      return false;
    }
    if (node === undefined || !isFocusable(node, config.tabbableOptions)) {
      // option not specified nor focusable: use fallback options
      if (findContainerIndex(doc.activeElement) >= 0) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;

        // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
        node = firstTabbableNode || getNodeForOption('fallbackFocus');
      }
    }
    if (!node) {
      throw new Error('Your focus-trap needs to have at least one focusable element');
    }
    return node;
  };
  var updateTabbableNodes = function updateTabbableNodes() {
    state.containerGroups = state.containers.map(function (container) {
      var tabbableNodes = tabbable(container, config.tabbableOptions);

      // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
      //  are a superset of tabbable nodes
      var focusableNodes = focusable(container, config.tabbableOptions);
      return {
        container: container,
        tabbableNodes: tabbableNodes,
        focusableNodes: focusableNodes,
        firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
        lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function nextTabbableNode(node) {
          var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          // NOTE: If tabindex is positive (in order to manipulate the tab order separate
          //  from the DOM order), this __will not work__ because the list of focusableNodes,
          //  while it contains tabbable nodes, does not sort its nodes in any order other
          //  than DOM order, because it can't: Where would you place focusable (but not
          //  tabbable) nodes in that order? They have no order, because they aren't tabbale...
          // Support for positive tabindex is already broken and hard to manage (possibly
          //  not supportable, TBD), so this isn't going to make things worse than they
          //  already are, and at least makes things better for the majority of cases where
          //  tabindex is either 0/unset or negative.
          // FYI, positive tabindex issue: https://github.com/focus-trap/focus-trap/issues/375
          var nodeIdx = focusableNodes.findIndex(function (n) {
            return n === node;
          });
          if (nodeIdx < 0) {
            return undefined;
          }
          if (forward) {
            return focusableNodes.slice(nodeIdx + 1).find(function (n) {
              return isTabbable(n, config.tabbableOptions);
            });
          }
          return focusableNodes.slice(0, nodeIdx).reverse().find(function (n) {
            return isTabbable(n, config.tabbableOptions);
          });
        }
      };
    });
    state.tabbableGroups = state.containerGroups.filter(function (group) {
      return group.tabbableNodes.length > 0;
    });

    // throw if no groups have tabbable nodes and we don't have a fallback focus node either
    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
    ) {
      throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
    }
  };
  var tryFocus = function tryFocus(node) {
    if (node === false) {
      return;
    }
    if (node === doc.activeElement) {
      return;
    }
    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }
    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  };
  var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus', previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  };

  // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.
  var checkPointerDown = function checkPointerDown(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target, e) >= 0) {
      // allow the click since it ocurred inside the trap
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      // immediately deactivate the trap
      trap.deactivate({
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked (and if not focusable, to "nothing"); by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node), whether the
        //  outside click was on a focusable node or not
        returnFocus: config.returnFocusOnDeactivate
      });
      return;
    }

    // This is needed for mobile devices.
    // (If we'll only let `click` events through,
    // then on mobile they will be blocked anyways if `touchstart` is blocked.)
    if (valueOrHandler(config.allowOutsideClick, e)) {
      // allow the click outside the trap to take place
      return;
    }

    // otherwise, prevent the click
    e.preventDefault();
  };

  // In case focus escapes the trap for some strange reason, pull it back in.
  var checkFocusIn = function checkFocusIn(e) {
    var target = getActualTarget(e);
    var targetContained = findContainerIndex(target, e) >= 0;

    // In Firefox when you Tab out of an iframe the Document is briefly focused.
    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      // escaped! pull it back in to where it just left
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  };

  // Hijack key nav events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.
  var checkKeyNav = function checkKeyNav(event) {
    var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var target = getActualTarget(event);
    updateTabbableNodes();
    var destinationNode = null;
    if (state.tabbableGroups.length > 0) {
      // make sure the target is actually contained in a group
      // NOTE: the target may also be the container itself if it's focusable
      //  with tabIndex='-1' and was given initial focus
      var containerIndex = findContainerIndex(target, event);
      var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
      if (containerIndex < 0) {
        // target not found in any group: quite possible focus has escaped the trap,
        //  so bring it back into...
        if (isBackward) {
          // ...the last node in the last group
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          // ...the first node in the first group
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (isBackward) {
        // REVERSE

        // is the target the first tabbable node in a group?
        var startOfGroupIndex = focus_trap_esm_findIndex(state.tabbableGroups, function (_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });
        if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
          // an exception case where the target is either the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle shift+tab as if focus were on the container's
          //  first tabbable node, and go to the last tabbable node of the LAST group
          startOfGroupIndex = containerIndex;
        }
        if (startOfGroupIndex >= 0) {
          // YES: then shift+tab should go to the last tabbable node in the
          //  previous group (and wrap around to the last tabbable node of
          //  the LAST group if it's the first tabbable node of the FIRST group)
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        } else if (!isTabEvent(event)) {
          // user must have customized the nav keys so we have to move focus manually _within_
          //  the active group: do this based on the order determined by tabbable()
          destinationNode = containerGroup.nextTabbableNode(target, false);
        }
      } else {
        // FORWARD

        // is the target the last tabbable node in a group?
        var lastOfGroupIndex = focus_trap_esm_findIndex(state.tabbableGroups, function (_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });
        if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
          // an exception case where the target is the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle tab as if focus were on the container's
          //  last tabbable node, and go to the first tabbable node of the FIRST group
          lastOfGroupIndex = containerIndex;
        }
        if (lastOfGroupIndex >= 0) {
          // YES: then tab should go to the first tabbable node in the next
          //  group (and wrap around to the first tabbable node of the FIRST
          //  group if it's the last tabbable node of the LAST group)
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        } else if (!isTabEvent(event)) {
          // user must have customized the nav keys so we have to move focus manually _within_
          //  the active group: do this based on the order determined by tabbable()
          destinationNode = containerGroup.nextTabbableNode(target);
        }
      }
    } else {
      // no groups available
      // NOTE: the fallbackFocus option does not support returning false to opt-out
      destinationNode = getNodeForOption('fallbackFocus');
    }
    if (destinationNode) {
      if (isTabEvent(event)) {
        // since tab natively moves focus, we wouldn't have a destination node unless we
        //  were on the edge of a container and had to move to the next/previous edge, in
        //  which case we want to prevent default to keep the browser from moving focus
        //  to where it normally would
        event.preventDefault();
      }
      tryFocus(destinationNode);
    }
    // else, let the browser take care of [shift+]tab and move the focus
  };

  var checkKey = function checkKey(event) {
    if (isEscapeEvent(event) && valueOrHandler(config.escapeDeactivates, event) !== false) {
      event.preventDefault();
      trap.deactivate();
      return;
    }
    if (config.isKeyForward(event) || config.isKeyBackward(event)) {
      checkKeyNav(event, config.isKeyBackward(event));
    }
  };
  var checkClick = function checkClick(e) {
    var target = getActualTarget(e);
    if (findContainerIndex(target, e) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
  };

  //
  // EVENT LISTENERS
  //

  var addListeners = function addListeners() {
    if (!state.active) {
      return;
    }

    // There can be only one listening focus trap at a time
    activeFocusTraps.activateTrap(trapStack, trap);

    // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.
    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };
  var removeListeners = function removeListeners() {
    if (!state.active) {
      return;
    }
    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);
    return trap;
  };

  //
  // MUTATION OBSERVER
  //

  var checkDomRemoval = function checkDomRemoval(mutations) {
    var isFocusedNodeRemoved = mutations.some(function (mutation) {
      var removedNodes = Array.from(mutation.removedNodes);
      return removedNodes.some(function (node) {
        return node === state.mostRecentlyFocusedNode;
      });
    });

    // If the currently focused is removed then browsers will move focus to the
    // <body> element. If this happens, try to move focus back into the trap.
    if (isFocusedNodeRemoved) {
      tryFocus(getInitialFocusNode());
    }
  };

  // Use MutationObserver - if supported - to detect if focused node is removed
  // from the DOM.
  var mutationObserver = typeof window !== 'undefined' && 'MutationObserver' in window ? new MutationObserver(checkDomRemoval) : undefined;
  var updateObservedNodes = function updateObservedNodes() {
    if (!mutationObserver) {
      return;
    }
    mutationObserver.disconnect();
    if (state.active && !state.paused) {
      state.containers.map(function (container) {
        mutationObserver.observe(container, {
          subtree: true,
          childList: true
        });
      });
    }
  };

  //
  // TRAP DEFINITION
  //

  trap = {
    get active() {
      return state.active;
    },
    get paused() {
      return state.paused;
    },
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }
      var onActivate = getOption(activateOptions, 'onActivate');
      var onPostActivate = getOption(activateOptions, 'onPostActivate');
      var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');
      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;
      onActivate === null || onActivate === void 0 ? void 0 : onActivate();
      var finishActivation = function finishActivation() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }
        addListeners();
        updateObservedNodes();
        onPostActivate === null || onPostActivate === void 0 ? void 0 : onPostActivate();
      };
      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }
      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }
      var options = _objectSpread2({
        onDeactivate: config.onDeactivate,
        onPostDeactivate: config.onPostDeactivate,
        checkCanReturnFocus: config.checkCanReturnFocus
      }, deactivateOptions);
      clearTimeout(state.delayInitialFocusTimer); // noop if undefined
      state.delayInitialFocusTimer = undefined;
      removeListeners();
      state.active = false;
      state.paused = false;
      updateObservedNodes();
      activeFocusTraps.deactivateTrap(trapStack, trap);
      var onDeactivate = getOption(options, 'onDeactivate');
      var onPostDeactivate = getOption(options, 'onPostDeactivate');
      var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
      var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');
      onDeactivate === null || onDeactivate === void 0 ? void 0 : onDeactivate();
      var finishDeactivation = function finishDeactivation() {
        delay(function () {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }
          onPostDeactivate === null || onPostDeactivate === void 0 ? void 0 : onPostDeactivate();
        });
      };
      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }
      finishDeactivation();
      return this;
    },
    pause: function pause(pauseOptions) {
      if (state.paused || !state.active) {
        return this;
      }
      var onPause = getOption(pauseOptions, 'onPause');
      var onPostPause = getOption(pauseOptions, 'onPostPause');
      state.paused = true;
      onPause === null || onPause === void 0 ? void 0 : onPause();
      removeListeners();
      updateObservedNodes();
      onPostPause === null || onPostPause === void 0 ? void 0 : onPostPause();
      return this;
    },
    unpause: function unpause(unpauseOptions) {
      if (!state.paused || !state.active) {
        return this;
      }
      var onUnpause = getOption(unpauseOptions, 'onUnpause');
      var onPostUnpause = getOption(unpauseOptions, 'onPostUnpause');
      state.paused = false;
      onUnpause === null || onUnpause === void 0 ? void 0 : onUnpause();
      updateTabbableNodes();
      addListeners();
      updateObservedNodes();
      onPostUnpause === null || onPostUnpause === void 0 ? void 0 : onPostUnpause();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === 'string' ? doc.querySelector(element) : element;
      });
      if (state.active) {
        updateTabbableNodes();
      }
      updateObservedNodes();
      return this;
    }
  };

  // initialize container elements
  trap.updateContainerElements(elements);
  return trap;
};


//# sourceMappingURL=focus-trap.esm.js.map

// CONCATENATED MODULE: ./node_modules/focus-trap-vue/dist/focus-trap-vue.esm-browser.js
/*!
  * focus-trap-vue v4.0.1
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */



function defineFocusTrapProps(props) {
    return props;
}
const FocusTrapProps = defineFocusTrapProps({
    escapeDeactivates: {
        type: Boolean,
        default: true,
    },
    returnFocusOnDeactivate: {
        type: Boolean,
        default: true,
    },
    allowOutsideClick: {
        type: [Boolean, Function],
        default: true,
    },
    clickOutsideDeactivates: [Boolean, Function],
    initialFocus: [String, Function, Boolean],
    fallbackFocus: [String, Function],
    checkCanFocusTrap: Function,
    checkCanReturnFocus: Function,
    delayInitialFocus: {
        type: Boolean,
        default: true,
    },
    document: Object,
    preventScroll: Boolean,
    setReturnFocus: [Object, String, Boolean, Function],
    tabbableOptions: Object,
});
const FocusTrap = Object(external_vue_["defineComponent"])({
    props: Object.assign({
        active: {
            // TODO: could be options for activate but what about the options for deactivating?
            type: Boolean,
            default: true,
        },
    }, FocusTrapProps),
    emits: [
        'update:active',
        'activate',
        'postActivate',
        'deactivate',
        'postDeactivate',
    ],
    render() {
        return this.renderImpl();
    },
    setup(props, { slots, emit }) {
        let trap;
        const wrapperEl = Object(external_vue_["ref"])(null);
        const el = Object(external_vue_["computed"])(() => {
            const innerElement = wrapperEl.value;
            return (innerElement &&
                (innerElement instanceof HTMLElement
                    ? innerElement
                    : innerElement.$el));
        });
        function ensureTrap() {
            if (trap) {
                return trap;
            }
            return (trap = focus_trap_esm_createFocusTrap(el.value, {
                escapeDeactivates: props.escapeDeactivates,
                allowOutsideClick: props.allowOutsideClick,
                returnFocusOnDeactivate: props.returnFocusOnDeactivate,
                clickOutsideDeactivates: props.clickOutsideDeactivates,
                onActivate: () => {
                    emit('update:active', true);
                    emit('activate');
                },
                onDeactivate: () => {
                    emit('update:active', false);
                    emit('deactivate');
                },
                onPostActivate: () => emit('postActivate'),
                onPostDeactivate: () => emit('postDeactivate'),
                initialFocus: props.initialFocus,
                fallbackFocus: props.fallbackFocus,
                tabbableOptions: props.tabbableOptions,
                delayInitialFocus: props.delayInitialFocus,
            }));
        }
        Object(external_vue_["onMounted"])(() => {
            Object(external_vue_["watch"])(() => props.active, active => {
                if (active && el.value) {
                    // has no effect if already activated
                    ensureTrap().activate();
                }
                else if (trap) {
                    trap.deactivate();
                    // this allows v-if blocks to work by invalidating the trap
                    // and forcing a new one to be created
                    if (!el.value || el.value.nodeType === Node.COMMENT_NODE) {
                        trap = null;
                    }
                }
            }, { immediate: true, flush: 'post' });
        });
        Object(external_vue_["onUnmounted"])(() => {
            if (trap)
                trap.deactivate();
            trap = null;
        });
        // Use object-return for setup so that we can expose the 'activate'
        // and 'deactivate' methods without making use of the 'expose({ ... })'
        // method as the ExposeProxy system is problematic for users migrating
        // from Vue2 -> Vue3 due to the ExposeProxy (correctly) preventing child
        // components from reading the internal state of their $parent. This is
        // problematic for migrating users because the the Vue2-based VueRouter
        // _requires_ that functionality as it does $parent._routerRoot to set
        // the $router and $route properties on components.
        return {
            activate() {
                ensureTrap().activate();
            },
            deactivate() {
                trap && trap.deactivate();
            },
            renderImpl() {
                if (!slots.default)
                    return null;
                const vNodes = slots.default().filter(vnode => vnode.type !== external_vue_["Comment"]);
                if (!vNodes || !vNodes.length || vNodes.length > 1) {
                    {
                        console.error('[focus-trap-vue]: FocusTrap requires exactly one child.');
                    }
                    return vNodes;
                }
                const vnode = Object(external_vue_["cloneVNode"])(vNodes[0], { ref: wrapperEl });
                return vnode;
            },
        };
    },
});



// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/GlobalNav/GlobalNavItem.vue?vue&type=template&id=4492b55c

const GlobalNavItemvue_type_template_id_4492b55c_hoisted_1 = {
  class: "nebula-global-nav-item__summary"
};
const GlobalNavItemvue_type_template_id_4492b55c_hoisted_2 = {
  class: "nebula-global-nav-item__link"
};
function GlobalNavItemvue_type_template_id_4492b55c_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  const _component_GlobalNavButton = Object(external_vue_["resolveComponent"])("GlobalNavButton");

  return $props.styleMap[$props.data.nav_id] ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_GlobalNavButton, {
    key: 0,
    href: $props.data.url,
    class: "nebula-global-nav-item",
    "data-click-name": $props.data.name,
    "data-click-type": "Global Navigation"
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("div", GlobalNavItemvue_type_template_id_4492b55c_hoisted_1, [Object(external_vue_["createElementVNode"])("div", {
      class: Object(external_vue_["normalizeClass"])(["nebula-global-nav-item__icon-wrapper", $props.styleMap[$props.data.nav_id].class && `icon-wrapper--${$props.styleMap[$props.data.nav_id].class}`])
    }, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
      symbolId: $props.styleMap[$props.data.nav_id].icon,
      size: "s"
    }, null, 8, ["symbolId"])], 2), Object(external_vue_["createElementVNode"])("h3", GlobalNavItemvue_type_template_id_4492b55c_hoisted_2, Object(external_vue_["toDisplayString"])($props.data.name), 1)])]),
    _: 1
  }, 8, ["href", "data-click-name"])) : Object(external_vue_["createCommentVNode"])("", true);
}
// CONCATENATED MODULE: ./src/components/GlobalNav/GlobalNavItem.vue?vue&type=template&id=4492b55c

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/GlobalNav/GlobalNavButton.vue?vue&type=template&id=872df17a

const GlobalNavButtonvue_type_template_id_872df17a_hoisted_1 = {
  class: "nebula-global-nav__button"
};
function GlobalNavButtonvue_type_template_id_872df17a_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("a", GlobalNavButtonvue_type_template_id_872df17a_hoisted_1, [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")]);
}
// CONCATENATED MODULE: ./src/components/GlobalNav/GlobalNavButton.vue?vue&type=template&id=872df17a

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/GlobalNav/GlobalNavButton.vue?vue&type=script&lang=js
/* harmony default export */ var GlobalNavButtonvue_type_script_lang_js = ({
  name: 'GlobalNavButton'
});
// CONCATENATED MODULE: ./src/components/GlobalNav/GlobalNavButton.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/GlobalNav/GlobalNavButton.vue?vue&type=style&index=0&id=872df17a&lang=stylus
var GlobalNavButtonvue_type_style_index_0_id_872df17a_lang_stylus = __webpack_require__("1981");

// CONCATENATED MODULE: ./src/components/GlobalNav/GlobalNavButton.vue







const GlobalNavButton_exports_ = /*#__PURE__*/exportHelper_default()(GlobalNavButtonvue_type_script_lang_js, [['render',GlobalNavButtonvue_type_template_id_872df17a_render]])

/* harmony default export */ var GlobalNavButton = (GlobalNavButton_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/GlobalNav/GlobalNavItem.vue?vue&type=script&lang=js


/* harmony default export */ var GlobalNavItemvue_type_script_lang_js = ({
  name: 'GlobalNavItem',
  components: {
    NebulaIcon: NebulaIcon,
    GlobalNavButton: GlobalNavButton
  },
  props: {
    data: {
      type: Object
    },
    styleMap: {
      type: Object
    }
  }
});
// CONCATENATED MODULE: ./src/components/GlobalNav/GlobalNavItem.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/GlobalNav/GlobalNavItem.vue?vue&type=style&index=0&id=4492b55c&lang=stylus
var GlobalNavItemvue_type_style_index_0_id_4492b55c_lang_stylus = __webpack_require__("0112");

// CONCATENATED MODULE: ./src/components/GlobalNav/GlobalNavItem.vue







const GlobalNavItem_exports_ = /*#__PURE__*/exportHelper_default()(GlobalNavItemvue_type_script_lang_js, [['render',GlobalNavItemvue_type_template_id_4492b55c_render]])

/* harmony default export */ var GlobalNavItem = (GlobalNavItem_exports_);
// CONCATENATED MODULE: ./src/utils/constants/globalNavData.js

/* harmony default export */ var globalNavData = ({
  supportedMyDE: {
    // "My Content"
    'MUS:MCON': {
      icon: 'drive'
    },
    'MUS:CLASSROOMS': {
      icon: 'whole-class'
    },
    'MUS:CLASSASGN': {
      icon: 'assignment'
    },
    'MUS:ASGN': {
      icon: 'assignment'
    },
    'MUS:SUBJECT_CHANNEL': {
      icon: 'subject'
    },
    // "Admin Dashboard"
    'MUS:MY_ADMIN': {
      icon: 'admin'
    }
  },
  supportedDiscover: {
    'MUS:EXPLORE_CHANNEL': {
      icon: 'explore'
    },
    'MUS:STANDARDS': {
      icon: 'standard'
    },
    'MUS:PRFLRN': {
      icon: 'learning'
    }
  },
  supportedTools: {
    'MUS:SPIRAL': {
      icon: 'quiz'
    },
    ABLDR: {
      icon: 'assessment'
    },
    'MUS:STUDIO': {
      icon: 'studio'
    }
  },
  supportedProducts: productConstant
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/GlobalNav/NebulaGlobalNav.vue?vue&type=script&lang=js




/* harmony default export */ var NebulaGlobalNavvue_type_script_lang_js = ({
  name: 'NebulaGlobalNav',
  components: {
    FocusTrap: FocusTrap,
    NebulaButton: NebulaButton,
    GlobalNavItem: GlobalNavItem
  },
  props: {
    data: {
      type: Object
    },
    focusTrapEnabled: {
      type: Boolean,
      default: false
    },
    homeLink: {
      type: String,
      default: '/suite/'
    },
    id: {
      type: String,
      default: 'nebula-global-nav'
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    routerLink: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle-global-nav'],
  methods: {
    handleClose() {
      this.$emit('toggle-global-nav', false); // revert focus to previously stored activeElement when global nav closes

      if (this.prevFocus) {
        this.prevFocus.focus();
      }
    },

    handleKeydown(e) {
      if (e.code === 'Escape') {
        this.handleClose();
      }
    },

    focusOnOpen() {
      var _this$$refs, _this$$refs$home;

      // store current activeElement before changing focus
      this.prevFocus = document.activeElement;
      const homeRef = ((_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : (_this$$refs$home = _this$$refs.home) === null || _this$$refs$home === void 0 ? void 0 : _this$$refs$home.$el) || this.$refs.home;

      if (!homeRef) {
        return;
      }

      homeRef.focus();
    }

  },
  computed: {
    focusTrapActive() {
      // criteria for FocusTrap to be enabled
      // user/dev must not have disabled it via the focusTrapEnabled prop
      if (!this.focusTrapEnabled) {
        return false;
      } // data must be present so sections are painted
      // isVisible state must be truthy (bound to transition timing on global nav)


      return !!this.data && !!this.data.navigation && this.isVisible;
    },

    parsedData() {
      const supportedTools = Object.keys(this.GlobalNavData.supportedTools);
      const supportedMyDE = Object.keys(this.GlobalNavData.supportedMyDE);
      const supportedDiscover = Object.keys(this.GlobalNavData.supportedDiscover);
      const allSupported = supportedTools.concat(supportedMyDE).concat(supportedDiscover);
      const products = {};
      const tools = {};
      const myDE = {};
      const discover = {};
      const {
        navigation
      } = this.$props.data; // data in the API response is grouped into products and 'grid'
      // we'll continue to support that unless we change that response

      navigation.products.forEach(each => {
        // pull out keyed object to map with internal color/icon map
        products[each.nav_id] = each;
      });
      navigation.grid.forEach(gridItem => {
        // bail if not supported. Support (including icon selection) needs to be added
        // for new navigation elements
        if (!allSupported.includes(gridItem.nav_id)) {
          return;
        }

        if (supportedTools.includes(gridItem.nav_id)) {
          tools[gridItem.nav_id] = gridItem;
        }

        if (supportedMyDE.includes(gridItem.nav_id)) {
          myDE[gridItem.nav_id] = gridItem;
        }

        if (supportedDiscover.includes(gridItem.nav_id)) {
          discover[gridItem.nav_id] = gridItem;
        }
      });
      return {
        myDE,
        discover,
        products,
        tools
      };
    }

  },

  data() {
    return {
      prevFocus: null,
      isVisible: false,
      GlobalNavData: globalNavData
    };
  },

  watch: {
    isOpen(openVal) {
      // Set timeout used to ensure the panel is visible
      // before triggering the focus trap, otherwise focus-trap doesn't
      // detect any tabbable elements and throws an error.
      setTimeout(() => {
        this.isVisible = openVal;
      }, 300);
    }

  }
});
// CONCATENATED MODULE: ./src/components/GlobalNav/NebulaGlobalNav.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/GlobalNav/NebulaGlobalNav.vue?vue&type=style&index=0&id=5b481dde&lang=stylus
var NebulaGlobalNavvue_type_style_index_0_id_5b481dde_lang_stylus = __webpack_require__("56fc");

// CONCATENATED MODULE: ./src/components/GlobalNav/NebulaGlobalNav.vue







const NebulaGlobalNav_exports_ = /*#__PURE__*/exportHelper_default()(NebulaGlobalNavvue_type_script_lang_js, [['render',NebulaGlobalNavvue_type_template_id_5b481dde_render]])

/* harmony default export */ var NebulaGlobalNav = (NebulaGlobalNav_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Grid/NebulaColumn.vue?vue&type=template&id=00f41d53

function NebulaColumnvue_type_template_id_00f41d53_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])(["nebula-column", $options.classes])
  }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")], 2);
}
// CONCATENATED MODULE: ./src/components/Grid/NebulaColumn.vue?vue&type=template&id=00f41d53

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Grid/NebulaColumn.vue?vue&type=script&lang=js
/* harmony default export */ var NebulaColumnvue_type_script_lang_js = ({
  name: 'NebulaColumn',
  props: {
    columns: {
      type: Number,
      default: 12
    },
    offset: {
      type: Number
    },
    mdOffset: {
      type: Number
    },
    mdSize: {
      type: Number
    },
    smOffset: {
      type: Number
    },
    smSize: {
      type: Number
    }
  },
  computed: {
    classes() {
      const styleClass = [`nebula-col-${this.columns}`];

      if (this.offset) {
        styleClass.push(`nebula-col-offset-${this.offset}`);
      }

      if (this.mdSize) {
        styleClass.push(`nebula-col-md-${this.mdSize}`);

        if (!this.smSize) {
          styleClass.push(`nebula-col-sm-${Math.ceil(this.mdSize / 2)}`);
        }
      }

      if (this.smSize) {
        styleClass.push(`nebula-col-sm-${this.smSize}`);
      } // check for undefined instead of truthiness for offset overrides because can be 0


      if (this.mdOffset !== undefined) {
        styleClass.push(`nebula-col-md-offset-${this.mdOffset}`); // If medium is specified but small is not, automate the equivalent override for small

        if (this.smOffset === undefined) {
          styleClass.push(`nebula-col-sm-offset-${Math.ceil(this.mdSize / 2)}`);
        }
      } // check for undefined instead of truthiness for offset overrides because can be 0


      if (this.smOffset !== undefined) {
        styleClass.push(`nebula-col-sm-offset-${this.smOffset}`);
      }

      return styleClass;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Grid/NebulaColumn.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Grid/NebulaColumn.vue?vue&type=style&index=0&id=00f41d53&lang=stylus
var NebulaColumnvue_type_style_index_0_id_00f41d53_lang_stylus = __webpack_require__("54c3");

// CONCATENATED MODULE: ./src/components/Grid/NebulaColumn.vue







const NebulaColumn_exports_ = /*#__PURE__*/exportHelper_default()(NebulaColumnvue_type_script_lang_js, [['render',NebulaColumnvue_type_template_id_00f41d53_render]])

/* harmony default export */ var NebulaColumn = (NebulaColumn_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Grid/NebulaGridBlock.vue?vue&type=template&id=809fb3cc

function NebulaGridBlockvue_type_template_id_809fb3cc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.classes)
  }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")], 2);
}
// CONCATENATED MODULE: ./src/components/Grid/NebulaGridBlock.vue?vue&type=template&id=809fb3cc

// CONCATENATED MODULE: ./src/components/Grid/gridMap.js
// JS version of the gridMap used primarily in stylus
// If this changes, update the stylus hash as well
// See components/Grid/grid.styl
const gridMap = {
  12: {
    md: 8,
    sm: 4
  },
  11: {
    md: 8,
    sm: 4
  },
  10: {
    md: 7,
    sm: 3
  },
  9: {
    md: 6,
    sm: 3
  },
  8: {
    md: 5,
    sm: 2
  },
  7: {
    md: 5,
    sm: 2
  },
  6: {
    md: 4,
    sm: 2
  },
  5: {
    md: 3,
    sm: 2
  },
  4: {
    md: 2,
    sm: 1
  },
  3: {
    md: 2,
    sm: 1
  },
  2: {
    md: 1,
    sm: 1
  },
  1: {
    md: 1,
    sm: 1
  }
};
/* harmony default export */ var Grid_gridMap = (gridMap);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Grid/NebulaGridBlock.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaGridBlockvue_type_script_lang_js = ({
  name: 'NebulaColumn',
  props: {
    columns: {
      type: Number,
      default: 12
    },
    offset: {
      type: Number
    },
    mdOffset: {
      type: Number
    },
    mdSize: {
      type: Number
    },
    smOffset: {
      type: Number
    },
    smSize: {
      type: Number
    }
  },
  computed: {
    classes() {
      const styleClass = [];
      const mdSize = this.mdSize || Grid_gridMap[this.columns].md;
      const smSize = this.smSize || Grid_gridMap[this.columns].sm; // CSS Grid does not allow span and grid-column-start to be set independently
      // To handle this, classes for offset vs not are either/or

      if (this.offset) {
        styleClass.push(`nebula-grid-block-${this.columns}-offset-${this.offset}`);
      } else {
        styleClass.push(`nebula-grid-block-${this.columns}`);
      } // Support for size-specific props
      // check for undefined instead of truthiness for offset overrides because can be 0


      if (this.mdOffset !== undefined) {
        styleClass.push(`nebula-grid-block-md-${mdSize}-offset-${this.mdOffset}`); // If medium is specified but small is not, automate the equivalent override for small

        if (this.smOffset === undefined) {
          styleClass.push(`nebula-grid-block-sm-${Math.ceil(mdSize / 2)}-offset-${Math.ceil(this.mdOffset / 2)}`);
        }
      } else if (this.mdSize) {
        styleClass.push(`nebula-grid-block-md-${mdSize}`); // If medium is specified but small is not, automate the equivalent override for small

        if (!this.smSize) {
          styleClass.push(`nebula-grid-block-sm-${Math.ceil(mdSize / 2)}`);
        }
      }

      if (this.smOffset !== undefined) {
        styleClass.push(`nebula-grid-block-sm-${smSize}-offset-${this.smOffset}`);
      } else if (this.smSize) {
        styleClass.push(`nebula-grid-block-sm-${smSize}`);
      }

      return styleClass;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Grid/NebulaGridBlock.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Grid/NebulaGridBlock.vue?vue&type=style&index=0&id=809fb3cc&lang=stylus
var NebulaGridBlockvue_type_style_index_0_id_809fb3cc_lang_stylus = __webpack_require__("8bde");

// CONCATENATED MODULE: ./src/components/Grid/NebulaGridBlock.vue







const NebulaGridBlock_exports_ = /*#__PURE__*/exportHelper_default()(NebulaGridBlockvue_type_script_lang_js, [['render',NebulaGridBlockvue_type_template_id_809fb3cc_render]])

/* harmony default export */ var NebulaGridBlock = (NebulaGridBlock_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Grid/NebulaPageWrapper.vue?vue&type=template&id=5474599a

const NebulaPageWrappervue_type_template_id_5474599a_hoisted_1 = {
  class: "nebula-page-container"
};
function NebulaPageWrappervue_type_template_id_5474599a_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaPageWrappervue_type_template_id_5474599a_hoisted_1, [Object(external_vue_["createElementVNode"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.wrapperClass)
  }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")], 2)]);
}
// CONCATENATED MODULE: ./src/components/Grid/NebulaPageWrapper.vue?vue&type=template&id=5474599a

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Grid/NebulaPageWrapper.vue?vue&type=script&lang=js
/* harmony default export */ var NebulaPageWrappervue_type_script_lang_js = ({
  name: 'NebulaPageWrapper',
  props: {
    contained: {
      type: Boolean,
      default: false
    },
    padded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    wrapperClass() {
      return ['nebula-page-wrapper', {
        'nebula-page-wrapper--contained': this.contained,
        'nebula-page-wrapper--padded': this.padded
      }];
    }

  }
});
// CONCATENATED MODULE: ./src/components/Grid/NebulaPageWrapper.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Grid/NebulaPageWrapper.vue?vue&type=style&index=0&id=5474599a&lang=stylus
var NebulaPageWrappervue_type_style_index_0_id_5474599a_lang_stylus = __webpack_require__("3f87");

// CONCATENATED MODULE: ./src/components/Grid/NebulaPageWrapper.vue







const NebulaPageWrapper_exports_ = /*#__PURE__*/exportHelper_default()(NebulaPageWrappervue_type_script_lang_js, [['render',NebulaPageWrappervue_type_template_id_5474599a_render]])

/* harmony default export */ var NebulaPageWrapper = (NebulaPageWrapper_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Grid/NebulaGridRow.vue?vue&type=template&id=a8b87a8a

function NebulaGridRowvue_type_template_id_a8b87a8a_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.styleClass)
  }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")], 2);
}
// CONCATENATED MODULE: ./src/components/Grid/NebulaGridRow.vue?vue&type=template&id=a8b87a8a

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Grid/NebulaGridRow.vue?vue&type=script&lang=js
/* harmony default export */ var NebulaGridRowvue_type_script_lang_js = ({
  name: 'NebulaGridRow',
  props: {
    type: {
      type: String,
      default: 'grid',

      validator(val) {
        const supported = ['flex', 'grid'];
        return supported.includes(val);
      }

    },
    gutter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    styleClass() {
      const toReturn = ['nebula-row', {
        'nebula-row--flex': this.type === 'flex',
        'nebula-row--grid': this.type === 'grid',
        // only apply gap to grid layouts
        // flex basis does not take gaps into account
        'nebula-row__gutter': this.gutter && this.type === 'grid'
      }];
      return toReturn;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Grid/NebulaGridRow.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Grid/NebulaGridRow.vue?vue&type=style&index=0&id=a8b87a8a&lang=stylus
var NebulaGridRowvue_type_style_index_0_id_a8b87a8a_lang_stylus = __webpack_require__("824f");

// CONCATENATED MODULE: ./src/components/Grid/NebulaGridRow.vue







const NebulaGridRow_exports_ = /*#__PURE__*/exportHelper_default()(NebulaGridRowvue_type_script_lang_js, [['render',NebulaGridRowvue_type_template_id_a8b87a8a_render]])

/* harmony default export */ var NebulaGridRow = (NebulaGridRow_exports_);
// CONCATENATED MODULE: ./src/components/Grid/index.js




/* harmony default export */ var Grid = ({
  NebulaColumn: NebulaColumn,
  NebulaGridBlock: NebulaGridBlock,
  NebulaPageWrapper: NebulaPageWrapper,
  NebulaGridRow: NebulaGridRow
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Hero/NebulaHero.vue?vue&type=template&id=41074696

const NebulaHerovue_type_template_id_41074696_hoisted_1 = {
  key: 0,
  class: "nebula-hero__background-image"
};
const NebulaHerovue_type_template_id_41074696_hoisted_2 = {
  key: 1,
  class: "nebula-hero__background-image"
};
const NebulaHerovue_type_template_id_41074696_hoisted_3 = {
  key: 2,
  class: "nebula-hero__background-image"
};
const NebulaHerovue_type_template_id_41074696_hoisted_4 = {
  class: "nebula-hero__flex-wrapper"
};
const NebulaHerovue_type_template_id_41074696_hoisted_5 = ["id", "autoplay"];
const NebulaHerovue_type_template_id_41074696_hoisted_6 = ["src"];
const NebulaHerovue_type_template_id_41074696_hoisted_7 = {
  key: 1,
  class: "nebula-hero__gradient"
};
const NebulaHerovue_type_template_id_41074696_hoisted_8 = {
  class: "nebula-hero__inner-wrapper"
};
const NebulaHerovue_type_template_id_41074696_hoisted_9 = {
  key: 0,
  class: "nebula-hero__actions"
};
const NebulaHerovue_type_template_id_41074696_hoisted_10 = {
  class: "nebula-hero__actions-inner"
};
const NebulaHerovue_type_template_id_41074696_hoisted_11 = {
  class: "nebula-hero__header"
};
const NebulaHerovue_type_template_id_41074696_hoisted_12 = {
  class: "nebula-hero__image"
};
const NebulaHerovue_type_template_id_41074696_hoisted_13 = {
  class: "nebula-hero__image"
};
const NebulaHerovue_type_template_id_41074696_hoisted_14 = ["innerHTML"];
const NebulaHerovue_type_template_id_41074696_hoisted_15 = ["innerHTML"];
const NebulaHerovue_type_template_id_41074696_hoisted_16 = {
  key: 2,
  class: "nebula-hero__extra-container"
};
const NebulaHerovue_type_template_id_41074696_hoisted_17 = {
  class: "nebula-hero__metadata"
};
const NebulaHerovue_type_template_id_41074696_hoisted_18 = {
  key: 0,
  class: "nebula-hero__metadata-text"
};
const NebulaHerovue_type_template_id_41074696_hoisted_19 = {
  key: 1,
  class: "nebula-hero__play-button"
};
const NebulaHerovue_type_template_id_41074696_hoisted_20 = {
  key: 0,
  class: "nebula-hero__call-to-action-container"
};
function NebulaHerovue_type_template_id_41074696_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaImage = Object(external_vue_["resolveComponent"])("NebulaImage");

  const _component_NebulaPicture = Object(external_vue_["resolveComponent"])("NebulaPicture");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaBadge = Object(external_vue_["resolveComponent"])("NebulaBadge");

  const _component_NebulaCallToAction = Object(external_vue_["resolveComponent"])("NebulaCallToAction");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: "nebula-hero",
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [$props.backgroundImgConfig ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaHerovue_type_template_id_41074696_hoisted_1, [Object(external_vue_["createVNode"])(_component_NebulaImage, Object(external_vue_["mergeProps"])($props.backgroundImgConfig, {
    covered: ""
  }), null, 16)])) : $props.backgroundPictureConfig ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaHerovue_type_template_id_41074696_hoisted_2, [Object(external_vue_["createVNode"])(_component_NebulaPicture, {
    assetConfig: $props.backgroundPictureConfig
  }, null, 8, ["assetConfig"])])) : Object(external_vue_["createCommentVNode"])("", true), $options.hasResponsiveBackgroundPictureSlot ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaHerovue_type_template_id_41074696_hoisted_3, [Object(external_vue_["renderSlot"])(_ctx.$slots, "responsiveBackgroundPicture")])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaHerovue_type_template_id_41074696_hoisted_4, [$props.videoUrl ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("video", {
    key: 0,
    class: "nebula-hero__video",
    id: $options.getVideoId,
    autoplay: $props.autoplay ? true : null,
    muted: "",
    loop: ""
  }, [Object(external_vue_["createElementVNode"])("source", {
    src: $props.videoUrl,
    type: "video/mp4"
  }, null, 8, NebulaHerovue_type_template_id_41074696_hoisted_6)], 8, NebulaHerovue_type_template_id_41074696_hoisted_5)) : Object(external_vue_["createCommentVNode"])("", true), $props.useGradient ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaHerovue_type_template_id_41074696_hoisted_7)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaHerovue_type_template_id_41074696_hoisted_8, [Object(external_vue_["createElementVNode"])("div", {
    class: Object(external_vue_["normalizeClass"])(['nebula-hero__inner-flex', !$props.showPlayButton && 'nebula-hero__inner-flex--column', $props.spaceBetweenActionButtons && 'nebula-hero__inner-flex--space-between'])
  }, [$options.hasHeroActionsSlot || $props.videoUrl ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaHerovue_type_template_id_41074696_hoisted_9, [Object(external_vue_["createElementVNode"])("div", NebulaHerovue_type_template_id_41074696_hoisted_10, [Object(external_vue_["renderSlot"])(_ctx.$slots, "heroActions")]), $props.videoUrl ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
    key: 0,
    "icon-right": $data.isPlaying ? 'pause' : 'play',
    size: "s",
    text: $data.isPlaying ? _ctx.$t('Pause Video') : _ctx.$t('Play Video'),
    type: "flat",
    onClick: $options.toggleVideoPlay
  }, null, 8, ["icon-right", "text", "onClick"])) : Object(external_vue_["createCommentVNode"])("", true)])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("header", NebulaHerovue_type_template_id_41074696_hoisted_11, [Object(external_vue_["createElementVNode"])("div", NebulaHerovue_type_template_id_41074696_hoisted_12, [$props.imgConfigTop ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaImage, Object(external_vue_["mergeProps"])({
    key: 0
  }, $props.imgConfigTop, {
    contained: ""
  }), null, 16)) : Object(external_vue_["createCommentVNode"])("", true)]), Object(external_vue_["createElementVNode"])("div", NebulaHerovue_type_template_id_41074696_hoisted_13, [$props.imgConfigBottom ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaImage, Object(external_vue_["mergeProps"])({
    key: 0
  }, $props.imgConfigBottom, {
    contained: ""
  }), null, 16)) : Object(external_vue_["createCommentVNode"])("", true)]), $props.title && !$props.imgConfigTop ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("h1", {
    key: 0,
    class: "nebula-hero__title",
    innerHTML: $props.title
  }, null, 8, NebulaHerovue_type_template_id_41074696_hoisted_14)) : Object(external_vue_["createCommentVNode"])("", true), $props.subtitle && !$props.imgConfigBottom ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", {
    key: 1,
    class: "nebula-hero__subtitle",
    innerHTML: $props.subtitle
  }, null, 8, NebulaHerovue_type_template_id_41074696_hoisted_15)) : Object(external_vue_["createCommentVNode"])("", true), $options.hasExtraSlot || $props.badges ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaHerovue_type_template_id_41074696_hoisted_16, [Object(external_vue_["renderSlot"])(_ctx.$slots, "extra", {}, () => [Object(external_vue_["createElementVNode"])("div", NebulaHerovue_type_template_id_41074696_hoisted_17, [$props.metadataText ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", NebulaHerovue_type_template_id_41074696_hoisted_18, Object(external_vue_["toDisplayString"])($props.metadataText), 1)) : Object(external_vue_["createCommentVNode"])("", true), (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.badges, badge => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaBadge, Object(external_vue_["mergeProps"])({
      key: badge.text
    }, badge), null, 16);
  }), 128))])])])) : Object(external_vue_["createCommentVNode"])("", true)]), $props.showPlayButton ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaHerovue_type_template_id_41074696_hoisted_19, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
    ariaLabel: $props.playButtonAriaLabel || _ctx.$t('Video Launcher'),
    iconLeft: $props.playButtonIcon,
    type: "flat",
    onClick: $options.handlePlayButtonClick
  }, null, 8, ["ariaLabel", "iconLeft", "onClick"])])) : Object(external_vue_["createCommentVNode"])("", true)], 2), $options.hasCallToActionsSlot || $props.callToActionConfig ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaHerovue_type_template_id_41074696_hoisted_20, [Object(external_vue_["renderSlot"])(_ctx.$slots, "callToAction"), $props.callToActionConfig ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaCallToAction, Object(external_vue_["mergeProps"])({
    key: 0,
    class: "nebula-hero__call-to-action"
  }, $props.callToActionConfig), null, 16)) : Object(external_vue_["createCommentVNode"])("", true)])) : Object(external_vue_["createCommentVNode"])("", true)])])], 4);
}
// CONCATENATED MODULE: ./src/components/Hero/NebulaHero.vue?vue&type=template&id=41074696

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Picture/NebulaPicture.vue?vue&type=template&id=6b2879ce

const NebulaPicturevue_type_template_id_6b2879ce_hoisted_1 = {
  class: "nebula-picture"
};
const NebulaPicturevue_type_template_id_6b2879ce_hoisted_2 = ["height", "media", "srcset", "type", "width"];
function NebulaPicturevue_type_template_id_6b2879ce_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaImage = Object(external_vue_["resolveComponent"])("NebulaImage");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("picture", NebulaPicturevue_type_template_id_6b2879ce_hoisted_1, [$options.hasSourcesSlot ? Object(external_vue_["renderSlot"])(_ctx.$slots, "sources", {
    key: 0
  }) : Object(external_vue_["createCommentVNode"])("", true), (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($data.formattedSourcesConfig, (source, i) => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("source", {
      key: i,
      height: source.height,
      media: source.media,
      srcset: source.srcset,
      type: source.type,
      width: source.width
    }, null, 8, NebulaPicturevue_type_template_id_6b2879ce_hoisted_2);
  }), 128)), $data.formattedImgConfig ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaImage, Object(external_vue_["mergeProps"])({
    key: 1
  }, $data.formattedImgConfig, {
    pictureComponent: ""
  }), null, 16)) : Object(external_vue_["createCommentVNode"])("", true)]);
}
// CONCATENATED MODULE: ./src/components/Picture/NebulaPicture.vue?vue&type=template&id=6b2879ce

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Picture/NebulaPicture.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaPicturevue_type_script_lang_js = ({
  name: 'NebulaPicture',
  components: {
    NebulaImage: NebulaImage
  },

  data() {
    return {
      formattedImgConfig: null,
      formattedSourcesConfig: null
    };
  },

  props: {
    assetConfig: {
      type: Object,
      default: null
    },
    imgConfig: {
      type: Object,
      default: null
    },
    sourcesConfig: {
      type: Array,
      default: null
    }
  },
  computed: {
    getAssetId() {
      let assetId = '';

      if (this.assetConfig && this.assetConfig.assetId) {
        assetId = this.assetConfig.assetId;
      } else if (this.assetId) {
        assetId = this.assetId;
      }

      return assetId;
    },

    getAssetType() {
      let assetType = '';

      if (this.assetConfig && this.assetConfig.assetType) {
        assetType = this.assetConfig.assetType;
      } else if (this.assetType) {
        assetType = this.assetType;
      }

      return assetType;
    },

    hasSourcesSlot() {
      return !!this.$slots.sources;
    }

  },
  methods: {
    imageUrl(assetSize) {
      return `https://d1m0scxbrw6oep.cloudfront.net/thumbnails/${this.getAssetId}-${assetSize}`;
    },

    setImgFromAssetConfig() {
      const imgConfigFromAssetConfig = this.assetConfig.imgConfig;

      if (this.assetConfig.assetId) {
        const size = this.assetConfig.assetSizes ? this.assetConfig.assetSizes[0] : 'medium';
        const imgUrl = this.imageUrl(size);
        imgConfigFromAssetConfig.src = imgUrl;
      }

      imgConfigFromAssetConfig.assetType = this.getAssetType;
      this.formattedImgConfig = imgConfigFromAssetConfig;
    },

    setSourcesFromAssetConfig() {
      let sourcesConfigFromAssetConfig = null;

      if (this.assetConfig.sourcesConfig) {
        sourcesConfigFromAssetConfig = this.assetConfig.sourcesConfig;

        if (this.assetConfig.assetId && this.assetConfig.assetSizes) {
          const {
            assetSizes
          } = this.assetConfig;
          const sourceLinks = [];
          assetSizes.forEach((size, index) => {
            if (index > 0) {
              sourceLinks.unshift(this.imageUrl(size));
            }
          });
          sourceLinks.forEach((link, index) => {
            sourcesConfigFromAssetConfig[index].srcset = link;
          });
        }

        this.formattedSourcesConfig = sourcesConfigFromAssetConfig;
      }
    },

    setConfigs() {
      if (this.assetConfig) {
        this.setImgFromAssetConfig();
        this.setSourcesFromAssetConfig();
      } else {
        this.formattedImgConfig = this.imgConfig;
        this.formattedSourcesConfig = this.sourcesConfig;
      }
    }

  },

  mounted() {
    this.setConfigs();
  }

});
// CONCATENATED MODULE: ./src/components/Picture/NebulaPicture.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/components/Picture/NebulaPicture.vue





const NebulaPicture_exports_ = /*#__PURE__*/exportHelper_default()(NebulaPicturevue_type_script_lang_js, [['render',NebulaPicturevue_type_template_id_6b2879ce_render]])

/* harmony default export */ var NebulaPicture = (NebulaPicture_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Hero/NebulaHero.vue?vue&type=script&lang=js







/* harmony default export */ var NebulaHerovue_type_script_lang_js = ({
  name: 'NebulaHero',
  components: {
    NebulaBadge: NebulaBadge,
    NebulaButton: NebulaButton,
    NebulaCallToAction: NebulaCallToAction,
    NebulaImage: NebulaImage,
    NebulaPicture: NebulaPicture
  },

  data() {
    return {
      isPlaying: false
    };
  },

  mixins: [themingUtils],
  emits: ['playButtonClick'],
  props: {
    autoplay: {
      type: Boolean,
      default: false
    },
    backgroundImgConfig: {
      type: [Object, Array],
      default: null
    },
    backgroundPictureConfig: {
      type: Object,
      default: null
    },
    badges: {
      type: [Object, Array],
      default: null
    },
    callToActionConfig: {
      type: [Object, Array],
      default: null
    },
    imgConfigTop: {
      type: [Object, Array],
      default: null
    },
    imgConfigBottom: {
      type: [Object, Array],
      default: null
    },
    metadataText: {
      type: String,
      default: null
    },
    playButtonAriaLabel: {
      type: String,
      default: null // this default is handled in the template

    },
    playButtonIcon: {
      type: String,
      default: 'circle-play--filled'
    },
    showPlayButton: {
      type: Boolean,
      default: false
    },
    spaceBetweenActionButtons: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    useGradient: {
      type: Boolean,
      default: false
    },
    videoId: {
      type: String,
      default: null
    },
    videoUrl: {
      type: String,
      default: null
    }
  },
  computed: {
    getVideoId() {
      return randomStringId(this.$props.videoId);
    },

    hasCallToActionsSlot() {
      return !!this.$slots.callToAction;
    },

    hasExtraSlot() {
      return !!this.$slots.extra;
    },

    hasHeroActionsSlot() {
      return !!this.$slots.heroActions;
    },

    hasResponsiveBackgroundPictureSlot() {
      return !!this.$slots.responsiveBackgroundPicture;
    },

    videoEl() {
      return document.getElementById(this.getVideoId);
    }

  },
  methods: {
    handlePlayButtonClick() {
      this.$emit('playButtonClick');
    },

    toggleVideoPlay() {
      if (this.videoEl.paused) {
        this.videoEl.play();
        this.isPlaying = true;
      } else {
        this.videoEl.pause();
        this.isPlaying = false;
      }
    }

  },

  mounted() {
    if (this.videoEl && this.autoplay) {
      this.isPlaying = true;
    }
  }

});
// CONCATENATED MODULE: ./src/components/Hero/NebulaHero.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Hero/NebulaHero.vue?vue&type=style&index=0&id=41074696&lang=stylus
var NebulaHerovue_type_style_index_0_id_41074696_lang_stylus = __webpack_require__("3dde");

// CONCATENATED MODULE: ./src/components/Hero/NebulaHero.vue







const NebulaHero_exports_ = /*#__PURE__*/exportHelper_default()(NebulaHerovue_type_script_lang_js, [['render',NebulaHerovue_type_template_id_41074696_render]])

/* harmony default export */ var NebulaHero = (NebulaHero_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Listbox/NebulaListboxItem.vue?vue&type=template&id=07463945

const NebulaListboxItemvue_type_template_id_07463945_hoisted_1 = ["aria-selected"];
const NebulaListboxItemvue_type_template_id_07463945_hoisted_2 = {
  class: "nebula-listbox-item__text"
};
function NebulaListboxItemvue_type_template_id_07463945_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
    class: Object(external_vue_["normalizeClass"])(["nebula-listbox__item", $props.selected && 'nebula-listbox__item--selected']),
    role: "option",
    "aria-selected": $props.selected && 'true',
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [Object(external_vue_["createElementVNode"])("button", {
    class: "nebula-listbox-item__inner",
    type: "button",
    role: "option",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('listboxItemClicked')),
    onFocus: _cache[1] || (_cache[1] = $event => _ctx.$emit('listboxItemFocused')),
    onKeyup: _cache[2] || (_cache[2] = (...args) => $options.checkKeyup && $options.checkKeyup(...args)),
    onKeydown: _cache[3] || (_cache[3] = (...args) => $options.checkKeydown && $options.checkKeydown(...args))
  }, [$props.icon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
    key: 0,
    symbolId: $props.icon,
    class: "nebula-listbox-item__icon"
  }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("span", NebulaListboxItemvue_type_template_id_07463945_hoisted_2, Object(external_vue_["toDisplayString"])($props.text), 1)], 32)], 14, NebulaListboxItemvue_type_template_id_07463945_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/Listbox/NebulaListboxItem.vue?vue&type=template&id=07463945

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Listbox/NebulaListboxItem.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaListboxItemvue_type_script_lang_js = ({
  name: 'NebulaListboxItem',
  components: {
    NebulaIcon: NebulaIcon
  },
  mixins: [themingUtils],
  props: {
    icon: {
      type: String,
      default: null
    },
    selected: {
      type: Boolean,
      default: false
    },
    text: String
  },
  emits: ['listboxItemClicked', 'listboxItemFocused'],
  methods: {
    checkKeyup(e) {
      //  space key and alt+up key trigger parent to select this item
      if (e.keyCode === 32 || e.keyCode === 38 && e.altKey) {
        this.$emit('listboxItemClicked');
      }
    },

    checkKeydown(e) {
      // tab key works on keydown instead of up
      if (e.keyCode === 9) {
        this.$emit('listboxItemClicked');
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/Listbox/NebulaListboxItem.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Listbox/NebulaListboxItem.vue?vue&type=style&index=0&id=07463945&lang=stylus
var NebulaListboxItemvue_type_style_index_0_id_07463945_lang_stylus = __webpack_require__("1ff7");

// CONCATENATED MODULE: ./src/components/Listbox/NebulaListboxItem.vue







const NebulaListboxItem_exports_ = /*#__PURE__*/exportHelper_default()(NebulaListboxItemvue_type_script_lang_js, [['render',NebulaListboxItemvue_type_template_id_07463945_render]])

/* harmony default export */ var NebulaListboxItem = (NebulaListboxItem_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Listgroup/NebulaListItemExpandable.vue?vue&type=template&id=3a864df6

const NebulaListItemExpandablevue_type_template_id_3a864df6_hoisted_1 = {
  class: "nebula-list-item-expandable__header"
};
const NebulaListItemExpandablevue_type_template_id_3a864df6_hoisted_2 = {
  key: 1,
  class: "nebula-list-item-expandable__label"
};
const NebulaListItemExpandablevue_type_template_id_3a864df6_hoisted_3 = ["id"];
function NebulaListItemExpandablevue_type_template_id_3a864df6_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
    class: Object(external_vue_["normalizeClass"])(["nebula-list-item-expandable", {
      'nebula-list-item-expandable--expanded': $data.isExpanded
    }]),
    ref: "parentEl"
  }, [Object(external_vue_["createElementVNode"])("div", NebulaListItemExpandablevue_type_template_id_3a864df6_hoisted_1, [$props.link ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
    key: 0,
    class: "nebula-list-item-expandable__label nebula-list-item-expandable__link",
    link: $props.link,
    routerLink: $props.routerLink,
    text: $options.textContent,
    type: "flat"
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])($options.textContent), 1)]),
    _: 1
  }, 8, ["link", "routerLink", "text"])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", NebulaListItemExpandablevue_type_template_id_3a864df6_hoisted_2, Object(external_vue_["toDisplayString"])($options.textContent), 1)), Object(external_vue_["createVNode"])(_component_NebulaButton, {
    "aria-controls": $data.ariaContentId,
    "aria-expanded": $data.isExpanded,
    "aria-label": "Expand item",
    class: "nebula-list-item-expandable__expand-button",
    "icon-left": "caret-down",
    size: "s",
    type: "flat",
    onClick: $options.toggleExpandable
  }, null, 8, ["aria-controls", "aria-expanded", "onClick"])]), Object(external_vue_["createElementVNode"])("div", {
    class: "nebula-list-item-expandable__content-wrapper",
    style: Object(external_vue_["normalizeStyle"])({
      height: $data.heightValue
    })
  }, [Object(external_vue_["createElementVNode"])("div", {
    id: $data.ariaContentId,
    ref: "contentEl",
    class: "nebula-list-item-expandable__content"
  }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")], 8, NebulaListItemExpandablevue_type_template_id_3a864df6_hoisted_3)], 4)], 2);
}
// CONCATENATED MODULE: ./src/components/Listgroup/NebulaListItemExpandable.vue?vue&type=template&id=3a864df6

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Listgroup/NebulaListItemExpandable.vue?vue&type=script&lang=js

const CHANGE_HEIGHT_EVENT = 'list-item-expandable-height-change';
let idCounter = Math.floor(Math.random() * 10000) + 1; // Minimal ID collision protection

/* harmony default export */ var NebulaListItemExpandablevue_type_script_lang_js = ({
  name: 'NebulaListItemExpandable',
  components: {
    NebulaButton: NebulaButton
  },

  data() {
    idCounter += 1;
    return {
      ariaContentId: `nebula-list-item-expandable-content-${idCounter}`,
      contentHeight: 0,
      heightValue: '0px',
      isExpanded: false
    };
  },

  props: {
    isExpandedOnLoad: {
      type: Boolean,
      default: false
    },
    link: {
      type: String,
      default: null
    },
    routerLink: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: null
    }
  },
  computed: {
    textContent() {
      return this.text || this.$t('Show more');
    }

  },

  mounted() {
    // If the ListItemexpandable is hidden in a modal or expandable,
    // then offsetParent == null, as it - or some ancestor - is hidden
    // so in this case add an IntersectionObserver
    // to set the initial content height when the component becomes visible
    if (this.$refs.parentEl.offsetParent === null) {
      const observer = new IntersectionObserver(() => {
        this.setInitialHeight();
      });
      observer.observe(this.$refs.parentEl);
    } else {
      this.setInitialHeight();
    } // Add listener to support height changes from nested ListItemexpandable


    this.$refs.contentEl.addEventListener(CHANGE_HEIGHT_EVENT, e => {
      this.updateNestedHeight(e.detail.height, e.detail.isIncrease);
    });
  },

  methods: {
    setInitialHeight() {
      this.contentHeight = Math.ceil(this.$refs.contentEl.getBoundingClientRect().height);

      if (this.isExpandedOnLoad) {
        this.isExpanded = true;
        this.heightValue = `${this.contentHeight}px`;
      }
    },

    toggleExpandable() {
      this.isExpanded = !this.isExpanded;
      this.updateHeight();
    },

    updateHeight() {
      if (this.isExpanded) {
        this.heightValue = `${this.contentHeight}px`;
      } else {
        this.heightValue = '0px';
      }
    },

    updateNestedHeight(delta, isIncrease) {
      if (isIncrease) {
        this.contentHeight += delta;
      } else {
        this.contentHeight -= delta;
      }

      this.updateHeight();
    }

  },
  watch: {
    heightValue(newVal) {
      const decreased = newVal === '0px';
      const eventData = {
        componentId: this.componentId,
        height: this.contentHeight,
        isIncrease: !decreased
      };
      const event = new CustomEvent(CHANGE_HEIGHT_EVENT, {
        bubbles: true,
        detail: eventData
      });
      this.$refs.parentEl.dispatchEvent(event);
    }

  }
});
// CONCATENATED MODULE: ./src/components/Listgroup/NebulaListItemExpandable.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Listgroup/NebulaListItemExpandable.vue?vue&type=style&index=0&id=3a864df6&lang=stylus
var NebulaListItemExpandablevue_type_style_index_0_id_3a864df6_lang_stylus = __webpack_require__("2f72");

// CONCATENATED MODULE: ./src/components/Listgroup/NebulaListItemExpandable.vue







const NebulaListItemExpandable_exports_ = /*#__PURE__*/exportHelper_default()(NebulaListItemExpandablevue_type_script_lang_js, [['render',NebulaListItemExpandablevue_type_template_id_3a864df6_render]])

/* harmony default export */ var NebulaListItemExpandable = (NebulaListItemExpandable_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/MenuBar/NebulaMenuBar.vue?vue&type=template&id=11f94db0

const NebulaMenuBarvue_type_template_id_11f94db0_hoisted_1 = {
  class: "nebula-menu-bar",
  ref: "menuBarContainer"
};
const NebulaMenuBarvue_type_template_id_11f94db0_hoisted_2 = {
  class: "nebula-menu-bar__responsive-menu"
};
const NebulaMenuBarvue_type_template_id_11f94db0_hoisted_3 = {
  key: 0,
  class: "nebula-menu-bar__responsive-extras"
};
function NebulaMenuBarvue_type_template_id_11f94db0_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaAccordionMenu = Object(external_vue_["resolveComponent"])("NebulaAccordionMenu");

  const _component_NebulaDropdown = Object(external_vue_["resolveComponent"])("NebulaDropdown");

  const _component_NebulaTabItem = Object(external_vue_["resolveComponent"])("NebulaTabItem");

  const _component_NebulaTabs = Object(external_vue_["resolveComponent"])("NebulaTabs");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaMenuBarvue_type_template_id_11f94db0_hoisted_1, [$data.responsiveView ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdown, Object(external_vue_["mergeProps"])({
    key: 0,
    buttonId: $options.getResponsiveDropdownButtonId,
    dropdownId: $options.getResponsiveDropdownMenuId,
    class: "nebula-menu-bar__responsive-dropdown",
    id: $options.getResponsiveDropdownId,
    alignToButtonStart: $props.responsiveMenuAlignToButtonStart,
    contentElement: "div",
    useWhiteBackground: ""
  }, $props.dropdownProps), {
    trigger: Object(external_vue_["withCtx"])(({
      toggleDropdown,
      checkArrowKeyOnTrigger,
      checkArrowKeyAfterTrigger,
      isOpen
    }) => [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      id: $options.getResponsiveDropdownButtonId,
      "aria-haspopup": "true",
      "aria-expanded": isOpen && 'true' || 'false',
      "aria-controls": $options.getResponsiveDropdownMenuId,
      text: $props.responsiveMenuButtonText ? $props.responsiveMenuButtonText : null,
      "icon-right": $props.responsiveMenuButtonIcon ? $props.responsiveMenuButtonText : 'menu',
      onClick: toggleDropdown,
      onKeydown: checkArrowKeyOnTrigger,
      onKeyup: checkArrowKeyAfterTrigger,
      "aria-label": !$props.responsiveMenuButtonText ? _ctx.$t('open menu') : null
    }, null, 8, ["id", "aria-expanded", "aria-controls", "text", "icon-right", "onClick", "onKeydown", "onKeyup", "aria-label"])]),
    content: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("div", NebulaMenuBarvue_type_template_id_11f94db0_hoisted_2, [Object(external_vue_["createVNode"])(_component_NebulaAccordionMenu, {
      menuItems: $props.menuItems
    }, null, 8, ["menuItems"]), $options.hasResponsiveExtrasSlot ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaMenuBarvue_type_template_id_11f94db0_hoisted_3, [Object(external_vue_["renderSlot"])(_ctx.$slots, "responsiveExtras")])) : Object(external_vue_["createCommentVNode"])("", true)])]),
    _: 3
  }, 16, ["buttonId", "dropdownId", "id", "alignToButtonStart"])) : !$data.responsiveView ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaTabs, {
    key: 1,
    ariaLabel: $props.ariaLabel,
    menuBar: ""
  }, {
    tabs: Object(external_vue_["withCtx"])(() => [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.menuItems, menuItem => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])(menuItem.items ? 'NebulaTabDropdown' : 'NebulaTabItem'), Object(external_vue_["mergeProps"])({
        key: menuItem.name
      }, menuItem, {
        dropdownProps: $props.dropdownProps
      }), {
        default: Object(external_vue_["withCtx"])(() => [menuItem.items ? (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
          key: 0
        }, Object(external_vue_["renderList"])(menuItem.items, subMenuItem => {
          return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaTabItem, Object(external_vue_["mergeProps"])({
            key: subMenuItem.name
          }, subMenuItem), null, 16);
        }), 128)) : Object(external_vue_["createCommentVNode"])("", true)]),
        _: 2
      }, 1040, ["dropdownProps"]);
    }), 128))]),
    _: 1
  }, 8, ["ariaLabel"])) : Object(external_vue_["createCommentVNode"])("", true)], 512);
}
// CONCATENATED MODULE: ./src/components/MenuBar/NebulaMenuBar.vue?vue&type=template&id=11f94db0

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/MenuBar/NebulaMenuBar.vue?vue&type=script&lang=js









/* harmony default export */ var NebulaMenuBarvue_type_script_lang_js = ({
  name: 'NebulaMenuBar',
  components: {
    NebulaAccordionMenu: NebulaAccordionMenu,
    NebulaButton: NebulaButton,
    NebulaDropdown: NebulaDropdown,
    NebulaTabs: NebulaTabs,
    NebulaTabDropdown: NebulaTabDropdown,
    NebulaTabItem: NebulaTabItem
  },

  data() {
    return {
      lastContainerWidth: -1,
      maxMenuBarWidth: 0,
      resizeObserver: null,
      responsiveView: false
    };
  },

  props: {
    actionBar: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String
    },
    buttonMarginInline: {
      type: Number,
      default: 16
    },
    dropdownProps: {
      type: Object
    },
    menuItems: {
      type: Array,
      default: null
    },
    responsiveMenuAlignToButtonStart: {
      type: Boolean,
      default: false
    },
    responsiveMenuButtonIcon: {
      type: String,
      default: null
    },
    responsiveMenuButtonText: {
      type: String,
      default: null
    }
  },
  computed: {
    containerEl() {
      let containerEl;

      if (this.actionBar) {
        containerEl = this.getTabsListEl.closest('.nebula-menu-bar');
      } else {
        containerEl = this.$refs.menuBarContainer;
      }

      return containerEl;
    },

    getResponsiveDropdownId() {
      return `nebula-responsive-breadcrumbs--${this.randomStringId}`;
    },

    getResponsiveDropdownButtonId() {
      return `nebula-responsive-breadcrumbs__dropdown-button--${this.randomStringId}`;
    },

    getResponsiveDropdownMenuId() {
      return `nebula-responsive-breadcrumbs__dropdown-menu--${this.randomStringId}`;
    },

    getTabsListEl() {
      return this.$el.getElementsByClassName('nebula-tabs__list')[0];
    },

    hasResponsiveExtrasSlot() {
      return !!this.$slots.responsiveExtras;
    },

    randomStringId() {
      return randomStringId();
    }

  },
  methods: {
    async calculateWidths() {
      const tabList = this.getTabsListEl;
      /* eslint-disable prefer-destructuring */

      const children = tabList.children;
      /* eslint-enable prefer-destructuring */

      for (let i = 0; i < children.length; i += 1) {
        this.maxMenuBarWidth += children[i].clientWidth + this.buttonMarginInline;
      }
    },

    determineView(newWidth) {
      let increasing = true;

      if (newWidth <= this.lastContainerWidth) {
        increasing = false;
      }

      if (increasing) {
        if (this.maxMenuBarWidth < newWidth) {
          this.responsiveView = false;
        }
      }

      if (this.maxMenuBarWidth > newWidth) {
        this.responsiveView = true;
      } else {
        this.responsiveView = false;
      }

      this.lastContainerWidth = newWidth;
    }

  },

  mounted() {
    this.menuBarResizeListener = lodash_es_throttle(this.determineView.bind(this), 100, {
      trailing: true
    });
    this.resizeObserver = new ResizeObserver_es["a" /* default */](entries => {
      entries.forEach(entry => {
        if (entry.contentBoxSize) {
          this.menuBarResizeListener(entry.contentBoxSize[0].inlineSize);
        } else {
          this.menuBarResizeListener(entry.contentRect.width);
        }
      });
    });
    this.resizeObserver.observe(this.containerEl);
    this.calculateWidths().then(() => this.determineView());
  },

  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

});
// CONCATENATED MODULE: ./src/components/MenuBar/NebulaMenuBar.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/MenuBar/NebulaMenuBar.vue?vue&type=style&index=0&id=11f94db0&lang=stylus
var NebulaMenuBarvue_type_style_index_0_id_11f94db0_lang_stylus = __webpack_require__("3fcf");

// CONCATENATED MODULE: ./src/components/MenuBar/NebulaMenuBar.vue







const NebulaMenuBar_exports_ = /*#__PURE__*/exportHelper_default()(NebulaMenuBarvue_type_script_lang_js, [['render',NebulaMenuBarvue_type_template_id_11f94db0_render]])

/* harmony default export */ var NebulaMenuBar = (NebulaMenuBar_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Modal/NebulaModal.vue?vue&type=template&id=8787f17a

const NebulaModalvue_type_template_id_8787f17a_hoisted_1 = ["id", "aria-describedby", "aria-labelledby"];
const NebulaModalvue_type_template_id_8787f17a_hoisted_2 = {
  class: "nebula-modal__container"
};
const NebulaModalvue_type_template_id_8787f17a_hoisted_3 = {
  key: 0,
  class: "nebula-modal__header nebula-modal__header--sticky"
};
const NebulaModalvue_type_template_id_8787f17a_hoisted_4 = {
  key: 0,
  class: "nebula-modal__x-button-container"
};
const NebulaModalvue_type_template_id_8787f17a_hoisted_5 = {
  class: "nebula-modal__inner"
};
const NebulaModalvue_type_template_id_8787f17a_hoisted_6 = {
  class: "nebula-modal__content-container"
};
const NebulaModalvue_type_template_id_8787f17a_hoisted_7 = {
  key: 1,
  class: "nebula-modal__actions-container"
};
const NebulaModalvue_type_template_id_8787f17a_hoisted_8 = {
  key: 1,
  class: "nebula-modal__actions-container nebula-modal__actions-container--sticky"
};
const NebulaModalvue_type_template_id_8787f17a_hoisted_9 = {
  key: 2,
  class: "nebula-modal__x-button-container"
};
function NebulaModalvue_type_template_id_8787f17a_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_FocusTrap = Object(external_vue_["resolveComponent"])("FocusTrap");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.modalContainerClassName)
  }, [Object(external_vue_["createElementVNode"])("div", {
    class: "nebula-modal-overlay",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onClickClose && $options.onClickClose(...args))
  }), Object(external_vue_["createElementVNode"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.modalScrollContainerClass),
    ref: "focusTrap"
  }, [Object(external_vue_["createElementVNode"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.modalClassName),
    id: $options.getModalId,
    role: "dialog",
    "aria-describedby": $props.ariaDescribedby,
    "aria-labelledby": $props.ariaLabelledby,
    "aria-modal": "true"
  }, [Object(external_vue_["createVNode"])(_component_FocusTrap, {
    "initial-focus": $options.setFirstFocusedElement,
    active: ""
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("div", NebulaModalvue_type_template_id_8787f17a_hoisted_2, [$options.hasStickyHeader ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaModalvue_type_template_id_8787f17a_hoisted_3, [Object(external_vue_["renderSlot"])(_ctx.$slots, "stickyHeader"), !$props.hideCloseButton ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaModalvue_type_template_id_8787f17a_hoisted_4, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      class: "nebula-modal__x-button",
      "icon-left": "x",
      type: "flat",
      size: "s",
      "aria-label": _ctx.$t('close modal'),
      onClick: $options.onClickClose
    }, null, 8, ["aria-label", "onClick"])])) : Object(external_vue_["createCommentVNode"])("", true)])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaModalvue_type_template_id_8787f17a_hoisted_5, [$props.showHeader || $options.hasHeader ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
      key: 0,
      class: Object(external_vue_["normalizeClass"])($options.headerContainerClass)
    }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "header")], 2)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaModalvue_type_template_id_8787f17a_hoisted_6, [Object(external_vue_["renderSlot"])(_ctx.$slots, "content")]), $options.hasActionsRow ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaModalvue_type_template_id_8787f17a_hoisted_7, [Object(external_vue_["renderSlot"])(_ctx.$slots, "actionsRow")])) : Object(external_vue_["createCommentVNode"])("", true)]), $options.hasStickyActionsRow ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaModalvue_type_template_id_8787f17a_hoisted_8, [Object(external_vue_["renderSlot"])(_ctx.$slots, "stickyActionsRow")])) : Object(external_vue_["createCommentVNode"])("", true), !$props.hideCloseButton && !$options.hasStickyHeader ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaModalvue_type_template_id_8787f17a_hoisted_9, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      class: "nebula-modal__x-button",
      "icon-left": "x",
      type: "flat",
      size: "s",
      "aria-label": _ctx.$t('close modal'),
      onClick: $options.onClickClose
    }, null, 8, ["aria-label", "onClick"])])) : Object(external_vue_["createCommentVNode"])("", true)])]),
    _: 3
  }, 8, ["initial-focus"])], 10, NebulaModalvue_type_template_id_8787f17a_hoisted_1)], 2)], 2);
}
// CONCATENATED MODULE: ./src/components/Modal/NebulaModal.vue?vue&type=template&id=8787f17a

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Modal/NebulaModal.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaModalvue_type_script_lang_js = ({
  name: 'NebulaModal',
  components: {
    FocusTrap: FocusTrap,
    NebulaButton: NebulaButton
  },

  data() {
    return {
      pageParentEl: null,
      pageParentHTML: '',
      initializedWithOverflowHidden: false
    };
  },

  props: {
    ariaDescribedby: {
      type: String,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    firstFocusedElement: {
      type: String,
      default: null
    },
    onCloseForcedFocusElementId: {
      type: String,
      default: null
    },
    hideCloseButton: {
      type: Boolean,
      default: false
    },
    id: [String, Number],
    pageParentId: {
      type: String,
      default: 'nebula-page-shell'
    },
    showHeader: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'm',
      // options: s, m, l, xl
      enum: ['s', 'm', 'l', 'xl'] // for docs site

    },
    takeover: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close-modal'],

  created() {
    document.addEventListener('keyup', this.emitKeyUpEvent);
  },

  mounted() {
    this.initializedWithOverflowHidden = document.body.style.overflow === 'hidden';

    if (this.takeover && !this.hasStickyActionsRow && !this.hasStickyHeader) {
      const pageParent = this.getPageParentEl;
      const modal = this.getModal;
      const modalHeight = modal.clientHeight;
      this.pageParentEl = pageParent;
      this.pageParentHTML = pageParent.outerHTML; // eslint-disable-next-line max-len

      const tempPageParentHtml = `<div id="nebula-modal__temp-screen-lock" style="overflow: hidden; max-height: ${modalHeight}px">${this.pageParentHTML}</div>`;
      pageParent.outerHTML = tempPageParentHtml;
      this.$el.parentNode.removeChild(this.$el);
      document.body.appendChild(this.$el);
    } else {
      document.body.style.overflow = 'hidden';
    }
  },

  beforeUnmount() {
    document.removeEventListener('keyup', this.emitKeyUpEvent);

    if (this.takeover && !this.hasStickyActionsRow && !this.hasStickyHeader) {
      const modalScreenLock = document.getElementById('nebula-modal__temp-screen-lock');
      modalScreenLock.replaceWith(this.pageParentEl);
    } else if (!this.initializedWithOverflowHidden) {
      document.body.style.overflow = 'unset';
    }
  },

  unmounted() {
    if (this.onCloseForcedFocusElementId) {
      document.getElementById(this.onCloseForcedFocusElementId).focus();
    }
  },

  computed: {
    getModalId() {
      if (this.$props.id) {
        return this.$props.id;
      }

      return `nebula-modal--${Math.random().toString(36).substring(2, 10)}`;
    },

    getModal() {
      return document.getElementById(this.getModalId);
    },

    getPageParentEl() {
      return document.getElementById(this.pageParentId);
    },

    hasActionsRow() {
      return !!this.$slots.actionsRow;
    },

    hasStickyActionsRow() {
      return !!this.$slots.stickyActionsRow;
    },

    hasStickyHeader() {
      return !!this.$slots.stickyHeader;
    },

    hasHeader() {
      return !!this.$slots.header;
    },

    headerContainerClass() {
      let className = '';

      if (this.hideCloseButton) {
        className = 'nebula-modal__header-container--full-width';
      } else {
        className = 'nebula-modal__header-container';
      }

      return className;
    },

    modalClassName() {
      const className = ['nebula-modal', `nebula-modal--${this.size}`];
      return className;
    },

    modalContainerClassName() {
      const className = ['nebula-modal-container', {
        'nebula-modal-container--takeover': this.takeover === true && !this.hasStickyActionsRow,
        'nebula-modal-container--takeover-and-sticky': this.takeover === true && this.hasStickyActionsRow,
        'nebula-modal-container--takeover-and-sticky-header': this.takeover === true && this.hasStickyHeader
      }];
      return className;
    },

    modalScrollContainerClass() {
      const className = ['nebula-modal__scroll-container', `nebula-modal__scroll-container--${this.size}`];
      return className;
    }

  },
  methods: {
    emitKeyUpEvent(e) {
      if (e.keyCode === 27) {
        this.onClickClose();
      }
    },

    getFirstSelectableElement() {
      const focusable = this.getFocusableElements();

      if (focusable.length) {
        if (focusable.length > 1 && focusable[0].classList.contains('nebula-modal__x-button')) {
          return focusable[1];
        }

        return focusable[0];
      }

      return this.$refs.focusTrap;
    },

    getFocusableElements() {
      const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
      return this.$refs.focusTrap.querySelectorAll(focusableSelector);
    },

    onClickClose() {
      this.$emit('close-modal');
    },

    setFirstFocusedElement() {
      let firstFocused = null;

      if (this.firstFocusedElement) {
        firstFocused = document.getElementById(this.firstFocusedElement);
      } else {
        firstFocused = this.getFirstSelectableElement();
      }

      return firstFocused;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Modal/NebulaModal.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Modal/NebulaModal.vue?vue&type=style&index=0&id=8787f17a&lang=stylus
var NebulaModalvue_type_style_index_0_id_8787f17a_lang_stylus = __webpack_require__("f624");

// CONCATENATED MODULE: ./src/components/Modal/NebulaModal.vue







const NebulaModal_exports_ = /*#__PURE__*/exportHelper_default()(NebulaModalvue_type_script_lang_js, [['render',NebulaModalvue_type_template_id_8787f17a_render]])

/* harmony default export */ var NebulaModal = (NebulaModal_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/MultiLevelNav/MultiLevelNav.vue?vue&type=template&id=03066134


const MultiLevelNavvue_type_template_id_03066134_hoisted_1 = ["aria-expanded", "aria-label", "id"];
const MultiLevelNavvue_type_template_id_03066134_hoisted_2 = {
  class: "nebula-global-nav__top"
};
const MultiLevelNavvue_type_template_id_03066134_hoisted_3 = ["alt"];
const MultiLevelNavvue_type_template_id_03066134_hoisted_4 = ["aria-label", "href"];
const MultiLevelNavvue_type_template_id_03066134_hoisted_5 = ["alt"];
const MultiLevelNavvue_type_template_id_03066134_hoisted_6 = {
  class: "nebula-global-nav__subnav-title-wrapper"
};
const MultiLevelNavvue_type_template_id_03066134_hoisted_7 = {
  class: "nebula-global-nav__subnav-title"
};
const MultiLevelNavvue_type_template_id_03066134_hoisted_8 = {
  key: 0,
  class: "nebula-global-nav__display"
};
const MultiLevelNavvue_type_template_id_03066134_hoisted_9 = {
  class: "nebula-global-nav__nav-row"
};
const MultiLevelNavvue_type_template_id_03066134_hoisted_10 = {
  class: "nebula-global-nav__animation-wrapper"
};
const MultiLevelNavvue_type_template_id_03066134_hoisted_11 = {
  class: "nebula-global-nav__animation-wrapper"
};
const MultiLevelNavvue_type_template_id_03066134_hoisted_12 = {
  class: "nebula-global-nav__animation-wrapper"
};
function MultiLevelNavvue_type_template_id_03066134_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RouterLink = Object(external_vue_["resolveComponent"])("RouterLink");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_MultiLevelNavPanel = Object(external_vue_["resolveComponent"])("MultiLevelNavPanel");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("nav", {
    "aria-expanded": $props.isOpen,
    "aria-label": _ctx.$t('Global Navigation'),
    "aria-modal": "true",
    class: Object(external_vue_["normalizeClass"])(["nebula-global-nav nebula-multi-level-global-nav", $options.wrapperClasses]),
    id: $props.id,
    ref: "navRef",
    role: "dialog",
    tabindex: "0",
    onKeydown: _cache[0] || (_cache[0] = (...args) => $options.handleKeydown && $options.handleKeydown(...args))
  }, [Object(external_vue_["createElementVNode"])("div", MultiLevelNavvue_type_template_id_03066134_hoisted_2, [$props.routerLink ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_RouterLink, {
    key: 0,
    "aria-label": _ctx.$t('Home'),
    class: "nebula-product-bar__home",
    "data-click-name": "Logo",
    "data-click-type": "Global Navigation",
    ref: "home",
    to: $props.homeLink
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("img", {
      alt: _ctx.$t('Discovery Education Logo'),
      src: de_logo_default.a,
      height: "40",
      width: "46"
    }, null, 8, MultiLevelNavvue_type_template_id_03066134_hoisted_3)]),
    _: 1
  }, 8, ["aria-label", "to"])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("a", {
    key: 1,
    "aria-label": _ctx.$t('Home'),
    href: $props.homeLink,
    class: "nebula-product-bar__home",
    "data-click-name": "Logo",
    "data-click-type": "Global Navigation",
    ref: "home"
  }, [Object(external_vue_["createElementVNode"])("img", {
    alt: _ctx.$t('Discovery Education Logo'),
    src: de_logo_default.a,
    height: "40",
    width: "46"
  }, null, 8, MultiLevelNavvue_type_template_id_03066134_hoisted_5)], 8, MultiLevelNavvue_type_template_id_03066134_hoisted_4)), Object(external_vue_["createElementVNode"])("div", MultiLevelNavvue_type_template_id_03066134_hoisted_6, [Object(external_vue_["createElementVNode"])("p", MultiLevelNavvue_type_template_id_03066134_hoisted_7, Object(external_vue_["toDisplayString"])($options.navTitle), 1)]), Object(external_vue_["createVNode"])(_component_NebulaButton, {
    "aria-label": "close global navigation",
    class: "nebula-global-nav__close",
    "data-click-name": "Navigation Closed",
    "data-click-type": "Global Navigation",
    iconLeft: "x",
    size: "s",
    type: "flat",
    onClick: $options.handleClose
  }, null, 8, ["onClick"])]), $data.level1Nav || $data.level2Nav || $data.level3Nav ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", MultiLevelNavvue_type_template_id_03066134_hoisted_8, [Object(external_vue_["createElementVNode"])("div", MultiLevelNavvue_type_template_id_03066134_hoisted_9, [Object(external_vue_["createElementVNode"])("div", MultiLevelNavvue_type_template_id_03066134_hoisted_10, [Object(external_vue_["createVNode"])(external_vue_["Transition"], {
    name: "main"
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["withDirectives"])(Object(external_vue_["createVNode"])(_component_MultiLevelNavPanel, {
      isActive: $data.level1Nav && !$data.productId && !$data.courseId,
      navData: $data.level1Nav,
      navUpdateHandler: $options.updateNav
    }, null, 8, ["isActive", "navData", "navUpdateHandler"]), [[external_vue_["vShow"], $data.level1Nav && !$data.productId && !$data.courseId]])]),
    _: 1
  })]), Object(external_vue_["createElementVNode"])("div", MultiLevelNavvue_type_template_id_03066134_hoisted_11, [Object(external_vue_["createVNode"])(external_vue_["Transition"], {
    name: "subnav"
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["withDirectives"])(Object(external_vue_["createVNode"])(_component_MultiLevelNavPanel, {
      isActive: $data.level2Nav && $data.productId && !$data.courseId,
      navData: $data.level2Nav,
      navUpdateHandler: $options.updateNav,
      parentTitle: _ctx.$t('Main'),
      productId: $data.productId
    }, null, 8, ["isActive", "navData", "navUpdateHandler", "parentTitle", "productId"]), [[external_vue_["vShow"], $data.level2Nav && $data.productId && !$data.courseId]])]),
    _: 1
  })]), Object(external_vue_["createElementVNode"])("div", MultiLevelNavvue_type_template_id_03066134_hoisted_12, [Object(external_vue_["createVNode"])(external_vue_["Transition"], {
    name: "subnav"
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["withDirectives"])(Object(external_vue_["createVNode"])(_component_MultiLevelNavPanel, {
      courseId: $data.courseId,
      isActive: $data.level3Nav && $data.productId && !!$data.courseId,
      navData: $data.level3Nav,
      navUpdateHandler: $options.updateNav,
      parentTitle: $data.courseId ? $data.activeProductTitle || _ctx.$t('Previous') : _ctx.$t('Main'),
      productId: $data.productId
    }, null, 8, ["courseId", "isActive", "navData", "navUpdateHandler", "parentTitle", "productId"]), [[external_vue_["vShow"], $data.level3Nav && $data.productId && !!$data.courseId]])]),
    _: 1
  })])])])) : Object(external_vue_["createCommentVNode"])("", true)], 42, MultiLevelNavvue_type_template_id_03066134_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/MultiLevelNav/MultiLevelNav.vue?vue&type=template&id=03066134

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/MultiLevelNav/MultiLevelNavPanel.vue?vue&type=template&id=334a2d00

const MultiLevelNavPanelvue_type_template_id_334a2d00_hoisted_1 = {
  key: 0,
  class: "nebula-global-nav__header"
};
function MultiLevelNavPanelvue_type_template_id_334a2d00_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_MultiLevelNavItem = Object(external_vue_["resolveComponent"])("MultiLevelNavItem");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.classes)
  }, [$options.isSubNav ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
    key: 0,
    class: "nebula-global-nav-sub-nav__back-button",
    iconLeft: "caret-left",
    size: "s",
    text: $props.parentTitle || _ctx.$t('Previous'),
    type: "flat",
    onClick: $options.backButtonListener
  }, null, 8, ["text", "onClick"])) : Object(external_vue_["createCommentVNode"])("", true), (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($data.latestItems, (group, index) => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("section", {
      key: index,
      class: "nebula-global-nav__section"
    }, [group.name ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("h2", MultiLevelNavPanelvue_type_template_id_334a2d00_hoisted_1, Object(external_vue_["toDisplayString"])(_ctx.$t(group.name)), 1)) : Object(external_vue_["createCommentVNode"])("", true), (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(group.items, item => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_MultiLevelNavItem, {
        allowSubNav: !$props.courseId,
        item: item,
        key: item.id,
        subNavListener: () => $options.subNavListener(item)
      }, null, 8, ["allowSubNav", "item", "subNavListener"]);
    }), 128))]);
  }), 128))], 2);
}
// CONCATENATED MODULE: ./src/components/MultiLevelNav/MultiLevelNavPanel.vue?vue&type=template&id=334a2d00

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/MultiLevelNav/MultiLevelNavItem.vue?vue&type=template&id=0013884d

const MultiLevelNavItemvue_type_template_id_0013884d_hoisted_1 = {
  class: "nebula-global-nav-item__summary"
};
const MultiLevelNavItemvue_type_template_id_0013884d_hoisted_2 = {
  class: "nebula-global-nav-item__link"
};
function MultiLevelNavItemvue_type_template_id_0013884d_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.itemClasses)
  }, [(Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($options.linkComponent), {
    class: "nebula-global-nav-item__link",
    href: $props.item.useRouterLink ? null : $props.item.url,
    "item-click-name": $props.item.name,
    "item-click-type": "Global Navigation",
    tabIndex: "0",
    to: $props.item.useRouterLink ? $props.item.url : null
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("div", MultiLevelNavItemvue_type_template_id_0013884d_hoisted_1, [Object(external_vue_["createElementVNode"])("div", {
      class: Object(external_vue_["normalizeClass"])(["nebula-global-nav-item__icon-wrapper", $options.getStyle($props.item.nav_id, 'class') && `icon-wrapper--${$options.getStyle($props.item.nav_id, 'class')}`])
    }, [$options.getStyle($props.item.nav_id, 'icon') ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
      key: 0,
      size: "s",
      symbolId: $options.getStyle($props.item.nav_id, 'icon')
    }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true)], 2), Object(external_vue_["createElementVNode"])("h3", MultiLevelNavItemvue_type_template_id_0013884d_hoisted_2, Object(external_vue_["toDisplayString"])($props.item.title || $props.item.name), 1)])]),
    _: 1
  }, 8, ["href", "item-click-name", "to"])), $props.allowSubNav && $props.item.has_sub_nav ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
    key: 0,
    ariaLabel: _ctx.$t('show subnav'),
    class: "nebula-global-nav-item__caret",
    iconRight: "caret-right",
    size: "s",
    type: "flat",
    onClick: $props.subNavListener
  }, null, 8, ["ariaLabel", "onClick"])) : Object(external_vue_["createCommentVNode"])("", true)], 2);
}
// CONCATENATED MODULE: ./src/components/MultiLevelNav/MultiLevelNavItem.vue?vue&type=template&id=0013884d

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/MultiLevelNav/MultiLevelNavItem.vue?vue&type=script&lang=js



/* harmony default export */ var MultiLevelNavItemvue_type_script_lang_js = ({
  name: 'MultiLevelNavItem',
  components: {
    NebulaButton: NebulaButton,
    NebulaIcon: NebulaIcon
  },

  data() {
    return {
      styleMap: globalNavData
    };
  },

  props: {
    allowSubNav: {
      type: Boolean,
      default: true
    },
    item: {
      type: Object
    },
    subNavListener: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    itemClasses() {
      var _this$item;

      return {
        'nebula-global-nav-item': true,
        'nebula-global-nav-item--has-subnav': (_this$item = this.item) === null || _this$item === void 0 ? void 0 : _this$item.has_sub_nav
      };
    },

    linkComponent() {
      return this.item.useRouterLink ? 'routerLink' : 'a';
    }

  },
  methods: {
    getStyle(navId, prop) {
      const item = globalNavData.supportedMyDE[navId] || globalNavData.supportedDiscover[navId] || globalNavData.supportedTools[navId] || globalNavData.supportedProducts[navId];
      return item && item[prop];
    }

  }
});
// CONCATENATED MODULE: ./src/components/MultiLevelNav/MultiLevelNavItem.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/MultiLevelNav/MultiLevelNavItem.vue?vue&type=style&index=0&id=0013884d&lang=stylus
var MultiLevelNavItemvue_type_style_index_0_id_0013884d_lang_stylus = __webpack_require__("0d44");

// CONCATENATED MODULE: ./src/components/MultiLevelNav/MultiLevelNavItem.vue







const MultiLevelNavItem_exports_ = /*#__PURE__*/exportHelper_default()(MultiLevelNavItemvue_type_script_lang_js, [['render',MultiLevelNavItemvue_type_template_id_0013884d_render]])

/* harmony default export */ var MultiLevelNavItem = (MultiLevelNavItem_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/MultiLevelNav/MultiLevelNavPanel.vue?vue&type=script&lang=js


/* harmony default export */ var MultiLevelNavPanelvue_type_script_lang_js = ({
  name: 'MultiLevelNavPanel',

  data() {
    return {
      latestItems: []
    };
  },

  components: {
    MultiLevelNavItem: MultiLevelNavItem,
    NebulaButton: NebulaButton
  },
  props: {
    courseId: {
      type: String,
      default: null
    },
    isActive: {
      type: Boolean,
      default: false
    },
    navData: {
      type: Array,
      default: null
    },
    productId: {
      type: String,
      default: null
    },
    parentTitle: {
      type: String,
      default: null
    },
    navUpdateHandler: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    isSubNav() {
      return !!this.productId;
    },

    classes() {
      return {
        'nebula-global-nav-sub-nav': this.isSubNav,
        'nebula-global-nav-main-nav': !this.isSubNav,
        'nebula-global-nav-panel--active': this.isActive
      };
    }

  },
  methods: {
    backButtonListener() {
      if (this.courseId) {
        this.navUpdateHandler(this.productId);
      } else {
        this.navUpdateHandler();
      }
    },

    subNavListener(item) {
      if (!item.has_sub_nav) return;

      if (!this.productId) {
        // Open level 2
        this.navUpdateHandler(item.id || item.nav_id);
      } else {
        // Open level 3
        this.navUpdateHandler(this.productId, item.id || item.nav_id);
      }
    },

    updateNavData(newData) {
      if (Array.isArray(newData)) {
        this.latestItems = [...newData];
      }
    }

  },

  mounted() {
    this.updateNavData(this.navData);
  },

  watch: {
    navData(newData) {
      this.updateNavData(newData);
    }

  }
});
// CONCATENATED MODULE: ./src/components/MultiLevelNav/MultiLevelNavPanel.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/MultiLevelNav/MultiLevelNavPanel.vue?vue&type=style&index=0&id=334a2d00&lang=stylus
var MultiLevelNavPanelvue_type_style_index_0_id_334a2d00_lang_stylus = __webpack_require__("fca6");

// CONCATENATED MODULE: ./src/components/MultiLevelNav/MultiLevelNavPanel.vue







const MultiLevelNavPanel_exports_ = /*#__PURE__*/exportHelper_default()(MultiLevelNavPanelvue_type_script_lang_js, [['render',MultiLevelNavPanelvue_type_template_id_334a2d00_render]])

/* harmony default export */ var MultiLevelNavPanel = (MultiLevelNavPanel_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/MultiLevelNav/MultiLevelNav.vue?vue&type=script&lang=js



/* harmony default export */ var MultiLevelNavvue_type_script_lang_js = ({
  name: 'MultiLevelGlobalNav',
  components: {
    MultiLevelNavPanel: MultiLevelNavPanel,
    NebulaButton: NebulaButton
  },

  data() {
    return {
      activeCourseTitle: null,
      activeProductTitle: null,
      courseId: null,
      isVisible: false,
      level1Nav: null,
      level2Nav: null,
      level3Nav: null,
      productId: null,
      navMap: new Map(),
      trap: null,
      trapIsActive: false,
      trapIsPaused: false
    };
  },

  props: {
    focusTrapEnabled: {
      type: Boolean,
      default: false
    },
    homeLink: {
      type: String,
      default: '/suite/'
    },
    id: {
      type: String,
      default: 'nebula-global-nav'
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    navContext: {
      type: Object,
      required: true,

      validator(obj) {
        const valid = ['getNavData', 'productId', 'courseId', 'courseTitle', 'productTitle'];
        const invalid = Object.keys(obj).find(key => valid.indexOf(key) < 0);
        return !invalid;
      }

    },
    routerLink: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle-global-nav'],
  computed: {
    navTitle() {
      return this.activeCourseTitle || this.activeProductTitle || null;
    },

    wrapperClasses() {
      return {
        'nebula-global-nav--closed': !this.isOpen,
        'nebula-global-nav--show-level-2-nav': !this.courseId && this.productId,
        'nebula-global-nav--show-level-3-nav': this.courseId && this.productId
      };
    }

  },
  methods: {
    getInitialFocus() {
      const el = this.$refs.navRef.querySelector('.nebula-global-nav-panel--active .nebula-global-nav-item__link');
      return el || this.$refs.navRef;
    },

    handleClose() {
      this.$emit('toggle-global-nav', false);
    },

    handleKeydown(e) {
      if (e.code === 'Escape') {
        this.handleClose();
      }
    },

    formatNavObject(inputData) {
      if (!this.inputIsValid(inputData)) {
        throw new Error('Invalid nav stucture');
      }

      return {
        groups: inputData.navigation.groupings
      };
    },

    getMatchingTitleFromNav(id, nav) {
      let title = null;

      if (id && nav && Array.isArray(nav)) {
        for (let i = 0; i < nav.length; i += 1) {
          var _group$items;

          const group = nav[i];
          const match = (_group$items = group.items) === null || _group$items === void 0 ? void 0 : _group$items.find(item => item.id === id || item.nav_id === id);

          if (match) {
            title = match.name;
            break;
          }
        }
      }

      return title;
    },

    inputIsValid(apiData) {
      var _apiData$navigation;

      return !!Array.isArray(apiData === null || apiData === void 0 ? void 0 : (_apiData$navigation = apiData.navigation) === null || _apiData$navigation === void 0 ? void 0 : _apiData$navigation.groupings);
    },

    pauseTrap() {
      if (this.trapIsActive) {
        this.trap.pause();
        this.trapIsPaused = true;
      }
    },

    unpauseTrap() {
      if (this.trapIsPaused) {
        this.trap.unpause();
        this.trapIsPaused = false;
      }
    },

    async updateNav(productId, courseId) {
      if (courseId && !productId) {
        throw new Error(`productId required for courseId ${courseId}`);
      }

      this.pauseTrap(); // Get our stored copy, if it exists

      const key = `${productId || ''}-${courseId || ''}`;
      let formattedNav = this.navMap.get(key);

      if (!formattedNav) {
        // Get nav from API
        try {
          const nav = await this.navContext.getNavData(productId, courseId);
          formattedNav = this.formatNavObject(nav); // Store in map, for later use.

          this.navMap.set(key, formattedNav);
        } catch (error) {
          this.unpauseTrap();
          throw error;
        }
      } // Update labels


      if (this.courseId && !courseId) {
        // We are moving UP from level three to level two
        this.activeCourseTitle = null;
      } else if (this.productId && !productId) {
        // We are moving UP from level two to level one
        this.activeProductTitle = null;
      } else if (productId && !this.productId && this.level1Nav) {
        // We are moving down from level 1 to level 2 nav
        this.activeProductTitle = this.getMatchingTitleFromNav(productId, this.level1Nav);
      } else if (courseId && !this.courseId && this.level2Nav) {
        // We are moving down from level 2 to level 3 nav
        this.activeCourseTitle = this.getMatchingTitleFromNav(courseId, this.level2Nav);
      } // Now update our state to point to the new nav data


      this.courseId = courseId;
      this.productId = productId;

      if (courseId) {
        this.level3Nav = formattedNav.groups;
      } else if (productId) {
        this.level2Nav = formattedNav.groups;
      } else {
        this.level1Nav = formattedNav.groups;
      } // Force focusTrap to find new elements


      setTimeout(() => {
        if (this.trapIsActive) {
          this.unpauseTrap();
        } else {
          this.trap.activate();
          this.trapIsActive = true;
        }
      }, 350); // 350ms to allow CSS animation extra time to complete
    }

  },

  mounted() {
    this.trap = focus_trap_esm_createFocusTrap(this.$refs.navRef, {
      allowOutsideClick: true,
      escapeDeactivates: false,
      initialFocus: this.getInitialFocus
    }); // Initialize labels if provided

    this.activeCourseTitle = this.navContext.courseTitle;
    this.activeProductTitle = this.navContext.productTitle;
  },

  beforeUnmount() {
    if (this.trap) this.trap.deactivate();
  },

  watch: {
    async isOpen(newVal) {
      if (newVal && this.navMap.size === 0) {
        // No nav entries exist in the map yet, this must be the first** open
        // so load the nav with initial settings in navContext
        this.updateNav(this.navContext.productId, this.navContext.courseId);
      } else if (newVal) {
        // On re-open, update nav using our stored state
        this.updateNav(this.productId, this.courseId);
      } else if (this.trap != null) {
        // When closing, disable the trap
        this.trap.deactivate();
        this.trapIsActive = false;
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/MultiLevelNav/MultiLevelNav.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/MultiLevelNav/MultiLevelNav.vue?vue&type=style&index=0&id=03066134&lang=stylus
var MultiLevelNavvue_type_style_index_0_id_03066134_lang_stylus = __webpack_require__("cdee");

// CONCATENATED MODULE: ./src/components/MultiLevelNav/MultiLevelNav.vue







const MultiLevelNav_exports_ = /*#__PURE__*/exportHelper_default()(MultiLevelNavvue_type_script_lang_js, [['render',MultiLevelNavvue_type_template_id_03066134_render]])

/* harmony default export */ var MultiLevelNav = (MultiLevelNav_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/PageShell/NebulaPageShell.vue?vue&type=template&id=3a162186

const NebulaPageShellvue_type_template_id_3a162186_hoisted_1 = {
  key: 0,
  class: "nebula-page-shell__action-bar-wrapper"
};
const NebulaPageShellvue_type_template_id_3a162186_hoisted_2 = {
  key: 6,
  class: "nebula-page-shell__wrapper"
};
const NebulaPageShellvue_type_template_id_3a162186_hoisted_3 = {
  class: "nebula-page-shell__content"
};
function NebulaPageShellvue_type_template_id_3a162186_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaTitleTooltip = Object(external_vue_["resolveComponent"])("NebulaTitleTooltip");

  const _component_NebulaProductBar = Object(external_vue_["resolveComponent"])("NebulaProductBar");

  const _component_NebulaActionBar = Object(external_vue_["resolveComponent"])("NebulaActionBar");

  const _component_MultiLevelNav = Object(external_vue_["resolveComponent"])("MultiLevelNav");

  const _component_NebulaGlobalNav = Object(external_vue_["resolveComponent"])("NebulaGlobalNav");

  const _component_NebulaProfilePanel = Object(external_vue_["resolveComponent"])("NebulaProfilePanel");

  const _component_NebulaSidebar = Object(external_vue_["resolveComponent"])("NebulaSidebar");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    style: Object(external_vue_["normalizeStyle"])($options.styleVars),
    class: Object(external_vue_["normalizeClass"])($options.pageShellClass)
  }, [Object(external_vue_["createVNode"])(_component_NebulaProductBar, Object(external_vue_["mergeProps"])($props.productBarData, {
    class: $options.hasActionBar && 'nebula-product-bar--stacked',
    isGlobalNavOpen: $data.globalNavOpen,
    isProfilePanelOpen: $data.profilePanelOpen,
    globalNavId: $props.globalNavId,
    profilePanelId: $props.profilePanelId,
    hideDesktopSearch: $props.hideDesktopSearch,
    onOpenGlobalNav: $options.toggleGlobalNav,
    onOpenProfilePanel: $options.toggleProfilePanel
  }), {
    search: Object(external_vue_["withCtx"])(() => [$props.showSearchBox ? Object(external_vue_["renderSlot"])(_ctx.$slots, "search", {
      key: 0
    }) : Object(external_vue_["createCommentVNode"])("", true)]),
    actionButton: Object(external_vue_["withCtx"])(() => [$props.showQuickListToggle ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaTitleTooltip, {
      key: 0,
      position: "block-end",
      text: _ctx.$t('Open Favorites')
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaButton, {
        "aria-controls": $props.profilePanelId,
        "aria-expanded": `${$data.profilePanelOpen}`,
        "aria-label": _ctx.$t('Open Favorites'),
        class: "nebula-product-bar__quicklist-button",
        "icon-left": "heart--filled",
        type: "flat",
        text: $props.quickListTotalCount.toString(),
        onClick: $options.toggleProfilePanel,
        "data-click-name": "Quick List Menu",
        "data-click-type": "Navigation Opener"
      }, null, 8, ["aria-controls", "aria-expanded", "aria-label", "text", "onClick"])]),
      _: 1
    }, 8, ["text"])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["renderSlot"])(_ctx.$slots, "actionButton")]),
    _: 3
  }, 16, ["class", "isGlobalNavOpen", "isProfilePanelOpen", "globalNavId", "profilePanelId", "hideDesktopSearch", "onOpenGlobalNav", "onOpenProfilePanel"]), this.$slots.actionBar || $props.actionBarData ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaPageShellvue_type_template_id_3a162186_hoisted_1, [$props.actionBarData ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaActionBar, Object(external_vue_["normalizeProps"])(Object(external_vue_["mergeProps"])({
    key: 0
  }, $props.actionBarData)), null, 16)) : Object(external_vue_["renderSlot"])(_ctx.$slots, "actionBar", {
    key: 1
  })])) : Object(external_vue_["createCommentVNode"])("", true), $props.navContext ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_MultiLevelNav, {
    key: 1,
    focusTrapEnabled: true,
    homeLink: $props.homeLink,
    id: $props.globalNavId,
    isOpen: $data.globalNavOpen,
    navContext: $props.navContext,
    onToggleGlobalNav: $options.toggleGlobalNav
  }, null, 8, ["homeLink", "id", "isOpen", "navContext", "onToggleGlobalNav"])) : $props.globalNavData ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaGlobalNav, {
    key: 2,
    focusTrapEnabled: true,
    homeLink: $props.homeLink,
    homeLinkComponent: $props.homeLinkComponent,
    id: $props.globalNavId,
    data: $props.globalNavData,
    onToggleGlobalNav: $options.toggleGlobalNav,
    ref: "globalNav",
    isOpen: $data.globalNavOpen
  }, null, 8, ["homeLink", "homeLinkComponent", "id", "data", "onToggleGlobalNav", "isOpen"])) : Object(external_vue_["createCommentVNode"])("", true), $data.globalNavOpen ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    key: 3,
    class: "nebula-global-nav__overlay",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toggleGlobalNav && $options.toggleGlobalNav(...args))
  })) : Object(external_vue_["createCommentVNode"])("", true), $props.profilePanelData ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaProfilePanel, {
    key: 4,
    createTeamsMeetingLink: $props.profilePanelData.createTeamsMeetingLink,
    focusTrapEnabled: true,
    id: $props.profilePanelId,
    isProfilePanelOpen: $data.profilePanelOpen,
    isUserImpersonating: $props.profilePanelData.isUserImpersonating,
    learnUrl: $props.profilePanelData.learnUrl,
    profilePanelCollapsed: !$data.profilePanelOpen,
    userAvatarUrl: $props.profilePanelData.userAvatarUrl,
    userBackgroundUrl: $props.profilePanelData.userBackgroundUrl,
    userCanCreateTeamsMeeting: $props.profilePanelData.userCanCreateTeamsMeeting,
    userFullName: $props.profilePanelData.userFullName,
    userHasProfileLink: $props.profilePanelData.userHasProfileLink,
    quitImpersonateUrl: $props.profilePanelData.quitImpersonateUrl,
    multisite: $options.parsedMultisite
  }, {
    profilePanelClose: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      "aria-label": "Close",
      iconRight: "x",
      type: "flat",
      onClick: $options.toggleProfilePanel
    }, null, 8, ["onClick"])]),
    quickListSlot: Object(external_vue_["withCtx"])(() => [Object(external_vue_["renderSlot"])(_ctx.$slots, "quickListSlot")]),
    _: 3
  }, 8, ["createTeamsMeetingLink", "id", "isProfilePanelOpen", "isUserImpersonating", "learnUrl", "profilePanelCollapsed", "userAvatarUrl", "userBackgroundUrl", "userCanCreateTeamsMeeting", "userFullName", "userHasProfileLink", "quitImpersonateUrl", "multisite"])) : Object(external_vue_["createCommentVNode"])("", true), $props.profilePanelData ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    key: 5,
    class: "nebula-profile-panel__overlay",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.toggleProfilePanel && $options.toggleProfilePanel(...args))
  })) : Object(external_vue_["createCommentVNode"])("", true), !$props.embed ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaPageShellvue_type_template_id_3a162186_hoisted_2, [$props.sidebarData ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaSidebar, {
    key: 0,
    sidebarData: $props.sidebarData,
    onSidebarItemClick: $options.handleItemClick
  }, null, 8, ["sidebarData", "onSidebarItemClick"])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaPageShellvue_type_template_id_3a162186_hoisted_3, [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")])])) : Object(external_vue_["createCommentVNode"])("", true)], 6);
}
// CONCATENATED MODULE: ./src/components/PageShell/NebulaPageShell.vue?vue&type=template&id=3a162186

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ProductBar/NebulaProductBar.vue?vue&type=template&id=c76f172e


const NebulaProductBarvue_type_template_id_c76f172e_hoisted_1 = {
  class: "nebula-product-bar__inner"
};
const NebulaProductBarvue_type_template_id_c76f172e_hoisted_2 = {
  class: "nebula-product-bar__inline-start"
};
const NebulaProductBarvue_type_template_id_c76f172e_hoisted_3 = ["src"];
const NebulaProductBarvue_type_template_id_c76f172e_hoisted_4 = ["alt"];
const NebulaProductBarvue_type_template_id_c76f172e_hoisted_5 = {
  key: 1
};
const NebulaProductBarvue_type_template_id_c76f172e_hoisted_6 = {
  key: 0,
  class: "nebula-product-bar__page-title nebula-product-bar__page-title--logo"
};
const NebulaProductBarvue_type_template_id_c76f172e_hoisted_7 = ["innerHTML"];
const NebulaProductBarvue_type_template_id_c76f172e_hoisted_8 = {
  key: 1,
  class: "nebula-product-bar__page-title"
};
const NebulaProductBarvue_type_template_id_c76f172e_hoisted_9 = {
  key: 0,
  class: "nebula-product-bar__middle"
};
const NebulaProductBarvue_type_template_id_c76f172e_hoisted_10 = {
  key: 0,
  class: "nebula-product-bar__search-container"
};
const NebulaProductBarvue_type_template_id_c76f172e_hoisted_11 = {
  class: "nebula-product-bar__inline-end"
};
const NebulaProductBarvue_type_template_id_c76f172e_hoisted_12 = ["aria-controls", "aria-expanded", "aria-label"];
const NebulaProductBarvue_type_template_id_c76f172e_hoisted_13 = {
  key: 0,
  class: "nebula-product-bar__avatar-text"
};
const NebulaProductBarvue_type_template_id_c76f172e_hoisted_14 = ["src"];
const NebulaProductBarvue_type_template_id_c76f172e_hoisted_15 = {
  key: 0,
  class: "nebula-product-bar__mobile-search"
};
function NebulaProductBarvue_type_template_id_c76f172e_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIconButton = Object(external_vue_["resolveComponent"])("NebulaIconButton");

  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaTitleTooltip = Object(external_vue_["resolveComponent"])("NebulaTitleTooltip");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])(["nebula-product-bar", {
      'nebula-product-bar--hidden': $data.productBarHidden,
      'nebula-product-bar--desktop-search-hidden': $props.hideDesktopSearch
    }])
  }, [Object(external_vue_["createElementVNode"])("div", NebulaProductBarvue_type_template_id_c76f172e_hoisted_1, [Object(external_vue_["createElementVNode"])("div", NebulaProductBarvue_type_template_id_c76f172e_hoisted_2, [$options.showGlobalNav ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIconButton, {
    key: 0,
    "aria-controls": $props.globalNavId,
    "aria-expanded": `${$props.isGlobalNavOpen}`,
    "aria-label": $options.getGlobalNavButtonLabel,
    class: "nebula-product-bar__global-nav-button",
    icon: "hamburger",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('open-global-nav')),
    "data-click-name": "Navigation Opener",
    "data-click-type": "Global Navigation Hamburger Menu",
    tooltipProps: {
      position: 'block-end',
      text: `${$options.getGlobalNavButtonLabel}`
    }
  }, null, 8, ["aria-controls", "aria-expanded", "aria-label", "tooltipProps"])) : Object(external_vue_["createCommentVNode"])("", true), (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.homeLogoElement), {
    href: $props.homeLogoElement === 'a' ? $props.homeLink : undefined,
    to: $props.homeLogoElement === 'RouterLink' ? $props.homeLink : undefined,
    "aria-label": $options.getHomeLogoAriaLabel,
    class: "nebula-product-bar__home",
    "data-click-name": "Logo",
    "data-click-type": "Global Navigation"
  }, {
    default: Object(external_vue_["withCtx"])(() => [$props.homeLogoImageSrc ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("img", {
      key: 0,
      src: $props.homeLogoImageSrc,
      alt: ""
    }, null, 8, NebulaProductBarvue_type_template_id_c76f172e_hoisted_3)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("img", {
      key: 1,
      src: de_logo_default.a,
      alt: _ctx.$t('Discovery Education Logo'),
      height: "40",
      width: "46"
    }, null, 8, NebulaProductBarvue_type_template_id_c76f172e_hoisted_4))]),
    _: 1
  }, 8, ["href", "to", "aria-label"])), !$data.isMobile && !$props.embed ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaProductBarvue_type_template_id_c76f172e_hoisted_5, [$props.pageTitleLogo ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaProductBarvue_type_template_id_c76f172e_hoisted_6, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
    symbolId: $props.pageTitleLogo + '-logo',
    class: "nebula-product-bar__page-title-logo"
  }, null, 8, ["symbolId"]), Object(external_vue_["createElementVNode"])("span", {
    class: "nebula-screenreader-only",
    innerHTML: _ctx.$t($props.pageTitle)
  }, null, 8, NebulaProductBarvue_type_template_id_c76f172e_hoisted_7)])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaProductBarvue_type_template_id_c76f172e_hoisted_8, Object(external_vue_["toDisplayString"])(_ctx.$t($props.pageTitle)), 1))])) : Object(external_vue_["createCommentVNode"])("", true)]), !$data.isMobile && !$props.prelogin ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaProductBarvue_type_template_id_c76f172e_hoisted_9, [!$data.searchInputHidden ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaProductBarvue_type_template_id_c76f172e_hoisted_10, [Object(external_vue_["renderSlot"])(_ctx.$slots, "search")])) : Object(external_vue_["createCommentVNode"])("", true)])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaProductBarvue_type_template_id_c76f172e_hoisted_11, [Object(external_vue_["createVNode"])(_component_NebulaTitleTooltip, {
    position: "block-end",
    text: $options.desktopSearchLabel
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      "aria-label": $options.desktopSearchLabel,
      class: "nebula-product-bar__toggle-search-button",
      "icon-left": $options.desktopSearchIcon,
      type: "flat",
      onClick: _cache[1] || (_cache[1] = $event => $options.toggleSearch())
    }, null, 8, ["aria-label", "icon-left"])]),
    _: 1
  }, 8, ["text"]), Object(external_vue_["renderSlot"])(_ctx.$slots, "actionButton"), $options.showProfileAvatar ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaTitleTooltip, {
    key: 0,
    position: "block-end",
    text: $options.getProfileButtonLabel
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("button", {
      "aria-controls": $props.profilePanelId,
      "aria-expanded": `${$props.isProfilePanelOpen}`,
      "aria-label": $options.getProfileButtonLabel,
      class: Object(external_vue_["normalizeClass"])(["nebula-product-bar__avatar", {
        'nebula-product-bar__avatar--image': $props.avatarImage && $data.hasValidAvatar
      }]),
      onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('open-profile-panel')),
      "data-click-name": "Profile Menu",
      "data-click-type": "Navigation Opener"
    }, [!$props.avatarImage || !$data.hasValidAvatar ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", NebulaProductBarvue_type_template_id_c76f172e_hoisted_13, Object(external_vue_["toDisplayString"])($props.userInitials), 1)) : Object(external_vue_["createCommentVNode"])("", true), $props.avatarImage && $data.hasValidAvatar ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("img", {
      key: 1,
      class: "nebula-product-bar__avatar-image",
      src: $props.avatarImage,
      alt: "",
      onError: _cache[2] || (_cache[2] = (...args) => $options.onImageLoadError && $options.onImageLoadError(...args))
    }, null, 40, NebulaProductBarvue_type_template_id_c76f172e_hoisted_14)) : Object(external_vue_["createCommentVNode"])("", true)], 10, NebulaProductBarvue_type_template_id_c76f172e_hoisted_12)]),
    _: 1
  }, 8, ["text"])) : Object(external_vue_["createCommentVNode"])("", true)])]), Object(external_vue_["createVNode"])(external_vue_["Transition"], {
    name: "product-bar-mobile-search-slide"
  }, {
    default: Object(external_vue_["withCtx"])(() => [$data.isMobile && $data.showMobileSearch && !$props.prelogin ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaProductBarvue_type_template_id_c76f172e_hoisted_15, [Object(external_vue_["renderSlot"])(_ctx.$slots, "search")])) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 3
  })], 2);
}
// CONCATENATED MODULE: ./src/components/ProductBar/NebulaProductBar.vue?vue&type=template&id=c76f172e

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ProductBar/NebulaProductBar.vue?vue&type=script&lang=js





/* harmony default export */ var NebulaProductBarvue_type_script_lang_js = ({
  name: 'NebulaProductBar',
  components: {
    NebulaButton: NebulaButton,
    NebulaIconButton: NebulaIconButton,
    NebulaIcon: NebulaIcon,
    NebulaTitleTooltip: NebulaTitleTooltip
  },

  data() {
    return {
      defaultHomeLogoAriaLabel: this.$t('Discovery Education Home'),
      desktopSearchOpen: true,
      hasValidAvatar: true,
      isMobile: document.documentElement.clientWidth <= 767,
      productBarHidden: false,
      searchSuggestions: null,
      searchInputHidden: false,
      showMobileSearch: false
    };
  },

  props: {
    avatarImage: {
      type: String,
      default: null
    },
    embed: {
      type: Boolean,
      default: false
    },
    globalNavId: {
      type: String,
      default: 'nebula-global-nav'
    },
    globalNavLabel: {
      type: String,
      default: null
    },
    hideDesktopSearch: {
      type: Boolean,
      default: false
    },
    hideGlobalNav: {
      type: Boolean,
      default: false
    },
    hideProfileAvatar: {
      type: Boolean,
      default: false
    },
    homeLogoAriaLabel: {
      type: String,
      default: null
    },
    homeLink: {
      type: String,
      default: '/suite'
    },
    homeLogoElement: {
      type: String,
      default: 'RouterLink'
    },
    homeLogoImageSrc: {
      type: String,
      default: null // the default is handled in the template so it imports properly

    },
    isGlobalNavOpen: {
      type: Boolean,
      default: false
    },
    isProfilePanelOpen: {
      type: Boolean,
      default: false
    },
    pageTitle: {
      type: String
    },
    pageTitleLogo: {
      type: String,
      default: null
    },
    prelogin: {
      type: Boolean,
      default: false
    },
    profileButtonLabel: {
      type: String,
      default: null
    },
    profilePanelId: {
      type: String,
      default: 'nebula-profile-panel'
    },
    searchAction: {
      type: String // TODO: This is not used. Can it be removed?

    },
    searchInputId: {
      type: String,
      default: 'nebula-product-bar__search-input'
    },
    userInitials: {
      type: String,
      default: 'DE'
    }
  },
  emits: ['open-global-nav', 'open-profile-panel'],
  computed: {
    desktopSearchIcon() {
      let desktopSearchIcon = 'search';

      if (this.hideDesktopSearch && this.desktopSearchOpen) {
        desktopSearchIcon = 'x';
      }

      if (this.isMobile) {
        desktopSearchIcon = 'search';
      }

      return desktopSearchIcon;
    },

    desktopSearchLabel() {
      let desktopSearchLabel = this.$t('Show Search');

      if (this.hideDesktopSearch && this.desktopSearchOpen) {
        desktopSearchLabel = this.$t('Close Search');
      }

      if (this.isMobile) {
        desktopSearchLabel = this.$t('Show Search');
      }

      return desktopSearchLabel;
    },

    getGlobalNavButtonLabel() {
      return this.globalNavLabel ? this.globalNavLabel : this.$t('Open Global Nav');
    },

    getHomeLogoAriaLabel() {
      return this.homeLogoAriaLabel ? this.homeLogoAriaLabel : this.$t('Home');
    },

    getProfileButtonLabel() {
      return this.profileButtonLabel ? this.profileButtonLabel : this.$t('Open Profile Panel');
    },

    showGlobalNav() {
      if (this.prelogin || this.embed || this.hideGlobalNav) {
        return false;
      }

      return true;
    },

    showProfileAvatar() {
      if (this.prelogin || this.embed || this.hideProfileAvatar) {
        return false;
      }

      return true;
    }

  },

  mounted() {
    this.throttledHandleResize = lodash_es_throttle(this.handleResize, 150);
    window.addEventListener('resize', this.throttledHandleResize);

    if (this.hideDesktopSearch === true) {
      this.desktopSearchOpen = false;
      this.searchInputHidden = true;
    }
  },

  unmounted() {
    window.removeEventListener('resize', this.throttledHandleResize);
  },

  methods: {
    closeMobileSearch() {
      this.showMobileSearch = false;
    },

    handleResize() {
      this.isMobile = document.documentElement.clientWidth <= 767; // 1px below tablet portrait

      if (!this.isMobile) {
        this.showMobileSearch = false;
      }
    },

    onImageLoadError() {
      this.hasValidAvatar = false;
    },

    focusSearchBox() {
      this.$nextTick(() => {
        document.getElementById(this.searchInputId).focus();
      });
    },

    toggleSearch() {
      if (!this.isMobile) {
        this.desktopSearchOpen = !this.desktopSearchOpen;
        this.searchInputHidden = !this.searchInputHidden;

        if (!this.searchInputHidden) {
          this.focusSearchBox();
        }
      } else {
        this.showMobileSearch = !this.showMobileSearch;

        if (this.showMobileSearch) {
          this.focusSearchBox();
        }
      }
    }

  },
  watch: {
    avatarImage() {
      // If the avatar changes, reset this so it can be loaded again
      this.hasValidAvatar = true;
    }

  }
});
// CONCATENATED MODULE: ./src/components/ProductBar/NebulaProductBar.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/ProductBar/NebulaProductBar.vue?vue&type=style&index=0&id=c76f172e&lang=stylus
var NebulaProductBarvue_type_style_index_0_id_c76f172e_lang_stylus = __webpack_require__("ebb3");

// CONCATENATED MODULE: ./src/components/ProductBar/NebulaProductBar.vue







const NebulaProductBar_exports_ = /*#__PURE__*/exportHelper_default()(NebulaProductBarvue_type_script_lang_js, [['render',NebulaProductBarvue_type_template_id_c76f172e_render]])

/* harmony default export */ var NebulaProductBar = (NebulaProductBar_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Sidebar/NebulaSidebar.vue?vue&type=template&id=52285868

const NebulaSidebarvue_type_template_id_52285868_hoisted_1 = ["id"];
const NebulaSidebarvue_type_template_id_52285868_hoisted_2 = {
  key: 0,
  class: "nebula-sidebar__section"
};
const NebulaSidebarvue_type_template_id_52285868_hoisted_3 = {
  class: "section__list"
};
const NebulaSidebarvue_type_template_id_52285868_hoisted_4 = {
  class: "section__list"
};
function NebulaSidebarvue_type_template_id_52285868_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaSidebarItem = Object(external_vue_["resolveComponent"])("NebulaSidebarItem");

  const _component_NebulaAccordion = Object(external_vue_["resolveComponent"])("NebulaAccordion");

  const _component_NebulaSidebarSectionHeader = Object(external_vue_["resolveComponent"])("NebulaSidebarSectionHeader");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.element), {
    class: Object(external_vue_["normalizeClass"])($options.getSidebarClass),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      class: "nebula-sidebar__toggle-nav-button",
      "aria-label": $options.getAriaLabel,
      "aria-controls": $options.sidebarId,
      "aria-expanded": $options.sidebarOpen.toString(),
      iconRight: $data.sidebarCollapsed ? 'sidebar-expand' : 'sidebar-collapse',
      shape: "pill",
      size: "s",
      text: $options.getResponsiveButtonText,
      onClick: $options.handleCollapse
    }, null, 8, ["aria-label", "aria-controls", "aria-expanded", "iconRight", "text", "onClick"]), Object(external_vue_["createElementVNode"])("div", {
      class: "nebula-sidebar__inner",
      id: $options.sidebarId
    }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "sidebar-top"), $props.sidebarData && $props.useAccordionGroups ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaSidebarvue_type_template_id_52285868_hoisted_2, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.sidebarData, (section, index) => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaAccordion, {
        key: index,
        element: "div",
        class: "nebula-sidebar__accordion",
        text: _ctx.$t(section.section_title),
        isExpandedOnLoad: section.expanded,
        mode: "flat"
      }, {
        default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("ul", NebulaSidebarvue_type_template_id_52285868_hoisted_3, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(section.items, (item, i) => {
          return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaSidebarItem, {
            key: i,
            item: item,
            class: Object(external_vue_["normalizeClass"])($options.getSidebarItemClass(item))
          }, null, 8, ["item", "class"]);
        }), 128))])]),
        _: 2
      }, 1032, ["text", "isExpandedOnLoad"]);
    }), 128))])) : $props.sidebarData && !$props.useAccordionGroups ? (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
      key: 1
    }, Object(external_vue_["renderList"])($props.sidebarData, (section, index) => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        key: index,
        class: "nebula-sidebar__section"
      }, [Object(external_vue_["createVNode"])(_component_NebulaSidebarSectionHeader, {
        text: _ctx.$t(section.section_title)
      }, null, 8, ["text"]), Object(external_vue_["createElementVNode"])("ul", NebulaSidebarvue_type_template_id_52285868_hoisted_4, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(section.items, (item, i) => {
        return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaSidebarItem, {
          key: i,
          item: item
        }, null, 8, ["item"]);
      }), 128))])]);
    }), 128)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["renderSlot"])(_ctx.$slots, "sidebar-content"), Object(external_vue_["renderSlot"])(_ctx.$slots, "sidebar-bottom")], 8, NebulaSidebarvue_type_template_id_52285868_hoisted_1)]),
    _: 3
  }, 8, ["class", "style"]);
}
// CONCATENATED MODULE: ./src/components/Sidebar/NebulaSidebar.vue?vue&type=template&id=52285868

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Sidebar/NebulaSidebarItem.vue?vue&type=template&id=4527b3cc

const NebulaSidebarItemvue_type_template_id_4527b3cc_hoisted_1 = ["data-name", "id"];
function NebulaSidebarItemvue_type_template_id_4527b3cc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
    class: Object(external_vue_["normalizeClass"])(["section__list-item", $options.sidebarItemClass]),
    "data-name": _ctx.$t($props.item.name),
    id: $options.formattedId
  }, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
    link: $props.item.url,
    text: _ctx.$t($props.item.name),
    "icon-left": $props.item.icon ? $props.item.icon : '',
    type: "flat",
    size: "s",
    class: Object(external_vue_["normalizeClass"])($props.item.usePushState ? 'do-push-state' : ''),
    routerLink: $props.item.routerLink,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('sidebarItemClick'))
  }, null, 8, ["link", "text", "icon-left", "class", "routerLink"])], 10, NebulaSidebarItemvue_type_template_id_4527b3cc_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/Sidebar/NebulaSidebarItem.vue?vue&type=template&id=4527b3cc

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Sidebar/NebulaSidebarItem.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaSidebarItemvue_type_script_lang_js = ({
  name: 'SidebarItem',
  components: {
    NebulaButton: NebulaButton
  },
  props: {
    id: {
      type: String
    },
    item: {
      type: Object
    }
  },
  emits: ['sidebarItemClick'],

  data() {
    return {
      sidebarCollapsed: false
    };
  },

  computed: {
    formattedId() {
      if (this.$props.id) {
        return this.$props.id;
      }

      return `nebula-sidebar-item--${this.randomStringId}`;
    },

    randomStringId() {
      return randomStringId();
    },

    sidebarItemClass() {
      const item = JSON.parse(JSON.stringify(this.item));
      const className = ['nebula-sidebar__accordion-item', {
        'nebula-sidebar__accordion-item--current': item.active && item.active === true,
        'nebula-sidebar__accordion-item--hidden': item.hidden && item.hidden === true
      }];
      return className;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Sidebar/NebulaSidebarItem.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/components/Sidebar/NebulaSidebarItem.vue





const NebulaSidebarItem_exports_ = /*#__PURE__*/exportHelper_default()(NebulaSidebarItemvue_type_script_lang_js, [['render',NebulaSidebarItemvue_type_template_id_4527b3cc_render]])

/* harmony default export */ var NebulaSidebarItem = (NebulaSidebarItem_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Sidebar/NebulaSidebarSectionHeader.vue?vue&type=template&id=0a4f1e93

function NebulaSidebarSectionHeadervue_type_template_id_0a4f1e93_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.element), {
    class: "section__header",
    id: $options.formattedId,
    textContent: Object(external_vue_["toDisplayString"])($props.text)
  }, null, 8, ["id", "textContent"]);
}
// CONCATENATED MODULE: ./src/components/Sidebar/NebulaSidebarSectionHeader.vue?vue&type=template&id=0a4f1e93

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayReduce.js
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/* harmony default export */ var _arrayReduce = (arrayReduce);

// CONCATENATED MODULE: ./node_modules/lodash-es/_basePropertyOf.js
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ var _basePropertyOf = (basePropertyOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/_deburrLetter.js


/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = _basePropertyOf(deburredLetters);

/* harmony default export */ var _deburrLetter = (deburrLetter);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayMap.js
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ var _arrayMap = (arrayMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/isArray.js
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ var lodash_es_isArray = (isArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseToString.js





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (lodash_es_isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (lodash_es_isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ var _baseToString = (baseToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/toString.js


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString_toString(value) {
  return value == null ? '' : _baseToString(value);
}

/* harmony default export */ var lodash_es_toString = (toString_toString);

// CONCATENATED MODULE: ./node_modules/lodash-es/deburr.js



/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = lodash_es_toString(string);
  return string && string.replace(reLatin, _deburrLetter).replace(reComboMark, '');
}

/* harmony default export */ var lodash_es_deburr = (deburr);

// CONCATENATED MODULE: ./node_modules/lodash-es/_asciiWords.js
/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/* harmony default export */ var _asciiWords = (asciiWords);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hasUnicodeWord.js
/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/* harmony default export */ var _hasUnicodeWord = (hasUnicodeWord);

// CONCATENATED MODULE: ./node_modules/lodash-es/_unicodeWords.js
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    _unicodeWords_rsComboMarksRange = '\\u0300-\\u036f',
    _unicodeWords_reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    _unicodeWords_rsComboSymbolsRange = '\\u20d0-\\u20ff',
    _unicodeWords_rsComboRange = _unicodeWords_rsComboMarksRange + _unicodeWords_reComboHalfMarksRange + _unicodeWords_rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    _unicodeWords_rsCombo = '[' + _unicodeWords_rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + _unicodeWords_rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/* harmony default export */ var _unicodeWords = (unicodeWords);

// CONCATENATED MODULE: ./node_modules/lodash-es/words.js





/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = lodash_es_toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return _hasUnicodeWord(string) ? _unicodeWords(string) : _asciiWords(string);
  }
  return string.match(pattern) || [];
}

/* harmony default export */ var lodash_es_words = (words);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createCompounder.js




/** Used to compose unicode capture groups. */
var _createCompounder_rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(_createCompounder_rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return _arrayReduce(lodash_es_words(lodash_es_deburr(string).replace(reApos, '')), callback, '');
  };
}

/* harmony default export */ var _createCompounder = (createCompounder);

// CONCATENATED MODULE: ./node_modules/lodash-es/kebabCase.js


/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = _createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

/* harmony default export */ var lodash_es_kebabCase = (kebabCase);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Sidebar/NebulaSidebarSectionHeader.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaSidebarSectionHeadervue_type_script_lang_js = ({
  name: 'SidebarSectionHeader',
  props: {
    element: {
      type: String,
      default: 'div'
    },
    id: {
      type: String
    },
    text: {
      type: String
    }
  },
  computed: {
    formattedId() {
      if (this.$props.id) {
        return this.$props.id;
      }

      return `nebula-sidebar-header--${lodash_es_kebabCase(this.text.toLowerCase())}`;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Sidebar/NebulaSidebarSectionHeader.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/components/Sidebar/NebulaSidebarSectionHeader.vue





const NebulaSidebarSectionHeader_exports_ = /*#__PURE__*/exportHelper_default()(NebulaSidebarSectionHeadervue_type_script_lang_js, [['render',NebulaSidebarSectionHeadervue_type_template_id_0a4f1e93_render]])

/* harmony default export */ var NebulaSidebarSectionHeader = (NebulaSidebarSectionHeader_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Sidebar/NebulaSidebar.vue?vue&type=script&lang=js







/* harmony default export */ var NebulaSidebarvue_type_script_lang_js = ({
  name: 'NebulaSidebar',
  mixins: [themingUtils],
  components: {
    NebulaAccordion: NebulaAccordion,
    NebulaButton: NebulaButton,
    NebulaSidebarItem: NebulaSidebarItem,
    NebulaSidebarSectionHeader: NebulaSidebarSectionHeader
  },

  data() {
    return {
      sidebarCollapsed: false,
      windowSize: null
    };
  },

  props: {
    ariaLabelCollapse: {
      type: String,
      default: null
    },
    ariaLabelExpand: {
      type: String,
      default: null
    },
    element: {
      type: String,
      default: 'div'
    },
    id: {
      type: String,
      default: null
    },
    responsiveButtonTextClose: {
      type: String,
      default: null
    },
    responsiveButtonTextOpen: {
      type: String,
      default: null
    },
    responsiveThreshold: {
      type: Number,
      default: 600
    },
    sidebarData: {
      type: Array
    },
    transitionSpeed: {
      type: Number,
      default: 100
    },
    useAccordionGroups: {
      type: Boolean,
      default: false
    },
    useResponsiveCollapseOnload: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    if (this.useResponsiveCollapseOnload) {
      this.throttledHandleResize = lodash_es_throttle(this.setWindowSize, 150);
      window.addEventListener('resize', this.throttledHandleResize);
      this.setWindowSize();

      if (this.responsiveCollapseActivated) {
        this.sidebarCollapsed = true;
      } else {
        this.sidebarCollapsed = false;
      }
    }
  },

  emits: ['sidebar-collapsed'],
  computed: {
    getAriaLabel() {
      let ariaLabel = '';

      if (this.sidebarCollapsed) {
        ariaLabel = this.ariaLabelExpand ? this.ariaLabelExpand : this.$t('expand sidebar');
      } else {
        ariaLabel = this.ariaLabelCollapse ? this.ariaLabelCollapse : this.$t('collapse sidebar');
      }

      return ariaLabel;
    },

    getResponsiveButtonText() {
      let buttonText = '';

      if (this.useResponsiveCollapseOnload) {
        if (this.responsiveCollapseActivated && this.sidebarCollapsed) {
          buttonText = this.responsiveButtonTextOpen || this.$t('Open Sidebar');
        } else if (this.responsiveCollapseActivated && !this.sidebarCollapsed) {
          buttonText = this.responsiveButtonTextClose || this.$t('Close Sidebar');
        }
      }

      return buttonText;
    },

    getSidebarClass() {
      const className = ['nebula-sidebar', {
        'nebula-sidebar--collapsed': this.sidebarCollapsed === true,
        'nebula-sidebar--show-responsive-button-text': this.responsiveCollapseActivated === true
      }];
      return className;
    },

    randomStringId() {
      return randomStringId();
    },

    responsiveCollapseActivated() {
      return this.windowSize <= this.responsiveThreshold;
    },

    sidebarEl() {
      return document.getElementById(this.sidebarId);
    },

    sidebarId() {
      let sidebarId = '';

      if (this.id) {
        sidebarId = this.id;
      } else {
        sidebarId = `nebula-sidebar--${this.randomStringId}`;
      }

      return sidebarId;
    },

    sidebarOpen() {
      return !this.sidebarCollapsed;
    }

  },
  methods: {
    getSidebarItemClass(item) {
      const className = ['nebula-sidebar__accordion-item', {
        'nebula-sidebar__accordion-item--current': item.active === true,
        'nebula-sidebar__accordion-item--hidden': item.hidden === true
      }];
      return className;
    },

    handleCollapse() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
      this.$emit('sidebar-collapsed', this.sidebarCollapsed);
    },

    setWindowSize() {
      this.windowSize = document.documentElement.clientWidth;
    }

  },
  watch: {
    responsiveCollapseActivated(newVal) {
      if (this.useResponsiveCollapseOnload) {
        if (newVal === true) {
          this.sidebarCollapsed = true;
        } else {
          this.sidebarCollapsed = false;
        }
      }
    },

    sidebarCollapsed(newVal) {
      if (newVal === true) {
        setTimeout(() => {
          this.sidebarEl.classList.add('nebula-sidebar__inner--removed');
        }, this.transitionSpeed);
      } else {
        this.sidebarEl.classList.remove('nebula-sidebar__inner--removed');
      }
    }

  },

  beforeUnmount() {
    if (this.useResponsiveCollapseOnload) {
      window.removeEventListener('resize', this.throttledHandleResize);
    }
  }

});
// CONCATENATED MODULE: ./src/components/Sidebar/NebulaSidebar.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Sidebar/NebulaSidebar.vue?vue&type=style&index=0&id=52285868&lang=stylus
var NebulaSidebarvue_type_style_index_0_id_52285868_lang_stylus = __webpack_require__("a6d9");

// CONCATENATED MODULE: ./src/components/Sidebar/NebulaSidebar.vue







const NebulaSidebar_exports_ = /*#__PURE__*/exportHelper_default()(NebulaSidebarvue_type_script_lang_js, [['render',NebulaSidebarvue_type_template_id_52285868_render]])

/* harmony default export */ var NebulaSidebar = (NebulaSidebar_exports_);
// EXTERNAL MODULE: ./src/assets/profile/default-profile-avatar.png
var default_profile_avatar = __webpack_require__("8694");
var default_profile_avatar_default = /*#__PURE__*/__webpack_require__.n(default_profile_avatar);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ProfilePanel/NebulaProfilePanel.vue?vue&type=template&id=cb4a839e


const NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_1 = ["id"];
const NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_2 = {
  class: "nebula-profile-panel__close-button"
};
const NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_3 = {
  class: "nebula-profile-panel__inner",
  ref: "profilePanelInner"
};
const NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_4 = {
  class: "nebula-profile-panel__avatar-container"
};
const NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_5 = ["src"];
const NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_6 = {
  class: "user-name"
};
const NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_7 = {
  key: 0,
  class: "nebula-profile-panel__multisite-container"
};
const NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_8 = {
  class: "nebula-profile-panel__multisite-header"
};
const NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_9 = {
  class: "nebula-profile-panel__multisite-school"
};
const NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_10 = {
  class: "nebula-profile-panel__actions"
};
const NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_11 = {
  class: "panel-action-item"
};
const NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_12 = {
  class: "panel-action-item"
};
const NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_13 = {
  key: 0,
  class: "panel-action-item"
};
const NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_14 = {
  class: "panel-action-item"
};
function NebulaProfilePanelvue_type_template_id_cb4a839e_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_FocusTrap = Object(external_vue_["resolveComponent"])("FocusTrap");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_FocusTrap, {
    active: $props.focusTrapEnabled && $data.focusTrapActive,
    escapeDeactivates: false,
    initialFocus: ".nebula-profile-panel__inner .nebula-button"
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("div", {
      class: Object(external_vue_["normalizeClass"])(["nebula-profile-panel", {
        'nebula-profile-panel--collapsed': $props.profilePanelCollapsed
      }]),
      id: $props.id
    }, [Object(external_vue_["createElementVNode"])("div", NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_2, [Object(external_vue_["renderSlot"])(_ctx.$slots, "profilePanelClose")]), Object(external_vue_["createElementVNode"])("div", NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_3, [Object(external_vue_["createElementVNode"])("div", {
      class: "nebula-profile-panel__info",
      style: Object(external_vue_["normalizeStyle"])({
        backgroundImage: `url(${$options.backgroundUrl})`
      })
    }, [Object(external_vue_["createElementVNode"])("div", NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_4, [$props.userAvatarUrl && $data.hasValidAvatar ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("img", {
      key: 0,
      class: Object(external_vue_["normalizeClass"])(["nebula-profile-panel__avatar", $data.avatarIsLoaded && 'nebula-profile-panel__avatar--loaded']),
      src: $props.userAvatarUrl,
      onLoad: _cache[0] || (_cache[0] = (...args) => $options.onAvatarLoaded && $options.onAvatarLoaded(...args)),
      onError: _cache[1] || (_cache[1] = (...args) => $options.onImageLoadError && $options.onImageLoadError(...args)),
      alt: ""
    }, null, 42, NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_5)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("img", {
      key: 1,
      class: Object(external_vue_["normalizeClass"])(["nebula-profile-panel__avatar", $data.avatarIsLoaded && 'nebula-profile-panel__avatar--loaded']),
      src: default_profile_avatar_default.a,
      onLoad: _cache[2] || (_cache[2] = (...args) => $options.onAvatarLoaded && $options.onAvatarLoaded(...args)),
      alt: ""
    }, null, 34))]), Object(external_vue_["createElementVNode"])("p", NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_6, Object(external_vue_["toDisplayString"])($props.userFullName), 1)], 4), $props.multisite && $props.multisite.school ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_7, [Object(external_vue_["createElementVNode"])("h3", NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_8, Object(external_vue_["toDisplayString"])(_ctx.$t("Current School")), 1), Object(external_vue_["createElementVNode"])("p", NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_9, Object(external_vue_["toDisplayString"])($props.multisite.school), 1), Object(external_vue_["createVNode"])(_component_NebulaButton, {
      class: "nebula-profile-panel__multisite-button",
      size: "s",
      link: $props.multisite.link,
      text: _ctx.$t('Switch School'),
      "data-click-name": "Switch School",
      "data-click-type": "Profile & Favorites Navigation"
    }, null, 8, ["link", "text"])])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("ul", NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_10, [Object(external_vue_["createElementVNode"])("li", NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_11, [$props.userHasProfileLink ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
      key: 0,
      link: `${$props.learnUrl}/profile/personalization`,
      text: _ctx.$t('View Profile'),
      iconLeft: "user",
      size: "m",
      type: "flat",
      "data-click-name": "View Profile",
      "data-click-type": "Profile & Favorites Navigation"
    }, null, 8, ["link", "text"])) : Object(external_vue_["createCommentVNode"])("", true)]), Object(external_vue_["createElementVNode"])("li", NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_12, [$props.userCanCreateTeamsMeeting ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
      key: 0,
      link: $props.createTeamsMeetingLink,
      text: _ctx.$t('Create Teams Meeting'),
      iconLeft: "users",
      size: "m",
      type: "flat",
      "data-click-name": "Create Teams Meetings",
      "data-click-type": "Profile & Favorites Navigation"
    }, null, 8, ["link", "text"])) : Object(external_vue_["createCommentVNode"])("", true)]), !$options.isIFrame ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_13, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      text: _ctx.$t('Sign Out'),
      iconLeft: "log-out",
      link: `${$props.learnUrl}/logout`,
      size: "m",
      type: "flat",
      "data-click-name": "Sign Out",
      "data-click-type": "Profile & Favorites Navigation"
    }, null, 8, ["text", "link"])])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("li", NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_14, [$props.isUserImpersonating ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
      key: 0,
      text: _ctx.$t('Quit Impersonation'),
      class: "nebula-profile-panel__quit-impersonate",
      iconLeft: "users",
      size: "m",
      link: $options.unimpersonateUrl,
      target: $options.unimpersonateTarget,
      rel: $options.unimpersonateRel
    }, null, 8, ["text", "link", "target", "rel"])) : Object(external_vue_["createCommentVNode"])("", true)])])], 512), Object(external_vue_["createElementVNode"])("div", {
      class: "nebula-profile-panel__quicklist-slot",
      style: Object(external_vue_["normalizeStyle"])({
        maxHeight: `calc(100% - ${$data.profilePanelInnerHeight}px)`
      })
    }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "quickListSlot")], 4)], 10, NebulaProfilePanelvue_type_template_id_cb4a839e_hoisted_1)]),
    _: 3
  }, 8, ["active"]);
}
// CONCATENATED MODULE: ./src/components/ProfilePanel/NebulaProfilePanel.vue?vue&type=template&id=cb4a839e

// EXTERNAL MODULE: ./src/assets/profile/profile-background-user.png
var profile_background_user = __webpack_require__("c72f");
var profile_background_user_default = /*#__PURE__*/__webpack_require__.n(profile_background_user);

// EXTERNAL MODULE: ./src/assets/profile/profile-background-impersonate.png
var profile_background_impersonate = __webpack_require__("c8f2");
var profile_background_impersonate_default = /*#__PURE__*/__webpack_require__.n(profile_background_impersonate);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ProfilePanel/NebulaProfilePanel.vue?vue&type=script&lang=js





/* harmony default export */ var NebulaProfilePanelvue_type_script_lang_js = ({
  name: 'NebulaProfilePanel',
  components: {
    FocusTrap: FocusTrap,
    NebulaButton: NebulaButton
  },

  data() {
    return {
      avatarIsLoaded: false,
      focusTrapActive: false,
      hasValidAvatar: true,
      profilePanelInnerHeight: 0
    };
  },

  props: {
    createTeamsMeetingLink: String,
    focusTrapEnabled: Boolean,
    id: {
      type: String,
      default: 'nebula-profile-panel'
    },
    isUserImpersonating: Boolean,
    learnUrl: {
      type: String,
      default: '/learn'
    },
    multisite: Object,
    profilePanelCollapsed: Boolean,
    userAvatarUrl: String,
    userBackgroundUrl: String,
    userCanCreateTeamsMeeting: Boolean,
    userFullName: String,
    userHasProfileLink: Boolean,
    quitImpersonateUrl: String
  },
  computed: {
    backgroundUrl() {
      if (this.userBackgroundUrl) return this.userBackgroundUrl;
      return this.isUserImpersonating ? profile_background_impersonate_default.a : profile_background_user_default.a;
    },

    unimpersonateUrl() {
      if (window.location !== window.parent.location) {
        return this.quitImpersonateUrl.concat('?embedded=True');
      }

      return this.quitImpersonateUrl;
    },

    unimpersonateRel() {
      return window.location !== window.parent.location ? 'opener' : false;
    },

    unimpersonateTarget() {
      return window.location !== window.parent.location ? '_blank' : false;
    },

    isIFrame() {
      return window.self !== window.top;
    }

  },

  mounted() {
    this.profilePanelObserver = new ResizeObserver_es["a" /* default */](this.updateProfilePanelInnerHeight);
    this.profilePanelObserver.observe(this.$refs.profilePanelInner);
    this.updateProfilePanelInnerHeight();

    if (window.location !== window.parent.location) {
      window.addEventListener('message', this.receiveMessage, false);
    }
  },

  beforeUnmount() {
    if (this.profilePanelObserver) {
      this.profilePanelObserver.unobserve(this.$refs.profilePanelInner);
      this.profilePanelObserver = null;
    }

    if (window.location !== window.parent.location) {
      window.removeEventListener('message', this.receiveMessage, false);
    }
  },

  methods: {
    onAvatarLoaded() {
      this.avatarIsLoaded = true;
    },

    onImageLoadError() {
      this.hasValidAvatar = false;
    },

    updateProfilePanelInnerHeight() {
      // To allow the QuickList to scroll properly, it's set to 100% minus
      // the height of the profile panel inner contents
      this.profilePanelInnerHeight = this.$refs.profilePanelInner.offsetHeight;
    },

    receiveMessage(event) {
      if (event.data && typeof event.data === 'string' && event.origin === window.paths.app) {
        const message = JSON.parse(event.data);

        if (message.type === 'unimpersonate' && message.next) {
          setTimeout(() => {
            document.location.href = message.next;
          }, 2000);
        }
      }
    }

  },
  watch: {
    profilePanelCollapsed(isCollapsed) {
      // Set timeout used to ensure the panel is visible
      // before triggering the focus trap, otherwise focus-trap doesn't
      // detect any tabbable elements and throws an error.
      setTimeout(() => {
        this.focusTrapActive = !isCollapsed;
      }, 100);
    },

    userAvatarUrl() {
      // If the avatar changes, reset this so it can be loaded again
      this.hasValidAvatar = true;
    }

  }
});
// CONCATENATED MODULE: ./src/components/ProfilePanel/NebulaProfilePanel.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/ProfilePanel/NebulaProfilePanel.vue?vue&type=style&index=0&id=cb4a839e&lang=stylus
var NebulaProfilePanelvue_type_style_index_0_id_cb4a839e_lang_stylus = __webpack_require__("4eaf");

// CONCATENATED MODULE: ./src/components/ProfilePanel/NebulaProfilePanel.vue







const NebulaProfilePanel_exports_ = /*#__PURE__*/exportHelper_default()(NebulaProfilePanelvue_type_script_lang_js, [['render',NebulaProfilePanelvue_type_template_id_cb4a839e_render]])

/* harmony default export */ var NebulaProfilePanel = (NebulaProfilePanel_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/PageShell/NebulaPageShell.vue?vue&type=script&lang=js








/* harmony default export */ var NebulaPageShellvue_type_script_lang_js = ({
  name: 'NebulaPageShell',
  components: {
    MultiLevelNav: MultiLevelNav,
    NebulaProductBar: NebulaProductBar,
    NebulaGlobalNav: NebulaGlobalNav,
    NebulaSidebar: NebulaSidebar,
    NebulaProfilePanel: NebulaProfilePanel,
    NebulaButton: NebulaButton,
    NebulaTitleTooltip: NebulaTitleTooltip,
    NebulaActionBar: NebulaActionBar
  },
  props: {
    embed: {
      type: Boolean,
      default: false
    },
    homeLink: {
      type: String,
      default: null
    },
    homeLinkComponent: {
      type: String,
      default: null
    },
    globalNavData: {
      type: Object
    },
    globalNavId: {
      type: String,
      default: 'nebula-global-nav'
    },
    currentSite: {
      type: Object,

      default() {
        return {};
      }

    },
    actionBarData: {
      type: Object,
      default: null
    },
    sidebarData: {
      type: Array,
      default: null
    },
    navContext: {
      type: Object,
      default: () => {}
    },
    productBarData: {
      type: Object,

      default() {
        return {};
      }

    },
    profilePanelData: {
      type: Object
    },
    profilePanelId: {
      type: String,
      default: 'nebula-profile-panel'
    },
    quickListTotalCount: {
      type: Number,

      default() {
        return 0;
      }

    },
    showQuickListToggle: {
      type: Boolean
    },
    showSearchBox: {
      type: Boolean,
      default: true
    },
    switchSiteUrl: {
      type: String,
      default: null
    },
    hideDesktopSearch: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle-global-nav'],

  data() {
    return {
      globalNavOpen: false,
      profilePanelOpen: false,
      // default set to current hardcoded value from NebulaActionBar,
      // resilient to change by measuring once mounted
      actionBarHeight: 56
    };
  },

  mounted() {
    const actionBar = document.querySelector('.nebula-page-shell__action-bar-wrapper'); // if actionBar is present, make the adjustment based on its rendered height

    if (actionBar) {
      this.actionBarHeight = `${actionBar.clientHeight}px`;
    } else {
      this.actionBarHeight = 0;
    }
  },

  computed: {
    styleVars() {
      return {
        '--actionBarHeight': this.actionBarHeight
      };
    },

    hasActionBar() {
      return Boolean(this.actionBarData || this.$slots.actionBar);
    },

    pageShellClass() {
      const className = ['nebula-page-shell', {
        // Firefox support uses this parent-level class to apply blur
        'nebula-page-shell--overlaid': this.globalNavOpen || this.profilePanelOpen,
        'nebula-page-shell--embed': this.embed
      }];
      return className;
    },

    parsedMultisite() {
      if (this.currentSite && this.currentSite.name) {
        return {
          school: this.currentSite.name,
          link: this.switchSiteUrl
        };
      }

      return {};
    }

  },
  methods: {
    toggleGlobalNav() {
      // Emit an event in case the parent app needs to load waffle data
      this.$emit('toggle-global-nav');

      if (!this.globalNavOpen && !this.navContext) {
        this.$refs.globalNav.focusOnOpen();
      }

      this.globalNavOpen = !this.globalNavOpen; // Prevents scrolling when global nav panel is open

      document.body.style.overflow = this.globalNavOpen ? 'hidden' : 'unset';
    },

    toggleProfilePanel() {
      this.profilePanelOpen = !this.profilePanelOpen; // Prevents scrolling when profile panel is open

      document.body.style.overflow = this.profilePanelOpen ? 'hidden' : 'unset';
    },

    handleItemClick() {
      return null;
    }

  }
});
// CONCATENATED MODULE: ./src/components/PageShell/NebulaPageShell.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/PageShell/NebulaPageShell.vue?vue&type=style&index=0&id=3a162186&lang=stylus
var NebulaPageShellvue_type_style_index_0_id_3a162186_lang_stylus = __webpack_require__("d797");

// CONCATENATED MODULE: ./src/components/PageShell/NebulaPageShell.vue







const NebulaPageShell_exports_ = /*#__PURE__*/exportHelper_default()(NebulaPageShellvue_type_script_lang_js, [['render',NebulaPageShellvue_type_template_id_3a162186_render]])

/* harmony default export */ var NebulaPageShell = (NebulaPageShell_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Pagination/NebulaPagination.vue?vue&type=template&id=dedeedfa

const NebulaPaginationvue_type_template_id_dedeedfa_hoisted_1 = ["aria-label"];
const NebulaPaginationvue_type_template_id_dedeedfa_hoisted_2 = {
  key: 0,
  class: "nebula-dropdown-pagination",
  ref: "paginationRef"
};
const NebulaPaginationvue_type_template_id_dedeedfa_hoisted_3 = {
  class: "nebula-dropdown-pagination__item"
};
const NebulaPaginationvue_type_template_id_dedeedfa_hoisted_4 = {
  class: "nebula-dropdown-pagination__item"
};
const NebulaPaginationvue_type_template_id_dedeedfa_hoisted_5 = {
  class: "nebula-dropdown-pagination__item"
};
const NebulaPaginationvue_type_template_id_dedeedfa_hoisted_6 = {
  class: "nebula-pagination__item"
};
const NebulaPaginationvue_type_template_id_dedeedfa_hoisted_7 = {
  class: "nebula-pagination__item"
};
function NebulaPaginationvue_type_template_id_dedeedfa_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaPaginationButtonItem = Object(external_vue_["resolveComponent"])("NebulaPaginationButtonItem");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaDropdownItem = Object(external_vue_["resolveComponent"])("NebulaDropdownItem");

  const _component_NebulaDropdown = Object(external_vue_["resolveComponent"])("NebulaDropdown");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [Object(external_vue_["createElementVNode"])("nav", {
    "aria-label": $options.getPaginationAriaLabel
  }, [$props.dropdownView || $data.showResponsiveDropdownView ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("ul", NebulaPaginationvue_type_template_id_dedeedfa_hoisted_2, [Object(external_vue_["createElementVNode"])("li", NebulaPaginationvue_type_template_id_dedeedfa_hoisted_3, [Object(external_vue_["createVNode"])(_component_NebulaPaginationButtonItem, {
    pageLabel: "Back",
    onClick: _cache[0] || (_cache[0] = $event => $options.onClickPage($event, $options.currentPage - 1)),
    link: $props.linkGenerator.getPrevPageLink(),
    usePushState: $options.usePushState,
    isDisabled: $props.linkGenerator.isFirstPage,
    type: "flat",
    shape: "pill",
    size: "s"
  }, null, 8, ["link", "usePushState", "isDisabled"])]), Object(external_vue_["createElementVNode"])("li", NebulaPaginationvue_type_template_id_dedeedfa_hoisted_4, [Object(external_vue_["createVNode"])(_component_NebulaDropdown, {
    buttonId: $options.getDropdownButtonId,
    dropdownId: $options.getDropdownMenuId
  }, {
    trigger: Object(external_vue_["withCtx"])(({
      toggleDropdown,
      checkArrowKeyOnTrigger,
      checkArrowKeyAfterTrigger,
      isOpen
    }) => [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      id: $options.getDropdownButtonId,
      "aria-expanded": isOpen && 'true' || 'false',
      "aria-haspopup": "true",
      "aria-controls": $options.getDropdownMenuId,
      text: _ctx.$t($options.pageRangeText($options.currentPage, $options.totalPages)),
      iconRight: "caret-down",
      type: "flat",
      size: "s",
      onClick: toggleDropdown,
      onKeydown: checkArrowKeyOnTrigger,
      onKeyup: checkArrowKeyAfterTrigger
    }, null, 8, ["id", "aria-expanded", "aria-controls", "text", "onClick", "onKeydown", "onKeyup"])]),
    content: Object(external_vue_["withCtx"])(() => [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.range(1, $options.totalPages + 1), i => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        class: "nebula-dropdown-pagination__item",
        key: i
      }, [Object(external_vue_["createVNode"])(_component_NebulaDropdownItem, {
        link: $props.linkGenerator.getPageLink(i),
        text: _ctx.$t($options.pageText(i)),
        onClick: $event => $options.onClickPage($event, i)
      }, null, 8, ["link", "text", "onClick"])]);
    }), 128))]),
    _: 1
  }, 8, ["buttonId", "dropdownId"])]), Object(external_vue_["createElementVNode"])("li", NebulaPaginationvue_type_template_id_dedeedfa_hoisted_5, [Object(external_vue_["createVNode"])(_component_NebulaPaginationButtonItem, {
    pageLabel: "Next",
    onClick: _cache[1] || (_cache[1] = $event => $options.onClickPage($event, $options.currentPage + 1)),
    link: $props.linkGenerator.getNextPageLink(),
    isDisabled: $props.linkGenerator.isLastPage,
    usePushState: $options.usePushState,
    type: "flat",
    shape: "pill",
    size: "s"
  }, null, 8, ["link", "isDisabled", "usePushState"])])], 512)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("ul", {
    key: 1,
    class: Object(external_vue_["normalizeClass"])(["nebula-pagination", {
      'nebula-pagination--arrows-only': $data.responsiveView
    }]),
    ref: "paginationRef"
  }, [Object(external_vue_["createElementVNode"])("li", {
    class: Object(external_vue_["normalizeClass"])(["nebula-pagination__item nebula-pagination__item--back", $options.itemClass])
  }, [Object(external_vue_["createVNode"])(_component_NebulaPaginationButtonItem, {
    pageLabel: "Back",
    onClick: _cache[2] || (_cache[2] = $event => $options.onClickPage($event, $options.currentPage - 1)),
    link: $props.linkGenerator.getPrevPageLink(),
    usePushState: $options.usePushState,
    isDisabled: $props.linkGenerator.isFirstPage,
    routerLink: $options.routerLink,
    size: $options.buttonSize
  }, null, 8, ["link", "usePushState", "isDisabled", "routerLink", "size"])], 2), Object(external_vue_["createElementVNode"])("li", {
    class: Object(external_vue_["normalizeClass"])(["nebula-pagination__item", $options.itemClass])
  }, [Object(external_vue_["createVNode"])(_component_NebulaPaginationButtonItem, {
    pageLabel: "1",
    isCurrentPage: $props.linkGenerator.isFirstPage,
    onClick: _cache[3] || (_cache[3] = $event => $options.onClickPage($event, 1)),
    link: $props.linkGenerator.getPageLink(1),
    usePushState: $options.usePushState,
    routerLink: $options.routerLink,
    size: $options.buttonSize
  }, null, 8, ["isCurrentPage", "link", "usePushState", "routerLink", "size"])], 2), $options.totalPages <= 6 ? (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
    key: 0
  }, Object(external_vue_["renderList"])($options.range(2, $options.totalPages), i => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
      class: Object(external_vue_["normalizeClass"])(["nebula-pagination__item", $options.itemClass]),
      key: i
    }, [Object(external_vue_["createVNode"])(_component_NebulaPaginationButtonItem, {
      pageLabel: i,
      isCurrentPage: $options.currentPage === i,
      onClick: $event => $options.onClickPage($event, i),
      link: $props.linkGenerator.getPageLink(i),
      usePushState: $options.usePushState,
      routerLink: $options.routerLink,
      size: $options.buttonSize
    }, null, 8, ["pageLabel", "isCurrentPage", "onClick", "link", "usePushState", "routerLink", "size"])], 2);
  }), 128)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
    key: 1
  }, [$options.currentPage <= 3 ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
    key: 0
  }, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.range(2, 6), i => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
      class: Object(external_vue_["normalizeClass"])(["nebula-pagination__item", $options.itemClass]),
      key: i
    }, [Object(external_vue_["createVNode"])(_component_NebulaPaginationButtonItem, {
      isCurrentPage: $options.currentPage === i,
      pageLabel: i,
      onClick: $event => $options.onClickPage($event, i),
      link: $props.linkGenerator.getPageLink(i),
      usePushState: $options.usePushState,
      routerLink: $options.routerLink,
      size: $options.buttonSize
    }, null, 8, ["isCurrentPage", "pageLabel", "onClick", "link", "usePushState", "routerLink", "size"])], 2);
  }), 128)), Object(external_vue_["createElementVNode"])("li", NebulaPaginationvue_type_template_id_dedeedfa_hoisted_6, [Object(external_vue_["createVNode"])(_component_NebulaPaginationButtonItem, {
    pageLabel: "Ellipsis"
  })])], 64)) : $options.currentPage >= 4 && $options.currentPage < $options.totalPages - 4 ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
    key: 1
  }, [Object(external_vue_["createElementVNode"])("li", {
    class: Object(external_vue_["normalizeClass"])(["nebula-pagination__item", $options.itemClass])
  }, [Object(external_vue_["createVNode"])(_component_NebulaPaginationButtonItem, {
    pageLabel: "Ellipsis"
  })], 2), (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.range($options.currentPage - 1, $options.currentPage + 3), i => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
      class: Object(external_vue_["normalizeClass"])(["nebula-pagination__item", $options.itemClass]),
      key: i
    }, [Object(external_vue_["createVNode"])(_component_NebulaPaginationButtonItem, {
      isCurrentPage: $options.currentPage === i,
      pageLabel: i,
      onClick: $event => $options.onClickPage($event, i),
      link: $props.linkGenerator.getPageLink(i),
      usePushState: $options.usePushState,
      routerLink: $options.routerLink,
      size: $options.buttonSize
    }, null, 8, ["isCurrentPage", "pageLabel", "onClick", "link", "usePushState", "routerLink", "size"])], 2);
  }), 128)), Object(external_vue_["createElementVNode"])("li", NebulaPaginationvue_type_template_id_dedeedfa_hoisted_7, [Object(external_vue_["createVNode"])(_component_NebulaPaginationButtonItem, {
    pageLabel: "Ellipsis"
  })])], 64)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
    key: 2
  }, [Object(external_vue_["createElementVNode"])("li", {
    class: Object(external_vue_["normalizeClass"])(["nebula-pagination__item", $options.itemClass])
  }, [Object(external_vue_["createVNode"])(_component_NebulaPaginationButtonItem, {
    pageLabel: "Ellipsis"
  })], 2), (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.range($options.totalPages - 4, $options.totalPages), i => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
      class: Object(external_vue_["normalizeClass"])(["nebula-pagination__item", $options.itemClass]),
      key: i
    }, [Object(external_vue_["createVNode"])(_component_NebulaPaginationButtonItem, {
      isCurrentPage: $options.currentPage === i,
      pageLabel: i,
      onClick: $event => $options.onClickPage($event, i),
      link: $props.linkGenerator.getPageLink(i),
      usePushState: $options.usePushState,
      routerLink: $options.routerLink,
      size: $options.buttonSize
    }, null, 8, ["isCurrentPage", "pageLabel", "onClick", "link", "usePushState", "routerLink", "size"])], 2);
  }), 128))], 64))], 64)), $options.totalPages > 1 ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
    key: 2,
    class: Object(external_vue_["normalizeClass"])(["nebula-pagination__item", $options.itemClass])
  }, [Object(external_vue_["createVNode"])(_component_NebulaPaginationButtonItem, {
    pageLabel: $options.totalPages,
    isCurrentPage: $options.currentPage === $options.totalPages,
    onClick: _cache[4] || (_cache[4] = $event => $options.onClickPage($event, $options.totalPages)),
    link: $props.linkGenerator.getPageLink($options.totalPages),
    usePushState: $options.usePushState,
    routerLink: $options.routerLink,
    size: $options.buttonSize
  }, null, 8, ["pageLabel", "isCurrentPage", "link", "usePushState", "routerLink", "size"])], 2)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("li", {
    class: Object(external_vue_["normalizeClass"])(["nebula-pagination__item nebula-pagination__item--next", $options.itemClass])
  }, [Object(external_vue_["createVNode"])(_component_NebulaPaginationButtonItem, {
    pageLabel: "Next",
    onClick: _cache[5] || (_cache[5] = $event => $options.onClickPage($event, $options.currentPage + 1)),
    link: $props.linkGenerator.getNextPageLink(),
    isDisabled: $props.linkGenerator.isLastPage,
    usePushState: $options.usePushState,
    routerLink: $options.routerLink,
    size: $options.buttonSize
  }, null, 8, ["link", "isDisabled", "usePushState", "routerLink", "size"])], 2)], 2))], 8, NebulaPaginationvue_type_template_id_dedeedfa_hoisted_1)], 4);
}
// CONCATENATED MODULE: ./src/components/Pagination/NebulaPagination.vue?vue&type=template&id=dedeedfa

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Pagination/NebulaPagination.vue?vue&type=script&lang=js








/* harmony default export */ var NebulaPaginationvue_type_script_lang_js = ({
  name: 'NebulaPagination',
  components: {
    NebulaButton: NebulaButton,
    NebulaPaginationButtonItem: NebulaPaginationButtonItem,
    NebulaDropdown: NebulaDropdown,
    NebulaDropdownItem: NebulaDropdownItem
  },
  mixins: [themingUtils],

  data() {
    return {
      lastContainerWidth: -1,
      maxPaginationHeight: 0,
      maxPaginationWidth: 0,
      resizeObserver: null,
      responsiveView: false,
      showResponsiveDropdownView: false
    };
  },

  props: {
    buttonMarginBlock: {
      type: Number,
      default: 16
    },
    buttonMarginInline: {
      type: Number,
      default: 16
    },
    compact: {
      type: Boolean,
      default: false
    },
    dropdownView: {
      type: Boolean,
      default: false
    },
    linkGenerator: {
      type: [base, Object]
    },
    paginationAriaLabel: {
      type: String
    },
    responsiveDropdownView: {
      type: Boolean,
      default: false
    }
  },
  emits: ['selectPage'],
  computed: {
    buttonSize() {
      return this.compact ? 's' : 'm';
    },

    currentPage() {
      return this.linkGenerator.currentPageNumber;
    },

    getDropdownButtonId() {
      return `nebula-dropdown-pagination__button--${this.randomStringId}`;
    },

    getDropdownMenuId() {
      return `nebula-dropdown-pagination__menu--${this.randomStringId}`;
    },

    getPaginationAriaLabel() {
      return this.paginationAriaLabel ? this.paginationAriaLabel : this.$t('Pagination');
    },

    itemClass() {
      return this.compact ? 'nebula-pagination__item--compact' : null;
    },

    randomStringId() {
      return randomStringId();
    },

    routerLink() {
      return this.linkGenerator.useRouterLink;
    },

    totalPages() {
      return this.linkGenerator.numberOfPages;
    },

    usePushState() {
      return this.linkGenerator.usePushState;
    }

  },
  methods: {
    async calculateWidths() {
      const {
        children
      } = this.$refs.paginationRef;

      for (let i = 0; i < children.length; i += 1) {
        this.maxPaginationWidth += children[i].clientWidth + this.buttonMarginInline;
      }

      this.maxPaginationHeight = children[0].firstChild.clientHeight + this.buttonMarginBlock;
    },

    determineView(newHeight, newWidth) {
      const containerWidth = newWidth || this.$refs.paginationRef.clientWidth || 0;
      let increasing = true;

      if (containerWidth <= this.lastContainerWidth) {
        increasing = false;
      }

      if (increasing) {
        if (this.maxPaginationWidth < newWidth) {
          if (this.responsiveDropdownView) {
            this.showResponsiveDropdownView = false;
          } else {
            this.responsiveView = false;
          }
        }
      } else if (this.maxPaginationHeight < newHeight) {
        if (this.responsiveDropdownView) {
          this.showResponsiveDropdownView = true;
        } else {
          this.responsiveView = true;
        }
      }

      this.lastContainerWidth = containerWidth;
    },

    range(start, end) {
      // Return an array from start to end, similar to Jinja's range()
      // The start is included; end is not
      const pageRange = [];

      for (let i = start; i < end; i += 1) {
        pageRange.push(i);
      }

      return pageRange;
    },

    onClickPage(e, page) {
      if (e.target.getAttribute('aria-disabled') === 'true') {
        return;
      }

      this.$emit('selectPage', page);
    },

    pageText(page) {
      return `Page ${page}`;
    },

    pageRangeText(current, total) {
      return `${current} of ${total}`;
    },

    selectNextPage(page) {
      this.currentPage = page - 1;
    }

  },

  mounted() {
    if (!this.dropdownView) {
      this.paginationResizeListener = lodash_es_throttle(this.determineView.bind(this), 100, {
        trailing: true
      });
      this.resizeObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
          if (entry.contentBoxSize) {
            this.paginationResizeListener(entry.contentBoxSize[0].blockSize, entry.contentBoxSize[0].inlineSize);
          } else {
            this.paginationResizeListener(entry.contentRect.height, entry.contentRect.width);
          }
        });
      });
      this.resizeObserver.observe(this.$refs.paginationRef);
      this.calculateWidths().then(() => this.determineView());
    }
  },

  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

});
// CONCATENATED MODULE: ./src/components/Pagination/NebulaPagination.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Pagination/NebulaPagination.vue?vue&type=style&index=0&id=dedeedfa&lang=stylus
var NebulaPaginationvue_type_style_index_0_id_dedeedfa_lang_stylus = __webpack_require__("adb8");

// CONCATENATED MODULE: ./src/components/Pagination/NebulaPagination.vue







const NebulaPagination_exports_ = /*#__PURE__*/exportHelper_default()(NebulaPaginationvue_type_script_lang_js, [['render',NebulaPaginationvue_type_template_id_dedeedfa_render]])

/* harmony default export */ var NebulaPagination = (NebulaPagination_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Panel/NebulaPanel.vue?vue&type=template&id=8204a2ba

const NebulaPanelvue_type_template_id_8204a2ba_hoisted_1 = {
  key: 0
};
const NebulaPanelvue_type_template_id_8204a2ba_hoisted_2 = {
  class: "nebula-panel__top"
};
const NebulaPanelvue_type_template_id_8204a2ba_hoisted_3 = {
  class: "nebula-panel__header"
};
const NebulaPanelvue_type_template_id_8204a2ba_hoisted_4 = {
  class: "nebula-panel__bottom"
};
const NebulaPanelvue_type_template_id_8204a2ba_hoisted_5 = {
  key: 1
};
const NebulaPanelvue_type_template_id_8204a2ba_hoisted_6 = {
  key: 0,
  class: "nebula-panel__top"
};
const NebulaPanelvue_type_template_id_8204a2ba_hoisted_7 = {
  class: "nebula-panel__header"
};
const NebulaPanelvue_type_template_id_8204a2ba_hoisted_8 = {
  key: 0,
  class: "nebula-panel__bottom"
};
function NebulaPanelvue_type_template_id_8204a2ba_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_FocusTrap = Object(external_vue_["resolveComponent"])("FocusTrap");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_FocusTrap, {
    active: $options.focusTrapActive,
    clickOutsideDeactivates: true,
    escapeDeactivates: true,
    initialFocus: $options.getInitialFocus,
    ref: "PanelFocusTrap"
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("div", {
      class: Object(external_vue_["normalizeClass"])($options.viewClass),
      style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
    }, [Object(external_vue_["createVNode"])(external_vue_["Transition"], {
      name: "nebula-panel-overlay-transition"
    }, {
      default: Object(external_vue_["withCtx"])(() => [$options.useOverlay && $props.isOpen ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        key: 0,
        class: "nebula-panel__overlay",
        onClick: _cache[0] || (_cache[0] = (...args) => $options.handleClose && $options.handleClose(...args))
      })) : Object(external_vue_["createCommentVNode"])("", true)]),
      _: 1
    }), $options.useOverlay ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaPanelvue_type_template_id_8204a2ba_hoisted_1, [(Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.panelElement), {
      class: Object(external_vue_["normalizeClass"])($options.stateClass),
      "aria-expanded": $props.isOpen ? 'true' : 'false',
      "aria-label": $options.getAriaLabel,
      "aria-modal": "true",
      id: $props.panelId,
      ref: "panel",
      role: "dialog",
      tabindex: $props.isOpen ? 0 : undefined,
      onKeydown: $options.handleKeydown
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(external_vue_["Transition"], {
        name: "nebula-panel-overlay-transition"
      }, {
        default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("div", NebulaPanelvue_type_template_id_8204a2ba_hoisted_2, [Object(external_vue_["createElementVNode"])("div", NebulaPanelvue_type_template_id_8204a2ba_hoisted_3, [Object(external_vue_["renderSlot"])(_ctx.$slots, "panelHeader")]), Object(external_vue_["createVNode"])(_component_NebulaButton, {
          "aria-label": "$t('close panel')",
          class: "nebula-panel__close",
          iconLeft: "x",
          size: "s",
          type: "flat",
          onClick: $options.handleClose
        }, null, 8, ["onClick"])])]),
        _: 3
      }), Object(external_vue_["createVNode"])(external_vue_["Transition"], {
        name: "nebula-panel-overlay-transition"
      }, {
        default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("div", NebulaPanelvue_type_template_id_8204a2ba_hoisted_4, [Object(external_vue_["renderSlot"])(_ctx.$slots, "panelContent")])]),
        _: 3
      })]),
      _: 3
    }, 40, ["class", "aria-expanded", "aria-label", "id", "tabindex", "onKeydown"]))])) : !$options.useOverlay ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaPanelvue_type_template_id_8204a2ba_hoisted_5, [(Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($props.panelElement), {
      class: Object(external_vue_["normalizeClass"])($options.stateClass),
      "aria-expanded": $props.isOpen ? 'true' : 'false',
      "aria-label": $options.getAriaLabel,
      "aria-modal": "true",
      id: $props.panelId,
      ref: "panel",
      role: "dialog",
      tabindex: $props.isOpen ? 0 : undefined,
      onKeydown: $options.handleKeydown
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(external_vue_["Transition"], {
        name: "nebula-panel-content-transition"
      }, {
        default: Object(external_vue_["withCtx"])(() => [$data.isVisible ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaPanelvue_type_template_id_8204a2ba_hoisted_6, [Object(external_vue_["createElementVNode"])("div", NebulaPanelvue_type_template_id_8204a2ba_hoisted_7, [Object(external_vue_["renderSlot"])(_ctx.$slots, "panelHeader")]), Object(external_vue_["createVNode"])(_component_NebulaButton, {
          "aria-label": "$t('close panel')",
          class: "nebula-panel__close",
          iconLeft: "x",
          size: "s",
          type: "flat",
          onClick: $options.handleClose
        }, null, 8, ["onClick"])])) : Object(external_vue_["createCommentVNode"])("", true)]),
        _: 3
      }), Object(external_vue_["createVNode"])(external_vue_["Transition"], {
        name: "nebula-panel-content-transition"
      }, {
        default: Object(external_vue_["withCtx"])(() => [$data.isVisible ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaPanelvue_type_template_id_8204a2ba_hoisted_8, [Object(external_vue_["renderSlot"])(_ctx.$slots, "panelContent")])) : Object(external_vue_["createCommentVNode"])("", true)]),
        _: 3
      })]),
      _: 3
    }, 40, ["class", "aria-expanded", "aria-label", "id", "tabindex", "onKeydown"]))])) : Object(external_vue_["createCommentVNode"])("", true)], 6)]),
    _: 3
  }, 8, ["active", "initialFocus"]);
}
// CONCATENATED MODULE: ./src/components/Panel/NebulaPanel.vue?vue&type=template&id=8204a2ba

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Panel/NebulaPanel.vue?vue&type=script&lang=js




/* harmony default export */ var NebulaPanelvue_type_script_lang_js = ({
  name: 'NebulaPanel',
  components: {
    FocusTrap: FocusTrap,
    NebulaButton: NebulaButton
  },
  mixins: [themingUtils],

  data() {
    return {
      isVisible: false,
      windowSize: null
    };
  },

  props: {
    alwaysUseOverlay: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: null
    },
    displayOnRight: {
      type: Boolean,
      default: false
    },
    firstFocusId: {
      type: String,
      default: null
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    mobileThreshold: {
      type: Number,
      default: 1024
    },
    panelElement: {
      type: String,
      default: 'section',
      enum: ['section', 'div', 'nav', 'form']
    },
    panelId: {
      type: String,
      default: 'nebula-panel'
    }
  },
  emits: ['toggle-panel'],
  methods: {
    determineFocusedElement() {
      const focusable = this.getFocusableElements();

      if (focusable.length) {
        if (focusable.length > 1 && focusable[0].classList.contains('nebula-panel__close')) {
          return focusable[1];
        }

        return focusable[0];
      }

      return this.$refs.panel;
    },

    getFocusableElements() {
      const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
      return this.$refs.panel.querySelectorAll(focusableSelector);
    },

    getInitialFocus() {
      let firstFocused = null;

      if (this.firstFocusId) {
        firstFocused = document.getElementById(this.firstFocusId);
      } else {
        firstFocused = this.determineFocusedElement();
      }

      return firstFocused;
    },

    handleClose() {
      this.$emit('toggle-panel', false);
    },

    handleKeydown(e) {
      if (e.code === 'Escape') {
        this.handleClose();
      }
    },

    setWindowSize() {
      this.windowSize = document.documentElement.clientWidth;
    }

  },
  computed: {
    focusTrapActive() {
      // isVisible state must be truthy (bound to transition timing on panel)
      return this.isVisible;
    },

    getAriaLabel() {
      return this.ariaLabel ? this.ariaLabel : this.$t('Panel');
    },

    useOverlay() {
      let useOverlay = false;

      if (this.alwaysUseOverlay) {
        useOverlay = true;
      } else if (this.windowSize <= this.mobileThreshold) {
        useOverlay = true;
      }

      return useOverlay;
    },

    stateClass() {
      return ['nebula-panel', {
        'nebula-panel--open': this.isOpen
      }];
    },

    viewClass() {
      return ['nebula-panel__outer', {
        'nebula-panel__outer--overlay': this.useOverlay,
        'nebula-panel__outer--overlay-display-on-right': this.useOverlay && this.displayOnRight
      }];
    }

  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        // Delay setting isVisible to true until after slide in animation completes
        // so that FocusTrap can find the panel's contents
        setTimeout(() => {
          this.isVisible = true;
        }, 125);

        if (this.useOverlay) {
          document.body.classList.add('nebula-panel--body-overflow-hidden');
        } else {
          document.body.classList.remove('nebula-panel--body-overflow-hidden');
        }
      } else {
        this.isVisible = false;
        document.body.classList.remove('nebula-panel--body-overflow-hidden');
      }
    }

  },

  mounted() {
    this.throttledHandleResize = lodash_es_throttle(this.setWindowSize, 150);
    window.addEventListener('resize', this.throttledHandleResize);
    this.setWindowSize();
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.throttledHandleResize);
  }

});
// CONCATENATED MODULE: ./src/components/Panel/NebulaPanel.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Panel/NebulaPanel.vue?vue&type=style&index=0&id=8204a2ba&lang=stylus
var NebulaPanelvue_type_style_index_0_id_8204a2ba_lang_stylus = __webpack_require__("f156");

// CONCATENATED MODULE: ./src/components/Panel/NebulaPanel.vue







const NebulaPanel_exports_ = /*#__PURE__*/exportHelper_default()(NebulaPanelvue_type_script_lang_js, [['render',NebulaPanelvue_type_template_id_8204a2ba_render]])

/* harmony default export */ var NebulaPanel = (NebulaPanel_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Popover/NebulaPopover.vue?vue&type=template&id=244aeecb

const NebulaPopovervue_type_template_id_244aeecb_hoisted_1 = ["id"];
const NebulaPopovervue_type_template_id_244aeecb_hoisted_2 = ["aria-label", "aria-labelledby", "id"];
const NebulaPopovervue_type_template_id_244aeecb_hoisted_3 = {
  key: 0,
  class: "popper__arrow",
  "data-popper-arrow": ""
};
const NebulaPopovervue_type_template_id_244aeecb_hoisted_4 = ["id"];
const NebulaPopovervue_type_template_id_244aeecb_hoisted_5 = {
  class: "nebula-popover__content-container"
};
function NebulaPopovervue_type_template_id_244aeecb_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: "nebula-popover__container",
    id: $options.getPopoverContainerId
  }, [Object(external_vue_["renderSlot"])(_ctx.$slots, "trigger", {
    togglePopover: $options.togglePopover,
    popoverOpen: $data.popoverOpen
  }), Object(external_vue_["withDirectives"])(Object(external_vue_["createElementVNode"])("div", {
    "aria-label": $props.ariaLabel,
    "aria-labelledby": $props.ariaLabelledby,
    class: Object(external_vue_["normalizeClass"])($options.popoverClassName),
    id: $options.popperId,
    ref: "focusTrap"
  }, [!$props.hidePointerNub ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaPopovervue_type_template_id_244aeecb_hoisted_3)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", {
    id: $options.getFocusAreaId,
    class: "nebula-popover__inner"
  }, [Object(external_vue_["createElementVNode"])("div", {
    class: Object(external_vue_["normalizeClass"])(["nebula-popover__close-button-container", [!$props.showCloseButton && 'nebula-screenreader-only']])
  }, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
    onClick: $options.closePopover,
    class: "nebula-popover__close-button",
    "icon-left": "x",
    type: "flat",
    size: "s",
    "aria-label": _ctx.$t('close popover')
  }, null, 8, ["onClick", "aria-label"])], 2), Object(external_vue_["createElementVNode"])("div", NebulaPopovervue_type_template_id_244aeecb_hoisted_5, [Object(external_vue_["renderSlot"])(_ctx.$slots, "content", {
    togglePopover: $options.togglePopover,
    popoverOpen: $data.popoverOpen,
    closePopover: $options.closePopover
  })])], 8, NebulaPopovervue_type_template_id_244aeecb_hoisted_4)], 10, NebulaPopovervue_type_template_id_244aeecb_hoisted_2), [[external_vue_["vShow"], $data.popoverOpen]])], 8, NebulaPopovervue_type_template_id_244aeecb_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/Popover/NebulaPopover.vue?vue&type=template&id=244aeecb

// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js




function getBoundingClientRect_getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect_getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle_getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle_getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect_getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect_getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect_getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle_getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle_getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle_getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle_getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle_getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var enums_right = 'right';
var enums_left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, enums_right, enums_left];
var enums_start = 'start';
var end = 'end';
var enums_clippingParents = 'clippingParents';
var viewport = 'viewport';
var enums_popper = 'popper';
var enums_reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + enums_start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + enums_start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var enums_main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, enums_main, afterMain, beforeWrite, write, afterWrite];
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/debounce.js
function debounce_debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/createPopper.js









var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce_debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper_createPopper = /*#__PURE__*/popperGenerator(); // eslint-disable-next-line import/no-unused-modules


// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case enums_right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case enums_left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case enums_start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets_popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets_popperOffsets,
  data: {}
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = enums_left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle_getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === enums_left || placement === enums_right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === enums_left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = enums_right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [enums_left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [enums_left, enums_right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset_offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset_offset
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle_getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect_getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle_getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? enums_clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? enums_popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === enums_popper ? enums_reference : enums_popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect_getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === enums_popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === enums_popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [enums_right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === enums_start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? enums_right : enums_left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : enums_left;
    var altSide = mainAxis === 'y' ? bottom : enums_right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === enums_start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === enums_start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : enums_left;

    var _altSide = mainAxis === 'x' ? bottom : enums_right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, enums_left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js








 // eslint-disable-next-line import/no-unused-modules

var arrow_toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [enums_left, enums_right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = arrow_toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : enums_left;
  var maxProp = axis === 'y' ? bottom : enums_right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, enums_right, bottom, enums_left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/popper.js










var popper_defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: popper_defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Popover/NebulaPopover.vue?vue&type=script&lang=js



/* harmony default export */ var NebulaPopovervue_type_script_lang_js = ({
  name: 'NebulaPopover',
  components: {
    NebulaButton: NebulaButton
  },

  data() {
    return {
      button: null,
      focusTrap: {},
      popoverOpen: false,
      popperInstance: null,
      tooltip: null
    };
  },

  props: {
    ariaLabel: {
      type: String,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    boundariesSelector: {
      type: [String, Number],
      default: null
    },
    distance: {
      type: Number,
      default: 10
    },
    id: {
      type: [String, Number],
      default: null
    },
    firstFocusId: {
      type: [String, Number],
      default: null
    },
    focusTrapEnabled: {
      type: Boolean,
      default: true
    },
    hidePointerNub: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'bottom',
      // option: top, right, bottom, left
      enum: ['top', 'right', 'bottom', 'left'] // for docs site

    },
    positionOverrideElementId: {
      type: String,
      default: null
    },
    showCloseButton: {
      type: Boolean,
      default: false
    },
    skidding: {
      type: Number,
      default: 0
    }
  },
  computed: {
    focusTrapArea() {
      return document.getElementById(this.getFocusAreaId);
    },

    getFocusAreaId() {
      return `nebula-popover__focus-area-${this.id}`;
    },

    getInitialFocus() {
      let firstFocused = null;

      if (this.firstFocusId) {
        firstFocused = document.getElementById(this.firstFocusId);
      } else {
        firstFocused = this.getFirstSelectableElement();
      }

      return firstFocused;
    },

    getPlacement() {
      const optionObject = {
        placement: this.placement
      };
      return optionObject;
    },

    getPopoverContainerId() {
      return `nebula-popover__container-${this.id}`;
    },

    getTriggerButtonId() {
      return `nebula-popover-trigger__${this.id}`;
    },

    popoverClassName() {
      const className = ['nebula-popover', 'popper', {
        'nebula-popover--has-close-button': this.showCloseButton
      }];
      return className;
    },

    popperId() {
      return this.id;
    },

    triggerButtonElement() {
      return document.getElementById(this.getTriggerButtonId);
    }

  },
  methods: {
    closePopover() {
      if (this.popoverOpen) {
        this.popoverOpen = false;

        if (this.focusTrapEnabled) {
          this.focusTrap.deactivate(); // After closing the popover, set focus back to the trigger

          setTimeout(() => {
            document.getElementById(this.getTriggerButtonId).focus();
          }, 100);
        }
      }
    },

    emitKeyUpEvent(e) {
      if (e.keyCode === 27) {
        this.closePopover();
      }
    },

    enableFocusTrap() {
      // After the Popover is shown, create the FocusTrap.
      // FocusTrap uses `checkCanFocusTrap` to makes sure the popover is there and contains focusable elements
      this.focusTrap = focus_trap_esm_createFocusTrap(this.focusTrapArea, {
        checkCanFocusTrap: trapContainers => {
          /* eslint-disable arrow-body-style */
          const results = trapContainers.map(trapContainer => new Promise(resolve => {
            const interval = setInterval(() => {
              if (getComputedStyle(trapContainer).visibility !== 'hidden') {
                resolve();
                clearInterval(interval);
              }
            }, 5);
          })); // Return a promise that resolves when all the trap containers are able to receive focus

          return Promise.all(results);
        },
        clickOutsideDeactivates: true,
        escapeDeactivates: true,
        fallbackFocus: this.getInitialFocus,
        initialFocus: this.getInitialFocus,
        preventScroll: true
      });
      this.focusTrap.activate();
    },

    getFirstSelectableElement() {
      const focusable = this.getFocusableElements();

      if (focusable.length) {
        if (focusable.length > 1 && focusable[0].classList.contains('nebula-popover__close-button')) {
          return focusable[1];
        }

        return focusable[0];
      }

      return this.$refs.focusTrap;
    },

    getFocusableElements() {
      const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
      return this.$refs.focusTrap.querySelectorAll(focusableSelector);
    },

    onBodyClick({
      target
    }) {
      // Runs on every click on the page, for each popover instance
      // `closePopover()` if the click target is not inside a popover element
      if (!this.$el.contains(target)) {
        this.closePopover();
      }
    },

    togglePopover() {
      if (!this.popoverOpen) {
        this.popperInstance.setOptions(options => ({ ...options,
          modifiers: [...options.modifiers, {
            name: 'eventListeners',
            enabled: true
          }]
        }));
        this.tooltip.setAttribute('data-show', '');
        this.popoverOpen = true;
        this.$nextTick(() => {
          this.popperInstance.update();
        });

        if (this.focusTrapEnabled) {
          setTimeout(() => {
            // FocusTrap needs a moment to find the Popover in the DOM
            this.enableFocusTrap();
          }, 100);
        }
      } else {
        // Disable the event listeners
        this.popperInstance.setOptions(options => ({ ...options,
          modifiers: [...options.modifiers, {
            name: 'eventListeners',
            enabled: false
          }]
        }));
        this.tooltip.removeAttribute('data-show');
        this.popoverOpen = false;
      }
    }

  },

  mounted() {
    this.button = this.triggerButtonElement;
    this.tooltip = document.getElementById(this.popperId);
    this.button.addEventListener('click', this.togglePopover);
    this.popperInstance = popper_createPopper(this.button, this.tooltip, {
      modifiers: [{
        name: 'eventListeners',
        enabled: false
      }, {
        name: 'offset',
        options: {
          offset: [this.skidding, this.distance]
        }
      }, {
        name: 'preventOverflow',
        options: {
          boundary: document.querySelector(this.boundariesSelector)
        }
      }],
      placement: this.placement
    });
    document.addEventListener('click', this.onBodyClick);
    document.addEventListener('keyup', this.emitKeyUpEvent);
  },

  beforeUnmount() {
    document.removeEventListener('keyup', this.emitKeyUpEvent);
    document.removeEventListener('click', this.onBodyClick);
  }

});
// CONCATENATED MODULE: ./src/components/Popover/NebulaPopover.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Popover/NebulaPopover.vue?vue&type=style&index=0&id=244aeecb&lang=stylus
var NebulaPopovervue_type_style_index_0_id_244aeecb_lang_stylus = __webpack_require__("810a");

// CONCATENATED MODULE: ./src/components/Popover/NebulaPopover.vue







const NebulaPopover_exports_ = /*#__PURE__*/exportHelper_default()(NebulaPopovervue_type_script_lang_js, [['render',NebulaPopovervue_type_template_id_244aeecb_render]])

/* harmony default export */ var NebulaPopover = (NebulaPopover_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ProductBar/NebulaProductBarSearch.vue?vue&type=template&id=422bd623

const NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_1 = ["action", "name"];
const NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_2 = ["name", "value"];
const NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_3 = {
  class: "nebula-product-bar__search-fieldset"
};
const NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_4 = ["textContent"];
const NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_5 = ["aria-expanded"];
const NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_6 = ["textContent"];
const NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_7 = {
  key: 0,
  class: "nebula-product-bar__popular-topics"
};
const NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_8 = {
  class: "nebula-product-bar__popular-topics-header"
};
const NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_9 = {
  class: "nebula-product-bar__popular-topics-links"
};
function NebulaProductBarSearchvue_type_template_id_422bd623_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaListItem = Object(external_vue_["resolveComponent"])("NebulaListItem");

  const _component_NebulaListGroup = Object(external_vue_["resolveComponent"])("NebulaListGroup");

  const _component_NebulaTitleTooltip = Object(external_vue_["resolveComponent"])("NebulaTitleTooltip");

  const _component_NebulaInputWithButtons = Object(external_vue_["resolveComponent"])("NebulaInputWithButtons");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("form", {
    class: Object(external_vue_["normalizeClass"])(["nebula-product-bar__search", $props.usePushState && 'do-form-submit']),
    action: $props.action,
    name: $props.searchFormName,
    ref: "searchForm",
    onSubmit: _cache[0] || (_cache[0] = (...args) => $options.handleSubmit && $options.handleSubmit(...args))
  }, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.filteredAdditionalParams, (param, index) => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("input", {
      key: index,
      type: "hidden",
      name: param.name,
      value: param.value
    }, null, 8, NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_2);
  }), 128)), Object(external_vue_["createElementVNode"])("fieldset", NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_3, [Object(external_vue_["createElementVNode"])("legend", {
    class: "nebula-screenreader-only",
    textContent: Object(external_vue_["toDisplayString"])($options.searchLegendText)
  }, null, 8, NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_4), Object(external_vue_["createVNode"])(_component_NebulaInputWithButtons, null, {
    input: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("div", {
      "aria-expanded": $options.isExpanded && 'true' || 'false',
      "aria-haspopup": "listbox",
      "aria-owns": "nebula-product-bar__suggestions-list",
      class: "nebula-product-bar__search-inner",
      role: "combobox"
    }, [Object(external_vue_["createElementVNode"])("div", {
      class: Object(external_vue_["normalizeClass"])(["nebula-product-bar__combobox", {
        'nebula-product-bar__combobox--has-speech-input': $data.acceptsSpeechInput && !$props.disableSpeechInput
      }])
    }, [Object(external_vue_["createElementVNode"])("label", {
      class: "nebula-screenreader-only",
      id: "nebula-product-bar__search-label",
      for: "nebula-product-bar__search-input",
      textContent: Object(external_vue_["toDisplayString"])(_ctx.$t('enter term to search for'))
    }, null, 8, NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_6), Object(external_vue_["renderSlot"])(_ctx.$slots, "searchInput", {
      emitInputKeyDownEvents: $options.searchInputKeyDownEvents
    }), Object(external_vue_["createVNode"])(external_vue_["Transition"], {
      name: "nebula-suggestions-transition",
      mode: "out-in"
    }, {
      default: Object(external_vue_["withCtx"])(() => [$options.isExpanded ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        key: 0,
        id: "nebula-product-bar__suggestions-list",
        class: Object(external_vue_["normalizeClass"])(["nebula-product-bar__suggestions-list", {
          'nebula-product-bar__suggestions-list--wide': !$data.minimumWordEnteredOnce && $options.popularTopicsAvailable
        }]),
        ref: "suggestionsList"
      }, [!$data.minimumWordEnteredOnce && $options.popularTopicsAvailable ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_7, [Object(external_vue_["createElementVNode"])("p", NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_8, Object(external_vue_["toDisplayString"])(_ctx.$t('Explore Popular Topics')), 1), Object(external_vue_["createElementVNode"])("div", NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_9, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.popularTopics, topic => {
        return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
          key: topic.text,
          link: `${$props.action}?q=${encodeURIComponent(topic.text)}&search_query_source=Explore%20Popular%20Topics`,
          size: "s",
          text: topic.text
        }, null, 8, ["link", "text"]);
      }), 128))])])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createVNode"])(_component_NebulaListGroup, {
        onKeydown: $options.suggestionsListKeyDownEvents,
        "aria-labelledby": "nebula-product-bar__search-label",
        nested: "",
        role: "listbox"
      }, {
        content: Object(external_vue_["withCtx"])(() => [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.suggestions, (suggestion, index) => {
          return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaListItem, {
            itemId: `search-suggest-${suggestion.text}`,
            key: index,
            link: `${$props.action}${$options.autoSuggestSearchLinkFor(suggestion.text)}`,
            text: suggestion.text,
            usePushState: $props.usePushState
          }, null, 8, ["itemId", "link", "text", "usePushState"]);
        }), 128))]),
        _: 1
      }, 8, ["onKeydown"]), $props.recentlySearched && !$data.recentlySearchedHidden ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
        key: 1,
        class: Object(external_vue_["normalizeClass"])($options.recentlySearchedBorderClass)
      }, [Object(external_vue_["createVNode"])(_component_NebulaListGroup, {
        onKeydown: $options.suggestionsListKeyDownEvents,
        nested: "",
        role: "listbox",
        header: _ctx.$t('Recent Searches')
      }, {
        content: Object(external_vue_["withCtx"])(() => [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.recentlySearchedItems, (recentSearch, index) => {
          return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaListItem, {
            itemId: `search-suggest-${recentSearch.text}`,
            key: index,
            link: `${$props.action}${$options.recentSearchLinkFor(recentSearch.text)}`,
            text: recentSearch.text,
            class: Object(external_vue_["normalizeClass"])(`nebula-list-item--${recentSearch.text}`),
            usePushState: $props.usePushState
          }, null, 8, ["itemId", "link", "text", "class", "usePushState"]);
        }), 128))]),
        _: 1
      }, 8, ["onKeydown", "header"])], 2)) : Object(external_vue_["createCommentVNode"])("", true), (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.userSuggestions, suggestion => {
        return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
          key: suggestion.type,
          class: "nebula-product-bar__user-suggestions"
        }, [suggestion.type === 'Product' ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaListGroup, {
          key: 0,
          onKeydown: $options.suggestionsListKeyDownEvents,
          nested: "",
          role: "listbox",
          header: _ctx.$t('Curriculum Packs')
        }, {
          content: Object(external_vue_["withCtx"])(() => [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(suggestion.values, productSuggestion => {
            return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaListItem, {
              itemId: `search-suggest-${productSuggestion.text}`,
              key: productSuggestion.text,
              link: productSuggestion.href,
              text: $options.friendlyNameFor(productSuggestion.text),
              icon: $options.iconFor(productSuggestion.text),
              class: Object(external_vue_["normalizeClass"])(`nebula-list-item--${$options.iconFor(productSuggestion.text)}`)
            }, null, 8, ["itemId", "link", "text", "icon", "class"]);
          }), 128))]),
          _: 2
        }, 1032, ["onKeydown", "header"])) : Object(external_vue_["createCommentVNode"])("", true)]);
      }), 128))], 2)) : Object(external_vue_["createCommentVNode"])("", true)]),
      _: 1
    }), $data.showClearSearch ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
      key: 0,
      onClick: $options.clearSearchBox,
      "aria-label": _ctx.$t('clear search box'),
      class: "nebula-product-bar__clear-search-button",
      "icon-left": "x",
      size: "s",
      type: "flat"
    }, null, 8, ["onClick", "aria-label"])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createVNode"])(_component_NebulaTitleTooltip, {
      class: "nebula-product-bar__speech-search-button-tooltip",
      position: "block-end",
      text: _ctx.$t('Search by Speech')
    }, {
      default: Object(external_vue_["withCtx"])(() => [$data.acceptsSpeechInput && !$props.disableSpeechInput ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
        key: 0,
        onClick: $options.captureSpeechInput,
        "aria-label": _ctx.$t('search by speech'),
        class: Object(external_vue_["normalizeClass"])($options.speechButtonClass),
        "icon-left": "microphone",
        size: "s",
        type: "flat"
      }, null, 8, ["onClick", "aria-label", "class"])) : Object(external_vue_["createCommentVNode"])("", true)]),
      _: 1
    }, 8, ["text"])], 2)], 8, NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_5)]),
    buttonElementEnd: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      "aria-label": _ctx.$t('search'),
      class: "nebula-product-bar__search-button",
      "icon-left": "search",
      isSubmit: "",
      id: $props.searchButtonId,
      size: "s"
    }, null, 8, ["aria-label", "id"])]),
    _: 3
  })])], 42, NebulaProductBarSearchvue_type_template_id_422bd623_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/ProductBar/NebulaProductBarSearch.vue?vue&type=template&id=422bd623

// CONCATENATED MODULE: ./node_modules/lodash-es/_isPrototype.js
/** Used for built-in method references. */
var _isPrototype_objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || _isPrototype_objectProto;

  return value === proto;
}

/* harmony default export */ var _isPrototype = (isPrototype);

// CONCATENATED MODULE: ./node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);

// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeKeys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

/* harmony default export */ var _nativeKeys = (nativeKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseKeys.js



/** Used for built-in method references. */
var _baseKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeys_hasOwnProperty = _baseKeys_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (_baseKeys_hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeys = (baseKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/_DataView.js



/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root["a" /* default */], 'DataView');

/* harmony default export */ var _DataView = (DataView);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Map.js



/* Built-in method references that are verified to be native. */
var _Map_Map = _getNative(_root["a" /* default */], 'Map');

/* harmony default export */ var _Map = (_Map_Map);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Promise.js



/* Built-in method references that are verified to be native. */
var _Promise_Promise = _getNative(_root["a" /* default */], 'Promise');

/* harmony default export */ var _Promise = (_Promise_Promise);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Set.js



/* Built-in method references that are verified to be native. */
var _Set_Set = _getNative(_root["a" /* default */], 'Set');

/* harmony default export */ var _Set = (_Set_Set);

// CONCATENATED MODULE: ./node_modules/lodash-es/_WeakMap.js



/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root["a" /* default */], 'WeakMap');

/* harmony default export */ var _WeakMap = (WeakMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getTag.js








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (_Map && getTag(new _Map) != mapTag) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ var _getTag = (getTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsArguments.js



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return lodash_es_isObjectLike(value) && _baseGetTag(value) == argsTag;
}

/* harmony default export */ var _baseIsArguments = (baseIsArguments);

// CONCATENATED MODULE: ./node_modules/lodash-es/isArguments.js



/** Used for built-in method references. */
var isArguments_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isArguments_hasOwnProperty = isArguments_objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = isArguments_objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return lodash_es_isObjectLike(value) && isArguments_hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ var lodash_es_isArguments = (isArguments);

// CONCATENATED MODULE: ./node_modules/lodash-es/isLength.js
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ var lodash_es_isLength = (isLength);

// CONCATENATED MODULE: ./node_modules/lodash-es/isArrayLike.js



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && lodash_es_isLength(value.length) && !lodash_es_isFunction(value);
}

/* harmony default export */ var lodash_es_isArrayLike = (isArrayLike);

// EXTERNAL MODULE: ./node_modules/lodash-es/isBuffer.js
var isBuffer = __webpack_require__("58e0");

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsTypedArray.js




/** `Object#toString` result references. */
var _baseIsTypedArray_argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    _baseIsTypedArray_funcTag = '[object Function]',
    _baseIsTypedArray_mapTag = '[object Map]',
    numberTag = '[object Number]',
    _baseIsTypedArray_objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    _baseIsTypedArray_setTag = '[object Set]',
    stringTag = '[object String]',
    _baseIsTypedArray_weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    _baseIsTypedArray_dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[_baseIsTypedArray_argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[_baseIsTypedArray_dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[_baseIsTypedArray_funcTag] =
typedArrayTags[_baseIsTypedArray_mapTag] = typedArrayTags[numberTag] =
typedArrayTags[_baseIsTypedArray_objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[_baseIsTypedArray_setTag] = typedArrayTags[stringTag] =
typedArrayTags[_baseIsTypedArray_weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return lodash_es_isObjectLike(value) &&
    lodash_es_isLength(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

/* harmony default export */ var _baseIsTypedArray = (baseIsTypedArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseUnary.js
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ var _baseUnary = (baseUnary);

// EXTERNAL MODULE: ./node_modules/lodash-es/_nodeUtil.js
var _nodeUtil = __webpack_require__("c6eb");

// CONCATENATED MODULE: ./node_modules/lodash-es/isTypedArray.js




/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

/* harmony default export */ var lodash_es_isTypedArray = (isTypedArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/isEmpty.js









/** `Object#toString` result references. */
var isEmpty_mapTag = '[object Map]',
    isEmpty_setTag = '[object Set]';

/** Used for built-in method references. */
var isEmpty_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isEmpty_hasOwnProperty = isEmpty_objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (lodash_es_isArrayLike(value) &&
      (lodash_es_isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(isBuffer["a" /* default */])(value) || lodash_es_isTypedArray(value) || lodash_es_isArguments(value))) {
    return !value.length;
  }
  var tag = _getTag(value);
  if (tag == isEmpty_mapTag || tag == isEmpty_setTag) {
    return !value.size;
  }
  if (_isPrototype(value)) {
    return !_baseKeys(value).length;
  }
  for (var key in value) {
    if (isEmpty_hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ var lodash_es_isEmpty = (isEmpty);

// CONCATENATED MODULE: ./src/utils/searchAutoCompleteData.js
function iconFor(productName) {
  switch (productName) {
    case 'Science Middle School':
      return 'science-flask';

    case 'Science Elementary':
      return 'science-flask';

    case 'Science Course':
      return 'science-flask';

    case 'Science Techbook':
      return 'science-flask';

    case 'Health and Relationships':
      return 'health';

    case 'Math Techbook':
      return 'math';

    case 'STEM Connect':
      return 'stem-connect';

    case 'Social Studies Techbook':
      return 'social-studies';

    case 'Mystery Science':
      return 'mysteryscience';

    case 'Coding':
      return 'coding';

    case 'Pathway':
      return 'pathway';

    case 'Espresso':
      return 'espresso';

    case 'Health':
      return 'health';
    // return exclamation so its clear there is no icon :shrugging:

    default:
      return 'exclamation';
  }
} // dont show 'Science Course' text instead show 'Science Techbook'


function friendlyNameFor(productName) {
  switch (productName) {
    case 'Science Course':
      return 'Science Techbook';

    default:
      return productName;
  }
}


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ProductBar/NebulaProductBarSearch.vue?vue&type=script&lang=js







const MINIMUM_WORD_LENGTH = 3; // UX may update after a word is typed of this minimum length;

/* harmony default export */ var NebulaProductBarSearchvue_type_script_lang_js = ({
  name: 'NebulaProductBarSearch',
  components: {
    NebulaInputWithButtons: NebulaInputWithButtons,
    NebulaButton: NebulaButton,
    NebulaListGroup: NebulaListGroup,
    NebulaListItem: NebulaListItem,
    NebulaTitleTooltip: NebulaTitleTooltip
  },

  data() {
    return {
      acceptsSpeechInput: false,
      displaySuggestionsList: false,
      isCapturingSpeechInput: false,
      recognition: null,
      recentlySearchedHidden: false,
      selectedType: null,
      showClearSearch: false,
      minimumWordEnteredOnce: false,
      suggestionsHidden: false
    };
  },

  props: {
    action: {
      type: String,
      default: '/learn/search'
    },
    additionalParams: {
      type: Array,

      default() {
        return [];
      }

    },
    disableSpeechInput: {
      type: Boolean,
      default: false
    },
    disableSuggestions: {
      type: Boolean,
      default: false
    },
    langCode: {
      type: String,
      default: 'en'
    },
    popularTopics: {
      type: Array,
      default: null
    },
    recentlySearched: {
      type: Array,
      default: null
    },
    searchFormName: {
      type: String,
      default: 'searchForm'
    },
    searchButtonId: {
      type: String,
      default: null
    },
    searchInputId: {
      type: String,
      default: 'nebula-product-bar__search-input'
    },
    suggestions: {
      type: Array,
      default: null
    },
    submitHandler: {
      type: Function,
      default: null
    },
    userSuggestions: {
      type: Array,
      default: null
    },
    usePushState: {
      type: Boolean,
      default: false
    }
  },
  emits: ['clear-search-box'],
  computed: {
    filteredAdditionalParams() {
      // Filter out group filter, since it's always included
      return this.additionalParams.filter(param => param.name !== 'group');
    },

    additionalParamsQueryString() {
      if (this.additionalParams.length) {
        const queryString = this.additionalParams.map(obj => `${obj.name}=${obj.value}`).join('&');
        return `&${queryString}`;
      }

      return '';
    },

    getSelectedType() {
      return this.selectedType || this.$t('All Assets');
    },

    popularTopicsAvailable() {
      var _this$popularTopics;

      return (_this$popularTopics = this.popularTopics) === null || _this$popularTopics === void 0 ? void 0 : _this$popularTopics.length;
    },

    speechButtonClass() {
      const className = ['nebula-product-bar__speech-search-button', {
        'nebula-product-bar__speech-search-button--listening': this.isCapturingSpeechInput === true
      }];
      return className;
    },

    searchInputEl() {
      return document.getElementById(this.searchInputId);
    },

    searchLegendText() {
      const message = {
        chunk1: this.$t('Search for '),
        chunk2: this.getSelectedType
      };
      return `${message.chunk1}${message.chunk2}`;
    },

    isExpanded() {
      var _this$popularTopics2;

      return this.displaySuggestionsList && (!lodash_es_isEmpty(this.suggestions) && !this.disableSuggestions || !lodash_es_isEmpty(this.recentlySearched) || !this.minimumWordEnteredOnce && ((_this$popularTopics2 = this.popularTopics) === null || _this$popularTopics2 === void 0 ? void 0 : _this$popularTopics2.length));
    },

    recentlySearchedBorderClass() {
      // Do not show top border if we are also displaying search suggestions
      return this.suggestions && !lodash_es_isEmpty(this.suggestions) ? 'nebula-product-bar__recently-searched' : 'nebula-product-bar__recently-searched--no-border';
    },

    recentlySearchedItems() {
      // limit to 3 recently searched terms on mobile viewport widths
      return document.documentElement.clientWidth <= 767 ? this.recentlySearched.slice(0, 3) : this.recentlySearched;
    }

  },

  created() {
    // If we already have a selected group, reflect that
    const groupParam = this.additionalParams.find(param => param.name === 'group');
    if (groupParam) this.selectedType = groupParam.value;
  },

  mounted() {
    var _this$searchInputEl, _searchInput$value;

    this.checkForSpeechRecognition();
    const searchInput = this.searchInputEl;
    this.showClearSearch = !!((_this$searchInputEl = this.searchInputEl) !== null && _this$searchInputEl !== void 0 && _this$searchInputEl.value);
    document.addEventListener('click', this.onBodyClick);
    searchInput.addEventListener('keyup', this.searchInputKeyUpEvents);
    searchInput.addEventListener('click', this.onSearchInputClick);
    searchInput.addEventListener('input', this.onInputEvent);
    this.minimumWordEnteredOnce = (((_searchInput$value = searchInput.value) === null || _searchInput$value === void 0 ? void 0 : _searchInput$value.length) || 0) >= MINIMUM_WORD_LENGTH;
  },

  beforeUnmount() {
    const searchInput = this.searchInputEl;
    document.removeEventListener('click', this.onBodyClick);
    searchInput.removeEventListener('keyup', this.searchInputKeyUpEvents);
    searchInput.removeEventListener('click', this.onSearchInputClick);
    searchInput.removeEventListener('input', this.onInputEvent);
  },

  methods: {
    iconFor(product) {
      return iconFor(product);
    },

    friendlyNameFor(product) {
      return friendlyNameFor(product);
    },

    changeSelected(e) {
      this.selectedType = e.currentTarget.value;
    },

    clearSearchBox() {
      this.searchInputEl.value = '';
      this.showClearSearch = false;
      this.suggestionsHidden = true;
      this.displaySuggestionsList = true;
      this.$emit('clear-search-box');
    },

    captureSpeechInput() {
      if (this.isCapturingSpeechInput && this.recognition) {
        this.isCapturingSpeechInput = false;
        this.recognition.stop();
      } else {
        this.isCapturingSpeechInput = true;
        /* eslint-disable new-cap */

        this.recognition = new window.webkitSpeechRecognition();
        /* eslint-enable new-cap */

        this.recognition.lang = this.langCode;
        this.recognition.continuous = true;
        this.recognition.interimResults = true;

        this.recognition.onstart = () => {
          this.onRecognizeStart();
        };

        this.recognition.onend = () => {
          this.onRecognizeEnd();
        };

        this.recognition.onresult = event => {
          this.onRecognize(event);
        };

        this.recognition.start();
      }
    },

    checkForSpeechRecognition() {
      if (window.webkitSpeechRecognition) {
        this.acceptsSpeechInput = true;
      }
    },

    handleSubmit(event) {
      if (this.submitHandler) {
        const formData = new FormData(this.$refs.searchForm);
        this.submitHandler(event, formData);
      }
    },

    onRecognizeStart() {
      if (this.recognitionTimeout) {
        clearTimeout(this.recognitionTimeout);
      }

      this.recognitionTimeout = setTimeout(this.onRecognitionTimeout, 8000);
      this.isCapturingSpeechInput = true;
    },

    onRecognizeEnd() {
      this.isCapturingSpeechInput = false;
    },

    onRecognize(event) {
      const result = event.results;

      if (result[0].isFinal) {
        this.recognition.stop();
        this.searchInputEl.value = result[0][0].transcript;
        this.$refs.searchForm.submit();
      }
    },

    onRecognitionTimeout() {
      if (this.isCapturingSpeechInput) {
        this.recognition.stop();
      }
    },

    keyCodeEvents(e) {
      // escape key
      if (e.keyCode === 27) {
        this.hideSuggestions();
      } // up arrow pressed


      if (e.keyCode === 38) {
        e.preventDefault();
        this.selectNextUp(e); // down arrow pressed
      } else if (e.keyCode === 40) {
        e.preventDefault();
        this.selectNextDown(e);
      }
    },

    onInputEvent(e) {
      var _e$target$value;

      if (!this.minimumWordEnteredOnce && ((_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.length) >= MINIMUM_WORD_LENGTH) {
        this.minimumWordEnteredOnce = true;
      }
    },

    onSearchInputClick() {
      this.displaySuggestionsList = true;
    },

    searchInputKeyDownEvents(e) {
      if (this.isExpanded) {
        this.keyCodeEvents(e);
      }
    },

    searchInputKeyUpEvents() {
      var _this$searchInputEl2;

      this.showClearSearch = !!((_this$searchInputEl2 = this.searchInputEl) !== null && _this$searchInputEl2 !== void 0 && _this$searchInputEl2.value);
      this.showSuggestions();
    },

    suggestionsListKeyDownEvents(e) {
      if (this.isExpanded) {
        this.keyCodeEvents(e); // tab key, close if exiting menu

        if (e.keyCode === 9) {
          const focusable = this.getFocusable();
          const index = Array.prototype.indexOf.call(focusable, document.activeElement);

          if (e.shiftKey) {
            if (index === 0) {
              this.hideSuggestions();
            }
          } else if (index === focusable.length - 1) {
            this.hideSuggestions();
          } else {
            const suggestionText = focusable[index].getElementsByClassName('nebula-list-item__text')[0].innerText;
            const suggestionId = focusable[index].id;
            this.searchInputEl.setAttribute('aria-activedescendant', suggestionId);
            this.searchInputEl.value = suggestionText;
          }
        }
      }
    },

    getFocusable() {
      /* eslint-disable max-len */
      return this.$refs.suggestionsList ? this.$refs.suggestionsList.querySelectorAll('button:not([tabindex="-1"]), [href]:not([tabindex="-1"])') : null;
      /* eslint-enable max-len */
    },

    hideSuggestions() {
      this.displaySuggestionsList = false;
    },

    onBodyClick({
      target
    }) {
      /* eslint-disable prefer-destructuring */
      if (!this.$el.getElementsByClassName('nebula-product-bar__combobox')[0].contains(target)) {
        this.hideSuggestions();
      }
      /* eslint-enable prefer-destructuring */

    },

    selectNextUp() {
      const focusable = this.getFocusable();
      const index = Array.prototype.indexOf.call(focusable, document.activeElement);

      if (index > 0) {
        const suggestionText = focusable[index - 1].getElementsByClassName('nebula-list-item__text')[0].innerText;
        const suggestionId = focusable[index - 1].id;
        this.searchInputEl.setAttribute('aria-activedescendant', suggestionId);
        this.searchInputEl.value = suggestionText;
        focusable[index - 1].focus();
      } else {
        focusable[focusable.length - 1].focus();
      }
    },

    selectNextDown() {
      const focusable = this.getFocusable();
      const index = Array.prototype.indexOf.call(focusable, document.activeElement);

      if (index < focusable.length - 1) {
        const suggestionText = focusable[index + 1].getElementsByClassName('nebula-list-item__text')[0].innerText;
        const suggestionId = focusable[index + 1].id;
        this.searchInputEl.setAttribute('aria-activedescendant', suggestionId);
        this.searchInputEl.value = suggestionText;
        focusable[index + 1].focus();
      } else {
        focusable[0].focus();
      }
    },

    showSuggestions() {
      this.suggestionsHidden = false;
    },

    autoSuggestSearchLinkFor(suggestionText) {
      return `?q=${suggestionText}&search_query_source=Autosuggest${this.additionalParamsQueryString}`;
    },

    recentSearchLinkFor(recentSearchText) {
      return `?q=${recentSearchText}&search_query_source=Recent%20Searches${this.additionalParamsQueryString}`;
    }

  }
});
// CONCATENATED MODULE: ./src/components/ProductBar/NebulaProductBarSearch.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/ProductBar/NebulaProductBarSearch.vue?vue&type=style&index=0&id=422bd623&lang=stylus
var NebulaProductBarSearchvue_type_style_index_0_id_422bd623_lang_stylus = __webpack_require__("05de");

// CONCATENATED MODULE: ./src/components/ProductBar/NebulaProductBarSearch.vue







const NebulaProductBarSearch_exports_ = /*#__PURE__*/exportHelper_default()(NebulaProductBarSearchvue_type_script_lang_js, [['render',NebulaProductBarSearchvue_type_template_id_422bd623_render]])

/* harmony default export */ var NebulaProductBarSearch = (NebulaProductBarSearch_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ProfilePanel/NebulaProfilePanelToggle.vue?vue&type=template&id=0b12f0fe

const NebulaProfilePanelTogglevue_type_template_id_0b12f0fe_hoisted_1 = {
  class: "nebula-profile-panel-toggle-button"
};
function NebulaProfilePanelTogglevue_type_template_id_0b12f0fe_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaProfilePanelTogglevue_type_template_id_0b12f0fe_hoisted_1, [Object(external_vue_["renderSlot"])(_ctx.$slots, "profilePanelClose")]);
}
// CONCATENATED MODULE: ./src/components/ProfilePanel/NebulaProfilePanelToggle.vue?vue&type=template&id=0b12f0fe

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ProfilePanel/NebulaProfilePanelToggle.vue?vue&type=script&lang=js
/* harmony default export */ var NebulaProfilePanelTogglevue_type_script_lang_js = ({
  name: 'NebulaProfilePanelToggle'
});
// CONCATENATED MODULE: ./src/components/ProfilePanel/NebulaProfilePanelToggle.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/components/ProfilePanel/NebulaProfilePanelToggle.vue





const NebulaProfilePanelToggle_exports_ = /*#__PURE__*/exportHelper_default()(NebulaProfilePanelTogglevue_type_script_lang_js, [['render',NebulaProfilePanelTogglevue_type_template_id_0b12f0fe_render]])

/* harmony default export */ var NebulaProfilePanelToggle = (NebulaProfilePanelToggle_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/QuickLinks/NebulaQuicklinks.vue?vue&type=template&id=7adb0c51

const NebulaQuicklinksvue_type_template_id_7adb0c51_hoisted_1 = {
  class: "nebula-quicklinks"
};
const NebulaQuicklinksvue_type_template_id_7adb0c51_hoisted_2 = {
  class: "nebula-quicklinks__label"
};
const NebulaQuicklinksvue_type_template_id_7adb0c51_hoisted_3 = ["href"];
function NebulaQuicklinksvue_type_template_id_7adb0c51_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("nav", NebulaQuicklinksvue_type_template_id_7adb0c51_hoisted_1, [Object(external_vue_["createElementVNode"])("h4", NebulaQuicklinksvue_type_template_id_7adb0c51_hoisted_2, Object(external_vue_["toDisplayString"])($props.header || _ctx.$t('Quicklinks')) + ":", 1), (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.links, link => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("a", {
      class: "nebula-quicklinks__link",
      href: `#${link.fragmentId}`,
      key: link.text,
      onClick: _cache[0] || (_cache[0] = (...args) => $options.handleClick && $options.handleClick(...args))
    }, Object(external_vue_["toDisplayString"])(link.text), 9, NebulaQuicklinksvue_type_template_id_7adb0c51_hoisted_3);
  }), 128))]);
}
// CONCATENATED MODULE: ./src/components/QuickLinks/NebulaQuicklinks.vue?vue&type=template&id=7adb0c51

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/QuickLinks/NebulaQuicklinks.vue?vue&type=script&lang=js
/* harmony default export */ var NebulaQuicklinksvue_type_script_lang_js = ({
  name: 'NebulaQuicklinks',
  emits: ['hashChange'],
  props: {
    header: {
      type: String,
      default: null
    },
    links: {
      type: Array,
      default: () => []
    },
    scrollOffset: {
      type: Number,
      default: 0
    },
    useSmoothScroll: {
      type: Boolean,
      deafult: false
    }
  },
  methods: {
    handleClick(e) {
      e.preventDefault(); // Find the target element

      const hash = e.target.getAttribute('href').replace('##', '').replace('#', '');
      let target = document.getElementById(hash);

      if (target === null) {
        const matches = document.getElementsByName(hash);
        target = matches && matches.length ? matches[0] : null;
      } // Now scroll to it


      if (target) {
        const {
          offsetTop
        } = target; // Hidden elements have a null offset in webkit

        if (offsetTop === null) {
          return;
        }

        const behaviorValue = this.useSmoothScroll ? 'smooth' : 'auto';

        if (this.scrollOffset === 0) {
          // If no scrollOffset provided just use scrollIntoView
          target.scrollIntoView({
            behavior: behaviorValue
          });
        } else {
          // Apply an extra offset, e.g. for fixed navs...
          const newY = window.pageYOffset + target.getBoundingClientRect().top - this.scrollOffset;
          window.scrollTo({
            top: newY,
            left: window.pageXOffset,
            behavior: behaviorValue
          });
        }
      } // Finally emit an event in case the site wants to update their location hash


      if (hash) {
        this.$emit('hashChange', hash);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/QuickLinks/NebulaQuicklinks.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/QuickLinks/NebulaQuicklinks.vue?vue&type=style&index=0&id=7adb0c51&lang=stylus
var NebulaQuicklinksvue_type_style_index_0_id_7adb0c51_lang_stylus = __webpack_require__("be52");

// CONCATENATED MODULE: ./src/components/QuickLinks/NebulaQuicklinks.vue







const NebulaQuicklinks_exports_ = /*#__PURE__*/exportHelper_default()(NebulaQuicklinksvue_type_script_lang_js, [['render',NebulaQuicklinksvue_type_template_id_7adb0c51_render]])

/* harmony default export */ var NebulaQuicklinks = (NebulaQuicklinks_exports_);
// EXTERNAL MODULE: ./src/assets/quicklist/quicklist-empty-state.png
var quicklist_empty_state = __webpack_require__("812b");
var quicklist_empty_state_default = /*#__PURE__*/__webpack_require__.n(quicklist_empty_state);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/QuickList/NebulaQuickList.vue?vue&type=template&id=5d6ca8bc


const NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_1 = {
  class: "nebula-quicklist-panel",
  ref: "quickListPanel"
};
const NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_2 = {
  class: "nebula-quicklist-panel__header"
};
const NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_3 = {
  class: "nebula-quicklist-panel__count"
};
const NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_4 = {
  class: "nebula-quicklist-panel__title"
};
const NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_5 = {
  "aria-hidden": "true"
};
const NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_6 = {
  class: "nebula-screenreader-only"
};
const NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_7 = {
  class: "nebula-quicklist-panel__action"
};
const NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_8 = {
  key: 0,
  class: "nebula-quicklist-panel__footer"
};
const NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_9 = {
  key: 1,
  class: "nebula-quicklist-panel__empty"
};
const NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_10 = {
  class: "nebula-quicklist-panel__empty-header"
};
const NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_11 = ["innerHTML"];
const NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_12 = ["alt"];
function NebulaQuickListvue_type_template_id_5d6ca8bc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  const _component_NebulaDraggableCards = Object(external_vue_["resolveComponent"])("NebulaDraggableCards");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_1, [Object(external_vue_["createElementVNode"])("div", NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_2, [Object(external_vue_["createElementVNode"])("div", NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_3, [Object(external_vue_["createElementVNode"])("h2", NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_4, Object(external_vue_["toDisplayString"])(_ctx.$t("Favorites")), 1), Object(external_vue_["createElementVNode"])("span", NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_5, Object(external_vue_["toDisplayString"])($props.quickListTotalCount), 1), Object(external_vue_["createElementVNode"])("span", NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_6, Object(external_vue_["toDisplayString"])(_ctx.$t('Contains %(num)s item(s)', {
    num: $props.quickListTotalCount
  })), 1), Object(external_vue_["createVNode"])(_component_NebulaIcon, {
    class: "nebula-quicklist-panel__count-icon",
    symbolId: "heart--filled",
    size: "s"
  })]), Object(external_vue_["createElementVNode"])("div", NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_7, [Object(external_vue_["renderSlot"])(_ctx.$slots, "quickListActionsMenu")])]), $options.mutableList.length ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    key: 0,
    class: Object(external_vue_["normalizeClass"])($options.quickListPanelContentClass)
  }, [Object(external_vue_["createVNode"])(_component_NebulaDraggableCards, {
    draggableElement: "NebulaQuickListCard",
    list: $options.mutableList,
    group: "quicklist",
    "disable-drag": !$options.isDraggable,
    handle: ".nebula-quicklist-panel__content-item",
    onChange: $options.handleChange
  }, {
    quickListItemActions: Object(external_vue_["withCtx"])(({
      asset
    }) => [Object(external_vue_["renderSlot"])(_ctx.$slots, "quickListItemActions", {
      asset: asset
    })]),
    _: 3
  }, 8, ["list", "disable-drag", "onChange"]), $props.quickListTotalCount >= 25 ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_8, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
    isDisabled: $props.quickListTotalCount === $options.mutableList.length,
    text: _ctx.$t('Load More'),
    size: "m",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('onLoadMoreButtonClick'))
  }, null, 8, ["isDisabled", "text"]), Object(external_vue_["createVNode"])(_component_NebulaButton, {
    iconLeft: "arrow-up",
    text: _ctx.$t('Back to Top'),
    type: "flat",
    size: "m",
    onClick: $options.scrollToQuickListTop
  }, null, 8, ["text", "onClick"])])) : Object(external_vue_["createCommentVNode"])("", true)], 2)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_9, [Object(external_vue_["createElementVNode"])("h3", NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_10, Object(external_vue_["toDisplayString"])(_ctx.$t("Start Adding!")), 1), Object(external_vue_["createElementVNode"])("p", {
    class: "nebula-quicklist-panel__empty-paragraph",
    innerHTML: $options.emptyQLText
  }, null, 8, NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_11), Object(external_vue_["createElementVNode"])("img", {
    src: quicklist_empty_state_default.a,
    alt: _ctx.$t('Add to Favorites instructions'),
    class: "nebula-quicklist-panel__empty-image"
  }, null, 8, NebulaQuickListvue_type_template_id_5d6ca8bc_hoisted_12)]))], 512);
}
// CONCATENATED MODULE: ./src/components/QuickList/NebulaQuickList.vue?vue&type=template&id=5d6ca8bc

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/QuickList/NebulaQuickList.vue?vue&type=script&lang=js



/* harmony default export */ var NebulaQuickListvue_type_script_lang_js = ({
  name: 'NebulaQuickList',
  components: {
    NebulaDraggableCards: NebulaDraggableCards,
    NebulaIcon: NebulaIcon,
    NebulaButton: NebulaButton
  },
  props: {
    draggable: {
      type: Boolean,
      default: false
    },
    itemPath: {
      type: String,
      default: '/learn/player'
    },
    reorderHandler: {
      type: Function,
      default: null
    },
    quickList: {
      type: Array,

      default() {
        return [];
      }

    },
    // The total count is the length of the full QuickList, even if only
    // the first page is loaded
    quickListTotalCount: {
      type: Number,
      required: true
    }
  },
  emits: ['change', 'onLoadMoreButtonClick', 'save-order'],

  data() {
    return {
      dragging: false,
      trackedList: this.quickList || [],
      windowSize: null
    };
  },

  computed: {
    emptyQLText() {
      return this.$t("Looks like you haven't added <br>items to your Favorites. You can add <br>items to easily find them later.");
    },

    isDraggable() {
      // disable drag on all mobile devices
      if (this.isMobile) {
        return false;
      }

      return this.draggable && this.mutableList.length && !this.isMobile;
    },

    isMobile() {
      return this.windowSize < 1200;
    },

    mutableList: {
      get() {
        return this.trackedList;
      },

      set(newList) {
        this.trackedList = newList;
      }

    },

    quickListPanelContentClass() {
      return this.mutableList.length <= 2 ? 'nebula-quicklist-panel__content nebula-quicklist-panel__content--short-list' : 'nebula-quicklist-panel__content';
    }

  },

  mounted() {
    this.windowSize = window.innerWidth;
    window.addEventListener('resize', this.setWindowSize);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.setWindowSize);
  },

  methods: {
    getItemUrl(asset) {
      return `${this.itemPath}/${asset.id}?utm_source=${asset.id}&utm_medium=quicklist&utm_campaign=hublinks`;
    },

    handleChange(event) {
      const {
        newIndex,
        element
      } = event.moved;

      if (this.reorderHandler) {
        this.reorderHandler(this.mutableList, newIndex, element.id);
      } else {
        this.$emit('change', this.mutableList, newIndex, element.id);
      }
    },

    onDragEnd() {
      setTimeout(() => {
        this.dragging = false;
      }, 0);
    },

    preventClickWhileDragging(event) {
      if (this.dragging) event.preventDefault();
    },

    scrollToQuickListTop() {
      this.$refs.quickListPanel.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
    },

    setWindowSize() {
      this.windowSize = window.innerWidth;
      return null;
    }

  },
  watch: {
    quickList(newList) {
      // Whenever quicklist updates *externally* we update our
      // internal mutable copy
      this.trackedList = newList || [];
    },

    draggable(next) {
      // if setting draggable to false (disabling drag)
      if (!next) {
        this.$emit('save-order');
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/QuickList/NebulaQuickList.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/QuickList/NebulaQuickList.vue?vue&type=style&index=0&id=5d6ca8bc&lang=stylus
var NebulaQuickListvue_type_style_index_0_id_5d6ca8bc_lang_stylus = __webpack_require__("ec47");

// CONCATENATED MODULE: ./src/components/QuickList/NebulaQuickList.vue







const NebulaQuickList_exports_ = /*#__PURE__*/exportHelper_default()(NebulaQuickListvue_type_script_lang_js, [['render',NebulaQuickListvue_type_template_id_5d6ca8bc_render]])

/* harmony default export */ var NebulaQuickList = (NebulaQuickList_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Row/NebulaContentRow.vue?vue&type=template&id=455dbbe5

const NebulaContentRowvue_type_template_id_455dbbe5_hoisted_1 = {
  class: "nebula-content-row__text-wrapper"
};
const NebulaContentRowvue_type_template_id_455dbbe5_hoisted_2 = ["innerHTML"];
const NebulaContentRowvue_type_template_id_455dbbe5_hoisted_3 = ["innerHTML"];
const NebulaContentRowvue_type_template_id_455dbbe5_hoisted_4 = ["innerHTML"];
const NebulaContentRowvue_type_template_id_455dbbe5_hoisted_5 = {
  key: 0,
  class: "nebula-content-row__badges"
};
function NebulaContentRowvue_type_template_id_455dbbe5_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaBadge = Object(external_vue_["resolveComponent"])("NebulaBadge");

  const _component_ThumbnailLoader = Object(external_vue_["resolveComponent"])("ThumbnailLoader");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])(["nebula-content-row", `nebula-content-row--image-${$props.imageSide}`]),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [Object(external_vue_["createElementVNode"])("div", NebulaContentRowvue_type_template_id_455dbbe5_hoisted_1, [$props.title ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("h1", {
    key: 0,
    class: "nebula-content-row__title",
    innerHTML: $props.title
  }, null, 8, NebulaContentRowvue_type_template_id_455dbbe5_hoisted_2)) : Object(external_vue_["createCommentVNode"])("", true), $props.subtitle ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", {
    key: 1,
    class: "nebula-content-row__subtitle",
    innerHTML: $props.subtitle
  }, null, 8, NebulaContentRowvue_type_template_id_455dbbe5_hoisted_3)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("p", {
    class: "nebula-content-row__text",
    innerHTML: $props.text
  }, null, 8, NebulaContentRowvue_type_template_id_455dbbe5_hoisted_4), Object(external_vue_["renderSlot"])(_ctx.$slots, "extra", {}, () => [$props.badges ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaContentRowvue_type_template_id_455dbbe5_hoisted_5, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.badges, badge => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaBadge, Object(external_vue_["mergeProps"])({
      key: badge.text
    }, badge), null, 16);
  }), 128))])) : Object(external_vue_["createCommentVNode"])("", true)])]), $props.imageAssetId ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    key: 0,
    class: Object(external_vue_["normalizeClass"])(["nebula-content-row__image", `nebula-content-row__image--${$props.imageWidth}`])
  }, [Object(external_vue_["createVNode"])(_component_ThumbnailLoader, {
    assetId: $props.imageAssetId
  }, null, 8, ["assetId"])], 2)) : Object(external_vue_["createCommentVNode"])("", true)], 6);
}
// CONCATENATED MODULE: ./src/components/Row/NebulaContentRow.vue?vue&type=template&id=455dbbe5

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/utils/ThumbnailLoader.vue?vue&type=template&id=ff046410

const ThumbnailLoadervue_type_template_id_ff046410_hoisted_1 = {
  class: "thumbnail-loader"
};
const ThumbnailLoadervue_type_template_id_ff046410_hoisted_2 = ["src", "alt"];
const ThumbnailLoadervue_type_template_id_ff046410_hoisted_3 = {
  key: 1,
  class: "nebula-screenreader-only"
};
function ThumbnailLoadervue_type_template_id_ff046410_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", ThumbnailLoadervue_type_template_id_ff046410_hoisted_1, [$data.loading || $data.loaded ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    key: 0,
    class: Object(external_vue_["normalizeClass"])(["thumbnail-loader__inner nebula-thumbnail__inner", $data.loading && !$data.loaded ? 'nebula-thumbnail__inner--thumbnail-loading' : 'nebula-thumbnail__inner--thumbnail-loaded']),
    style: Object(external_vue_["normalizeStyle"])($data.imageExists ? 'background-image: url( ' + $options.thumbnailUrl + ' )' : false)
  }, [$data.imageExists ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("img", {
    key: 0,
    src: $options.thumbnailUrl,
    alt: $props.alt,
    class: "nebula-thumbnail__print-only-image",
    onError: _cache[0] || (_cache[0] = (...args) => $options.setIconFallback && $options.setIconFallback(...args))
  }, null, 40, ThumbnailLoadervue_type_template_id_ff046410_hoisted_2)) : Object(external_vue_["createCommentVNode"])("", true), $props.alt ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", ThumbnailLoadervue_type_template_id_ff046410_hoisted_3, Object(external_vue_["toDisplayString"])($props.alt), 1)) : Object(external_vue_["createCommentVNode"])("", true)], 6)) : Object(external_vue_["createCommentVNode"])("", true), $data.showIconFallback ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
    key: 1,
    alt: $props.alt,
    class: Object(external_vue_["normalizeClass"])(["nebula-thumbnail__icon", $data.loading && 'thumbnail-loader__fade-out']),
    symbolId: $options.iconId
  }, null, 8, ["alt", "class", "symbolId"])) : Object(external_vue_["createCommentVNode"])("", true)]);
}
// CONCATENATED MODULE: ./src/utils/ThumbnailLoader.vue?vue&type=template&id=ff046410

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/utils/ThumbnailLoader.vue?vue&type=script&lang=js


/* harmony default export */ var ThumbnailLoadervue_type_script_lang_js = ({
  name: 'ThumbnailLoader',

  data() {
    return {
      availableIcons: nebulaIconNames(),
      imageError: false,
      imageExists: false,
      loading: false,
      loaded: false,
      showIconFallback: true
    };
  },

  components: {
    NebulaIcon: NebulaIcon
  },

  mounted() {
    // allow time for image to error before setting status
    setTimeout(() => {
      this.setImageStatus();
    }, 200);
  },

  props: {
    assetType: String,
    assetId: {
      type: String,
      validator: prop => typeof prop === 'string' || prop === null || prop === undefined
    },
    imageSize: {
      type: String,
      default: 'small',
      validator: size => ['small', 'medium', 'large', 'xlarge'].indexOf(size) !== -1
    },
    alt: {
      type: String,
      default: ''
    },
    thumbnailUrlOverride: {
      type: String
    },
    coreStaticAssetsPath: {
      type: String
    }
  },
  computed: {
    iconId() {
      if (this.assetType) {
        const assetTypeSlug = this.assetType.toLowerCase().replace(/[^a-z]/gi, '-');

        if (this.availableIcons.includes(`asset-${assetTypeSlug}`)) {
          return `asset-${assetTypeSlug}`;
        }
      }

      return 'asset-document';
    },

    thumbnailUrl() {
      if (this.coreStaticAssetsPath) return `${window.paths.core_static}common/assets${this.coreStaticAssetsPath}`;
      if (this.thumbnailUrlOverride) return this.thumbnailUrlOverride;
      return `https://d1m0scxbrw6oep.cloudfront.net/thumbnails/${this.assetId}-${this.imageSize}`;
    }

  },
  methods: {
    setImageStatus() {
      if (!this.imageError) {
        setTimeout(() => {
          // allow time for thumbnail to be on page but hidden with opacity: 0
          this.loading = true; // allow time for icon fade out

          setTimeout(() => {
            this.imageExists = true;
            this.showIconFallback = false; // allow time for image fade in

            setTimeout(() => {
              this.loaded = true;
            }, 200);
          }, 150);
        }, 200);
      }
    },

    iconDisplayName(id) {
      return id.split('-').filter(part => !!part).map(part => `${part[0].toUpperCase()}${part.slice(1)}`).join(' ');
    },

    setIconFallback() {
      this.onerror = null;
      this.loading = false;
      this.loaded = false;
      this.imageError = true;
      this.imageExists = false;
      this.showIconFallback = true;
    }

  }
});
// CONCATENATED MODULE: ./src/utils/ThumbnailLoader.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/utils/ThumbnailLoader.vue?vue&type=style&index=0&id=ff046410&lang=stylus
var ThumbnailLoadervue_type_style_index_0_id_ff046410_lang_stylus = __webpack_require__("e4fa");

// CONCATENATED MODULE: ./src/utils/ThumbnailLoader.vue







const ThumbnailLoader_exports_ = /*#__PURE__*/exportHelper_default()(ThumbnailLoadervue_type_script_lang_js, [['render',ThumbnailLoadervue_type_template_id_ff046410_render]])

/* harmony default export */ var ThumbnailLoader = (ThumbnailLoader_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Row/NebulaContentRow.vue?vue&type=script&lang=js



/* harmony default export */ var NebulaContentRowvue_type_script_lang_js = ({
  name: 'NebulaContentRow',
  mixins: [themingUtils],
  components: {
    NebulaBadge: NebulaBadge,
    ThumbnailLoader: ThumbnailLoader
  },
  props: {
    badges: {
      type: Array,
      default: null
    },
    imageAssetId: {
      type: String,
      required: true
    },
    imageSide: {
      type: String,
      default: 'right',
      validator: val => {
        const valid = ['left', 'right'];
        return valid.includes(val);
      }
    },
    imageWidth: {
      type: String,
      default: 'm',
      validator: val => {
        const valid = ['s', 'm', 'l'];
        return valid.includes(val);
      }
    },
    subtitle: {
      type: String,
      default: null
    },
    text: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: null
    }
  }
});
// CONCATENATED MODULE: ./src/components/Row/NebulaContentRow.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Row/NebulaContentRow.vue?vue&type=style&index=0&id=455dbbe5&lang=stylus
var NebulaContentRowvue_type_style_index_0_id_455dbbe5_lang_stylus = __webpack_require__("20cc");

// CONCATENATED MODULE: ./src/components/Row/NebulaContentRow.vue







const NebulaContentRow_exports_ = /*#__PURE__*/exportHelper_default()(NebulaContentRowvue_type_script_lang_js, [['render',NebulaContentRowvue_type_template_id_455dbbe5_render]])

/* harmony default export */ var NebulaContentRow = (NebulaContentRow_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Row/NebulaFeatureRow.vue?vue&type=template&id=10768716

const NebulaFeatureRowvue_type_template_id_10768716_hoisted_1 = {
  class: "nebula-feature-row__banner-area"
};
const NebulaFeatureRowvue_type_template_id_10768716_hoisted_2 = {
  class: "nebula-feature-row__content-area"
};
const NebulaFeatureRowvue_type_template_id_10768716_hoisted_3 = {
  class: "nebula-feature-row__title"
};
const NebulaFeatureRowvue_type_template_id_10768716_hoisted_4 = {
  key: 1,
  class: "nebula-feature-row__subtitle"
};
const NebulaFeatureRowvue_type_template_id_10768716_hoisted_5 = {
  class: "nebula-feature-row__description"
};
const NebulaFeatureRowvue_type_template_id_10768716_hoisted_6 = {
  key: 2,
  class: "nebula-feature-row__actions"
};
const NebulaFeatureRowvue_type_template_id_10768716_hoisted_7 = {
  class: "nebula-feature-row__image-area"
};
const NebulaFeatureRowvue_type_template_id_10768716_hoisted_8 = ["src", "alt"];
const NebulaFeatureRowvue_type_template_id_10768716_hoisted_9 = {
  key: 0,
  class: "nebula-feature-row__preview-slides"
};
const NebulaFeatureRowvue_type_template_id_10768716_hoisted_10 = {
  class: "nebula-feature-row__preview-slide-carousel"
};
const NebulaFeatureRowvue_type_template_id_10768716_hoisted_11 = {
  class: "nebula-feature-row__preview-slide-carousel-inner"
};
const NebulaFeatureRowvue_type_template_id_10768716_hoisted_12 = ["src", "alt"];
function NebulaFeatureRowvue_type_template_id_10768716_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaBadge = Object(external_vue_["resolveComponent"])("NebulaBadge");

  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.className),
    style: Object(external_vue_["normalizeStyle"])($options.cssProps)
  }, [Object(external_vue_["createElementVNode"])("div", NebulaFeatureRowvue_type_template_id_10768716_hoisted_1, [Object(external_vue_["createElementVNode"])("div", NebulaFeatureRowvue_type_template_id_10768716_hoisted_2, [Object(external_vue_["renderSlot"])(_ctx.$slots, "content", {}, () => [$props.badgeText ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaBadge, {
    key: 0,
    class: "nebula-feature-row__badge",
    color: "gray"
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])($props.badgeText), 1)]),
    _: 1
  })) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("h1", NebulaFeatureRowvue_type_template_id_10768716_hoisted_3, Object(external_vue_["toDisplayString"])($props.title), 1), $props.subtitle ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", NebulaFeatureRowvue_type_template_id_10768716_hoisted_4, Object(external_vue_["toDisplayString"])($props.subtitle), 1)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["renderSlot"])(_ctx.$slots, "metadata"), Object(external_vue_["createElementVNode"])("p", NebulaFeatureRowvue_type_template_id_10768716_hoisted_5, Object(external_vue_["toDisplayString"])($props.description), 1), $props.actions ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaFeatureRowvue_type_template_id_10768716_hoisted_6, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.actions, (item, i) => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
      key: i,
      class: Object(external_vue_["normalizeClass"])(i == 0 ? 'nebula-feature-row__action--primary' : 'nebula-feature-row__action--secondary'),
      text: item.text,
      "icon-left": item.iconLeft,
      "icon-right": item.iconRight,
      link: item.link,
      routerLink: item.routerLink,
      target: item.target
    }, null, 8, ["class", "text", "icon-left", "icon-right", "link", "routerLink", "target"]);
  }), 128))])) : Object(external_vue_["createCommentVNode"])("", true)])]), Object(external_vue_["createElementVNode"])("div", NebulaFeatureRowvue_type_template_id_10768716_hoisted_7, [Object(external_vue_["createElementVNode"])("img", {
    src: $props.image,
    alt: $props.imageAlt,
    class: Object(external_vue_["normalizeClass"])($props.imageFit == 'cover' ? 'nebula-feature-row__image nebula-feature-row__image--cover' : 'nebula-feature-row__image')
  }, null, 10, NebulaFeatureRowvue_type_template_id_10768716_hoisted_8)])]), $props.previewSlides ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaFeatureRowvue_type_template_id_10768716_hoisted_9, [Object(external_vue_["withDirectives"])(Object(external_vue_["createVNode"])(_component_NebulaButton, {
    class: "nebula-feature-row__preview-slide-carousel-control nebula-feature-row__preview-slide-carousel-control--start",
    "icon-left": "caret-left",
    shape: "pill",
    onClick: _cache[0] || (_cache[0] = $event => $options.scrollCarousel('left'))
  }, null, 512), [[external_vue_["vShow"], $data.showCarouselControls]]), Object(external_vue_["createElementVNode"])("div", NebulaFeatureRowvue_type_template_id_10768716_hoisted_10, [Object(external_vue_["createElementVNode"])("div", NebulaFeatureRowvue_type_template_id_10768716_hoisted_11, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.previewSlides, (item, i) => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])(item.link ? item.routerLink ? 'router-link' : 'a' : $props.actions[0].routerLink ? 'router-link' : 'a'), {
      key: i,
      to: item.routerLink ? item.link : $props.actions[0].routerLink ? $props.actions[0].link : null,
      href: !item.routerLink ? item.link : !$props.actions[0].routerLink ? $props.actions[0].link : null,
      class: Object(external_vue_["normalizeClass"])(['nebula-feature-row__preview-slide', {
        'nebula-feature-row__preview-slide--enlarge': $props.enlarge
      }])
    }, {
      default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("img", {
        class: "nebula-feature-row__preview-slide-image",
        src: item.image,
        alt: item.imageAlt,
        onLoad: _cache[1] || (_cache[1] = (...args) => $options.checkCarouselControls && $options.checkCarouselControls(...args))
      }, null, 40, NebulaFeatureRowvue_type_template_id_10768716_hoisted_12)]),
      _: 2
    }, 1032, ["to", "href", "class"]);
  }), 128))])]), Object(external_vue_["withDirectives"])(Object(external_vue_["createVNode"])(_component_NebulaButton, {
    class: "nebula-feature-row__preview-slide-carousel-control nebula-feature-row__preview-slide-carousel-control--end",
    "icon-left": "caret-right",
    shape: "pill",
    onClick: _cache[2] || (_cache[2] = $event => $options.scrollCarousel('right'))
  }, null, 512), [[external_vue_["vShow"], $data.showCarouselControls]])])) : Object(external_vue_["createCommentVNode"])("", true)], 6);
}
// CONCATENATED MODULE: ./src/components/Row/NebulaFeatureRow.vue?vue&type=template&id=10768716

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Row/NebulaFeatureRow.vue?vue&type=script&lang=js



/* harmony default export */ var NebulaFeatureRowvue_type_script_lang_js = ({
  name: 'NebulaFeatureRow',
  components: {
    NebulaButton: NebulaButton,
    NebulaBadge: NebulaBadge
  },
  mixins: [themingUtils],
  props: {
    actions: {
      type: Array,
      default: null
    },
    badgeText: {
      type: String,
      default: null
    },
    description: {
      type: String
    },
    hideImageOnMobile: {
      type: Boolean,
      default: false
    },
    image: {
      type: String
    },
    imageAlt: {
      type: String,
      default: null
    },
    imageFit: {
      type: String,
      default: 'contain',
      enum: ['contain', 'cover'] // for docs site

    },
    imagePosition: {
      type: String,
      default: 'right',
      enum: ['left', 'right'] // for docs site

    },
    imageLink: {
      type: String,
      default: null
    },
    previewSlides: {
      type: Array,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    title: {
      type: String
    },
    enlarge: {
      type: Boolean
    }
  },

  data() {
    return {
      showCarouselControls: null
    };
  },

  computed: {
    className() {
      const className = ['nebula-feature-row', {
        'nebula-feature-row--image-left': this.imagePosition === 'left',
        'nebula-feature-row--has-slides': this.previewSlides
      }];
      return className;
    },

    cssProps() {
      // this will override the mixin to handle this special var for slide count
      return this.cssPropsCompute(this.customStyles, 'nebula', customProps => {
        if (this.previewSlides) {
          // eslint-disable-next-line no-param-reassign
          customProps['--nebula-slide-count'] = this.previewSlides.length;
        }
      });
    }

  },

  created() {
    window.addEventListener('resize', this.checkCarouselControls);
  },

  unmounted() {
    window.removeEventListener('resize', this.checkCarouselControls);
  },

  methods: {
    scrollCarousel(direction) {
      const carousel = this.$el.querySelector('.nebula-feature-row__preview-slide-carousel');
      const carouselItem = this.$el.querySelector('.nebula-feature-row__preview-slide');
      const carouselItemWidth = carouselItem.offsetWidth;

      if (direction === 'left') {
        carousel.scrollBy(-carouselItemWidth, 0);
      }

      if (direction === 'right') {
        carousel.scrollBy(carouselItemWidth, 0);
      }
    },

    checkCarouselControls() {
      if (this.previewSlides) {
        const carousel = this.$el.querySelector('.nebula-feature-row__preview-slide-carousel');
        this.showCarouselControls = carousel.scrollWidth > carousel.clientWidth;
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/Row/NebulaFeatureRow.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Row/NebulaFeatureRow.vue?vue&type=style&index=0&id=10768716&lang=stylus
var NebulaFeatureRowvue_type_style_index_0_id_10768716_lang_stylus = __webpack_require__("e023");

// CONCATENATED MODULE: ./src/components/Row/NebulaFeatureRow.vue







const NebulaFeatureRow_exports_ = /*#__PURE__*/exportHelper_default()(NebulaFeatureRowvue_type_script_lang_js, [['render',NebulaFeatureRowvue_type_template_id_10768716_render]])

/* harmony default export */ var NebulaFeatureRow = (NebulaFeatureRow_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Row/NebulaImageRow.vue?vue&type=template&id=331fb13c

function NebulaImageRowvue_type_template_id_331fb13c_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ThumbnailLoader = Object(external_vue_["resolveComponent"])("ThumbnailLoader");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])(["nebula-image-row", $props.classes]),
    style: Object(external_vue_["normalizeStyle"])($options.wrapperStyles)
  }, [Object(external_vue_["createVNode"])(_component_ThumbnailLoader, Object(external_vue_["mergeProps"])({
    class: ""
  }, _ctx.$attrs), null, 16)], 6);
}
// CONCATENATED MODULE: ./src/components/Row/NebulaImageRow.vue?vue&type=template&id=331fb13c

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Row/NebulaImageRow.vue?vue&type=script&lang=js

const sideCSSMap = {
  left: 'border-inline-start',
  right: 'border-inline-end',
  top: 'border-block-start',
  bottom: 'border-block-end'
};
/* harmony default export */ var NebulaImageRowvue_type_script_lang_js = ({
  name: 'NebulaImageRow',
  components: {
    ThumbnailLoader: ThumbnailLoader
  },
  props: {
    borderColor: {
      type: String,
      default: '#0077D1'
    },
    borderSide: {
      type: String,
      default: 'bottom',

      validator(val) {
        const allowed = ['left', 'right', 'top', 'bottom'];
        return allowed.includes(val);
      }

    },
    borderWidth: {
      type: Number,
      default: 10
    },
    classes: {
      type: String,
      default: null
    },
    height: {
      type: Number,
      default: 300
    }
  },
  inheritAttrs: false,
  computed: {
    wrapperStyles() {
      const borderSide = sideCSSMap[this.borderSide];
      return {
        height: `${this.height}px`,
        [borderSide]: `solid ${this.borderWidth}px ${this.borderColor}`
      };
    }

  }
});
// CONCATENATED MODULE: ./src/components/Row/NebulaImageRow.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Row/NebulaImageRow.vue?vue&type=style&index=0&id=331fb13c&lang=stylus
var NebulaImageRowvue_type_style_index_0_id_331fb13c_lang_stylus = __webpack_require__("7dfa");

// CONCATENATED MODULE: ./src/components/Row/NebulaImageRow.vue







const NebulaImageRow_exports_ = /*#__PURE__*/exportHelper_default()(NebulaImageRowvue_type_script_lang_js, [['render',NebulaImageRowvue_type_template_id_331fb13c_render]])

/* harmony default export */ var NebulaImageRow = (NebulaImageRow_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Row/NebulaRow.vue?vue&type=template&id=7ab5d144

const NebulaRowvue_type_template_id_7ab5d144_hoisted_1 = {
  class: "nebula-row"
};
const NebulaRowvue_type_template_id_7ab5d144_hoisted_2 = {
  class: "nebula-row__inner"
};
function NebulaRowvue_type_template_id_7ab5d144_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaRowvue_type_template_id_7ab5d144_hoisted_1, [Object(external_vue_["createElementVNode"])("div", NebulaRowvue_type_template_id_7ab5d144_hoisted_2, [Object(external_vue_["renderSlot"])(_ctx.$slots, "default", {}, () => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(_ctx.content), 1)])])]);
}
// CONCATENATED MODULE: ./src/components/Row/NebulaRow.vue?vue&type=template&id=7ab5d144

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Row/NebulaRow.vue?vue&type=script&lang=js
/* harmony default export */ var NebulaRowvue_type_script_lang_js = ({
  name: 'NebulaRow'
});
// CONCATENATED MODULE: ./src/components/Row/NebulaRow.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Row/NebulaRow.vue?vue&type=style&index=0&id=7ab5d144&lang=stylus
var NebulaRowvue_type_style_index_0_id_7ab5d144_lang_stylus = __webpack_require__("7702");

// CONCATENATED MODULE: ./src/components/Row/NebulaRow.vue







const NebulaRow_exports_ = /*#__PURE__*/exportHelper_default()(NebulaRowvue_type_script_lang_js, [['render',NebulaRowvue_type_template_id_7ab5d144_render]])

/* harmony default export */ var NebulaRow = (NebulaRow_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Sidebar/NebulaIconSidebar.vue?vue&type=template&id=051a6281

const NebulaIconSidebarvue_type_template_id_051a6281_hoisted_1 = ["aria-expanded"];
const NebulaIconSidebarvue_type_template_id_051a6281_hoisted_2 = ["id"];
const NebulaIconSidebarvue_type_template_id_051a6281_hoisted_3 = {
  key: 0,
  class: "nebula-icon-sidebar__section-header"
};
const NebulaIconSidebarvue_type_template_id_051a6281_hoisted_4 = {
  class: "nebula-icon-sidebar__section-items"
};
function NebulaIconSidebarvue_type_template_id_051a6281_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  const _component_NebulaTitleTooltip = Object(external_vue_["resolveComponent"])("NebulaTitleTooltip");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("nav", {
    class: Object(external_vue_["normalizeClass"])(["nebula-icon-sidebar", {
      'nebula-icon-sidebar--collapsed': $data.isCollapsed,
      'nebula-icon-sidebar--expanded': !$data.isCollapsed
    }]),
    "aria-expanded": $data.isCollapsed ? 'false' : 'true',
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
    class: "nebula-icon-sidebar__toggle-nav-button",
    "aria-controls": $options.sidebarId,
    "aria-expanded": $options.sidebarOpen.toString(),
    "aria-label": $data.isCollapsed ? _ctx.$t('Expand Sidebar') : _ctx.$t('Collapse Sidebar'),
    iconLeft: $data.isCollapsed ? 'sidebar-expand' : 'sidebar-collapse',
    shape: "pill",
    size: "s",
    onClick: $options.handleCollapse
  }, null, 8, ["aria-controls", "aria-expanded", "aria-label", "iconLeft", "onClick"]), Object(external_vue_["createElementVNode"])("div", {
    class: "nebula-icon-sidebar__inner",
    id: $options.sidebarId
  }, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.sections, (section, sectionIndex) => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
      key: sectionIndex,
      class: "nebula-icon-sidebar__section"
    }, [section.title ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("h6", NebulaIconSidebarvue_type_template_id_051a6281_hoisted_3, Object(external_vue_["toDisplayString"])(section.title), 1)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("ul", NebulaIconSidebarvue_type_template_id_051a6281_hoisted_4, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(section.items, (item, itemIndex) => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
        key: itemIndex,
        class: Object(external_vue_["normalizeClass"])(["nebula-icon-sidebar__section-item", item.active && 'nebula-icon-sidebar__section-item--active'])
      }, [Object(external_vue_["createVNode"])(_component_NebulaTitleTooltip, {
        class: "nebula-icon-sidebar__section-item-tooltip",
        position: "inline-end",
        text: item.text
      }, {
        default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createVNode"])(_component_NebulaButton, {
          class: "nebula-icon-sidebar__section-item-button",
          link: item.url,
          "aria-label": item.ariaLabel || item.text,
          text: item.text,
          "icon-left": item.iconLeft,
          "icon-right": item.iconRight,
          shape: $data.isCollapsed ? 'square' : 'pill',
          type: "flat",
          size: "s",
          usePushState: item.usePushState,
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('item-click'))
        }, null, 8, ["link", "aria-label", "text", "icon-left", "icon-right", "shape", "usePushState"])]),
        _: 2
      }, 1032, ["text"])], 2);
    }), 128))])]);
  }), 128))], 8, NebulaIconSidebarvue_type_template_id_051a6281_hoisted_2)], 14, NebulaIconSidebarvue_type_template_id_051a6281_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/Sidebar/NebulaIconSidebar.vue?vue&type=template&id=051a6281

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Sidebar/NebulaIconSidebar.vue?vue&type=script&lang=js




/* harmony default export */ var NebulaIconSidebarvue_type_script_lang_js = ({
  name: 'NebulaIconSidebar',
  mixins: [themingUtils],
  components: {
    NebulaButton: NebulaButton,
    NebulaTitleTooltip: NebulaTitleTooltip
  },
  props: {
    id: {
      type: String,
      default: null
    },
    sections: {
      type: Array,
      required: true
    },
    startCollapsed: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ['item-click', 'sidebar-collapsed'],

  data() {
    return {
      isCollapsed: this.startCollapsed
    };
  },

  computed: {
    randomStringId() {
      return randomStringId();
    },

    sidebarId() {
      let sidebarId = '';

      if (this.id) {
        sidebarId = this.id;
      } else {
        sidebarId = `nebula-sidebar--${this.randomStringId}`;
      }

      return sidebarId;
    },

    sidebarOpen() {
      return !this.isCollapsed;
    }

  },
  methods: {
    handleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      this.$emit('sidebar-collapsed', this.isCollapsed);
    }

  }
});
// CONCATENATED MODULE: ./src/components/Sidebar/NebulaIconSidebar.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Sidebar/NebulaIconSidebar.vue?vue&type=style&index=0&id=051a6281&lang=stylus
var NebulaIconSidebarvue_type_style_index_0_id_051a6281_lang_stylus = __webpack_require__("77f6");

// CONCATENATED MODULE: ./src/components/Sidebar/NebulaIconSidebar.vue







const NebulaIconSidebar_exports_ = /*#__PURE__*/exportHelper_default()(NebulaIconSidebarvue_type_script_lang_js, [['render',NebulaIconSidebarvue_type_template_id_051a6281_render]])

/* harmony default export */ var NebulaIconSidebar = (NebulaIconSidebar_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Table/NebulaTable.vue?vue&type=template&id=7ed75fd4

const NebulaTablevue_type_template_id_7ed75fd4_hoisted_1 = {
  key: 0,
  class: "nebula-table"
};
const NebulaTablevue_type_template_id_7ed75fd4_hoisted_2 = {
  key: 0,
  class: "nebula-table__head"
};
const NebulaTablevue_type_template_id_7ed75fd4_hoisted_3 = {
  class: "nebula-table__row"
};
const NebulaTablevue_type_template_id_7ed75fd4_hoisted_4 = {
  key: 1
};
const NebulaTablevue_type_template_id_7ed75fd4_hoisted_5 = ["href"];
const NebulaTablevue_type_template_id_7ed75fd4_hoisted_6 = {
  key: 1
};
function NebulaTablevue_type_template_id_7ed75fd4_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaTableHeader = Object(external_vue_["resolveComponent"])("NebulaTableHeader");

  const _component_NebulaTableCell = Object(external_vue_["resolveComponent"])("NebulaTableCell");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.tableClasses),
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [$props.tableData ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("table", NebulaTablevue_type_template_id_7ed75fd4_hoisted_1, [$options.headers ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("thead", NebulaTablevue_type_template_id_7ed75fd4_hoisted_2, [Object(external_vue_["createElementVNode"])("tr", NebulaTablevue_type_template_id_7ed75fd4_hoisted_3, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.headers, (header, index) => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaTableHeader, {
      key: index,
      text: header.text
    }, null, 8, ["text"]);
  }), 128))])])) : Object(external_vue_["createCommentVNode"])("", true), $options.rows ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("tbody", NebulaTablevue_type_template_id_7ed75fd4_hoisted_4, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.rows, (row, idx) => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("tr", {
      class: "nebula-table__row",
      key: idx
    }, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(Object.keys(row), key => {
      return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaTableCell, {
        key: key,
        responsiveLabel: key
      }, {
        tableCell: Object(external_vue_["withCtx"])(() => [row[key].href ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("a", {
          key: 0,
          href: row[key].href
        }, Object(external_vue_["toDisplayString"])(row[key].text), 9, NebulaTablevue_type_template_id_7ed75fd4_hoisted_5)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", NebulaTablevue_type_template_id_7ed75fd4_hoisted_6, Object(external_vue_["toDisplayString"])(row[key].text || row[key]), 1))]),
        _: 2
      }, 1032, ["responsiveLabel"]);
    }), 128))]);
  }), 128))])) : Object(external_vue_["createCommentVNode"])("", true)])) : Object(external_vue_["renderSlot"])(_ctx.$slots, "table", {
    key: 1
  })], 6);
}
// CONCATENATED MODULE: ./src/components/Table/NebulaTable.vue?vue&type=template&id=7ed75fd4

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Table/NebulaTableHeader.vue?vue&type=template&id=f28aff2e

const NebulaTableHeadervue_type_template_id_f28aff2e_hoisted_1 = ["colspan", "rowspan", "aria-sort"];
const NebulaTableHeadervue_type_template_id_f28aff2e_hoisted_2 = ["textContent"];
const NebulaTableHeadervue_type_template_id_f28aff2e_hoisted_3 = ["href", "aria-label"];
const NebulaTableHeadervue_type_template_id_f28aff2e_hoisted_4 = ["textContent"];
const NebulaTableHeadervue_type_template_id_f28aff2e_hoisted_5 = ["aria-label"];
const NebulaTableHeadervue_type_template_id_f28aff2e_hoisted_6 = ["textContent"];
const NebulaTableHeadervue_type_template_id_f28aff2e_hoisted_7 = ["textContent"];
function NebulaTableHeadervue_type_template_id_f28aff2e_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  const _component_router_link = Object(external_vue_["resolveComponent"])("router-link");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("th", {
    class: Object(external_vue_["normalizeClass"])($options.tableHeaderClassName),
    colspan: $props.colspan,
    rowspan: $props.rowspan,
    "aria-sort": $options.getAriaSort
  }, [$props.routerLink ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_router_link, {
    key: 0,
    class: "nebula-table__header-link",
    to: $props.link,
    "aria-label": $props.ariaLabel ? $props.ariaLabel : false
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createElementVNode"])("span", {
      class: "nebula-table__header-text",
      textContent: Object(external_vue_["toDisplayString"])($props.text)
    }, null, 8, NebulaTableHeadervue_type_template_id_f28aff2e_hoisted_2), $props.isSortable ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
      key: 0,
      class: "nebula-table__header-icon",
      symbolId: $options.getTableSortIcon,
      size: "s"
    }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true)]),
    _: 1
  }, 8, ["to", "aria-label"])) : $props.link ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("a", {
    key: 1,
    class: Object(external_vue_["normalizeClass"])(["nebula-table__header-link", $props.usePushState && 'do-push-state']),
    href: $props.link,
    "aria-label": $props.ariaLabel ? $props.ariaLabel : false
  }, [Object(external_vue_["createElementVNode"])("span", {
    class: "nebula-table__header-text",
    textContent: Object(external_vue_["toDisplayString"])($props.text)
  }, null, 8, NebulaTableHeadervue_type_template_id_f28aff2e_hoisted_4), $props.isSortable ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
    key: 0,
    class: "nebula-table__header-icon",
    symbolId: $options.getTableSortIcon,
    size: "s"
  }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true)], 10, NebulaTableHeadervue_type_template_id_f28aff2e_hoisted_3)) : $props.button ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("button", {
    key: 2,
    class: "nebula-table__header-button",
    "aria-label": $props.ariaLabel ? $props.ariaLabel : false
  }, [Object(external_vue_["createElementVNode"])("span", {
    class: "nebula-table__header-text",
    textContent: Object(external_vue_["toDisplayString"])($props.text)
  }, null, 8, NebulaTableHeadervue_type_template_id_f28aff2e_hoisted_6), $props.isSortable ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaIcon, {
    key: 0,
    class: "nebula-table__header-icon",
    symbolId: $options.getTableSortIcon,
    size: "s"
  }, null, 8, ["symbolId"])) : Object(external_vue_["createCommentVNode"])("", true)], 8, NebulaTableHeadervue_type_template_id_f28aff2e_hoisted_5)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", {
    key: 3,
    class: "nebula-table__header-text",
    textContent: Object(external_vue_["toDisplayString"])($props.text)
  }, null, 8, NebulaTableHeadervue_type_template_id_f28aff2e_hoisted_7))], 10, NebulaTableHeadervue_type_template_id_f28aff2e_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/Table/NebulaTableHeader.vue?vue&type=template&id=f28aff2e

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Table/NebulaTableHeader.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaTableHeadervue_type_script_lang_js = ({
  name: 'NebulaTableHeader',
  components: {
    NebulaIcon: NebulaIcon
  },
  props: {
    colspan: {
      type: [Number, String],
      default: null
    },
    isActiveSort: {
      type: Boolean,
      default: false
    },
    isAscending: {
      type: Boolean,
      default: false
    },
    button: {
      type: Boolean,
      default: false
    },
    isSortable: {
      type: Boolean,
      default: false
    },
    link: {
      type: String,
      default: null
    },
    routerLink: {
      type: Boolean,
      default: false
    },
    rowspan: {
      type: [Number, String],
      default: null
    },
    text: {
      type: String
    },
    usePushState: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  computed: {
    getAriaSort() {
      if (!this.isSortable) {
        return false;
      }

      if (!this.isActiveSort) {
        return false;
      }

      if (this.isAscending) {
        return 'ascending';
      }

      return 'descending';
    },

    getTableSortIcon() {
      let iconName = '';

      if (!this.isActiveSort) {
        iconName = 'sortable';
      } else if (this.isAscending) {
        iconName = 'sort-asc';
      } else {
        iconName = 'sort-desc';
      }

      return iconName;
    },

    tableHeaderClassName() {
      const className = ['nebula-table__header', {
        'nebula-table__header--sortable': this.isSortable === true
      }];
      return className;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Table/NebulaTableHeader.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Table/NebulaTableHeader.vue?vue&type=style&index=0&id=f28aff2e&lang=stylus
var NebulaTableHeadervue_type_style_index_0_id_f28aff2e_lang_stylus = __webpack_require__("d17d");

// CONCATENATED MODULE: ./src/components/Table/NebulaTableHeader.vue







const NebulaTableHeader_exports_ = /*#__PURE__*/exportHelper_default()(NebulaTableHeadervue_type_script_lang_js, [['render',NebulaTableHeadervue_type_template_id_f28aff2e_render]])

/* harmony default export */ var NebulaTableHeader = (NebulaTableHeader_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Table/NebulaTableCell.vue?vue&type=template&id=49eb0797

const NebulaTableCellvue_type_template_id_49eb0797_hoisted_1 = ["data-label"];
const NebulaTableCellvue_type_template_id_49eb0797_hoisted_2 = ["data-label"];
function NebulaTableCellvue_type_template_id_49eb0797_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("td", {
    class: "nebula-table__cell",
    "data-label": $props.responsiveLabel
  }, [Object(external_vue_["createElementVNode"])("span", {
    "aria-hidden": "true",
    class: "nebula-table__cell-responsive-header",
    "data-label": $props.responsiveLabel
  }, null, 8, NebulaTableCellvue_type_template_id_49eb0797_hoisted_2), Object(external_vue_["renderSlot"])(_ctx.$slots, "tableCell")], 8, NebulaTableCellvue_type_template_id_49eb0797_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/Table/NebulaTableCell.vue?vue&type=template&id=49eb0797

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Table/NebulaTableCell.vue?vue&type=script&lang=js
/* harmony default export */ var NebulaTableCellvue_type_script_lang_js = ({
  name: 'NebulaTableCell',
  props: {
    responsiveLabel: {
      type: String,
      default: null
    }
  }
});
// CONCATENATED MODULE: ./src/components/Table/NebulaTableCell.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Table/NebulaTableCell.vue?vue&type=style&index=0&id=49eb0797&lang=stylus
var NebulaTableCellvue_type_style_index_0_id_49eb0797_lang_stylus = __webpack_require__("d56c");

// CONCATENATED MODULE: ./src/components/Table/NebulaTableCell.vue







const NebulaTableCell_exports_ = /*#__PURE__*/exportHelper_default()(NebulaTableCellvue_type_script_lang_js, [['render',NebulaTableCellvue_type_template_id_49eb0797_render]])

/* harmony default export */ var NebulaTableCell = (NebulaTableCell_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Table/NebulaTable.vue?vue&type=script&lang=js



/* harmony default export */ var NebulaTablevue_type_script_lang_js = ({
  name: 'NebulaTable',
  mixins: [themingUtils],
  props: {
    containsRowspan: {
      type: Boolean,
      default: false
    },
    disableMobileView: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Object
    },
    zebraStripe: {
      type: Boolean,
      default: false
    }
  },
  components: {
    NebulaTableHeader: NebulaTableHeader,
    NebulaTableCell: NebulaTableCell
  },
  computed: {
    headers() {
      let {
        headers
      } = this.$props.tableData; // if headers are not passed in

      if (!headers) {
        // reset as an empty array
        headers = [];
        const {
          rows
        } = this.$props.tableData;
        const firstRow = rows[0]; // and populate with keys of first row
        // this will use the defaults for isActiveSort, isAscending, and isSortable

        Object.keys(firstRow).forEach(header => {
          const toAdd = {
            text: header
          };
          headers.push(toAdd);
        });
      }

      headers.forEach((header, idx) => {
        const {
          text
        } = header;
        const cleanHeader = header; // if text is missing, just pass an empty string so we keep the spot in the table grid

        if (!text) {
          cleanHeader.text = '';
        }

        headers[idx] = this.setHeaderDefaults(cleanHeader);
      });
      return headers;
    },

    rows() {
      const {
        rows
      } = this.$props.tableData;
      return rows;
    },

    tableClasses() {
      return ['nebula-table__container', {
        'nebula-table__container--disable-mobile-view': this.disableMobileView,
        'nebula-table__container--contains-rowspan': this.containsRowspan,
        'nebula-table__container--zebra-stripe': this.zebraStripe
      }];
    }

  },
  methods: {
    setHeaderDefaults(header) {
      const parsed = header;
      const defaults = {
        isActiveSort: false,
        isAscending: false,
        isSortable: true,
        ariaLabel: null
      };
      Object.keys(defaults).forEach(attribute => {
        // if the header property is not set
        if (header[attribute] === undefined) {
          // apply the default value
          parsed[attribute] = defaults[attribute];
        }
      });
      return parsed;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Table/NebulaTable.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Table/NebulaTable.vue?vue&type=style&index=0&id=7ed75fd4&lang=stylus
var NebulaTablevue_type_style_index_0_id_7ed75fd4_lang_stylus = __webpack_require__("d3fe");

// CONCATENATED MODULE: ./src/components/Table/NebulaTable.vue







const NebulaTable_exports_ = /*#__PURE__*/exportHelper_default()(NebulaTablevue_type_script_lang_js, [['render',NebulaTablevue_type_template_id_7ed75fd4_render]])

/* harmony default export */ var NebulaTable = (NebulaTable_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Tag/NebulaTag.vue?vue&type=template&id=391f3e66

const NebulaTagvue_type_template_id_391f3e66_hoisted_1 = ["aria-label"];
function NebulaTagvue_type_template_id_391f3e66_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: "nebula-tag",
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])($props.text) + " ", 1), Object(external_vue_["createElementVNode"])("button", {
    "aria-label": $props.ariaLabel || _ctx.$t('remove tag'),
    onClick: _cache[0] || (_cache[0] = $event => $options.handleClick($event)),
    class: "nebula-tag__close-button"
  }, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
    class: "nebula-tag__icon nebula-tag__icon--base",
    size: "s",
    symbolId: "circle-x"
  }), Object(external_vue_["createVNode"])(_component_NebulaIcon, {
    class: "nebula-tag__icon nebula-tag__icon--overlay",
    size: "s",
    symbolId: "circle-x--filled"
  })], 8, NebulaTagvue_type_template_id_391f3e66_hoisted_1)], 4);
}
// CONCATENATED MODULE: ./src/components/Tag/NebulaTag.vue?vue&type=template&id=391f3e66

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Tag/NebulaTag.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaTagvue_type_script_lang_js = ({
  name: 'NebulaTag',
  components: {
    NebulaIcon: NebulaIcon
  },
  mixins: [themingUtils],
  emits: ['click'],
  methods: {
    handleClick(event) {
      this.$emit('click', event);
    }

  },
  props: {
    ariaLabel: {
      type: String,
      default: null // the default is handled in the template itself

    },
    text: {
      type: String,
      default: null
    }
  }
});
// CONCATENATED MODULE: ./src/components/Tag/NebulaTag.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Tag/NebulaTag.vue?vue&type=style&index=0&id=391f3e66&lang=stylus
var NebulaTagvue_type_style_index_0_id_391f3e66_lang_stylus = __webpack_require__("e888");

// CONCATENATED MODULE: ./src/components/Tag/NebulaTag.vue







const NebulaTag_exports_ = /*#__PURE__*/exportHelper_default()(NebulaTagvue_type_script_lang_js, [['render',NebulaTagvue_type_template_id_391f3e66_render]])

/* harmony default export */ var NebulaTag = (NebulaTag_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Testimonial/NebulaTestimonial.vue?vue&type=template&id=7960d10b

const NebulaTestimonialvue_type_template_id_7960d10b_hoisted_1 = {
  class: "nebula-testimonial"
};
const NebulaTestimonialvue_type_template_id_7960d10b_hoisted_2 = {
  key: 0,
  class: "nebula-testimonial__background-image"
};
const NebulaTestimonialvue_type_template_id_7960d10b_hoisted_3 = {
  key: 1,
  class: "nebula-testimonial__gradient"
};
const NebulaTestimonialvue_type_template_id_7960d10b_hoisted_4 = {
  class: "nebula-testimonial__quote-wrapper nebula-testimonial__quote-wrapper--start"
};
const NebulaTestimonialvue_type_template_id_7960d10b_hoisted_5 = {
  class: "nebula-testimonial__main"
};
const NebulaTestimonialvue_type_template_id_7960d10b_hoisted_6 = {
  key: 0,
  class: "nebula-testimonial__content"
};
const NebulaTestimonialvue_type_template_id_7960d10b_hoisted_7 = {
  key: 1,
  class: "nebula-testimonial__quote"
};
const NebulaTestimonialvue_type_template_id_7960d10b_hoisted_8 = {
  class: "nebula-testimonial__attribution"
};
const NebulaTestimonialvue_type_template_id_7960d10b_hoisted_9 = {
  class: "nebula-testimonial__img"
};
const NebulaTestimonialvue_type_template_id_7960d10b_hoisted_10 = {
  class: "nebula-testimonial__attribution-text"
};
const NebulaTestimonialvue_type_template_id_7960d10b_hoisted_11 = {
  class: "nebula-testimonial__name"
};
const NebulaTestimonialvue_type_template_id_7960d10b_hoisted_12 = {
  class: "nebula-testimonial__title"
};
const NebulaTestimonialvue_type_template_id_7960d10b_hoisted_13 = {
  class: "nebula-testimonial__quote-wrapper nebula-testimonial__quote-wrapper--end"
};
function NebulaTestimonialvue_type_template_id_7960d10b_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaImage = Object(external_vue_["resolveComponent"])("NebulaImage");

  const _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaTestimonialvue_type_template_id_7960d10b_hoisted_1, [$props.backgroundImgConfig ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaTestimonialvue_type_template_id_7960d10b_hoisted_2, [Object(external_vue_["createVNode"])(_component_NebulaImage, Object(external_vue_["mergeProps"])({
    covered: ""
  }, $props.backgroundImgConfig), null, 16)])) : Object(external_vue_["createCommentVNode"])("", true), $props.useGradient ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaTestimonialvue_type_template_id_7960d10b_hoisted_3)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("div", NebulaTestimonialvue_type_template_id_7960d10b_hoisted_4, [Object(external_vue_["createVNode"])(_component_NebulaIcon, Object(external_vue_["mergeProps"])($options.iconConfigClean, {
    symbolId: $options.symbolIdLeft,
    class: "nebula-testimonial__quote-icon"
  }), null, 16, ["symbolId"])]), Object(external_vue_["createElementVNode"])("div", NebulaTestimonialvue_type_template_id_7960d10b_hoisted_5, [$options.usesContentSlot ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaTestimonialvue_type_template_id_7960d10b_hoisted_6, [Object(external_vue_["renderSlot"])(_ctx.$slots, "content")])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", NebulaTestimonialvue_type_template_id_7960d10b_hoisted_7, Object(external_vue_["toDisplayString"])($props.quote), 1)), Object(external_vue_["createElementVNode"])("div", NebulaTestimonialvue_type_template_id_7960d10b_hoisted_8, [Object(external_vue_["createElementVNode"])("div", NebulaTestimonialvue_type_template_id_7960d10b_hoisted_9, [Object(external_vue_["createVNode"])(_component_NebulaImage, Object(external_vue_["normalizeProps"])(Object(external_vue_["guardReactiveProps"])($props.imgConfig)), null, 16)]), Object(external_vue_["createElementVNode"])("div", NebulaTestimonialvue_type_template_id_7960d10b_hoisted_10, [Object(external_vue_["createElementVNode"])("p", NebulaTestimonialvue_type_template_id_7960d10b_hoisted_11, Object(external_vue_["toDisplayString"])($props.name), 1), Object(external_vue_["createElementVNode"])("p", NebulaTestimonialvue_type_template_id_7960d10b_hoisted_12, Object(external_vue_["toDisplayString"])($props.title), 1)])])]), Object(external_vue_["createElementVNode"])("div", NebulaTestimonialvue_type_template_id_7960d10b_hoisted_13, [Object(external_vue_["createVNode"])(_component_NebulaIcon, Object(external_vue_["mergeProps"])($options.iconConfigClean, {
    symbolId: $options.symbolIdRight,
    class: "nebula-testimonial__quote-icon"
  }), null, 16, ["symbolId"])])]);
}
// CONCATENATED MODULE: ./src/components/Testimonial/NebulaTestimonial.vue?vue&type=template&id=7960d10b

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Testimonial/NebulaTestimonial.vue?vue&type=script&lang=js


/* harmony default export */ var NebulaTestimonialvue_type_script_lang_js = ({
  name: 'NebulaTestimonial',
  components: {
    NebulaIcon: NebulaIcon,
    NebulaImage: NebulaImage
  },
  props: {
    backgroundImgConfig: {
      type: Object,
      default: null
    },
    imgConfig: {
      type: Object,
      default: null
    },
    iconConfig: {
      type: Object,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    quote: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    useGradient: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    usesContentSlot() {
      return !!this.$slots.content;
    },

    symbolIdLeft() {
      const defaultSymbolId = 'quote';

      if (this.iconConfig) {
        const {
          symbolIdLeft
        } = this.iconConfig;
        return symbolIdLeft || defaultSymbolId;
      }

      return defaultSymbolId;
    },

    symbolIdRight() {
      const defaultSymbolId = 'quote-end';

      if (this.iconConfig) {
        const {
          symbolIdRight
        } = this.iconConfig;
        return symbolIdRight || defaultSymbolId;
      }

      return defaultSymbolId;
    },

    iconConfigClean() {
      if (this.iconConfig) {
        const {
          symbolIdLeft,
          symbolIdRight,
          ...rest
        } = this.iconConfig;
        return rest;
      }

      return null;
    }

  }
});
// CONCATENATED MODULE: ./src/components/Testimonial/NebulaTestimonial.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Testimonial/NebulaTestimonial.vue?vue&type=style&index=0&id=7960d10b&lang=stylus
var NebulaTestimonialvue_type_style_index_0_id_7960d10b_lang_stylus = __webpack_require__("564f");

// CONCATENATED MODULE: ./src/components/Testimonial/NebulaTestimonial.vue







const NebulaTestimonial_exports_ = /*#__PURE__*/exportHelper_default()(NebulaTestimonialvue_type_script_lang_js, [['render',NebulaTestimonialvue_type_template_id_7960d10b_render]])

/* harmony default export */ var NebulaTestimonial = (NebulaTestimonial_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/TitleBlock/NebulaTitleBlock.vue?vue&type=template&id=06d80350

const NebulaTitleBlockvue_type_template_id_06d80350_hoisted_1 = {
  class: "nebula-title-block"
};
const NebulaTitleBlockvue_type_template_id_06d80350_hoisted_2 = {
  key: 0,
  class: "nebula-title-block__description"
};
function NebulaTitleBlockvue_type_template_id_06d80350_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaTitleBlockvue_type_template_id_06d80350_hoisted_1, [Object(external_vue_["createElementVNode"])("div", null, [(Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])($options.titleComponent), {
    class: Object(external_vue_["normalizeClass"])($options.headerClass)
  }, {
    default: Object(external_vue_["withCtx"])(() => [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])($props.title), 1)]),
    _: 1
  }, 8, ["class"])), $props.description ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", NebulaTitleBlockvue_type_template_id_06d80350_hoisted_2, Object(external_vue_["toDisplayString"])($props.description), 1)) : Object(external_vue_["createCommentVNode"])("", true)]), Object(external_vue_["renderSlot"])(_ctx.$slots, "default", {}, () => [$props.actionButton ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, Object(external_vue_["mergeProps"])({
    key: 0
  }, $options.parsedActionProps.rest, {
    onClick: $options.parsedActionProps.action,
    class: "nebula-title-block__button"
  }), null, 16, ["onClick"])) : Object(external_vue_["createCommentVNode"])("", true)])]);
}
// CONCATENATED MODULE: ./src/components/TitleBlock/NebulaTitleBlock.vue?vue&type=template&id=06d80350

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/TitleBlock/NebulaTitleBlock.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaTitleBlockvue_type_script_lang_js = ({
  name: 'NebulaTitleBlock',
  components: {
    NebulaButton: NebulaButton
  },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    actionButton: {
      type: Object
    },
    type: {
      type: String,
      enum: ['title', 'section'],
      default: 'title',

      validator(val) {
        const types = ['title', 'section'];
        return types.includes(val);
      }

    }
  },
  computed: {
    parsedActionProps() {
      const {
        action,
        ...rest
      } = this.actionButton;
      return {
        action,
        rest
      };
    },

    headerClass() {
      let styleClass = 'nebula-title-block__title';

      if (this.type === 'section') {
        styleClass = 'nebula-title-block__title nebula-title-block__title--section';
      }

      return styleClass;
    },

    titleComponent() {
      if (this.type === 'section') {
        return 'h2';
      }

      return 'h1';
    }

  }
});
// CONCATENATED MODULE: ./src/components/TitleBlock/NebulaTitleBlock.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/TitleBlock/NebulaTitleBlock.vue?vue&type=style&index=0&id=06d80350&lang=stylus
var NebulaTitleBlockvue_type_style_index_0_id_06d80350_lang_stylus = __webpack_require__("036a");

// CONCATENATED MODULE: ./src/components/TitleBlock/NebulaTitleBlock.vue







const NebulaTitleBlock_exports_ = /*#__PURE__*/exportHelper_default()(NebulaTitleBlockvue_type_script_lang_js, [['render',NebulaTitleBlockvue_type_template_id_06d80350_render]])

/* harmony default export */ var NebulaTitleBlock = (NebulaTitleBlock_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ToastMessage/NebulaToastMessage.vue?vue&type=template&id=f8950b9e

const NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_1 = ["id"];
const NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_2 = {
  class: "nebula-toast-message__inner"
};
const NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_3 = {
  class: "nebula-toast-message__icon-container"
};
const NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_4 = {
  class: "nebula-toast-message__message-area"
};
const NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_5 = ["textContent"];
const NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_6 = ["textContent"];
const NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_7 = {
  key: 1
};
const NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_8 = {
  key: 0,
  class: "nebula-toast-message__text--strong"
};
const NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_9 = ["inner-html"];
function NebulaToastMessagevue_type_template_id_f8950b9e_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaSticker = Object(external_vue_["resolveComponent"])("NebulaSticker");

  const _component_NebulaIconButton = Object(external_vue_["resolveComponent"])("NebulaIconButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    onMouseover: _cache[0] || (_cache[0] = (...args) => $options.pauseFadeOut && $options.pauseFadeOut(...args)),
    onMouseleave: _cache[1] || (_cache[1] = (...args) => $options.resumeFadeOut && $options.resumeFadeOut(...args)),
    class: Object(external_vue_["normalizeClass"])($options.toastClassName),
    id: $props.id,
    role: "alert",
    style: Object(external_vue_["normalizeStyle"])(_ctx.cssProps)
  }, [Object(external_vue_["createElementVNode"])("div", NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_2, [Object(external_vue_["createElementVNode"])("div", NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_3, [Object(external_vue_["createVNode"])(_component_NebulaSticker, {
    class: "nebula-toast-message__sticker",
    icon: $props.icon,
    size: "s",
    customStyles: {
      stickerBackgroundColor: 'var(--nebula-toast-sticker-color)'
    }
  }, null, 8, ["icon", "customStyles"])]), Object(external_vue_["createElementVNode"])("div", NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_4, [Object(external_vue_["createElementVNode"])("div", {
    class: Object(external_vue_["normalizeClass"])($options.contentClass)
  }, [$props.title ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", {
    key: 0,
    class: "nebula-toast-message__title",
    textContent: Object(external_vue_["toDisplayString"])($props.title)
  }, null, 8, NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_5)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["renderSlot"])(_ctx.$slots, "customContentOverride", {}, () => [$props.text ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", {
    key: 0,
    class: "nebula-toast-message__text",
    textContent: Object(external_vue_["toDisplayString"])($props.text)
  }, null, 8, NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_6)) : Object(external_vue_["createCommentVNode"])("", true), $props.content ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_7, [$props.content.title ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_8, Object(external_vue_["toDisplayString"])($props.content.title), 1)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createTextVNode"])(" " + Object(external_vue_["toDisplayString"])($props.content.action), 1)])) : Object(external_vue_["createCommentVNode"])("", true), $props.content && $props.content.raw_html ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", {
    key: 2,
    class: "nebula-toast-message__raw-html",
    "inner-html": $options.decodeHtmlEntity($props.content.raw_html)
  }, null, 8, NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_9)) : Object(external_vue_["createCommentVNode"])("", true)])], 2), Object(external_vue_["createVNode"])(_component_NebulaIconButton, {
    onClick: $options.closeToastMessage,
    icon: "x",
    type: "flat",
    size: "s",
    "aria-label": _ctx.$t('close'),
    customStyles: {
      iconButtonBackgroundHover: 'var(--nebula-toast-button-background-hover)',
      iconButtonBackgroundActive: 'var(--nebula-toast-button-background-active)',
      iconButtonBorderRadius: 'var(--nebula-toast-button-border-radius)',
      iconButtonFill: 'var(--nebula-toast-button-fill)',
      iconButtonFillHover: 'var(--nebula-toast-button-fill-hover)',
      iconButtonFillActive: 'var(--nebula-toast-button-fill-active)'
    }
  }, null, 8, ["onClick", "aria-label", "customStyles"])])])], 46, NebulaToastMessagevue_type_template_id_f8950b9e_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/ToastMessage/NebulaToastMessage.vue?vue&type=template&id=f8950b9e

// CONCATENATED MODULE: ./src/utils/formatContent.js
const decodeHtmlEntity = html => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

/* harmony default export */ var formatContent = (decodeHtmlEntity);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ToastMessage/NebulaToastMessage.vue?vue&type=script&lang=js




/* harmony default export */ var NebulaToastMessagevue_type_script_lang_js = ({
  name: 'NebulaToastMessage',

  data() {
    return {
      isVisible: false,
      isPaused: false,
      fadeOutTimer: undefined,
      destroyTimer: undefined
    };
  },

  components: {
    NebulaIconButton: NebulaIconButton,
    NebulaSticker: NebulaSticker
  },
  mixins: [themingUtils],
  props: {
    callBackOnClose: {
      type: Function,
      default: null
    },
    content: {
      type: Object,
      default: null
    },
    disableFadeout: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String
    },
    id: {
      type: [String, Number]
    },
    setFadeOutTimerTo: {
      type: Number,
      default: 5000,
      validator: value => Math.sign(value) > 0
    },
    text: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null,
      // options: error, success, warning. null defaults to interface blue
      enum: ['error', 'success', 'warning'] // for docs site

    }
  },
  emits: ['close-toast-message'],
  computed: {
    contentClass() {
      const className = ['nebula-toast-message__content', {
        'nebula-toast-message__content--flex-row': this.content !== null && !this.title
      }];
      return className;
    },

    toastClassName() {
      const className = ['nebula-toast-message', {
        'nebula-toast-message--visible': this.isVisible === true,
        'nebula-toast-message--title-only': !this.text && !this.content,
        'nebula-toast-message--error': this.type === 'error',
        'nebula-toast-message--success': this.type === 'success',
        'nebula-toast-message--warning': this.type === 'warning'
      }];
      return className;
    }

  },

  mounted() {
    // allows fade in transition
    setTimeout(() => {
      this.isVisible = true;
    }, 10);
    if (!this.disableFadeout) this.setFadeOutTimer(this.setFadeOutTimerTo);
  },

  beforeUnmount() {
    this.clearFadeInTimer();
    this.clearFadeOutTimer();
  },

  methods: {
    clearFadeInTimer() {
      clearTimeout(this.fadeInTimer);
    },

    clearFadeOutTimer() {
      clearTimeout(this.fadeOutTimer);
    },

    closeToastMessage() {
      this.isVisible = false;
      this.setDestroyTimer();
    },

    pauseFadeOut() {
      if (!this.disableFadeout) {
        this.clearFadeOutTimer();
        this.isPaused = true;
      }
    },

    resumeFadeOut() {
      if (!this.disableFadeout && this.isPaused) {
        this.isPaused = false;
        this.setFadeOutTimer(1000);
      }
    },

    setFadeOutTimer(milliseconds) {
      this.fadeOutTimer = setTimeout(this.closeToastMessage, milliseconds);
    },

    setDestroyTimer() {
      this.destroyTimer = setTimeout(() => {
        if (this.callBackOnClose) this.callBackOnClose(this.id);
        this.$emit('close-toast-message', this.id);
      }, 250);
      this.clearFadeInTimer();
      this.clearFadeOutTimer();
    },

    decodeHtmlEntity: decodeHtmlEntity
  }
});
// CONCATENATED MODULE: ./src/components/ToastMessage/NebulaToastMessage.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/ToastMessage/NebulaToastMessage.vue?vue&type=style&index=0&id=f8950b9e&lang=stylus
var NebulaToastMessagevue_type_style_index_0_id_f8950b9e_lang_stylus = __webpack_require__("f4ec");

// CONCATENATED MODULE: ./src/components/ToastMessage/NebulaToastMessage.vue







const NebulaToastMessage_exports_ = /*#__PURE__*/exportHelper_default()(NebulaToastMessagevue_type_script_lang_js, [['render',NebulaToastMessagevue_type_template_id_f8950b9e_render]])

/* harmony default export */ var NebulaToastMessage = (NebulaToastMessage_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ToastMessage/NebulaToastMessages.vue?vue&type=template&id=538d1cd8

const NebulaToastMessagesvue_type_template_id_538d1cd8_hoisted_1 = {
  class: "nebula-toast-message-queue"
};
function NebulaToastMessagesvue_type_template_id_538d1cd8_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NebulaToastMessage = Object(external_vue_["resolveComponent"])("NebulaToastMessage");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", NebulaToastMessagesvue_type_template_id_538d1cd8_hoisted_1, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.mutableToastMessages, message => {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaToastMessage, {
      onCloseToastMessage: $options.emitRemoveToastMessage,
      class: Object(external_vue_["normalizeClass"])(message.className),
      content: message.content,
      disableFadeout: message.disableFadeout,
      icon: $options.getSymbolId(message),
      id: message.id,
      isSmall: message.isSmall,
      key: message.id,
      setFadeOutTimerTo: message.setFadeOutTimerTo,
      text: message.text,
      title: message.title,
      type: message.type
    }, null, 8, ["onCloseToastMessage", "class", "content", "disableFadeout", "icon", "id", "isSmall", "setFadeOutTimerTo", "text", "title", "type"]);
  }), 128))]);
}
// CONCATENATED MODULE: ./src/components/ToastMessage/NebulaToastMessages.vue?vue&type=template&id=538d1cd8

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ToastMessage/NebulaToastMessages.vue?vue&type=script&lang=js

/* harmony default export */ var NebulaToastMessagesvue_type_script_lang_js = ({
  name: 'NebulaToastMessages',
  components: {
    NebulaToastMessage: NebulaToastMessage
  },

  data() {
    return {
      trackedList: this.toastMessages || []
    };
  },

  props: {
    toastMessages: {
      type: Array,

      default() {
        return [];
      }

    }
  },
  emits: ['remove-toast-message'],
  computed: {
    mutableToastMessages: {
      get() {
        return this.trackedList;
      },

      set(newList) {
        this.trackedList = newList;
      }

    }
  },
  methods: {
    emitRemoveToastMessage(id) {
      this.$emit('remove-toast-message', id);
    },

    getSymbolId(msg) {
      let symbolId = null;

      if (msg.icon) {
        symbolId = msg.icon;
      } else if (msg.content && msg.content.icon) {
        symbolId = msg.content.icon;
      }

      return symbolId;
    }

  },
  watch: {
    toastMessages(newList) {
      // Whenever quicklist updates *externally* we update our
      // internal mutable copy
      this.trackedList = newList || [];
    }

  }
});
// CONCATENATED MODULE: ./src/components/ToastMessage/NebulaToastMessages.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/ToastMessage/NebulaToastMessages.vue?vue&type=style&index=0&id=538d1cd8&lang=stylus
var NebulaToastMessagesvue_type_style_index_0_id_538d1cd8_lang_stylus = __webpack_require__("5a9a");

// CONCATENATED MODULE: ./src/components/ToastMessage/NebulaToastMessages.vue







const NebulaToastMessages_exports_ = /*#__PURE__*/exportHelper_default()(NebulaToastMessagesvue_type_script_lang_js, [['render',NebulaToastMessagesvue_type_template_id_538d1cd8_render]])

/* harmony default export */ var NebulaToastMessages = (NebulaToastMessages_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Tooltip/NebulaTooltip.vue?vue&type=template&id=58b1eca2

const NebulaTooltipvue_type_template_id_58b1eca2_hoisted_1 = {
  class: "nebula-tooltip-trigger"
};
const NebulaTooltipvue_type_template_id_58b1eca2_hoisted_2 = ["data-position"];
const NebulaTooltipvue_type_template_id_58b1eca2_hoisted_3 = {
  class: "nebula-tooltip__text"
};

const NebulaTooltipvue_type_template_id_58b1eca2_hoisted_4 = /*#__PURE__*/Object(external_vue_["createElementVNode"])("span", {
  class: "nebula-tooltip__nub"
}, null, -1);

function NebulaTooltipvue_type_template_id_58b1eca2_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", {
    class: Object(external_vue_["normalizeClass"])(["nebula-tooltip", $props.usesLightTheme && 'nebula-title-tooltip--light'])
  }, [Object(external_vue_["createElementVNode"])("span", NebulaTooltipvue_type_template_id_58b1eca2_hoisted_1, [Object(external_vue_["renderSlot"])(_ctx.$slots, "default")]), Object(external_vue_["createElementVNode"])("span", {
    class: "nebula-tooltip__tooltip",
    "data-position": $props.position
  }, [Object(external_vue_["createElementVNode"])("p", NebulaTooltipvue_type_template_id_58b1eca2_hoisted_3, Object(external_vue_["toDisplayString"])($props.text), 1), NebulaTooltipvue_type_template_id_58b1eca2_hoisted_4], 8, NebulaTooltipvue_type_template_id_58b1eca2_hoisted_2)], 2);
}
// CONCATENATED MODULE: ./src/components/Tooltip/NebulaTooltip.vue?vue&type=template&id=58b1eca2

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/Tooltip/NebulaTooltip.vue?vue&type=script&lang=js
/* harmony default export */ var NebulaTooltipvue_type_script_lang_js = ({
  name: 'NebulaTooltip',
  props: {
    text: String,
    usesLightTheme: {
      type: Boolean,
      default: false
    },
    nub: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'top',
      // Options: top, right, bottom, left
      enum: ['top', 'right', 'bottom', 'left'] // for docs site

    }
  }
});
// CONCATENATED MODULE: ./src/components/Tooltip/NebulaTooltip.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/Tooltip/NebulaTooltip.vue?vue&type=style&index=0&id=58b1eca2&lang=stylus
var NebulaTooltipvue_type_style_index_0_id_58b1eca2_lang_stylus = __webpack_require__("c414");

// CONCATENATED MODULE: ./src/components/Tooltip/NebulaTooltip.vue







const NebulaTooltip_exports_ = /*#__PURE__*/exportHelper_default()(NebulaTooltipvue_type_script_lang_js, [['render',NebulaTooltipvue_type_template_id_58b1eca2_render]])

/* harmony default export */ var NebulaTooltip = (NebulaTooltip_exports_);
// CONCATENATED MODULE: ./src/utils/ariaDisabledEvents.js
function buttonEventControl(e, callback) {
  if (e.target.getAttribute('aria-disabled') === 'true') {
    return;
  }

  if (callback !== null && callback !== undefined) {
    callback();
  }
}

function formEventControl(e) {
  if (e.target.getAttribute('aria-disabled') === 'true') {
    const allowedKeys = ['Tab', 'Alt'];
    const keyCode = e.code;

    if (allowedKeys.includes(keyCode)) {
      return;
    }

    e.preventDefault();
  }
}


// EXTERNAL MODULE: ./src/utils/constants/i18nPluralTerms.json
var i18nPluralTerms = __webpack_require__("286d");

// CONCATENATED MODULE: ./src/utils/pagination/link-generators/skip-limit.js

/**
 * SkipLimitGenerator
 *
 * This page-link generator is based on the "skip-limit"
 * pagination model.
 *
 * const generator = new SkipLimitGenerator({
 *      baseUrl: '/cards-sink?q=&language_family_code=eng&sort_by=popular',
 *      limit: 10,
 *      skip: 210,
 *      totalRecords: 72564,
 *      usePushState: false,
 *      useRouterLink: true,
 * });
 *
 */

class skip_limit_SkipLimitGenerator extends base {
  getPageLink(pageNumber) {
    const pageUrl = this.getUrlWithQueryParams({
      limit: this.limit,
      skip: this.getSkipFromPageNumber(pageNumber)
    });
    return pageUrl;
  }

  getSkipFromPageNumber(pageNumber) {
    return (pageNumber - 1) * this.limit;
  }

  initialize(opts) {
    this.limit = opts.limit || 25;
    this.skip = opts.skip || 0;
    this.totalRecords = opts.totalRecords || 0;
    super.initialize(opts);
  }

  updateMetadata() {
    this.currentPageNumber = this.skip / this.limit + 1;
    this.numberOfPages = Math.ceil(this.totalRecords / this.limit);
  }

}

/* harmony default export */ var skip_limit = (skip_limit_SkipLimitGenerator);
// CONCATENATED MODULE: ./src/utils/pagination/link-generators/index.js



/* harmony default export */ var link_generators = ({
  PaginationLinkGeneratorBase: base,
  PageGenerator: page,
  SkipLimitGenerator: skip_limit
});
// CONCATENATED MODULE: ./src/utils/getOrdinalSuffix.js
function getOrdinalSuffix(number) {
  const tens = number % 10;
  const hundreds = number % 100;

  if (tens === 1 && hundreds !== 11) {
    return `${number}st`;
  }

  if (tens === 2 && hundreds !== 12) {
    return `${number}nd`;
  }

  if (tens === 3 && hundreds !== 13) {
    return `${number}rd`;
  }

  return `${number}th`;
}

/* harmony default export */ var utils_getOrdinalSuffix = (getOrdinalSuffix);
// CONCATENATED MODULE: ./src/utils/fullscreen.js
/* harmony default export */ var fullscreen = ({
  methods: {
    isFullscreenSupported() {
      const doc = window.document;
      return doc.documentElement.requestFullscreen || doc.documentElement.webkitRequestFullscreen;
    },

    enterFullscreen(fullscreenTarget) {
      if (fullscreenTarget.requestFullscreen) {
        fullscreenTarget.requestFullscreen();
      } else if (fullscreenTarget.webkitRequestFullscreen) {
        fullscreenTarget.webkitRequestFullscreen();
      }
    },

    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    },

    toggleFullscreen(fullscreenTarget) {
      let fullscreenElement = fullscreenTarget;

      if (!fullscreenTarget) {
        fullscreenElement = this.$parent.$el;
      }

      if (fullscreenElement) {
        if (!document.fullscreenElement && !document.webkitFullscreenElement) {
          this.enterFullscreen(fullscreenElement);
        } else {
          this.exitFullscreen();
        }
      }
    }

  }
});
// CONCATENATED MODULE: ./src/main-lib.js
/*
 * This is the entry file for the npm package. If you'd like anything to be available in
 * the package, add it to the exports here.
 *
 * Note that we use BOTH a named export in the second block, AND a default export at the bottom
 * This is to support developers using either named or default
 * Be sure to include the export in both blocks, and that any named export is prefixed with `Nebula`
 */






 // Buttons










 // Cards









 // Card Partials








 // Card Containers








 // Dropdown



 // FormElements


















 // Listgroup





 // MultiLevelNav




 // Pagination






 // ProductBar



 // ProfilePanel



 // QuickList


 // Row




 // Sidebar





 // Table



 // Tabs







 // ToastMessage


 // Tooltip


 // VideoSegmentCarousel


 // MIXINS AND UTILS






 //
// Named Exports
//

const main_lib_NebulaAccordion = NebulaAccordion;
const main_lib_NebulaActionBar = NebulaActionBar;
const main_lib_NebulaBadge = NebulaBadge;
const main_lib_NebulaBanner = NebulaBanner;
const main_lib_NebulaBlockMessage = NebulaBlockMessage;
const main_lib_NebulaBreadcrumbs = NebulaBreadcrumbs; // Buttons

const main_lib_NebulaBackToTop = NebulaBackToTop;
const main_lib_NebulaButton = NebulaButton;
const main_lib_NebulaCopyButton = NebulaCopyButton;
const main_lib_NebulaFavoritesButton = NebulaFavoritesButton;
const main_lib_NebulaFloatingActionButton = NebulaFloatingActionButton;
const main_lib_NebulaFullscreenButton = NebulaFullscreenButton;
const main_lib_NebulaIconButton = NebulaIconButton;
const main_lib_NebulaButtonGroup = NebulaButtonGroup;
const main_lib_NebulaCallout = NebulaCallout;
const main_lib_NebulaCallToAction = NebulaCallToAction; // Cards

const main_lib_NebulaActivityCard = NebulaActivityCard;
const main_lib_NebulaAssetCard = NebulaAssetCard;
const main_lib_NebulaAssignmentCard = NebulaAssignmentCard;
const main_lib_NebulaCard = NebulaCard;
const main_lib_NebulaChannelCard = NebulaChannelCard;
const main_lib_NebulaClassroomCard = NebulaClassroomCard;
const main_lib_NebulaContainerCard = NebulaContainerCard;
const main_lib_NebulaLessonCard = NebulaLessonCard;
const main_lib_NebulaVideoCard = NebulaVideoCard; // Card Partials

const main_lib_NebulaCardDescription = NebulaCardDescription;
const main_lib_NebulaCardHeader = NebulaCardHeader;
const main_lib_NebulaCardLabel = NebulaCardLabel;
const main_lib_NebulaCardLinks = NebulaCardLinks;
const main_lib_NebulaCardLogos = NebulaCardLogos;
const main_lib_NebulaCardMetadata = NebulaCardMetadata;
const main_lib_NebulaCardThumbnail = NebulaCardThumbnail;
const main_lib_NebulaCardTitle = NebulaCardTitle; // Card Containers

const main_lib_NebulaCardGrid = NebulaCardGrid;
const main_lib_NebulaCardRow = NebulaCardRow;
const main_lib_NebulaCardCarousel = NebulaCardCarousel;
const main_lib_NebulaCarousel = NebulaCarousel;
const main_lib_NebulaCombobox = NebulaCombobox;
const main_lib_NebulaDatepicker = NebulaDatepicker;
const main_lib_NebulaDialog = NebulaDialog;
const main_lib_NebulaDraggableCards = NebulaDraggableCards; // Dropdown

const main_lib_NebulaDropdown = NebulaDropdown;
const main_lib_NebulaDropdownItem = NebulaDropdownItem;
const main_lib_NebulaFooter = NebulaFooter; // Form Elements

const main_lib_NebulaVueSelect = NebulaVueSelect;
const main_lib_NebulaCheckbox = NebulaCheckbox;
const main_lib_NebulaFieldGroup = NebulaFieldGroup;
const main_lib_NebulaFormHelper = NebulaFormHelper;
const main_lib_NebulaInput = NebulaInput;
const main_lib_NebulaInputWithButtons = NebulaInputWithButtons;
const main_lib_NebulaLabel = NebulaLabel;
const main_lib_NebulaRadio = NebulaRadio;
const main_lib_NebulaSelect = NebulaSelect;
const main_lib_NebulaSelectOption = NebulaSelectOption;
const main_lib_NebulaSwitch = NebulaSwitch;
const main_lib_NebulaTextarea = NebulaTextarea;
const main_lib_NebulaGlobalNav = NebulaGlobalNav;
const NebulaGrid = Grid;
const main_lib_NebulaHero = NebulaHero;
const main_lib_NebulaIcon = NebulaIcon;
const main_lib_NebulaImage = NebulaImage;
const main_lib_NebulaListboxItem = NebulaListboxItem; // List Group

const main_lib_NebulaListGroup = NebulaListGroup;
const main_lib_NebulaListItem = NebulaListItem;
const main_lib_NebulaListItemExpandable = NebulaListItemExpandable;
const main_lib_NebulaMenuBar = NebulaMenuBar;
const main_lib_NebulaModal = NebulaModal; // MultiLevelNav

const main_lib_MultiLevelNav = MultiLevelNav;
const NebulaMultiLevelNavItem = MultiLevelNavItem;
const NebulaMultiLevelNavPanel = MultiLevelNavPanel;
const main_lib_NebulaPageShell = NebulaPageShell; // Pagination

const main_lib_NebulaDropdownPagination = NebulaDropdownPagination;
const main_lib_NebulaPagination = NebulaPagination;
const main_lib_NebulaPaginationButtonItem = NebulaPaginationButtonItem;
const main_lib_NebulaPanel = NebulaPanel;
const main_lib_NebulaPicture = NebulaPicture;
const main_lib_NebulaPopover = NebulaPopover; // ProductBar

const main_lib_NebulaProductBar = NebulaProductBar;
const main_lib_NebulaProductBarSearch = NebulaProductBarSearch;
const main_lib_NebulaProductBlock = NebulaProductBlock; // ProfilePanel

const main_lib_NebulaProfilePanel = NebulaProfilePanel;
const main_lib_NebulaProfilePanelToggle = NebulaProfilePanelToggle;
const main_lib_NebulaQuicklinks = NebulaQuicklinks; // QuickList

const main_lib_NebulaQuickList = NebulaQuickList;
const main_lib_NebulaQuickListCard = NebulaQuickListCard; // Row

const main_lib_NebulaContentRow = NebulaContentRow;
const main_lib_NebulaFeatureRow = NebulaFeatureRow;
const main_lib_NebulaImageRow = NebulaImageRow;
const main_lib_NebulaRow = NebulaRow; // Sidebar

const main_lib_NebulaIconSidebar = NebulaIconSidebar;
const main_lib_NebulaSidebar = NebulaSidebar;
const main_lib_NebulaSidebarItem = NebulaSidebarItem;
const main_lib_NebulaSidebarSectionHeader = NebulaSidebarSectionHeader;
const main_lib_NebulaSticker = NebulaSticker; // Table

const main_lib_NebulaTable = NebulaTable;
const main_lib_NebulaTableCell = NebulaTableCell;
const main_lib_NebulaTableHeader = NebulaTableHeader; // Tabs

const main_lib_NebulaTabDropdown = NebulaTabDropdown;
const main_lib_NebulaTabItem = NebulaTabItem;
const main_lib_NebulaTabs = NebulaTabs;
const main_lib_NebulaTag = NebulaTag;
const main_lib_NebulaTestimonial = NebulaTestimonial;
const main_lib_NebulaThumbnail = NebulaThumbnail;
const main_lib_NebulaTitleBlock = NebulaTitleBlock; // ToastMessage

const main_lib_NebulaToastMessage = NebulaToastMessage;
const main_lib_NebulaToastMessages = NebulaToastMessages; // Tooltip

const main_lib_NebulaTooltip = NebulaTooltip;
const main_lib_NebulaTitleTooltip = NebulaTitleTooltip; // VideoSegmentCarousel

const main_lib_NebulaVideoSegmentCard = NebulaVideoSegmentCard;
const main_lib_NebulaVideoSegmentCarousel = NebulaVideoSegmentCarousel; // Mixins and Utils

const nebulaAriaDisabledEvents = /* Cannot get final name for export "default" in "./src/utils/ariaDisabledEvents.js" (known exports: buttonEventControl formEventControl, known reexports: ) */ undefined;
const nebulaI18nPluralTerms = i18nPluralTerms;
const NebulaPaginationLinkGenerators = link_generators;
const NebulaGetOrdinalSuffix = utils_getOrdinalSuffix;
const NebulaThemingUtils = themingUtils;
const NebulaFullscreenMixin = fullscreen; //
// Default Export
//

/* harmony default export */ var main_lib = ({
  NebulaAccordion: NebulaAccordion,
  NebulaActionBar: NebulaActionBar,
  NebulaBadge: NebulaBadge,
  NebulaBanner: NebulaBanner,
  NebulaBlockMessage: NebulaBlockMessage,
  NebulaBreadcrumbs: NebulaBreadcrumbs,
  // Buttons
  NebulaBackToTop: NebulaBackToTop,
  NebulaButton: NebulaButton,
  NebulaCopyButton: NebulaCopyButton,
  NebulaFavoritesButton: NebulaFavoritesButton,
  NebulaFloatingActionButton: NebulaFloatingActionButton,
  NebulaFullscreenButton: NebulaFullscreenButton,
  NebulaIconButton: NebulaIconButton,
  NebulaButtonGroup: NebulaButtonGroup,
  NebulaCallout: NebulaCallout,
  NebulaCallToAction: NebulaCallToAction,
  // Cards
  NebulaActivityCard: NebulaActivityCard,
  NebulaAssetCard: NebulaAssetCard,
  NebulaAssignmentCard: NebulaAssignmentCard,
  NebulaCard: NebulaCard,
  NebulaChannelCard: NebulaChannelCard,
  NebulaClassroomCard: NebulaClassroomCard,
  NebulaContainerCard: NebulaContainerCard,
  NebulaLessonCard: NebulaLessonCard,
  NebulaVideoCard: NebulaVideoCard,
  // Card Partials
  NebulaCardDescription: NebulaCardDescription,
  NebulaCardHeader: NebulaCardHeader,
  NebulaCardLabel: NebulaCardLabel,
  NebulaCardLinks: NebulaCardLinks,
  NebulaCardLogos: NebulaCardLogos,
  NebulaCardMetadata: NebulaCardMetadata,
  NebulaCardThumbnail: NebulaCardThumbnail,
  NebulaCardTitle: NebulaCardTitle,
  // Card Containers
  NebulaCardGrid: NebulaCardGrid,
  NebulaCardRow: NebulaCardRow,
  NebulaCardCarousel: NebulaCardCarousel,
  NebulaCarousel: NebulaCarousel,
  NebulaCombobox: NebulaCombobox,
  NebulaDatepicker: NebulaDatepicker,
  NebulaDialog: NebulaDialog,
  NebulaDraggableCards: NebulaDraggableCards,
  // Dropdown
  NebulaDropdown: NebulaDropdown,
  NebulaDropdownItem: NebulaDropdownItem,
  NebulaFooter: NebulaFooter,
  // Form Elements
  NebulaVueSelect: NebulaVueSelect,
  NebulaCheckbox: NebulaCheckbox,
  NebulaFieldGroup: NebulaFieldGroup,
  NebulaFormHelper: NebulaFormHelper,
  NebulaInput: NebulaInput,
  NebulaInputWithButtons: NebulaInputWithButtons,
  NebulaLabel: NebulaLabel,
  NebulaRadio: NebulaRadio,
  NebulaSelect: NebulaSelect,
  NebulaSelectOption: NebulaSelectOption,
  NebulaSwitch: NebulaSwitch,
  NebulaTextarea: NebulaTextarea,
  NebulaGlobalNav: NebulaGlobalNav,
  NebulaGrid: Grid,
  NebulaHero: NebulaHero,
  NebulaIcon: NebulaIcon,
  NebulaImage: NebulaImage,
  NebulaListboxItem: NebulaListboxItem,
  // List Group
  NebulaListGroup: NebulaListGroup,
  NebulaListItem: NebulaListItem,
  NebulaListItemExpandable: NebulaListItemExpandable,
  NebulaMenuBar: NebulaMenuBar,
  NebulaModal: NebulaModal,
  // MultiLevelNav
  MultiLevelNav: MultiLevelNav,
  NebulaMultiLevelNavItem: MultiLevelNavItem,
  NebulaMultiLevelNavPanel: MultiLevelNavPanel,
  NebulaPageShell: NebulaPageShell,
  // Pagination
  NebulaDropdownPagination: NebulaDropdownPagination,
  NebulaPagination: NebulaPagination,
  NebulaPaginationButtonItem: NebulaPaginationButtonItem,
  NebulaPanel: NebulaPanel,
  NebulaPicture: NebulaPicture,
  NebulaPopover: NebulaPopover,
  // ProductBar
  NebulaProductBar: NebulaProductBar,
  NebulaProductBarSearch: NebulaProductBarSearch,
  NebulaProductBlock: NebulaProductBlock,
  // ProfilePanel
  NebulaProfilePanel: NebulaProfilePanel,
  NebulaProfilePanelToggle: NebulaProfilePanelToggle,
  NebulaQuicklinks: NebulaQuicklinks,
  // QuickList
  NebulaQuickList: NebulaQuickList,
  NebulaQuickListCard: NebulaQuickListCard,
  // Row
  NebulaContentRow: NebulaContentRow,
  NebulaFeatureRow: NebulaFeatureRow,
  NebulaImageRow: NebulaImageRow,
  NebulaRow: NebulaRow,
  // Sidebar
  NebulaIconSidebar: NebulaIconSidebar,
  NebulaSidebar: NebulaSidebar,
  NebulaSidebarItem: NebulaSidebarItem,
  NebulaSidebarSectionHeader: NebulaSidebarSectionHeader,
  NebulaSticker: NebulaSticker,
  // Table
  NebulaTable: NebulaTable,
  NebulaTableCell: NebulaTableCell,
  NebulaTableHeader: NebulaTableHeader,
  // Tabs
  NebulaTabDropdown: NebulaTabDropdown,
  NebulaTabItem: NebulaTabItem,
  NebulaTabs: NebulaTabs,
  NebulaTag: NebulaTag,
  NebulaTestimonial: NebulaTestimonial,
  NebulaThumbnail: NebulaThumbnail,
  NebulaTitleBlock: NebulaTitleBlock,
  // ToastMessage
  NebulaToastMessage: NebulaToastMessage,
  NebulaToastMessages: NebulaToastMessages,
  // Tooltip
  NebulaTooltip: NebulaTooltip,
  NebulaTitleTooltip: NebulaTitleTooltip,
  // VideoSegmentCarousel
  NebulaVideoSegmentCard: NebulaVideoSegmentCard,
  NebulaVideoSegmentCarousel: NebulaVideoSegmentCarousel,
  // Mixins and Utils
  nebulaAriaDisabledEvents: /* Cannot get final name for export "default" in "./src/utils/ariaDisabledEvents.js" (known exports: buttonEventControl formEventControl, known reexports: ) */ undefined,
  nebulaI18nPluralTerms: i18nPluralTerms,
  NebulaPaginationLinkGenerators: link_generators,
  NebulaGetOrdinalSuffix: utils_getOrdinalSuffix,
  NebulaThemingUtils: themingUtils,
  NebulaFullscreenMixin: fullscreen
});
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (main_lib);



/***/ }),

/***/ "fb60":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fca6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MultiLevelNavPanel_vue_vue_type_style_index_0_id_334a2d00_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("90b2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MultiLevelNavPanel_vue_vue_type_style_index_0_id_334a2d00_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_MultiLevelNavPanel_vue_vue_type_style_index_0_id_334a2d00_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "fd82":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaQuickListCard_vue_vue_type_style_index_0_id_41d81b8f_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5f87");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaQuickListCard_vue_vue_type_style_index_0_id_41d81b8f_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaQuickListCard_vue_vue_type_style_index_0_id_41d81b8f_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "fd9e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fe2c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDatepicker_vue_vue_type_style_index_0_id_11782aa8_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("945a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDatepicker_vue_vue_type_style_index_0_id_11782aa8_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_stylus_loader_index_js_ref_12_oneOf_1_3_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_NebulaDatepicker_vue_vue_type_style_index_0_id_11782aa8_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "fe70":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nebula-components-assets/img/asset-title-chapter-video-segment.svg";

/***/ }),

/***/ "ff8d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ })

/******/ });
//# sourceMappingURL=nebula-components.common.js.map